/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	
	//Module Imports
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _appState = __webpack_require__(7);
	
	var _appState2 = _interopRequireDefault(_appState);
	
	var _globalNav = __webpack_require__(9);
	
	var nav = _interopRequireWildcard(_globalNav);
	
	var _globalFooter = __webpack_require__(10);
	
	var footer = _interopRequireWildcard(_globalFooter);
	
	var _globalComponents = __webpack_require__(11);
	
	var components = _interopRequireWildcard(_globalComponents);
	
	var _versionJson = __webpack_require__(12);
	
	var _versionJson2 = _interopRequireDefault(_versionJson);
	
	var _libJquery214MinJs = __webpack_require__(13);
	
	var _libJquery214MinJs2 = _interopRequireDefault(_libJquery214MinJs);
	
	var _libChosenJqueryJs = __webpack_require__(15);
	
	var _libChosenJqueryJs2 = _interopRequireDefault(_libChosenJqueryJs);
	
	var _componentsModal = __webpack_require__(16);
	
	var _componentsModal2 = _interopRequireDefault(_componentsModal);
	
	var _componentsTooltip = __webpack_require__(23);
	
	var _componentsTooltip2 = _interopRequireDefault(_componentsTooltip);
	
	var _componentsLoader = __webpack_require__(24);
	
	var _componentsLoader2 = _interopRequireDefault(_componentsLoader);
	
	var _componentsButtonSwitch = __webpack_require__(25);
	
	var _componentsButtonSwitch2 = _interopRequireDefault(_componentsButtonSwitch);
	
	var _componentsTextareaCountdown = __webpack_require__(26);
	
	var _componentsTextareaCountdown2 = _interopRequireDefault(_componentsTextareaCountdown);
	
	var _componentsAddressAutoComplete = __webpack_require__(27);
	
	var _componentsAddressAutoComplete2 = _interopRequireDefault(_componentsAddressAutoComplete);
	
	var _componentsDatePicker = __webpack_require__(28);
	
	var _componentsDatePicker2 = _interopRequireDefault(_componentsDatePicker);
	
	var _componentsTabs = __webpack_require__(29);
	
	var _componentsTabs2 = _interopRequireDefault(_componentsTabs);
	
	var _componentsSortableTable = __webpack_require__(30);
	
	var _componentsSortableTable2 = _interopRequireDefault(_componentsSortableTable);
	
	// import QuoteComparisonTable from './components/QuoteComparisonTable';
	
	var _componentsViewMoreLess = __webpack_require__(33);
	
	var _componentsViewMoreLess2 = _interopRequireDefault(_componentsViewMoreLess);
	
	var _componentsToTopArrow = __webpack_require__(34);
	
	var _componentsToTopArrow2 = _interopRequireDefault(_componentsToTopArrow);
	
	var _componentsValidateForm = __webpack_require__(35);
	
	var _componentsValidateForm2 = _interopRequireDefault(_componentsValidateForm);
	
	var _componentsInPageNavigation = __webpack_require__(36);
	
	var _componentsInPageNavigation2 = _interopRequireDefault(_componentsInPageNavigation);
	
	var _componentsTimelineFilter = __webpack_require__(37);
	
	var _componentsTimelineFilter2 = _interopRequireDefault(_componentsTimelineFilter);
	
	var _componentsTimeline = __webpack_require__(38);
	
	var _componentsTimeline2 = _interopRequireDefault(_componentsTimeline);
	
	var _componentsAccordion = __webpack_require__(42);
	
	var _componentsAccordion2 = _interopRequireDefault(_componentsAccordion);
	
	var _componentsAlert = __webpack_require__(43);
	
	var _componentsAlert2 = _interopRequireDefault(_componentsAlert);
	
	var _componentsMoreInfoButton = __webpack_require__(44);
	
	var _componentsMoreInfoButton2 = _interopRequireDefault(_componentsMoreInfoButton);
	
	var _componentsBackgroundPattern = __webpack_require__(45);
	
	var _componentsBackgroundPattern2 = _interopRequireDefault(_componentsBackgroundPattern);
	
	var _componentsBackgroundPatternPortfolioPage = __webpack_require__(48);
	
	var _componentsBackgroundPatternPortfolioPage2 = _interopRequireDefault(_componentsBackgroundPatternPortfolioPage);
	
	var _componentsDotNavigation = __webpack_require__(49);
	
	var _componentsDotNavigation2 = _interopRequireDefault(_componentsDotNavigation);
	
	var _componentsEditableTable = __webpack_require__(50);
	
	var _componentsEditableTable2 = _interopRequireDefault(_componentsEditableTable);
	
	var _componentsCoverageGraph = __webpack_require__(51);
	
	var _componentsCoverageGraph2 = _interopRequireDefault(_componentsCoverageGraph);
	
	var _componentsCommonQuestionsSquares = __webpack_require__(52);
	
	var _componentsCommonQuestionsSquares2 = _interopRequireDefault(_componentsCommonQuestionsSquares);
	
	var _componentsUpsell = __webpack_require__(53);
	
	var _componentsUpsell2 = _interopRequireDefault(_componentsUpsell);
	
	var _componentsPortfolio = __webpack_require__(54);
	
	var _componentsPortfolio2 = _interopRequireDefault(_componentsPortfolio);
	
	var _componentsPayPlans = __webpack_require__(55);
	
	var _componentsPayPlans2 = _interopRequireDefault(_componentsPayPlans);
	
	var _componentsConsolidatedSummary = __webpack_require__(56);
	
	var _componentsConsolidatedSummary2 = _interopRequireDefault(_componentsConsolidatedSummary);
	
	var _componentsEditComponent = __webpack_require__(57);
	
	var _componentsEditComponent2 = _interopRequireDefault(_componentsEditComponent);
	
	var _componentsDockedMessage = __webpack_require__(58);
	
	var _componentsDockedMessage2 = _interopRequireDefault(_componentsDockedMessage);
	
	var _componentsSegmentedControl = __webpack_require__(59);
	
	var _componentsSegmentedControl2 = _interopRequireDefault(_componentsSegmentedControl);
	
	var _componentsMultipleSelectBox = __webpack_require__(62);
	
	var _componentsMultipleSelectBox2 = _interopRequireDefault(_componentsMultipleSelectBox);
	
	var _componentsCardSelections = __webpack_require__(63);
	
	var _componentsCardSelections2 = _interopRequireDefault(_componentsCardSelections);
	
	var _componentsTimeInput = __webpack_require__(64);
	
	var _componentsTimeInput2 = _interopRequireDefault(_componentsTimeInput);
	
	var _componentsNavigationalBox = __webpack_require__(65);
	
	var _componentsNavigationalBox2 = _interopRequireDefault(_componentsNavigationalBox);
	
	var _componentsPasswordMeter = __webpack_require__(66);
	
	var _componentsPasswordMeter2 = _interopRequireDefault(_componentsPasswordMeter);
	
	var _componentsCreditCard = __webpack_require__(67);
	
	var _componentsCreditCard2 = _interopRequireDefault(_componentsCreditCard);
	
	var _componentsCurrencyInput = __webpack_require__(68);
	
	var _componentsCurrencyInput2 = _interopRequireDefault(_componentsCurrencyInput);
	
	var _componentsMakePayment = __webpack_require__(69);
	
	var _componentsMakePayment2 = _interopRequireDefault(_componentsMakePayment);
	
	var GDK = GDK || {};
	
	//let version = versionJson.version;
	//let date = Date.now().toString();
	////let build = [date.slice(0, 3), ".", date.slice(3, 6), ".", date.slice(6, 10)].join().replace(/[, ]+/g, "").trim();
	
	function init() {
	
		var ProtoGDK = {
			about: _versionJson2['default'],
			navigation: nav,
			Modal: _componentsModal2['default'],
			Tooltip: _componentsTooltip2['default'],
			Loader: _componentsLoader2['default'],
			ButtonSwitch: _componentsButtonSwitch2['default'],
			TextareaCountdown: _componentsTextareaCountdown2['default'],
			DatePicker: _componentsDatePicker2['default'],
			AddressAutoComplete: _componentsAddressAutoComplete2['default'],
			Tabs: _componentsTabs2['default'],
			SortableTable: _componentsSortableTable2['default'],
			// QuoteComparisonTable : QuoteComparisonTable,
			ViewMoreLess: _componentsViewMoreLess2['default'],
			ValidateForm: _componentsValidateForm2['default'],
			InPageNavigation: _componentsInPageNavigation2['default'],
			TimelineFilter: _componentsTimelineFilter2['default'],
			Timeline: _componentsTimeline2['default'],
			Accordion: _componentsAccordion2['default'],
			ToTopArrow: _componentsToTopArrow2['default'],
			Alert: _componentsAlert2['default'],
			MoreInfoButton: _componentsMoreInfoButton2['default'],
			BackgroundPattern: _componentsBackgroundPattern2['default'],
			BackgroundPatternPortfolioPage: _componentsBackgroundPatternPortfolioPage2['default'],
			DotNavigation: _componentsDotNavigation2['default'],
			EditableTable: _componentsEditableTable2['default'],
			CoverageGraph: _componentsCoverageGraph2['default'],
			CommonQuestionsSquares: _componentsCommonQuestionsSquares2['default'],
			ConsolidatedSummary: _componentsConsolidatedSummary2['default'],
			UpsellCarousel: _componentsUpsell2['default'],
			footer: footer,
			PayPlans: _componentsPayPlans2['default'],
			jQuery: _libJquery214MinJs2['default'],
			Chosen: _libChosenJqueryJs2['default'],
			MultipleSelectBox: _componentsMultipleSelectBox2['default'],
			Portfolio: _componentsPortfolio2['default'],
			EditComponent: _componentsEditComponent2['default'],
			DockedMessage: _componentsDockedMessage2['default'],
			SegmentedControl: _componentsSegmentedControl2['default'],
			CardSelections: _componentsCardSelections2['default'],
			TimeInput: _componentsTimeInput2['default'],
			NavigationalBox: _componentsNavigationalBox2['default'],
			components: components,
			PasswordMeter: _componentsPasswordMeter2['default'],
			CurrencyInput: _componentsCurrencyInput2['default'],
			CreditCard: _componentsCreditCard2['default'],
			MakePayment: _componentsMakePayment2['default']
		};
	
		for (var property in ProtoGDK) {
			if (!GDK.hasOwnProperty(property)) {
				GDK[property] = ProtoGDK[property];
			}
		}
	
		window.addEventListener('resize', function () {
			handleResize();
		});
	
		handleResize();
	}
	
	function handleResize() {
		_appState2['default'].windowSize = { width: window.innerWidth || document.documentElement.clientWidth, height: window.innerHeight || document.documentElement.clientHeight };
	}
	
	init();
	window.GDK = GDK;
	exports.GDK = GDK;

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	//global vars
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	// Module Imports
	
	var _utils = __webpack_require__(8);
	
	var utils = _interopRequireWildcard(_utils);
	
	var html = document.getElementsByTagName('html')[0];
	
	var appState = Object.defineProperties({
	
		mode: null,
		isTouchDevice: isTouchDevice(),
	
		size: {
			windowWidth: null,
			windowHeight: null
		}
	
	}, {
		windowSize: {
			set: function set(obj) {
				this.size.windowWidth = obj.width;
				this.size.windowHeight = obj.height;
				setMode(this.size.windowWidth);
			},
			get: function get() {
				return this.size;
			},
			configurable: true,
			enumerable: true
		}
	});
	
	/**
	 * setMode()
	 * Sets the appState mode depending on window side
	 *
	 * @param {Number} Window Width
	 */
	function setMode(w) {
		if (w >= 768) {
			appState.mode = "desktop";
		} else {
			appState.mode = "mobile";
		}
	}
	
	/**
	 * isTouchDevice()
	 * Sets the appState mode depending on window side
	 *
	 * @return {Bool}
	 */
	function isTouchDevice() {
		return utils.hasClass(html, 'touch');
	}
	
	exports['default'] = appState;
	module.exports = exports['default'];

/***/ },
/* 8 */
/***/ function(module, exports) {

	/**
	 * hasClass()
	 * Checks wether element contains a class
	 * This accounts for the fact that element might contain multiple class names separated by space.
	 *
	 * @param {Dom Element}
	 * @param {String} name of class we are checking
	 * @return {Boolean}
	 */
	
	//TODO check the best way to do this
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function hasClass(element, className) {
	    return element.classList.contains(className);
	}
	
	/**
	 * getParentByTagName()
	 * Get parent node for given tagname
	 *
	 * @param  {Object} node    DOM node
	 * @param  {String} tagname HTML tagName
	 * @return {Object}         Parent node
	 */
	function getParentByTagName(node, tagname) {
	    var parent;
	    if (node === null || tagname === '') return;
	    parent = node.parentNode;
	    tagname = tagname.toUpperCase();
	
	    while (parent.tagName !== "HTML") {
	        if (parent.tagName === tagname) {
	            return parent;
	        }
	        parent = parent.parentNode;
	    }
	
	    return parent;
	}
	
	function isChild(parent, child) {
	    var node = child.parentElement;
	    while (node !== null) {
	        if (node.classList.contains(parent)) {
	            return true;
	        }
	        node = node.parentElement;
	    }
	    return false;
	}
	
	/**
	 * scrollToTop()
	 * Used to animate the scroll position back to the top of the page
	 */
	function scrollToTop() {
	
	    var scrollHeight = window.scrollY,
	        scrollDuration = 500,
	        scrollStep = Math.PI / (scrollDuration / 15),
	        cosParameter = scrollHeight / 2;
	
	    var scrollCount = 0,
	        scrollMargin = undefined;
	
	    requestAnimationFrame(step);
	
	    console.log(scrollStep);
	
	    function step() {
	        setTimeout(function () {
	            if (window.scrollY !== 0) {
	                requestAnimationFrame(step);
	                scrollCount = scrollCount + 1;
	                scrollMargin = cosParameter - cosParameter * Math.cos(scrollCount * scrollStep);
	                window.scrollTo(0, scrollHeight - scrollMargin);
	            }
	        }, 15);
	    }
	}
	
	exports.hasClass = hasClass;
	exports.getParentByTagName = getParentByTagName;
	exports.isChild = isChild;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	//Module Imports
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _utils = __webpack_require__(8);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _appState = __webpack_require__(7);
	
	var _appState2 = _interopRequireDefault(_appState);
	
	//Global nav vars
	var body = undefined,
	    header = undefined,
	    headerAnchors = undefined,
	    nav = undefined,
	    navBackground = undefined,
	    actionableIcons = undefined,
	    submenuWrapper = undefined,
	    panelTriggers = undefined,
	    currentlyOpenPanel = undefined,
	    currentlyOpenSubPanel = undefined,
	    panels = undefined,
	    panelUL = undefined,
	    panelIsOpen = false,
	    hover_timer = undefined,
	    panel_timer = undefined,
	    open_timer = undefined,
	    svgAnim_timer = undefined,
	    currentNavState = undefined,
	    mainListItems = undefined,
	    mainListItemsAnchor = undefined,
	    mainListItemsAnchorMobile = undefined,
	    mainListItemsAnchorRightMobile = undefined,
	    mobilenavaccordionHeadlines = undefined,
	    secondaryListItemsAnchorMobile = undefined,
	    svgToAnim = undefined,
	    subpanelName = undefined,
	    hamburgerIcons = undefined,
	    dashOffsetEnd = 180,
	    //svg animation settings
	dashArrayComplete = 183,
	    //svg animation settings
	tickSpeed = 3.5,
	    //svg animation settings
	tickSpeedMobile = 5,
	    //svg animation settings
	tick = 0; //svg animation settings
	
	function init(config) {
	
	    if (!config || config.generateMobileNavHtml) {
	        generateMobileMenuElements(config);
	        /*
	         * At this point the mobile nav has been generated so we
	         * can initialize the view-more-less components for the first menu tier.
	         * */
	        var mobileNav = new GDK.Accordion({
	            "content": "#mobile-nav",
	            "forceOpenSingleAccordionElement": true
	        });
	    }
	
	    console.log('Initialized Navigation');
	
	    findDomElements();
	
	    if (_appState2['default'].mode === "mobile") {
	        body.style.overflowX = "hidden";
	    }
	
	    //add the navigation background
	    nav.insertAdjacentHTML('afterBegin', '<div id="nav-background"></div>');
	    navBackground = document.getElementById('nav-background');
	
	    addSVGs();
	    addHamburgerMarkup();
	
	    if (_appState2['default'].mode === "desktop") {
	        currentNavState = "desktop";
	
	        if (_appState2['default'].isTouchDevice) {
	            initDesktopTouchEvents();
	        } else {
	            initDesktopEvents();
	        }
	    } else {
	        currentNavState = "mobile";
	
	        if (_appState2['default'].isTouchDevice) {
	            initMobileTouchEvents();
	        } else {
	            initMobileEvents();
	        }
	    }
	
	    if (document.querySelector('.skip-to-content') && (!document.body.classList.contains('with-unsupported-browser') || !document.querySelector('.unsupported-browser'))) {
	        document.querySelector('.skip-to-content').addEventListener('blur', function () {
	            document.querySelector('#primary-header').style.top = '0';
	        });
	        document.querySelector('.skip-to-content').addEventListener('focus', function () {
	            document.querySelector('#primary-header').style.top = '2rem';
	        });
	    }
	
	    Array.prototype.forEach.call(headerAnchors, function (el, i) {
	        el.setAttribute('aria-expanded', 'false');
	    });
	
	    window.addEventListener('resize', handleResize);
	    handleResize();
	}
	
	function closeAccordionsMobileNav() {
	    var openAccordians = document.querySelector('#mobile-nav').querySelectorAll(".accordion > li.open");
	    Array.prototype.forEach.call(openAccordians, function (el, i) {
	        el.classList.remove("open");
	        var contentContainer = el.querySelector(".accordion-content-container");
	        contentContainer.style.display = "none";
	    });
	}
	
	/**
	 * findDomElements()
	 * Finds all Dom elements needed to run the navigation functionality
	 */
	function findDomElements() {
	    body = document.getElementsByTagName('body')[0];
	    header = document.getElementById('primary-header');
	    nav = document.getElementById('primary-navigation');
	
	    //find all header anchors
	    headerAnchors = header.querySelectorAll('a');
	
	    //finds any dom elements that have a data attribute of side-panel.
	    //Any header element that opens a panel should have this data attribute, so we know which panel to open
	    panelTriggers = header.querySelectorAll('[data-side-panel-trigger]');
	    panels = nav.querySelectorAll('.panel-wrapper');
	
	    //find all the submenus
	    submenuWrapper = nav.querySelectorAll('.geico-nav-menu-secondary-wrapper');
	
	    //find all hamburger icons
	    hamburgerIcons = header.querySelectorAll('.hamburger-menu');
	
	    //find all the actionable-icons
	    actionableIcons = nav.querySelectorAll('a .geico-icon--actionable');
	
	    Array.prototype.forEach.call(actionableIcons, function (el, i) {
	        el.style.width = "60px";
	        el.style.height = "60px";
	        el.style.lineHeight = "60px";
	        el.style.fontSize = "30px";
	    });
	
	    //find all first level li's for mobile
	    mainListItems = nav.querySelectorAll('.panel-wrapper > ul > li');
	    mainListItemsAnchor = nav.querySelectorAll('.panel-wrapper > ul > li > a');
	    mainListItemsAnchorMobile = nav.querySelectorAll('.panel-wrapper > #mobile-nav > li > .accordion-content-container > div > ul > li > a');
	    mainListItemsAnchorRightMobile = nav.querySelectorAll('.panel-wrapper.right > ul > li > a');
	    mobilenavaccordionHeadlines = nav.querySelectorAll('.panel-wrapper > #mobile-nav > li > .accordion-headline');
	    secondaryListItemsAnchorMobile = nav.querySelectorAll('.panel-wrapper > #mobile-nav .geico-nav-menu-secondary-wrapper > ul > li > a');
	
	    panelUL = nav.querySelectorAll('.panel-wrapper > ul');
	}
	
	/**
	 * Svetoslav Kostadinov
	 * 07.Jan.2106
	 *
	 * Generate mobile navigation markup.
	 */
	function generateMobileMenuElements(config) {
	
	    var navContainer = document.querySelectorAll('#primary-navigation')[0];
	    /* Delete any existing Mobile Nav */
	    if (navContainer.querySelector('[data-side-panel="mobile-menu"]') !== null) {
	        navContainer.removeChild(navContainer.querySelector('[data-side-panel="mobile-menu"]'));
	    }
	    var mobileNavDiv = navContainer.cloneNode(true);
	
	    // Create the mobile menu element
	    var navMobilePanelWrapper = document.createElement('div');
	    navMobilePanelWrapper.className = 'panel-wrapper';
	    navMobilePanelWrapper.setAttribute('data-side-panel', 'mobile-menu');
	
	    // Generate the mobile nav shell
	    var mobileNavigation = document.createElement('ul');
	    mobileNavigation.setAttribute('id', 'mobile-nav');
	    mobileNavigation.setAttribute('class', 'accordion');
	
	    // generate the search form section
	    if (config && config.mobileSearchForm) {
	        var searchForm = document.createElement('form');
	        searchForm.setAttribute('method', config.mobileSearchForm.method);
	        searchForm.setAttribute('action', config.mobileSearchForm.action);
	        searchForm.setAttribute('class', 'search-box');
	
	        var searchInputField = document.createElement('input');
	        searchInputField.setAttribute('type', 'text');
	        searchInputField.setAttribute('class', 'search-input');
	        searchInputField.setAttribute('placeholder', config.mobileSearchForm.placeholder);
	        searchInputField.setAttribute('name', config.mobileSearchForm.name);
	        searchInputField.setAttribute('aria-label', config.mobileSearchForm.ariaLabel);
	
	        var searchSubmitButton = document.createElement('button');
	        searchSubmitButton.setAttribute('type', 'submit');
	        searchSubmitButton.setAttribute('class', 'icon-search small');
	
	        // assemble the search form
	        searchForm.appendChild(searchInputField);
	        searchForm.appendChild(searchSubmitButton);
	
	        var searchResultField = document.createElement('ul');
	        searchResultField.setAttribute('class', 'dropdown-list');
	        searchResultField.setAttribute('style', 'display: none');
	
	        // Add the search form to the Mobile Nav before the Tier One Elements Loop
	        navMobilePanelWrapper.appendChild(searchForm);
	        navMobilePanelWrapper.appendChild(searchResultField);
	    }
	
	    var mobileHeader = document.querySelector('#primary-header').cloneNode(true);
	    var primaryHeaderLeftAnchors = mobileHeader.querySelectorAll('#header-left-links .desktop-links a');
	    var nonMenuAnchorUL = document.createElement('UL');
	    Array.prototype.forEach.call(primaryHeaderLeftAnchors, function (el, i) {
	        if (!el.getAttribute('data-side-panel-trigger')) {
	            var justAnchorLI = document.createElement('LI');
	            var anchorTextNode = document.createTextNode(el.innerHTML);
	            el.innerHTML = "";
	            var justAnchorSpan = document.createElement('SPAN');
	            justAnchorSpan.classList.add('geico-nav-menu-item');
	            justAnchorSpan.appendChild(anchorTextNode);
	            el.appendChild(justAnchorSpan);
	            justAnchorLI.appendChild(el);
	            nonMenuAnchorUL.appendChild(justAnchorLI);
	        }
	    });
	
	    // generate nav tier 1 elements
	    // pull nav elements from the desktop main menu.
	    var navElementsArray = mobileNavDiv.querySelectorAll('.panel-wrapper');
	    // Loop through and generate the mobile menu structure.
	    Array.prototype.forEach.call(navElementsArray, function (element, i) {
	        if (element.className.indexOf("no-mobile") === -1) {
	            (function () {
	                var tierOneElement = document.createElement('li');
	
	                // Element Headline and Label
	                var tierOneHeadline = document.createElement('div');
	                tierOneHeadline.setAttribute('class', 'accordion-headline');
	                tierOneHeadline.setAttribute('tabindex', '0');
	                var tierOneHeadlineH3 = document.createElement('h3');
	                tierOneHeadlineH3.innerHTML = element.getAttribute('data-side-panel').capitalizeFirstLetter();
	                tierOneHeadline.appendChild(tierOneHeadlineH3);
	
	                //element content container
	                var tierOneContentContainer = document.createElement('div');
	                tierOneContentContainer.setAttribute('class', 'accordion-content-container');
	
	                var tierOneContent = document.createElement('div');
	                tierOneContent.setAttribute('class', 'accordion-content');
	                tierOneContent.setAttribute('data-side-panel', 'mobile-menu');
	
	                var tierOneContentUl = document.createElement('ul');
	                // fill the ul with tier 2 and 3 elements.
	                Array.prototype.forEach.call(element.querySelectorAll('ul>li[data-name]'), function (el, i) {
	
	                    var classNames = el.className;
	                    var classArray = classNames.split(' ');
	
	                    el.className = classArray.join(' ');
	                    tierOneContentUl.appendChild(el);
	                });
	
	                // assemble the navigation
	                tierOneContent.appendChild(tierOneContentUl);
	                tierOneContentContainer.appendChild(tierOneContent);
	                tierOneElement.appendChild(tierOneHeadline);
	                tierOneElement.appendChild(tierOneContentContainer);
	                mobileNavigation.appendChild(tierOneElement);
	            })();
	        }
	    });
	
	    navMobilePanelWrapper.appendChild(mobileNavigation);
	    navMobilePanelWrapper.appendChild(nonMenuAnchorUL);
	
	    navContainer.appendChild(navMobilePanelWrapper);
	}
	
	/**
	 * Svetoslav Kostadinov
	 * 07.Jan.2016
	 *
	 * @returns {string}
	 */
	String.prototype.capitalizeFirstLetter = function () {
	    return this.charAt(0).toUpperCase() + this.slice(1);
	};
	
	/**
	 * initDesktopEvents()
	 * Initialize all desktop  events
	 */
	function initDesktopEvents() {
	    console.log("initDesktopEvents");
	
	    document.addEventListener('keyup', function (e) {
	        if (document.getElementById('wrapper').contains(e.target)) {
	            if (e.which == '9' || e.keyCode == '9') {
	                if (panelIsOpen) {
	                    closePanel(currentlyOpenPanel);
	                }
	            }
	        }
	    });
	
	    Array.prototype.forEach.call(panelTriggers, function (el, i) {
	        el.addEventListener('mouseenter', menuEnter);
	        el.addEventListener('mouseleave', menuLeave);
	    });
	
	    //keyboard navigation events on header anchors
	    Array.prototype.forEach.call(headerAnchors, function (el, i) {
	        addKeyboardFocus(el);
	        el.addEventListener('focus', focusPanel);
	    });
	
	    Array.prototype.forEach.call(panelTriggers, function (el, i) {
	        el.addEventListener('click', menuEnter);
	        el.addEventListener('keydown', menuEnter);
	    });
	
	    Array.prototype.forEach.call(mainListItems, function (el, i) {
	        el.addEventListener('mouseenter', openSubMenu);
	        el.addEventListener('focus', openSubMenu, true);
	    });
	
	    //for each submenu wrapper listen for its mouse over
	    //so we know when to close the menu when you roll off the submenu
	    Array.prototype.forEach.call(submenuWrapper, function (el, i) {
	        el.addEventListener('mouseover', submenuWrapperHover);
	    });
	
	    //for each panel listen for its mouse leave so we know when to close the menu
	    Array.prototype.forEach.call(panels, function (el, i) {
	        if (!el.querySelector('.geico-nav-menu-secondary-wrapper')) {
	            el.addEventListener('mouseleave', panelLeave);
	        } else {
	            var liNone = el.querySelectorAll('ul > li[class^="geico-nav"]');
	            Array.prototype.forEach.call(liNone, function (el, i) {
	                if (!el.querySelector('.geico-nav-menu-secondary-wrapper')) {
	                    el.addEventListener('mouseleave', menuLeave);
	                }
	            });
	        }
	
	        var firstFocusableInPanel = nav.querySelectorAll('.first-focusable');
	        Array.prototype.forEach.call(firstFocusableInPanel, function (el, i) {
	            el.addEventListener('keydown', keyPressSearchBackward);
	        });
	        if (document.querySelector('.search input')) {
	            document.querySelector('.search input').addEventListener('keydown', keyPressSearchBackward);
	        }
	
	        if (!el.classList.contains('search')) {
	            if (el.querySelector('ul') && el.firstElementChild.nodeName == 'UL' && el.querySelector('ul').firstElementChild && el.querySelector('ul').lastElementChild) {
	                el.querySelector('ul').firstElementChild.querySelector('a').addEventListener('keydown', keyPressFirstBackwards);
	                if (el.querySelector('ul').lastElementChild.querySelector('.geico-nav-menu-secondary-wrapper')) {
	                    el.querySelector('ul').lastElementChild.querySelector('.geico-nav-menu-secondary-wrapper').querySelector('ul').lastElementChild.querySelector('a').addEventListener('keydown', keyPressNextTab);
	                } else {
	                    el.querySelector('ul').lastElementChild.querySelector('a').addEventListener('keydown', keyPressNextTab);
	                }
	            } else {
	                if (el.lastElementChild.querySelector('ul') && el.lastElementChild.querySelector('ul').lastElementChild) {
	                    el.lastElementChild.querySelector('ul').lastElementChild.querySelector('a').addEventListener('keydown', keyPressNextTab);
	                }
	            }
	        }
	
	        navBackground.addEventListener('click', closeAllPanels);
	    });
	}
	
	function keyPressSearchBackward(e) {
	    if (e.shiftKey && e.keyCode == 9) {
	        e.preventDefault();
	
	        var parentPanel = e.target.parentNode.parentNode;
	        //to be refined for an easier way to implement this logic
	        if (!parentPanel.getAttribute('data-side-panel')) {
	            parentPanel = parentPanel.parentNode;
	            if (!parentPanel.getAttribute('data-side-panel')) {
	                parentPanel = parentPanel.parentNode;
	                if (!parentPanel.getAttribute('data-side-panel')) {
	                    parentPanel = parentPanel.parentNode;
	                }
	            }
	        }
	        header.querySelector('[data-side-panel-trigger="' + parentPanel.getAttribute('data-side-panel') + '"]').focus();
	        if (_appState2['default'].mode === "desktop") {
	            Array.prototype.forEach.call(headerAnchors, function (el, i) {
	                el.removeAttribute('tabindex');
	            });
	        }
	    }
	}
	
	function keyPressNextTab(e) {
	    if (e.shiftKey) {
	        return;
	    } else if (e.which == 9 || e.keyCode == 9) {
	        console.log('tab only');
	        console.log(e.target);
	        var parentPanel = findUpParent(e.target, 'data-side-panel');
	        //let parentPanel = e.target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;
	        //console.log(header.querySelector('[data-side-panel-trigger="' + parentPanel.getAttribute('data-side-panel') + '"]').parentNode);
	        header.querySelector('[data-side-panel-trigger="' + parentPanel.getAttribute('data-side-panel') + '"]').parentNode.querySelector('a').focus();
	    }
	}
	
	function keyPressFirstBackwards(e) {
	    //header.querySelector('[data-side-panel-trigger="versions"]').focus();
	    if (e.shiftKey && e.keyCode == 9) {
	        e.preventDefault();
	        var parentPanel = e.target.parentNode.parentNode.parentNode;
	        if (_appState2['default'].mode == 'desktop') {
	            header.querySelector('[data-side-panel-trigger="' + parentPanel.getAttribute('data-side-panel') + '"]').focus();
	        } else if (_appState2['default'].mode == 'mobile') {
	            header.querySelector('.mobile-links [data-side-panel-trigger="' + parentPanel.getAttribute('data-side-panel') + '"]').focus();
	        }
	        console.log(parentPanel);
	        console.log(header.querySelector('[data-side-panel-trigger="' + parentPanel.getAttribute('data-side-panel') + '"]'));
	    }
	}
	
	function findUpParent(el, attribute) {
	    while (el.parentNode) {
	        el = el.parentNode;
	        if (el.getAttribute(attribute)) return el;
	    }
	    return null;
	}
	
	/**
	 * initDesktopTouchEvents()
	 * Initialize all desktop touch events
	 */
	function initDesktopTouchEvents() {
	
	    //All panel triggers should have a click event that open or closes a panel
	    Array.prototype.forEach.call(panelTriggers, function (el, i) {
	        el.addEventListener('touchend', menuEnter);
	    });
	
	    Array.prototype.forEach.call(mainListItemsAnchor, function (el, i) {
	        el.addEventListener('click', openSubMenu);
	    });
	
	    //for each submenu wrapper listen for its mouse over
	    //so we know when to close the menu when you roll off the submenu
	    Array.prototype.forEach.call(submenuWrapper, function (el, i) {
	        el.addEventListener('touchend', submenuWrapperHover);
	    });
	
	    navBackground.addEventListener('touchend', closeAllPanels);
	}
	
	/**
	 * initMobileEvents()
	 * Initialize all mobile events
	 */
	function initMobileEvents() {
	    var isClick = false;
	
	    document.addEventListener('keyup', function (e) {
	        if (document.getElementById('wrapper').contains(e.target)) {
	            if (e.which == '9' || e.keyCode == '9') {
	                if (panelIsOpen) {
	                    closePanel(currentlyOpenPanel);
	                    header.querySelector('.mobile-links [data-side-panel-trigger="' + currentlyOpenPanel.getAttribute('data-side-panel') + '"]').focus();
	                }
	            }
	        }
	    });
	
	    //All panel triggers should have a click event that open or closes a panel
	    Array.prototype.forEach.call(panelTriggers, function (el, i) {
	        el.addEventListener('click', menuEnter);
	        el.addEventListener('keypress', menuEnter);
	    });
	
	    Array.prototype.forEach.call(headerAnchors, function (el, i) {
	        addKeyboardFocus(el);
	    });
	
	    //close mobile panel when focusing on geico logo
	    document.querySelector('#header-middle-links a').addEventListener('focus', function () {
	        Array.prototype.forEach.call(panels, function (panel, i) {
	            if (panel.classList.contains('open')) {
	                closePanel(panel);
	            }
	        });
	    });
	
	    Array.prototype.forEach.call(mainListItemsAnchorMobile, function (el, i) {
	        addKeyboardFocus(el);
	
	        el.addEventListener('mousedown', function () {
	            isClick = true;
	        });
	
	        el.addEventListener('click', openMobileSubMenu);
	
	        el.addEventListener('focus', function (e) {
	            var submenu = el.parentNode.getElementsByClassName('geico-nav-menu-secondary-wrapper');
	
	            if (!isClick && submenu.length > 0) {
	                openMobileSubMenu.bind(this)(e);
	            } else {
	                if (currentlyOpenSubPanel) {
	                    //closeMobileSubMenu(currentlyOpenSubPanel); do not need, duplicate
	                }
	            }
	
	            //reset flag
	            isClick = false;
	
	            var parentAccordion = findClosestParent(el, 'accordion-content-container');
	            var accordionHeadline = parentAccordion.parentNode.querySelector('.accordion-headline');
	
	            if (!parentAccordion.parentNode.classList.contains('open')) {
	                accordionHeadline.click();
	            }
	        });
	
	        Array.prototype.forEach.call(secondaryListItemsAnchorMobile, function (el, i) {
	            addKeyboardFocus(el);
	
	            el.addEventListener('focus', function (e) {
	                //var parentLI = el.closest('.accordion-content > ul > li');
	                var parentLI = findUpParent(el, 'data-name');
	                var submenu = parentLI.querySelector('.geico-nav-menu-secondary-wrapper');
	
	                if (!parentLI.classList.contains('open')) {
	                    openMobileSubMenu.bind(submenu)(e);
	                }
	
	                var parentAccordion = findClosestParent(el, 'accordion-content-container');
	                var accordionHeadline = parentAccordion.parentNode.querySelector('.accordion-headline');
	
	                if (!parentAccordion.parentNode.classList.contains('open')) {
	                    accordionHeadline.click();
	                }
	            });
	        });
	    });
	
	    navBackground.addEventListener('click', closeAllPanels);
	
	    Array.prototype.forEach.call(mobilenavaccordionHeadlines, function (el, i) {
	        addKeyboardFocus(el);
	        el.addEventListener('click', closeSubMenufromHeadline);
	    });
	
	    Array.prototype.forEach.call(headerAnchors, function (el, i) {
	        el.setAttribute('tabindex', '-1');
	        if (el.parentNode.parentNode.classList.contains('mobile-links') || el.parentNode.parentNode.classList.contains('right-mobile-links') || el.classList.contains('icon-geico')) {
	            el.removeAttribute('tabindex');
	        }
	    });
	
	    Array.prototype.forEach.call(mainListItemsAnchorRightMobile, function (el, i) {
	        el.addEventListener('focus', function () {
	            addKeyboardFocus(el);
	        });
	    });
	}
	
	/**
	 * initMobileTouchEvents()
	 * Initialize mobile touch events
	 */
	function initMobileTouchEvents() {
	
	    //All panel triggers should have a click event that open or closes a panel
	    Array.prototype.forEach.call(panelTriggers, function (el, i) {
	        el.addEventListener('touchend', menuEnter);
	    });
	
	    Array.prototype.forEach.call(mainListItemsAnchorMobile, function (el, i) {
	        el.addEventListener('click', openMobileSubMenu);
	    });
	
	    navBackground.addEventListener('touchend', closeAllPanels);
	
	    Array.prototype.forEach.call(mobilenavaccordionHeadlines, function (el, i) {
	        el.addEventListener('touchend', closeSubMenufromHeadline);
	    });
	}
	
	function closeSubMenufromHeadline() {
	    if (currentlyOpenSubPanel) {
	        closeMobileSubMenu(currentlyOpenSubPanel);
	        //console.log(subWrapper.getBoundingClientRect().top);
	    }
	}
	
	/**
	 * removeNavEvents()
	 * Remove all navigation events
	 */
	
	function removeNavEvents() {
	
	    Array.prototype.forEach.call(panelTriggers, function (el, i) {
	        el.removeEventListener('touchstart', menuEnter);
	        el.removeEventListener('click', menuEnter);
	        el.removeEventListener('mouseenter', menuEnter);
	        el.removeEventListener('mouseleave', menuLeave);
	        el.removeEventListener('keypress', menuEnter);
	        el.removeEventListener('touchend', menuEnter);
	    });
	
	    Array.prototype.forEach.call(headerAnchors, function (el, i) {
	        el.removeEventListener('keypress', menuEnter);
	        el.removeEventListener('focus', focusPanel);
	    });
	
	    Array.prototype.forEach.call(mainListItems, function (el, i) {
	        el.removeEventListener('mouseenter', openSubMenu);
	        el.removeEventListener('focus', openSubMenu, true);
	    });
	
	    Array.prototype.forEach.call(mainListItemsAnchor, function (el, i) {
	        el.removeEventListener('click', openMobileSubMenu);
	        el.removeEventListener('touchstart', openSubMenu);
	        el.removeEventListener('mouseenter', openSubMenu);
	    });
	
	    Array.prototype.forEach.call(submenuWrapper, function (el, i) {
	        el.removeEventListener('touchstart', submenuWrapperHover);
	        el.removeEventListener('mouseover', submenuWrapperHover);
	    });
	
	    Array.prototype.forEach.call(panels, function (el, i) {
	        el.removeEventListener('mouseleave', panelLeave);
	    });
	
	    navBackground.removeEventListener('touchstart', closeAllPanels);
	    navBackground.removeEventListener('click', closeAllPanels);
	
	    removeTabIndexes();
	}
	
	function focusPanel() {
	    Array.prototype.forEach.call(panels, function (panel, i) {
	        if (panel.classList.contains('open')) {
	            closePanel(panel);
	        }
	    });
	}
	
	/**
	 * removeTabIndexes()
	 * remove all tabindexes from nav elements
	 */
	function removeTabIndexes() {
	    var headerLinks = header.querySelectorAll('a');
	
	    Array.prototype.forEach.call(headerLinks, function (headerLink) {
	        headerLink.removeAttribute('tabindex');
	    });
	
	    var panelElements = nav.querySelectorAll('*');
	
	    Array.prototype.forEach.call(panelElements, function (panelElement) {
	        if (panelElement.classList && !panelElement.classList.contains('accordion-headline')) panelElement.removeAttribute('tabindex');
	    });
	}
	
	/**
	 * addKeyboardFocus()
	 * add/remove focus class to keyboard focused and blurred elements
	 */
	function addKeyboardFocus(element) {
	    var isClick = false;
	
	    element.addEventListener('mousedown', function () {
	        isClick = true;
	    });
	
	    element.addEventListener('focus', function (e) {
	        if (!isClick) {
	            element.classList.add('keyboard-focus');
	        }
	
	        //reset flag
	        isClick = false;
	    });
	
	    element.addEventListener('blur', function () {
	        element.classList.remove('keyboard-focus');
	    });
	}
	
	/**
	 * findClosestParent()
	 * finds closest parent element by class
	 */
	function findClosestParent(element, parentClass) {
	    while ((element = element.parentElement) && !element.classList.contains(parentClass));
	    return element;
	}
	
	/**
	 * menuEnter()
	 * Gets called whenever your mouse enters a trigger link
	 */
	
	function menuEnter(e) {
	    var _this = this;
	
	    //for keyboard navigation: if anything other than "enter" key is pressed do not continue
	    if ((e.type == 'keydown' || e.type == 'keypress') && (e.keyCode || e.which) != 13) {
	        return;
	    } else if (e.type == 'keydown' || e.type == 'keypress' || e.type == 'click') {
	        if (_appState2['default'].mode === "desktop") {
	            Array.prototype.forEach.call(headerAnchors, function (el, i) {
	                el.setAttribute('tabindex', '-1');
	            });
	        }
	        Array.prototype.forEach.call(submenuWrapper, function (el, i) {
	            el.removeEventListener('mouseover', submenuWrapperHover);
	        });
	    } else if (e.type == 'mouseenter') {
	        removeNavEvents();
	        if (_appState2['default'].isTouchDevice) {
	            initDesktopTouchEvents();
	        } else {
	            initDesktopEvents();
	        }
	        if (_appState2['default'].mode == "desktop") {
	            if (panelIsOpen && e.target.classList.contains('open')) {
	                e.preventDefault();
	                return;
	            }
	        }
	    } else if (e.type == 'click') {
	        if (_appState2['default'].mode == "desktop") {
	            if (panelIsOpen) {
	                e.preventDefault();
	                return;
	            }
	        }
	    }
	
	    e.preventDefault();
	    var panelToFind = undefined;
	
	    //get the name of the panel to find which is stored in the data attribute of the trigger
	    if (e.target.nodeName === "A") {
	        panelToFind = e.target.getAttribute('data-side-panel-trigger');
	    } else {
	        panelToFind = utils.getParentByTagName(e.target, "A").getAttribute('data-side-panel-trigger');
	    }
	
	    if (_appState2['default'].mode === "mobile" && utils.hasClass(this, 'open')) {
	
	        //if our mode is mobile and the panel is already open just close it
	        Array.prototype.forEach.call(panels, function (el, i) {
	
	            if (el.getAttribute('data-side-panel') === panelToFind) {
	                closePanel(el);
	            }
	        });
	    } else {
	        if (this.classList.contains('open')) {
	            closePanel(currentlyOpenPanel);
	            return;
	        }
	
	        //if there is a current panel open then close it before opening the new one
	        if (panelIsOpen) {
	            closePanel(currentlyOpenPanel);
	        }
	
	        //add and open class the the a tag
	        this.classList.add('open');
	        this.setAttribute('aria-expanded', 'true');
	
	        //for each panel find the one that was triggered
	        Array.prototype.forEach.call(panels, function (el, i) {
	
	            if (el.getAttribute('data-side-panel') === panelToFind) {
	
	                openPanel(el);
	                if (_appState2['default'].mode == 'desktop' && !_appState2['default'].isTouchDevice) el.style.display = "block";
	                var allAinPanel = el.querySelectorAll('a');
	                Array.prototype.forEach.call(allAinPanel, function (el, i) {
	                    el.removeAttribute('tabindex');
	                });
	                var allULinPanel = el.querySelectorAll('ul');
	                if (el.querySelector('.geico-nav-menu-secondary-wrapper')) {
	                    var allSecondaryUL = el.querySelectorAll('.geico-nav-menu-secondary-wrapper > ul');
	                    Array.prototype.forEach.call(allSecondaryUL, function (el, i) {
	                        el.removeAttribute('tabindex');
	                    });
	                    Array.prototype.forEach.call(allULinPanel, function (el, i) {
	                        el.setAttribute('tabindex', '-1');
	                        var allSVGinUL = el.querySelectorAll('svg');
	                        Array.prototype.forEach.call(allSVGinUL, function (el, i) {
	                            el.setAttribute('focusable', 'false');
	                        });
	                    });
	                }
	            } else {
	                if (_appState2['default'].mode == 'desktop' && !_appState2['default'].isTouchDevice) el.style.display = "none";
	                var allAinPanel = el.querySelectorAll('a');
	                Array.prototype.forEach.call(allAinPanel, function (el, i) {
	                    el.setAttribute('tabindex', '-1');
	                });
	                var allULinPanel = el.querySelectorAll('ul');
	
	                if (el.querySelector('.geico-nav-menu-secondary-wrapper')) {
	                    var allSecondaryUL = el.querySelectorAll('.geico-nav-menu-secondary-wrapper > ul');
	                    Array.prototype.forEach.call(allSecondaryUL, function (el, i) {
	                        el.setAttribute('tabindex', '-1');
	                    });
	                }
	                Array.prototype.forEach.call(allULinPanel, function (el, i) {
	                    el.setAttribute('tabindex', '-1');
	                });
	            }
	        });
	
	        //add a class to every panel trigger you did not roll over
	        Array.prototype.forEach.call(panelTriggers, function (el, i) {
	
	            if (el != _this) {
	                el.classList.add("not-open");
	                el.setAttribute('aria-expanded', 'false');
	            }
	        });
	    }
	}
	
	/**
	 * menuEnter()
	 * Gets called whenever your mouse leaves a trigger link
	 */
	function menuLeave(e) {
	    //When your mouse leaves the trigger detect if its over the open panel
	    //If its not over the open panel then close the panel
	    if (currentlyOpenPanel) {
	        if (!currentlyOpenPanel.contains(e.relatedTarget)) {
	            closePanel(currentlyOpenPanel);
	        }
	    }
	}
	
	function scrollTo(element, to, duration) {
	    if (duration <= 0) return;
	    var difference = to - element.scrollTop;
	    var perTick = difference / duration * 10;
	
	    setTimeout(function () {
	        element.scrollTop = element.scrollTop + perTick;
	        if (element.scrollTop === to) return;
	        scrollTo(element, to, duration - 10);
	    }, 10);
	}
	
	/**
	 * panelLeave()
	 * Gets fired when your mouse leaves a panel
	 */
	function panelLeave() {
	    //only close the panel if there is not a sub panel open
	    if (currentlyOpenSubPanel || currentlyOpenPanel) {
	        if (!currentlyOpenPanel.contains(document.activeElement)) {
	            closePanel(currentlyOpenPanel);
	        }
	    }
	}
	
	/**
	 * openPanel()
	 * Opens a panel by adding the necessary open a classes
	 */
	function openPanel(el) {
	
	    //if there is a panel close timer than cancel it because we just opened up another panel
	    if (panel_timer) {
	        clearTimeout(panel_timer);
	        nav.style.display = "block";
	    }
	
	    nav.style.display = "block";
	
	    if (_appState2['default'].mode === "mobile") {
	        document.querySelector('body').style.overflowY = "hidden";
	        document.querySelector('body').style.position = "fixed";
	
	        header.querySelector('#header-middle-links a').setAttribute('tabindex', '-1');
	
	        if (el.getAttribute('data-side-panel') == 'mobile-menu') {
	            var allHeaderRight = header.querySelectorAll('#header-right-links .mobile-links a');
	            Array.prototype.forEach.call(allHeaderRight, function (el, i) {
	                el.setAttribute('tabindex', '-1');
	            });
	        } else if (el.classList.contains('right')) {
	            header.querySelector('#header-middle-links a').removeAttribute('tabindex');
	        }
	    }
	
	    clearTimeout(open_timer);
	
	    open_timer = setTimeout(function () {
	
	        nav.classList.add('open');
	        if (el.getAttribute('data-side-panel') == 'mobile-menu') {
	            header.classList.add('open');
	        }
	        el.classList.add('open');
	        if (_appState2['default'].mode === 'mobile' && !_appState2['default'].isTouchDevice) {
	            Array.prototype.forEach.call(panels, function (el, i) {
	                if (!el.classList.contains('open')) {
	                    el.style.display = "none";
	                }
	            });
	        }
	
	        //store the open panel
	        currentlyOpenPanel = el;
	        panelIsOpen = true;
	    }, 50);
	}
	
	/**
	 * closePanel()
	 * Closes a panel by removing the necessary open a classes
	 */
	function closePanel(el, e) {
	
	    if (_appState2['default'].mode === "mobile") {
	        document.querySelector('body').style.overflowY = "visible";
	        document.querySelector('body').style.position = "relative";
	
	        closeAccordionsMobileNav();
	
	        header.querySelector('#header-middle-links a').removeAttribute('tabindex');
	    }
	    if (_appState2['default'].mode === 'mobile') {
	        Array.prototype.forEach.call(panels, function (el, i) {
	
	            el.removeAttribute('style');
	        });
	    }
	    nav.classList.remove('open');
	    header.classList.remove('open');
	    el.classList.remove('open');
	    panelIsOpen = false;
	    subpanelName = null;
	
	    Array.prototype.forEach.call(panelTriggers, function (el, i) {
	        el.classList.remove('open');
	        el.classList.remove('not-open');
	        el.setAttribute('aria-expanded', 'false');
	    });
	
	    //if a sub menu is open then close that
	    if (currentlyOpenSubPanel) {
	        currentlyOpenSubPanel.classList.remove("open");
	        currentlyOpenSubPanel = null;
	    }
	
	    panel_timer = setTimeout(function () {
	
	        Array.prototype.forEach.call(mainListItems, function (el, i) {
	            el.classList.remove("open");
	        });
	
	        if (_appState2['default'].mode === "mobile") {
	            Array.prototype.forEach.call(submenuWrapper, function (el, i) {
	                el.style.maxHeight = "0px";
	            });
	        }
	
	        nav.style.display = "none";
	        panel_timer = null;
	    }, 500);
	
	    removeTabIndexes();
	    //no animation for kit purpose because too jagged
	}
	
	/**
	 * submenuWrapperHover()
	 * Detects if you have rolled over the submenuWrapper
	 * so we know when to close the menu when you roll off the submenu
	 */
	function submenuWrapperHover(e) {
	    if (currentlyOpenPanel) {
	        //NodeList of items that the mouse is currently over in document order.
	        //The last element in the NodeList is the most specific, each preceding
	        //one should be a parent, grandparent, and so on.
	        var nodes = document.querySelectorAll(":hover");
	
	        //if the target node is a div an the last hovered node is the wrapper
	        //we know we are off the submenu so close menues
	        if (e.target.nodeName == "DIV" && e.target == nodes[nodes.length - 1]) {
	            closePanel(currentlyOpenPanel);
	        }
	    }
	}
	
	/**
	 * openSubMenu()
	 * Opens the submenu when you click on its parent li
	 * This is used when on a touch device
	 */
	function openSubMenu(e) {
	    Array.prototype.forEach.call(headerAnchors, function (el, i) {
	        el.removeAttribute('tabindex');
	    });
	    //dont open a subpanel if the parent is not open
	    if (!panelIsOpen) {
	        return;
	    }
	
	    clearTimeout(hover_timer);
	    var p = undefined;
	    var hoverDelay = undefined;
	    if (_appState2['default'].isTouchDevice) {
	        p = this.parentNode;
	        hoverDelay = 0;
	    } else {
	        p = this;
	        hoverDelay = 150;
	    }
	
	    var subWrapper = p.querySelector(".geico-nav-menu-secondary-wrapper");
	
	    if (subWrapper) {
	        e.preventDefault();
	    }
	    hover_timer = setTimeout(function () {
	
	        if (!utils.hasClass(p, 'open')) {
	            //animate the svg
	            if (p.querySelector("svg")) {
	                svgToAnim = p.querySelector("svg");
	                svgAnim();
	            }
	        }
	
	        //if a sub menu is open then close that
	        if (currentlyOpenSubPanel) {
	            currentlyOpenSubPanel.classList.remove("open");
	            currentlyOpenSubPanel = null;
	        }
	
	        currentlyOpenSubPanel = p;
	
	        if (!_appState2['default'].isTouchDevice) {
	            p.classList.toggle('open'); //this FF
	        }
	
	        if (subWrapper) {
	
	            if (_appState2['default'].isTouchDevice) {
	                p.classList.toggle('open');
	            }
	        }
	    }, hoverDelay);
	}
	
	/**
	 * closeMobileSubMenu()
	 * Opens the submenu when you click on its parent li
	 */
	function closeMobileSubMenu(el) {
	    el.classList.remove('open');
	    var subWrapper = el.querySelector(".geico-nav-menu-secondary-wrapper");
	    subWrapper.style.maxHeight = "0px";
	    currentlyOpenSubPanel = null;
	    subpanelName = null;
	}
	
	/**
	 * openMobileSubMenu()
	 * Opens the submenu when you click on its parent li
	 */
	function openMobileSubMenu(e) {
	
	    //console.log("openMobileSubMenu");
	
	    //this is the list item that was clicked
	    var p = this.parentNode;
	    var subWrapper = p.querySelector(".geico-nav-menu-secondary-wrapper");
	    var clickedSubpanelName = p.getAttribute('data-name');
	    var shouldOpenSubPanel = false;
	    var subMenuOpened = false;
	    //console.log(subWrapper.parentNode.querySelector('a').querySelector('span').getBoundingClientRect().top);
	
	    if (subWrapper) {
	        //if there is a submenu then prevent default
	        e.preventDefault();
	
	        if (subpanelName !== clickedSubpanelName) {
	            shouldOpenSubPanel = true;
	        }
	
	        ///close any open submenus
	        if (currentlyOpenSubPanel) {
	            subMenuOpened = true;
	            closeMobileSubMenu(currentlyOpenSubPanel);
	        }
	
	        //if the submenu you are trying to open up is not already open then open the submenu
	        if (shouldOpenSubPanel) {
	
	            //store the open panel and its name
	            currentlyOpenSubPanel = p;
	            subpanelName = this.parentNode.getAttribute('data-name');
	
	            if (!utils.hasClass(p, 'open')) {
	                //animate the svg
	                svgToAnim = p.querySelector("svg");
	                svgAnim();
	            }
	
	            p.classList.toggle('open');
	            var accordionContainer = searchParentByClassName(this, "accordion-content-container");
	
	            var subWrapperUl = subWrapper.querySelector("ul");
	            if (window.getComputedStyle(subWrapper).maxHeight == "0px") {
	
	                subWrapper.style.maxHeight = outerHeight(subWrapperUl) + "px";
	                accordionContainer.style.maxHeight = accordionContainer.offsetHeight + outerHeight(subWrapperUl) + "px";
	
	                //if there are no other submenus opened, scroll the current submenu being opened to the top of the page
	                if (subMenuOpened === false) {
	                    (function () {
	                        var aboveNavOffset = 0;
	                        var aboveNavElements = document.getElementsByClassName('above-nav');
	
	                        Array.prototype.forEach.call(aboveNavElements, function (el, i) {
	                            aboveNavOffset += el.offsetHeight;
	                        });
	
	                        var mobileMenu = document.querySelector('[data-side-panel="mobile-menu"]');
	                        var offset = p.getBoundingClientRect().top + mobileMenu.scrollTop - aboveNavOffset;
	
	                        setTimeout(function () {
	                            scrollTo(mobileMenu, offset, 200);
	                        }, 296);
	                    })();
	                }
	            } else {
	                accordionContainer.style.maxHeight = accordionContainer.offsetHeight - outerHeight(subWrapperUl) + "px";
	                subWrapper.style.maxHeight = "0px";
	            }
	        }
	    } else {
	        closePanel(currentlyOpenPanel);
	    }
	}
	
	/**
	 * Svetoslav Kostadinov
	 * 06.Jan.2016
	 * Recursive Search of a Parent element by a search Criteria
	 *
	 * @param sPoint // starting point
	 * @param criteria // search criteria
	 * @returns {*}
	 */
	function searchParentByClassName(sPoint, criteria) {
	    if (typeof sPoint === "undefined") {
	        return null;
	    } else if (sPoint.className.indexOf(criteria) === -1) {
	        var element = searchParentByClassName(sPoint.parentNode, criteria);
	        if (element !== null) return element;
	    } else {
	        return sPoint;
	    }
	}
	
	/**
	 * addSVGs()
	 * Adds the border SVGs to all first level nav items
	 */
	function addSVGs() {
	
	    //All panel triggers should have a click event that open or closes a panel
	    Array.prototype.forEach.call(actionableIcons, function (el, i) {
	        el.insertAdjacentHTML('beforebegin', '<svg width="60" height="60" version="1.1" xmlns="http://www.w3.org/2000/svg" style="width: 60px; height: 60px;"><circle cx="30" cy=\'30\' r="29" /></svg>');
	    });
	
	    Array.prototype.forEach.call(actionableIcons, function (el, i) {
	        el.style.width = "60px";
	        el.style.height = "60px";
	        el.style.lineHeight = "60px";
	        el.style.fontSize = "30px";
	    });
	}
	
	/**
	 * addSVGs()
	 * Adds additional markup to every hamburger item
	 */
	function addHamburgerMarkup() {
	
	    //All panel triggers should have a click event that open or closes a panel
	    Array.prototype.forEach.call(hamburgerIcons, function (el, i) {
	        el.insertAdjacentHTML('beforeend', '<div class="hamburger"><span></span><span></span><span></span><span></span></div>');
	    });
	}
	
	/**
	 * handleResize()
	 * listen for window resize so we can detect the mode
	 */
	function handleResize() {
	    if (_appState2['default'].mode === "desktop" && currentNavState === "mobile") {
	        //clear some styling
	        Array.prototype.forEach.call(submenuWrapper, function (el, i) {
	            el.removeAttribute('style');
	        });
	        Array.prototype.forEach.call(panels, function (el, i) {
	            if (!el.classList.contains('open')) {
	                el.removeAttribute('style');
	            }
	        });
	        removeNavEvents();
	        currentNavState = "desktop";
	        if (currentlyOpenPanel) {
	            closePanel(currentlyOpenPanel);
	        }
	        if (_appState2['default'].isTouchDevice) {
	            initDesktopTouchEvents();
	        } else {
	            initDesktopEvents();
	        }
	        //document.querySelector('body').style.overflowY = "visible";
	        //document.querySelector('body').style.position = "relative";
	        //body.style.overflowX = "visible";
	        body.removeAttribute('style');
	    } else if (_appState2['default'].mode === "mobile" && currentNavState === "desktop") {
	        removeNavEvents();
	        currentNavState = "mobile";
	        if (currentlyOpenPanel) {
	            closePanel(currentlyOpenPanel);
	        }
	        if (_appState2['default'].isTouchDevice) {
	            initMobileTouchEvents();
	        } else {
	            initMobileEvents();
	        }
	    }
	}
	
	/**
	 * closeAllPanels()
	 * this force closes all menus, good for single page apps thats need to close the menu
	 */
	function closeAllPanels() {
	
	    if (currentlyOpenPanel) {
	        closePanel(currentlyOpenPanel);
	    }
	}
	
	/**
	 * outerHeight()
	 * used to get the height of an element that is the same across all browsers
	 *
	 * @param  {Object} node    DOM node
	 * @return {number}
	 */
	function outerHeight(el) {
	    var height = el.offsetHeight;
	    var style = getComputedStyle(el);
	
	    height += parseInt(style.marginTop) + parseInt(style.marginBottom);
	    return height;
	}
	
	/**
	 * svgAnim()
	 * animates the svg around the icon
	 */
	function svgAnim() {
	
	    if (_appState2['default'].mode === "desktop") {
	        tick += tickSpeed;
	    } else {
	        tick += tickSpeedMobile;
	    }
	
	    var t = tick / 100;
	    var offsetStrokeDasharray = easeInQuad(t, 0, dashArrayComplete, 1);
	    svgToAnim.style.strokeDasharray = offsetStrokeDasharray + ' , ' + dashArrayComplete;
	
	    if (tick < 100) {
	        requestAnimationFrame(svgAnim.bind(this));
	    } else {
	        tick = 0;
	    }
	}
	
	/**
	 * easeInQuad()
	 * Quadratic easing
	 */
	function easeInQuad(t, b, c, d) {
	    var ts = (t /= d) * t;
	    return b + c * ts;
	}
	/**
	 * easeInCubic()
	 * Cubic easing
	 */
	function easeInCubic(t, b, c, d) {
	    var ts = (t /= d) * t * t;
	    return b + c * ts;
	}
	
	exports.init = init;
	exports.closeAllPanels = closeAllPanels;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	//Module Imports
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var _utils = __webpack_require__(8);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _appState = __webpack_require__(7);
	
	var _appState2 = _interopRequireDefault(_appState);
	
	//Global footer vars
	var copyRight = undefined,
	    footerNewYear = undefined,
	    footerCurrentYear = undefined;
	
	function init() {
	
	    console.log('Footer initialized');
	
	    setYear();
	}
	
	function setYear() {
	    copyRight = document.getElementById('footerDate');
	    footerNewYear = new Date();
	    footerCurrentYear = footerNewYear.getFullYear();
	    copyRight.innerHTML = footerCurrentYear;
	}
	
	exports.init = init;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	//Module Imports
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }
	
	var _utils = __webpack_require__(8);
	
	var utils = _interopRequireWildcard(_utils);
	
	function initAllTextareaCountdown() {
	    initAll(".textarea-countdown-container", "TextareaCountdown");
	}
	
	function initAllToolTips() {
	    initAll(".tooltip-trigger", "Tooltip");
	}
	
	function initAllVML() {
	    initAll(".view-more-less", "ViewMoreLess");
	}
	
	function initAllMoreInfoBtn() {
	    initAll(".more-info-button-container", "MoreInfoButton");
	}
	
	function initAllTabs() {
	    initAll(".tabs", "Tabs");
	}
	
	function initAllAlert() {
	    initAll(".alert", "Alert");
	}
	
	function initAllSortableTable() {
	    initAll(".table--sortable", "SortableTable");
	}
	
	function initAllAccordions() {
	    initAll(".accordion", "Accordion");
	}
	
	function initAllNavigationalBox() {
	    initAll(".navigational-box", "NavigationalBox");
	}
	
	//initAll(".view-more-less", "ViewMoreLess");
	
	function initAll(className, GDKname) {
	    for (var i = 0; i < document.querySelectorAll(className).length; i++) {
	        switch (GDKname) {
	            case "ViewMoreLess":
	                var vml = new GDK.ViewMoreLess({
	                    "content": document.querySelectorAll(className)[i]
	                });
	                break;
	            case "Tooltip":
	                var tooltip = new GDK.Tooltip({
	                    "content": document.querySelectorAll(className)[i]
	                });
	                break;
	            case "TextareaCountdown":
	                var tacountdown = new GDK.TextareaCountdown({
	                    "content": document.querySelectorAll(className)[i]
	                });
	                break;
	            case "MoreInfoButton":
	                var mib = new GDK.MoreInfoButton({
	                    "content": document.querySelectorAll(className)[i]
	                });
	                break;
	            case "Tabs":
	                var tab = new GDK.Tabs({
	                    "content": document.querySelectorAll(className)[i]
	                });
	                break;
	            case "Alert":
	                var alert = new GDK.Alert({
	                    "content": document.querySelectorAll(className)[i]
	                });
	                break;
	            case "SortableTable":
	                var sortableTable = new GDK.SortableTable({
	                    "content": document.querySelectorAll(className)[i]
	                });
	                break;
	            case "Accordion":
	                var accordion = new GDK.Accordion({
	                    "content": document.querySelectorAll(className)[i]
	                });
	                break;
	            case "NavigationalBox":
	                var navigationalBox = new GDK.NavigationalBox({
	                    "content": document.querySelectorAll(className)[i]
	                });
	        }
	    }
	}
	
	exports.initAllTextareaCountdown = initAllTextareaCountdown;
	exports.initAllToolTips = initAllToolTips;
	exports.initAllVML = initAllVML;
	exports.initAllMoreInfoBtn = initAllMoreInfoBtn;
	exports.initAllTabs = initAllTabs;
	exports.initAllAlert = initAllAlert;
	exports.initAllSortableTable = initAllSortableTable;
	exports.initAllAccordions = initAllAccordions;
	exports.initAllNavigationalBox = initAllNavigationalBox;

/***/ },
/* 12 */
/***/ function(module, exports) {

	module.exports = {
		"_comment": "This is a generated version.json file. Do not attempt to modify. Modify Version from package.json file.",
		"version": "4.2.0929",
		"date": "29, Sep, 2017"
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! jQuery v2.1.4 | (c) 2005, 2015 jQuery Foundation, Inc. | jquery.org/license */
	"use strict";
	
	!(function (a, b) {
	  "object" == typeof module && "object" == typeof module.exports ? module.exports = a.document ? b(a, !0) : function (a) {
	    if (!a.document) throw new Error("jQuery requires a window with a document");return b(a);
	  } : b(a);
	})("undefined" != typeof window ? window : undefined, function (a, b) {
	  var c = [],
	      d = c.slice,
	      e = c.concat,
	      f = c.push,
	      g = c.indexOf,
	      h = {},
	      i = h.toString,
	      j = h.hasOwnProperty,
	      k = {},
	      l = a.document,
	      m = "2.1.4",
	      n = function n(a, b) {
	    return new n.fn.init(a, b);
	  },
	      o = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	      p = /^-ms-/,
	      q = /-([\da-z])/gi,
	      r = function r(a, b) {
	    return b.toUpperCase();
	  };n.fn = n.prototype = { jquery: m, constructor: n, selector: "", length: 0, toArray: function toArray() {
	      return d.call(this);
	    }, get: function get(a) {
	      return null != a ? 0 > a ? this[a + this.length] : this[a] : d.call(this);
	    }, pushStack: function pushStack(a) {
	      var b = n.merge(this.constructor(), a);return b.prevObject = this, b.context = this.context, b;
	    }, each: function each(a, b) {
	      return n.each(this, a, b);
	    }, map: function map(a) {
	      return this.pushStack(n.map(this, function (b, c) {
	        return a.call(b, c, b);
	      }));
	    }, slice: function slice() {
	      return this.pushStack(d.apply(this, arguments));
	    }, first: function first() {
	      return this.eq(0);
	    }, last: function last() {
	      return this.eq(-1);
	    }, eq: function eq(a) {
	      var b = this.length,
	          c = +a + (0 > a ? b : 0);return this.pushStack(c >= 0 && b > c ? [this[c]] : []);
	    }, end: function end() {
	      return this.prevObject || this.constructor(null);
	    }, push: f, sort: c.sort, splice: c.splice }, n.extend = n.fn.extend = function () {
	    var a,
	        b,
	        c,
	        d,
	        e,
	        f,
	        g = arguments[0] || {},
	        h = 1,
	        i = arguments.length,
	        j = !1;for ("boolean" == typeof g && (j = g, g = arguments[h] || {}, h++), "object" == typeof g || n.isFunction(g) || (g = {}), h === i && (g = this, h--); i > h; h++) if (null != (a = arguments[h])) for (b in a) c = g[b], d = a[b], g !== d && (j && d && (n.isPlainObject(d) || (e = n.isArray(d))) ? (e ? (e = !1, f = c && n.isArray(c) ? c : []) : f = c && n.isPlainObject(c) ? c : {}, g[b] = n.extend(j, f, d)) : void 0 !== d && (g[b] = d));return g;
	  }, n.extend({ expando: "jQuery" + (m + Math.random()).replace(/\D/g, ""), isReady: !0, error: function error(a) {
	      throw new Error(a);
	    }, noop: function noop() {}, isFunction: function isFunction(a) {
	      return "function" === n.type(a);
	    }, isArray: Array.isArray, isWindow: function isWindow(a) {
	      return null != a && a === a.window;
	    }, isNumeric: function isNumeric(a) {
	      return !n.isArray(a) && a - parseFloat(a) + 1 >= 0;
	    }, isPlainObject: function isPlainObject(a) {
	      return "object" !== n.type(a) || a.nodeType || n.isWindow(a) ? !1 : a.constructor && !j.call(a.constructor.prototype, "isPrototypeOf") ? !1 : !0;
	    }, isEmptyObject: function isEmptyObject(a) {
	      var b;for (b in a) return !1;return !0;
	    }, type: function type(a) {
	      return null == a ? a + "" : "object" == typeof a || "function" == typeof a ? h[i.call(a)] || "object" : typeof a;
	    }, globalEval: function globalEval(a) {
	      var b,
	          c = eval;a = n.trim(a), a && (1 === a.indexOf("use strict") ? (b = l.createElement("script"), b.text = a, l.head.appendChild(b).parentNode.removeChild(b)) : c(a));
	    }, camelCase: function camelCase(a) {
	      return a.replace(p, "ms-").replace(q, r);
	    }, nodeName: function nodeName(a, b) {
	      return a.nodeName && a.nodeName.toLowerCase() === b.toLowerCase();
	    }, each: function each(a, b, c) {
	      var d,
	          e = 0,
	          f = a.length,
	          g = s(a);if (c) {
	        if (g) {
	          for (; f > e; e++) if ((d = b.apply(a[e], c), d === !1)) break;
	        } else for (e in a) if ((d = b.apply(a[e], c), d === !1)) break;
	      } else if (g) {
	        for (; f > e; e++) if ((d = b.call(a[e], e, a[e]), d === !1)) break;
	      } else for (e in a) if ((d = b.call(a[e], e, a[e]), d === !1)) break;return a;
	    }, trim: function trim(a) {
	      return null == a ? "" : (a + "").replace(o, "");
	    }, makeArray: function makeArray(a, b) {
	      var c = b || [];return null != a && (s(Object(a)) ? n.merge(c, "string" == typeof a ? [a] : a) : f.call(c, a)), c;
	    }, inArray: function inArray(a, b, c) {
	      return null == b ? -1 : g.call(b, a, c);
	    }, merge: function merge(a, b) {
	      for (var c = +b.length, d = 0, e = a.length; c > d; d++) a[e++] = b[d];return a.length = e, a;
	    }, grep: function grep(a, b, c) {
	      for (var d, e = [], f = 0, g = a.length, h = !c; g > f; f++) d = !b(a[f], f), d !== h && e.push(a[f]);return e;
	    }, map: function map(a, b, c) {
	      var d,
	          f = 0,
	          g = a.length,
	          h = s(a),
	          i = [];if (h) for (; g > f; f++) d = b(a[f], f, c), null != d && i.push(d);else for (f in a) d = b(a[f], f, c), null != d && i.push(d);return e.apply([], i);
	    }, guid: 1, proxy: function proxy(a, b) {
	      var c, e, f;return "string" == typeof b && (c = a[b], b = a, a = c), n.isFunction(a) ? (e = d.call(arguments, 2), f = function () {
	        return a.apply(b || this, e.concat(d.call(arguments)));
	      }, f.guid = a.guid = a.guid || n.guid++, f) : void 0;
	    }, now: Date.now, support: k }), n.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function (a, b) {
	    h["[object " + b + "]"] = b.toLowerCase();
	  });function s(a) {
	    var b = "length" in a && a.length,
	        c = n.type(a);return "function" === c || n.isWindow(a) ? !1 : 1 === a.nodeType && b ? !0 : "array" === c || 0 === b || "number" == typeof b && b > 0 && b - 1 in a;
	  }var t = (function (a) {
	    var b,
	        c,
	        d,
	        e,
	        f,
	        g,
	        h,
	        i,
	        j,
	        k,
	        l,
	        m,
	        n,
	        o,
	        p,
	        q,
	        r,
	        s,
	        t,
	        u = "sizzle" + 1 * new Date(),
	        v = a.document,
	        w = 0,
	        x = 0,
	        y = ha(),
	        z = ha(),
	        A = ha(),
	        B = function B(a, b) {
	      return a === b && (l = !0), 0;
	    },
	        C = 1 << 31,
	        D = ({}).hasOwnProperty,
	        E = [],
	        F = E.pop,
	        G = E.push,
	        H = E.push,
	        I = E.slice,
	        J = function J(a, b) {
	      for (var c = 0, d = a.length; d > c; c++) if (a[c] === b) return c;return -1;
	    },
	        K = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	        L = "[\\x20\\t\\r\\n\\f]",
	        M = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	        N = M.replace("w", "w#"),
	        O = "\\[" + L + "*(" + M + ")(?:" + L + "*([*^$|!~]?=)" + L + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + N + "))|)" + L + "*\\]",
	        P = ":(" + M + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + O + ")*)|.*)\\)|)",
	        Q = new RegExp(L + "+", "g"),
	        R = new RegExp("^" + L + "+|((?:^|[^\\\\])(?:\\\\.)*)" + L + "+$", "g"),
	        S = new RegExp("^" + L + "*," + L + "*"),
	        T = new RegExp("^" + L + "*([>+~]|" + L + ")" + L + "*"),
	        U = new RegExp("=" + L + "*([^\\]'\"]*?)" + L + "*\\]", "g"),
	        V = new RegExp(P),
	        W = new RegExp("^" + N + "$"),
	        X = { ID: new RegExp("^#(" + M + ")"), CLASS: new RegExp("^\\.(" + M + ")"), TAG: new RegExp("^(" + M.replace("w", "w*") + ")"), ATTR: new RegExp("^" + O), PSEUDO: new RegExp("^" + P), CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + L + "*(even|odd|(([+-]|)(\\d*)n|)" + L + "*(?:([+-]|)" + L + "*(\\d+)|))" + L + "*\\)|)", "i"), bool: new RegExp("^(?:" + K + ")$", "i"), needsContext: new RegExp("^" + L + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + L + "*((?:-\\d)?\\d*)" + L + "*\\)|)(?=[^-]|$)", "i") },
	        Y = /^(?:input|select|textarea|button)$/i,
	        Z = /^h\d$/i,
	        $ = /^[^{]+\{\s*\[native \w/,
	        _ = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	        aa = /[+~]/,
	        ba = /'|\\/g,
	        ca = new RegExp("\\\\([\\da-f]{1,6}" + L + "?|(" + L + ")|.)", "ig"),
	        da = function da(a, b, c) {
	      var d = "0x" + b - 65536;return d !== d || c ? b : 0 > d ? String.fromCharCode(d + 65536) : String.fromCharCode(d >> 10 | 55296, 1023 & d | 56320);
	    },
	        ea = function ea() {
	      m();
	    };try {
	      H.apply(E = I.call(v.childNodes), v.childNodes), E[v.childNodes.length].nodeType;
	    } catch (fa) {
	      H = { apply: E.length ? function (a, b) {
	          G.apply(a, I.call(b));
	        } : function (a, b) {
	          var c = a.length,
	              d = 0;while (a[c++] = b[d++]);a.length = c - 1;
	        } };
	    }function ga(a, b, d, e) {
	      var f, h, j, k, l, o, r, s, w, x;if (((b ? b.ownerDocument || b : v) !== n && m(b), b = b || n, d = d || [], k = b.nodeType, "string" != typeof a || !a || 1 !== k && 9 !== k && 11 !== k)) return d;if (!e && p) {
	        if (11 !== k && (f = _.exec(a))) if (j = f[1]) {
	          if (9 === k) {
	            if ((h = b.getElementById(j), !h || !h.parentNode)) return d;if (h.id === j) return d.push(h), d;
	          } else if (b.ownerDocument && (h = b.ownerDocument.getElementById(j)) && t(b, h) && h.id === j) return d.push(h), d;
	        } else {
	          if (f[2]) return H.apply(d, b.getElementsByTagName(a)), d;if ((j = f[3]) && c.getElementsByClassName) return H.apply(d, b.getElementsByClassName(j)), d;
	        }if (c.qsa && (!q || !q.test(a))) {
	          if ((s = r = u, w = b, x = 1 !== k && a, 1 === k && "object" !== b.nodeName.toLowerCase())) {
	            o = g(a), (r = b.getAttribute("id")) ? s = r.replace(ba, "\\$&") : b.setAttribute("id", s), s = "[id='" + s + "'] ", l = o.length;while (l--) o[l] = s + ra(o[l]);w = aa.test(a) && pa(b.parentNode) || b, x = o.join(",");
	          }if (x) try {
	            return H.apply(d, w.querySelectorAll(x)), d;
	          } catch (y) {} finally {
	            r || b.removeAttribute("id");
	          }
	        }
	      }return i(a.replace(R, "$1"), b, d, e);
	    }function ha() {
	      var a = [];function b(c, e) {
	        return a.push(c + " ") > d.cacheLength && delete b[a.shift()], b[c + " "] = e;
	      }return b;
	    }function ia(a) {
	      return a[u] = !0, a;
	    }function ja(a) {
	      var b = n.createElement("div");try {
	        return !!a(b);
	      } catch (c) {
	        return !1;
	      } finally {
	        b.parentNode && b.parentNode.removeChild(b), b = null;
	      }
	    }function ka(a, b) {
	      var c = a.split("|"),
	          e = a.length;while (e--) d.attrHandle[c[e]] = b;
	    }function la(a, b) {
	      var c = b && a,
	          d = c && 1 === a.nodeType && 1 === b.nodeType && (~b.sourceIndex || C) - (~a.sourceIndex || C);if (d) return d;if (c) while (c = c.nextSibling) if (c === b) return -1;return a ? 1 : -1;
	    }function ma(a) {
	      return function (b) {
	        var c = b.nodeName.toLowerCase();return "input" === c && b.type === a;
	      };
	    }function na(a) {
	      return function (b) {
	        var c = b.nodeName.toLowerCase();return ("input" === c || "button" === c) && b.type === a;
	      };
	    }function oa(a) {
	      return ia(function (b) {
	        return b = +b, ia(function (c, d) {
	          var e,
	              f = a([], c.length, b),
	              g = f.length;while (g--) c[e = f[g]] && (c[e] = !(d[e] = c[e]));
	        });
	      });
	    }function pa(a) {
	      return a && "undefined" != typeof a.getElementsByTagName && a;
	    }c = ga.support = {}, f = ga.isXML = function (a) {
	      var b = a && (a.ownerDocument || a).documentElement;return b ? "HTML" !== b.nodeName : !1;
	    }, m = ga.setDocument = function (a) {
	      var b,
	          e,
	          g = a ? a.ownerDocument || a : v;return g !== n && 9 === g.nodeType && g.documentElement ? (n = g, o = g.documentElement, e = g.defaultView, e && e !== e.top && (e.addEventListener ? e.addEventListener("unload", ea, !1) : e.attachEvent && e.attachEvent("onunload", ea)), p = !f(g), c.attributes = ja(function (a) {
	        return a.className = "i", !a.getAttribute("className");
	      }), c.getElementsByTagName = ja(function (a) {
	        return a.appendChild(g.createComment("")), !a.getElementsByTagName("*").length;
	      }), c.getElementsByClassName = $.test(g.getElementsByClassName), c.getById = ja(function (a) {
	        return o.appendChild(a).id = u, !g.getElementsByName || !g.getElementsByName(u).length;
	      }), c.getById ? (d.find.ID = function (a, b) {
	        if ("undefined" != typeof b.getElementById && p) {
	          var c = b.getElementById(a);return c && c.parentNode ? [c] : [];
	        }
	      }, d.filter.ID = function (a) {
	        var b = a.replace(ca, da);return function (a) {
	          return a.getAttribute("id") === b;
	        };
	      }) : (delete d.find.ID, d.filter.ID = function (a) {
	        var b = a.replace(ca, da);return function (a) {
	          var c = "undefined" != typeof a.getAttributeNode && a.getAttributeNode("id");return c && c.value === b;
	        };
	      }), d.find.TAG = c.getElementsByTagName ? function (a, b) {
	        return "undefined" != typeof b.getElementsByTagName ? b.getElementsByTagName(a) : c.qsa ? b.querySelectorAll(a) : void 0;
	      } : function (a, b) {
	        var c,
	            d = [],
	            e = 0,
	            f = b.getElementsByTagName(a);if ("*" === a) {
	          while (c = f[e++]) 1 === c.nodeType && d.push(c);return d;
	        }return f;
	      }, d.find.CLASS = c.getElementsByClassName && function (a, b) {
	        return p ? b.getElementsByClassName(a) : void 0;
	      }, r = [], q = [], (c.qsa = $.test(g.querySelectorAll)) && (ja(function (a) {
	        o.appendChild(a).innerHTML = "<a id='" + u + "'></a><select id='" + u + "-\f]' msallowcapture=''><option selected=''></option></select>", a.querySelectorAll("[msallowcapture^='']").length && q.push("[*^$]=" + L + "*(?:''|\"\")"), a.querySelectorAll("[selected]").length || q.push("\\[" + L + "*(?:value|" + K + ")"), a.querySelectorAll("[id~=" + u + "-]").length || q.push("~="), a.querySelectorAll(":checked").length || q.push(":checked"), a.querySelectorAll("a#" + u + "+*").length || q.push(".#.+[+~]");
	      }), ja(function (a) {
	        var b = g.createElement("input");b.setAttribute("type", "hidden"), a.appendChild(b).setAttribute("name", "D"), a.querySelectorAll("[name=d]").length && q.push("name" + L + "*[*^$|!~]?="), a.querySelectorAll(":enabled").length || q.push(":enabled", ":disabled"), a.querySelectorAll("*,:x"), q.push(",.*:");
	      })), (c.matchesSelector = $.test(s = o.matches || o.webkitMatchesSelector || o.mozMatchesSelector || o.oMatchesSelector || o.msMatchesSelector)) && ja(function (a) {
	        c.disconnectedMatch = s.call(a, "div"), s.call(a, "[s!='']:x"), r.push("!=", P);
	      }), q = q.length && new RegExp(q.join("|")), r = r.length && new RegExp(r.join("|")), b = $.test(o.compareDocumentPosition), t = b || $.test(o.contains) ? function (a, b) {
	        var c = 9 === a.nodeType ? a.documentElement : a,
	            d = b && b.parentNode;return a === d || !(!d || 1 !== d.nodeType || !(c.contains ? c.contains(d) : a.compareDocumentPosition && 16 & a.compareDocumentPosition(d)));
	      } : function (a, b) {
	        if (b) while (b = b.parentNode) if (b === a) return !0;return !1;
	      }, B = b ? function (a, b) {
	        if (a === b) return l = !0, 0;var d = !a.compareDocumentPosition - !b.compareDocumentPosition;return d ? d : (d = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : 1, 1 & d || !c.sortDetached && b.compareDocumentPosition(a) === d ? a === g || a.ownerDocument === v && t(v, a) ? -1 : b === g || b.ownerDocument === v && t(v, b) ? 1 : k ? J(k, a) - J(k, b) : 0 : 4 & d ? -1 : 1);
	      } : function (a, b) {
	        if (a === b) return l = !0, 0;var c,
	            d = 0,
	            e = a.parentNode,
	            f = b.parentNode,
	            h = [a],
	            i = [b];if (!e || !f) return a === g ? -1 : b === g ? 1 : e ? -1 : f ? 1 : k ? J(k, a) - J(k, b) : 0;if (e === f) return la(a, b);c = a;while (c = c.parentNode) h.unshift(c);c = b;while (c = c.parentNode) i.unshift(c);while (h[d] === i[d]) d++;return d ? la(h[d], i[d]) : h[d] === v ? -1 : i[d] === v ? 1 : 0;
	      }, g) : n;
	    }, ga.matches = function (a, b) {
	      return ga(a, null, null, b);
	    }, ga.matchesSelector = function (a, b) {
	      if (((a.ownerDocument || a) !== n && m(a), b = b.replace(U, "='$1']"), !(!c.matchesSelector || !p || r && r.test(b) || q && q.test(b)))) try {
	        var d = s.call(a, b);if (d || c.disconnectedMatch || a.document && 11 !== a.document.nodeType) return d;
	      } catch (e) {}return ga(b, n, null, [a]).length > 0;
	    }, ga.contains = function (a, b) {
	      return (a.ownerDocument || a) !== n && m(a), t(a, b);
	    }, ga.attr = function (a, b) {
	      (a.ownerDocument || a) !== n && m(a);var e = d.attrHandle[b.toLowerCase()],
	          f = e && D.call(d.attrHandle, b.toLowerCase()) ? e(a, b, !p) : void 0;return void 0 !== f ? f : c.attributes || !p ? a.getAttribute(b) : (f = a.getAttributeNode(b)) && f.specified ? f.value : null;
	    }, ga.error = function (a) {
	      throw new Error("Syntax error, unrecognized expression: " + a);
	    }, ga.uniqueSort = function (a) {
	      var b,
	          d = [],
	          e = 0,
	          f = 0;if ((l = !c.detectDuplicates, k = !c.sortStable && a.slice(0), a.sort(B), l)) {
	        while (b = a[f++]) b === a[f] && (e = d.push(f));while (e--) a.splice(d[e], 1);
	      }return k = null, a;
	    }, e = ga.getText = function (a) {
	      var b,
	          c = "",
	          d = 0,
	          f = a.nodeType;if (f) {
	        if (1 === f || 9 === f || 11 === f) {
	          if ("string" == typeof a.textContent) return a.textContent;for (a = a.firstChild; a; a = a.nextSibling) c += e(a);
	        } else if (3 === f || 4 === f) return a.nodeValue;
	      } else while (b = a[d++]) c += e(b);return c;
	    }, d = ga.selectors = { cacheLength: 50, createPseudo: ia, match: X, attrHandle: {}, find: {}, relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } }, preFilter: { ATTR: function ATTR(a) {
	          return a[1] = a[1].replace(ca, da), a[3] = (a[3] || a[4] || a[5] || "").replace(ca, da), "~=" === a[2] && (a[3] = " " + a[3] + " "), a.slice(0, 4);
	        }, CHILD: function CHILD(a) {
	          return a[1] = a[1].toLowerCase(), "nth" === a[1].slice(0, 3) ? (a[3] || ga.error(a[0]), a[4] = +(a[4] ? a[5] + (a[6] || 1) : 2 * ("even" === a[3] || "odd" === a[3])), a[5] = +(a[7] + a[8] || "odd" === a[3])) : a[3] && ga.error(a[0]), a;
	        }, PSEUDO: function PSEUDO(a) {
	          var b,
	              c = !a[6] && a[2];return X.CHILD.test(a[0]) ? null : (a[3] ? a[2] = a[4] || a[5] || "" : c && V.test(c) && (b = g(c, !0)) && (b = c.indexOf(")", c.length - b) - c.length) && (a[0] = a[0].slice(0, b), a[2] = c.slice(0, b)), a.slice(0, 3));
	        } }, filter: { TAG: function TAG(a) {
	          var b = a.replace(ca, da).toLowerCase();return "*" === a ? function () {
	            return !0;
	          } : function (a) {
	            return a.nodeName && a.nodeName.toLowerCase() === b;
	          };
	        }, CLASS: function CLASS(a) {
	          var b = y[a + " "];return b || (b = new RegExp("(^|" + L + ")" + a + "(" + L + "|$)")) && y(a, function (a) {
	            return b.test("string" == typeof a.className && a.className || "undefined" != typeof a.getAttribute && a.getAttribute("class") || "");
	          });
	        }, ATTR: function ATTR(a, b, c) {
	          return function (d) {
	            var e = ga.attr(d, a);return null == e ? "!=" === b : b ? (e += "", "=" === b ? e === c : "!=" === b ? e !== c : "^=" === b ? c && 0 === e.indexOf(c) : "*=" === b ? c && e.indexOf(c) > -1 : "$=" === b ? c && e.slice(-c.length) === c : "~=" === b ? (" " + e.replace(Q, " ") + " ").indexOf(c) > -1 : "|=" === b ? e === c || e.slice(0, c.length + 1) === c + "-" : !1) : !0;
	          };
	        }, CHILD: function CHILD(a, b, c, d, e) {
	          var f = "nth" !== a.slice(0, 3),
	              g = "last" !== a.slice(-4),
	              h = "of-type" === b;return 1 === d && 0 === e ? function (a) {
	            return !!a.parentNode;
	          } : function (b, c, i) {
	            var j,
	                k,
	                l,
	                m,
	                n,
	                o,
	                p = f !== g ? "nextSibling" : "previousSibling",
	                q = b.parentNode,
	                r = h && b.nodeName.toLowerCase(),
	                s = !i && !h;if (q) {
	              if (f) {
	                while (p) {
	                  l = b;while (l = l[p]) if (h ? l.nodeName.toLowerCase() === r : 1 === l.nodeType) return !1;o = p = "only" === a && !o && "nextSibling";
	                }return !0;
	              }if ((o = [g ? q.firstChild : q.lastChild], g && s)) {
	                k = q[u] || (q[u] = {}), j = k[a] || [], n = j[0] === w && j[1], m = j[0] === w && j[2], l = n && q.childNodes[n];while (l = ++n && l && l[p] || (m = n = 0) || o.pop()) if (1 === l.nodeType && ++m && l === b) {
	                  k[a] = [w, n, m];break;
	                }
	              } else if (s && (j = (b[u] || (b[u] = {}))[a]) && j[0] === w) m = j[1];else while (l = ++n && l && l[p] || (m = n = 0) || o.pop()) if ((h ? l.nodeName.toLowerCase() === r : 1 === l.nodeType) && ++m && (s && ((l[u] || (l[u] = {}))[a] = [w, m]), l === b)) break;return m -= e, m === d || m % d === 0 && m / d >= 0;
	            }
	          };
	        }, PSEUDO: function PSEUDO(a, b) {
	          var c,
	              e = d.pseudos[a] || d.setFilters[a.toLowerCase()] || ga.error("unsupported pseudo: " + a);return e[u] ? e(b) : e.length > 1 ? (c = [a, a, "", b], d.setFilters.hasOwnProperty(a.toLowerCase()) ? ia(function (a, c) {
	            var d,
	                f = e(a, b),
	                g = f.length;while (g--) d = J(a, f[g]), a[d] = !(c[d] = f[g]);
	          }) : function (a) {
	            return e(a, 0, c);
	          }) : e;
	        } }, pseudos: { not: ia(function (a) {
	          var b = [],
	              c = [],
	              d = h(a.replace(R, "$1"));return d[u] ? ia(function (a, b, c, e) {
	            var f,
	                g = d(a, null, e, []),
	                h = a.length;while (h--) (f = g[h]) && (a[h] = !(b[h] = f));
	          }) : function (a, e, f) {
	            return b[0] = a, d(b, null, f, c), b[0] = null, !c.pop();
	          };
	        }), has: ia(function (a) {
	          return function (b) {
	            return ga(a, b).length > 0;
	          };
	        }), contains: ia(function (a) {
	          return a = a.replace(ca, da), function (b) {
	            return (b.textContent || b.innerText || e(b)).indexOf(a) > -1;
	          };
	        }), lang: ia(function (a) {
	          return W.test(a || "") || ga.error("unsupported lang: " + a), a = a.replace(ca, da).toLowerCase(), function (b) {
	            var c;do if (c = p ? b.lang : b.getAttribute("xml:lang") || b.getAttribute("lang")) return c = c.toLowerCase(), c === a || 0 === c.indexOf(a + "-"); while ((b = b.parentNode) && 1 === b.nodeType);return !1;
	          };
	        }), target: function target(b) {
	          var c = a.location && a.location.hash;return c && c.slice(1) === b.id;
	        }, root: function root(a) {
	          return a === o;
	        }, focus: function focus(a) {
	          return a === n.activeElement && (!n.hasFocus || n.hasFocus()) && !!(a.type || a.href || ~a.tabIndex);
	        }, enabled: function enabled(a) {
	          return a.disabled === !1;
	        }, disabled: function disabled(a) {
	          return a.disabled === !0;
	        }, checked: function checked(a) {
	          var b = a.nodeName.toLowerCase();return "input" === b && !!a.checked || "option" === b && !!a.selected;
	        }, selected: function selected(a) {
	          return a.parentNode && a.parentNode.selectedIndex, a.selected === !0;
	        }, empty: function empty(a) {
	          for (a = a.firstChild; a; a = a.nextSibling) if (a.nodeType < 6) return !1;return !0;
	        }, parent: function parent(a) {
	          return !d.pseudos.empty(a);
	        }, header: function header(a) {
	          return Z.test(a.nodeName);
	        }, input: function input(a) {
	          return Y.test(a.nodeName);
	        }, button: function button(a) {
	          var b = a.nodeName.toLowerCase();return "input" === b && "button" === a.type || "button" === b;
	        }, text: function text(a) {
	          var b;return "input" === a.nodeName.toLowerCase() && "text" === a.type && (null == (b = a.getAttribute("type")) || "text" === b.toLowerCase());
	        }, first: oa(function () {
	          return [0];
	        }), last: oa(function (a, b) {
	          return [b - 1];
	        }), eq: oa(function (a, b, c) {
	          return [0 > c ? c + b : c];
	        }), even: oa(function (a, b) {
	          for (var c = 0; b > c; c += 2) a.push(c);return a;
	        }), odd: oa(function (a, b) {
	          for (var c = 1; b > c; c += 2) a.push(c);return a;
	        }), lt: oa(function (a, b, c) {
	          for (var d = 0 > c ? c + b : c; --d >= 0;) a.push(d);return a;
	        }), gt: oa(function (a, b, c) {
	          for (var d = 0 > c ? c + b : c; ++d < b;) a.push(d);return a;
	        }) } }, d.pseudos.nth = d.pseudos.eq;for (b in { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }) d.pseudos[b] = ma(b);for (b in { submit: !0, reset: !0 }) d.pseudos[b] = na(b);function qa() {}qa.prototype = d.filters = d.pseudos, d.setFilters = new qa(), g = ga.tokenize = function (a, b) {
	      var c,
	          e,
	          f,
	          g,
	          h,
	          i,
	          j,
	          k = z[a + " "];if (k) return b ? 0 : k.slice(0);h = a, i = [], j = d.preFilter;while (h) {
	        (!c || (e = S.exec(h))) && (e && (h = h.slice(e[0].length) || h), i.push(f = [])), c = !1, (e = T.exec(h)) && (c = e.shift(), f.push({ value: c, type: e[0].replace(R, " ") }), h = h.slice(c.length));for (g in d.filter) !(e = X[g].exec(h)) || j[g] && !(e = j[g](e)) || (c = e.shift(), f.push({ value: c, type: g, matches: e }), h = h.slice(c.length));if (!c) break;
	      }return b ? h.length : h ? ga.error(a) : z(a, i).slice(0);
	    };function ra(a) {
	      for (var b = 0, c = a.length, d = ""; c > b; b++) d += a[b].value;return d;
	    }function sa(a, b, c) {
	      var d = b.dir,
	          e = c && "parentNode" === d,
	          f = x++;return b.first ? function (b, c, f) {
	        while (b = b[d]) if (1 === b.nodeType || e) return a(b, c, f);
	      } : function (b, c, g) {
	        var h,
	            i,
	            j = [w, f];if (g) {
	          while (b = b[d]) if ((1 === b.nodeType || e) && a(b, c, g)) return !0;
	        } else while (b = b[d]) if (1 === b.nodeType || e) {
	          if ((i = b[u] || (b[u] = {}), (h = i[d]) && h[0] === w && h[1] === f)) return j[2] = h[2];if ((i[d] = j, j[2] = a(b, c, g))) return !0;
	        }
	      };
	    }function ta(a) {
	      return a.length > 1 ? function (b, c, d) {
	        var e = a.length;while (e--) if (!a[e](b, c, d)) return !1;return !0;
	      } : a[0];
	    }function ua(a, b, c) {
	      for (var d = 0, e = b.length; e > d; d++) ga(a, b[d], c);return c;
	    }function va(a, b, c, d, e) {
	      for (var f, g = [], h = 0, i = a.length, j = null != b; i > h; h++) (f = a[h]) && (!c || c(f, d, e)) && (g.push(f), j && b.push(h));return g;
	    }function wa(a, b, c, d, e, f) {
	      return d && !d[u] && (d = wa(d)), e && !e[u] && (e = wa(e, f)), ia(function (f, g, h, i) {
	        var j,
	            k,
	            l,
	            m = [],
	            n = [],
	            o = g.length,
	            p = f || ua(b || "*", h.nodeType ? [h] : h, []),
	            q = !a || !f && b ? p : va(p, m, a, h, i),
	            r = c ? e || (f ? a : o || d) ? [] : g : q;if ((c && c(q, r, h, i), d)) {
	          j = va(r, n), d(j, [], h, i), k = j.length;while (k--) (l = j[k]) && (r[n[k]] = !(q[n[k]] = l));
	        }if (f) {
	          if (e || a) {
	            if (e) {
	              j = [], k = r.length;while (k--) (l = r[k]) && j.push(q[k] = l);e(null, r = [], j, i);
	            }k = r.length;while (k--) (l = r[k]) && (j = e ? J(f, l) : m[k]) > -1 && (f[j] = !(g[j] = l));
	          }
	        } else r = va(r === g ? r.splice(o, r.length) : r), e ? e(null, g, r, i) : H.apply(g, r);
	      });
	    }function xa(a) {
	      for (var b, c, e, f = a.length, g = d.relative[a[0].type], h = g || d.relative[" "], i = g ? 1 : 0, k = sa(function (a) {
	        return a === b;
	      }, h, !0), l = sa(function (a) {
	        return J(b, a) > -1;
	      }, h, !0), m = [function (a, c, d) {
	        var e = !g && (d || c !== j) || ((b = c).nodeType ? k(a, c, d) : l(a, c, d));return b = null, e;
	      }]; f > i; i++) if (c = d.relative[a[i].type]) m = [sa(ta(m), c)];else {
	        if ((c = d.filter[a[i].type].apply(null, a[i].matches), c[u])) {
	          for (e = ++i; f > e; e++) if (d.relative[a[e].type]) break;return wa(i > 1 && ta(m), i > 1 && ra(a.slice(0, i - 1).concat({ value: " " === a[i - 2].type ? "*" : "" })).replace(R, "$1"), c, e > i && xa(a.slice(i, e)), f > e && xa(a = a.slice(e)), f > e && ra(a));
	        }m.push(c);
	      }return ta(m);
	    }function ya(a, b) {
	      var c = b.length > 0,
	          e = a.length > 0,
	          f = function f(_f, g, h, i, k) {
	        var l,
	            m,
	            o,
	            p = 0,
	            q = "0",
	            r = _f && [],
	            s = [],
	            t = j,
	            u = _f || e && d.find.TAG("*", k),
	            v = w += null == t ? 1 : Math.random() || .1,
	            x = u.length;for (k && (j = g !== n && g); q !== x && null != (l = u[q]); q++) {
	          if (e && l) {
	            m = 0;while (o = a[m++]) if (o(l, g, h)) {
	              i.push(l);break;
	            }k && (w = v);
	          }c && ((l = !o && l) && p--, _f && r.push(l));
	        }if ((p += q, c && q !== p)) {
	          m = 0;while (o = b[m++]) o(r, s, g, h);if (_f) {
	            if (p > 0) while (q--) r[q] || s[q] || (s[q] = F.call(i));s = va(s);
	          }H.apply(i, s), k && !_f && s.length > 0 && p + b.length > 1 && ga.uniqueSort(i);
	        }return k && (w = v, j = t), r;
	      };return c ? ia(f) : f;
	    }return h = ga.compile = function (a, b) {
	      var c,
	          d = [],
	          e = [],
	          f = A[a + " "];if (!f) {
	        b || (b = g(a)), c = b.length;while (c--) f = xa(b[c]), f[u] ? d.push(f) : e.push(f);f = A(a, ya(e, d)), f.selector = a;
	      }return f;
	    }, i = ga.select = function (a, b, e, f) {
	      var i,
	          j,
	          k,
	          l,
	          m,
	          n = "function" == typeof a && a,
	          o = !f && g(a = n.selector || a);if ((e = e || [], 1 === o.length)) {
	        if ((j = o[0] = o[0].slice(0), j.length > 2 && "ID" === (k = j[0]).type && c.getById && 9 === b.nodeType && p && d.relative[j[1].type])) {
	          if ((b = (d.find.ID(k.matches[0].replace(ca, da), b) || [])[0], !b)) return e;n && (b = b.parentNode), a = a.slice(j.shift().value.length);
	        }i = X.needsContext.test(a) ? 0 : j.length;while (i--) {
	          if ((k = j[i], d.relative[l = k.type])) break;if ((m = d.find[l]) && (f = m(k.matches[0].replace(ca, da), aa.test(j[0].type) && pa(b.parentNode) || b))) {
	            if ((j.splice(i, 1), a = f.length && ra(j), !a)) return H.apply(e, f), e;break;
	          }
	        }
	      }return (n || h(a, o))(f, b, !p, e, aa.test(a) && pa(b.parentNode) || b), e;
	    }, c.sortStable = u.split("").sort(B).join("") === u, c.detectDuplicates = !!l, m(), c.sortDetached = ja(function (a) {
	      return 1 & a.compareDocumentPosition(n.createElement("div"));
	    }), ja(function (a) {
	      return a.innerHTML = "<a href='#'></a>", "#" === a.firstChild.getAttribute("href");
	    }) || ka("type|href|height|width", function (a, b, c) {
	      return c ? void 0 : a.getAttribute(b, "type" === b.toLowerCase() ? 1 : 2);
	    }), c.attributes && ja(function (a) {
	      return a.innerHTML = "<input/>", a.firstChild.setAttribute("value", ""), "" === a.firstChild.getAttribute("value");
	    }) || ka("value", function (a, b, c) {
	      return c || "input" !== a.nodeName.toLowerCase() ? void 0 : a.defaultValue;
	    }), ja(function (a) {
	      return null == a.getAttribute("disabled");
	    }) || ka(K, function (a, b, c) {
	      var d;return c ? void 0 : a[b] === !0 ? b.toLowerCase() : (d = a.getAttributeNode(b)) && d.specified ? d.value : null;
	    }), ga;
	  })(a);n.find = t, n.expr = t.selectors, n.expr[":"] = n.expr.pseudos, n.unique = t.uniqueSort, n.text = t.getText, n.isXMLDoc = t.isXML, n.contains = t.contains;var u = n.expr.match.needsContext,
	      v = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
	      w = /^.[^:#\[\.,]*$/;function x(a, b, c) {
	    if (n.isFunction(b)) return n.grep(a, function (a, d) {
	      return !!b.call(a, d, a) !== c;
	    });if (b.nodeType) return n.grep(a, function (a) {
	      return a === b !== c;
	    });if ("string" == typeof b) {
	      if (w.test(b)) return n.filter(b, a, c);b = n.filter(b, a);
	    }return n.grep(a, function (a) {
	      return g.call(b, a) >= 0 !== c;
	    });
	  }n.filter = function (a, b, c) {
	    var d = b[0];return c && (a = ":not(" + a + ")"), 1 === b.length && 1 === d.nodeType ? n.find.matchesSelector(d, a) ? [d] : [] : n.find.matches(a, n.grep(b, function (a) {
	      return 1 === a.nodeType;
	    }));
	  }, n.fn.extend({ find: function find(a) {
	      var b,
	          c = this.length,
	          d = [],
	          e = this;if ("string" != typeof a) return this.pushStack(n(a).filter(function () {
	        for (b = 0; c > b; b++) if (n.contains(e[b], this)) return !0;
	      }));for (b = 0; c > b; b++) n.find(a, e[b], d);return d = this.pushStack(c > 1 ? n.unique(d) : d), d.selector = this.selector ? this.selector + " " + a : a, d;
	    }, filter: function filter(a) {
	      return this.pushStack(x(this, a || [], !1));
	    }, not: function not(a) {
	      return this.pushStack(x(this, a || [], !0));
	    }, is: function is(a) {
	      return !!x(this, "string" == typeof a && u.test(a) ? n(a) : a || [], !1).length;
	    } });var y,
	      z = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,
	      A = n.fn.init = function (a, b) {
	    var c, d;if (!a) return this;if ("string" == typeof a) {
	      if ((c = "<" === a[0] && ">" === a[a.length - 1] && a.length >= 3 ? [null, a, null] : z.exec(a), !c || !c[1] && b)) return !b || b.jquery ? (b || y).find(a) : this.constructor(b).find(a);if (c[1]) {
	        if ((b = b instanceof n ? b[0] : b, n.merge(this, n.parseHTML(c[1], b && b.nodeType ? b.ownerDocument || b : l, !0)), v.test(c[1]) && n.isPlainObject(b))) for (c in b) n.isFunction(this[c]) ? this[c](b[c]) : this.attr(c, b[c]);return this;
	      }return d = l.getElementById(c[2]), d && d.parentNode && (this.length = 1, this[0] = d), this.context = l, this.selector = a, this;
	    }return a.nodeType ? (this.context = this[0] = a, this.length = 1, this) : n.isFunction(a) ? "undefined" != typeof y.ready ? y.ready(a) : a(n) : (void 0 !== a.selector && (this.selector = a.selector, this.context = a.context), n.makeArray(a, this));
	  };A.prototype = n.fn, y = n(l);var B = /^(?:parents|prev(?:Until|All))/,
	      C = { children: !0, contents: !0, next: !0, prev: !0 };n.extend({ dir: function dir(a, b, c) {
	      var d = [],
	          e = void 0 !== c;while ((a = a[b]) && 9 !== a.nodeType) if (1 === a.nodeType) {
	        if (e && n(a).is(c)) break;d.push(a);
	      }return d;
	    }, sibling: function sibling(a, b) {
	      for (var c = []; a; a = a.nextSibling) 1 === a.nodeType && a !== b && c.push(a);return c;
	    } }), n.fn.extend({ has: function has(a) {
	      var b = n(a, this),
	          c = b.length;return this.filter(function () {
	        for (var a = 0; c > a; a++) if (n.contains(this, b[a])) return !0;
	      });
	    }, closest: function closest(a, b) {
	      for (var c, d = 0, e = this.length, f = [], g = u.test(a) || "string" != typeof a ? n(a, b || this.context) : 0; e > d; d++) for (c = this[d]; c && c !== b; c = c.parentNode) if (c.nodeType < 11 && (g ? g.index(c) > -1 : 1 === c.nodeType && n.find.matchesSelector(c, a))) {
	        f.push(c);break;
	      }return this.pushStack(f.length > 1 ? n.unique(f) : f);
	    }, index: function index(a) {
	      return a ? "string" == typeof a ? g.call(n(a), this[0]) : g.call(this, a.jquery ? a[0] : a) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
	    }, add: function add(a, b) {
	      return this.pushStack(n.unique(n.merge(this.get(), n(a, b))));
	    }, addBack: function addBack(a) {
	      return this.add(null == a ? this.prevObject : this.prevObject.filter(a));
	    } });function D(a, b) {
	    while ((a = a[b]) && 1 !== a.nodeType);return a;
	  }n.each({ parent: function parent(a) {
	      var b = a.parentNode;return b && 11 !== b.nodeType ? b : null;
	    }, parents: function parents(a) {
	      return n.dir(a, "parentNode");
	    }, parentsUntil: function parentsUntil(a, b, c) {
	      return n.dir(a, "parentNode", c);
	    }, next: function next(a) {
	      return D(a, "nextSibling");
	    }, prev: function prev(a) {
	      return D(a, "previousSibling");
	    }, nextAll: function nextAll(a) {
	      return n.dir(a, "nextSibling");
	    }, prevAll: function prevAll(a) {
	      return n.dir(a, "previousSibling");
	    }, nextUntil: function nextUntil(a, b, c) {
	      return n.dir(a, "nextSibling", c);
	    }, prevUntil: function prevUntil(a, b, c) {
	      return n.dir(a, "previousSibling", c);
	    }, siblings: function siblings(a) {
	      return n.sibling((a.parentNode || {}).firstChild, a);
	    }, children: function children(a) {
	      return n.sibling(a.firstChild);
	    }, contents: function contents(a) {
	      return a.contentDocument || n.merge([], a.childNodes);
	    } }, function (a, b) {
	    n.fn[a] = function (c, d) {
	      var e = n.map(this, b, c);return "Until" !== a.slice(-5) && (d = c), d && "string" == typeof d && (e = n.filter(d, e)), this.length > 1 && (C[a] || n.unique(e), B.test(a) && e.reverse()), this.pushStack(e);
	    };
	  });var E = /\S+/g,
	      F = {};function G(a) {
	    var b = F[a] = {};return n.each(a.match(E) || [], function (a, c) {
	      b[c] = !0;
	    }), b;
	  }n.Callbacks = function (a) {
	    a = "string" == typeof a ? F[a] || G(a) : n.extend({}, a);var b,
	        c,
	        d,
	        e,
	        f,
	        g,
	        h = [],
	        i = !a.once && [],
	        j = function j(l) {
	      for (b = a.memory && l, c = !0, g = e || 0, e = 0, f = h.length, d = !0; h && f > g; g++) if (h[g].apply(l[0], l[1]) === !1 && a.stopOnFalse) {
	        b = !1;break;
	      }d = !1, h && (i ? i.length && j(i.shift()) : b ? h = [] : k.disable());
	    },
	        k = { add: function add() {
	        if (h) {
	          var c = h.length;!(function g(b) {
	            n.each(b, function (b, c) {
	              var d = n.type(c);"function" === d ? a.unique && k.has(c) || h.push(c) : c && c.length && "string" !== d && g(c);
	            });
	          })(arguments), d ? f = h.length : b && (e = c, j(b));
	        }return this;
	      }, remove: function remove() {
	        return h && n.each(arguments, function (a, b) {
	          var c;while ((c = n.inArray(b, h, c)) > -1) h.splice(c, 1), d && (f >= c && f--, g >= c && g--);
	        }), this;
	      }, has: function has(a) {
	        return a ? n.inArray(a, h) > -1 : !(!h || !h.length);
	      }, empty: function empty() {
	        return h = [], f = 0, this;
	      }, disable: function disable() {
	        return h = i = b = void 0, this;
	      }, disabled: function disabled() {
	        return !h;
	      }, lock: function lock() {
	        return i = void 0, b || k.disable(), this;
	      }, locked: function locked() {
	        return !i;
	      }, fireWith: function fireWith(a, b) {
	        return !h || c && !i || (b = b || [], b = [a, b.slice ? b.slice() : b], d ? i.push(b) : j(b)), this;
	      }, fire: function fire() {
	        return k.fireWith(this, arguments), this;
	      }, fired: function fired() {
	        return !!c;
	      } };return k;
	  }, n.extend({ Deferred: function Deferred(a) {
	      var b = [["resolve", "done", n.Callbacks("once memory"), "resolved"], ["reject", "fail", n.Callbacks("once memory"), "rejected"], ["notify", "progress", n.Callbacks("memory")]],
	          c = "pending",
	          d = { state: function state() {
	          return c;
	        }, always: function always() {
	          return e.done(arguments).fail(arguments), this;
	        }, then: function then() {
	          var a = arguments;return n.Deferred(function (c) {
	            n.each(b, function (b, f) {
	              var g = n.isFunction(a[b]) && a[b];e[f[1]](function () {
	                var a = g && g.apply(this, arguments);a && n.isFunction(a.promise) ? a.promise().done(c.resolve).fail(c.reject).progress(c.notify) : c[f[0] + "With"](this === d ? c.promise() : this, g ? [a] : arguments);
	              });
	            }), a = null;
	          }).promise();
	        }, promise: function promise(a) {
	          return null != a ? n.extend(a, d) : d;
	        } },
	          e = {};return d.pipe = d.then, n.each(b, function (a, f) {
	        var g = f[2],
	            h = f[3];d[f[1]] = g.add, h && g.add(function () {
	          c = h;
	        }, b[1 ^ a][2].disable, b[2][2].lock), e[f[0]] = function () {
	          return e[f[0] + "With"](this === e ? d : this, arguments), this;
	        }, e[f[0] + "With"] = g.fireWith;
	      }), d.promise(e), a && a.call(e, e), e;
	    }, when: function when(a) {
	      var b = 0,
	          c = d.call(arguments),
	          e = c.length,
	          f = 1 !== e || a && n.isFunction(a.promise) ? e : 0,
	          g = 1 === f ? a : n.Deferred(),
	          h = function h(a, b, c) {
	        return function (e) {
	          b[a] = this, c[a] = arguments.length > 1 ? d.call(arguments) : e, c === i ? g.notifyWith(b, c) : --f || g.resolveWith(b, c);
	        };
	      },
	          i,
	          j,
	          k;if (e > 1) for (i = new Array(e), j = new Array(e), k = new Array(e); e > b; b++) c[b] && n.isFunction(c[b].promise) ? c[b].promise().done(h(b, k, c)).fail(g.reject).progress(h(b, j, i)) : --f;return f || g.resolveWith(k, c), g.promise();
	    } });var H;n.fn.ready = function (a) {
	    return n.ready.promise().done(a), this;
	  }, n.extend({ isReady: !1, readyWait: 1, holdReady: function holdReady(a) {
	      a ? n.readyWait++ : n.ready(!0);
	    }, ready: function ready(a) {
	      (a === !0 ? --n.readyWait : n.isReady) || (n.isReady = !0, a !== !0 && --n.readyWait > 0 || (H.resolveWith(l, [n]), n.fn.triggerHandler && (n(l).triggerHandler("ready"), n(l).off("ready"))));
	    } });function I() {
	    l.removeEventListener("DOMContentLoaded", I, !1), a.removeEventListener("load", I, !1), n.ready();
	  }n.ready.promise = function (b) {
	    return H || (H = n.Deferred(), "complete" === l.readyState ? setTimeout(n.ready) : (l.addEventListener("DOMContentLoaded", I, !1), a.addEventListener("load", I, !1))), H.promise(b);
	  }, n.ready.promise();var J = n.access = function (a, b, c, d, e, f, g) {
	    var h = 0,
	        i = a.length,
	        j = null == c;if ("object" === n.type(c)) {
	      e = !0;for (h in c) n.access(a, b, h, c[h], !0, f, g);
	    } else if (void 0 !== d && (e = !0, n.isFunction(d) || (g = !0), j && (g ? (b.call(a, d), b = null) : (j = b, b = function (a, b, c) {
	      return j.call(n(a), c);
	    })), b)) for (; i > h; h++) b(a[h], c, g ? d : d.call(a[h], h, b(a[h], c)));return e ? a : j ? b.call(a) : i ? b(a[0], c) : f;
	  };n.acceptData = function (a) {
	    return 1 === a.nodeType || 9 === a.nodeType || ! +a.nodeType;
	  };function K() {
	    Object.defineProperty(this.cache = {}, 0, { get: function get() {
	        return {};
	      } }), this.expando = n.expando + K.uid++;
	  }K.uid = 1, K.accepts = n.acceptData, K.prototype = { key: function key(a) {
	      if (!K.accepts(a)) return 0;var b = {},
	          c = a[this.expando];if (!c) {
	        c = K.uid++;try {
	          b[this.expando] = { value: c }, Object.defineProperties(a, b);
	        } catch (d) {
	          b[this.expando] = c, n.extend(a, b);
	        }
	      }return this.cache[c] || (this.cache[c] = {}), c;
	    }, set: function set(a, b, c) {
	      var d,
	          e = this.key(a),
	          f = this.cache[e];if ("string" == typeof b) f[b] = c;else if (n.isEmptyObject(f)) n.extend(this.cache[e], b);else for (d in b) f[d] = b[d];return f;
	    }, get: function get(a, b) {
	      var c = this.cache[this.key(a)];return void 0 === b ? c : c[b];
	    }, access: function access(a, b, c) {
	      var d;return void 0 === b || b && "string" == typeof b && void 0 === c ? (d = this.get(a, b), void 0 !== d ? d : this.get(a, n.camelCase(b))) : (this.set(a, b, c), void 0 !== c ? c : b);
	    }, remove: function remove(a, b) {
	      var c,
	          d,
	          e,
	          f = this.key(a),
	          g = this.cache[f];if (void 0 === b) this.cache[f] = {};else {
	        n.isArray(b) ? d = b.concat(b.map(n.camelCase)) : (e = n.camelCase(b), b in g ? d = [b, e] : (d = e, d = d in g ? [d] : d.match(E) || [])), c = d.length;while (c--) delete g[d[c]];
	      }
	    }, hasData: function hasData(a) {
	      return !n.isEmptyObject(this.cache[a[this.expando]] || {});
	    }, discard: function discard(a) {
	      a[this.expando] && delete this.cache[a[this.expando]];
	    } };var L = new K(),
	      M = new K(),
	      N = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	      O = /([A-Z])/g;function P(a, b, c) {
	    var d;if (void 0 === c && 1 === a.nodeType) if ((d = "data-" + b.replace(O, "-$1").toLowerCase(), c = a.getAttribute(d), "string" == typeof c)) {
	      try {
	        c = "true" === c ? !0 : "false" === c ? !1 : "null" === c ? null : +c + "" === c ? +c : N.test(c) ? n.parseJSON(c) : c;
	      } catch (e) {}M.set(a, b, c);
	    } else c = void 0;return c;
	  }n.extend({ hasData: function hasData(a) {
	      return M.hasData(a) || L.hasData(a);
	    }, data: function data(a, b, c) {
	      return M.access(a, b, c);
	    }, removeData: function removeData(a, b) {
	      M.remove(a, b);
	    }, _data: function _data(a, b, c) {
	      return L.access(a, b, c);
	    }, _removeData: function _removeData(a, b) {
	      L.remove(a, b);
	    } }), n.fn.extend({ data: function data(a, b) {
	      var c,
	          d,
	          e,
	          f = this[0],
	          g = f && f.attributes;if (void 0 === a) {
	        if (this.length && (e = M.get(f), 1 === f.nodeType && !L.get(f, "hasDataAttrs"))) {
	          c = g.length;while (c--) g[c] && (d = g[c].name, 0 === d.indexOf("data-") && (d = n.camelCase(d.slice(5)), P(f, d, e[d])));L.set(f, "hasDataAttrs", !0);
	        }return e;
	      }return "object" == typeof a ? this.each(function () {
	        M.set(this, a);
	      }) : J(this, function (b) {
	        var c,
	            d = n.camelCase(a);if (f && void 0 === b) {
	          if ((c = M.get(f, a), void 0 !== c)) return c;if ((c = M.get(f, d), void 0 !== c)) return c;if ((c = P(f, d, void 0), void 0 !== c)) return c;
	        } else this.each(function () {
	          var c = M.get(this, d);M.set(this, d, b), -1 !== a.indexOf("-") && void 0 !== c && M.set(this, a, b);
	        });
	      }, null, b, arguments.length > 1, null, !0);
	    }, removeData: function removeData(a) {
	      return this.each(function () {
	        M.remove(this, a);
	      });
	    } }), n.extend({ queue: function queue(a, b, c) {
	      var d;return a ? (b = (b || "fx") + "queue", d = L.get(a, b), c && (!d || n.isArray(c) ? d = L.access(a, b, n.makeArray(c)) : d.push(c)), d || []) : void 0;
	    }, dequeue: function dequeue(a, b) {
	      b = b || "fx";var c = n.queue(a, b),
	          d = c.length,
	          e = c.shift(),
	          f = n._queueHooks(a, b),
	          g = function g() {
	        n.dequeue(a, b);
	      };"inprogress" === e && (e = c.shift(), d--), e && ("fx" === b && c.unshift("inprogress"), delete f.stop, e.call(a, g, f)), !d && f && f.empty.fire();
	    }, _queueHooks: function _queueHooks(a, b) {
	      var c = b + "queueHooks";return L.get(a, c) || L.access(a, c, { empty: n.Callbacks("once memory").add(function () {
	          L.remove(a, [b + "queue", c]);
	        }) });
	    } }), n.fn.extend({ queue: function queue(a, b) {
	      var c = 2;return "string" != typeof a && (b = a, a = "fx", c--), arguments.length < c ? n.queue(this[0], a) : void 0 === b ? this : this.each(function () {
	        var c = n.queue(this, a, b);n._queueHooks(this, a), "fx" === a && "inprogress" !== c[0] && n.dequeue(this, a);
	      });
	    }, dequeue: function dequeue(a) {
	      return this.each(function () {
	        n.dequeue(this, a);
	      });
	    }, clearQueue: function clearQueue(a) {
	      return this.queue(a || "fx", []);
	    }, promise: function promise(a, b) {
	      var c,
	          d = 1,
	          e = n.Deferred(),
	          f = this,
	          g = this.length,
	          h = function h() {
	        --d || e.resolveWith(f, [f]);
	      };"string" != typeof a && (b = a, a = void 0), a = a || "fx";while (g--) c = L.get(f[g], a + "queueHooks"), c && c.empty && (d++, c.empty.add(h));return h(), e.promise(b);
	    } });var Q = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
	      R = ["Top", "Right", "Bottom", "Left"],
	      S = function S(a, b) {
	    return a = b || a, "none" === n.css(a, "display") || !n.contains(a.ownerDocument, a);
	  },
	      T = /^(?:checkbox|radio)$/i;!(function () {
	    var a = l.createDocumentFragment(),
	        b = a.appendChild(l.createElement("div")),
	        c = l.createElement("input");c.setAttribute("type", "radio"), c.setAttribute("checked", "checked"), c.setAttribute("name", "t"), b.appendChild(c), k.checkClone = b.cloneNode(!0).cloneNode(!0).lastChild.checked, b.innerHTML = "<textarea>x</textarea>", k.noCloneChecked = !!b.cloneNode(!0).lastChild.defaultValue;
	  })();var U = "undefined";k.focusinBubbles = "onfocusin" in a;var V = /^key/,
	      W = /^(?:mouse|pointer|contextmenu)|click/,
	      X = /^(?:focusinfocus|focusoutblur)$/,
	      Y = /^([^.]*)(?:\.(.+)|)$/;function Z() {
	    return !0;
	  }function $() {
	    return !1;
	  }function _() {
	    try {
	      return l.activeElement;
	    } catch (a) {}
	  }n.event = { global: {}, add: function add(a, b, c, d, e) {
	      var f,
	          g,
	          h,
	          i,
	          j,
	          k,
	          l,
	          m,
	          o,
	          p,
	          q,
	          r = L.get(a);if (r) {
	        c.handler && (f = c, c = f.handler, e = f.selector), c.guid || (c.guid = n.guid++), (i = r.events) || (i = r.events = {}), (g = r.handle) || (g = r.handle = function (b) {
	          return typeof n !== U && n.event.triggered !== b.type ? n.event.dispatch.apply(a, arguments) : void 0;
	        }), b = (b || "").match(E) || [""], j = b.length;while (j--) h = Y.exec(b[j]) || [], o = q = h[1], p = (h[2] || "").split(".").sort(), o && (l = n.event.special[o] || {}, o = (e ? l.delegateType : l.bindType) || o, l = n.event.special[o] || {}, k = n.extend({ type: o, origType: q, data: d, handler: c, guid: c.guid, selector: e, needsContext: e && n.expr.match.needsContext.test(e), namespace: p.join(".") }, f), (m = i[o]) || (m = i[o] = [], m.delegateCount = 0, l.setup && l.setup.call(a, d, p, g) !== !1 || a.addEventListener && a.addEventListener(o, g, !1)), l.add && (l.add.call(a, k), k.handler.guid || (k.handler.guid = c.guid)), e ? m.splice(m.delegateCount++, 0, k) : m.push(k), n.event.global[o] = !0);
	      }
	    }, remove: function remove(a, b, c, d, e) {
	      var f,
	          g,
	          h,
	          i,
	          j,
	          k,
	          l,
	          m,
	          o,
	          p,
	          q,
	          r = L.hasData(a) && L.get(a);if (r && (i = r.events)) {
	        b = (b || "").match(E) || [""], j = b.length;while (j--) if ((h = Y.exec(b[j]) || [], o = q = h[1], p = (h[2] || "").split(".").sort(), o)) {
	          l = n.event.special[o] || {}, o = (d ? l.delegateType : l.bindType) || o, m = i[o] || [], h = h[2] && new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)"), g = f = m.length;while (f--) k = m[f], !e && q !== k.origType || c && c.guid !== k.guid || h && !h.test(k.namespace) || d && d !== k.selector && ("**" !== d || !k.selector) || (m.splice(f, 1), k.selector && m.delegateCount--, l.remove && l.remove.call(a, k));g && !m.length && (l.teardown && l.teardown.call(a, p, r.handle) !== !1 || n.removeEvent(a, o, r.handle), delete i[o]);
	        } else for (o in i) n.event.remove(a, o + b[j], c, d, !0);n.isEmptyObject(i) && (delete r.handle, L.remove(a, "events"));
	      }
	    }, trigger: function trigger(b, c, d, e) {
	      var f,
	          g,
	          h,
	          i,
	          k,
	          m,
	          o,
	          p = [d || l],
	          q = j.call(b, "type") ? b.type : b,
	          r = j.call(b, "namespace") ? b.namespace.split(".") : [];if ((g = h = d = d || l, 3 !== d.nodeType && 8 !== d.nodeType && !X.test(q + n.event.triggered) && (q.indexOf(".") >= 0 && (r = q.split("."), q = r.shift(), r.sort()), k = q.indexOf(":") < 0 && "on" + q, b = b[n.expando] ? b : new n.Event(q, "object" == typeof b && b), b.isTrigger = e ? 2 : 3, b.namespace = r.join("."), b.namespace_re = b.namespace ? new RegExp("(^|\\.)" + r.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, b.result = void 0, b.target || (b.target = d), c = null == c ? [b] : n.makeArray(c, [b]), o = n.event.special[q] || {}, e || !o.trigger || o.trigger.apply(d, c) !== !1))) {
	        if (!e && !o.noBubble && !n.isWindow(d)) {
	          for (i = o.delegateType || q, X.test(i + q) || (g = g.parentNode); g; g = g.parentNode) p.push(g), h = g;h === (d.ownerDocument || l) && p.push(h.defaultView || h.parentWindow || a);
	        }f = 0;while ((g = p[f++]) && !b.isPropagationStopped()) b.type = f > 1 ? i : o.bindType || q, m = (L.get(g, "events") || {})[b.type] && L.get(g, "handle"), m && m.apply(g, c), m = k && g[k], m && m.apply && n.acceptData(g) && (b.result = m.apply(g, c), b.result === !1 && b.preventDefault());return b.type = q, e || b.isDefaultPrevented() || o._default && o._default.apply(p.pop(), c) !== !1 || !n.acceptData(d) || k && n.isFunction(d[q]) && !n.isWindow(d) && (h = d[k], h && (d[k] = null), n.event.triggered = q, d[q](), n.event.triggered = void 0, h && (d[k] = h)), b.result;
	      }
	    }, dispatch: function dispatch(a) {
	      a = n.event.fix(a);var b,
	          c,
	          e,
	          f,
	          g,
	          h = [],
	          i = d.call(arguments),
	          j = (L.get(this, "events") || {})[a.type] || [],
	          k = n.event.special[a.type] || {};if ((i[0] = a, a.delegateTarget = this, !k.preDispatch || k.preDispatch.call(this, a) !== !1)) {
	        h = n.event.handlers.call(this, a, j), b = 0;while ((f = h[b++]) && !a.isPropagationStopped()) {
	          a.currentTarget = f.elem, c = 0;while ((g = f.handlers[c++]) && !a.isImmediatePropagationStopped()) (!a.namespace_re || a.namespace_re.test(g.namespace)) && (a.handleObj = g, a.data = g.data, e = ((n.event.special[g.origType] || {}).handle || g.handler).apply(f.elem, i), void 0 !== e && (a.result = e) === !1 && (a.preventDefault(), a.stopPropagation()));
	        }return k.postDispatch && k.postDispatch.call(this, a), a.result;
	      }
	    }, handlers: function handlers(a, b) {
	      var c,
	          d,
	          e,
	          f,
	          g = [],
	          h = b.delegateCount,
	          i = a.target;if (h && i.nodeType && (!a.button || "click" !== a.type)) for (; i !== this; i = i.parentNode || this) if (i.disabled !== !0 || "click" !== a.type) {
	        for (d = [], c = 0; h > c; c++) f = b[c], e = f.selector + " ", void 0 === d[e] && (d[e] = f.needsContext ? n(e, this).index(i) >= 0 : n.find(e, this, null, [i]).length), d[e] && d.push(f);d.length && g.push({ elem: i, handlers: d });
	      }return h < b.length && g.push({ elem: this, handlers: b.slice(h) }), g;
	    }, props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "), fixHooks: {}, keyHooks: { props: "char charCode key keyCode".split(" "), filter: function filter(a, b) {
	        return null == a.which && (a.which = null != b.charCode ? b.charCode : b.keyCode), a;
	      } }, mouseHooks: { props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "), filter: function filter(a, b) {
	        var c,
	            d,
	            e,
	            f = b.button;return null == a.pageX && null != b.clientX && (c = a.target.ownerDocument || l, d = c.documentElement, e = c.body, a.pageX = b.clientX + (d && d.scrollLeft || e && e.scrollLeft || 0) - (d && d.clientLeft || e && e.clientLeft || 0), a.pageY = b.clientY + (d && d.scrollTop || e && e.scrollTop || 0) - (d && d.clientTop || e && e.clientTop || 0)), a.which || void 0 === f || (a.which = 1 & f ? 1 : 2 & f ? 3 : 4 & f ? 2 : 0), a;
	      } }, fix: function fix(a) {
	      if (a[n.expando]) return a;var b,
	          c,
	          d,
	          e = a.type,
	          f = a,
	          g = this.fixHooks[e];g || (this.fixHooks[e] = g = W.test(e) ? this.mouseHooks : V.test(e) ? this.keyHooks : {}), d = g.props ? this.props.concat(g.props) : this.props, a = new n.Event(f), b = d.length;while (b--) c = d[b], a[c] = f[c];return a.target || (a.target = l), 3 === a.target.nodeType && (a.target = a.target.parentNode), g.filter ? g.filter(a, f) : a;
	    }, special: { load: { noBubble: !0 }, focus: { trigger: function trigger() {
	          return this !== _() && this.focus ? (this.focus(), !1) : void 0;
	        }, delegateType: "focusin" }, blur: { trigger: function trigger() {
	          return this === _() && this.blur ? (this.blur(), !1) : void 0;
	        }, delegateType: "focusout" }, click: { trigger: function trigger() {
	          return "checkbox" === this.type && this.click && n.nodeName(this, "input") ? (this.click(), !1) : void 0;
	        }, _default: function _default(a) {
	          return n.nodeName(a.target, "a");
	        } }, beforeunload: { postDispatch: function postDispatch(a) {
	          void 0 !== a.result && a.originalEvent && (a.originalEvent.returnValue = a.result);
	        } } }, simulate: function simulate(a, b, c, d) {
	      var e = n.extend(new n.Event(), c, { type: a, isSimulated: !0, originalEvent: {} });d ? n.event.trigger(e, null, b) : n.event.dispatch.call(b, e), e.isDefaultPrevented() && c.preventDefault();
	    } }, n.removeEvent = function (a, b, c) {
	    a.removeEventListener && a.removeEventListener(b, c, !1);
	  }, n.Event = function (a, b) {
	    return this instanceof n.Event ? (a && a.type ? (this.originalEvent = a, this.type = a.type, this.isDefaultPrevented = a.defaultPrevented || void 0 === a.defaultPrevented && a.returnValue === !1 ? Z : $) : this.type = a, b && n.extend(this, b), this.timeStamp = a && a.timeStamp || n.now(), void (this[n.expando] = !0)) : new n.Event(a, b);
	  }, n.Event.prototype = { isDefaultPrevented: $, isPropagationStopped: $, isImmediatePropagationStopped: $, preventDefault: function preventDefault() {
	      var a = this.originalEvent;this.isDefaultPrevented = Z, a && a.preventDefault && a.preventDefault();
	    }, stopPropagation: function stopPropagation() {
	      var a = this.originalEvent;this.isPropagationStopped = Z, a && a.stopPropagation && a.stopPropagation();
	    }, stopImmediatePropagation: function stopImmediatePropagation() {
	      var a = this.originalEvent;this.isImmediatePropagationStopped = Z, a && a.stopImmediatePropagation && a.stopImmediatePropagation(), this.stopPropagation();
	    } }, n.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (a, b) {
	    n.event.special[a] = { delegateType: b, bindType: b, handle: function handle(a) {
	        var c,
	            d = this,
	            e = a.relatedTarget,
	            f = a.handleObj;return (!e || e !== d && !n.contains(d, e)) && (a.type = f.origType, c = f.handler.apply(this, arguments), a.type = b), c;
	      } };
	  }), k.focusinBubbles || n.each({ focus: "focusin", blur: "focusout" }, function (a, b) {
	    var c = function c(a) {
	      n.event.simulate(b, a.target, n.event.fix(a), !0);
	    };n.event.special[b] = { setup: function setup() {
	        var d = this.ownerDocument || this,
	            e = L.access(d, b);e || d.addEventListener(a, c, !0), L.access(d, b, (e || 0) + 1);
	      }, teardown: function teardown() {
	        var d = this.ownerDocument || this,
	            e = L.access(d, b) - 1;e ? L.access(d, b, e) : (d.removeEventListener(a, c, !0), L.remove(d, b));
	      } };
	  }), n.fn.extend({ on: function on(a, b, c, d, e) {
	      var f, g;if ("object" == typeof a) {
	        "string" != typeof b && (c = c || b, b = void 0);for (g in a) this.on(g, b, c, a[g], e);return this;
	      }if ((null == c && null == d ? (d = b, c = b = void 0) : null == d && ("string" == typeof b ? (d = c, c = void 0) : (d = c, c = b, b = void 0)), d === !1)) d = $;else if (!d) return this;return 1 === e && (f = d, d = function (a) {
	        return n().off(a), f.apply(this, arguments);
	      }, d.guid = f.guid || (f.guid = n.guid++)), this.each(function () {
	        n.event.add(this, a, d, c, b);
	      });
	    }, one: function one(a, b, c, d) {
	      return this.on(a, b, c, d, 1);
	    }, off: function off(a, b, c) {
	      var d, e;if (a && a.preventDefault && a.handleObj) return d = a.handleObj, n(a.delegateTarget).off(d.namespace ? d.origType + "." + d.namespace : d.origType, d.selector, d.handler), this;if ("object" == typeof a) {
	        for (e in a) this.off(e, b, a[e]);return this;
	      }return (b === !1 || "function" == typeof b) && (c = b, b = void 0), c === !1 && (c = $), this.each(function () {
	        n.event.remove(this, a, c, b);
	      });
	    }, trigger: function trigger(a, b) {
	      return this.each(function () {
	        n.event.trigger(a, b, this);
	      });
	    }, triggerHandler: function triggerHandler(a, b) {
	      var c = this[0];return c ? n.event.trigger(a, b, c, !0) : void 0;
	    } });var aa = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
	      ba = /<([\w:]+)/,
	      ca = /<|&#?\w+;/,
	      da = /<(?:script|style|link)/i,
	      ea = /checked\s*(?:[^=]|=\s*.checked.)/i,
	      fa = /^$|\/(?:java|ecma)script/i,
	      ga = /^true\/(.*)/,
	      ha = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,
	      ia = { option: [1, "<select multiple='multiple'>", "</select>"], thead: [1, "<table>", "</table>"], col: [2, "<table><colgroup>", "</colgroup></table>"], tr: [2, "<table><tbody>", "</tbody></table>"], td: [3, "<table><tbody><tr>", "</tr></tbody></table>"], _default: [0, "", ""] };ia.optgroup = ia.option, ia.tbody = ia.tfoot = ia.colgroup = ia.caption = ia.thead, ia.th = ia.td;function ja(a, b) {
	    return n.nodeName(a, "table") && n.nodeName(11 !== b.nodeType ? b : b.firstChild, "tr") ? a.getElementsByTagName("tbody")[0] || a.appendChild(a.ownerDocument.createElement("tbody")) : a;
	  }function ka(a) {
	    return a.type = (null !== a.getAttribute("type")) + "/" + a.type, a;
	  }function la(a) {
	    var b = ga.exec(a.type);return b ? a.type = b[1] : a.removeAttribute("type"), a;
	  }function ma(a, b) {
	    for (var c = 0, d = a.length; d > c; c++) L.set(a[c], "globalEval", !b || L.get(b[c], "globalEval"));
	  }function na(a, b) {
	    var c, d, e, f, g, h, i, j;if (1 === b.nodeType) {
	      if (L.hasData(a) && (f = L.access(a), g = L.set(b, f), j = f.events)) {
	        delete g.handle, g.events = {};for (e in j) for (c = 0, d = j[e].length; d > c; c++) n.event.add(b, e, j[e][c]);
	      }M.hasData(a) && (h = M.access(a), i = n.extend({}, h), M.set(b, i));
	    }
	  }function oa(a, b) {
	    var c = a.getElementsByTagName ? a.getElementsByTagName(b || "*") : a.querySelectorAll ? a.querySelectorAll(b || "*") : [];return void 0 === b || b && n.nodeName(a, b) ? n.merge([a], c) : c;
	  }function pa(a, b) {
	    var c = b.nodeName.toLowerCase();"input" === c && T.test(a.type) ? b.checked = a.checked : ("input" === c || "textarea" === c) && (b.defaultValue = a.defaultValue);
	  }n.extend({ clone: function clone(a, b, c) {
	      var d,
	          e,
	          f,
	          g,
	          h = a.cloneNode(!0),
	          i = n.contains(a.ownerDocument, a);if (!(k.noCloneChecked || 1 !== a.nodeType && 11 !== a.nodeType || n.isXMLDoc(a))) for (g = oa(h), f = oa(a), d = 0, e = f.length; e > d; d++) pa(f[d], g[d]);if (b) if (c) for (f = f || oa(a), g = g || oa(h), d = 0, e = f.length; e > d; d++) na(f[d], g[d]);else na(a, h);return g = oa(h, "script"), g.length > 0 && ma(g, !i && oa(a, "script")), h;
	    }, buildFragment: function buildFragment(a, b, c, d) {
	      for (var e, f, g, h, i, j, k = b.createDocumentFragment(), l = [], m = 0, o = a.length; o > m; m++) if ((e = a[m], e || 0 === e)) if ("object" === n.type(e)) n.merge(l, e.nodeType ? [e] : e);else if (ca.test(e)) {
	        f = f || k.appendChild(b.createElement("div")), g = (ba.exec(e) || ["", ""])[1].toLowerCase(), h = ia[g] || ia._default, f.innerHTML = h[1] + e.replace(aa, "<$1></$2>") + h[2], j = h[0];while (j--) f = f.lastChild;n.merge(l, f.childNodes), f = k.firstChild, f.textContent = "";
	      } else l.push(b.createTextNode(e));k.textContent = "", m = 0;while (e = l[m++]) if ((!d || -1 === n.inArray(e, d)) && (i = n.contains(e.ownerDocument, e), f = oa(k.appendChild(e), "script"), i && ma(f), c)) {
	        j = 0;while (e = f[j++]) fa.test(e.type || "") && c.push(e);
	      }return k;
	    }, cleanData: function cleanData(a) {
	      for (var b, c, d, e, f = n.event.special, g = 0; void 0 !== (c = a[g]); g++) {
	        if (n.acceptData(c) && (e = c[L.expando], e && (b = L.cache[e]))) {
	          if (b.events) for (d in b.events) f[d] ? n.event.remove(c, d) : n.removeEvent(c, d, b.handle);L.cache[e] && delete L.cache[e];
	        }delete M.cache[c[M.expando]];
	      }
	    } }), n.fn.extend({ text: function text(a) {
	      return J(this, function (a) {
	        return void 0 === a ? n.text(this) : this.empty().each(function () {
	          (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) && (this.textContent = a);
	        });
	      }, null, a, arguments.length);
	    }, append: function append() {
	      return this.domManip(arguments, function (a) {
	        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
	          var b = ja(this, a);b.appendChild(a);
	        }
	      });
	    }, prepend: function prepend() {
	      return this.domManip(arguments, function (a) {
	        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
	          var b = ja(this, a);b.insertBefore(a, b.firstChild);
	        }
	      });
	    }, before: function before() {
	      return this.domManip(arguments, function (a) {
	        this.parentNode && this.parentNode.insertBefore(a, this);
	      });
	    }, after: function after() {
	      return this.domManip(arguments, function (a) {
	        this.parentNode && this.parentNode.insertBefore(a, this.nextSibling);
	      });
	    }, remove: function remove(a, b) {
	      for (var c, d = a ? n.filter(a, this) : this, e = 0; null != (c = d[e]); e++) b || 1 !== c.nodeType || n.cleanData(oa(c)), c.parentNode && (b && n.contains(c.ownerDocument, c) && ma(oa(c, "script")), c.parentNode.removeChild(c));return this;
	    }, empty: function empty() {
	      for (var a, b = 0; null != (a = this[b]); b++) 1 === a.nodeType && (n.cleanData(oa(a, !1)), a.textContent = "");return this;
	    }, clone: function clone(a, b) {
	      return a = null == a ? !1 : a, b = null == b ? a : b, this.map(function () {
	        return n.clone(this, a, b);
	      });
	    }, html: function html(a) {
	      return J(this, function (a) {
	        var b = this[0] || {},
	            c = 0,
	            d = this.length;if (void 0 === a && 1 === b.nodeType) return b.innerHTML;if ("string" == typeof a && !da.test(a) && !ia[(ba.exec(a) || ["", ""])[1].toLowerCase()]) {
	          a = a.replace(aa, "<$1></$2>");try {
	            for (; d > c; c++) b = this[c] || {}, 1 === b.nodeType && (n.cleanData(oa(b, !1)), b.innerHTML = a);b = 0;
	          } catch (e) {}
	        }b && this.empty().append(a);
	      }, null, a, arguments.length);
	    }, replaceWith: function replaceWith() {
	      var a = arguments[0];return this.domManip(arguments, function (b) {
	        a = this.parentNode, n.cleanData(oa(this)), a && a.replaceChild(b, this);
	      }), a && (a.length || a.nodeType) ? this : this.remove();
	    }, detach: function detach(a) {
	      return this.remove(a, !0);
	    }, domManip: function domManip(a, b) {
	      a = e.apply([], a);var c,
	          d,
	          f,
	          g,
	          h,
	          i,
	          j = 0,
	          l = this.length,
	          m = this,
	          o = l - 1,
	          p = a[0],
	          q = n.isFunction(p);if (q || l > 1 && "string" == typeof p && !k.checkClone && ea.test(p)) return this.each(function (c) {
	        var d = m.eq(c);q && (a[0] = p.call(this, c, d.html())), d.domManip(a, b);
	      });if (l && (c = n.buildFragment(a, this[0].ownerDocument, !1, this), d = c.firstChild, 1 === c.childNodes.length && (c = d), d)) {
	        for (f = n.map(oa(c, "script"), ka), g = f.length; l > j; j++) h = c, j !== o && (h = n.clone(h, !0, !0), g && n.merge(f, oa(h, "script"))), b.call(this[j], h, j);if (g) for (i = f[f.length - 1].ownerDocument, n.map(f, la), j = 0; g > j; j++) h = f[j], fa.test(h.type || "") && !L.access(h, "globalEval") && n.contains(i, h) && (h.src ? n._evalUrl && n._evalUrl(h.src) : n.globalEval(h.textContent.replace(ha, "")));
	      }return this;
	    } }), n.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (a, b) {
	    n.fn[a] = function (a) {
	      for (var c, d = [], e = n(a), g = e.length - 1, h = 0; g >= h; h++) c = h === g ? this : this.clone(!0), n(e[h])[b](c), f.apply(d, c.get());return this.pushStack(d);
	    };
	  });var qa,
	      ra = {};function sa(b, c) {
	    var d,
	        e = n(c.createElement(b)).appendTo(c.body),
	        f = a.getDefaultComputedStyle && (d = a.getDefaultComputedStyle(e[0])) ? d.display : n.css(e[0], "display");return e.detach(), f;
	  }function ta(a) {
	    var b = l,
	        c = ra[a];return c || (c = sa(a, b), "none" !== c && c || (qa = (qa || n("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement), b = qa[0].contentDocument, b.write(), b.close(), c = sa(a, b), qa.detach()), ra[a] = c), c;
	  }var ua = /^margin/,
	      va = new RegExp("^(" + Q + ")(?!px)[a-z%]+$", "i"),
	      wa = function wa(b) {
	    return b.ownerDocument.defaultView.opener ? b.ownerDocument.defaultView.getComputedStyle(b, null) : a.getComputedStyle(b, null);
	  };function xa(a, b, c) {
	    var d,
	        e,
	        f,
	        g,
	        h = a.style;return c = c || wa(a), c && (g = c.getPropertyValue(b) || c[b]), c && ("" !== g || n.contains(a.ownerDocument, a) || (g = n.style(a, b)), va.test(g) && ua.test(b) && (d = h.width, e = h.minWidth, f = h.maxWidth, h.minWidth = h.maxWidth = h.width = g, g = c.width, h.width = d, h.minWidth = e, h.maxWidth = f)), void 0 !== g ? g + "" : g;
	  }function ya(a, b) {
	    return { get: function get() {
	        return a() ? void delete this.get : (this.get = b).apply(this, arguments);
	      } };
	  }!(function () {
	    var b,
	        c,
	        d = l.documentElement,
	        e = l.createElement("div"),
	        f = l.createElement("div");if (f.style) {
	      (function () {
	        var g = function g() {
	          f.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute", f.innerHTML = "", d.appendChild(e);var g = a.getComputedStyle(f, null);b = "1%" !== g.top, c = "4px" === g.width, d.removeChild(e);
	        };
	
	        f.style.backgroundClip = "content-box", f.cloneNode(!0).style.backgroundClip = "", k.clearCloneStyle = "content-box" === f.style.backgroundClip, e.style.cssText = "border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;position:absolute", e.appendChild(f);a.getComputedStyle && n.extend(k, { pixelPosition: function pixelPosition() {
	            return g(), b;
	          }, boxSizingReliable: function boxSizingReliable() {
	            return null == c && g(), c;
	          }, reliableMarginRight: function reliableMarginRight() {
	            var b,
	                c = f.appendChild(l.createElement("div"));return c.style.cssText = f.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", c.style.marginRight = c.style.width = "0", f.style.width = "1px", d.appendChild(e), b = !parseFloat(a.getComputedStyle(c, null).marginRight), d.removeChild(e), f.removeChild(c), b;
	          } });
	      })();
	    }
	  })(), n.swap = function (a, b, c, d) {
	    var e,
	        f,
	        g = {};for (f in b) g[f] = a.style[f], a.style[f] = b[f];e = c.apply(a, d || []);for (f in b) a.style[f] = g[f];return e;
	  };var za = /^(none|table(?!-c[ea]).+)/,
	      Aa = new RegExp("^(" + Q + ")(.*)$", "i"),
	      Ba = new RegExp("^([+-])=(" + Q + ")", "i"),
	      Ca = { position: "absolute", visibility: "hidden", display: "block" },
	      Da = { letterSpacing: "0", fontWeight: "400" },
	      Ea = ["Webkit", "O", "Moz", "ms"];function Fa(a, b) {
	    if (b in a) return b;var c = b[0].toUpperCase() + b.slice(1),
	        d = b,
	        e = Ea.length;while (e--) if ((b = Ea[e] + c, b in a)) return b;return d;
	  }function Ga(a, b, c) {
	    var d = Aa.exec(b);return d ? Math.max(0, d[1] - (c || 0)) + (d[2] || "px") : b;
	  }function Ha(a, b, c, d, e) {
	    for (var f = c === (d ? "border" : "content") ? 4 : "width" === b ? 1 : 0, g = 0; 4 > f; f += 2) "margin" === c && (g += n.css(a, c + R[f], !0, e)), d ? ("content" === c && (g -= n.css(a, "padding" + R[f], !0, e)), "margin" !== c && (g -= n.css(a, "border" + R[f] + "Width", !0, e))) : (g += n.css(a, "padding" + R[f], !0, e), "padding" !== c && (g += n.css(a, "border" + R[f] + "Width", !0, e)));return g;
	  }function Ia(a, b, c) {
	    var d = !0,
	        e = "width" === b ? a.offsetWidth : a.offsetHeight,
	        f = wa(a),
	        g = "border-box" === n.css(a, "boxSizing", !1, f);if (0 >= e || null == e) {
	      if ((e = xa(a, b, f), (0 > e || null == e) && (e = a.style[b]), va.test(e))) return e;d = g && (k.boxSizingReliable() || e === a.style[b]), e = parseFloat(e) || 0;
	    }return e + Ha(a, b, c || (g ? "border" : "content"), d, f) + "px";
	  }function Ja(a, b) {
	    for (var c, d, e, f = [], g = 0, h = a.length; h > g; g++) d = a[g], d.style && (f[g] = L.get(d, "olddisplay"), c = d.style.display, b ? (f[g] || "none" !== c || (d.style.display = ""), "" === d.style.display && S(d) && (f[g] = L.access(d, "olddisplay", ta(d.nodeName)))) : (e = S(d), "none" === c && e || L.set(d, "olddisplay", e ? c : n.css(d, "display"))));for (g = 0; h > g; g++) d = a[g], d.style && (b && "none" !== d.style.display && "" !== d.style.display || (d.style.display = b ? f[g] || "" : "none"));return a;
	  }n.extend({ cssHooks: { opacity: { get: function get(a, b) {
	          if (b) {
	            var c = xa(a, "opacity");return "" === c ? "1" : c;
	          }
	        } } }, cssNumber: { columnCount: !0, fillOpacity: !0, flexGrow: !0, flexShrink: !0, fontWeight: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, widows: !0, zIndex: !0, zoom: !0 }, cssProps: { "float": "cssFloat" }, style: function style(a, b, c, d) {
	      if (a && 3 !== a.nodeType && 8 !== a.nodeType && a.style) {
	        var e,
	            f,
	            g,
	            h = n.camelCase(b),
	            i = a.style;return b = n.cssProps[h] || (n.cssProps[h] = Fa(i, h)), g = n.cssHooks[b] || n.cssHooks[h], void 0 === c ? g && "get" in g && void 0 !== (e = g.get(a, !1, d)) ? e : i[b] : (f = typeof c, "string" === f && (e = Ba.exec(c)) && (c = (e[1] + 1) * e[2] + parseFloat(n.css(a, b)), f = "number"), null != c && c === c && ("number" !== f || n.cssNumber[h] || (c += "px"), k.clearCloneStyle || "" !== c || 0 !== b.indexOf("background") || (i[b] = "inherit"), g && "set" in g && void 0 === (c = g.set(a, c, d)) || (i[b] = c)), void 0);
	      }
	    }, css: function css(a, b, c, d) {
	      var e,
	          f,
	          g,
	          h = n.camelCase(b);return b = n.cssProps[h] || (n.cssProps[h] = Fa(a.style, h)), g = n.cssHooks[b] || n.cssHooks[h], g && "get" in g && (e = g.get(a, !0, c)), void 0 === e && (e = xa(a, b, d)), "normal" === e && b in Da && (e = Da[b]), "" === c || c ? (f = parseFloat(e), c === !0 || n.isNumeric(f) ? f || 0 : e) : e;
	    } }), n.each(["height", "width"], function (a, b) {
	    n.cssHooks[b] = { get: function get(a, c, d) {
	        return c ? za.test(n.css(a, "display")) && 0 === a.offsetWidth ? n.swap(a, Ca, function () {
	          return Ia(a, b, d);
	        }) : Ia(a, b, d) : void 0;
	      }, set: function set(a, c, d) {
	        var e = d && wa(a);return Ga(a, c, d ? Ha(a, b, d, "border-box" === n.css(a, "boxSizing", !1, e), e) : 0);
	      } };
	  }), n.cssHooks.marginRight = ya(k.reliableMarginRight, function (a, b) {
	    return b ? n.swap(a, { display: "inline-block" }, xa, [a, "marginRight"]) : void 0;
	  }), n.each({ margin: "", padding: "", border: "Width" }, function (a, b) {
	    n.cssHooks[a + b] = { expand: function expand(c) {
	        for (var d = 0, e = {}, f = "string" == typeof c ? c.split(" ") : [c]; 4 > d; d++) e[a + R[d] + b] = f[d] || f[d - 2] || f[0];return e;
	      } }, ua.test(a) || (n.cssHooks[a + b].set = Ga);
	  }), n.fn.extend({ css: function css(a, b) {
	      return J(this, function (a, b, c) {
	        var d,
	            e,
	            f = {},
	            g = 0;if (n.isArray(b)) {
	          for (d = wa(a), e = b.length; e > g; g++) f[b[g]] = n.css(a, b[g], !1, d);return f;
	        }return void 0 !== c ? n.style(a, b, c) : n.css(a, b);
	      }, a, b, arguments.length > 1);
	    }, show: function show() {
	      return Ja(this, !0);
	    }, hide: function hide() {
	      return Ja(this);
	    }, toggle: function toggle(a) {
	      return "boolean" == typeof a ? a ? this.show() : this.hide() : this.each(function () {
	        S(this) ? n(this).show() : n(this).hide();
	      });
	    } });function Ka(a, b, c, d, e) {
	    return new Ka.prototype.init(a, b, c, d, e);
	  }n.Tween = Ka, Ka.prototype = { constructor: Ka, init: function init(a, b, c, d, e, f) {
	      this.elem = a, this.prop = c, this.easing = e || "swing", this.options = b, this.start = this.now = this.cur(), this.end = d, this.unit = f || (n.cssNumber[c] ? "" : "px");
	    }, cur: function cur() {
	      var a = Ka.propHooks[this.prop];return a && a.get ? a.get(this) : Ka.propHooks._default.get(this);
	    }, run: function run(a) {
	      var b,
	          c = Ka.propHooks[this.prop];return this.options.duration ? this.pos = b = n.easing[this.easing](a, this.options.duration * a, 0, 1, this.options.duration) : this.pos = b = a, this.now = (this.end - this.start) * b + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), c && c.set ? c.set(this) : Ka.propHooks._default.set(this), this;
	    } }, Ka.prototype.init.prototype = Ka.prototype, Ka.propHooks = { _default: { get: function get(a) {
	        var b;return null == a.elem[a.prop] || a.elem.style && null != a.elem.style[a.prop] ? (b = n.css(a.elem, a.prop, ""), b && "auto" !== b ? b : 0) : a.elem[a.prop];
	      }, set: function set(a) {
	        n.fx.step[a.prop] ? n.fx.step[a.prop](a) : a.elem.style && (null != a.elem.style[n.cssProps[a.prop]] || n.cssHooks[a.prop]) ? n.style(a.elem, a.prop, a.now + a.unit) : a.elem[a.prop] = a.now;
	      } } }, Ka.propHooks.scrollTop = Ka.propHooks.scrollLeft = { set: function set(a) {
	      a.elem.nodeType && a.elem.parentNode && (a.elem[a.prop] = a.now);
	    } }, n.easing = { linear: function linear(a) {
	      return a;
	    }, swing: function swing(a) {
	      return .5 - Math.cos(a * Math.PI) / 2;
	    } }, n.fx = Ka.prototype.init, n.fx.step = {};var La,
	      Ma,
	      Na = /^(?:toggle|show|hide)$/,
	      Oa = new RegExp("^(?:([+-])=|)(" + Q + ")([a-z%]*)$", "i"),
	      Pa = /queueHooks$/,
	      Qa = [Va],
	      Ra = { "*": [function (a, b) {
	      var c = this.createTween(a, b),
	          d = c.cur(),
	          e = Oa.exec(b),
	          f = e && e[3] || (n.cssNumber[a] ? "" : "px"),
	          g = (n.cssNumber[a] || "px" !== f && +d) && Oa.exec(n.css(c.elem, a)),
	          h = 1,
	          i = 20;if (g && g[3] !== f) {
	        f = f || g[3], e = e || [], g = +d || 1;do h = h || ".5", g /= h, n.style(c.elem, a, g + f); while (h !== (h = c.cur() / d) && 1 !== h && --i);
	      }return e && (g = c.start = +g || +d || 0, c.unit = f, c.end = e[1] ? g + (e[1] + 1) * e[2] : +e[2]), c;
	    }] };function Sa() {
	    return setTimeout(function () {
	      La = void 0;
	    }), La = n.now();
	  }function Ta(a, b) {
	    var c,
	        d = 0,
	        e = { height: a };for (b = b ? 1 : 0; 4 > d; d += 2 - b) c = R[d], e["margin" + c] = e["padding" + c] = a;return b && (e.opacity = e.width = a), e;
	  }function Ua(a, b, c) {
	    for (var d, e = (Ra[b] || []).concat(Ra["*"]), f = 0, g = e.length; g > f; f++) if (d = e[f].call(c, b, a)) return d;
	  }function Va(a, b, c) {
	    var d,
	        e,
	        f,
	        g,
	        h,
	        i,
	        j,
	        k,
	        l = this,
	        m = {},
	        o = a.style,
	        p = a.nodeType && S(a),
	        q = L.get(a, "fxshow");c.queue || (h = n._queueHooks(a, "fx"), null == h.unqueued && (h.unqueued = 0, i = h.empty.fire, h.empty.fire = function () {
	      h.unqueued || i();
	    }), h.unqueued++, l.always(function () {
	      l.always(function () {
	        h.unqueued--, n.queue(a, "fx").length || h.empty.fire();
	      });
	    })), 1 === a.nodeType && ("height" in b || "width" in b) && (c.overflow = [o.overflow, o.overflowX, o.overflowY], j = n.css(a, "display"), k = "none" === j ? L.get(a, "olddisplay") || ta(a.nodeName) : j, "inline" === k && "none" === n.css(a, "float") && (o.display = "inline-block")), c.overflow && (o.overflow = "hidden", l.always(function () {
	      o.overflow = c.overflow[0], o.overflowX = c.overflow[1], o.overflowY = c.overflow[2];
	    }));for (d in b) if ((e = b[d], Na.exec(e))) {
	      if ((delete b[d], f = f || "toggle" === e, e === (p ? "hide" : "show"))) {
	        if ("show" !== e || !q || void 0 === q[d]) continue;p = !0;
	      }m[d] = q && q[d] || n.style(a, d);
	    } else j = void 0;if (n.isEmptyObject(m)) "inline" === ("none" === j ? ta(a.nodeName) : j) && (o.display = j);else {
	      q ? "hidden" in q && (p = q.hidden) : q = L.access(a, "fxshow", {}), f && (q.hidden = !p), p ? n(a).show() : l.done(function () {
	        n(a).hide();
	      }), l.done(function () {
	        var b;L.remove(a, "fxshow");for (b in m) n.style(a, b, m[b]);
	      });for (d in m) g = Ua(p ? q[d] : 0, d, l), d in q || (q[d] = g.start, p && (g.end = g.start, g.start = "width" === d || "height" === d ? 1 : 0));
	    }
	  }function Wa(a, b) {
	    var c, d, e, f, g;for (c in a) if ((d = n.camelCase(c), e = b[d], f = a[c], n.isArray(f) && (e = f[1], f = a[c] = f[0]), c !== d && (a[d] = f, delete a[c]), g = n.cssHooks[d], g && "expand" in g)) {
	      f = g.expand(f), delete a[d];for (c in f) c in a || (a[c] = f[c], b[c] = e);
	    } else b[d] = e;
	  }function Xa(a, b, c) {
	    var d,
	        e,
	        f = 0,
	        g = Qa.length,
	        h = n.Deferred().always(function () {
	      delete i.elem;
	    }),
	        i = function i() {
	      if (e) return !1;for (var b = La || Sa(), c = Math.max(0, j.startTime + j.duration - b), d = c / j.duration || 0, f = 1 - d, g = 0, i = j.tweens.length; i > g; g++) j.tweens[g].run(f);return h.notifyWith(a, [j, f, c]), 1 > f && i ? c : (h.resolveWith(a, [j]), !1);
	    },
	        j = h.promise({ elem: a, props: n.extend({}, b), opts: n.extend(!0, { specialEasing: {} }, c), originalProperties: b, originalOptions: c, startTime: La || Sa(), duration: c.duration, tweens: [], createTween: function createTween(b, c) {
	        var d = n.Tween(a, j.opts, b, c, j.opts.specialEasing[b] || j.opts.easing);return j.tweens.push(d), d;
	      }, stop: function stop(b) {
	        var c = 0,
	            d = b ? j.tweens.length : 0;if (e) return this;for (e = !0; d > c; c++) j.tweens[c].run(1);return b ? h.resolveWith(a, [j, b]) : h.rejectWith(a, [j, b]), this;
	      } }),
	        k = j.props;for (Wa(k, j.opts.specialEasing); g > f; f++) if (d = Qa[f].call(j, a, k, j.opts)) return d;return n.map(k, Ua, j), n.isFunction(j.opts.start) && j.opts.start.call(a, j), n.fx.timer(n.extend(i, { elem: a, anim: j, queue: j.opts.queue })), j.progress(j.opts.progress).done(j.opts.done, j.opts.complete).fail(j.opts.fail).always(j.opts.always);
	  }n.Animation = n.extend(Xa, { tweener: function tweener(a, b) {
	      n.isFunction(a) ? (b = a, a = ["*"]) : a = a.split(" ");for (var c, d = 0, e = a.length; e > d; d++) c = a[d], Ra[c] = Ra[c] || [], Ra[c].unshift(b);
	    }, prefilter: function prefilter(a, b) {
	      b ? Qa.unshift(a) : Qa.push(a);
	    } }), n.speed = function (a, b, c) {
	    var d = a && "object" == typeof a ? n.extend({}, a) : { complete: c || !c && b || n.isFunction(a) && a, duration: a, easing: c && b || b && !n.isFunction(b) && b };return d.duration = n.fx.off ? 0 : "number" == typeof d.duration ? d.duration : d.duration in n.fx.speeds ? n.fx.speeds[d.duration] : n.fx.speeds._default, (null == d.queue || d.queue === !0) && (d.queue = "fx"), d.old = d.complete, d.complete = function () {
	      n.isFunction(d.old) && d.old.call(this), d.queue && n.dequeue(this, d.queue);
	    }, d;
	  }, n.fn.extend({ fadeTo: function fadeTo(a, b, c, d) {
	      return this.filter(S).css("opacity", 0).show().end().animate({ opacity: b }, a, c, d);
	    }, animate: function animate(a, b, c, d) {
	      var e = n.isEmptyObject(a),
	          f = n.speed(b, c, d),
	          g = function g() {
	        var b = Xa(this, n.extend({}, a), f);(e || L.get(this, "finish")) && b.stop(!0);
	      };return g.finish = g, e || f.queue === !1 ? this.each(g) : this.queue(f.queue, g);
	    }, stop: function stop(a, b, c) {
	      var d = function d(a) {
	        var b = a.stop;delete a.stop, b(c);
	      };return "string" != typeof a && (c = b, b = a, a = void 0), b && a !== !1 && this.queue(a || "fx", []), this.each(function () {
	        var b = !0,
	            e = null != a && a + "queueHooks",
	            f = n.timers,
	            g = L.get(this);if (e) g[e] && g[e].stop && d(g[e]);else for (e in g) g[e] && g[e].stop && Pa.test(e) && d(g[e]);for (e = f.length; e--;) f[e].elem !== this || null != a && f[e].queue !== a || (f[e].anim.stop(c), b = !1, f.splice(e, 1));(b || !c) && n.dequeue(this, a);
	      });
	    }, finish: function finish(a) {
	      return a !== !1 && (a = a || "fx"), this.each(function () {
	        var b,
	            c = L.get(this),
	            d = c[a + "queue"],
	            e = c[a + "queueHooks"],
	            f = n.timers,
	            g = d ? d.length : 0;for (c.finish = !0, n.queue(this, a, []), e && e.stop && e.stop.call(this, !0), b = f.length; b--;) f[b].elem === this && f[b].queue === a && (f[b].anim.stop(!0), f.splice(b, 1));for (b = 0; g > b; b++) d[b] && d[b].finish && d[b].finish.call(this);delete c.finish;
	      });
	    } }), n.each(["toggle", "show", "hide"], function (a, b) {
	    var c = n.fn[b];n.fn[b] = function (a, d, e) {
	      return null == a || "boolean" == typeof a ? c.apply(this, arguments) : this.animate(Ta(b, !0), a, d, e);
	    };
	  }), n.each({ slideDown: Ta("show"), slideUp: Ta("hide"), slideToggle: Ta("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (a, b) {
	    n.fn[a] = function (a, c, d) {
	      return this.animate(b, a, c, d);
	    };
	  }), n.timers = [], n.fx.tick = function () {
	    var a,
	        b = 0,
	        c = n.timers;for (La = n.now(); b < c.length; b++) a = c[b], a() || c[b] !== a || c.splice(b--, 1);c.length || n.fx.stop(), La = void 0;
	  }, n.fx.timer = function (a) {
	    n.timers.push(a), a() ? n.fx.start() : n.timers.pop();
	  }, n.fx.interval = 13, n.fx.start = function () {
	    Ma || (Ma = setInterval(n.fx.tick, n.fx.interval));
	  }, n.fx.stop = function () {
	    clearInterval(Ma), Ma = null;
	  }, n.fx.speeds = { slow: 600, fast: 200, _default: 400 }, n.fn.delay = function (a, b) {
	    return a = n.fx ? n.fx.speeds[a] || a : a, b = b || "fx", this.queue(b, function (b, c) {
	      var d = setTimeout(b, a);c.stop = function () {
	        clearTimeout(d);
	      };
	    });
	  }, (function () {
	    var a = l.createElement("input"),
	        b = l.createElement("select"),
	        c = b.appendChild(l.createElement("option"));a.type = "checkbox", k.checkOn = "" !== a.value, k.optSelected = c.selected, b.disabled = !0, k.optDisabled = !c.disabled, a = l.createElement("input"), a.value = "t", a.type = "radio", k.radioValue = "t" === a.value;
	  })();var Ya,
	      Za,
	      $a = n.expr.attrHandle;n.fn.extend({ attr: function attr(a, b) {
	      return J(this, n.attr, a, b, arguments.length > 1);
	    }, removeAttr: function removeAttr(a) {
	      return this.each(function () {
	        n.removeAttr(this, a);
	      });
	    } }), n.extend({ attr: function attr(a, b, c) {
	      var d,
	          e,
	          f = a.nodeType;if (a && 3 !== f && 8 !== f && 2 !== f) return typeof a.getAttribute === U ? n.prop(a, b, c) : (1 === f && n.isXMLDoc(a) || (b = b.toLowerCase(), d = n.attrHooks[b] || (n.expr.match.bool.test(b) ? Za : Ya)), void 0 === c ? d && "get" in d && null !== (e = d.get(a, b)) ? e : (e = n.find.attr(a, b), null == e ? void 0 : e) : null !== c ? d && "set" in d && void 0 !== (e = d.set(a, c, b)) ? e : (a.setAttribute(b, c + ""), c) : void n.removeAttr(a, b));
	    }, removeAttr: function removeAttr(a, b) {
	      var c,
	          d,
	          e = 0,
	          f = b && b.match(E);if (f && 1 === a.nodeType) while (c = f[e++]) d = n.propFix[c] || c, n.expr.match.bool.test(c) && (a[d] = !1), a.removeAttribute(c);
	    }, attrHooks: { type: { set: function set(a, b) {
	          if (!k.radioValue && "radio" === b && n.nodeName(a, "input")) {
	            var c = a.value;return a.setAttribute("type", b), c && (a.value = c), b;
	          }
	        } } } }), Za = { set: function set(a, b, c) {
	      return b === !1 ? n.removeAttr(a, c) : a.setAttribute(c, c), c;
	    } }, n.each(n.expr.match.bool.source.match(/\w+/g), function (a, b) {
	    var c = $a[b] || n.find.attr;$a[b] = function (a, b, d) {
	      var e, f;return d || (f = $a[b], $a[b] = e, e = null != c(a, b, d) ? b.toLowerCase() : null, $a[b] = f), e;
	    };
	  });var _a = /^(?:input|select|textarea|button)$/i;n.fn.extend({ prop: function prop(a, b) {
	      return J(this, n.prop, a, b, arguments.length > 1);
	    }, removeProp: function removeProp(a) {
	      return this.each(function () {
	        delete this[n.propFix[a] || a];
	      });
	    } }), n.extend({ propFix: { "for": "htmlFor", "class": "className" }, prop: function prop(a, b, c) {
	      var d,
	          e,
	          f,
	          g = a.nodeType;if (a && 3 !== g && 8 !== g && 2 !== g) return f = 1 !== g || !n.isXMLDoc(a), f && (b = n.propFix[b] || b, e = n.propHooks[b]), void 0 !== c ? e && "set" in e && void 0 !== (d = e.set(a, c, b)) ? d : a[b] = c : e && "get" in e && null !== (d = e.get(a, b)) ? d : a[b];
	    }, propHooks: { tabIndex: { get: function get(a) {
	          return a.hasAttribute("tabindex") || _a.test(a.nodeName) || a.href ? a.tabIndex : -1;
	        } } } }), k.optSelected || (n.propHooks.selected = { get: function get(a) {
	      var b = a.parentNode;return b && b.parentNode && b.parentNode.selectedIndex, null;
	    } }), n.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
	    n.propFix[this.toLowerCase()] = this;
	  });var ab = /[\t\r\n\f]/g;n.fn.extend({ addClass: function addClass(a) {
	      var b,
	          c,
	          d,
	          e,
	          f,
	          g,
	          h = "string" == typeof a && a,
	          i = 0,
	          j = this.length;if (n.isFunction(a)) return this.each(function (b) {
	        n(this).addClass(a.call(this, b, this.className));
	      });if (h) for (b = (a || "").match(E) || []; j > i; i++) if ((c = this[i], d = 1 === c.nodeType && (c.className ? (" " + c.className + " ").replace(ab, " ") : " "))) {
	        f = 0;while (e = b[f++]) d.indexOf(" " + e + " ") < 0 && (d += e + " ");g = n.trim(d), c.className !== g && (c.className = g);
	      }return this;
	    }, removeClass: function removeClass(a) {
	      var b,
	          c,
	          d,
	          e,
	          f,
	          g,
	          h = 0 === arguments.length || "string" == typeof a && a,
	          i = 0,
	          j = this.length;if (n.isFunction(a)) return this.each(function (b) {
	        n(this).removeClass(a.call(this, b, this.className));
	      });if (h) for (b = (a || "").match(E) || []; j > i; i++) if ((c = this[i], d = 1 === c.nodeType && (c.className ? (" " + c.className + " ").replace(ab, " ") : ""))) {
	        f = 0;while (e = b[f++]) while (d.indexOf(" " + e + " ") >= 0) d = d.replace(" " + e + " ", " ");g = a ? n.trim(d) : "", c.className !== g && (c.className = g);
	      }return this;
	    }, toggleClass: function toggleClass(a, b) {
	      var c = typeof a;return "boolean" == typeof b && "string" === c ? b ? this.addClass(a) : this.removeClass(a) : this.each(n.isFunction(a) ? function (c) {
	        n(this).toggleClass(a.call(this, c, this.className, b), b);
	      } : function () {
	        if ("string" === c) {
	          var b,
	              d = 0,
	              e = n(this),
	              f = a.match(E) || [];while (b = f[d++]) e.hasClass(b) ? e.removeClass(b) : e.addClass(b);
	        } else (c === U || "boolean" === c) && (this.className && L.set(this, "__className__", this.className), this.className = this.className || a === !1 ? "" : L.get(this, "__className__") || "");
	      });
	    }, hasClass: function hasClass(a) {
	      for (var b = " " + a + " ", c = 0, d = this.length; d > c; c++) if (1 === this[c].nodeType && (" " + this[c].className + " ").replace(ab, " ").indexOf(b) >= 0) return !0;return !1;
	    } });var bb = /\r/g;n.fn.extend({ val: function val(a) {
	      var b,
	          c,
	          d,
	          e = this[0];{
	        if (arguments.length) return d = n.isFunction(a), this.each(function (c) {
	          var e;1 === this.nodeType && (e = d ? a.call(this, c, n(this).val()) : a, null == e ? e = "" : "number" == typeof e ? e += "" : n.isArray(e) && (e = n.map(e, function (a) {
	            return null == a ? "" : a + "";
	          })), b = n.valHooks[this.type] || n.valHooks[this.nodeName.toLowerCase()], b && "set" in b && void 0 !== b.set(this, e, "value") || (this.value = e));
	        });if (e) return b = n.valHooks[e.type] || n.valHooks[e.nodeName.toLowerCase()], b && "get" in b && void 0 !== (c = b.get(e, "value")) ? c : (c = e.value, "string" == typeof c ? c.replace(bb, "") : null == c ? "" : c);
	      }
	    } }), n.extend({ valHooks: { option: { get: function get(a) {
	          var b = n.find.attr(a, "value");return null != b ? b : n.trim(n.text(a));
	        } }, select: { get: function get(a) {
	          for (var b, c, d = a.options, e = a.selectedIndex, f = "select-one" === a.type || 0 > e, g = f ? null : [], h = f ? e + 1 : d.length, i = 0 > e ? h : f ? e : 0; h > i; i++) if ((c = d[i], !(!c.selected && i !== e || (k.optDisabled ? c.disabled : null !== c.getAttribute("disabled")) || c.parentNode.disabled && n.nodeName(c.parentNode, "optgroup")))) {
	            if ((b = n(c).val(), f)) return b;g.push(b);
	          }return g;
	        }, set: function set(a, b) {
	          var c,
	              d,
	              e = a.options,
	              f = n.makeArray(b),
	              g = e.length;while (g--) d = e[g], (d.selected = n.inArray(d.value, f) >= 0) && (c = !0);return c || (a.selectedIndex = -1), f;
	        } } } }), n.each(["radio", "checkbox"], function () {
	    n.valHooks[this] = { set: function set(a, b) {
	        return n.isArray(b) ? a.checked = n.inArray(n(a).val(), b) >= 0 : void 0;
	      } }, k.checkOn || (n.valHooks[this].get = function (a) {
	      return null === a.getAttribute("value") ? "on" : a.value;
	    });
	  }), n.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function (a, b) {
	    n.fn[b] = function (a, c) {
	      return arguments.length > 0 ? this.on(b, null, a, c) : this.trigger(b);
	    };
	  }), n.fn.extend({ hover: function hover(a, b) {
	      return this.mouseenter(a).mouseleave(b || a);
	    }, bind: function bind(a, b, c) {
	      return this.on(a, null, b, c);
	    }, unbind: function unbind(a, b) {
	      return this.off(a, null, b);
	    }, delegate: function delegate(a, b, c, d) {
	      return this.on(b, a, c, d);
	    }, undelegate: function undelegate(a, b, c) {
	      return 1 === arguments.length ? this.off(a, "**") : this.off(b, a || "**", c);
	    } });var cb = n.now(),
	      db = /\?/;n.parseJSON = function (a) {
	    return JSON.parse(a + "");
	  }, n.parseXML = function (a) {
	    var b, c;if (!a || "string" != typeof a) return null;try {
	      c = new DOMParser(), b = c.parseFromString(a, "text/xml");
	    } catch (d) {
	      b = void 0;
	    }return (!b || b.getElementsByTagName("parsererror").length) && n.error("Invalid XML: " + a), b;
	  };var eb = /#.*$/,
	      fb = /([?&])_=[^&]*/,
	      gb = /^(.*?):[ \t]*([^\r\n]*)$/gm,
	      hb = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	      ib = /^(?:GET|HEAD)$/,
	      jb = /^\/\//,
	      kb = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,
	      lb = {},
	      mb = {},
	      nb = "*/".concat("*"),
	      ob = a.location.href,
	      pb = kb.exec(ob.toLowerCase()) || [];function qb(a) {
	    return function (b, c) {
	      "string" != typeof b && (c = b, b = "*");var d,
	          e = 0,
	          f = b.toLowerCase().match(E) || [];if (n.isFunction(c)) while (d = f[e++]) "+" === d[0] ? (d = d.slice(1) || "*", (a[d] = a[d] || []).unshift(c)) : (a[d] = a[d] || []).push(c);
	    };
	  }function rb(a, b, c, d) {
	    var e = {},
	        f = a === mb;function g(h) {
	      var i;return e[h] = !0, n.each(a[h] || [], function (a, h) {
	        var j = h(b, c, d);return "string" != typeof j || f || e[j] ? f ? !(i = j) : void 0 : (b.dataTypes.unshift(j), g(j), !1);
	      }), i;
	    }return g(b.dataTypes[0]) || !e["*"] && g("*");
	  }function sb(a, b) {
	    var c,
	        d,
	        e = n.ajaxSettings.flatOptions || {};for (c in b) void 0 !== b[c] && ((e[c] ? a : d || (d = {}))[c] = b[c]);return d && n.extend(!0, a, d), a;
	  }function tb(a, b, c) {
	    var d,
	        e,
	        f,
	        g,
	        h = a.contents,
	        i = a.dataTypes;while ("*" === i[0]) i.shift(), void 0 === d && (d = a.mimeType || b.getResponseHeader("Content-Type"));if (d) for (e in h) if (h[e] && h[e].test(d)) {
	      i.unshift(e);break;
	    }if (i[0] in c) f = i[0];else {
	      for (e in c) {
	        if (!i[0] || a.converters[e + " " + i[0]]) {
	          f = e;break;
	        }g || (g = e);
	      }f = f || g;
	    }return f ? (f !== i[0] && i.unshift(f), c[f]) : void 0;
	  }function ub(a, b, c, d) {
	    var e,
	        f,
	        g,
	        h,
	        i,
	        j = {},
	        k = a.dataTypes.slice();if (k[1]) for (g in a.converters) j[g.toLowerCase()] = a.converters[g];f = k.shift();while (f) if ((a.responseFields[f] && (c[a.responseFields[f]] = b), !i && d && a.dataFilter && (b = a.dataFilter(b, a.dataType)), i = f, f = k.shift())) if ("*" === f) f = i;else if ("*" !== i && i !== f) {
	      if ((g = j[i + " " + f] || j["* " + f], !g)) for (e in j) if ((h = e.split(" "), h[1] === f && (g = j[i + " " + h[0]] || j["* " + h[0]]))) {
	        g === !0 ? g = j[e] : j[e] !== !0 && (f = h[0], k.unshift(h[1]));break;
	      }if (g !== !0) if (g && a["throws"]) b = g(b);else try {
	        b = g(b);
	      } catch (l) {
	        return { state: "parsererror", error: g ? l : "No conversion from " + i + " to " + f };
	      }
	    }return { state: "success", data: b };
	  }n.extend({ active: 0, lastModified: {}, etag: {}, ajaxSettings: { url: ob, type: "GET", isLocal: hb.test(pb[1]), global: !0, processData: !0, async: !0, contentType: "application/x-www-form-urlencoded; charset=UTF-8", accepts: { "*": nb, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" }, contents: { xml: /xml/, html: /html/, json: /json/ }, responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" }, converters: { "* text": String, "text html": !0, "text json": n.parseJSON, "text xml": n.parseXML }, flatOptions: { url: !0, context: !0 } }, ajaxSetup: function ajaxSetup(a, b) {
	      return b ? sb(sb(a, n.ajaxSettings), b) : sb(n.ajaxSettings, a);
	    }, ajaxPrefilter: qb(lb), ajaxTransport: qb(mb), ajax: function ajax(a, b) {
	      "object" == typeof a && (b = a, a = void 0), b = b || {};var c,
	          d,
	          e,
	          f,
	          g,
	          h,
	          i,
	          j,
	          k = n.ajaxSetup({}, b),
	          l = k.context || k,
	          m = k.context && (l.nodeType || l.jquery) ? n(l) : n.event,
	          o = n.Deferred(),
	          p = n.Callbacks("once memory"),
	          q = k.statusCode || {},
	          r = {},
	          s = {},
	          t = 0,
	          u = "canceled",
	          v = { readyState: 0, getResponseHeader: function getResponseHeader(a) {
	          var b;if (2 === t) {
	            if (!f) {
	              f = {};while (b = gb.exec(e)) f[b[1].toLowerCase()] = b[2];
	            }b = f[a.toLowerCase()];
	          }return null == b ? null : b;
	        }, getAllResponseHeaders: function getAllResponseHeaders() {
	          return 2 === t ? e : null;
	        }, setRequestHeader: function setRequestHeader(a, b) {
	          var c = a.toLowerCase();return t || (a = s[c] = s[c] || a, r[a] = b), this;
	        }, overrideMimeType: function overrideMimeType(a) {
	          return t || (k.mimeType = a), this;
	        }, statusCode: function statusCode(a) {
	          var b;if (a) if (2 > t) for (b in a) q[b] = [q[b], a[b]];else v.always(a[v.status]);return this;
	        }, abort: function abort(a) {
	          var b = a || u;return c && c.abort(b), x(0, b), this;
	        } };if ((o.promise(v).complete = p.add, v.success = v.done, v.error = v.fail, k.url = ((a || k.url || ob) + "").replace(eb, "").replace(jb, pb[1] + "//"), k.type = b.method || b.type || k.method || k.type, k.dataTypes = n.trim(k.dataType || "*").toLowerCase().match(E) || [""], null == k.crossDomain && (h = kb.exec(k.url.toLowerCase()), k.crossDomain = !(!h || h[1] === pb[1] && h[2] === pb[2] && (h[3] || ("http:" === h[1] ? "80" : "443")) === (pb[3] || ("http:" === pb[1] ? "80" : "443")))), k.data && k.processData && "string" != typeof k.data && (k.data = n.param(k.data, k.traditional)), rb(lb, k, b, v), 2 === t)) return v;i = n.event && k.global, i && 0 === n.active++ && n.event.trigger("ajaxStart"), k.type = k.type.toUpperCase(), k.hasContent = !ib.test(k.type), d = k.url, k.hasContent || (k.data && (d = k.url += (db.test(d) ? "&" : "?") + k.data, delete k.data), k.cache === !1 && (k.url = fb.test(d) ? d.replace(fb, "$1_=" + cb++) : d + (db.test(d) ? "&" : "?") + "_=" + cb++)), k.ifModified && (n.lastModified[d] && v.setRequestHeader("If-Modified-Since", n.lastModified[d]), n.etag[d] && v.setRequestHeader("If-None-Match", n.etag[d])), (k.data && k.hasContent && k.contentType !== !1 || b.contentType) && v.setRequestHeader("Content-Type", k.contentType), v.setRequestHeader("Accept", k.dataTypes[0] && k.accepts[k.dataTypes[0]] ? k.accepts[k.dataTypes[0]] + ("*" !== k.dataTypes[0] ? ", " + nb + "; q=0.01" : "") : k.accepts["*"]);for (j in k.headers) v.setRequestHeader(j, k.headers[j]);if (k.beforeSend && (k.beforeSend.call(l, v, k) === !1 || 2 === t)) return v.abort();u = "abort";for (j in { success: 1, error: 1, complete: 1 }) v[j](k[j]);if (c = rb(mb, k, b, v)) {
	        v.readyState = 1, i && m.trigger("ajaxSend", [v, k]), k.async && k.timeout > 0 && (g = setTimeout(function () {
	          v.abort("timeout");
	        }, k.timeout));try {
	          t = 1, c.send(r, x);
	        } catch (w) {
	          if (!(2 > t)) throw w;x(-1, w);
	        }
	      } else x(-1, "No Transport");function x(a, b, f, h) {
	        var j,
	            r,
	            s,
	            u,
	            w,
	            x = b;2 !== t && (t = 2, g && clearTimeout(g), c = void 0, e = h || "", v.readyState = a > 0 ? 4 : 0, j = a >= 200 && 300 > a || 304 === a, f && (u = tb(k, v, f)), u = ub(k, u, v, j), j ? (k.ifModified && (w = v.getResponseHeader("Last-Modified"), w && (n.lastModified[d] = w), w = v.getResponseHeader("etag"), w && (n.etag[d] = w)), 204 === a || "HEAD" === k.type ? x = "nocontent" : 304 === a ? x = "notmodified" : (x = u.state, r = u.data, s = u.error, j = !s)) : (s = x, (a || !x) && (x = "error", 0 > a && (a = 0))), v.status = a, v.statusText = (b || x) + "", j ? o.resolveWith(l, [r, x, v]) : o.rejectWith(l, [v, x, s]), v.statusCode(q), q = void 0, i && m.trigger(j ? "ajaxSuccess" : "ajaxError", [v, k, j ? r : s]), p.fireWith(l, [v, x]), i && (m.trigger("ajaxComplete", [v, k]), --n.active || n.event.trigger("ajaxStop")));
	      }return v;
	    }, getJSON: function getJSON(a, b, c) {
	      return n.get(a, b, c, "json");
	    }, getScript: function getScript(a, b) {
	      return n.get(a, void 0, b, "script");
	    } }), n.each(["get", "post"], function (a, b) {
	    n[b] = function (a, c, d, e) {
	      return n.isFunction(c) && (e = e || d, d = c, c = void 0), n.ajax({ url: a, type: b, dataType: e, data: c, success: d });
	    };
	  }), n._evalUrl = function (a) {
	    return n.ajax({ url: a, type: "GET", dataType: "script", async: !1, global: !1, "throws": !0 });
	  }, n.fn.extend({ wrapAll: function wrapAll(a) {
	      var b;return n.isFunction(a) ? this.each(function (b) {
	        n(this).wrapAll(a.call(this, b));
	      }) : (this[0] && (b = n(a, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && b.insertBefore(this[0]), b.map(function () {
	        var a = this;while (a.firstElementChild) a = a.firstElementChild;return a;
	      }).append(this)), this);
	    }, wrapInner: function wrapInner(a) {
	      return this.each(n.isFunction(a) ? function (b) {
	        n(this).wrapInner(a.call(this, b));
	      } : function () {
	        var b = n(this),
	            c = b.contents();c.length ? c.wrapAll(a) : b.append(a);
	      });
	    }, wrap: function wrap(a) {
	      var b = n.isFunction(a);return this.each(function (c) {
	        n(this).wrapAll(b ? a.call(this, c) : a);
	      });
	    }, unwrap: function unwrap() {
	      return this.parent().each(function () {
	        n.nodeName(this, "body") || n(this).replaceWith(this.childNodes);
	      }).end();
	    } }), n.expr.filters.hidden = function (a) {
	    return a.offsetWidth <= 0 && a.offsetHeight <= 0;
	  }, n.expr.filters.visible = function (a) {
	    return !n.expr.filters.hidden(a);
	  };var vb = /%20/g,
	      wb = /\[\]$/,
	      xb = /\r?\n/g,
	      yb = /^(?:submit|button|image|reset|file)$/i,
	      zb = /^(?:input|select|textarea|keygen)/i;function Ab(a, b, c, d) {
	    var e;if (n.isArray(b)) n.each(b, function (b, e) {
	      c || wb.test(a) ? d(a, e) : Ab(a + "[" + ("object" == typeof e ? b : "") + "]", e, c, d);
	    });else if (c || "object" !== n.type(b)) d(a, b);else for (e in b) Ab(a + "[" + e + "]", b[e], c, d);
	  }n.param = function (a, b) {
	    var c,
	        d = [],
	        e = function e(a, b) {
	      b = n.isFunction(b) ? b() : null == b ? "" : b, d[d.length] = encodeURIComponent(a) + "=" + encodeURIComponent(b);
	    };if ((void 0 === b && (b = n.ajaxSettings && n.ajaxSettings.traditional), n.isArray(a) || a.jquery && !n.isPlainObject(a))) n.each(a, function () {
	      e(this.name, this.value);
	    });else for (c in a) Ab(c, a[c], b, e);return d.join("&").replace(vb, "+");
	  }, n.fn.extend({ serialize: function serialize() {
	      return n.param(this.serializeArray());
	    }, serializeArray: function serializeArray() {
	      return this.map(function () {
	        var a = n.prop(this, "elements");return a ? n.makeArray(a) : this;
	      }).filter(function () {
	        var a = this.type;return this.name && !n(this).is(":disabled") && zb.test(this.nodeName) && !yb.test(a) && (this.checked || !T.test(a));
	      }).map(function (a, b) {
	        var c = n(this).val();return null == c ? null : n.isArray(c) ? n.map(c, function (a) {
	          return { name: b.name, value: a.replace(xb, "\r\n") };
	        }) : { name: b.name, value: c.replace(xb, "\r\n") };
	      }).get();
	    } }), n.ajaxSettings.xhr = function () {
	    try {
	      return new XMLHttpRequest();
	    } catch (a) {}
	  };var Bb = 0,
	      Cb = {},
	      Db = { 0: 200, 1223: 204 },
	      Eb = n.ajaxSettings.xhr();a.attachEvent && a.attachEvent("onunload", function () {
	    for (var a in Cb) Cb[a]();
	  }), k.cors = !!Eb && "withCredentials" in Eb, k.ajax = Eb = !!Eb, n.ajaxTransport(function (a) {
	    var b;return k.cors || Eb && !a.crossDomain ? { send: function send(c, d) {
	        var e,
	            f = a.xhr(),
	            g = ++Bb;if ((f.open(a.type, a.url, a.async, a.username, a.password), a.xhrFields)) for (e in a.xhrFields) f[e] = a.xhrFields[e];a.mimeType && f.overrideMimeType && f.overrideMimeType(a.mimeType), a.crossDomain || c["X-Requested-With"] || (c["X-Requested-With"] = "XMLHttpRequest");for (e in c) f.setRequestHeader(e, c[e]);b = function (a) {
	          return function () {
	            b && (delete Cb[g], b = f.onload = f.onerror = null, "abort" === a ? f.abort() : "error" === a ? d(f.status, f.statusText) : d(Db[f.status] || f.status, f.statusText, "string" == typeof f.responseText ? { text: f.responseText } : void 0, f.getAllResponseHeaders()));
	          };
	        }, f.onload = b(), f.onerror = b("error"), b = Cb[g] = b("abort");try {
	          f.send(a.hasContent && a.data || null);
	        } catch (h) {
	          if (b) throw h;
	        }
	      }, abort: function abort() {
	        b && b();
	      } } : void 0;
	  }), n.ajaxSetup({ accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" }, contents: { script: /(?:java|ecma)script/ }, converters: { "text script": function textScript(a) {
	        return n.globalEval(a), a;
	      } } }), n.ajaxPrefilter("script", function (a) {
	    void 0 === a.cache && (a.cache = !1), a.crossDomain && (a.type = "GET");
	  }), n.ajaxTransport("script", function (a) {
	    if (a.crossDomain) {
	      var b, c;return { send: function send(d, e) {
	          b = n("<script>").prop({ async: !0, charset: a.scriptCharset, src: a.url }).on("load error", c = function (a) {
	            b.remove(), c = null, a && e("error" === a.type ? 404 : 200, a.type);
	          }), l.head.appendChild(b[0]);
	        }, abort: function abort() {
	          c && c();
	        } };
	    }
	  });var Fb = [],
	      Gb = /(=)\?(?=&|$)|\?\?/;n.ajaxSetup({ jsonp: "callback", jsonpCallback: function jsonpCallback() {
	      var a = Fb.pop() || n.expando + "_" + cb++;return this[a] = !0, a;
	    } }), n.ajaxPrefilter("json jsonp", function (b, c, d) {
	    var e,
	        f,
	        g,
	        h = b.jsonp !== !1 && (Gb.test(b.url) ? "url" : "string" == typeof b.data && !(b.contentType || "").indexOf("application/x-www-form-urlencoded") && Gb.test(b.data) && "data");return h || "jsonp" === b.dataTypes[0] ? (e = b.jsonpCallback = n.isFunction(b.jsonpCallback) ? b.jsonpCallback() : b.jsonpCallback, h ? b[h] = b[h].replace(Gb, "$1" + e) : b.jsonp !== !1 && (b.url += (db.test(b.url) ? "&" : "?") + b.jsonp + "=" + e), b.converters["script json"] = function () {
	      return g || n.error(e + " was not called"), g[0];
	    }, b.dataTypes[0] = "json", f = a[e], a[e] = function () {
	      g = arguments;
	    }, d.always(function () {
	      a[e] = f, b[e] && (b.jsonpCallback = c.jsonpCallback, Fb.push(e)), g && n.isFunction(f) && f(g[0]), g = f = void 0;
	    }), "script") : void 0;
	  }), n.parseHTML = function (a, b, c) {
	    if (!a || "string" != typeof a) return null;"boolean" == typeof b && (c = b, b = !1), b = b || l;var d = v.exec(a),
	        e = !c && [];return d ? [b.createElement(d[1])] : (d = n.buildFragment([a], b, e), e && e.length && n(e).remove(), n.merge([], d.childNodes));
	  };var Hb = n.fn.load;n.fn.load = function (a, b, c) {
	    if ("string" != typeof a && Hb) return Hb.apply(this, arguments);var d,
	        e,
	        f,
	        g = this,
	        h = a.indexOf(" ");return h >= 0 && (d = n.trim(a.slice(h)), a = a.slice(0, h)), n.isFunction(b) ? (c = b, b = void 0) : b && "object" == typeof b && (e = "POST"), g.length > 0 && n.ajax({ url: a, type: e, dataType: "html", data: b }).done(function (a) {
	      f = arguments, g.html(d ? n("<div>").append(n.parseHTML(a)).find(d) : a);
	    }).complete(c && function (a, b) {
	      g.each(c, f || [a.responseText, b, a]);
	    }), this;
	  }, n.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (a, b) {
	    n.fn[b] = function (a) {
	      return this.on(b, a);
	    };
	  }), n.expr.filters.animated = function (a) {
	    return n.grep(n.timers, function (b) {
	      return a === b.elem;
	    }).length;
	  };var Ib = a.document.documentElement;function Jb(a) {
	    return n.isWindow(a) ? a : 9 === a.nodeType && a.defaultView;
	  }n.offset = { setOffset: function setOffset(a, b, c) {
	      var d,
	          e,
	          f,
	          g,
	          h,
	          i,
	          j,
	          k = n.css(a, "position"),
	          l = n(a),
	          m = {};"static" === k && (a.style.position = "relative"), h = l.offset(), f = n.css(a, "top"), i = n.css(a, "left"), j = ("absolute" === k || "fixed" === k) && (f + i).indexOf("auto") > -1, j ? (d = l.position(), g = d.top, e = d.left) : (g = parseFloat(f) || 0, e = parseFloat(i) || 0), n.isFunction(b) && (b = b.call(a, c, h)), null != b.top && (m.top = b.top - h.top + g), null != b.left && (m.left = b.left - h.left + e), "using" in b ? b.using.call(a, m) : l.css(m);
	    } }, n.fn.extend({ offset: function offset(a) {
	      if (arguments.length) return void 0 === a ? this : this.each(function (b) {
	        n.offset.setOffset(this, a, b);
	      });var b,
	          c,
	          d = this[0],
	          e = { top: 0, left: 0 },
	          f = d && d.ownerDocument;if (f) return b = f.documentElement, n.contains(b, d) ? (typeof d.getBoundingClientRect !== U && (e = d.getBoundingClientRect()), c = Jb(f), { top: e.top + c.pageYOffset - b.clientTop, left: e.left + c.pageXOffset - b.clientLeft }) : e;
	    }, position: function position() {
	      if (this[0]) {
	        var a,
	            b,
	            c = this[0],
	            d = { top: 0, left: 0 };return "fixed" === n.css(c, "position") ? b = c.getBoundingClientRect() : (a = this.offsetParent(), b = this.offset(), n.nodeName(a[0], "html") || (d = a.offset()), d.top += n.css(a[0], "borderTopWidth", !0), d.left += n.css(a[0], "borderLeftWidth", !0)), { top: b.top - d.top - n.css(c, "marginTop", !0), left: b.left - d.left - n.css(c, "marginLeft", !0) };
	      }
	    }, offsetParent: function offsetParent() {
	      return this.map(function () {
	        var a = this.offsetParent || Ib;while (a && !n.nodeName(a, "html") && "static" === n.css(a, "position")) a = a.offsetParent;return a || Ib;
	      });
	    } }), n.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (b, c) {
	    var d = "pageYOffset" === c;n.fn[b] = function (e) {
	      return J(this, function (b, e, f) {
	        var g = Jb(b);return void 0 === f ? g ? g[c] : b[e] : void (g ? g.scrollTo(d ? a.pageXOffset : f, d ? f : a.pageYOffset) : b[e] = f);
	      }, b, e, arguments.length, null);
	    };
	  }), n.each(["top", "left"], function (a, b) {
	    n.cssHooks[b] = ya(k.pixelPosition, function (a, c) {
	      return c ? (c = xa(a, b), va.test(c) ? n(a).position()[b] + "px" : c) : void 0;
	    });
	  }), n.each({ Height: "height", Width: "width" }, function (a, b) {
	    n.each({ padding: "inner" + a, content: b, "": "outer" + a }, function (c, d) {
	      n.fn[d] = function (d, e) {
	        var f = arguments.length && (c || "boolean" != typeof d),
	            g = c || (d === !0 || e === !0 ? "margin" : "border");return J(this, function (b, c, d) {
	          var e;return n.isWindow(b) ? b.document.documentElement["client" + a] : 9 === b.nodeType ? (e = b.documentElement, Math.max(b.body["scroll" + a], e["scroll" + a], b.body["offset" + a], e["offset" + a], e["client" + a])) : void 0 === d ? n.css(b, c, g) : n.style(b, c, d, g);
	        }, b, f ? d : void 0, f, null);
	      };
	    });
	  }), n.fn.size = function () {
	    return this.length;
	  }, n.fn.andSelf = n.fn.addBack, "function" == "function" && __webpack_require__(14) && !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return n;
	  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));var Kb = a.jQuery,
	      Lb = a.$;return n.noConflict = function (b) {
	    return a.$ === n && (a.$ = Lb), b && a.jQuery === n && (a.jQuery = Kb), n;
	  }, typeof b === U && (a.jQuery = a.$ = n), n;
	});

/***/ },
/* 14 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 15 */
/***/ function(module, exports) {

	/**
	 * Created by a180583 on 6/9/16.
	 */
	
	/*!
	 Chosen, a Select Box Enhancer for jQuery and Prototype
	 by Patrick Filler for Harvest, http://getharvest.com
	
	 Version 1.5.1
	 Full source at https://github.com/harvesthq/chosen
	 Copyright (c) 2011-2016 Harvest http://getharvest.com
	
	 MIT License, https://github.com/harvesthq/chosen/blob/master/LICENSE.md
	 This file is generated by `grunt build`, do not edit it by hand.
	 */
	
	"use strict";
	
	(function () {
	  var $,
	      AbstractChosen,
	      Chosen,
	      SelectParser,
	      _ref,
	      __hasProp = ({}).hasOwnProperty,
	      __extends = function __extends(child, parent) {
	    for (var key in parent) {
	      if (__hasProp.call(parent, key)) child[key] = parent[key];
	    }function ctor() {
	      this.constructor = child;
	    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
	  };
	
	  SelectParser = (function () {
	    function SelectParser() {
	      this.options_index = 0;
	      this.parsed = [];
	    }
	
	    SelectParser.prototype.add_node = function (child) {
	      if (child.nodeName.toUpperCase() === "OPTGROUP") {
	        return this.add_group(child);
	      } else {
	        return this.add_option(child);
	      }
	    };
	
	    SelectParser.prototype.add_group = function (group) {
	      var group_position, option, _i, _len, _ref, _results;
	      group_position = this.parsed.length;
	      this.parsed.push({
	        array_index: group_position,
	        group: true,
	        label: this.escapeExpression(group.label),
	        title: group.title ? group.title : void 0,
	        children: 0,
	        disabled: group.disabled,
	        classes: group.className
	      });
	      _ref = group.childNodes;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        option = _ref[_i];
	        _results.push(this.add_option(option, group_position, group.disabled));
	      }
	      return _results;
	    };
	
	    SelectParser.prototype.add_option = function (option, group_position, group_disabled) {
	      if (option.nodeName.toUpperCase() === "OPTION") {
	        if (option.text !== "") {
	          if (group_position != null) {
	            this.parsed[group_position].children += 1;
	          }
	          this.parsed.push({
	            array_index: this.parsed.length,
	            options_index: this.options_index,
	            value: option.value,
	            text: option.text,
	            html: option.innerHTML,
	            title: option.title ? option.title : void 0,
	            selected: option.selected,
	            disabled: group_disabled === true ? group_disabled : option.disabled,
	            group_array_index: group_position,
	            group_label: group_position != null ? this.parsed[group_position].label : null,
	            classes: option.className,
	            style: option.style.cssText
	          });
	        } else {
	          this.parsed.push({
	            array_index: this.parsed.length,
	            options_index: this.options_index,
	            empty: true
	          });
	        }
	        return this.options_index += 1;
	      }
	    };
	
	    SelectParser.prototype.escapeExpression = function (text) {
	      var map, unsafe_chars;
	      if (text == null || text === false) {
	        return "";
	      }
	      if (!/[\&\<\>\"\'\`]/.test(text)) {
	        return text;
	      }
	      map = {
	        "<": "&lt;",
	        ">": "&gt;",
	        '"': "&quot;",
	        "'": "&#x27;",
	        "`": "&#x60;"
	      };
	      unsafe_chars = /&(?!\w+;)|[\<\>\"\'\`]/g;
	      return text.replace(unsafe_chars, function (chr) {
	        return map[chr] || "&amp;";
	      });
	    };
	
	    return SelectParser;
	  })();
	
	  SelectParser.select_to_array = function (select) {
	    var child, parser, _i, _len, _ref;
	    parser = new SelectParser();
	    _ref = select.childNodes;
	    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	      child = _ref[_i];
	      parser.add_node(child);
	    }
	    return parser.parsed;
	  };
	
	  AbstractChosen = (function () {
	    function AbstractChosen(form_field, options) {
	      this.form_field = form_field;
	      this.options = options != null ? options : {};
	      if (!AbstractChosen.browser_is_supported()) {
	        return;
	      }
	      this.is_multiple = this.form_field.multiple;
	      this.set_default_text();
	      this.set_default_values();
	      this.setup();
	      this.set_up_html();
	      this.register_observers();
	      this.on_ready();
	    }
	
	    AbstractChosen.prototype.set_default_values = function () {
	      var _this = this;
	      this.click_test_action = function (evt) {
	        return _this.test_active_click(evt);
	      };
	      this.activate_action = function (evt) {
	        return _this.activate_field(evt);
	      };
	      this.active_field = false;
	      this.mouse_on_container = false;
	      this.results_showing = false;
	      this.result_highlighted = null;
	      this.allow_single_deselect = this.options.allow_single_deselect != null && this.form_field.options[0] != null && this.form_field.options[0].text === "" ? this.options.allow_single_deselect : false;
	      this.disable_search_threshold = this.options.disable_search_threshold || 0;
	      this.disable_search = this.options.disable_search || false;
	      this.enable_split_word_search = this.options.enable_split_word_search != null ? this.options.enable_split_word_search : true;
	      this.group_search = this.options.group_search != null ? this.options.group_search : true;
	      this.search_contains = this.options.search_contains || false;
	      this.single_backstroke_delete = this.options.single_backstroke_delete != null ? this.options.single_backstroke_delete : true;
	      this.max_selected_options = this.options.max_selected_options || Infinity;
	      this.inherit_select_classes = this.options.inherit_select_classes || false;
	      this.display_selected_options = this.options.display_selected_options != null ? this.options.display_selected_options : true;
	      this.display_disabled_options = this.options.display_disabled_options != null ? this.options.display_disabled_options : true;
	      this.include_group_label_in_selected = this.options.include_group_label_in_selected || false;
	      return this.max_shown_results = this.options.max_shown_results || Number.POSITIVE_INFINITY;
	    };
	
	    AbstractChosen.prototype.set_default_text = function () {
	      if (this.form_field.getAttribute("data-placeholder")) {
	        this.default_text = this.form_field.getAttribute("data-placeholder");
	      } else if (this.is_multiple) {
	        this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || AbstractChosen.default_multiple_text;
	      } else {
	        this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || AbstractChosen.default_single_text;
	      }
	      return this.results_none_found = this.form_field.getAttribute("data-no_results_text") || this.options.no_results_text || AbstractChosen.default_no_result_text;
	    };
	
	    AbstractChosen.prototype.choice_label = function (item) {
	      if (this.include_group_label_in_selected && item.group_label != null) {
	        return "<b class='group-name'>" + item.group_label + "</b>" + item.html;
	      } else {
	        return item.html;
	      }
	    };
	
	    AbstractChosen.prototype.mouse_enter = function () {
	      return this.mouse_on_container = true;
	    };
	
	    AbstractChosen.prototype.mouse_leave = function () {
	      return this.mouse_on_container = false;
	    };
	
	    AbstractChosen.prototype.input_focus = function (evt) {
	      var _this = this;
	      if (this.is_multiple) {
	        if (!this.active_field) {
	          return setTimeout(function () {
	            return _this.container_mousedown();
	          }, 50);
	        }
	      } else {
	        if (!this.active_field) {
	          return this.activate_field();
	        }
	      }
	    };
	
	    AbstractChosen.prototype.input_blur = function (evt) {
	      var _this = this;
	      if (!this.mouse_on_container) {
	        this.active_field = false;
	        return setTimeout(function () {
	          return _this.blur_test();
	        }, 100);
	      }
	    };
	
	    AbstractChosen.prototype.results_option_build = function (options) {
	      var content, data, data_content, shown_results, _i, _len, _ref;
	      content = '';
	      shown_results = 0;
	      _ref = this.results_data;
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        data = _ref[_i];
	        data_content = '';
	        if (data.group) {
	          data_content = this.result_add_group(data);
	        } else {
	          data_content = this.result_add_option(data);
	        }
	        if (data_content !== '') {
	          shown_results++;
	          content += data_content;
	        }
	        if (options != null ? options.first : void 0) {
	          if (data.selected && this.is_multiple) {
	            this.choice_build(data);
	          } else if (data.selected && !this.is_multiple) {
	            this.single_set_selected_text(this.choice_label(data));
	          }
	        }
	        if (shown_results >= this.max_shown_results) {
	          break;
	        }
	      }
	      return content;
	    };
	
	    AbstractChosen.prototype.result_add_option = function (option) {
	      var classes, option_el;
	      if (!option.search_match) {
	        return '';
	      }
	      if (!this.include_option_in_results(option)) {
	        return '';
	      }
	      classes = [];
	      if (!option.disabled && !(option.selected && this.is_multiple)) {
	        classes.push("active-result");
	      }
	      if (option.disabled && !(option.selected && this.is_multiple)) {
	        classes.push("disabled-result");
	      }
	      if (option.selected) {
	        classes.push("result-selected");
	      }
	      if (option.group_array_index != null) {
	        classes.push("group-option");
	      }
	      if (option.classes !== "") {
	        classes.push(option.classes);
	      }
	      option_el = document.createElement("li");
	      option_el.className = classes.join(" ");
	      option_el.style.cssText = option.style;
	      option_el.setAttribute("data-option-array-index", option.array_index);
	      option_el.innerHTML = option.search_text;
	      if (option.title) {
	        option_el.title = option.title;
	      }
	      return this.outerHTML(option_el);
	    };
	
	    AbstractChosen.prototype.result_add_group = function (group) {
	      var classes, group_el;
	      if (!(group.search_match || group.group_match)) {
	        return '';
	      }
	      if (!(group.active_options > 0)) {
	        return '';
	      }
	      classes = [];
	      classes.push("group-result");
	      if (group.classes) {
	        classes.push(group.classes);
	      }
	      group_el = document.createElement("li");
	      group_el.className = classes.join(" ");
	      group_el.innerHTML = group.search_text;
	      if (group.title) {
	        group_el.title = group.title;
	      }
	      return this.outerHTML(group_el);
	    };
	
	    AbstractChosen.prototype.results_update_field = function () {
	      this.set_default_text();
	      if (!this.is_multiple) {
	        this.results_reset_cleanup();
	      }
	      this.result_clear_highlight();
	      this.results_build();
	      if (this.results_showing) {
	        return this.winnow_results();
	      }
	    };
	
	    AbstractChosen.prototype.reset_single_select_options = function () {
	      var result, _i, _len, _ref, _results;
	      _ref = this.results_data;
	      _results = [];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        result = _ref[_i];
	        if (result.selected) {
	          _results.push(result.selected = false);
	        } else {
	          _results.push(void 0);
	        }
	      }
	      return _results;
	    };
	
	    AbstractChosen.prototype.results_toggle = function () {
	      if (this.results_showing) {
	        return this.results_hide();
	      } else {
	        return this.results_show();
	      }
	    };
	
	    AbstractChosen.prototype.results_search = function (evt) {
	      if (this.results_showing) {
	        return this.winnow_results();
	      } else {
	        return this.results_show();
	      }
	    };
	
	    AbstractChosen.prototype.winnow_results = function () {
	      var escapedSearchText, option, regex, results, results_group, searchText, startpos, text, zregex, _i, _len, _ref;
	      this.no_results_clear();
	      results = 0;
	      searchText = this.get_search_text();
	      escapedSearchText = searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
	      zregex = new RegExp(escapedSearchText, 'i');
	      regex = this.get_search_regex(escapedSearchText);
	      _ref = this.results_data;
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        option = _ref[_i];
	        option.search_match = false;
	        results_group = null;
	        if (this.include_option_in_results(option)) {
	          if (option.group) {
	            option.group_match = false;
	            option.active_options = 0;
	          }
	          if (option.group_array_index != null && this.results_data[option.group_array_index]) {
	            results_group = this.results_data[option.group_array_index];
	            if (results_group.active_options === 0 && results_group.search_match) {
	              results += 1;
	            }
	            results_group.active_options += 1;
	          }
	          option.search_text = option.group ? option.label : option.html;
	          if (!(option.group && !this.group_search)) {
	            option.search_match = this.search_string_match(option.search_text, regex);
	            if (option.search_match && !option.group) {
	              results += 1;
	            }
	            if (option.search_match) {
	              if (searchText.length) {
	                startpos = option.search_text.search(zregex);
	                text = option.search_text.substr(0, startpos + searchText.length) + '</em>' + option.search_text.substr(startpos + searchText.length);
	                option.search_text = text.substr(0, startpos) + '<em>' + text.substr(startpos);
	              }
	              if (results_group != null) {
	                results_group.group_match = true;
	              }
	            } else if (option.group_array_index != null && this.results_data[option.group_array_index].search_match) {
	              option.search_match = true;
	            }
	          }
	        }
	      }
	      this.result_clear_highlight();
	      if (results < 1 && searchText.length) {
	        this.update_results_content("");
	        return this.no_results(searchText);
	      } else {
	        this.update_results_content(this.results_option_build());
	        return this.winnow_results_set_highlight();
	      }
	    };
	
	    AbstractChosen.prototype.get_search_regex = function (escaped_search_string) {
	      var regex_anchor;
	      regex_anchor = this.search_contains ? "" : "^";
	      return new RegExp(regex_anchor + escaped_search_string, 'i');
	    };
	
	    AbstractChosen.prototype.search_string_match = function (search_string, regex) {
	      var part, parts, _i, _len;
	      if (regex.test(search_string)) {
	        return true;
	      } else if (this.enable_split_word_search && (search_string.indexOf(" ") >= 0 || search_string.indexOf("[") === 0)) {
	        parts = search_string.replace(/\[|\]/g, "").split(" ");
	        if (parts.length) {
	          for (_i = 0, _len = parts.length; _i < _len; _i++) {
	            part = parts[_i];
	            if (regex.test(part)) {
	              return true;
	            }
	          }
	        }
	      }
	    };
	
	    AbstractChosen.prototype.choices_count = function () {
	      var option, _i, _len, _ref;
	      if (this.selected_option_count != null) {
	        return this.selected_option_count;
	      }
	      this.selected_option_count = 0;
	      _ref = this.form_field.options;
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        option = _ref[_i];
	        if (option.selected) {
	          this.selected_option_count += 1;
	        }
	      }
	      return this.selected_option_count;
	    };
	
	    AbstractChosen.prototype.choices_click = function (evt) {
	      evt.preventDefault();
	      if (!(this.results_showing || this.is_disabled)) {
	        return this.results_show();
	      }
	    };
	
	    AbstractChosen.prototype.keyup_checker = function (evt) {
	      var stroke, _ref;
	      stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
	      this.search_field_scale();
	      switch (stroke) {
	        case 8:
	          if (this.is_multiple && this.backstroke_length < 1 && this.choices_count() > 0) {
	            return this.keydown_backstroke();
	          } else if (!this.pending_backstroke) {
	            this.result_clear_highlight();
	            return this.results_search();
	          }
	          break;
	        case 13:
	          evt.preventDefault();
	          if (this.results_showing) {
	            return this.result_select(evt);
	          }
	          break;
	        case 27:
	          if (this.results_showing) {
	            this.results_hide();
	          }
	          return true;
	        case 9:
	        case 38:
	        case 40:
	        case 16:
	        case 91:
	        case 17:
	        case 18:
	          break;
	        default:
	          return this.results_search();
	      }
	    };
	
	    AbstractChosen.prototype.clipboard_event_checker = function (evt) {
	      var _this = this;
	      return setTimeout(function () {
	        return _this.results_search();
	      }, 50);
	    };
	
	    AbstractChosen.prototype.container_width = function () {
	      if (this.options.width != null) {
	        return this.options.width;
	      } else {
	        return "" + this.form_field.offsetWidth + "px";
	      }
	    };
	
	    AbstractChosen.prototype.include_option_in_results = function (option) {
	      if (this.is_multiple && !this.display_selected_options && option.selected) {
	        return false;
	      }
	      if (!this.display_disabled_options && option.disabled) {
	        return false;
	      }
	      if (option.empty) {
	        return false;
	      }
	      return true;
	    };
	
	    AbstractChosen.prototype.search_results_touchstart = function (evt) {
	      this.touch_started = true;
	      return this.search_results_mouseover(evt);
	    };
	
	    AbstractChosen.prototype.search_results_touchmove = function (evt) {
	      this.touch_started = false;
	      return this.search_results_mouseout(evt);
	    };
	
	    AbstractChosen.prototype.search_results_touchend = function (evt) {
	      if (this.touch_started) {
	        return this.search_results_mouseup(evt);
	      }
	    };
	
	    AbstractChosen.prototype.outerHTML = function (element) {
	      var tmp;
	      if (element.outerHTML) {
	        return element.outerHTML;
	      }
	      tmp = document.createElement("div");
	      tmp.appendChild(element);
	      return tmp.innerHTML;
	    };
	
	    AbstractChosen.browser_is_supported = function () {
	      if (/iP(od|hone)/i.test(window.navigator.userAgent)) {
	        return false;
	      }
	      if (/Android/i.test(window.navigator.userAgent)) {
	        if (/Mobile/i.test(window.navigator.userAgent)) {
	          return false;
	        }
	      }
	      if (/IEMobile/i.test(window.navigator.userAgent)) {
	        return false;
	      }
	      if (/Windows Phone/i.test(window.navigator.userAgent)) {
	        return false;
	      }
	      if (/BlackBerry/i.test(window.navigator.userAgent)) {
	        return false;
	      }
	      if (/BB10/i.test(window.navigator.userAgent)) {
	        return false;
	      }
	      if (window.navigator.appName === "Microsoft Internet Explorer") {
	        return document.documentMode >= 8;
	      }
	      return true;
	    };
	
	    AbstractChosen.default_multiple_text = "Select Some Options";
	
	    AbstractChosen.default_single_text = "Select an Option";
	
	    AbstractChosen.default_no_result_text = "No results match";
	
	    return AbstractChosen;
	  })();
	
	  $ = jQuery;
	
	  $.fn.extend({
	    chosen: function chosen(options) {
	      if (!AbstractChosen.browser_is_supported()) {
	        return this;
	      }
	      return this.each(function (input_field) {
	        var $this, chosen;
	        $this = $(this);
	        chosen = $this.data('chosen');
	        if (options === 'destroy') {
	          if (chosen instanceof Chosen) {
	            chosen.destroy();
	          }
	          return;
	        }
	        if (!(chosen instanceof Chosen)) {
	          $this.data('chosen', new Chosen(this, options));
	        }
	      });
	    }
	  });
	
	  Chosen = (function (_super) {
	    __extends(Chosen, _super);
	
	    function Chosen() {
	      _ref = Chosen.__super__.constructor.apply(this, arguments);
	      return _ref;
	    }
	
	    Chosen.prototype.setup = function () {
	      this.form_field_jq = $(this.form_field);
	      this.current_selectedIndex = this.form_field.selectedIndex;
	      return this.is_rtl = this.form_field_jq.hasClass("chosen-rtl");
	    };
	
	    Chosen.prototype.set_up_html = function () {
	      var container_classes, container_props;
	      container_classes = ["chosen-container"];
	      container_classes.push("chosen-container-" + (this.is_multiple ? "multi" : "single"));
	      if (this.inherit_select_classes && this.form_field.className) {
	        container_classes.push(this.form_field.className);
	      }
	      if (this.is_rtl) {
	        container_classes.push("chosen-rtl");
	      }
	      container_props = {
	        'class': container_classes.join(' '),
	        'style': "width: " + this.container_width() + ";",
	        'title': this.form_field.title
	      };
	      if (this.form_field.id.length) {
	        container_props.id = this.form_field.id.replace(/[^\w]/g, '_') + "_chosen";
	      }
	      this.container = $("<div />", container_props);
	      if (this.is_multiple) {
	        this.container.html('<ul class="chosen-choices"><li class="search-field"><input type="text" value="' + this.default_text + '" class="default" autocomplete="off" style="width:25px;" /></li></ul><div class="chosen-drop"><ul class="chosen-results"></ul></div>');
	      } else {
	        this.container.html('<a class="chosen-single chosen-default"><span>' + this.default_text + '</span><div><b></b></div></a><div class="chosen-drop"><div class="chosen-search"><input type="text" autocomplete="off" /></div><ul class="chosen-results"></ul></div>');
	      }
	      this.form_field_jq.hide().after(this.container);
	      this.dropdown = this.container.find('div.chosen-drop').first();
	      this.search_field = this.container.find('input').first();
	      this.search_results = this.container.find('ul.chosen-results').first();
	      this.search_field_scale();
	      this.search_no_results = this.container.find('li.no-results').first();
	      if (this.is_multiple) {
	        this.search_choices = this.container.find('ul.chosen-choices').first();
	        this.search_container = this.container.find('li.search-field').first();
	      } else {
	        this.search_container = this.container.find('div.chosen-search').first();
	        this.selected_item = this.container.find('.chosen-single').first();
	      }
	      this.results_build();
	      this.set_tab_index();
	      return this.set_label_behavior();
	    };
	
	    Chosen.prototype.on_ready = function () {
	      return this.form_field_jq.trigger("chosen:ready", {
	        chosen: this
	      });
	    };
	
	    Chosen.prototype.register_observers = function () {
	      var _this = this;
	      this.container.bind('touchstart.chosen', function (evt) {
	        _this.container_mousedown(evt);
	        return evt.preventDefault();
	      });
	      this.container.bind('touchend.chosen', function (evt) {
	        _this.container_mouseup(evt);
	        return evt.preventDefault();
	      });
	      this.container.bind('mousedown.chosen', function (evt) {
	        _this.container_mousedown(evt);
	      });
	      this.container.bind('mouseup.chosen', function (evt) {
	        _this.container_mouseup(evt);
	      });
	      this.container.bind('mouseenter.chosen', function (evt) {
	        _this.mouse_enter(evt);
	      });
	      this.container.bind('mouseleave.chosen', function (evt) {
	        _this.mouse_leave(evt);
	      });
	      this.search_results.bind('mouseup.chosen', function (evt) {
	        _this.search_results_mouseup(evt);
	      });
	      this.search_results.bind('mouseover.chosen', function (evt) {
	        _this.search_results_mouseover(evt);
	      });
	      this.search_results.bind('mouseout.chosen', function (evt) {
	        _this.search_results_mouseout(evt);
	      });
	      this.search_results.bind('mousewheel.chosen DOMMouseScroll.chosen', function (evt) {
	        _this.search_results_mousewheel(evt);
	      });
	      this.search_results.bind('touchstart.chosen', function (evt) {
	        _this.search_results_touchstart(evt);
	      });
	      this.search_results.bind('touchmove.chosen', function (evt) {
	        _this.search_results_touchmove(evt);
	      });
	      this.search_results.bind('touchend.chosen', function (evt) {
	        _this.search_results_touchend(evt);
	      });
	      this.form_field_jq.bind("chosen:updated.chosen", function (evt) {
	        _this.results_update_field(evt);
	      });
	      this.form_field_jq.bind("chosen:activate.chosen", function (evt) {
	        _this.activate_field(evt);
	      });
	      this.form_field_jq.bind("chosen:open.chosen", function (evt) {
	        _this.container_mousedown(evt);
	      });
	      this.form_field_jq.bind("chosen:close.chosen", function (evt) {
	        _this.input_blur(evt);
	      });
	      this.search_field.bind('blur.chosen', function (evt) {
	        _this.input_blur(evt);
	      });
	      this.search_field.bind('keyup.chosen', function (evt) {
	        _this.keyup_checker(evt);
	      });
	      this.search_field.bind('keydown.chosen', function (evt) {
	        _this.keydown_checker(evt);
	      });
	      this.search_field.bind('focus.chosen', function (evt) {
	        _this.input_focus(evt);
	      });
	      this.search_field.bind('cut.chosen', function (evt) {
	        _this.clipboard_event_checker(evt);
	      });
	      this.search_field.bind('paste.chosen', function (evt) {
	        _this.clipboard_event_checker(evt);
	      });
	      if (this.is_multiple) {
	        return this.search_choices.bind('click.chosen', function (evt) {
	          _this.choices_click(evt);
	        });
	      } else {
	        return this.container.bind('click.chosen', function (evt) {
	          evt.preventDefault();
	        });
	      }
	    };
	
	    Chosen.prototype.destroy = function () {
	      $(this.container[0].ownerDocument).unbind("click.chosen", this.click_test_action);
	      if (this.search_field[0].tabIndex) {
	        this.form_field_jq[0].tabIndex = this.search_field[0].tabIndex;
	      }
	      this.container.remove();
	      this.form_field_jq.removeData('chosen');
	      return this.form_field_jq.show();
	    };
	
	    Chosen.prototype.search_field_disabled = function () {
	      this.is_disabled = this.form_field_jq[0].disabled;
	      if (this.is_disabled) {
	        this.container.addClass('chosen-disabled');
	        this.search_field[0].disabled = true;
	        if (!this.is_multiple) {
	          this.selected_item.unbind("focus.chosen", this.activate_action);
	        }
	        return this.close_field();
	      } else {
	        this.container.removeClass('chosen-disabled');
	        this.search_field[0].disabled = false;
	        if (!this.is_multiple) {
	          return this.selected_item.bind("focus.chosen", this.activate_action);
	        }
	      }
	    };
	
	    Chosen.prototype.container_mousedown = function (evt) {
	      if (!this.is_disabled) {
	        if (evt && evt.type === "mousedown" && !this.results_showing) {
	          evt.preventDefault();
	        }
	        if (!(evt != null && $(evt.target).hasClass("search-choice-close"))) {
	          if (!this.active_field) {
	            if (this.is_multiple) {
	              this.search_field.val("");
	            }
	            $(this.container[0].ownerDocument).bind('click.chosen', this.click_test_action);
	            this.results_show();
	          } else if (!this.is_multiple && evt && ($(evt.target)[0] === this.selected_item[0] || $(evt.target).parents("a.chosen-single").length)) {
	            evt.preventDefault();
	            this.results_toggle();
	          }
	          return this.activate_field();
	        }
	      }
	    };
	
	    Chosen.prototype.container_mouseup = function (evt) {
	      if (evt.target.nodeName === "ABBR" && !this.is_disabled) {
	        return this.results_reset(evt);
	      }
	    };
	
	    Chosen.prototype.search_results_mousewheel = function (evt) {
	      var delta;
	      if (evt.originalEvent) {
	        delta = evt.originalEvent.deltaY || -evt.originalEvent.wheelDelta || evt.originalEvent.detail;
	      }
	      if (delta != null) {
	        evt.preventDefault();
	        if (evt.type === 'DOMMouseScroll') {
	          delta = delta * 40;
	        }
	        return this.search_results.scrollTop(delta + this.search_results.scrollTop());
	      }
	    };
	
	    Chosen.prototype.blur_test = function (evt) {
	      if (!this.active_field && this.container.hasClass("chosen-container-active")) {
	        return this.close_field();
	      }
	    };
	
	    Chosen.prototype.close_field = function () {
	      $(this.container[0].ownerDocument).unbind("click.chosen", this.click_test_action);
	      this.active_field = false;
	      this.results_hide();
	      this.container.removeClass("chosen-container-active");
	      this.clear_backstroke();
	      this.show_search_field_default();
	      return this.search_field_scale();
	    };
	
	    Chosen.prototype.activate_field = function () {
	      this.container.addClass("chosen-container-active");
	      this.active_field = true;
	      this.search_field.val(this.search_field.val());
	      return this.search_field.focus();
	    };
	
	    Chosen.prototype.test_active_click = function (evt) {
	      var active_container;
	      active_container = $(evt.target).closest('.chosen-container');
	      if (active_container.length && this.container[0] === active_container[0]) {
	        return this.active_field = true;
	      } else {
	        return this.close_field();
	      }
	    };
	
	    Chosen.prototype.results_build = function () {
	      this.parsing = true;
	      this.selected_option_count = null;
	      this.results_data = SelectParser.select_to_array(this.form_field);
	      if (this.is_multiple) {
	        this.search_choices.find("li.search-choice").remove();
	      } else if (!this.is_multiple) {
	        this.single_set_selected_text();
	        if (this.disable_search || this.form_field.options.length <= this.disable_search_threshold) {
	          this.search_field[0].readOnly = true;
	          this.container.addClass("chosen-container-single-nosearch");
	        } else {
	          this.search_field[0].readOnly = false;
	          this.container.removeClass("chosen-container-single-nosearch");
	        }
	      }
	      this.update_results_content(this.results_option_build({
	        first: true
	      }));
	      this.search_field_disabled();
	      this.show_search_field_default();
	      this.search_field_scale();
	      return this.parsing = false;
	    };
	
	    Chosen.prototype.result_do_highlight = function (el) {
	      var high_bottom, high_top, maxHeight, visible_bottom, visible_top;
	      if (el.length) {
	        this.result_clear_highlight();
	        this.result_highlight = el;
	        this.result_highlight.addClass("highlighted");
	        maxHeight = parseInt(this.search_results.css("maxHeight"), 10);
	        visible_top = this.search_results.scrollTop();
	        visible_bottom = maxHeight + visible_top;
	        high_top = this.result_highlight.position().top + this.search_results.scrollTop();
	        high_bottom = high_top + this.result_highlight.outerHeight();
	        if (high_bottom >= visible_bottom) {
	          return this.search_results.scrollTop(high_bottom - maxHeight > 0 ? high_bottom - maxHeight : 0);
	        } else if (high_top < visible_top) {
	          return this.search_results.scrollTop(high_top);
	        }
	      }
	    };
	
	    Chosen.prototype.result_clear_highlight = function () {
	      if (this.result_highlight) {
	        this.result_highlight.removeClass("highlighted");
	      }
	      return this.result_highlight = null;
	    };
	
	    Chosen.prototype.results_show = function () {
	      if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
	        this.form_field_jq.trigger("chosen:maxselected", {
	          chosen: this
	        });
	        return false;
	      }
	      this.container.addClass("chosen-with-drop");
	      this.results_showing = true;
	      this.search_field.focus();
	      this.search_field.val(this.search_field.val());
	      this.winnow_results();
	      return this.form_field_jq.trigger("chosen:showing_dropdown", {
	        chosen: this
	      });
	    };
	
	    Chosen.prototype.update_results_content = function (content) {
	      return this.search_results.html(content);
	    };
	
	    Chosen.prototype.results_hide = function () {
	      if (this.results_showing) {
	        this.result_clear_highlight();
	        this.container.removeClass("chosen-with-drop");
	        this.form_field_jq.trigger("chosen:hiding_dropdown", {
	          chosen: this
	        });
	      }
	      return this.results_showing = false;
	    };
	
	    Chosen.prototype.set_tab_index = function (el) {
	      var ti;
	      if (this.form_field.tabIndex) {
	        ti = this.form_field.tabIndex;
	        this.form_field.tabIndex = -1;
	        return this.search_field[0].tabIndex = ti;
	      }
	    };
	
	    Chosen.prototype.set_label_behavior = function () {
	      var _this = this;
	      this.form_field_label = this.form_field_jq.parents("label");
	      if (!this.form_field_label.length && this.form_field.id.length) {
	        this.form_field_label = $("label[for='" + this.form_field.id + "']");
	      }
	      if (this.form_field_label.length > 0) {
	        return this.form_field_label.bind('click.chosen', function (evt) {
	          if (_this.is_multiple) {
	            return _this.container_mousedown(evt);
	          } else {
	            return _this.activate_field();
	          }
	        });
	      }
	    };
	
	    Chosen.prototype.show_search_field_default = function () {
	      if (this.is_multiple && this.choices_count() < 1 && !this.active_field) {
	        this.search_field.val(this.default_text);
	        return this.search_field.addClass("default");
	      } else {
	        this.search_field.val("");
	        return this.search_field.removeClass("default");
	      }
	    };
	
	    Chosen.prototype.search_results_mouseup = function (evt) {
	      var target;
	      target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
	      if (target.length) {
	        this.result_highlight = target;
	        this.result_select(evt);
	        return this.search_field.focus();
	      }
	    };
	
	    Chosen.prototype.search_results_mouseover = function (evt) {
	      var target;
	      target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
	      if (target) {
	        return this.result_do_highlight(target);
	      }
	    };
	
	    Chosen.prototype.search_results_mouseout = function (evt) {
	      if ($(evt.target).hasClass("active-result" || $(evt.target).parents('.active-result').first())) {
	        return this.result_clear_highlight();
	      }
	    };
	
	    Chosen.prototype.choice_build = function (item) {
	      var choice,
	          close_link,
	          _this = this;
	      choice = $('<li />', {
	        "class": "search-choice"
	      }).html("<span>" + this.choice_label(item) + "</span>");
	      if (item.disabled) {
	        choice.addClass('search-choice-disabled');
	      } else {
	        close_link = $('<span />', {
	          "class": 'search-choice-close icon icon-close',
	          'data-option-array-index': item.array_index
	        });
	        close_link.bind('click.chosen', function (evt) {
	          return _this.choice_destroy_link_click(evt);
	        });
	        choice.append(close_link);
	      }
	      return this.search_container.before(choice);
	    };
	
	    Chosen.prototype.choice_destroy_link_click = function (evt) {
	      evt.preventDefault();
	      evt.stopPropagation();
	      if (!this.is_disabled) {
	        return this.choice_destroy($(evt.target));
	      }
	    };
	
	    Chosen.prototype.choice_destroy = function (link) {
	      if (this.result_deselect(link[0].getAttribute("data-option-array-index"))) {
	        this.show_search_field_default();
	        if (this.is_multiple && this.choices_count() > 0 && this.search_field.val().length < 1) {
	          this.results_hide();
	        }
	        link.parents('li').first().remove();
	        return this.search_field_scale();
	      }
	    };
	
	    Chosen.prototype.results_reset = function () {
	      this.reset_single_select_options();
	      this.form_field.options[0].selected = true;
	      this.single_set_selected_text();
	      this.show_search_field_default();
	      this.results_reset_cleanup();
	      this.form_field_jq.trigger("change");
	      if (this.active_field) {
	        return this.results_hide();
	      }
	    };
	
	    Chosen.prototype.results_reset_cleanup = function () {
	      this.current_selectedIndex = this.form_field.selectedIndex;
	      return this.selected_item.find("abbr").remove();
	    };
	
	    Chosen.prototype.result_select = function (evt) {
	      var high, item;
	      if (this.result_highlight) {
	        high = this.result_highlight;
	        this.result_clear_highlight();
	        if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
	          this.form_field_jq.trigger("chosen:maxselected", {
	            chosen: this
	          });
	          return false;
	        }
	        if (this.is_multiple) {
	          high.removeClass("active-result");
	        } else {
	          this.reset_single_select_options();
	        }
	        high.addClass("result-selected");
	        item = this.results_data[high[0].getAttribute("data-option-array-index")];
	        item.selected = true;
	        this.form_field.options[item.options_index].selected = true;
	        this.selected_option_count = null;
	        if (this.is_multiple) {
	          this.choice_build(item);
	        } else {
	          this.single_set_selected_text(this.choice_label(item));
	        }
	        if (!((evt.metaKey || evt.ctrlKey) && this.is_multiple)) {
	          this.results_hide();
	        }
	        this.show_search_field_default();
	        if (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) {
	          this.form_field_jq.trigger("change", {
	            'selected': this.form_field.options[item.options_index].value
	          });
	        }
	        this.current_selectedIndex = this.form_field.selectedIndex;
	        evt.preventDefault();
	        return this.search_field_scale();
	      }
	    };
	
	    Chosen.prototype.single_set_selected_text = function (text) {
	      if (text == null) {
	        text = this.default_text;
	      }
	      if (text === this.default_text) {
	        this.selected_item.addClass("chosen-default");
	      } else {
	        this.single_deselect_control_build();
	        this.selected_item.removeClass("chosen-default");
	      }
	      return this.selected_item.find("span").html(text);
	    };
	
	    Chosen.prototype.result_deselect = function (pos) {
	      var result_data;
	      result_data = this.results_data[pos];
	      if (!this.form_field.options[result_data.options_index].disabled) {
	        result_data.selected = false;
	        this.form_field.options[result_data.options_index].selected = false;
	        this.selected_option_count = null;
	        this.result_clear_highlight();
	        if (this.results_showing) {
	          this.winnow_results();
	        }
	        this.form_field_jq.trigger("change", {
	          deselected: this.form_field.options[result_data.options_index].value
	        });
	        this.search_field_scale();
	        return true;
	      } else {
	        return false;
	      }
	    };
	
	    Chosen.prototype.single_deselect_control_build = function () {
	      if (!this.allow_single_deselect) {
	        return;
	      }
	      if (!this.selected_item.find("abbr").length) {
	        this.selected_item.find("span").first().after("<abbr class=\"search-choice-close\"></abbr>");
	      }
	      return this.selected_item.addClass("chosen-single-with-deselect");
	    };
	
	    Chosen.prototype.get_search_text = function () {
	      return $('<div/>').text($.trim(this.search_field.val())).html();
	    };
	
	    Chosen.prototype.winnow_results_set_highlight = function () {
	      var do_high, selected_results;
	      selected_results = !this.is_multiple ? this.search_results.find(".result-selected.active-result") : [];
	      do_high = selected_results.length ? selected_results.first() : this.search_results.find(".active-result").first();
	      if (do_high != null) {
	        return this.result_do_highlight(do_high);
	      }
	    };
	
	    Chosen.prototype.no_results = function (terms) {
	      var no_results_html;
	      no_results_html = $('<li class="no-results">' + this.results_none_found + ' "<span></span>"</li>');
	      no_results_html.find("span").first().html(terms);
	      this.search_results.append(no_results_html);
	      return this.form_field_jq.trigger("chosen:no_results", {
	        chosen: this
	      });
	    };
	
	    Chosen.prototype.no_results_clear = function () {
	      return this.search_results.find(".no-results").remove();
	    };
	
	    Chosen.prototype.keydown_arrow = function () {
	      var next_sib;
	      if (this.results_showing && this.result_highlight) {
	        next_sib = this.result_highlight.nextAll("li.active-result").first();
	        if (next_sib) {
	          return this.result_do_highlight(next_sib);
	        }
	      } else {
	        return this.results_show();
	      }
	    };
	
	    Chosen.prototype.keyup_arrow = function () {
	      var prev_sibs;
	      if (!this.results_showing && !this.is_multiple) {
	        return this.results_show();
	      } else if (this.result_highlight) {
	        prev_sibs = this.result_highlight.prevAll("li.active-result");
	        if (prev_sibs.length) {
	          return this.result_do_highlight(prev_sibs.first());
	        } else {
	          if (this.choices_count() > 0) {
	            this.results_hide();
	          }
	          return this.result_clear_highlight();
	        }
	      }
	    };
	
	    Chosen.prototype.keydown_backstroke = function () {
	      var next_available_destroy;
	      if (this.pending_backstroke) {
	        this.choice_destroy(this.pending_backstroke.find(".search-choice-close").first());
	        return this.clear_backstroke();
	      } else {
	        next_available_destroy = this.search_container.siblings("li.search-choice").last();
	        if (next_available_destroy.length && !next_available_destroy.hasClass("search-choice-disabled")) {
	          this.pending_backstroke = next_available_destroy;
	          if (this.single_backstroke_delete) {
	            return this.keydown_backstroke();
	          } else {
	            return this.pending_backstroke.addClass("search-choice-focus");
	          }
	        }
	      }
	    };
	
	    Chosen.prototype.clear_backstroke = function () {
	      if (this.pending_backstroke) {
	        this.pending_backstroke.removeClass("search-choice-focus");
	      }
	      return this.pending_backstroke = null;
	    };
	
	    Chosen.prototype.keydown_checker = function (evt) {
	      var stroke, _ref1;
	      stroke = (_ref1 = evt.which) != null ? _ref1 : evt.keyCode;
	      this.search_field_scale();
	      if (stroke !== 8 && this.pending_backstroke) {
	        this.clear_backstroke();
	      }
	      switch (stroke) {
	        case 8:
	          this.backstroke_length = this.search_field.val().length;
	          break;
	        case 9:
	          if (this.results_showing && !this.is_multiple) {
	            this.result_select(evt);
	          }
	          this.mouse_on_container = false;
	          break;
	        case 13:
	          if (this.results_showing) {
	            evt.preventDefault();
	          }
	          break;
	        case 32:
	          if (this.disable_search) {
	            evt.preventDefault();
	          }
	          break;
	        case 38:
	          evt.preventDefault();
	          this.keyup_arrow();
	          break;
	        case 40:
	          evt.preventDefault();
	          this.keydown_arrow();
	          break;
	      }
	    };
	
	    Chosen.prototype.search_field_scale = function () {
	      var div, f_width, h, style, style_block, styles, w, _i, _len;
	      if (this.is_multiple) {
	        h = 0;
	        w = 0;
	        style_block = "position:absolute; left: -1000px; top: -1000px; display:none;";
	        styles = ['font-size', 'font-style', 'font-weight', 'font-family', 'line-height', 'text-transform', 'letter-spacing'];
	        for (_i = 0, _len = styles.length; _i < _len; _i++) {
	          style = styles[_i];
	          style_block += style + ":" + this.search_field.css(style) + ";";
	        }
	        div = $('<div />', {
	          'style': style_block
	        });
	        div.text(this.search_field.val());
	        $('body').append(div);
	        w = div.width() + 25;
	        div.remove();
	        f_width = this.container.outerWidth();
	        if (w > f_width - 10) {
	          w = f_width - 10;
	        }
	        return this.search_field.css({
	          'width': w + 'px'
	        });
	      }
	    };
	
	    return Chosen;
	  })(AbstractChosen);
	}).call(undefined);

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	
	//Module Imports
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _utils = __webpack_require__(8);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var PromiseIE = __webpack_require__(18).Promise;
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK Modal : Content must be defined and set to a DOM selector or Node"]
	}, {
	    setting: "autoShow",
	    isRequired: false,
	    validate: "type",
	    possibleValues: ["boolean"],
	    errorMessage: ["GDK Modal : autoShow must be a boolean"]
	}, {
	    setting: "overlayShouldCloseModal",
	    isRequired: false,
	    validate: "type",
	    possibleValues: ["boolean"],
	    errorMessage: ["GDK Modal : overlayShouldCloseModal must be a boolean"]
	}, {
	    setting: "hideCloseButton",
	    isRequired: false,
	    validate: "type",
	    possibleValues: ["boolean"],
	    errorMessage: ["GDK Modal : hideCloseButton must be a boolean"]
	}, {
	    setting: "onOpened",
	    isRequired: false,
	    validate: "type",
	    possibleValues: ["function"],
	    errorMessage: ["GDK Modal : onOpened must be a function"]
	}, {
	    setting: "onClosed",
	    isRequired: false,
	    validate: "type",
	    possibleValues: ["function"],
	    errorMessage: ["GDK Modal : onClosed must be a function"]
	}];
	
	var modalCloseBtn = '<button class="btn-close icon-close" type="button" aria-label="Close modal"></button>';
	
	var Modal = (function () {
	    /**
	     * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	     * @param {string|Object} content
	     * A reference to the modal node
	     *
	     * @param {boolean} [autoShow=false]
	     * Use if you want to model to auto show when instantiated
	     *
	     * @param {boolean} [overlayShouldCloseModal=true]
	     * Set to false if you do not want the overlay to have click to close functionality
	     *
	     * @param {boolean} [hideCloseButton=false]
	     * Set to true if you want to hide the close button in the upper right corner of the modal
	     *
	     * @param {function} [onOpened]
	     * A callback function that gets fired when the modal has been opened
	     *
	     * @param {function} [onClosed]
	     * A callback function that gets fired when the modal has been closed
	     *
	     */
	
	    function Modal(options) {
	        _classCallCheck(this, Modal);
	
	        this._internalVars = {
	            node: null, //used for current node
	            closeBtn: null
	        };
	
	        //options with defaults set
	        this._defaults = {
	            autoShow: false,
	            overlayShouldCloseModal: true,
	            hideCloseButton: false
	        };
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2['default'].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2['default'].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2['default'].getContentType(this);
	            setLocalVars.call(this);
	            buildModal.call(this);
	            setEvents.call(this);
	
	            if (this._options.autoShow) {
	                this.show();
	            }
	        }
	    }
	
	    /**
	    * setLocalVars()
	    * set all the local vars to passed in options
	    */
	
	    //Public Methods
	
	    /**
	    * show()
	    * shows the modal
	    */
	
	    _createClass(Modal, [{
	        key: 'show',
	        value: function show() {
	            var _this = this;
	
	            this._internalVars.node.style.display = "block";
	
	            setTimeout(function () {
	                _this._internalVars.node.classList.add("modal--show");
	                if (_this._options.onOpened) _this._options.onOpened();
	            }, 10);
	            this._internalVars.inModalArray = [];
	            document.addEventListener('keyup', this._internalVars.modalTabHandler);
	        }
	
	        /**
	        * hide()
	        * hides the modal
	        */
	    }, {
	        key: 'hide',
	        value: function hide() {
	            var _this2 = this;
	
	            var duration = arguments.length <= 0 || arguments[0] === undefined ? 500 : arguments[0];
	
	            this._internalVars.inModalArray = [];
	            document.removeEventListener('keyup', this._internalVars.modalTabHandler);
	
	            return new PromiseIE(function (resolve, reject) {
	                setTimeout(function () {
	                    _this2._internalVars.node.classList.remove("modal--show");
	                    _this2._internalVars.node.style.display = "none";
	                    if (_this2._options.onClosed) _this2._options.onClosed();
	                    resolve();
	                }, duration);
	            });
	        }
	
	        /**
	        * destroy()
	        * removes the node from the dom and any events attached
	        */
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            removeEvents.call(this);
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return Modal;
	})();
	
	function setLocalVars() {
	    //determine the type of content passed in
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    this._internalVars.modalTabHandler = isolateTab.bind(this);
	}
	
	/**
	* modalClicked()
	* Gets fired when you click anywhere on a model
	*/
	function modalClicked(e) {
	
	    //NodeList of items that the mouse is currently over in document order.
	    //The last element in the NodeList is the most specific, each preceding
	    //one should be a parent, grandparent, and so on.
	    var nodes = document.querySelectorAll(":hover");
	
	    if (this._internalVars.node == nodes[nodes.length - 1]) {
	        this.hide();
	    }
	}
	
	/**
	 * setEvents()
	 * Sets all the events needed for this component
	 */
	function setEvents() {
	
	    var eventName = "click";
	
	    if ("ontouchstart" in document.documentElement) {
	        eventName = navigator.userAgent.toLowerCase().indexOf('windows') === -1 ? "touchstart" : "pointerup";
	        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
	            eventName = "touchstart";
	        }
	    }
	
	    if (this._options.overlayShouldCloseModal) {
	        this._internalVars.node.addEventListener(eventName, modalClicked.bind(this));
	    }
	
	    if (this._options.hideCloseButton) {
	        this._internalVars.closeBtn.classList.add("hidden");
	    } else {
	        this._internalVars.closeBtn.addEventListener(eventName, this.hide.bind(this));
	        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
	            this._internalVars.closeBtn.addEventListener('click', this.hide.bind(this));
	        }
	    }
	}
	
	/**
	 * removeEvents()
	 * removes all events from this component
	 */
	function removeEvents() {
	
	    var eventName = "click";
	
	    if ("ontouchstart" in document.documentElement) {
	        eventName = navigator.userAgent.toLowerCase().indexOf('windows') === -1 ? "touchstart" : "pointerup";
	        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
	            eventName = "touchstart";
	        }
	    }
	
	    if (this._options.overlayShouldCloseModal) {
	        this._internalVars.node.removeEventListener(eventName, modalClicked.bind(this));
	    }
	    this._internalVars.closeBtn.removeEventListener(eventName, this.hide.bind(this));
	    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
	        this._internalVars.closeBtn.removeEventListener('click', this.hide.bind(this));
	    }
	}
	
	/**
	* buildModal()
	* Adds needed markup this component
	*/
	function buildModal() {
	    var modalContentDom = this._internalVars.node.querySelector(".modal-container");
	    modalContentDom.insertAdjacentHTML('afterBegin', modalCloseBtn);
	
	    this._internalVars.closeBtn = this._internalVars.node.querySelector(".btn-close");
	
	    var spanTab = document.createElement('span');
	    spanTab.setAttribute('tabindex', '0');
	    spanTab.setAttribute('class', 'tab-filler');
	    var cloneSpanTab = spanTab.cloneNode(true);
	    modalContentDom.appendChild(spanTab);
	    modalContentDom.insertBefore(cloneSpanTab, modalContentDom.children[0]);
	}
	
	function isolateTab(e) {
	    if (e.keyCode == 9 || e.keyCode == 9 && e.shiftKey) {
	        if (utils.isChild("modal", document.activeElement) && !document.activeElement.classList.contains('tab-filler') && !this._internalVars.inModalArray.includes(document.activeElement)) {
	            this._internalVars.inModalArray.push(document.activeElement);
	        }
	
	        if (document.activeElement.classList.contains('tab-filler')) {
	            if (this._internalVars.inModalArray.length > 0) {
	                this._internalVars.inModalArray[0].focus();
	            }
	        }
	    }
	}
	
	exports['default'] = Modal;
	module.exports = exports['default'];

/***/ },
/* 17 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var baseComponent = {
	
		/**
	  * validateSettings()
	  * Validates all content settings
	  */
		validateSettings: function validateSettings(currentOptions, validationRules) {
	
			var valid = true;
	
			Array.prototype.forEach.call(validationRules, function (el, i) {
	
				var setting = currentOptions[el.setting];
	
				if (el.isRequired === true) {
	
					//if a required field is not set retun false
					if (baseComponent.validateRequiredSettings(el, currentOptions)) {
	
						if (!baseComponent.validateSettingValues(setting, el.validate, el.possibleValues, el.errorMessage)) {
							valid = false;
							return false;
						}
					} else {
						valid = false;
						return false;
					}
				} else {
	
					//if is a setting is not required but its set we need to validate it
					if (setting) {
						if (!baseComponent.validateSettingValues(setting, el.validate, el.possibleValues, el.errorMessage)) {
							valid = false;
							return false;
						}
					}
				}
			});
	
			if (valid) {
				return true;
			}
		},
	
		validateRequiredSettings: function validateRequiredSettings(el, currentOptions) {
	
			var setting = currentOptions[el.setting];
	
			try {
	
				if (setting) {
					return true;
				} else {
					throw new Error(el.errorMessage);
				}
			} catch (ex) {
				console.error("Error : ", ex.message);
			}
		},
	
		validateSettingValues: function validateSettingValues(setting, validate, values, error) {
	
			var validValue = false;
	
			Array.prototype.forEach.call(values, function (el, i) {
	
				if (validate === "type") {
	
					if (typeof setting === el) {
						validValue = true;
					}
				} else if (validate === "value") {
	
					if (el === setting) {
						validValue = true;
					}
				}
			});
	
			try {
	
				if (validValue) {
					return true;
				} else {
					throw new Error(error);
				}
			} catch (ex) {
				console.error("Error : ", ex.message);
			}
		},
	
		getContentType: function getContentType(o) {
			try {
				if (typeof o._options.content === "string" || typeof o._options.content === "object") {
	
					var contentType = typeof o._options.content;
	
					if (this.isDOM(o._options.content)) {
						contentType = "domNode";
					}
	
					return contentType;
				} else {
					throw new Error("The content option must be a DOM selector or Node.");
				}
			} catch (ex) {
				console.error("Error : ", ex.message);
			}
		},
	
		extendDefaults: function extendDefaults(source, properties) {
			var property;
			for (property in properties) {
				if (properties.hasOwnProperty(property)) {
					source[property] = properties[property];
				}
			}
			return source;
		},
	
		isDOM: function isDOM(obj) {
			// DOM, Level2
			if ("HTMLElement" in window) {
				return !!obj && obj instanceof HTMLElement;
			}
			// Older browsers
			return !!obj && typeof obj === "object" && obj.nodeType === 1 && !!obj.nodeName;
		}
	
	};
	
	exports["default"] = baseComponent;
	module.exports = exports["default"];

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(19);

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, setImmediate) {'use strict';
	
	(function (global) {
	
	  //
	  // Check for native Promise and it has correct interface
	  //
	
	  var NativePromise = global['Promise'];
	  var nativePromiseSupported = NativePromise &&
	  // Some of these methods are missing from
	  // Firefox/Chrome experimental implementations
	  'resolve' in NativePromise && 'reject' in NativePromise && 'all' in NativePromise && 'race' in NativePromise &&
	  // Older version of the spec had a resolver object
	  // as the arg rather than a function
	  (function () {
	    var resolve;
	    new NativePromise(function (r) {
	      resolve = r;
	    });
	    return typeof resolve === 'function';
	  })();
	
	  //
	  // export if necessary
	  //
	
	  if (typeof exports !== 'undefined' && exports) {
	    // node.js
	    exports.Promise = nativePromiseSupported ? NativePromise : Promise;
	    exports.Polyfill = Promise;
	  } else {
	    // AMD
	    if (true) {
	      !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	        return nativePromiseSupported ? NativePromise : Promise;
	      }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else {
	      // in browser add to global
	      if (!nativePromiseSupported) global['Promise'] = Promise;
	    }
	  }
	
	  //
	  // Polyfill
	  //
	
	  var PENDING = 'pending';
	  var SEALED = 'sealed';
	  var FULFILLED = 'fulfilled';
	  var REJECTED = 'rejected';
	  var NOOP = function NOOP() {};
	
	  function isArray(value) {
	    return Object.prototype.toString.call(value) === '[object Array]';
	  }
	
	  // async calls
	  var asyncSetTimer = typeof setImmediate !== 'undefined' ? setImmediate : setTimeout;
	  var asyncQueue = [];
	  var asyncTimer;
	
	  function asyncFlush() {
	    // run promise callbacks
	    for (var i = 0; i < asyncQueue.length; i++) asyncQueue[i][0](asyncQueue[i][1]);
	
	    // reset async asyncQueue
	    asyncQueue = [];
	    asyncTimer = false;
	  }
	
	  function asyncCall(callback, arg) {
	    asyncQueue.push([callback, arg]);
	
	    if (!asyncTimer) {
	      asyncTimer = true;
	      asyncSetTimer(asyncFlush, 0);
	    }
	  }
	
	  function invokeResolver(resolver, promise) {
	    function resolvePromise(value) {
	      resolve(promise, value);
	    }
	
	    function rejectPromise(reason) {
	      reject(promise, reason);
	    }
	
	    try {
	      resolver(resolvePromise, rejectPromise);
	    } catch (e) {
	      rejectPromise(e);
	    }
	  }
	
	  function invokeCallback(subscriber) {
	    var owner = subscriber.owner;
	    var settled = owner.state_;
	    var value = owner.data_;
	    var callback = subscriber[settled];
	    var promise = subscriber.then;
	
	    if (typeof callback === 'function') {
	      settled = FULFILLED;
	      try {
	        value = callback(value);
	      } catch (e) {
	        reject(promise, e);
	      }
	    }
	
	    if (!handleThenable(promise, value)) {
	      if (settled === FULFILLED) resolve(promise, value);
	
	      if (settled === REJECTED) reject(promise, value);
	    }
	  }
	
	  function handleThenable(promise, value) {
	    var resolved;
	
	    try {
	      if (promise === value) throw new TypeError('A promises callback cannot return that same promise.');
	
	      if (value && (typeof value === 'function' || typeof value === 'object')) {
	        var then = value.then; // then should be retrived only once
	
	        if (typeof then === 'function') {
	          then.call(value, function (val) {
	            if (!resolved) {
	              resolved = true;
	
	              if (value !== val) resolve(promise, val);else fulfill(promise, val);
	            }
	          }, function (reason) {
	            if (!resolved) {
	              resolved = true;
	
	              reject(promise, reason);
	            }
	          });
	
	          return true;
	        }
	      }
	    } catch (e) {
	      if (!resolved) reject(promise, e);
	
	      return true;
	    }
	
	    return false;
	  }
	
	  function resolve(promise, value) {
	    if (promise === value || !handleThenable(promise, value)) fulfill(promise, value);
	  }
	
	  function fulfill(promise, value) {
	    if (promise.state_ === PENDING) {
	      promise.state_ = SEALED;
	      promise.data_ = value;
	
	      asyncCall(publishFulfillment, promise);
	    }
	  }
	
	  function reject(promise, reason) {
	    if (promise.state_ === PENDING) {
	      promise.state_ = SEALED;
	      promise.data_ = reason;
	
	      asyncCall(publishRejection, promise);
	    }
	  }
	
	  function publish(promise) {
	    var callbacks = promise.then_;
	    promise.then_ = undefined;
	
	    for (var i = 0; i < callbacks.length; i++) {
	      invokeCallback(callbacks[i]);
	    }
	  }
	
	  function publishFulfillment(promise) {
	    promise.state_ = FULFILLED;
	    publish(promise);
	  }
	
	  function publishRejection(promise) {
	    promise.state_ = REJECTED;
	    publish(promise);
	  }
	
	  /**
	  * @class
	  */
	  function Promise(resolver) {
	    if (typeof resolver !== 'function') throw new TypeError('Promise constructor takes a function argument');
	
	    if (this instanceof Promise === false) throw new TypeError('Failed to construct \'Promise\': Please use the \'new\' operator, this object constructor cannot be called as a function.');
	
	    this.then_ = [];
	
	    invokeResolver(resolver, this);
	  }
	
	  Promise.prototype = {
	    constructor: Promise,
	
	    state_: PENDING,
	    then_: null,
	    data_: undefined,
	
	    then: function then(onFulfillment, onRejection) {
	      var subscriber = {
	        owner: this,
	        then: new this.constructor(NOOP),
	        fulfilled: onFulfillment,
	        rejected: onRejection
	      };
	
	      if (this.state_ === FULFILLED || this.state_ === REJECTED) {
	        // already resolved, call callback async
	        asyncCall(invokeCallback, subscriber);
	      } else {
	        // subscribe
	        this.then_.push(subscriber);
	      }
	
	      return subscriber.then;
	    },
	
	    'catch': function _catch(onRejection) {
	      return this.then(null, onRejection);
	    }
	  };
	
	  Promise.all = function (promises) {
	    var Class = this;
	
	    if (!isArray(promises)) throw new TypeError('You must pass an array to Promise.all().');
	
	    return new Class(function (resolve, reject) {
	      var results = [];
	      var remaining = 0;
	
	      function resolver(index) {
	        remaining++;
	        return function (value) {
	          results[index] = value;
	          if (! --remaining) resolve(results);
	        };
	      }
	
	      for (var i = 0, promise; i < promises.length; i++) {
	        promise = promises[i];
	
	        if (promise && typeof promise.then === 'function') promise.then(resolver(i), reject);else results[i] = promise;
	      }
	
	      if (!remaining) resolve(results);
	    });
	  };
	
	  Promise.race = function (promises) {
	    var Class = this;
	
	    if (!isArray(promises)) throw new TypeError('You must pass an array to Promise.race().');
	
	    return new Class(function (resolve, reject) {
	      for (var i = 0, promise; i < promises.length; i++) {
	        promise = promises[i];
	
	        if (promise && typeof promise.then === 'function') promise.then(resolve, reject);else resolve(promise);
	      }
	    });
	  };
	
	  Promise.resolve = function (value) {
	    var Class = this;
	
	    if (value && typeof value === 'object' && value.constructor === Class) return value;
	
	    return new Class(function (resolve) {
	      resolve(value);
	    });
	  };
	
	  Promise.reject = function (reason) {
	    var Class = this;
	
	    return new Class(function (resolve, reject) {
	      reject(reason);
	    });
	  };
	})(typeof window != 'undefined' ? window : typeof global != 'undefined' ? global : typeof self != 'undefined' ? self : undefined);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(20).setImmediate))

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function () {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function () {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout = exports.clearInterval = function (timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function () {};
	Timeout.prototype.close = function () {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function (item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function (item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function (item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout) item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(21);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {"use strict";
	
	(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	        // Callback can either be a function or a string
	        if (typeof callback !== "function") {
	            callback = new Function("" + callback);
	        }
	        // Copy function arguments
	        var args = new Array(arguments.length - 1);
	        for (var i = 0; i < args.length; i++) {
	            args[i] = arguments[i + 1];
	        }
	        // Store and register the task
	        var task = { callback: callback, args: args };
	        tasksByHandle[nextHandle] = task;
	        registerImmediate(nextHandle);
	        return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	            case 0:
	                callback();
	                break;
	            case 1:
	                callback(args[0]);
	                break;
	            case 2:
	                callback(args[0], args[1]);
	                break;
	            case 3:
	                callback(args[0], args[1], args[2]);
	                break;
	            default:
	                callback.apply(undefined, args);
	                break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function (handle) {
	            process.nextTick(function () {
	                runIfPresent(handle);
	            });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function () {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function onGlobalMessage(event) {
	            if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function (handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function (event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function (handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function (handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function (handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if (({}).toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	})(typeof self === "undefined" ? typeof global === "undefined" ? undefined : global : self);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(22)))

/***/ },
/* 22 */
/***/ function(module, exports) {

	// shim for using process in browser
	'use strict';
	
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout() {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	})();
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e) {
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e) {
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while (len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () {
	    return '/';
	};
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function () {
	    return 0;
	};

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	
	//Module Imports
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK Tooltip : Content must be defined and set to a DOM selector or Node"]
	}, {
	    setting: "toolTipText",
	    isRequired: false,
	    validate: "type", //a type or a value
	    possibleValues: ["string"],
	    errorMessage: ["GDK Tooltip : toolTipText must be set to a string"]
	}, {
	    setting: "toolTipOpen",
	    isRequired: false,
	    validate: "type", //a type or a value
	    possibleValues: ["function"],
	    errorMessage: ["GDK Tooltip : toolTipOpen must be defined and set function"]
	}, {
	    setting: "toolTipClose",
	    isRequired: false,
	    validate: "type", //a type or a value
	    possibleValues: ["function"],
	    errorMessage: ["GDK Tooltip : toolTipClose must be defined and set function"]
	}];
	
	var Tooltip = (function () {
	    /**
	     * Refer to the design kit section of this component for JS examples and setting details.
	     * @param {string, Object} content
	     *  A reference to the html Tooltip trigger's node
	     *
	     * @param {string} [toolTipText]
	     * Callback function fired once a 'filter-submit' is clicked
	     *
	     * @param {function} [toolTipOpen]
	     * A callback function triggered when a tooltip is displayed
	     *
	     * @param {function} [toolTipClose]
	     * A callback function triggered when a tooltip is closed manually
	     *
	     */
	
	    function Tooltip(options) {
	        _classCallCheck(this, Tooltip);
	
	        this._internalVars = {
	            node: null, //used for content item
	            toolTip: null,
	
	            triggerOffset: null,
	            timeout: null,
	            delay: 300, // delay 0.3 seconds
	            breakpoint: 768,
	            margin: 12,
	            wrapperElementId: "wrapper",
	            toolTiplElementClass: "tooltip",
	            toolTipTriggerElementClass: "tooltip-trigger",
	            toolTipCloseElementClass: "icon-close-20",
	            toolTipActiveClass: "tooltip--active",
	            wrapper: null,
	            closeBtn: null
	        };
	
	        //options with defaults set
	        this._defaults = {
	            toolTipText: null
	        };
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2["default"].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2["default"].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2["default"].getContentType(this);
	            setLocalVars.call(this);
	            setEvents.call(this);
	        }
	    }
	
	    // Private Methods
	    /**
	     * setLocalVars()
	     * set all the local vars to passed in options
	     */
	
	    //Public Methods
	
	    /**
	     * destroy()
	     * removes the node from the dom and any events attached
	     */
	
	    _createClass(Tooltip, [{
	        key: "destroy",
	        value: function destroy() {
	            removeEvents.call(this);
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	            this._internalVars.toolTip.parentNode.removeChild(this._internalVars.toolTip);
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return Tooltip;
	})();
	
	function setLocalVars() {
	    //determine the type of content passed in
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    if (this._options.toolTipText === null) {
	        this._internalVars.toolTip = document.querySelector("#" + this._internalVars.node.getAttribute('data-tooltip-view'));
	        this._internalVars.node.parentNode.insertBefore(this._internalVars.toolTip, this._internalVars.node.nextSibling);
	        var divFocus = document.createElement("div"); // Create a <button> element
	        divFocus.setAttribute("tabindex", 0);
	        divFocus.classList.add(this._internalVars.node.getAttribute('data-tooltip-view'));
	        this._internalVars.node.parentNode.appendChild(divFocus);
	    } else {
	        buildNewTooltip.call(this);
	    }
	
	    this._internalVars.wrapper = document.querySelector("#" + this._internalVars.wrapperElementId);
	    this._internalVars.closeBtn = this._internalVars.toolTip.querySelector("." + this._internalVars.toolTipCloseElementClass);
	    this._internalVars.toolTipClass = 'tooltip';
	}
	
	/**
	 * setEvents()
	 * Sets all the events needed for the component
	 */
	function setEvents() {
	    if ("ontouchstart" in document.documentElement) {
	        this._internalVars.node.addEventListener("touchstart", showToolTip.bind(this));
	        this._internalVars.closeBtn.addEventListener("touchstart", closeBtnClickHandler.bind(this));
	    } else {
	        this._internalVars.node.addEventListener("mouseenter", showToolTip.bind(this));
	        this._internalVars.node.addEventListener("click", function (e) {
	            e.preventDefault();
	        });
	        this._internalVars.node.addEventListener("focus", showToolTip.bind(this));
	        this._internalVars.closeBtn.addEventListener("keypress", movetoNextFocus.bind(this, this._internalVars.closeBtn));
	        this._internalVars.closeBtn.addEventListener("click", closeBtnClickHandler.bind(this));
	    }
	}
	
	function movetoNextFocus(hi) {
	    console.log(hi.parentNode.parentNode);
	    hi.parentNode.parentNode.querySelector("." + this._internalVars.node.getAttribute('data-tooltip-view')).focus();
	}
	
	/**
	 * removeEvents()
	 * removes all events from the component
	 */
	function removeEvents() {
	    if ("ontouchstart" in document.documentElement) {
	        this._internalVars.node.removeEventListener("touchstart", showToolTip.bind(this));
	        this._internalVars.closeBtn.removeEventListener("touchstart", closeBtnClickHandler.bind(this));
	    } else {
	        this._internalVars.node.removeEventListener("mouseenter", showToolTip.bind(this));
	        this._internalVars.closeBtn.removeEventListener("click", closeBtnClickHandler.bind(this));
	    }
	}
	
	/**
	 * closeBtnClickHandler()
	 * catches click on close button
	 */
	function closeBtnClickHandler(e) {
	    console.log("closeBtnClickHandler");
	    e.preventDefault();
	    hideToolTip.call(this);
	
	    if (this._options.toolTipClose) {
	        var tooltip = e.currentTarget.parentNode;
	        this._options.toolTipClose(tooltip);
	    }
	}
	
	/**
	 * buildNewTooltip()
	 * use to dynamically create the tooltip
	 */
	function buildNewTooltip() {
	    var toolTipId = this._internalVars.node.getAttribute('data-tooltip-view');
	
	    var dynamicToolTip = document.createElement('div');
	    dynamicToolTip.setAttribute('id', toolTipId);
	    dynamicToolTip.classList.add("tooltip");
	    dynamicToolTip.innerHTML = '<div tabindex="0">' + this._options.toolTipText + '</div><button class="icon-close-20" aria-label="Close tooltip"></button>';
	
	    this._internalVars.node.parentNode.insertBefore(dynamicToolTip, this._internalVars.node.nextSibling);
	    this._internalVars.toolTip = document.querySelector("#" + toolTipId);
	    var divFocus = document.createElement("div"); // Create a <button> element
	    divFocus.setAttribute("tabindex", 0);
	    divFocus.classList.add(this._internalVars.node.getAttribute('data-tooltip-view'));
	    this._internalVars.node.parentNode.appendChild(divFocus);
	}
	
	/**
	 * showToolTip()
	 * show tooltip on hover
	 */
	function showToolTip(e) {
	    var _this = this;
	
	    e.preventDefault();
	    try {
	        hideToolTip.call(this);
	    } catch (err) {
	        // clear existing tt
	    }
	
	    clearTimeout(this._internalVars.timeout);
	    var self = e.currentTarget;
	
	    self.classList.add(this._internalVars.toolTipActiveClass);
	
	    this._internalVars.activationArea = self;
	
	    self.addEventListener("mouseleave", settimeout.bind(this));
	
	    this._internalVars.toolTip.addEventListener("mouseleave", settimeout.bind(this));
	
	    this._internalVars.toolTip.addEventListener("mouseenter", cleartimeout.bind(this));
	
	    this._internalVars.triggerOffset = self.getBoundingClientRect();
	
	    setTimeout(function () {
	        if (self.classList.contains("tooltip--active")) {
	            _this._internalVars.toolTip.style.display = "block";
	            //position the tooltip after setting to block
	            positionToolTip.call(_this);
	            //set opacity and let css transition fade it in
	            _this._internalVars.toolTip.style.opacity = 1;
	        }
	    }, this._internalVars.delay);
	
	    if (this._options.toolTipOpen) {
	        var triggerElement = e.currentTarget.parentNode,
	            tooltip = triggerElement.querySelector('.' + this._internalVars.toolTipClass);
	        this._options.toolTipOpen(tooltip);
	    }
	}
	
	/**
	 * cleartimeout()
	 * clears set timeout
	 */
	function cleartimeout(e) {
	    clearTimeout(this._internalVars.timeout);
	}
	
	/**
	 * settimeout()
	 * sets a timeout to hide the tooltip
	 */
	function settimeout(e) {
	    clearTimeout(this._internalVars.timeout);
	    this._internalVars.node.classList.remove(this._internalVars.toolTipActiveClass);
	    this._internalVars.timeout = setTimeout(hideToolTip.bind(this), 1000);
	}
	
	/**
	 * hideToolTip()
	 * hides the tooltip
	 */
	function hideToolTip() {
	    var _this2 = this;
	
	    this._internalVars.toolTip.style.opacity = 0;
	
	    setTimeout(function () {
	        _this2._internalVars.toolTip.style.display = "none";
	    }, this._internalVars.delay);
	}
	
	/**
	 * positionToolTip()
	 * sets the position for the tooltip depending on trigger position
	 */
	function positionToolTip() {
	    this._internalVars.toolTip.classList.remove("arrow-right");
	    this._internalVars.toolTip.classList.remove("arrow-bottom");
	
	    var winWidth = document.body.clientWidth;
	    var winHeight = window.innerHeight || document.documentElement.clientHeight;
	    var containerOffset = this._internalVars.wrapper.getBoundingClientRect();
	    var containerOffsetLeft = containerOffset.left;
	    var containerWidth = this._internalVars.wrapper.offsetWidth;
	    var tooltipWidth = this._internalVars.toolTip.offsetWidth;
	    var tooltipHeight = this._internalVars.toolTip.offsetHeight;
	    var xpos = null;
	    var ypos = null;
	
	    if (winWidth < this._internalVars.breakpoint) {
	        ypos = 25;
	        if (this._internalVars.triggerOffset.left - containerOffsetLeft + tooltipWidth < containerWidth) {
	            xpos = 0;
	        } else {
	            xpos = -(this._internalVars.triggerOffset.left - containerOffsetLeft + tooltipWidth - containerWidth + 10);
	        }
	    } else {
	        xpos = 40;
	        ypos = -15;
	        if (this._internalVars.triggerOffset.left - containerOffsetLeft + tooltipWidth + 50 < containerWidth) {
	            xpos = 40;
	            ypos = -15;
	        } else {
	            xpos = -(this._internalVars.triggerOffset.left - containerOffsetLeft + tooltipWidth - containerWidth + tooltipWidth + 20);
	            this._internalVars.toolTip.classList.add("arrow-right");
	        }
	    }
	
	    this._internalVars.toolTip.style.left = xpos + "px";
	    this._internalVars.toolTip.style.top = ypos + "px";
	}
	
	exports["default"] = Tooltip;
	module.exports = exports["default"];

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	
	//Module Imports
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK Loader : Content must be defined and set to a DOM selector or Node"]
	}, {
	    setting: "type",
	    isRequired: false,
	    validate: "value",
	    possibleValues: ["inline", "section", "inline--xsmall"],
	    errorMessage: ["GDK Loader : Type must be defined and set to inline or section"]
	}, {
	    setting: "autoShow",
	    isRequired: false,
	    validate: "type",
	    possibleValues: ["boolean"],
	    errorMessage: ["GDK Loader : autoShow must be a boolean"]
	}];
	
	var loaderLargeSVG = "\n    <svg class=\"circle-loader\" width=\"62\" height=\"62\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\">\n        <circle cx=\"31\" cy=\"31\" r=\"29\">\n    </svg>\n    <span class=\"geico-icon icon-loader-g\" style=\"width: 60px; height: 60px; line-height: 60px; font-size: 30px;\"></span>\n";
	
	var loaderSmallSVG = "\n    <svg class=\"circle-loader\" width=\"32\" height=\"32\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\">\n        <circle cx=\"16\" cy=\"16\" r=\"15\">\n    </svg>\n";
	
	var loaderXSmallSVG = "\n    <svg class=\"circle-loader\" width=\"20\" height=\"20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\">\n        <circle cx=\"10\" cy=\"10\" r=\"9\">\n    </svg>\n";
	
	var Loader = (function () {
	    /**
	     * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	     * @param {string|Object} content
	     * A reference to the loader. If the loader type is a section loader this should be a reference to the loader-container. If the loader type is a inline loader this should be a reference to the loader itself.
	     *
	     * @param {string} type
	     * Used to determine the type of loader. Options: "inline" || "section"
	     *
	     * @param {boolean} [autoShow=false]
	     * Use if you want to set loader to auto show when instantiated
	     *
	     */
	
	    function Loader(options) {
	        _classCallCheck(this, Loader);
	
	        this._internalVars = {
	            node: null, //used for current node
	            loaderDom: null, //stores reference to the loader when using a section loader
	            tick: 0,
	            loaderShouldPlay: false,
	            loaderSVG: null,
	            loaderG: null
	        };
	
	        //options with defaults set
	        this._defaults = {
	            autoShow: false
	        };
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2["default"].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2["default"].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2["default"].getContentType(this);
	            setLocalVars.call(this);
	            buildLoader.call(this);
	
	            if (this._options.autoShow) {
	                this.show();
	            }
	        }
	    }
	
	    /**
	    * setLocalVars()
	    * set all the local vars to passed in options
	    */
	
	    //Public Methods
	
	    /**
	    * show()
	    * plays and animates loader
	    */
	
	    _createClass(Loader, [{
	        key: "show",
	        value: function show() {
	            var _this = this;
	
	            this._internalVars.node.style.display = "block";
	            setTimeout(function () {
	
	                if (_this._options.type === "section") {
	                    _this._internalVars.node.classList.add("section-loader--show");
	                    _this._internalVars.loaderDom.classList.add("loader--play");
	                } else {
	                    _this._internalVars.node.classList.add("inline-loader--show");
	                    _this._internalVars.node.classList.add("loader--play");
	                }
	
	                _this._internalVars.loaderShouldPlay = true;
	                loaderAnim.call(_this);
	            }, 10);
	        }
	
	        /**
	        * hide()
	        * hides and stops the loader
	        */
	    }, {
	        key: "hide",
	        value: function hide() {
	            var _this2 = this;
	
	            if (this._options.type === "section") {
	                this._internalVars.node.classList.remove("section-loader--show");
	            } else {
	                this._internalVars.node.classList.remove("inline-loader--show");
	            }
	
	            setTimeout(function () {
	                _this2._internalVars.node.style.display = "none";
	
	                if (_this2._options.type === "section") {
	                    _this2._internalVars.loaderDom.classList.remove("loader--play");
	                } else {
	                    _this2._internalVars.node.classList.remove("loader--play");
	                }
	
	                _this2._internalVars.loaderShouldPlay = false;
	            }, 500);
	        }
	
	        /**
	        * destroy()
	        * removes the node from the dom and any events attached
	        */
	    }, {
	        key: "destroy",
	        value: function destroy() {
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return Loader;
	})();
	
	function setLocalVars() {
	    //determine the type of content passed in
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    //if its a section loader find the loader
	    if (this._options.type === "section") {
	        this._internalVars.loaderDom = this._internalVars.node.querySelector(".loader");
	        this._internalVars.loaderDom.style.width = "60px";
	        this._internalVars.loaderDom.style.height = "60px";
	        this._internalVars.loaderDom.style.lineHeight = "60px";
	        this._internalVars.loaderDom.style.fontSize = "60px";
	    }
	}
	
	/**
	* buildLoader()
	* Adds markup and classes this component
	*/
	function buildLoader() {
	
	    if (this._options.type === "section") {
	        this._internalVars.loaderDom.classList.add("loader--large");
	        this._internalVars.loaderDom.insertAdjacentHTML('afterBegin', loaderLargeSVG);
	
	        this._internalVars.dashOffsetEnd = 180;
	        this._internalVars.dashArrayComplete = 183;
	        this._internalVars.dashArrayEnd = 153;
	        this._internalVars.tickSpeed = 1;
	    } else if (this._options.type === "inline") {
	        this._internalVars.node.classList.add("loader--small");
	        this._internalVars.node.insertAdjacentHTML('afterBegin', loaderSmallSVG);
	
	        this._internalVars.dashOffsetEnd = 92;
	        this._internalVars.dashArrayComplete = 95;
	        this._internalVars.dashArrayEnd = 153;
	        this._internalVars.tickSpeed = 1.5;
	    } else if (this._options.type === "inline--xsmall") {
	        this._internalVars.node.classList.add("loader--small");
	        this._internalVars.node.insertAdjacentHTML('afterBegin', loaderXSmallSVG);
	
	        this._internalVars.dashOffsetEnd = 62;
	        this._internalVars.dashArrayComplete = 65;
	        this._internalVars.dashArrayEnd = 153;
	        this._internalVars.tickSpeed = 1.5;
	    }
	
	    this._internalVars.loaderSVG = this._internalVars.node.querySelector(".circle-loader");
	}
	
	function loaderAnim() {
	    this._internalVars.tick += this._internalVars.tickSpeed;
	
	    if (this._internalVars.tick > 100) {
	        this._internalVars.tick = 0;
	    }
	
	    var t = this._internalVars.tick / 100;
	    var offsetStrokeDashOffset = easeInCubic(t, 0, -this._internalVars.dashOffsetEnd, 1);
	    var offsetStrokeDasharray = easeInCubic(t, 0, this._internalVars.dashArrayEnd, 1);
	
	    this._internalVars.loaderSVG.style.strokeDashoffset = offsetStrokeDashOffset;
	    this._internalVars.loaderSVG.style.strokeDasharray = offsetStrokeDasharray + " , " + this._internalVars.dashArrayComplete;
	
	    if (this._internalVars.loaderShouldPlay) {
	        requestAnimationFrame(loaderAnim.bind(this));
	    }
	}
	
	/**
	* easeInQuad()
	* Quadratic easing
	*/
	function easeInQuad(t, b, c, d) {
	    var ts = (t /= d) * t;
	    return b + c * ts;
	}
	/**
	* easeInCubic()
	* Cubic easing
	*/
	function easeInCubic(t, b, c, d) {
	    var ts = (t /= d) * t * t;
	    return b + c * ts;
	}
	
	exports["default"] = Loader;
	module.exports = exports["default"];

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	
	//Module Imports
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK ButtonSwitch : Content must be defined and set to a DOM selector or Node"]
	}, {
	    setting: "initialActiveSide",
	    isRequired: false,
	    validate: "value", //a type or a value
	    possibleValues: ["left", "right"],
	    errorMessage: ["GDK ButtonSwitch : initialActiveSide must be set to left or right"]
	}, {
	    setting: "leftSideClicked",
	    isRequired: false,
	    validate: "type",
	    possibleValues: ["function"],
	    errorMessage: ["GDK ButtonSwitch : leftSideClicked must be a function"]
	}, {
	    setting: "rightSideClicked",
	    isRequired: false,
	    validate: "type",
	    possibleValues: ["function"],
	    errorMessage: ["GDK ButtonSwitch : rightSideClicked must be a function"]
	}];
	
	var ButtonSwitch = (function () {
	    /**
	     * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	     * @param {string|Object} content
	     * A reference to the button node to switch
	     *
	     * @param {string} [initialActiveSide="left"]
	     * Used to designate which side of the button is initially active. Options: "left" || "right"
	     *
	     * @param {function} [leftSideClicked]
	     * A callback function that gets fired when the left side of the button is clicked
	     *
	     * @param {function} [rightSideClicked]
	     * A callback function that gets fired when the left side of the button is clicked
	     */
	
	    function ButtonSwitch(options) {
	        _classCallCheck(this, ButtonSwitch);
	
	        this._internalVars = {
	            node: null, //used for content item
	            left: null, //clickable node on the left side of the button
	            right: null, //clickable node on the right side of the button
	            sideOptions: ["left", "right"],
	            side: null
	        };
	
	        //options with defaults set
	        this._defaults = {
	            initialActiveSide: this._internalVars.sideOptions[0]
	        };
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2["default"].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2["default"].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2["default"].getContentType(this);
	            setLocalVars.call(this);
	            setEvents.call(this);
	            if (!this._internalVars.node.getAttribute('tabindex')) this._internalVars.node.setAttribute('tabindex', '0');
	
	            this._internalVars.node.setAttribute('role', 'checkbox');
	        }
	    }
	
	    // Private Methods
	    /**
	     * setEvents()
	     * Sets all the events needed for the component
	     */
	
	    //Public Methods
	    /**
	     * currentSide()
	     * returns the side the switch button is currently on
	     * @returns {string} "left" | "right"
	     */
	
	    _createClass(ButtonSwitch, [{
	        key: "currentSide",
	        value: function currentSide() {
	            return this._internalVars.side;
	        }
	
	        /**
	         * slideLeft()
	         * invokes a click on the left side of the switch button
	         */
	    }, {
	        key: "slideLeft",
	        value: function slideLeft() {
	            if (this._internalVars.node.classList.contains("button-switch--slide-right")) {
	                this._internalVars.node.classList.remove("button-switch--slide-right");
	                switchLeft.call(this);
	            } else if (this._internalVars.node.classList.contains("button-switch--start-right") && !this._internalVars.node.classList.contains("button-switch--slide-right") && !this._internalVars.node.classList.contains("button-switch--slide-left")) {
	                switchLeft.call(this);
	            }
	        }
	
	        /**
	         * slideRight()
	         * invokes a click on the right side of the switch button
	         */
	    }, {
	        key: "slideRight",
	        value: function slideRight() {
	            if (this._internalVars.node.classList.contains("button-switch--slide-left")) {
	                this._internalVars.node.classList.remove("button-switch--slide-left");
	                switchRight.call(this);
	            } else if (this._internalVars.node.classList.contains("button-switch--start-left") && !this._internalVars.node.classList.contains("button-switch--slide-right") && !this._internalVars.node.classList.contains("button-switch--slide-left")) {
	                switchRight.call(this);
	            }
	        }
	
	        /**
	         * destroy()
	         * removes the node from the dom and any events attached
	         */
	    }, {
	        key: "destroy",
	        value: function destroy() {
	            removeEvents.call(this);
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return ButtonSwitch;
	})();
	
	function setEvents() {
	    var eventName = "click";
	    if ("ontouchstart" in document.documentElement) {
	        eventName = "touchstart";
	    }
	
	    this._internalVars.node.addEventListener(eventName, this._internalVars.handler);
	    this._internalVars.node.addEventListener("keyup", this._internalVars.handler);
	}
	
	/**
	 * removeEvents()
	 * removes all events from the component
	 */
	function removeEvents() {
	    var eventName = "click";
	    if ("ontouchstart" in document.documentElement) {
	        eventName = "touchstart";
	    }
	
	    this._internalVars.node.removeEventListener(eventName, this._internalVars.handler);
	}
	
	/**
	 * switchClick()
	 * if you click on button it will switch
	 */
	function switchClick(e) {
	    if (e.type == 'keypress' || e.type == 'keyup' && (e.keyCode || e.which) != 13) {
	        return;
	    }
	
	    if (this._internalVars.node.classList.contains('disabled')) {
	        return;
	    }
	    if (this._internalVars.node.classList.contains("button-switch--slide-right")) {
	        this._internalVars.node.classList.remove("button-switch--slide-right");
	        switchLeft.call(this);
	    } else if (this._internalVars.node.classList.contains("button-switch--slide-left")) {
	        this._internalVars.node.classList.remove("button-switch--slide-left");
	        switchRight.call(this);
	    }
	
	    if (this._internalVars.node.classList.contains("button-switch--start-left") && !this._internalVars.node.classList.contains("button-switch--slide-right") && !this._internalVars.node.classList.contains("button-switch--slide-left")) {
	        switchRight.call(this);
	    } else if (this._internalVars.node.classList.contains("button-switch--start-right") && !this._internalVars.node.classList.contains("button-switch--slide-right") && !this._internalVars.node.classList.contains("button-switch--slide-left")) {
	        switchLeft.call(this);
	    }
	}
	
	function switchLeft() {
	    this._internalVars.node.classList.add("button-switch--slide-left");
	    this._internalVars.side = this._internalVars.sideOptions[0];
	    this._internalVars.node.setAttribute('aria-checked', 'false');
	    if (this._options.leftSideClicked) this._options.leftSideClicked();
	}
	
	function switchRight() {
	    this._internalVars.node.classList.add("button-switch--slide-right");
	    this._internalVars.side = this._internalVars.sideOptions[1];
	    this._internalVars.node.setAttribute('aria-checked', 'true');
	    if (this._options.rightSideClicked) this._options.rightSideClicked();
	}
	
	/**
	 * setLocalVars()
	 * set all the local vars to passed in options
	 */
	function setLocalVars() {
	    //determine the type of content passed in
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    //get the child spans to add click events too
	    var spans = this._internalVars.node.querySelectorAll("span");
	    this._internalVars.left = spans[0];
	    this._internalVars.right = spans[1];
	
	    //init the current side and add the class
	    this._internalVars.side = this._options.initialActiveSide.toLowerCase();
	    //check for right else use the default left
	    if (this._internalVars.side === this._internalVars.sideOptions[1]) {
	        this._internalVars.node.classList.add("button-switch--start-right");
	        this._internalVars.node.setAttribute('aria-checked', 'true');
	    } else {
	        this._internalVars.node.classList.add("button-switch--start-left");
	        this._internalVars.node.setAttribute('aria-checked', 'false');
	    }
	
	    this._internalVars.handler = switchClick.bind(this);
	}
	
	exports["default"] = ButtonSwitch;
	module.exports = exports["default"];

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	
	//Module Imports
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
		setting: "content",
		isRequired: true,
		validate: "type", //a type or a value
		possibleValues: ["string", "object"],
		errorMessage: ["GDK TextareaCountdown : Content must be defined and set to a DOM selector or Node"]
	}, {
		setting: "countdownMax",
		isRequired: false,
		validate: "type", //a type or a value
		possibleValues: ["number"],
		errorMessage: ["GDK TextareaCountdown : countdownMax must be a number"]
	}];
	
	var TextareaCountdown = (function () {
		/**
	  * Refer to the design kit section of this component for JS examples and setting details.
	  * @param {string, Object} content
	  * A reference to the html textarea container node
	  *
	  * @param {number} [countdownMax=1000]
	  * The number of characters allowed in the textarea
	  *
	  */
	
		function TextareaCountdown(options) {
			_classCallCheck(this, TextareaCountdown);
	
			this._internalVars = {
				node: null, //used for content item
				geicoTextAreaCountdownContainerClass: "textarea-countdown-container",
				geicoTextAreaCountdownClass: "textarea-countdown",
				geicoTextAreaGoodClass: "textarea-countdown--good",
				geicoTextAreaCloseClass: "textarea-countdown--close",
				geicoTextAreaOverClass: "textarea-countdown--over",
				geicoTextAreaCountdownInfoClass: "textarea-countdown-info",
				geicoTextAreaCountdownInfoTextClass: "textarea-countdown-info-text",
				geicoTextAreaCountdownInfoCounterClass: "textarea-countdown-info-counter",
				geicoTextGoodCopy: "Good to go.",
				geicoTextCloseCopy: "Near the edge.",
				geicoTextOverCopy: "Over by",
				closeNum: 10,
				geicoTextAreaCountdownData: null,
				count: null
			};
	
			//options with defaults set
			this._defaults = {
				countdownMax: 1000
			};
	
			// Create options by extending defaults with the passed in arugments
			if (options && typeof options === "object") {
				this._options = _baseComponent2["default"].extendDefaults(this._defaults, options);
			}
	
			//if the required options are valid set up the environment
			if (_baseComponent2["default"].validateSettings(this._options, validateSettings)) {
				this._internalVars.contentType = _baseComponent2["default"].getContentType(this);
				setLocalVars.call(this);
				setEvents.call(this);
			}
		}
	
		// Private Methods
		/**
	  * setEvents()
	  * Sets all the events needed for the component
	  */
	
		//Public Methods
	
		/**
	  * destroy()
	  * removes the node from the dom and any events attached
	  */
	
		_createClass(TextareaCountdown, [{
			key: "destroy",
			value: function destroy() {
				removeEvents.call(this);
				this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
				//a little garbage collection
				for (var variableKey in this) {
					if (this.hasOwnProperty(variableKey)) {
						delete this[variableKey];
					}
				}
			}
		}]);
	
		return TextareaCountdown;
	})();
	
	function setEvents() {
		this._internalVars.textArea.addEventListener("change", this._internalVars.handler);
		this._internalVars.textArea.addEventListener("keyup", this._internalVars.handler);
		this._internalVars.textArea.addEventListener("keydown", this._internalVars.handler);
		this._internalVars.textArea.addEventListener("blur", this._internalVars.handler);
		this._internalVars.textArea.addEventListener("paste", pasteHandler);
	}
	
	/**
	 * removeEvents()
	 * removes all events from the component
	 */
	function removeEvents() {
		this._internalVars.textArea.removeEventListener("change", this._internalVars.handler);
		this._internalVars.textArea.removeEventListener("keyup", this._internalVars.handler);
		this._internalVars.textArea.removeEventListener("keydown", this._internalVars.handler);
		this._internalVars.textArea.removeEventListener("blur", this._internalVars.handler);
		this._internalVars.textArea.removeEventListener("paste", pasteHandler);
	}
	
	/**
	 * pasteHandler()
	 * triggers a keydown event on paste
	 */
	function pasteHandler(evt) {
		var _this = evt.currentTarget;
		setTimeout(function () {
			var event = document.createEvent('HTMLEvents');
			event.initEvent('keydown', true, false);
			_this.dispatchEvent(event);
		}, 10);
	}
	
	/**
	 * updateCountdown()
	 * updates the countdown text and counter
	 */
	function updateCountdown(evt) {
		var _this = evt.currentTarget;
		var container = _this.parentNode;
		var text = _this.value;
		var remaining = this._options.countdownMax - text.length;
	
		if (remaining < 0) {
	
			this._internalVars.countdownInfoText.textContent = this._internalVars.geicoTextOverCopy;
			this._internalVars.countdownInfoTextCurrent = this._internalVars.geicoTextOverCopy;
			container.classList.remove(this._internalVars.geicoTextAreaCloseClass);
			container.classList.add(this._internalVars.geicoTextAreaOverClass);
		} else if (remaining < 10) {
	
			this._internalVars.countdownInfoText.textContent = this._internalVars.geicoTextCloseCopy;
			this._internalVars.countdownInfoTextCurrent = this._internalVars.geicoTextCloseCopy;
			container.classList.remove(this._internalVars.geicoTextAreaGoodClass);
			container.classList.remove(this._internalVars.geicoTextAreaOverClass);
			container.classList.add(this._internalVars.geicoTextAreaCloseClass);
		} else if (this._internalVars.countdownInfoTextCurrent === this._internalVars.geicoTextCloseCopy || this._internalVars.countdownInfoTextCurrent === this._internalVars.geicoTextOverCopy) {
	
			this._internalVars.countdownInfoText.textContent = this._internalVars.geicoTextGoodCopy;
			this._internalVars.countdownInfoTextCurrent = this._internalVars.geicoTextGoodCopy;
			container.classList.remove(this._internalVars.geicoTextAreaCloseClass);
			container.classList.remove(this._internalVars.geicoTextAreaOverClass);
			container.classList.add(this._internalVars.geicoTextAreaGoodClass);
		}
	
		updateRemaining.call(this, remaining, text.length, this._options.countdownMax, this._internalVars.countdownInfoCounter);
	}
	
	/**
	 * updateRemaining()
	 * updates the remaining characters left
	 */
	function updateRemaining(remaining, tl, countdown, countdownInfoCounter) {
		var val = remaining;
	
		if (remaining === 0) val = 0;else if (remaining < 0) val = tl - countdown;
	
		countdownInfoCounter.textContent = val;
	}
	
	/**
	 * setLocalVars()
	 * set all the local vars to passed in options
	 */
	function setLocalVars() {
		//determine the type of content passed in
		if (this._internalVars.contentType === 'string') {
			this._internalVars.node = document.querySelector(this._options.content);
		} else if (this._internalVars.contentType === 'domNode') {
			this._internalVars.node = this._options.content;
		}
	
		//node to hold status text
		var infoText = document.createElement("SPAN");
		infoText.classList.add(this._internalVars.geicoTextAreaCountdownInfoTextClass);
	
		//node to hold count of characters left
		var infoCounter = document.createElement("SPAN");
		infoCounter.classList.add(this._internalVars.geicoTextAreaCountdownInfoCounterClass);
	
		//node to hold count of characters left
		var countdownInfo = document.createElement("DIV");
		countdownInfo.classList.add(this._internalVars.geicoTextAreaCountdownInfoClass);
		countdownInfo.setAttribute('aria-live', 'polite');
		countdownInfo.setAttribute('aria-atomic', 'true');
	
		//add the text and counter to the container
		countdownInfo.appendChild(infoText);
		countdownInfo.appendChild(infoCounter);
	
		//append the container to the node
		this._internalVars.node.appendChild(countdownInfo);
		//set initial class for container
		this._internalVars.node.classList.add(this._internalVars.geicoTextAreaGoodClass);
	
		//get access to the textarea, counter and counter info for future reference
		this._internalVars.textArea = this._internalVars.node.querySelector("." + this._internalVars.geicoTextAreaCountdownClass);
		this._internalVars.countdownInfoText = this._internalVars.node.querySelector("." + this._internalVars.geicoTextAreaCountdownInfoTextClass);
		this._internalVars.countdownInfoCounter = this._internalVars.node.querySelector("." + this._internalVars.geicoTextAreaCountdownInfoCounterClass);
		this._internalVars.countdownInfoTextCurrent = this._internalVars.geicoTextGoodCopy;
	
		this._internalVars.countdownInfoCounter.textContent = this._options.countdownMax;
		this._internalVars.countdownInfoText.textContent = this._internalVars.countdownInfoTextCurrent;
	
		this._internalVars.handler = updateCountdown.bind(this);
	}
	
	exports["default"] = TextareaCountdown;
	module.exports = exports["default"];

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	
	/*
	 Problems:
	 1)      Requiring a specific ID – The code as-is requires a specific ID for the search field (code: var input = document.querySelector('#address-search-field');).  This requires that we only use 1 instance of this address autocomplete on the screen at one time and forces us to use specific IDs. I’ve complained about this pattern repeatedly over the last couple years and it still seems to be the go to solution for the design team implementations of things. (NOTE: it also requires specific IDs for each and every field of the address that directly match data coming back from google’s apis.)
	 2)      The implementation doesn’t seem to keep in mind anything related to single-page application design (regardless of technology):
	 a.       The implementation requires a global javascript function to be present at page load time.
	 b.      It presumes to know what the IDs and types of all the input fields are and auto-populates them with no ability to notify client code when this has occurred.  This screws up any kind of data binding technology (angular, knockout, etc)
	 3)      It does not seem to include Zip +4 (which it looks like the Google APIs don’t return)
	 4)      It hard codes English text (code:  message.innerHTML = 'No Results Found';)
	 5)      It watches the entire document body for changes to see if a DOM node is inserted. (code:  document.body.addEventListener('DOMNodeInserted', function (event)…).  That can’t possibly be necessary.
	
	 Questions:
	 1)      Is this supposed to be the new way all addresses are entered in the system, or just an optional component for teams to use? (did you talk to multiple teams to gather requirements or was this just implemented at the request of one team?)
	 */
	//Module Imports
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	  setting: "content",
	  isRequired: true,
	  validate: "type", //a type or a value
	  possibleValues: ["string", "object"],
	  errorMessage: ["GDK AddressAutoComplete : Content must be defined and set to a DOM selector or Node"]
	}];
	
	var ValueSelected = false;
	var selector;
	
	var AddressAutoComplete = (function () {
	  function AddressAutoComplete(options) {
	    _classCallCheck(this, AddressAutoComplete);
	
	    this._internalVars = {
	      node: null //used for content item
	    };
	
	    //options with defaults set
	    this._defaults = {};
	
	    // Create options by extending defaults with the passed in arugments
	    if (options && typeof options === "object") {
	      this._options = _baseComponent2["default"].extendDefaults(this._defaults, options);
	    }
	
	    //if the required options are valid set up the environment
	    if (_baseComponent2["default"].validateSettings(this._options, validateSettings)) {
	      if (document.querySelector(this._options.content)) {
	        selector = this._options.content;
	        this._internalVars.contentType = _baseComponent2["default"].getContentType(this);
	        setLocalVars.call(this);
	        setEvents.call(this);
	        init.call(this);
	      }
	    }
	  }
	
	  /**
	   * setLocalVars()
	   * set all the local vars to passed in options
	   */
	
	  //Public Methods
	
	  // Bias the autocomplete object to the user's geographical location,
	  // as supplied by the browser's 'navigator.geolocation' object.
	
	  _createClass(AddressAutoComplete, [{
	    key: "geolocate",
	    value: function geolocate() {
	      if (navigator.geolocation) {
	        navigator.geolocation.getCurrentPosition(function (position) {
	          var geolocation = {
	            lat: position.coords.latitude,
	            lng: position.coords.longitude
	          };
	          var circle = new google.maps.Circle({
	            center: geolocation,
	            radius: position.coords.accuracy
	          });
	          this.autoComplete.setBounds(circle.getBounds());
	        });
	      }
	    }
	  }]);
	
	  return AddressAutoComplete;
	})();
	
	function setLocalVars() {
	  try {
	    //determine the type of content passed in
	    if (this._internalVars.contentType === 'string') {
	      this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	      this._internalVars.node = this._options.content;
	    }
	    this._internalVars.addressSearchField = this._internalVars.node.querySelector('.address_search_field');
	
	    // Create the autocomplete object, restricting the search to geographical
	    // location types.
	    this.autoComplete = new google.maps.places.Autocomplete(
	    /** @type {!HTMLInputElement} */this._internalVars.addressSearchField, { types: ['geocode'] });
	    this._internalVars.componentForm = {
	      street_number: 'short_name',
	      route: 'long_name',
	      locality: 'long_name',
	      administrative_area_level_1: 'short_name',
	      country: 'long_name',
	      postal_code: 'short_name'
	    };
	  } catch (ex) {
	    return null;
	  }
	}
	
	/**
	 * setEvents()
	 * Sets all the events needed for the component
	 */
	function setEvents() {}
	
	function init() {
	
	  // When the user selects an address from the dropdown, populate the address
	  // fields in the form.
	  this.autoComplete.addListener('place_changed', fillInAddress.bind(this));
	
	  var styleInitialized = false;
	
	  if (document.querySelector(selector).querySelector('.address_search_field') !== null) {
	    document.querySelector(selector).querySelector('.address_search_field').addEventListener('blur', function (event) {
	      if (document.querySelector('.pac-container') && document.querySelector('.pac-container').children.length === 0 && event.target.value.length !== 0 && document.querySelector('.address_1').value.length === 0) {
	        document.querySelector('.address_1').value = event.target.value;
	        event.target.value = '';
	      }
	    });
	  }
	}
	
	function fillInAddress() {
	
	  console.log('new results :) ');
	
	  ValueSelected = true;
	
	  // Get the place details from the autocomplete object.
	  var place = this.autoComplete.getPlace();
	
	  // Reset All Fields
	  var address1Element = this._internalVars.node.querySelector('.address_1');
	  address1Element.value = '';
	  address1Element.disabled = false;
	  for (var component in this._internalVars.componentForm) {
	    if (component !== 'street_number' && component !== 'route' && this._internalVars.node.querySelector('.' + component) !== null) {
	      var element = this._internalVars.node.querySelector('.' + component);
	      element.value = '';
	      element.disabled = false;
	    }
	  }
	
	  // Get each component of the address from the place details
	  // and fill the corresponding field on the form.
	  for (var i = 0; i < place.address_components.length; i++) {
	    var addressType = place.address_components[i].types[0];
	    if (this._internalVars.componentForm[addressType]) {
	      var val = place.address_components[i][this._internalVars.componentForm[addressType]];
	      if (addressType === 'street_number') {
	        address1Element.value = val + ' ';
	      } else if (addressType === 'route') {
	        address1Element.value = address1Element.value + val;
	      } else {
	        this._internalVars.node.querySelector('.' + addressType).value = val;
	      }
	    }
	  }
	  document.querySelector(selector).value = '';
	}
	
	exports["default"] = AddressAutoComplete;
	module.exports = exports["default"];

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	
	//Module Imports
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var _appState = __webpack_require__(7);
	
	var _appState2 = _interopRequireDefault(_appState);
	
	var _utils = __webpack_require__(8);
	
	var utils = _interopRequireWildcard(_utils);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK DatePicker : Content must be defined and set to a DOM selector or Node"]
	}, {
	    setting: "monthYearDropdowns",
	    isRequired: false,
	    validate: "type", //a type or a value
	    possibleValues: ["boolean"],
	    errorMessage: ["GDK DatePicker : monthYearDropdowns must be set to a boolean"]
	}, {
	    setting: "dateFormatShort",
	    isRequired: false,
	    validate: "type", //a type or a value
	    possibleValues: ["boolean"],
	    errorMessage: ["GDK DatePicker : dateFormatShort must be set to a boolean"]
	}, {
	    setting: "minDate",
	    isRequired: false,
	    validate: "type", //a type or a value
	    possibleValues: ["number", "date", "string", "object"],
	    errorMessage: ["GDK DatePicker : minDate must be set to a number, date, or string"]
	}, {
	    setting: "maxDate",
	    isRequired: false,
	    validate: "type", //a type or a value
	    possibleValues: ["number", "date", "string", "object"],
	    errorMessage: ["GDK DatePicker : maxDate must be set to a number, date, or string"]
	}, {
	    setting: "showWeekends",
	    isRequired: false,
	    validate: "type", //a type or a value
	    possibleValues: ["boolean"],
	    errorMessage: ["GDK DatePicker : showWeekends must be set to a boolean"]
	}, {
	    setting: "dateSelected",
	    isRequired: false,
	    validate: "type", //a type or a value
	    possibleValues: ["function"],
	    errorMessage: ["GDK DatePicker : dateSelected must be a callback function"]
	}, {
	    setting: "disabled",
	    isRequired: false,
	    validate: "type", //a type or a value
	    possibleValues: ["boolean"],
	    errorMessage: ["GDK DatePicker : disabled must be a boolean"]
	}];
	
	/**
	 * DatePicker Class
	 */
	
	var DatePicker = (function () {
	
	    /**
	     * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	     * @param {string|Object} content
	     * A reference to the html date node
	     *
	     * @param {boolean} [monthYearDropdowns=false]
	     * Determines whether or not to show select boxes for the month and year
	     *
	     * @param {boolean} [dateFormatShort=false]
	     * Determines whether to use the short format date instead of the default long format
	     *
	     * @param {function} [dateSelected]
	     * Callback gets fired when a user selects a date
	     *
	     * @param {Date|number|string} [minDate=null]
	     * The minimum selectable date. When set to null, there is no minimum.
	     *
	     * @param {Date|number|string} [maxDate=null]
	     * The maximum selectable date. When set to null, there is no maximum.
	     *
	     * @param {boolean} [hideWeekends=false]
	     * Set to true if you would like to disable the weekends in the calender.
	     *
	     * @param {boolean} [disabled]
	     * Set to true if you would like to disable the input and calendar button.
	     *
	     */
	
	    function DatePicker(options) {
	        _classCallCheck(this, DatePicker);
	
	        this._internalVars = {
	            node: null, //used for content item
	            button: null,
	            wrapper: null,
	            wrapperElementId: "wrapper",
	            marginLeft: 15,
	            marginTopBottomLeft: 10,
	            marginTopBottomRight: 28,
	            breakpoint: 768,
	            calendarWidth: 300,
	            borderWidth: 4
	        };
	
	        //options with defaults set
	        this._defaults = {
	            monthYearDropdowns: false,
	            dateFormatShort: false,
	            minDate: null,
	            maxDate: null,
	            hideWeekends: false
	        };
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2['default'].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2['default'].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2['default'].getContentType(this);
	            setLocalVars.call(this);
	            setEvents.call(this);
	            init.call(this);
	            this._internalVars.button.setAttribute('tabindex', '-1');
	        }
	    }
	
	    /**
	     * set all the local vars to passed in options
	     */
	
	    //Public Methods
	
	    /**
	     * removes the node from the dom and any events attached
	     */
	
	    _createClass(DatePicker, [{
	        key: 'destroy',
	        value: function destroy() {
	            removeEvents.call(this);
	            $(this._internalVars.node).datepicker("destroy");
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	
	        /**
	         * Set Min Date for the DatePicker Instance
	         * @param {number|Date|string|object} minDate The starting date for the date picker instance
	         */
	    }, {
	        key: 'setMinDate',
	        value: function setMinDate(minDate) {
	            this._options.minDate = new Date(minDate);
	        }
	
	        /**
	         * Set Max Date for the DatePicker Instance
	         * @param {number|Date|string|object} maxDate The ending date for the date picker instance
	         */
	    }, {
	        key: 'setMaxDate',
	        value: function setMaxDate(maxDate) {
	            this._options.maxDate = new Date(maxDate);
	        }
	
	        /**
	         * Set Min and Max Dates for the DatePicker Instance
	         * @param {number|Date|string|object} minDate The starting date for the date picker instance
	         * @param {number|Date|string|object} maxDate The ending date for the date picker instance
	         */
	    }, {
	        key: 'setMinMaxDateLimits',
	        value: function setMinMaxDateLimits(minDate, maxDate) {
	            this._options.minDate = new Date(minDate);
	            this._options.maxDate = new Date(maxDate);
	        }
	
	        /**
	         * Disables a specific date picker
	         * @param {String} datePickerId ID of the date picker to be disabled
	         */
	    }, {
	        key: 'disableDatePicker',
	        value: function disableDatePicker() {
	            var option = 'disable';
	            datePickerState.call(this, option);
	        }
	
	        /**
	         * Enable a specif date picker
	         * @param {Object} datePickerId ID of the date picker to be enabled
	         */
	    }, {
	        key: 'enableDatePicker',
	        value: function enableDatePicker(datePickerId) {
	            var option = 'enable';
	            datePickerState.call(this, option);
	        }
	    }]);
	
	    return DatePicker;
	})();
	
	function setLocalVars() {
	
	    var _this = this;
	
	    try {
	        //determine the type of content passed in
	        if (this._internalVars.contentType === 'string') {
	            this._internalVars.node = document.querySelector(this._options.content);
	        } else if (this._internalVars.contentType === 'domNode') {
	            this._internalVars.node = this._options.content;
	        }
	
	        var dpOptions = {
	            showOtherMonths: false,
	            showOn: "button",
	            buttonText: "",
	            nextText: "",
	            prevText: "",
	            dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
	            changeMonth: false,
	            changeYear: false,
	            showOptions: { direction: "left" },
	            beforeShow: updateDatepicker.bind(this),
	            onClose: closedDatepicker.bind(this),
	            onSelect: function onSelect(dateText, inst) {
	                var date = $(this).val();
	
	                _this._internalVars.node.parentNode.classList.remove("form-field--error");
	
	                // Get all spans and remove ones bearing class "form-message"
	                var spans = _this._internalVars.node.parentNode.getElementsByTagName('span');
	                for (var e = 0; spans.length > e; e++) {
	                    if (-1 !== spans[e].className.indexOf("form-message")) {
	                        spans[e].parentNode.removeChild(spans[e]);
	                    }
	                }
	
	                if (_this._options.dateSelected) {
	                    _this._options.dateSelected(date);
	                }
	            }
	        };
	
	        if (this._options.hideWeekends) {
	            dpOptions.beforeShowDay = $.datepicker.noWeekends;
	        }
	
	        $(this._internalVars.node).datepicker(dpOptions);
	
	        this._internalVars.button = this._internalVars.node.nextElementSibling;
	        this._internalVars.wrapper = document.querySelector("#" + this._internalVars.wrapperElementId);
	        this._internalVars.handler = toggleHover.bind(this);
	        this._internalVars.handlerOverride = calendarPositionOverride.bind(this);
	
	        var $datapicker = $(".ui-datepicker");
	
	        if ($datapicker.data("initialized") !== true) {
	            $datapicker.data("initialized", true);
	            document.addEventListener("animationstart", insertListener, false); // standard + firefox
	            document.addEventListener("MSAnimationStart", insertListener, false); // IE
	            document.addEventListener("webkitAnimationStart", insertListener, false); // Chrome + Safari
	        }
	    } catch (ex) {
	        console.error("Error : ", ex.message);
	    }
	}
	
	/**
	 * Sets all the events needed for the component
	 */
	function setEvents() {
	    this._internalVars.button.addEventListener("mouseover", this._internalVars.handler, false);
	    this._internalVars.button.addEventListener("mouseout", this._internalVars.handler, false);
	    window.addEventListener('resize', handleResize.bind(this));
	
	    //special case if a datepicker exist in a modal - override third party jquery snippet
	    if (utils.isChild('modal', this._internalVars.button)) {
	        this._internalVars.button.addEventListener("click", this._internalVars.handlerOverride);
	    }
	}
	
	function init() {
	    if (this._options.disabled === true) {
	        var option = 'disable';
	
	        datePickerState.call(this, option);
	    }
	}
	
	/**
	 * removes all events from the component
	 */
	function removeEvents() {
	    this._internalVars.button.removeEventListener("mouseoout", this._internalVars.handler, false);
	}
	
	/**
	 * Checks if the ID passed from the enable or disable public method exists
	 * @param {string} option  Variable identifying enable or disable
	 */
	function datePickerState(option) {
	    var datePickerId = this._internalVars.node.id,
	        datePicker = document.getElementById(datePickerId),
	        parent = datePicker.parentNode,
	        button = parent.querySelector(".ui-datepicker-trigger"),
	        hasButton = false;
	
	    if (button) {
	        hasButton = true;
	    }
	
	    if (option === 'disable') {
	        disable.call(this, datePicker, button, hasButton);
	    } else if (option === 'enable') {
	        enable.call(this, datePicker, button, hasButton);
	    }
	}
	
	/**
	 * Disables the specified date picker
	 * @param {object} datePicker  The date picker HTML element
	 * @param {object} button  The date picker calendar button HTML element
	 * @param {boolean} hasButton Boolean indicating if calendar button exists
	 */
	function disable(datePicker, button, hasButton) {
	    datePicker.setAttribute('disabled', 'disabled');
	    if (hasButton === true) {
	        button.setAttribute('disabled', 'disabled');
	    }
	}
	
	/**
	 * Enables the specified date picker
	 * @param {object} datePicker  The date picker HTML element
	 * @param {object} button  The date picker calendar button HTML element
	 * @param {boolean} hasButton Boolean indicating if calendar button exists
	 */
	function enable(datePicker, button, hasButton) {
	    datePicker.removeAttribute('disabled');
	    if (hasButton === true) {
	        button.removeAttribute('disabled');
	    }
	}
	
	/**
	 * toggles the active state of the neighboring input field
	 */
	function toggleHover() {
	    if (this._internalVars.node.classList.contains("active")) this._internalVars.node.classList.remove("active");else this._internalVars.node.classList.add("active");
	}
	
	/**
	 * listens for the select box to be inserted and wraps it in a container
	 */
	function insertListener(event) {
	    if (event.animationName == "nodeInserted") {
	        if (!$(".ui-datepicker-year").parent().hasClass("select-box")) $(".ui-datepicker-year").wrap("<div class=\"select-box\"></div>");
	
	        if (!$(".ui-datepicker-month").parent().hasClass("select-box")) $(".ui-datepicker-month").wrap("<div class=\"select-box\"></div>");
	    }
	}
	
	/**
	 * runs when the datepicker window closes
	 */
	function closedDatepicker() {
	    //re-assign button variable since datepicker replaces the original node
	    this._internalVars.button = this._internalVars.node.nextElementSibling;
	    setEvents.call(this);
	    this._internalVars.button.setAttribute('tabindex', '-1');
	}
	
	/**
	 * runs before displaying the datapicker and updates it based on the current options
	 */
	function updateDatepicker(el, obj) {
	
	    var changeOptions = {};
	
	    changeOptions.minDate = this._options.minDate;
	    changeOptions.maxDate = this._options.maxDate;
	
	    if (this._options.monthYearDropdowns) {
	        //adds the month and year dropdowns
	        changeOptions.changeMonth = true;
	        changeOptions.changeYear = true;
	
	        //hide the month arrows
	        $(".ui-datepicker").addClass("date-picker-hide-arrows");
	    } else {
	        //removes the month and year dropdowns
	        changeOptions.changeMonth = false;
	        changeOptions.changeYear = false;
	
	        //displays the month arrows
	        $(".ui-datepicker").removeClass("date-picker-hide-arrows");
	    }
	
	    //set the date format to full or short
	    if (this._options.dateFormatShort) {
	        changeOptions.dateFormat = "mm/yy";
	    } else {
	        changeOptions.dateFormat = "mm/dd/yy";
	    }
	
	    $(el).datepicker("change", changeOptions);
	
	    positionDatePicker.call(this, el);
	
	    $.datepicker._shouldFocusInput = function () {
	        return false;
	    };
	}
	
	/**
	 * Positions calendar
	 * @param {object} el HTML element
	 */
	function positionDatePicker(el) {
	    console.log("update position");
	    //need to add code to check if position has changed before recalculating
	    var winWidth = document.body.clientWidth;
	    var winHeight = window.innerHeight || document.documentElement.clientHeight;
	    var inputOffset = this._internalVars.node.getBoundingClientRect();
	    var containerOffset = this._internalVars.wrapper.getBoundingClientRect();
	    var containerOffsetLeft = containerOffset.left;
	    var containerWidth = this._internalVars.wrapper.offsetWidth;
	    var inputWidth = this._internalVars.node.offsetWidth + this._internalVars.node.nextElementSibling.offsetWidth;
	    var isRight = false;
	
	    if (winWidth >= this._internalVars.breakpoint) {
	
	        $.datepicker._pos = $.datepicker._findPos(el);
	        //figure out correct horizontal direction
	        if ($.datepicker._pos[0] + this._internalVars.calendarWidth + inputWidth < containerWidth) {
	            $.datepicker._pos[0] += inputWidth + this._internalVars.marginLeft;
	        } else {
	            $.datepicker._pos[0] -= this._internalVars.calendarWidth - inputWidth;
	            isRight = true;
	        }
	
	        //figure out correct vertical direction
	        if (inputOffset.top + this._internalVars.calendarWidth < winHeight) {
	            if (!isRight) {
	                $.datepicker._pos[1] -= this._internalVars.marginTopBottomLeft;
	            } else {
	                $.datepicker._pos[1] += inputOffset.bottom - inputOffset.top - this._internalVars.borderWidth + this._internalVars.marginTopBottomLeft;
	            }
	        } else {
	            if (!isRight) {
	                $.datepicker._pos[1] -= this._internalVars.calendarWidth - this._internalVars.marginTopBottomRight;
	            } else {
	                $.datepicker._pos[1] -= this._internalVars.calendarWidth + this._internalVars.marginTopBottomRight;
	            }
	        }
	    }
	}
	
	/**
	 * handles window resize
	 */
	function handleResize() {
	    $(this._internalVars.node).datepicker("hide");
	}
	
	function calendarPositionOverride() {
	    if (_appState2['default'].mode == 'desktop') {
	        document.querySelector('#ui-datepicker-div').style.top = document.querySelector('.modal .hasDatepicker').offsetTop + 'px';
	    }
	}
	
	exports['default'] = DatePicker;
	module.exports = exports['default'];

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _appState = __webpack_require__(7);
	
	var _appState2 = _interopRequireDefault(_appState);
	
	//Module Imports
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK Tabs : Content must be defined and set to a DOM selector or Node"]
	}, {
	    setting: "initialTabOpen",
	    isRequired: false,
	    validate: "type", //a type or a value
	    possibleValues: ["number"],
	    errorMessage: ["GDK Tabs : initialTabOpen must be set to a number"]
	}, {
	    setting: "tabClicked",
	    isRequired: false,
	    validate: "type",
	    possibleValues: ["function"],
	    errorMessage: ["GDK Accordion : accordionClicked must be a function"]
	}];
	
	var Tabs = (function () {
	    /**
	     * Refer to the design kit section of this component for JS examples and setting details.
	     * @param {string, Object} content
	     * A reference to the html tabs node
	     *
	     * @param {number} [initialTabOpen=1]
	     * The number index of the tab to display on initialization
	     *
	     * @param {function} [tabClicked]
	     * A callback function that gets fired when a tab is clicked to open
	     *
	     */
	
	    function Tabs(options) {
	        _classCallCheck(this, Tabs);
	
	        this._internalVars = {
	            node: null, //used for content item
	            tabs: null,
	            panels: null,
	            breakpoint: 767
	        };
	
	        //options with defaults set
	        this._defaults = {
	            initialTabOpen: 1
	        };
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2['default'].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2['default'].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2['default'].getContentType(this);
	            setLocalVars.call(this);
	            setEvents.call(this);
	            openInitialTab.call(this);
	
	            Array.prototype.forEach.call(this._internalVars.tabs, function (element) {
	                element.setAttribute('role', 'tab');
	            });
	            Array.prototype.forEach.call(this._internalVars.panels, function (element) {
	                element.setAttribute('role', 'tabpanel');
	            });
	        }
	    }
	
	    // Private Methods
	
	    /**
	     * setLocalVars()
	     * set all the local vars to passed in options
	     */
	
	    //Public Methods
	    /**
	     * destroy()
	     * removes the node from the dom and any events attached
	     */
	
	    _createClass(Tabs, [{
	        key: 'destroy',
	        value: function destroy() {
	            removeEvents.call(this);
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return Tabs;
	})();
	
	function setLocalVars() {
	    //determine the type of content passed in
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    this._internalVars.tabs = this._internalVars.node.querySelectorAll(".tab");
	    this._internalVars.panels = this._internalVars.node.querySelectorAll(".panel");
	    this._internalVars.globalPanels = document.querySelectorAll('.tabs>.panel');
	
	    this._internalVars.handler = tabClickHandler.bind(this);
	}
	
	/**
	 * setEvents()
	 * Sets all the events needed for the component
	 */
	function setEvents() {
	    var _this = this;
	
	    window.onresize = switchMobileToDesktopTabs.bind(this);
	
	    var eventName = "click";
	    if ("ontouchstart" in document.documentElement) {
	        eventName = "touchstart";
	    }
	    //set tab click events
	    Array.prototype.forEach.call(this._internalVars.tabs, function (element) {
	        element.addEventListener(eventName, _this._internalVars.handler);
	    });
	}
	
	/**
	 * removeEvents()
	 * removes all events from the component
	 */
	function removeEvents() {
	    var _this2 = this;
	
	    var eventName = "click";
	    if ("ontouchstart" in document.documentElement) {
	        eventName = "touchstart";
	    }
	
	    Array.prototype.forEach.call(this._internalVars.tabs, function (element) {
	        element.removeEventListener(eventName, _this2._internalVars.handler);
	    });
	}
	
	/**
	 * tabClickHandler()
	 * Opens tab content for clicked tab and hides the rest
	 */
	function tabClickHandler(element) {
	    var _this3 = this;
	
	    element.preventDefault();
	    var currentNode = element.currentTarget;
	    //get index of clicked tab
	    var index = [].indexOf.call(this._internalVars.tabs, currentNode);
	    if (this._options.tabClicked) if (this._options.tabClicked(currentNode) === false) return false;
	
	    Array.prototype.map.call(this._internalVars.tabs, function (element, i) {
	        if (element === currentNode) {
	            if (_appState2['default'].mode === "mobile" && element.classList.contains("active")) {
	                element.classList.remove("active");
	                element.setAttribute('aria-selected', false);
	            } else {
	                element.classList.add("active");
	                element.setAttribute('aria-selected', true);
	            }
	        } else {
	            element.classList.remove("active");
	            element.setAttribute('aria-selected', false);
	        }
	    });
	
	    Array.prototype.map.call(this._internalVars.panels, function (element, i) {
	        if (_appState2['default'].mode === "mobile") {
	            if (i === index && !element.classList.contains('active')) {
	                openPanel.call(_this3, element);
	            } else {
	                closePanel.call(_this3, element);
	            }
	        } else {
	            if (i === index) {
	                openPanel.call(_this3, element);
	            } else {
	                closePanel.call(_this3, element);
	            }
	        }
	    });
	}
	
	/**
	 * openPanel()
	 * Opens panel at the same index as the clicked tab and hides the other panels
	 */
	function openPanel(element) {
	    if (_appState2['default'].mode === "mobile") {
	        $(element).slideDown();
	    }
	    element.classList.add("active");
	    element.setAttribute('aria-hidden', false);
	}
	
	/**
	 * closePanel()
	 * closes the past in panel
	 */
	function closePanel(element) {
	    if (_appState2['default'].mode === "mobile") {
	        $(element).slideUp();
	    }
	    element.classList.remove("active");
	    element.setAttribute('aria-hidden', true);
	}
	
	/**
	 * switchMobileToDesktopTabs()
	 * keeps the current tab open while going from desktop to mobile window mode.
	 */
	function switchMobileToDesktopTabs() {
	    var _this4 = this;
	
	    Array.prototype.map.call(this._internalVars.globalPanels, function (element) {
	        element.removeAttribute("style");
	        if (element.classList.contains("active")) {
	            openPanel.call(_this4, element);
	        } else {
	            closePanel.call(_this4, element);
	        }
	    });
	}
	
	function openInitialTab() {
	    var _this5 = this;
	
	    var tabIndex = this._options.initialTabOpen - 1;
	
	    Array.prototype.map.call(this._internalVars.tabs, function (element, i) {
	        if (i === tabIndex) {
	            element.classList.add("active");
	            element.setAttribute('aria-selected', true);
	        } else {
	            element.classList.remove("active");
	            element.setAttribute('aria-selected', false);
	        }
	    });
	
	    Array.prototype.map.call(this._internalVars.panels, function (element, i) {
	        element.removeAttribute("style");
	        if (i === tabIndex) {
	            openPanel.call(_this5, element);
	        } else {
	            closePanel.call(_this5, element);
	        }
	    });
	}
	
	exports['default'] = Tabs;
	module.exports = exports['default'];

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//Module Imports
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var Tablesort = __webpack_require__(31);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK SortableTable : Content must be defined and set to a DOM selector or Node"]
	}, {
	    setting: "descending",
	    isRequired: false,
	    validate: "type", //a type or a value
	    possibleValues: ["boolean"],
	    errorMessage: ["GDK SortableTable : descending must be a boolean"]
	}];
	
	var SortableTable = (function () {
	    /**
	     * Refer to the design kit section of this component for JS examples and setting details.
	     * @param {string, Object} content
	     * A reference to the sortable table node
	     *
	     * @param {boolean} [descending=false]
	     * The number of the item to set as the active selection on initialization. Must be greater than 0 and equal to or less than the number of segment options
	     *
	     */
	
	    function SortableTable(options) {
	        _classCallCheck(this, SortableTable);
	
	        this._internalVars = {
	            node: null, //used for current node
	            sortableTable: null //hold reference to the sortable table
	        };
	
	        //options with defaults set
	        this._defaults = {
	            descending: false
	        };
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2["default"].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2["default"].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2["default"].getContentType(this);
	            setLocalVars.call(this);
	            init.call(this);
	        }
	    }
	
	    /**
	    * init()
	    * instantiate the Tablesort
	    */
	
	    /**
	    * update()
	    * Updates the sort if you have added content
	    */
	
	    _createClass(SortableTable, [{
	        key: "update",
	        value: function update() {
	            this._internalVars.sortableTable.refresh();
	        }
	
	        /**
	        * destroy()
	        * removes the node from the dom and any events attached
	        */
	    }, {
	        key: "destroy",
	        value: function destroy() {
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return SortableTable;
	})();
	
	function init() {
	
	    var options = {};
	
	    if (this._options.descending) {
	        options.descending = true;
	    }
	
	    Tablesort.extend('date', function (item) {
	        return (item.search(/(Mon|Tue|Wed|Thu|Fri|Sat|Sun)\.?\,?\s*/i) !== -1 || item.search(/\d{1,2}[\/\-]\d{1,2}[\/\-]\d{2,4}/) !== -1 || item.search(/(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)/i) !== -1) && !isNaN(parseDate.call(this, item));
	    }, function (a, b) {
	        a = a.toLowerCase();
	        b = b.toLowerCase();
	
	        return parseDate.call(this, b) - parseDate.call(this, a);
	    });
	
	    Tablesort.extend('number', function (item) {
	        return item.match(/^-?[£\x24Û¢´€]?\d+\s*([,\.]\d{0,2})/) || // Prefixed currency
	        item.match(/^-?\d+\s*([,\.]\d{0,2})?[£\x24Û¢´€]/) || // Suffixed currency
	        item.match(/^-?(\d)*-?([,\.]){0,1}-?(\d)+([E,e][\-+][\d]+)?%?$/); // Number
	    }, function (a, b) {
	        a = cleanNumber.call(this, a);
	        b = cleanNumber.call(this, b);
	
	        return compareNumber.call(this, b, a);
	    });
	
	    this._internalVars.sortableTable = new Tablesort(this._internalVars.node, options);
	}
	
	/**
	* cleanNumber()
	* regex replace for extending Tablsort to sort by numbers (and currency)
	*/
	function cleanNumber(i) {
	    return i.replace(/[^\-?0-9.]/g, '');
	}
	
	/**
	* compareNumber()
	* sort function for numbers
	*/
	function compareNumber(a, b) {
	    a = parseFloat(a);
	    b = parseFloat(b);
	
	    a = isNaN(a) ? 0 : a;
	    b = isNaN(b) ? 0 : b;
	
	    return a - b;
	}
	
	/**
	* parseDate()
	* prepares date for sorting
	*/
	function parseDate(date) {
	    date = date.replace(/\-/g, '/');
	    date = date.replace(/(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{2})/, '$1/$2/$3'); // format before getTime
	
	    return new Date(date).getTime();
	}
	
	/**
	* setLocalVars()
	* set all the local vars to passed in options
	*/
	function setLocalVars() {
	    //determine the type of content passed in
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	}
	
	exports["default"] = SortableTable;
	module.exports = exports["default"];

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(32);

/***/ },
/* 32 */
/***/ function(module, exports) {

	/*!
	 * tablesort v3.2.0 (2015-12-11)
	 * http://tristen.ca/tablesort/demo/
	 * Copyright (c) 2015 ; Licensed MIT
	*/"use strict";
	
	!(function () {
	  function a(b, c) {
	    if (!(this instanceof a)) return new a(b, c);if (!b || "TABLE" !== b.tagName) throw new Error("Element must be a table");this.init(b, c || {});
	  }var b = [],
	      c = function c(a) {
	    var b;return window.CustomEvent && "function" == typeof window.CustomEvent ? b = new CustomEvent(a) : (b = document.createEvent("CustomEvent"), b.initCustomEvent(a, !1, !1, void 0)), b;
	  },
	      d = function d(a) {
	    return a.getAttribute("data-sort") || a.textContent || a.innerText || "";
	  },
	      e = function e(a, b) {
	    return a = a.toLowerCase(), b = b.toLowerCase(), a === b ? 0 : b > a ? 1 : -1;
	  },
	      f = function f(a, b) {
	    return function (c, d) {
	      var e = a(c.td, d.td);return 0 === e ? b ? d.index - c.index : c.index - d.index : e;
	    };
	  };a.extend = function (a, c, d) {
	    if ("function" != typeof c || "function" != typeof d) throw new Error("Pattern and sort must be a function");b.push({ name: a, pattern: c, sort: d });
	  }, a.prototype = { init: function init(a, b) {
	      var c,
	          d,
	          e,
	          f,
	          g = this;if ((g.table = a, g.thead = !1, g.options = b, a.rows && a.rows.length > 0 && (a.tHead && a.tHead.rows.length > 0 ? (c = a.tHead.rows[a.tHead.rows.length - 1], g.thead = !0) : c = a.rows[0]), c)) {
	        var h = function h() {
	          g.current && g.current !== this && (g.current.classList.remove("sort-up"), g.current.classList.remove("sort-down")), g.current = this, g.sortTable(this);
	        };for (e = 0; e < c.cells.length; e++) f = c.cells[e], f.classList.contains("no-sort") || (f.classList.add("sort-header"), f.tabindex = 0, f.addEventListener("click", h, !1), f.classList.contains("sort-default") && (d = f));d && (g.current = d, g.sortTable(d));
	      }
	    }, sortTable: function sortTable(a, g) {
	      var h,
	          i = this,
	          j = a.cellIndex,
	          k = e,
	          l = "",
	          m = [],
	          n = i.thead ? 0 : 1,
	          o = a.getAttribute("data-sort-method"),
	          p = a.getAttribute("data-sort-order");if ((i.table.dispatchEvent(c("beforeSort")), g ? h = a.classList.contains("sort-up") ? "sort-up" : "sort-down" : (h = a.classList.contains("sort-up") ? "sort-down" : a.classList.contains("sort-down") ? "sort-up" : "asc" === p ? "sort-down" : "desc" === p ? "sort-up" : i.options.descending ? "sort-up" : "sort-down", a.classList.remove("sort-down" === h ? "sort-up" : "sort-down"), a.classList.add(h)), !(i.table.rows.length < 2))) {
	        if (!o) {
	          for (; m.length < 3 && n < i.table.tBodies[0].rows.length;) l = d(i.table.tBodies[0].rows[n].cells[j]), l = l.trim(), l.length > 0 && m.push(l), n++;if (!m) return;
	        }for (n = 0; n < b.length; n++) if ((l = b[n], o)) {
	          if (l.name === o) {
	            k = l.sort;break;
	          }
	        } else if (m.every(l.pattern)) {
	          k = l.sort;break;
	        }i.col = j;var q,
	            r = [],
	            s = {},
	            t = 0,
	            u = 0;for (n = 0; n < i.table.tBodies.length; n++) for (q = 0; q < i.table.tBodies[n].rows.length; q++) l = i.table.tBodies[n].rows[q], l.classList.contains("no-sort") ? s[t] = l : r.push({ tr: l, td: d(l.cells[i.col]), index: t }), t++;for ("sort-down" === h ? (r.sort(f(k, !0)), r.reverse()) : r.sort(f(k, !1)), n = 0; t > n; n++) s[n] ? (l = s[n], u++) : l = r[n - u].tr, i.table.tBodies[0].appendChild(l);i.table.dispatchEvent(c("afterSort"));
	      }
	    }, refresh: function refresh() {
	      void 0 !== this.current && this.sortTable(this.current, !0);
	    } }, "undefined" != typeof module && module.exports ? module.exports = a : window.Tablesort = a;
	})();

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by Svet Kostadinov on 6/17/2015.
	 */
	
	//Require static assets
	
	//Module Imports
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _utils = __webpack_require__(8);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK ViewMoreLess : Content must be defined and set to a DOM selector or Node"]
	}, {
	    setting: "viewMoreLinkClicked",
	    isRequired: false,
	    validate: "type", //a type or a value
	    possibleValues: ["function"],
	    errorMessage: ["GDK ViewMoreLess : viewMoreLinkClicked must be defined and set function"]
	}, {
	    setting: "collapsedTextValue",
	    isRequired: false,
	    validate: "type", //a type or a value
	    possibleValues: ["string"],
	    errorMessage: ["GDK ViewMoreLess : collapsedTextValue must be defined as a text string"]
	}, {
	    setting: "expandedTextValue",
	    isRequired: false,
	    validate: "type", //a type or a value
	    possibleValues: ["string"],
	    errorMessage: ["GDK ViewMoreLess : expandedTextValue must be defined as a text string"]
	}];
	
	/**
	 * View More/Less Class
	 */
	
	var ViewMoreLess = (function () {
	    /**
	     * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	     * @param {string|Object} content
	     * A reference to the component node to toggle
	     *
	     * @param {function} [viewMoreLinkClicked]
	     * A callback function that gets fired when the View link is clicked
	     *
	     * @param {string} [collapsedTextValue="View More"]
	     *  A string representing the link text when collapsed
	     *
	     * @param {string} [expandedTextValue="View Less"]
	     * A string representing the link text when expanded
	     *
	     */
	
	    function ViewMoreLess(options) {
	        _classCallCheck(this, ViewMoreLess);
	
	        console.log('ViewMoreLess initialized');
	
	        this._internalVars = {
	            node: null //used for current node
	        };
	
	        //options with defaults set
	        this._defaults = {
	            collapsedTextValue: 'View More',
	            expandedTextValue: 'View Less'
	        };
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2['default'].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2['default'].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2['default'].getContentType(this);
	            setLocalVars.call(this);
	            init.call(this);
	            setEvents.call(this);
	        }
	    }
	
	    // Private Methods
	    /**
	     * setEvents()
	     * Sets all the events needed for the component
	     */
	
	    //Public Methods
	
	    /**
	     * removes the node from the dom and any events attached
	     */
	
	    _createClass(ViewMoreLess, [{
	        key: 'destroy',
	        value: function destroy() {
	            removeEvents.call(this);
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return ViewMoreLess;
	})();
	
	function setEvents() {
	    this._internalVars.vmlLinkObject.addEventListener("click", this._internalVars.handler);
	}
	
	/**
	 * removeEvents()
	 * removes all events from the component
	 */
	function removeEvents() {
	    this._internalVars.vmlLinkObject.removeEventListener("click", this._internalVars.handler);
	}
	
	function init() {
	    this._internalVars.vmlTitleObject.innerHTML = this._internalVars.collapsedTextValue;
	}
	
	/**
	 * toggleView()
	 * instantiate View More/Less
	 */
	function toggleView(e) {
	    e.preventDefault();
	    this._internalVars.vmlIconObject.classList.toggle('view-less-link-icon');
	    this._internalVars.vmlObject.querySelector('.' + this._internalVars.vmlContentClass).classList.toggle('expanded');
	
	    if (this._internalVars.vmlContentObject.classList.contains('expanded')) {
	        $(this._internalVars.vmlContentObject).slideDown();
	    } else {
	        $(this._internalVars.vmlContentObject).slideUp();
	    }
	
	    if (utils.hasClass(this._internalVars.vmlIconObject, 'view-less-link-icon')) {
	        this._internalVars.vmlTitleObject.innerHTML = this._internalVars.expandedTextValue;
	        this._internalVars.vmlLinkObject.setAttribute('aria-expanded', 'true');
	        this._internalVars.vmlContentObject.setAttribute('aria-hidden', 'false');
	        this._internalVars.vmlState = true;
	    } else {
	        this._internalVars.vmlTitleObject.innerHTML = this._internalVars.collapsedTextValue;
	        this._internalVars.vmlLinkObject.setAttribute('aria-expanded', 'false');
	        this._internalVars.vmlContentObject.setAttribute('aria-hidden', 'true');
	        this._internalVars.vmlState = false;
	    }
	
	    if (this._options.viewMoreLinkClicked) {
	        this._options.viewMoreLinkClicked(this._internalVars.vmlState);
	    }
	}
	
	/**
	 * setLocalVars()
	 * set local vars to the ones passed in options
	 */
	function setLocalVars() {
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	    this._internalVars.collapsedTextValue = this._options.collapsedTextValue;
	    this._internalVars.expandedTextValue = this._options.expandedTextValue;
	
	    this._internalVars.vmlLinkClass = 'view-more-less-link';
	    this._internalVars.vmlLinkTitle = 'view-more-link-title';
	    this._internalVars.vmlIconClass = 'view-more-link-icon';
	    this._internalVars.vmlContentClass = 'view-more-less-content';
	    this._internalVars.vmlObject = this._internalVars.node;
	    this._internalVars.vmlLinkObject = this._internalVars.node.querySelector('a.' + this._internalVars.vmlLinkClass);
	    this._internalVars.vmlTitleObject = this._internalVars.node.querySelector('span.' + this._internalVars.vmlLinkTitle);
	    this._internalVars.vmlIconObject = this._internalVars.node.querySelector('span.' + this._internalVars.vmlIconClass);
	    this._internalVars.vmlContentObject = this._internalVars.node.querySelector('div.' + this._internalVars.vmlContentClass);
	    this._internalVars.vmlState = false;
	
	    if (this._internalVars.vmlContentObject.classList.contains('expanded')) {
	        this._internalVars.vmlLinkObject.setAttribute('aria-expanded', 'true');
	        this._internalVars.vmlContentObject.setAttribute('aria-hidden', 'false');
	        this._internalVars.vmlState = true;
	    } else {
	        this._internalVars.vmlLinkObject.setAttribute('aria-expanded', 'false');
	        this._internalVars.vmlContentObject.setAttribute('aria-hidden', 'true');
	        this._internalVars.vmlState = false;
	    }
	
	    this._internalVars.handler = toggleView.bind(this);
	}
	
	exports['default'] = ViewMoreLess;
	module.exports = exports['default'];

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	
	//Module Imports
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	  setting: "content",
	  isRequired: true,
	  validate: "type", //a type or a value
	  possibleValues: ["string", "object"],
	  errorMessage: ["GDK ToTopArrow : Content must be defined and set to a DOM selector or Node"]
	}, {
	  setting: "toTopArrowClicked",
	  isRequired: false,
	  validate: "type", //a type or a value
	  possibleValues: ["function"],
	  errorMessage: ["GDK ToTopArrow : toTopArrowClicked must be defined and set function"]
	}];
	
	var ToTopArrow = (function () {
	  /**
	   * Refer to the design kit section of this component for JS examples and setting details.
	   * @param {string, Object} content
	   *  A reference to the component node to toggle
	   *
	   * @param {function} [toTopArrowClicked]
	   * A callback function that gets fired when the To Top arrow is clicked
	   *
	   */
	
	  function ToTopArrow(options) {
	    _classCallCheck(this, ToTopArrow);
	
	    console.log('ToTopArrow has been initialized');
	
	    this._internalVars = {
	      node: null //used for current node
	    };
	
	    //options with defaults set
	    this._defaults = {
	      "getDuration": function getDuration() {
	        return pageYOffset <= 2000 ? 300 : 1200;
	      }
	    };
	
	    // Create options by extending defaults with the passed in arguments
	    if (options && typeof options === "object") {
	      this._options = _baseComponent2["default"].extendDefaults(this._defaults, options);
	    }
	
	    //if the required options are valid set up the environment
	    if (_baseComponent2["default"].validateSettings(this._options, validateSettings)) {
	      this._internalVars.contentType = _baseComponent2["default"].getContentType(this);
	      setLocalVars.call(this);
	      setEvents.call(this);
	    }
	  }
	
	  // Private Methods
	  /**
	   * setEvents()
	   * Sets all the events needed for the component
	   */
	
	  //Public Methods
	
	  /**
	   * removes the node from the dom and any events attached
	   */
	
	  _createClass(ToTopArrow, [{
	    key: "destroy",
	    value: function destroy() {
	      removeEvents.call(this);
	      this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	      //a little garbage collection
	      for (var variableKey in this) {
	        if (this.hasOwnProperty(variableKey)) {
	          delete this[variableKey];
	        }
	      }
	    }
	  }]);
	
	  return ToTopArrow;
	})();
	
	function setEvents() {
	  this._internalVars.button.addEventListener("click", this._internalVars.handler);
	  window.addEventListener("scroll", toggleScrollBtnView.bind(this));
	}
	
	/**
	 * removeEvents()
	 * removes all events from the component
	 */
	function removeEvents() {
	  this._internalVars.button.removeEventListener("click", this._internalVars.handler);
	}
	
	/**
	 * toggleScrollBtnView()
	 * @param e
	 */
	function toggleScrollBtnView(e) {
	  if ((window.scrollY || screen.scrollY) > 200 && !this._internalVars.isDisplayed || (window.pageYOffset || screen.pageYOffset) > 200 && !this._internalVars.isDisplayed) {
	    this._internalVars.button.classList.add('displayed');
	    this._internalVars.isDisplayed = true;
	  } else if (window.scrollY <= 100 && this._internalVars.isDisplayed || window.pageYOffset <= 100 && this._internalVars.isDisplayed) {
	    this._internalVars.button.classList.remove('displayed');
	    this._internalVars.isDisplayed = false;
	  }
	}
	
	/**
	 * toggleView()
	 * instantiate To Top Arrow
	 */
	
	function toggleScroll(e) {
	  //TODO: set correct Duration speed!
	  var duration = this._defaults.getDuration();
	  e.preventDefault();
	  var scrollStep = -window.scrollY / (duration / 15) || -window.pageYOffset / (duration / 15),
	      scrollInterval = setInterval(function () {
	    if (window.scrollY !== 0 && window.scrollY !== undefined || window.pageYOffset !== 0 && window.pageYOffset !== undefined) {
	      window.scrollBy(0, scrollStep);
	    } else clearInterval(scrollInterval);
	  }, 15);
	
	  if (this._options.toTopArrowClicked) {
	    this._options.toTopArrowClicked();
	  }
	}
	
	/**
	 * setLocalVars()
	 * set local vars to the ones passed in options
	 */
	function setLocalVars() {
	  if (this._internalVars.contentType === 'string') {
	    this._internalVars.node = document.querySelector(this._options.content);
	  } else if (this._internalVars.contentType === 'domNode') {
	    this._internalVars.node = this._options.content;
	  }
	
	  //add icon dom
	  this._internalVars.node.insertAdjacentHTML('beforeend', "<div class=\"icon-to-top-arrow\"></div>");
	
	  this._internalVars.button = this._internalVars.node;
	  this._internalVars.isDisplayed = false;
	
	  this._internalVars.handler = toggleScroll.bind(this);
	}
	
	exports["default"] = ToTopArrow;
	module.exports = exports["default"];

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	
	//
	// PureJS Validation - Our component builds off the validation provided by validate.js
	//
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	//
	// Module Imports
	//
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	(function (window, document, undefined) {
	    /*
	     * If you would like an application-wide config, change these defaults.
	     * Otherwise, use the setMessage() function to configure form specific messages.
	     */
	
	    var defaults = {
	        messages: {
	            required: 'The %s field is required.',
	            matches: 'The %s field does not match the %s field.',
	            "default": 'The %s field is still set to default, please change.',
	            valid_email: 'The %s field must contain a valid email address.',
	            valid_emails: 'The %s field must contain all valid email addresses.',
	            min_length: 'The %s field must be at least %s characters in length.',
	            max_length: 'The %s field must not exceed %s characters in length.',
	            exact_length: 'The %s field must be exactly %s characters in length.',
	            greater_than: 'The %s field must contain a number greater than %s.',
	            less_than: 'The %s field must contain a number less than %s.',
	            alpha: 'The %s field must only contain alphabetical characters.',
	            alpha_numeric: 'The %s field must only contain alpha-numeric characters.',
	            alpha_dash: 'The %s field must only contain alpha-numeric characters, underscores, and dashes.',
	            numeric: 'The %s field must contain only numbers.',
	            integer: 'The %s field must contain an integer.',
	            decimal: 'The %s field must contain a decimal number.',
	            is_natural: 'The %s field must contain only positive numbers.',
	            is_natural_no_zero: 'The %s field must contain a number greater than zero.',
	            valid_ip: 'The %s field must contain a valid IP.',
	            valid_base64: 'The %s field must contain a base64 string.',
	            valid_credit_card: 'The %s field must contain a valid credit card number.',
	            is_file_type: 'The %s field must contain only %s files.',
	            valid_url: 'The %s field must contain a valid URL.'
	        },
	        callback: function callback(errors) {}
	    };
	
	    /*
	     * Define the regular expressions that will be used
	     */
	
	    var ruleRegex = /^(.+?)\[(.+)\]$/,
	        numericRegex = /^[0-9]+$/,
	        integerRegex = /^\-?[0-9]+$/,
	        decimalRegex = /^\-?[0-9]*\.?[0-9]+$/,
	        emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9]){1,})+$/,
	        alphaRegex = /^[a-z]+$/i,
	        alphaNumericRegex = /^[a-z0-9]+$/i,
	        alphaDashRegex = /^[a-z0-9_\-]+$/i,
	        naturalRegex = /^[0-9]+$/i,
	        naturalNoZeroRegex = /^[1-9][0-9]*$/i,
	        ipRegex = /^((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){3}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})$/i,
	        base64Regex = /[^a-zA-Z0-9\/\+=]/i,
	        numericDashRegex = /^[\d\-\s]+$/,
	        urlRegex = /^((http|https):\/\/(\w+:{0,1}\w*@)?(\S+)|)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/;
	
	    /*
	     * The exposed public object to validate a form:
	     *
	     * @param formNameOrNode - String - The name attribute of the form (i.e. <form name="myForm"></form>) or node of the form element
	     * @param fields - Array - [{
	     *     name: The name of the element (i.e. <input name="myField" />)
	     *     display: 'Field Name'
	     *     rules: required|matches[password_confirm]
	     * }]
	     * @param callback - Function - The callback after validation has been performed.
	     *     @argument errors - An array of validation errors
	     *     @argument event - The javascript event
	     */
	
	    var FormValidator = function FormValidator(formNameOrNode, fields, callback) {
	        this.callback = callback || defaults.callback;
	        this.errors = [];
	        this.fields = {};
	        this.form = this._formByNameOrNode(formNameOrNode) || {};
	        this.messages = {};
	        this.handlers = {};
	        this.conditionals = {};
	
	        for (var i = 0, fieldLength = fields.length; i < fieldLength; i++) {
	            var field = fields[i];
	
	            // If passed in incorrectly, we need to skip the field.
	            if (!field.name && !field.names || !field.rules) {
	                continue;
	            }
	
	            /*
	             * Build the master fields array that has all the information needed to validate
	             */
	
	            if (field.names) {
	                for (var j = 0, fieldNamesLength = field.names.length; j < fieldNamesLength; j++) {
	                    this._addField(field, field.names[j]);
	                }
	            } else {
	                this._addField(field, field.name);
	            }
	        }
	
	        /*
	         * Attach an event callback for the form submission
	         */
	
	        var _onsubmit = this.form.onsubmit;
	
	        this.form.onsubmit = (function (that) {
	            return function (evt) {
	                try {
	                    return that._validateForm(evt) && (_onsubmit === undefined || _onsubmit());
	                } catch (e) {}
	            };
	        })(this);
	    },
	        attributeValue = function attributeValue(element, attributeName) {
	
	        if (element.length > 0 && (element[0].type === 'radio' || element[0].type === 'checkbox')) {
	            for (var i = 0; element.length > i; i++) {
	                if (element[i].checked) {
	                    return element[i][attributeName];
	                }
	            }
	            return;
	        }
	
	        return element[attributeName];
	    };
	
	    /*
	     * @public
	     * Sets a custom message for one of the rules
	     */
	
	    FormValidator.prototype.setMessage = function (rule, message) {
	        this.messages[rule] = message;
	
	        // return this for chaining
	        return this;
	    };
	
	    /*
	     * @public
	     * Registers a callback for a custom rule (i.e. callback_username_check)
	     */
	
	    FormValidator.prototype.registerCallback = function (name, handler) {
	        if (name && typeof name === 'string' && handler && typeof handler === 'function') {
	            this.handlers[name] = handler;
	        }
	
	        // return this for chaining
	        return this;
	    };
	
	    /*
	     * @public
	     * Registers a conditional for a custom 'depends' rule
	     */
	
	    FormValidator.prototype.registerConditional = function (name, conditional) {
	        if (name && typeof name === 'string' && conditional && typeof conditional === 'function') {
	            this.conditionals[name] = conditional;
	        }
	
	        // return this for chaining
	        return this;
	    };
	
	    /*
	     * @private
	     * Determines if a form dom node was passed in or just a string representing the form name
	     */
	
	    FormValidator.prototype._formByNameOrNode = function (formNameOrNode) {
	        return typeof formNameOrNode === 'object' ? formNameOrNode : document.forms[formNameOrNode];
	    };
	
	    /*
	     * @private
	     * Adds a file to the master fields array
	     */
	
	    FormValidator.prototype._addField = function (field, nameValue) {
	        this.fields[nameValue] = {
	            name: nameValue,
	            display: field.display || nameValue,
	            rules: field.rules,
	            depends: field.depends,
	            id: null,
	            element: null,
	            type: null,
	            value: null,
	            checked: null
	        };
	    };
	
	    /*
	     * @private
	     * Runs the validation when the form is submitted.
	     */
	
	    FormValidator.prototype._validateForm = function (evt) {
	        this.errors = [];
	
	        for (var key in this.fields) {
	
	            if (this.fields.hasOwnProperty(key)) {
	                var field = this.fields[key] || {};
	                var element = this.form.querySelectorAll('[name=' + field.name + ']'); //this.form[field.name];
	                if (element.length == 1) {
	                    element = element[0];
	                }
	
	                if (element && element !== undefined) {
	                    field.element = element;
	                    field.type = element.length > 0 ? element[0].type : element.type;
	                    field.id = attributeValue(element, 'id');
	                    field.value = attributeValue(element, 'value');
	                    field.checked = attributeValue(element, 'checked');
	
	                    /*
	                     * Run through the rules for each field.
	                     * If the field has a depends conditional, only validate the field
	                     * if it passes the custom function
	                     */
	
	                    if (field.depends && typeof field.depends === "function") {
	                        if (field.depends.call(this, field)) {
	                            this._validateField(field);
	                        }
	                    } else if (field.depends && typeof field.depends === "string" && this.conditionals[field.depends]) {
	                        if (this.conditionals[field.depends].call(this, field)) {
	                            this._validateField(field);
	                        }
	                    } else {
	                        this._validateField(field);
	                    }
	                }
	            }
	        }
	
	        if (typeof this.callback === 'function') {
	            this.callback(this.errors, evt);
	        }
	
	        if (this.errors.length > 0) {
	            if (evt && evt.preventDefault) {
	                evt.preventDefault();
	                return false;
	            } else if (event) {
	                // IE uses the global event variable
	                event.returnValue = false;
	            }
	        }
	
	        return true;
	    };
	
	    /*
	     * @private
	     * Looks at the fields value and evaluates it against the given rules
	     */
	
	    FormValidator.prototype._validateField = function (field) {
	        var rules = field.rules.split('|'),
	            indexOfRequired = field.rules.indexOf('required'),
	            isEmpty = !field.value || field.value === '' || field.value === undefined;
	
	        /*
	         * Run through the rules and execute the validation methods as needed
	         */
	
	        for (var i = 0, ruleLength = rules.length; i < ruleLength; i++) {
	            var method = rules[i],
	                param = null,
	                failed = false,
	                parts = ruleRegex.exec(method);
	
	            /*
	             * If this field is not required and the value is empty, continue on to the next rule unless it's a callback.
	             * This ensures that a callback will always be called but other rules will be skipped.
	             */
	
	            if (indexOfRequired === -1 && method.indexOf('!callback_') === -1 && isEmpty) {
	                continue;
	            }
	
	            /*
	             * If the rule has a parameter (i.e. matches[param]) split it out
	             */
	
	            if (parts) {
	                method = parts[1];
	                param = parts[2];
	            }
	
	            if (method.charAt(0) === '!') {
	                method = method.substring(1, method.length);
	            }
	
	            /*
	             * If the hook is defined, run it to find any validation errors
	             */
	
	            if (typeof this._hooks[method] === 'function') {
	                if (!this._hooks[method].apply(this, [field, param])) {
	                    failed = true;
	                }
	            } else if (method.substring(0, 9) === 'callback_') {
	                // Custom method. Execute the handler if it was registered
	                method = method.substring(9, method.length);
	
	                if (typeof this.handlers[method] === 'function') {
	                    if (this.handlers[method].apply(this, [field.value, param, field]) === false) {
	                        failed = true;
	                    }
	                }
	            }
	
	            /*
	             * If the hook failed, add a message to the errors array
	             */
	
	            if (failed) {
	                // Make sure we have a message for this rule
	                var source = this.messages[field.name + '.' + method] || this.messages[method] || defaults.messages[method],
	                    message = 'An error has occurred with the ' + field.display + ' field.';
	
	                if (source) {
	                    message = source.replace('%s', field.display);
	
	                    if (param) {
	                        message = message.replace('%s', this.fields[param] ? this.fields[param].display : param);
	                    }
	                }
	
	                this.errors.push({
	                    id: field.id,
	                    element: field.element,
	                    name: field.name,
	                    message: message,
	                    rule: method
	                });
	
	                // Break out so as to not spam with validation errors (i.e. required and valid_email)
	                break;
	            }
	        }
	    };
	
	    /*
	     * @private
	     * Object containing all of the validation hooks
	     */
	
	    FormValidator.prototype._hooks = {
	        required: function required(field) {
	            var value = field.value;
	
	            if (field.type === 'checkbox' || field.type === 'radio') {
	                return field.checked === true;
	            }
	
	            return value !== null && value !== '';
	        },
	
	        "default": function _default(field, defaultName) {
	            return field.value !== defaultName;
	        },
	
	        matches: function matches(field, matchName) {
	            var el = this.form[matchName];
	
	            if (el) {
	                return field.value === el.value;
	            }
	
	            return false;
	        },
	
	        valid_email: function valid_email(field) {
	            return emailRegex.test(field.value);
	        },
	
	        valid_emails: function valid_emails(field) {
	            var result = field.value.split(",");
	
	            for (var i = 0, resultLength = result.length; i < resultLength; i++) {
	                if (!emailRegex.test(result[i])) {
	                    return false;
	                }
	            }
	
	            return true;
	        },
	
	        min_length: function min_length(field, length) {
	            if (!numericRegex.test(length)) {
	                return false;
	            }
	
	            return field.value.length >= parseInt(length, 10);
	        },
	
	        max_length: function max_length(field, length) {
	            if (!numericRegex.test(length)) {
	                return false;
	            }
	
	            return field.value.length <= parseInt(length, 10);
	        },
	
	        exact_length: function exact_length(field, length) {
	            if (!numericRegex.test(length)) {
	                return false;
	            }
	
	            return field.value.length === parseInt(length, 10);
	        },
	
	        greater_than: function greater_than(field, param) {
	            if (!decimalRegex.test(field.value)) {
	                return false;
	            }
	
	            return parseFloat(field.value) > parseFloat(param);
	        },
	
	        less_than: function less_than(field, param) {
	            if (!decimalRegex.test(field.value)) {
	                return false;
	            }
	
	            return parseFloat(field.value) < parseFloat(param);
	        },
	
	        alpha: function alpha(field) {
	            return alphaRegex.test(field.value);
	        },
	
	        alpha_numeric: function alpha_numeric(field) {
	            return alphaNumericRegex.test(field.value);
	        },
	
	        alpha_dash: function alpha_dash(field) {
	            return alphaDashRegex.test(field.value);
	        },
	
	        numeric: function numeric(field) {
	            return numericRegex.test(field.value);
	        },
	
	        integer: function integer(field) {
	            return integerRegex.test(field.value);
	        },
	
	        decimal: function decimal(field) {
	            return decimalRegex.test(field.value);
	        },
	
	        is_natural: function is_natural(field) {
	            return naturalRegex.test(field.value);
	        },
	
	        is_natural_no_zero: function is_natural_no_zero(field) {
	            return naturalNoZeroRegex.test(field.value);
	        },
	
	        valid_ip: function valid_ip(field) {
	            return ipRegex.test(field.value);
	        },
	
	        valid_base64: function valid_base64(field) {
	            return base64Regex.test(field.value);
	        },
	
	        valid_url: function valid_url(field) {
	            return urlRegex.test(field.value);
	        },
	
	        valid_credit_card: function valid_credit_card(field) {
	            // Luhn Check Code from https://gist.github.com/4075533
	            // accept only digits, dashes or spaces
	            if (!numericDashRegex.test(field.value)) return false;
	
	            // The Luhn Algorithm. It's so pretty.
	            var nCheck = 0,
	                nDigit = 0,
	                bEven = false;
	            var strippedField = field.value.replace(/\D/g, "");
	
	            for (var n = strippedField.length - 1; n >= 0; n--) {
	                var cDigit = strippedField.charAt(n);
	                nDigit = parseInt(cDigit, 10);
	                if (bEven) {
	                    if ((nDigit *= 2) > 9) nDigit -= 9;
	                }
	
	                nCheck += nDigit;
	                bEven = !bEven;
	            }
	
	            return nCheck % 10 === 0;
	        },
	
	        is_file_type: function is_file_type(field, type) {
	            if (field.type !== 'file') {
	                return true;
	            }
	
	            var ext = field.value.substr(field.value.lastIndexOf('.') + 1),
	                typeArray = type.split(','),
	                inArray = false,
	                i = 0,
	                len = typeArray.length;
	
	            for (i; i < len; i++) {
	                if (ext == typeArray[i]) inArray = true;
	            }
	
	            return inArray;
	        }
	    };
	
	    window.FormValidator = FormValidator;
	})(window, document);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK ValidateForm : Content must be defined and set to a DOM selector or Node"]
	}];
	
	var ValidateForm = (function () {
	
	    // 1. All input fields need error styling, if there is a server error on fields we are not directly validating
	    // 2. Numbers -- needs to be a number and if required
	    // 3. Email -- needs to be a email and if required
	    // 4. Phone Number -- needs match exact phone number pattern "(804) 341-3525"
	    // 5. SSN -- validate the hidden field needs match exact ssn pattern "123-12-4124"
	    // 6. Select Box -- if required
	    // 7. Checkbox -- if required
	    // 8. Radio Buttons -- if required
	    // 9. Text area -- if required
	
	    /**
	     * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	     * @param {string|Object} content
	     *  A reference to the html form container
	     */
	
	    function ValidateForm(options) {
	        _classCallCheck(this, ValidateForm);
	
	        console.log("Initialized the ValidateForm component");
	
	        this._internalVars = {
	            node: null //used for content item
	        };
	
	        //options with defaults set
	        this._defaults = {};
	
	        // Create options by extending defaults with the passed in arguments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2['default'].extendDefaults(this._defaults, options);
	        }
	
	        // From the passed in CSS selector iterate over each form and build validation rules and events
	        this._forms = document.querySelectorAll(options.content);
	        this._validators = [];
	        this._rules = [];
	        for (var n = 0; this._forms.length > n; n++) {
	            // Initialize the form
	            initializeForm.call(this, n);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2['default'].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2['default'].getContentType(this);
	            setLocalVars.call(this);
	            setEvents.call(this);
	        }
	    }
	
	    // Private Methods
	
	    /**
	     * Initialize the form
	     */
	
	    //Public Methods
	
	    /**
	     * removes the node from the dom and any events attached
	     */
	
	    _createClass(ValidateForm, [{
	        key: 'destroy',
	        value: function destroy() {
	            removeEvents.call(this);
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return ValidateForm;
	})();
	
	function initializeForm(n) {
	
	    return (function (that, n) {
	        that._rules[n] = buildRules(that._forms[n]);
	
	        that._validators[n] = new FormValidator(that._forms[n],
	        // Built dynamically via data attributes
	        that._rules[n],
	        // Callback on each validation pass blur or submit
	        function (errors, evt) {
	            // Clear any old errors
	            var wrappers = this.form.querySelectorAll('[class=form-field]');
	            for (var j = 0; wrappers.length > j; j++) {
	                // clear all field errors and reset the error class on wrapper
	                clearFieldError(wrappers[j]);
	            }
	
	            // Handle displaying any errors in the form
	            if (errors.length > 0) {
	
	                // add error classes to appropriate elements
	                for (var i = 0; errors.length > i; i++) {
	                    var element = this.form.querySelectorAll('[name=' + errors[i].name + ']')[0];
	
	                    // get this field's wrapper
	                    var field_wrapper = closest(element, "form-field");
	
	                    // Create and append the error message
	                    addFieldError(field_wrapper, errors[i].message);
	                }
	            }
	        });
	
	        // Extend validation class
	        extendValidator(that._validators[n]);
	    })(this, n);
	}
	
	function addBlur(validator, element) {
	    return (function (that, element) {
	        return function (evt) {
	            var field = that.fields[element.getAttribute('name')] || {};
	
	            if (element && element !== undefined) {
	                field.element = element;
	                field.id = element.getAttribute('id');
	                field.name = element.getAttribute('name');
	                field.type = element.length > 0 ? element[0].type : element.type;
	                field.value = element.value;
	                field.checked = element.checked;
	
	                // clear any errors relating to this field
	                if (that.errors.length > 0) {
	                    for (var i = 0; that.errors.length > i; i++) {
	                        if (that.errors[i].name == field.name) {
	                            // splice don't delete
	                            that.errors.splice(i, 1);
	                        }
	                    }
	                }
	
	                // get this field's wrapper
	                var field_wrapper = closest(element, "form-field");
	
	                // clear all field errors and reset the error class on wrapper
	                clearFieldError(field_wrapper);
	
	                // validate this field
	                that.errors = [];
	                that._validateField(field);
	
	                // Handle displaying any errors in the form
	                if (that.errors.length > 0) {
	                    // add error classes to appropriate elements
	                    for (var j = 0; that.errors.length > j; j++) {
	                        // get this field's wrapper
	                        field_wrapper = closest(that.errors[j].element, "form-field");
	
	                        // Create and append the error message
	                        addFieldError(field_wrapper, that.errors[j].message);
	                    }
	                }
	            }
	        };
	    })(validator, element);
	}
	
	/**
	 * setEvents()
	 * Sets all the events needed for the component
	 */
	function setEvents() {
	    // Go through each form's rulesets
	    for (var n = 0; this._rules.length > n; n++) {
	        // Go through each ruleset
	        for (var e = 0; this._rules[n].length > e; e++) {
	            // pull out the element
	            var element = this._rules[n][e].element;
	
	            if (element.type === 'checkbox' || element.type === 'radio') {
	                // Add an onchange event
	                element.onchange = addBlur(this._validators[n], element);
	            } else {
	                // Add an onblur event
	                element.onblur = addBlur(this._validators[n], element);
	            }
	        }
	    }
	}
	
	/**
	 * removeEvents()
	 * removes all events from the component
	 */
	function removeEvents() {}
	
	/**
	 * buildRules()
	 * builds an array of validation rules based on the DOM attributes
	 */
	function buildRules(form) {
	    form = typeof form === 'object' ? form : document.forms[form];
	    var elements = form.querySelectorAll('[data-validate]');
	    var rules = [];
	    var unique_rules = [];
	
	    for (var i = 0; elements.length > i; i++) {
	        // set up a rule for this element
	        var rule = {
	            rules: elements[i].getAttribute("data-validate"),
	            element: elements[i],
	            name: elements[i].getAttribute("name")
	        };
	
	        if (!rule.name) {
	            console.log("Warning: Field element missing name attribute.", rule.element);
	        }
	
	        // Add rule to the list
	        rules.push(rule);
	    }
	
	    return rules;
	}
	
	/**
	 * Find the closest parent containing a class
	 */
	function closest(el, cls) {
	    while ((el = el.parentNode) && -1 === el.className.indexOf(cls));
	    return el;
	}
	
	/**
	 * Add an error message to an element
	 */
	function addFieldError(wrapper, error) {
	    // Make sure the wrapper has the error class
	    if (-1 === wrapper.className.indexOf("form-field--error")) {
	        wrapper.className = wrapper.className + " form-field--error";
	    }
	    if (wrapper.querySelector('input')) wrapper.querySelector('input').setAttribute("aria-invalid", "true");
	    if (wrapper.querySelector('textarea')) wrapper.querySelector('textarea').setAttribute("aria-invalid", "true");
	    if (wrapper.querySelector('select')) wrapper.querySelector('select').setAttribute("aria-invalid", "true");
	
	    // Get all spans and check ones bearing class "form-message"
	    var spans = wrapper.getElementsByTagName('span');
	    for (var e = 0; spans.length > e; e++) {
	
	        // Somewhat of a hack to do element content comparison when
	        // browsers render inner tags differently
	        var comparison_div = document.createElement("div");
	        comparison_div.innerHTML = error;
	
	        // If the discovered span is a message and contains the same text as the error var
	        if (-1 !== spans[e].className.indexOf("form-message") && spans[e].innerHTML === comparison_div.innerHTML) {
	            // Don't add the same message to a wrapper twice
	            return;
	        }
	    }
	
	    // Add an error to the element wrapper
	    var msg = document.createElement("span");
	    msg.id = "form-message-" + wrapper.querySelector('[data-validate]').id;
	    msg.innerHTML = error;
	    msg.className = "form-message";
	    var idString = "";
	    wrapper.appendChild(msg);
	    if (wrapper.querySelector('.form-descriptive-copy')) {
	        idString = wrapper.querySelector('.form-descriptive-copy').id + " " + msg.id;
	    } else {
	        idString = msg.id;
	    }
	    wrapper.querySelector('[data-validate]').setAttribute('aria-describedby', idString);
	}
	
	/**
	 * Remove field errors from an element
	 */
	function clearFieldError(wrapper) {
	    // remove error class from wrapper
	    if (-1 !== wrapper.className.indexOf("form-field--error")) {
	        wrapper.className = wrapper.className.replace("form-field--error", "");
	    }
	    if (wrapper.querySelector('input')) wrapper.querySelector('input').setAttribute("aria-invalid", "false");
	    if (wrapper.querySelector('textarea')) wrapper.querySelector('textarea').setAttribute("aria-invalid", "false");
	    if (wrapper.querySelector('select')) wrapper.querySelector('select').setAttribute("aria-invalid", "false");
	    // Get all spans and remove ones bearing class "form-message"
	    var spans = wrapper.getElementsByTagName('span');
	    for (var e = 0; spans.length > e; e++) {
	        if (-1 !== spans[e].className.indexOf("form-message")) {
	            spans[e].parentNode.removeChild(spans[e]);
	        }
	    }
	    wrapper.querySelector('[data-validate]').removeAttribute('aria-describedby');
	}
	
	/**
	 * Attach additional validator rules to validator objects
	 */
	function extendValidator(validator) {
	
	    // custom validators
	    validator.registerCallback('ssn', function (value, masked_ssn_id) {
	        // get the masked SSN
	        var masked_ssn = document.getElementById(masked_ssn_id);
	        // Test to see if the masked SSN is valid: '###-##-####'
	        // var ssn_regex = /^\d{3}-?\d{2}-?\d{4}$/;
	        var ssn_regex = /^(?!219-09-9999|078-05-1120)(?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4}$/;
	        return ssn_regex.test(masked_ssn.value);
	    });
	    validator.registerCallback('phone', function (value) {
	        // Test to see if the Phone is valid: '(###) ###-####'
	        var phone_regex = /^([\(]{1}[0-9]{3}[\)]{1}[ ]?[0-9]{3}[\-]{1}[0-9]{4})$/;
	        return phone_regex.test(value);
	    });
	    validator.registerCallback('date', function (value) {
	        // Test to see if the Date is valid: '##/##/####'
	        var date_regex = /^((0[1-9])|(1[0-2]))[\/]((0[1-9])|([1,2][0-9])|(3[0,1]))[\/]((19|20)[0-9][0-9])$/;
	        if (date_regex.test(value)) {
	            var date_parts = value.split("/");
	            // check to see if the month is still the correct month after
	            // casting the date string to a date, This works because if a
	            // day is past the last day of the month the JS Date object
	            // advances the number of days past the month's end into the
	            // next month.
	            return new Date(date_parts[2], parseInt(date_parts[0]) - 1, date_parts[1]).getMonth() === parseInt(date_parts[0]) - 1;
	        }
	        return false;
	    });
	    validator.registerCallback('date_short', function (value) {
	        // Test to see if the Date is valid: '##/####'
	        var date_regex = /^((0[1-9])|(1[0-2]))[\/]((19|20)[0-9][0-9])$/;
	        return date_regex.test(value);
	    });
	    validator.registerCallback('date_expiration', function (value) {
	        // Test to see if the Date is valid: '##/##'
	        var date_regex = /^((0[1-9])|(1[0-2]))[\/]([1-9][7-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[0-9])$/;
	        return date_regex.test(value);
	    });
	    validator.registerCallback('radio_required', function (value, element_name) {
	        // See if there are any checked input elements matching the element name passed in
	        var radio = this.form.querySelectorAll('input[name="' + element_name + '"]:checked');
	        if (radio.length > 0) {
	            return true;
	        }
	
	        return false;
	    });
	    validator.registerCallback('checkbox_required', function (value, element_name) {
	        // See if there are any checked input elements matching the element name passed in
	        var cb = this.form.querySelectorAll('input[name="' + element_name + '"]:checked');
	        if (cb.length > 0) {
	            return true;
	        }
	
	        return false;
	    });
	    validator.registerCallback('select_required', function (value, select_id) {
	        // See if there are any selected option elements under the provided select
	        var select_element = document.getElementById(select_id);
	        if (select_element.options[select_element.selectedIndex] !== undefined) {
	            // overwrite the "value" passed into this validator
	            value = select_element.options[select_element.selectedIndex].value;
	            if (value !== undefined && value) {
	                return true;
	            }
	        }
	
	        return false;
	    });
	    validator.registerCallback('timeInput', function (value, masked_timeInput_id) {
	        // get the masked timeInput
	        var masked_timeInput = document.getElementById(masked_timeInput_id),
	            timeInput_regex = /^(0?[1-9]|1[012]):[0-5][0-9]$/,
	            timeInputValue = masked_timeInput.value,
	            initialHour,
	            minutes;
	
	        if (timeInputValue.length === 5) {
	            initialHour = timeInputValue.substring(2, 0);
	            minutes = timeInputValue.substring(3);
	            if (initialHour > 12 && initialHour < 24) {
	                initialHour = initialHour - 12;
	                setTime.call(this, masked_timeInput, initialHour, minutes);
	            }
	            if (initialHour < 1) {
	                initialHour = 12;
	                setTime.call(this, masked_timeInput, initialHour, minutes);
	            }
	        }
	
	        return timeInput_regex.test(masked_timeInput.value);
	    });
	
	    function setTime(masked_timeInput, initialHour, minutes) {
	        var numHour, newValue, hour;
	        numHour = String(initialHour);
	        if (numHour.length < 2) {
	            hour = '0' + numHour;
	        } else {
	            hour = numHour;
	        }
	        Number(hour);
	        Number(initialHour);
	        newValue = hour + ':' + minutes;
	        masked_timeInput.value = newValue;
	    }
	
	    // Custom validation messages
	    validator.setMessage('required', 'Invalid entry.<br> Please check your entry and try again.');
	    validator.setMessage('numeric', 'Invalid entry.<br> Please check your entry and try again.');
	    validator.setMessage('ssn', 'Please enter a valid Social Security Number.');
	    validator.setMessage('phone', 'Please enter a valid Phone Number.');
	    validator.setMessage('radio_required', 'Please make a selection.');
	    validator.setMessage('checkbox_required', 'Please make a selection.');
	    validator.setMessage('select_required', 'Please make a selection.');
	    validator.setMessage('valid_email', "Invalid email.<br> Please check your entry and try again.");
	    validator.setMessage('date', "Invalid date format.<br> Please check your entry and try again.");
	    validator.setMessage('date_short', "Invalid date format.<br> Please check your entry and try again.");
	    validator.setMessage('timeInput', 'Please enter a valid time of day.');
	}
	
	/**
	 * setLocalVars()
	 * set all the local vars to passed in options
	 */
	function setLocalVars() {
	    //determine the type of content passed in
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	}
	
	exports['default'] = ValidateForm;
	module.exports = exports['default'];
	/*
	 * validate.js 1.4.1
	 * Copyright (c) 2011 - 2014 Rick Harrison, http://rickharrison.me
	 * validate.js is open sourced under the MIT license.
	 * Portions of validate.js are inspired by CodeIgniter.
	 * http://rickharrison.github.com/validate.js
	 */

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	
	//Module Imports
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	  setting: "content",
	  isRequired: true,
	  validate: "type", //a type or a value
	  possibleValues: ["string", "object"],
	  errorMessage: ["GDK InPageNavigation : Content must be defined and set to a DOM selector or Node"]
	}, {
	  setting: "onClicked",
	  isRequired: false,
	  validate: "type",
	  possibleValues: ["function"],
	  errorMessage: ["GDK InPageNavigation : onClicked must be a function"]
	}, {
	  setting: "startingPos",
	  isRequired: false,
	  validate: "type", //a type or a value
	  possibleValues: ["number"],
	  errorMessage: ["GDK InPageNavigation : startingPos must be set to a number"]
	}, {
	  setting: "autoHide",
	  isRequired: false,
	  validate: "type", //a type or a value
	  possibleValues: ["boolean"],
	  errorMessage: ["GDK InPageNavigation : autoHide must be set to be boolean. Default value is False."]
	}];
	
	var InPageNavigation = (function () {
	
	  /**
	   * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	   * @param {string|Object} content
	   * A reference to the html 'in page navigation' node
	   *
	   * @param {function} [onClicked]
	   *  Callback function fired once a 'in-page-item' is clicked
	   *
	   * @param {number} [startingPos=1]
	   * The number of the navigation item to display on initialization
	   */
	
	  function InPageNavigation(options) {
	    _classCallCheck(this, InPageNavigation);
	
	    this._internalVars = {
	      node: null, //used for content item
	      navItem: null,
	      marker: null
	    };
	
	    //options with defaults set
	    this._defaults = {
	      startingPos: 1,
	      autoHide: false
	    };
	
	    // Create options by extending defaults with the passed in arguments
	    if (options && typeof options === "object") {
	      this._options = _baseComponent2["default"].extendDefaults(this._defaults, options);
	    }
	
	    //if the required options are valid set up the environment
	    if (_baseComponent2["default"].validateSettings(this._options, validateSettings)) {
	      this._internalVars.contentType = _baseComponent2["default"].getContentType(this);
	      setLocalVars.call(this);
	      setEvents.call(this);
	      setStartPosition.call(this);
	    }
	  }
	
	  // Private Methods
	
	  /**
	   * setLocalVars()
	   * set all the local vars to passed in options
	   */
	
	  //Public Methods
	
	  /**
	   * @param {number} [newIndex]
	   * newIndex is the number of the navigation item to go to first on initialization
	   */
	
	  _createClass(InPageNavigation, [{
	    key: "goTo",
	    value: function goTo(newIndex) {
	      var _this = this;
	
	      var index = newIndex - 1;
	
	      Array.prototype.map.call(this._internalVars.navItem, function (e, rank) {
	        if (rank === index) {
	          e.classList.add("in-page-item--selected");
	
	          var topPosition = e.offsetTop;
	          var nodeHeight = e.offsetHeight;
	
	          // set marker to correct position
	          _this._internalVars.marker.style.top = topPosition + "px";
	          _this._internalVars.marker.style.height = nodeHeight + "px";
	        } else {
	          e.classList.remove("in-page-item--selected");
	        }
	      });
	    }
	
	    /**
	     * destroy()
	     * removes the node from the dom and any events attached
	     */
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      removeEvents.call(this);
	      this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	      //a little garbage collection
	      for (var variableKey in this) {
	        if (this.hasOwnProperty(variableKey)) {
	          delete this[variableKey];
	        }
	      }
	    }
	  }]);
	
	  return InPageNavigation;
	})();
	
	function setLocalVars() {
	  //determine the type of content passed in
	  if (this._internalVars.contentType === 'string') {
	    this._internalVars.node = document.querySelector(this._options.content);
	  } else if (this._internalVars.contentType === 'domNode') {
	    this._internalVars.node = this._options.content;
	  }
	
	  this._internalVars.node.insertAdjacentHTML('beforeend', "<li class=\"in-page-marker\"></li>");
	
	  this._internalVars.navItem = this._internalVars.node.querySelectorAll(".in-page-item");
	  this._internalVars.marker = this._internalVars.node.querySelector(".in-page-marker");
	
	  this._internalVars.navId = this._internalVars.node.id;
	
	  this._internalVars.backgroundItems = [];
	  this._internalVars.backgroundItemsTop = [];
	  this._internalVars.backgroundItemsBottom = [];
	
	  this._internalVars.backgroundItemsDefined = false;
	
	  this._internalVars.handler = inPageItemClickHandler.bind(this);
	}
	
	/**
	 * setEvents()
	 * Sets all the events needed for the component
	 */
	function setEvents() {
	  var _this2 = this;
	
	  var eventName = "click";
	
	  //set click events
	  Array.prototype.forEach.call(this._internalVars.navItem, function (el, i) {
	    el.addEventListener(eventName, _this2._internalVars.handler);
	  });
	
	  window.addEventListener('scroll', scrollPosition.bind(this));
	  window.addEventListener('scroll', checkNode.bind(this));
	}
	
	/**
	 * removeEvents()
	 * removes all events from the component
	 */
	function removeEvents() {
	  var _this3 = this;
	
	  var eventName = "click";
	
	  //remove click events
	  Array.prototype.forEach.call(this._internalVars.navItem, function (el, i) {
	    el.removeEventListener(eventName, _this3._internalVars.handler);
	  });
	}
	
	/**
	 * if In Page Navigation Node exists, run processes
	 */
	function checkNode() {
	  if (document.getElementById(this._internalVars.navId)) {
	    defineBackgroundItems.call(this);
	  }
	}
	
	/**
	 * Create array of all items with a bg or gradient background spanning the full width of the page
	 */
	function defineBackgroundItems() {
	  var _this4 = this;
	
	  if (this._internalVars.backgroundItemsDefined === false) {
	    var gradientItems = document.querySelectorAll('.bg-gradient'),
	        coloredItems = document.querySelectorAll('.bg-color'),
	        crossSellItems = document.querySelectorAll('.cross-sell-image');
	
	    Array.prototype.forEach.call(gradientItems, function (el) {
	      if (el.clientWidth === document.body.scrollWidth) {
	        _this4._internalVars.backgroundItems.push(el);
	      }
	    });
	
	    Array.prototype.forEach.call(coloredItems, function (el) {
	      if (el.clientWidth === document.body.scrollWidth) {
	        _this4._internalVars.backgroundItems.push(el);
	      }
	    });
	
	    Array.prototype.forEach.call(crossSellItems, function (el) {
	      if (el.clientWidth === document.body.scrollWidth) {
	        _this4._internalVars.backgroundItems.push(el);
	      }
	    });
	
	    this._internalVars.backgroundItemsDefined = true;
	  }
	  checkBackgroundItems.call(this);
	}
	
	function checkBackgroundItems() {
	  var _this5 = this;
	
	  this._internalVars.backgroundItemsTop = [];
	  this._internalVars.backgroundItemsBottom = [];
	  Array.prototype.forEach.call(this._internalVars.backgroundItems, function (el) {
	    var top = $(el).offset().top - window.pageYOffset,
	        bottom = top + el.clientHeight;
	    if (top > 0 && top < window.innerHeight) {
	      addBackgroundItemsToArray.call(_this5, el);
	    } else if (bottom > 0 && bottom < window.innerHeight) {
	      addBackgroundItemsToArray.call(_this5, el);
	    }
	  });
	  changeNavItemColor.call(this);
	}
	
	function addBackgroundItemsToArray(el) {
	  var crossSellHeight = el.clientHeight / 2;
	
	  if (el.classList.contains('cross-sell-image')) {
	    this._internalVars.backgroundItemsTop.push($(el).offset().top + crossSellHeight);
	    this._internalVars.backgroundItemsBottom.push($(el).offset().top + el.clientHeight);
	  } else {
	    this._internalVars.backgroundItemsTop.push($(el).offset().top);
	    this._internalVars.backgroundItemsBottom.push($(el).offset().top + el.clientHeight);
	  }
	}
	
	function changeNavItemColor() {
	  var _this6 = this;
	
	  Array.prototype.forEach.call(this._internalVars.navItem, function (el) {
	    var top = $(el).offset().top - window.pageYOffset,
	        height = el.clientHeight,
	        changePoint = top + height / 2,
	        changeColor = true;
	
	    Array.prototype.forEach.call(_this6._internalVars.backgroundItems, function (ele, ind) {
	      if (changeColor === true) {
	        if (changePoint + window.pageYOffset > _this6._internalVars.backgroundItemsTop[ind] && changePoint + window.pageYOffset < _this6._internalVars.backgroundItemsBottom[ind]) {
	          el.classList.add('changeFontColor');
	          changeColor = false;
	        } else {
	          if (el.classList.contains('changeFontColor')) {
	            el.classList.remove('changeFontColor');
	          }
	        }
	      }
	    });
	  });
	
	  var component = document.getElementById(this._internalVars.navId),
	      navMarker = component.querySelector('.in-page-marker'),
	      selected = component.querySelector('.in-page-item--selected');
	
	  if (selected.classList.contains('changeFontColor')) {
	    navMarker.classList.add('changeFontColor');
	  } else {
	    if (navMarker.classList.contains('changeFontColor')) {
	      navMarker.classList.remove('changeFontColor');
	    }
	  }
	}
	
	/**
	 * inPageItemClickHandler()
	 * Opens tab content for clicked tab and hides the rest
	 */
	function inPageItemClickHandler(el) {
	  var _this7 = this;
	
	  el.preventDefault();
	  var currentNode = el.currentTarget;
	
	  // get position and height of currentNode
	  var topPosition = currentNode.offsetTop;
	  var nodeHeight = currentNode.offsetHeight;
	
	  // add selected class
	  Array.prototype.map.call(this._internalVars.navItem, function (e, rank) {
	    if (e === currentNode) {
	      e.classList.add("in-page-item--selected");
	    } else {
	      e.classList.remove("in-page-item--selected");
	    }
	  });
	
	  // set marker to correct position
	  this._internalVars.marker.style.top = topPosition + "px";
	  this._internalVars.marker.style.height = nodeHeight + "px";
	
	  var currentNodeSection = currentNode.getElementsByTagName("a");
	
	  if (currentNodeSection[0].hasAttribute('data-link')) {
	    var getDataLink = currentNodeSection[0].getAttribute("data-link");
	    var section = document.getElementById(getDataLink);
	    //start will adjusting this number to a negative and go from there.  Will adjust position of a.
	    var _top = -40;
	    var sectionTop = section.offsetTop + _top;
	
	    window.scrollTo(0, sectionTop);
	  }
	
	  // fire onClicked Callback if there is one
	  setTimeout(function () {
	    if (_this7._options.onClicked) _this7._options.onClicked(currentNode);
	  }, 10);
	}
	
	/**
	 * setStartPosition()
	 * Set starting link
	 */
	function setStartPosition() {
	  var _this8 = this;
	
	  var linkIndex = this._options.startingPos - 1;
	
	  if (this._options.autoHide) {
	    if (!this._internalVars.node.classList.contains('hidden')) {
	      toggleComponent.call(this);
	    }
	  }
	
	  Array.prototype.map.call(this._internalVars.navItem, function (e, rank) {
	    if (rank === linkIndex) {
	      e.classList.add("in-page-item--selected");
	
	      var topPosition = e.offsetTop;
	      var nodeHeight = e.offsetHeight;
	
	      _this8._internalVars.marker.style.top = topPosition + "px";
	      _this8._internalVars.marker.style.height = nodeHeight + "px";
	    }
	  });
	}
	
	/**
	 * Toggle Component Function
	 * Displays and hides the component
	 */
	function toggleComponent() {
	  if (this._internalVars.node.classList.contains('hidden')) {
	    this._internalVars.node.classList.remove('hidden');
	  } else {
	    this._internalVars.node.classList.add('hidden');
	  }
	}
	
	function scrollPosition() {
	  var inPageNav = this._internalVars.node;
	  if (inPageNav.parentNode.parentNode.getBoundingClientRect().top - 65 < 0) {
	    inPageNav.style.position = "fixed";
	    inPageNav.style.top = window.innerHeight / 2 - inPageNav.offsetHeight + "px";
	  } else {
	    inPageNav.style.position = "absolute";
	    inPageNav.style.top = "";
	  }
	}
	
	exports["default"] = InPageNavigation;
	module.exports = exports["default"];

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	
	//Module Imports
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _appState = __webpack_require__(7);
	
	var _appState2 = _interopRequireDefault(_appState);
	
	var _utils = __webpack_require__(8);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK TimelineFilter : Content must be defined and set to a DOM selector or Node"]
	}, {
	    setting: "onFilterSubmit",
	    isRequired: false,
	    validate: "type",
	    possibleValues: ["function"],
	    errorMessage: ["GDK InPageNavigation : onFilterSubmit must be a function"]
	}, {
	    setting: "onClearFilter",
	    isRequired: false,
	    validate: "type",
	    possibleValues: ["function"],
	    errorMessage: ["GDK InPageNavigation : onClearFilter must be a function"]
	}];
	
	var TimelineFilter = (function () {
	    /**
	     * Refer to the design kit section of this component for JS examples and setting details.
	     * @param {string, Object} content
	     *  A reference to the html timeline filter node
	     *
	     * @param {function} [onFilterSubmit]
	     * Callback function fired once a 'filter-submit' is clicked
	     *
	     * @param {function} [onClearFilter]
	     * Callback function fired once 'Clear Filters' is clicked
	     *
	     */
	
	    function TimelineFilter(options) {
	        _classCallCheck(this, TimelineFilter);
	
	        this._internalVars = {
	            node: null, //used for content item
	            dropdownTrigger: null,
	            checkbox: null,
	            dropdown: null,
	            mobileOpen: null,
	            //mobileClose: null,
	            mobileBar: null,
	            mobileText: null,
	            clear: null,
	            search: null,
	            submit: null,
	            dropdownContainer: null
	        };
	
	        //options with defaults set
	        this._defaults = {};
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2['default'].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2['default'].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2['default'].getContentType(this);
	            setLocalVars.call(this);
	            setEvents.call(this);
	
	            if (_appState2['default'].mode == "desktop") Array.prototype.forEach.call(this._internalVars.dropdownTrigger, function (el, i) {
	                el.setAttribute('aria-expanded', 'false');
	            });
	        }
	    }
	
	    // Private Methods
	
	    /**
	     * setLocalVars()
	     * set all the local vars to passed in options
	     */
	
	    //Public Methods
	
	    /**
	     * destroy()
	     * removes the node from the dom and any events attached
	     */
	
	    _createClass(TimelineFilter, [{
	        key: 'destroy',
	        value: function destroy() {
	            removeEvents.call(this);
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return TimelineFilter;
	})();
	
	function setLocalVars() {
	    //determine the type of content passed in
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    this._internalVars.dropdownTrigger = this._internalVars.node.querySelectorAll(".filter-dropdown-trigger");
	    this._internalVars.checkbox = this._internalVars.node.querySelectorAll(".filter-checkbox");
	    this._internalVars.dropdown = this._internalVars.node.querySelectorAll(".filter-dropdown");
	    this._internalVars.clear = this._internalVars.node.querySelector(".filter-clear");
	    this._internalVars.search = this._internalVars.node.querySelector(".filter-search");
	    this._internalVars.submit = this._internalVars.node.querySelector(".filter-submit");
	    this._internalVars.dropdownContainer = this._internalVars.node.querySelectorAll(".filter-container");
	
	    this._internalVars.mobileOpen = this._internalVars.node.querySelector(".filter-mobile-open");
	    //this._internalVars.mobileClose = this._internalVars.node.querySelector(".filter-mobile-close");
	    this._internalVars.mobileBar = this._internalVars.node.querySelector(".filter-mobile-bar");
	    this._internalVars.mobileText = this._internalVars.node.querySelector(".filter-mobile-bar-text");
	}
	
	/**
	 * setEvents()
	 * Sets all the events needed for the component
	 */
	function setEvents() {
	    var _this = this;
	
	    var eventName = "click";
	
	    if ("ontouchstart" in document.documentElement) {
	        eventName = "touchstart";
	    }
	
	    //set click events
	    Array.prototype.forEach.call(this._internalVars.dropdownTrigger, function (el, i) {
	        el.addEventListener(eventName, dropdownClickHandler.bind(_this));
	    });
	    Array.prototype.forEach.call(this._internalVars.dropdownContainer, function (el, i) {
	        el.addEventListener("mouseleave", outsideFieldClickHandler.bind(_this));
	    });
	    Array.prototype.forEach.call(this._internalVars.checkbox, function (el, i) {
	        el.addEventListener('change', checkboxChangeHandler.bind(_this));
	    });
	
	    this._internalVars.clear.addEventListener(eventName, clearFilter.bind(this));
	    if (this._internalVars.search) {
	        this._internalVars.search.addEventListener('focus', searchFocus.bind(this));
	    }
	    this._internalVars.submit.addEventListener(eventName, submitFilter.bind(this));
	
	    // mobile
	    this._internalVars.mobileOpen.addEventListener(eventName, openDrawer.bind(this));
	    //this._internalVars.mobileClose.addEventListener(eventName, closeDrawer.bind(this) );
	}
	
	/**
	 * removeEvents()
	 * removes all events from the component
	 */
	function removeEvents() {
	    var _this2 = this;
	
	    var eventName = "click";
	
	    if ("ontouchstart" in document.documentElement) {
	        eventName = "touchstart";
	    }
	
	    //remove click events
	    Array.prototype.forEach.call(this._internalVars.dropdownTrigger, function (el, i) {
	        el.removeEventListener(eventName, dropdownClickHandler.bind(_this2));
	    });
	    Array.prototype.forEach.call(this._internalVars.checkbox, function (el, i) {
	        el.removeEventListener('change', checkboxChangeHandler.bind(_this2));
	    });
	
	    this._internalVars.clear.removeEventListener(eventName, clearFilter.bind(this));
	
	    this._internalVars.submit.removeEventListener(eventName, submitFilter.bind(this));
	
	    // mobile
	    this._internalVars.mobileOpen.removeEventListener(eventName, openDrawer.bind(this));
	    //this._internalVars.mobileClose.removeEventListener(eventName, closeDrawer.bind(this) );
	}
	
	/**
	 * openDrawer()
	 * opens the mobile filter drawer
	 */
	function openDrawer(el) {
	    if (utils.hasClass(this._internalVars.node, "-drawer-open")) {
	        closeDrawer.call(this);
	    } else {
	        this._internalVars.node.classList.add("-drawer-open");
	    }
	}
	
	/**
	 * closeDrawer()
	 * closes the mobile filter drawer
	 */
	function closeDrawer(el) {
	    this._internalVars.node.classList.remove("-drawer-open");
	}
	
	/**
	 * submitFilter()
	 * submits Filter form
	 */
	function submitFilter(el) {
	    var _this3 = this;
	
	    var data = serializeForm(this._internalVars.node);
	
	    // if mobile, close the drawer and update the filter text
	    if (_appState2['default'].mode === "mobile") {
	        var fields = Object.keys(data).length;
	
	        if (data.keywords !== '' || fields > 1) {
	            this._internalVars.mobileText.innerHTML = 'Showing filtered activities & policies';
	        } else {
	            this._internalVars.mobileText.innerHTML = 'Showing all activities & policies';
	        }
	        this._internalVars.node.classList.remove("-drawer-open");
	    }
	
	    // fire onFilterSubmit Callback if there is one
	    setTimeout(function () {
	        if (_this3._options.onFilterSubmit) _this3._options.onFilterSubmit(data);
	    }, 10);
	
	    return false;
	}
	
	/**
	 * serializeForm()
	 * serialize form into object
	 */
	function serializeForm(form) {
	    if (!form || form.nodeName !== "FORM") {
	        return;
	    }
	    var i,
	        j,
	        obj = {};
	    for (i = form.elements.length - 1; i >= 0; i = i - 1) {
	        if (form.elements[i].name === "") {
	            continue;
	        }
	        switch (form.elements[i].nodeName) {
	            case 'INPUT':
	                switch (form.elements[i].type) {
	                    case 'text':
	                    case 'hidden':
	                    case 'password':
	                    case 'button':
	                    case 'reset':
	                    case 'submit':
	                        obj[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
	                        break;
	                    case 'checkbox':
	                    case 'radio':
	                        if (form.elements[i].checked) {
	                            obj[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
	                        }
	                        break;
	                    case 'file':
	                        break;
	                }
	                break;
	            case 'TEXTAREA':
	                obj[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
	                break;
	            case 'SELECT':
	                switch (form.elements[i].type) {
	                    case 'select-one':
	                        obj[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
	                        break;
	                    case 'select-multiple':
	                        for (j = form.elements[i].options.length - 1; j >= 0; j = j - 1) {
	                            if (form.elements[i].options[j].selected) {
	                                obj[form.elements[i].name] = encodeURIComponent(form.elements[i].options[j].value);
	                            }
	                        }
	                        break;
	                }
	                break;
	            case 'BUTTON':
	                switch (form.elements[i].type) {
	                    case 'reset':
	                    case 'submit':
	                    case 'button':
	                        obj[form.elements[i].name] = encodeURIComponent(form.elements[i].value);
	                        break;
	                }
	                break;
	        }
	    }
	    return obj;
	}
	
	/**
	 * clearFilter()
	 * clears the timeline filters and unchecks all checkboxes
	 */
	function clearFilter(el) {
	    var _this4 = this;
	
	    // unchecks all checkboxes
	    Array.prototype.forEach.call(this._internalVars.checkbox, function (el, i) {
	
	        el.checked = false;
	    });
	
	    // update notification bubble to 0
	    Array.prototype.forEach.call(this._internalVars.dropdownTrigger, function (el, i) {
	
	        updateNotificationBubble(el, 0);
	    });
	
	    // clears search field
	    if (this._internalVars.search) {
	        this._internalVars.search.value = '';
	    }
	
	    // fire onClearFilter Callback if there is one
	    setTimeout(function () {
	        if (_this4._options.onClearFilter) _this4._options.onClearFilter();
	    }, 10);
	}
	
	/**
	 * checkboxChangeHandler()
	 * updates the notification of how many checkboxes are selected per dropdown
	 */
	function checkboxChangeHandler(el) {
	
	    var currentNode = el.currentTarget;
	
	    var dropdownParent = findAncestor(currentNode, 'filter-dropdown');
	    var dropdownTrigger = dropdownParent.previousSibling.previousSibling;
	
	    var total = dropdownParent.querySelectorAll('input[type="checkbox"]:checked').length;
	
	    updateNotificationBubble(dropdownTrigger, total);
	}
	
	/**
	 * findAncestor()
	 * Finds nearest ancestor with specified class
	 */
	function findAncestor(el, cls) {
	    while ((el = el.parentElement) && !el.classList.contains(cls));
	    return el;
	}
	
	/**
	 * checkboxChangeHandler()
	 * updates the notification of how many checkboxes are selected per dropdown
	 */
	function updateNotificationBubble(el, value) {
	
	    var bubble = el.getElementsByClassName('dropdown-notify')[0];
	    bubble.innerHTML = value;
	
	    if (value > 0) {
	        bubble.classList.add("-visible");
	    } else {
	        bubble.classList.remove("-visible");
	    }
	}
	
	/**
	 * dropdownClickHandler()
	 * Opens tab content for clicked tab and hides the rest
	 */
	function dropdownClickHandler(el) {
	
	    var currentNode = el.currentTarget;
	    currentNode.focus();
	    // add -active class
	    Array.prototype.map.call(this._internalVars.dropdownTrigger, function (e, rank) {
	        if (e === currentNode && e === document.activeElement) {
	            // if already has active class, remove it
	            if (utils.hasClass(e, 'filter-dropdown-trigger--active')) {
	                e.classList.remove("filter-dropdown-trigger--active");
	                if (_appState2['default'].mode == 'desktop') e.setAttribute('aria-expanded', 'false');
	            } else {
	                e.classList.add("filter-dropdown-trigger--active");
	                if (_appState2['default'].mode == 'desktop') {
	                    e.setAttribute('aria-expanded', 'true');
	                }
	            }
	        } else {
	            e.classList.remove("filter-dropdown-trigger--active");
	            if (_appState2['default'].mode == 'desktop') e.setAttribute('aria-expanded', 'false');
	        }
	    });
	}
	
	/**
	 * dropdownClickHandler()
	 * Opens tab content for clicked tab and hides the rest
	 */
	function outsideFieldClickHandler(el) {
	
	    var currentNode = el.currentTarget;
	    // add -active class
	    Array.prototype.map.call(this._internalVars.dropdownTrigger, function (e, rank) {
	        if (e === currentNode) {
	            // if already has active class, remove it
	            if (utils.hasClass(e, 'filter-dropdown-trigger--active')) {
	                e.classList.remove("filter-dropdown-trigger--active");
	                if (_appState2['default'].mode == 'desktop') e.setAttribute('aria-expanded', 'false');
	            }
	        } else {
	            e.classList.remove("filter-dropdown-trigger--active");
	            if (_appState2['default'].mode == 'desktop') e.setAttribute('aria-expanded', 'false');
	        }
	    });
	}
	
	/**
	 * searchFocus()
	 * Closes all dropdowns on search focus
	 */
	function searchFocus(el) {
	    // add -active class
	    Array.prototype.map.call(this._internalVars.dropdownTrigger, function (e, rank) {
	        e.classList.remove("filter-dropdown-trigger--active");
	        if (_appState2['default'].mode == 'desktop') e.setAttribute('aria-expanded', 'false');
	    });
	}
	
	exports['default'] = TimelineFilter;
	module.exports = exports['default'];

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	//Module Imports
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var Hogan = __webpack_require__(39);
	var template = '{{# years}}<li class="entry -year">{{year}}</li>{{# entries}}<li class="entry -{{timescale}} {{#first-transaction-of-year}}-firstofyear{{/first-transaction-of-year}}"><div class="entry-date">{{#present}}<strong>Today</strong><br> {{/present}} {{{date-month}}} {{date-day}} <br> {{time}}</div><ol class="entry-transactions">{{# sessions}}<li class="session" data-session-id="{{id}}">{{# transactions}}<div class="transaction {{#view-details}}transaction-has-details{{/view-details}} section--{{color}}" data-type="{{type}}" data-policy="{{policy}}"><div class="transaction-type"><span class="geico-icon icon-{{type}}"></span></div><div class="transaction-content"><h3>{{title}}</h3><p>{{summary}}</p>{{#view-link}}<a href="{{link-url}}" class="transaction-details-button"><span>{{link-text}}</span></a>{{/view-link}} {{#view-link-btn}}<a href="{{link-url}}" class="btn btn--primary btn--{{color}} btn--full-mobile"><span>{{link-text}}</span></a>{{/view-link-btn}}<div class="transaction-details-action">                                                      {{#view-balance}}<div class="transaction-balance">Balance: <span>{{balance}}</span></div>{{/view-balance}}</div> {{#view-details}}<a class="transaction-details-toggle"><span>Details</span></a><div class="transaction-details">{{{details}}}</div>{{/view-details}}</div><div class="transaction-action">{{#view-link-desktop}}<a href="{{link-url}}" class="btn btn--primary btn--{{color}}"><span>{{link-text}}</span></a>{{/view-link-desktop}}                      {{^view-link}}{{#view-balance}}<div class="transaction-balance">Balance<br> <span>{{balance}}</span></div>{{/view-balance}}{{#view-details}}<div class="transaction-divider"></div><div class="transaction-details-link"><a href="javascript:void(0)" class="transaction-details-toggle"><span>Details</span></a></div>{{/view-details}}{{/view-link}}     </div></div>{{/ transactions}}</li>{{/ sessions}}</ol></li>{{/ entries}}{{/ years}}{{^ years}}<li class="entry -no-results"><p>Your search has returned 0 results.<br> Please, try again.</p></li>{{/ years}}';
	
	var HoganTemplate = Hogan.compile(template);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK Timeline : Content must be defined and set to a DOM selector or Node"]
	}, {
	    setting: "data",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["object"],
	    errorMessage: ["GDK Timeline : Data must be a valid JSON object"]
	}];
	
	var Timeline = (function () {
	    /**
	     * Refer to the design kit section of this component for JS examples and setting details.
	     * @param {string, Object} content
	     *  A reference to the html timeline node
	     *
	     * @param {JSON Object} data
	     * A reference to a valid JSON object which will be used to render the initial state of the timeline
	     *
	     */
	
	    function Timeline(options) {
	        _classCallCheck(this, Timeline);
	
	        this._internalVars = {
	            node: null, //used for content item
	            data: null,
	            transactionDetails: null
	        };
	
	        //options with defaults set
	        this._defaults = {};
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2['default'].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2['default'].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2['default'].getContentType(this);
	            setLocalVars.call(this);
	            setEvents.call(this);
	            // render data
	            render.call(this);
	        }
	    }
	
	    // Private Methods
	    /**
	     * render()
	     * Initial Render of Timeline
	     */
	
	    //Public Methods
	    /**
	    * update()
	    * Rerender timeline with new data
	    */
	
	    _createClass(Timeline, [{
	        key: 'update',
	        value: function update(data) {
	
	            var output = HoganTemplate.render(data);
	            this._internalVars.node.innerHTML = output;
	        }
	
	        /**
	         * destroy()
	         * removes the node from the dom and any events attached
	         */
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            removeEvents.call(this);
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return Timeline;
	})();
	
	function render(el) {
	
	    var output = HoganTemplate.render(this._internalVars.data);
	
	    this._internalVars.node.innerHTML = output;
	}
	/**
	 * setEvents()
	 * Sets all the events needed for the component
	 */
	function setEvents() {
	
	    live('.transaction.transaction-has-details', "click", function () {
	        detailsClickHandler(this);
	    }, this._internalVars.node);
	}
	
	/**
	 * removeEvents()
	 * removes all events from the component
	 */
	function removeEvents() {
	    var _this = this;
	
	    // TODO need to fix with new live handler
	    //remove click events
	
	    this._internalVars.transactionDetails = this._internalVars.node.querySelectorAll(".transaction-has-details");
	
	    Array.prototype.forEach.call(this._internalVars.transactionDetails, function (el, i) {
	        el.removeEventListener("click", detailsClickHandler.bind(_this));
	    });
	}
	
	/**
	 * detailsClickHandler()
	 * Opens details drawer for specified transaction
	 */
	function detailsClickHandler(el) {
	
	    // toggle class
	    el.classList.toggle("transaction-details-open");
	}
	
	/**
	 * findAncestor()
	 * Finds nearest ancestor with specified class
	 */
	function findAncestor(el, cls) {
	    while ((el = el.parentElement) && !el.classList.contains(cls));
	    return el;
	}
	
	/**
	 * setLocalVars()
	 * set all the local vars to passed in options
	 */
	function setLocalVars() {
	    //determine the type of content passed in
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    this._internalVars.data = this._options.data;
	}
	
	function addEvent(el, type, handler) {
	    if (el.attachEvent) el.attachEvent('on' + type, handler);else el.addEventListener(type, handler);
	}
	
	// live binding helper with CSS selector
	function live(selector, event, callback, context) {
	    addEvent(context || document, event, function (e) {
	        var qs = (context || document).querySelectorAll(selector);
	        if (qs) {
	            var el = e.target || e.srcElement,
	                index = -1;
	            while (el && (index = Array.prototype.indexOf.call(qs, el)) === -1) el = el.parentElement;
	            if (index > -1) callback.call(el, e);
	        }
	    });
	}
	
	exports['default'] = Timeline;
	module.exports = exports['default'];

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 *  Copyright 2011 Twitter, Inc.
	 *  Licensed under the Apache License, Version 2.0 (the "License");
	 *  you may not use this file except in compliance with the License.
	 *  You may obtain a copy of the License at
	 *
	 *  http://www.apache.org/licenses/LICENSE-2.0
	 *
	 *  Unless required by applicable law or agreed to in writing, software
	 *  distributed under the License is distributed on an "AS IS" BASIS,
	 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 *  See the License for the specific language governing permissions and
	 *  limitations under the License.
	 */
	
	// This file is for use with Node.js. See dist/ for browser files.
	
	'use strict';
	
	var Hogan = __webpack_require__(40);
	Hogan.Template = __webpack_require__(41).Template;
	Hogan.template = Hogan.Template;
	module.exports = Hogan;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 *  Copyright 2011 Twitter, Inc.
	 *  Licensed under the Apache License, Version 2.0 (the "License");
	 *  you may not use this file except in compliance with the License.
	 *  You may obtain a copy of the License at
	 *
	 *  http://www.apache.org/licenses/LICENSE-2.0
	 *
	 *  Unless required by applicable law or agreed to in writing, software
	 *  distributed under the License is distributed on an "AS IS" BASIS,
	 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 *  See the License for the specific language governing permissions and
	 *  limitations under the License.
	 */
	
	'use strict';
	
	(function (Hogan) {
	  // Setup regex  assignments
	  // remove whitespace according to Mustache spec
	  var rIsWhitespace = /\S/,
	      rQuot = /\"/g,
	      rNewline = /\n/g,
	      rCr = /\r/g,
	      rSlash = /\\/g,
	      rLineSep = /\u2028/,
	      rParagraphSep = /\u2029/;
	
	  Hogan.tags = {
	    '#': 1, '^': 2, '<': 3, '$': 4,
	    '/': 5, '!': 6, '>': 7, '=': 8, '_v': 9,
	    '{': 10, '&': 11, '_t': 12
	  };
	
	  Hogan.scan = function scan(text, delimiters) {
	    var len = text.length,
	        IN_TEXT = 0,
	        IN_TAG_TYPE = 1,
	        IN_TAG = 2,
	        state = IN_TEXT,
	        tagType = null,
	        tag = null,
	        buf = '',
	        tokens = [],
	        seenTag = false,
	        i = 0,
	        lineStart = 0,
	        otag = '{{',
	        ctag = '}}';
	
	    function addBuf() {
	      if (buf.length > 0) {
	        tokens.push({ tag: '_t', text: new String(buf) });
	        buf = '';
	      }
	    }
	
	    function lineIsWhitespace() {
	      var isAllWhitespace = true;
	      for (var j = lineStart; j < tokens.length; j++) {
	        isAllWhitespace = Hogan.tags[tokens[j].tag] < Hogan.tags['_v'] || tokens[j].tag == '_t' && tokens[j].text.match(rIsWhitespace) === null;
	        if (!isAllWhitespace) {
	          return false;
	        }
	      }
	
	      return isAllWhitespace;
	    }
	
	    function filterLine(haveSeenTag, noNewLine) {
	      addBuf();
	
	      if (haveSeenTag && lineIsWhitespace()) {
	        for (var j = lineStart, next; j < tokens.length; j++) {
	          if (tokens[j].text) {
	            if ((next = tokens[j + 1]) && next.tag == '>') {
	              // set indent to token value
	              next.indent = tokens[j].text.toString();
	            }
	            tokens.splice(j, 1);
	          }
	        }
	      } else if (!noNewLine) {
	        tokens.push({ tag: '\n' });
	      }
	
	      seenTag = false;
	      lineStart = tokens.length;
	    }
	
	    function changeDelimiters(text, index) {
	      var close = '=' + ctag,
	          closeIndex = text.indexOf(close, index),
	          delimiters = trim(text.substring(text.indexOf('=', index) + 1, closeIndex)).split(' ');
	
	      otag = delimiters[0];
	      ctag = delimiters[delimiters.length - 1];
	
	      return closeIndex + close.length - 1;
	    }
	
	    if (delimiters) {
	      delimiters = delimiters.split(' ');
	      otag = delimiters[0];
	      ctag = delimiters[1];
	    }
	
	    for (i = 0; i < len; i++) {
	      if (state == IN_TEXT) {
	        if (tagChange(otag, text, i)) {
	          --i;
	          addBuf();
	          state = IN_TAG_TYPE;
	        } else {
	          if (text.charAt(i) == '\n') {
	            filterLine(seenTag);
	          } else {
	            buf += text.charAt(i);
	          }
	        }
	      } else if (state == IN_TAG_TYPE) {
	        i += otag.length - 1;
	        tag = Hogan.tags[text.charAt(i + 1)];
	        tagType = tag ? text.charAt(i + 1) : '_v';
	        if (tagType == '=') {
	          i = changeDelimiters(text, i);
	          state = IN_TEXT;
	        } else {
	          if (tag) {
	            i++;
	          }
	          state = IN_TAG;
	        }
	        seenTag = i;
	      } else {
	        if (tagChange(ctag, text, i)) {
	          tokens.push({ tag: tagType, n: trim(buf), otag: otag, ctag: ctag,
	            i: tagType == '/' ? seenTag - otag.length : i + ctag.length });
	          buf = '';
	          i += ctag.length - 1;
	          state = IN_TEXT;
	          if (tagType == '{') {
	            if (ctag == '}}') {
	              i++;
	            } else {
	              cleanTripleStache(tokens[tokens.length - 1]);
	            }
	          }
	        } else {
	          buf += text.charAt(i);
	        }
	      }
	    }
	
	    filterLine(seenTag, true);
	
	    return tokens;
	  };
	
	  function cleanTripleStache(token) {
	    if (token.n.substr(token.n.length - 1) === '}') {
	      token.n = token.n.substring(0, token.n.length - 1);
	    }
	  }
	
	  function trim(s) {
	    if (s.trim) {
	      return s.trim();
	    }
	
	    return s.replace(/^\s*|\s*$/g, '');
	  }
	
	  function tagChange(tag, text, index) {
	    if (text.charAt(index) != tag.charAt(0)) {
	      return false;
	    }
	
	    for (var i = 1, l = tag.length; i < l; i++) {
	      if (text.charAt(index + i) != tag.charAt(i)) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  // the tags allowed inside super templates
	  var allowedInSuper = { '_t': true, '\n': true, '$': true, '/': true };
	
	  function buildTree(tokens, kind, stack, customTags) {
	    var instructions = [],
	        opener = null,
	        tail = null,
	        token = null;
	
	    tail = stack[stack.length - 1];
	
	    while (tokens.length > 0) {
	      token = tokens.shift();
	
	      if (tail && tail.tag == '<' && !(token.tag in allowedInSuper)) {
	        throw new Error('Illegal content in < super tag.');
	      }
	
	      if (Hogan.tags[token.tag] <= Hogan.tags['$'] || isOpener(token, customTags)) {
	        stack.push(token);
	        token.nodes = buildTree(tokens, token.tag, stack, customTags);
	      } else if (token.tag == '/') {
	        if (stack.length === 0) {
	          throw new Error('Closing tag without opener: /' + token.n);
	        }
	        opener = stack.pop();
	        if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) {
	          throw new Error('Nesting error: ' + opener.n + ' vs. ' + token.n);
	        }
	        opener.end = token.i;
	        return instructions;
	      } else if (token.tag == '\n') {
	        token.last = tokens.length == 0 || tokens[0].tag == '\n';
	      }
	
	      instructions.push(token);
	    }
	
	    if (stack.length > 0) {
	      throw new Error('missing closing tag: ' + stack.pop().n);
	    }
	
	    return instructions;
	  }
	
	  function isOpener(token, tags) {
	    for (var i = 0, l = tags.length; i < l; i++) {
	      if (tags[i].o == token.n) {
	        token.tag = '#';
	        return true;
	      }
	    }
	  }
	
	  function isCloser(close, open, tags) {
	    for (var i = 0, l = tags.length; i < l; i++) {
	      if (tags[i].c == close && tags[i].o == open) {
	        return true;
	      }
	    }
	  }
	
	  function stringifySubstitutions(obj) {
	    var items = [];
	    for (var key in obj) {
	      items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + '}');
	    }
	    return "{ " + items.join(",") + " }";
	  }
	
	  function stringifyPartials(codeObj) {
	    var partials = [];
	    for (var key in codeObj.partials) {
	      partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
	    }
	    return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
	  }
	
	  Hogan.stringify = function (codeObj, text, options) {
	    return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) + "}";
	  };
	
	  var serialNo = 0;
	  Hogan.generate = function (tree, text, options) {
	    serialNo = 0;
	    var context = { code: '', subs: {}, partials: {} };
	    Hogan.walk(tree, context);
	
	    if (options.asString) {
	      return this.stringify(context, text, options);
	    }
	
	    return this.makeTemplate(context, text, options);
	  };
	
	  Hogan.wrapMain = function (code) {
	    return 'var t=this;t.b(i=i||"");' + code + 'return t.fl();';
	  };
	
	  Hogan.template = Hogan.Template;
	
	  Hogan.makeTemplate = function (codeObj, text, options) {
	    var template = this.makePartials(codeObj);
	    template.code = new Function('c', 'p', 'i', this.wrapMain(codeObj.code));
	    return new this.template(template, text, this, options);
	  };
	
	  Hogan.makePartials = function (codeObj) {
	    var key,
	        template = { subs: {}, partials: codeObj.partials, name: codeObj.name };
	    for (key in template.partials) {
	      template.partials[key] = this.makePartials(template.partials[key]);
	    }
	    for (key in codeObj.subs) {
	      template.subs[key] = new Function('c', 'p', 't', 'i', codeObj.subs[key]);
	    }
	    return template;
	  };
	
	  function esc(s) {
	    return s.replace(rSlash, '\\\\').replace(rQuot, '\\\"').replace(rNewline, '\\n').replace(rCr, '\\r').replace(rLineSep, '\\u2028').replace(rParagraphSep, '\\u2029');
	  }
	
	  function chooseMethod(s) {
	    return ~s.indexOf('.') ? 'd' : 'f';
	  }
	
	  function createPartial(node, context) {
	    var prefix = "<" + (context.prefix || "");
	    var sym = prefix + node.n + serialNo++;
	    context.partials[sym] = { name: node.n, partials: {} };
	    context.code += 't.b(t.rp("' + esc(sym) + '",c,p,"' + (node.indent || '') + '"));';
	    return sym;
	  }
	
	  Hogan.codegen = {
	    '#': function _(node, context) {
	      context.code += 'if(t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' + 'c,p,0,' + node.i + ',' + node.end + ',"' + node.otag + " " + node.ctag + '")){' + 't.rs(c,p,' + 'function(c,p,t){';
	      Hogan.walk(node.nodes, context);
	      context.code += '});c.pop();}';
	    },
	
	    '^': function _(node, context) {
	      context.code += 'if(!t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
	      Hogan.walk(node.nodes, context);
	      context.code += '};';
	    },
	
	    '>': createPartial,
	    '<': function _(node, context) {
	      var ctx = { partials: {}, code: '', subs: {}, inPartial: true };
	      Hogan.walk(node.nodes, ctx);
	      var template = context.partials[createPartial(node, context)];
	      template.subs = ctx.subs;
	      template.partials = ctx.partials;
	    },
	
	    '$': function $(node, context) {
	      var ctx = { subs: {}, code: '', partials: context.partials, prefix: node.n };
	      Hogan.walk(node.nodes, ctx);
	      context.subs[node.n] = ctx.code;
	      if (!context.inPartial) {
	        context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
	      }
	    },
	
	    '\n': function _(node, context) {
	      context.code += write('"\\n"' + (node.last ? '' : ' + i'));
	    },
	
	    '_v': function _v(node, context) {
	      context.code += 't.b(t.v(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
	    },
	
	    '_t': function _t(node, context) {
	      context.code += write('"' + esc(node.text) + '"');
	    },
	
	    '{': tripleStache,
	
	    '&': tripleStache
	  };
	
	  function tripleStache(node, context) {
	    context.code += 't.b(t.t(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
	  }
	
	  function write(s) {
	    return 't.b(' + s + ');';
	  }
	
	  Hogan.walk = function (nodelist, context) {
	    var func;
	    for (var i = 0, l = nodelist.length; i < l; i++) {
	      func = Hogan.codegen[nodelist[i].tag];
	      func && func(nodelist[i], context);
	    }
	    return context;
	  };
	
	  Hogan.parse = function (tokens, text, options) {
	    options = options || {};
	    return buildTree(tokens, '', [], options.sectionTags || []);
	  };
	
	  Hogan.cache = {};
	
	  Hogan.cacheKey = function (text, options) {
	    return [text, !!options.asString, !!options.disableLambda, options.delimiters, !!options.modelGet].join('||');
	  };
	
	  Hogan.compile = function (text, options) {
	    options = options || {};
	    var key = Hogan.cacheKey(text, options);
	    var template = this.cache[key];
	
	    if (template) {
	      var partials = template.partials;
	      for (var name in partials) {
	        delete partials[name].instance;
	      }
	      return template;
	    }
	
	    template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
	    return this.cache[key] = template;
	  };
	})( true ? exports : Hogan);

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 *  Copyright 2011 Twitter, Inc.
	 *  Licensed under the Apache License, Version 2.0 (the "License");
	 *  you may not use this file except in compliance with the License.
	 *  You may obtain a copy of the License at
	 *
	 *  http://www.apache.org/licenses/LICENSE-2.0
	 *
	 *  Unless required by applicable law or agreed to in writing, software
	 *  distributed under the License is distributed on an "AS IS" BASIS,
	 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 *  See the License for the specific language governing permissions and
	 *  limitations under the License.
	 */
	
	'use strict';
	
	var Hogan = {};
	
	(function (Hogan) {
	  Hogan.Template = function (codeObj, text, compiler, options) {
	    codeObj = codeObj || {};
	    this.r = codeObj.code || this.r;
	    this.c = compiler;
	    this.options = options || {};
	    this.text = text || '';
	    this.partials = codeObj.partials || {};
	    this.subs = codeObj.subs || {};
	    this.buf = '';
	  };
	
	  Hogan.Template.prototype = {
	    // render: replaced by generated code.
	    r: function r(context, partials, indent) {
	      return '';
	    },
	
	    // variable escaping
	    v: hoganEscape,
	
	    // triple stache
	    t: coerceToString,
	
	    render: function render(context, partials, indent) {
	      return this.ri([context], partials || {}, indent);
	    },
	
	    // render internal -- a hook for overrides that catches partials too
	    ri: function ri(context, partials, indent) {
	      return this.r(context, partials, indent);
	    },
	
	    // ensurePartial
	    ep: function ep(symbol, partials) {
	      var partial = this.partials[symbol];
	
	      // check to see that if we've instantiated this partial before
	      var template = partials[partial.name];
	      if (partial.instance && partial.base == template) {
	        return partial.instance;
	      }
	
	      if (typeof template == 'string') {
	        if (!this.c) {
	          throw new Error("No compiler available.");
	        }
	        template = this.c.compile(template, this.options);
	      }
	
	      if (!template) {
	        return null;
	      }
	
	      // We use this to check whether the partials dictionary has changed
	      this.partials[symbol].base = template;
	
	      if (partial.subs) {
	        // Make sure we consider parent template now
	        if (!partials.stackText) partials.stackText = {};
	        for (key in partial.subs) {
	          if (!partials.stackText[key]) {
	            partials.stackText[key] = this.activeSub !== undefined && partials.stackText[this.activeSub] ? partials.stackText[this.activeSub] : this.text;
	          }
	        }
	        template = createSpecializedPartial(template, partial.subs, partial.partials, this.stackSubs, this.stackPartials, partials.stackText);
	      }
	      this.partials[symbol].instance = template;
	
	      return template;
	    },
	
	    // tries to find a partial in the current scope and render it
	    rp: function rp(symbol, context, partials, indent) {
	      var partial = this.ep(symbol, partials);
	      if (!partial) {
	        return '';
	      }
	
	      return partial.ri(context, partials, indent);
	    },
	
	    // render a section
	    rs: function rs(context, partials, section) {
	      var tail = context[context.length - 1];
	
	      if (!isArray(tail)) {
	        section(context, partials, this);
	        return;
	      }
	
	      for (var i = 0; i < tail.length; i++) {
	        context.push(tail[i]);
	        section(context, partials, this);
	        context.pop();
	      }
	    },
	
	    // maybe start a section
	    s: function s(val, ctx, partials, inverted, start, end, tags) {
	      var pass;
	
	      if (isArray(val) && val.length === 0) {
	        return false;
	      }
	
	      if (typeof val == 'function') {
	        val = this.ms(val, ctx, partials, inverted, start, end, tags);
	      }
	
	      pass = !!val;
	
	      if (!inverted && pass && ctx) {
	        ctx.push(typeof val == 'object' ? val : ctx[ctx.length - 1]);
	      }
	
	      return pass;
	    },
	
	    // find values with dotted names
	    d: function d(key, ctx, partials, returnFound) {
	      var found,
	          names = key.split('.'),
	          val = this.f(names[0], ctx, partials, returnFound),
	          doModelGet = this.options.modelGet,
	          cx = null;
	
	      if (key === '.' && isArray(ctx[ctx.length - 2])) {
	        val = ctx[ctx.length - 1];
	      } else {
	        for (var i = 1; i < names.length; i++) {
	          found = findInScope(names[i], val, doModelGet);
	          if (found !== undefined) {
	            cx = val;
	            val = found;
	          } else {
	            val = '';
	          }
	        }
	      }
	
	      if (returnFound && !val) {
	        return false;
	      }
	
	      if (!returnFound && typeof val == 'function') {
	        ctx.push(cx);
	        val = this.mv(val, ctx, partials);
	        ctx.pop();
	      }
	
	      return val;
	    },
	
	    // find values with normal names
	    f: function f(key, ctx, partials, returnFound) {
	      var val = false,
	          v = null,
	          found = false,
	          doModelGet = this.options.modelGet;
	
	      for (var i = ctx.length - 1; i >= 0; i--) {
	        v = ctx[i];
	        val = findInScope(key, v, doModelGet);
	        if (val !== undefined) {
	          found = true;
	          break;
	        }
	      }
	
	      if (!found) {
	        return returnFound ? false : "";
	      }
	
	      if (!returnFound && typeof val == 'function') {
	        val = this.mv(val, ctx, partials);
	      }
	
	      return val;
	    },
	
	    // higher order templates
	    ls: function ls(func, cx, partials, text, tags) {
	      var oldTags = this.options.delimiters;
	
	      this.options.delimiters = tags;
	      this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
	      this.options.delimiters = oldTags;
	
	      return false;
	    },
	
	    // compile text
	    ct: function ct(text, cx, partials) {
	      if (this.options.disableLambda) {
	        throw new Error('Lambda features disabled.');
	      }
	      return this.c.compile(text, this.options).render(cx, partials);
	    },
	
	    // template result buffering
	    b: function b(s) {
	      this.buf += s;
	    },
	
	    fl: function fl() {
	      var r = this.buf;this.buf = '';return r;
	    },
	
	    // method replace section
	    ms: function ms(func, ctx, partials, inverted, start, end, tags) {
	      var textSource,
	          cx = ctx[ctx.length - 1],
	          result = func.call(cx);
	
	      if (typeof result == 'function') {
	        if (inverted) {
	          return true;
	        } else {
	          textSource = this.activeSub && this.subsText && this.subsText[this.activeSub] ? this.subsText[this.activeSub] : this.text;
	          return this.ls(result, cx, partials, textSource.substring(start, end), tags);
	        }
	      }
	
	      return result;
	    },
	
	    // method replace variable
	    mv: function mv(func, ctx, partials) {
	      var cx = ctx[ctx.length - 1];
	      var result = func.call(cx);
	
	      if (typeof result == 'function') {
	        return this.ct(coerceToString(result.call(cx)), cx, partials);
	      }
	
	      return result;
	    },
	
	    sub: function sub(name, context, partials, indent) {
	      var f = this.subs[name];
	      if (f) {
	        this.activeSub = name;
	        f(context, partials, this, indent);
	        this.activeSub = false;
	      }
	    }
	
	  };
	
	  //Find a key in an object
	  function findInScope(key, scope, doModelGet) {
	    var val;
	
	    if (scope && typeof scope == 'object') {
	
	      if (scope[key] !== undefined) {
	        val = scope[key];
	
	        // try lookup with get for backbone or similar model data
	      } else if (doModelGet && scope.get && typeof scope.get == 'function') {
	          val = scope.get(key);
	        }
	    }
	
	    return val;
	  }
	
	  function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
	    function PartialTemplate() {};
	    PartialTemplate.prototype = instance;
	    function Substitutions() {};
	    Substitutions.prototype = instance.subs;
	    var key;
	    var partial = new PartialTemplate();
	    partial.subs = new Substitutions();
	    partial.subsText = {}; //hehe. substext.
	    partial.buf = '';
	
	    stackSubs = stackSubs || {};
	    partial.stackSubs = stackSubs;
	    partial.subsText = stackText;
	    for (key in subs) {
	      if (!stackSubs[key]) stackSubs[key] = subs[key];
	    }
	    for (key in stackSubs) {
	      partial.subs[key] = stackSubs[key];
	    }
	
	    stackPartials = stackPartials || {};
	    partial.stackPartials = stackPartials;
	    for (key in partials) {
	      if (!stackPartials[key]) stackPartials[key] = partials[key];
	    }
	    for (key in stackPartials) {
	      partial.partials[key] = stackPartials[key];
	    }
	
	    return partial;
	  }
	
	  var rAmp = /&/g,
	      rLt = /</g,
	      rGt = />/g,
	      rApos = /\'/g,
	      rQuot = /\"/g,
	      hChars = /[&<>\"\']/;
	
	  function coerceToString(val) {
	    return String(val === null || val === undefined ? '' : val);
	  }
	
	  function hoganEscape(str) {
	    str = coerceToString(str);
	    return hChars.test(str) ? str.replace(rAmp, '&amp;').replace(rLt, '&lt;').replace(rGt, '&gt;').replace(rApos, '&#39;').replace(rQuot, '&quot;') : str;
	  }
	
	  var isArray = Array.isArray || function (a) {
	    return Object.prototype.toString.call(a) === '[object Array]';
	  };
	})( true ? exports : Hogan);

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	
	//Module Imports
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK Accordion : Content must be defined and set to a DOM selector or Node"]
	}, {
	    setting: "initiallyOpenedElement",
	    isRequired: false,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK Accordion : Content must be defined and set to a DOM selector or Node"]
	}, {
	    setting: "shouldCloseOthers",
	    isRequired: false,
	    validate: "type", //a type or a value
	    possibleValues: ["boolean"],
	    errorMessage: ["GDK Accordion : shouldCloseOthers must be set to a boolean"]
	},
	/**
	 * Design Kit DEVELOPERS USE ONLY:
	 *
	 * forceOpenSingleAccordionElement is to be used only when there is a single, forced opened element of the accordion
	 * Case Study: Mobile Navigation when there is a single Tier 1 element, which is forcefully opened in the mobile view,
	 * so it won't require additional click to open when user use the navigation.
	 *
	 * NOTE: The force-open element DO NOT have accordion functionality to retract and stays expanded at all times.
	 */
	{
	    setting: "forceOpenSingleAccordionElement",
	    isRequired: false,
	    validate: "type", //a type or a value
	    possibleValues: ["boolean"],
	    errorMessage: ["GDK Accordion : forceOpenSingleAccordionElement must be set as a boolean"]
	}, {
	    setting: "accordionOpenClicked",
	    isRequired: false,
	    validate: "type",
	    possibleValues: ["function"],
	    errorMessage: ["GDK Accordion : accordionOpenClicked must be a function"]
	}, {
	    setting: "accordionCloseClicked",
	    isRequired: false,
	    validate: "type",
	    possibleValues: ["function"],
	    errorMessage: ["GDK Accordion : accordionCloseClicked must be a function"]
	}];
	
	var Accordion = (function () {
	
	    /**
	     * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	     * @param {string|Object} content
	     * A reference to the html accordion node
	     *
	     * @param {string|Object} initiallyOpenedElement
	     * A reference to the html accordion li tag element that should be opened on start
	     *
	     * @param {boolean} [shouldCloseOthers="true"]
	     * Used to set URL target to open in same page or in a new window/tab
	     *
	     * @param {function} [accordionOpenClicked]
	     * A callback function that gets fired when an accordion tab opens up. Param currentNode is optional and refers to the target clicked.
	     *
	     * @param {function} [accordionCloseClicked]
	     *  A callback function that gets fired when an accordion tab closes. Param currentNode is optional and refers to the target clicked.
	     */
	
	    function Accordion(options) {
	        _classCallCheck(this, Accordion);
	
	        this._internalVars = {
	            node: null, //used for content item
	            headline: null,
	            contentContainer: null,
	            content: null
	        };
	
	        //options with defaults set
	        this._defaults = {
	            shouldCloseOthers: true,
	            forceOpenSingleAccordionElement: false
	        };
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2["default"].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2["default"].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2["default"].getContentType(this);
	            setLocalVars.call(this);
	            setEvents.call(this);
	            if (this._options.initiallyOpenedElement) {
	                openInitialElements.call(this);
	            }
	            var allAccordionHeadlines = this._internalVars.node.querySelectorAll('.accordion-headline');
	            Array.prototype.forEach.call(allAccordionHeadlines, function (el, i) {
	                if (!el.getAttribute('tabindex')) el.setAttribute('tabindex', '0');
	
	                el.setAttribute('role', 'button');
	            });
	        }
	
	        window.addEventListener('resize', function () {
	            //handleResize.call(this);
	        });
	    }
	
	    // Private Methods
	    /**
	     * openInitialElement()
	     * a private method which is only invoked when the initiallyOpenedElement property is set.
	     */
	
	    //Public Methods
	
	    /**
	     * destroy()
	     * removes the node from the dom and any events attached
	     */
	
	    _createClass(Accordion, [{
	        key: "destroy",
	        value: function destroy() {
	            removeEvents.call(this);
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return Accordion;
	})();
	
	function openInitialElements() {
	    var element = undefined;
	    if (typeof this._options.initiallyOpenedElement === 'string') {
	        element = this._internalVars.node.querySelector(this._options.initiallyOpenedElement);
	        openAccordionElement.call(this, element);
	    } else if (typeof this._options.initiallyOpenedElement === 'object') {
	        element = this._options.initiallyOpenedElement;
	        openAccordionElement.call(this, element);
	    }
	}
	
	/**
	 * setEvents()
	 * Sets all the events needed for the component
	 */
	function setEvents() {
	    var _this = this;
	
	    if (this._internalVars.node.childElementCount == 1 && this._options.forceOpenSingleAccordionElement) {
	        console.log("The single element will be forced opened");
	        forceOpenAccordion(this._internalVars.node.children[0]);
	    } else {
	        (function () {
	            var eventName = "click";
	            if ("ontouchstart" in document.documentElement) {
	                eventName = "click";
	            }
	
	            Array.prototype.forEach.call(_this._internalVars.headline, function (el, i) {
	                el.addEventListener(eventName, _this._internalVars.handler);
	                el.addEventListener("keyup", _this._internalVars.handler);
	                el.addEventListener('keyup', function (e) {
	                    if (e.shiftKey && e.keyCode == 9 || e.keyCode == 9) {
	                        el.classList.add('keyboard-focus');
	                    }
	                });
	                el.addEventListener('blur', function (e) {
	                    el.classList.remove('keyboard-focus');
	                });
	            });
	        })();
	    }
	}
	
	/**
	 * removeEvents()
	 * removes all events from the component
	 */
	function removeEvents() {
	    var _this2 = this;
	
	    var eventName = "click";
	    if ("ontouchstart" in document.documentElement) {
	        eventName = "click";
	    }
	    Array.prototype.forEach.call(this._internalVars.headline, function (el, i) {
	        el.removeEventListener(eventName, _this2._internalVars.handler);
	    });
	}
	
	/**
	 * toggleAccordion()
	 * opens or closes an accordions content
	 *
	 * @param  {Object} node    DOM node that was clicked
	 */
	function toggleAccordion(el) {
	    if (el.type == 'keypress' || el.type == 'keyup' && (el.keyCode || el.which) != 13) {
	        return;
	    }
	
	    var currentNode = el.currentTarget;
	    var parentNode = currentNode.parentNode;
	    var contentContainer = parentNode.querySelector(".accordion-content-container");
	    var content = contentContainer.querySelector(".accordion-content");
	
	    if (!contentContainer.parentNode.classList.contains('open')) {
	        if (this._options.accordionOpenClicked) if (this._options.accordionOpenClicked(currentNode) === false) return false;
	        if (this._options.shouldCloseOthers) {
	            closeAccordions.call(this);
	        }
	
	        parentNode.classList.add("open");
	        $(contentContainer).slideDown();
	        currentNode.setAttribute('aria-expanded', 'true');
	        contentContainer.setAttribute('aria-hidden', 'false');
	    } else {
	        if (this._options.accordionCloseClicked) if (this._options.accordionCloseClicked(currentNode) === false) return false;
	        parentNode.classList.remove("open");
	        $(contentContainer).slideUp();
	        currentNode.setAttribute('aria-expanded', 'false');
	        contentContainer.setAttribute('aria-hidden', 'true');
	    }
	}
	
	/**
	 * openAccordionElement(element)
	 * @param element
	 * @returns {boolean}
	 *
	 * private method to simply open the element that have been passed as parameter (no events)
	 */
	function openAccordionElement(element) {
	    var contentContainer = element.querySelector(".accordion-content-container");
	    var nodeHeadline = element.querySelector('.accordion-headline');
	    var content = contentContainer.querySelector(".accordion-content");
	
	    if (!contentContainer.parentNode.classList.contains('open')) {
	        if (this._options.accordionOpenClicked) if (this._options.accordionOpenClicked(nodeHeadline) === false) return false;
	        if (this._options.shouldCloseOthers) {
	            closeAccordions.call(this);
	        }
	
	        $(contentContainer).slideDown();
	        element.classList.add("open");
	        nodeHeadline.setAttribute('aria-expanded', 'true');
	        contentContainer.setAttribute('aria-hidden', 'false');
	    } else {
	        if (this._options.accordionCloseClicked) if (this._options.accordionCloseClicked(nodeHeadline) === false) return false;
	        element.classList.remove("open");
	        $(contentContainer).slideUp();
	        nodeHeadline.setAttribute('aria-expanded', 'false');
	        contentContainer.setAttribute('aria-hidden', 'true');
	    }
	}
	
	function forceOpenAccordion(el) {
	    el.classList.add('force-open');
	}
	
	/**
	 * closeAccordions()
	 * closes all open accordains
	 */
	function closeAccordions() {
	
	    var openAccordians = this._internalVars.node.parentNode.querySelectorAll(".accordion > li.open");
	    Array.prototype.forEach.call(openAccordians, function (el, i) {
	        el.classList.remove("open");
	        var contentContainer = el.querySelector(".accordion-content-container");
	        el.querySelector('.accordion-headline').setAttribute('aria-expanded', 'false');
	        contentContainer.setAttribute('aria-hidden', 'true');
	        $(contentContainer).slideUp();
	    });
	}
	
	/**
	 * setLocalVars()
	 * recalulates the max height when you resize the browser
	 */
	function handleResize() {
	    if (this._internalVars.node.parentNode) {
	        var openAccordions = this._internalVars.node.parentNode.querySelectorAll(".accordion > li.open");
	        Array.prototype.forEach.call(openAccordions, function (el, i) {
	
	            var contentContainer = el.querySelector(".accordion-content-container");
	            var content = contentContainer.querySelector(".accordion-content");
	        });
	    }
	}
	
	/**
	 * setLocalVars()
	 * set all the local vars to passed in options
	 */
	function setLocalVars() {
	    //determine the type of content passed in
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    this._internalVars.headline = this._internalVars.node.querySelectorAll(".accordion-headline");
	    var allLIAccordions = this._internalVars.node.parentNode.querySelectorAll(".accordion > li");
	
	    Array.prototype.forEach.call(allLIAccordions, function (el, i) {
	        if (el.classList.contains('open')) {
	            el.querySelector('.accordion-headline').setAttribute('aria-expanded', 'true');
	            el.querySelector('.accordion-content-container').setAttribute('aria-hidden', 'false');
	        } else {
	            el.querySelector('.accordion-headline').setAttribute('aria-expanded', 'false');
	            el.querySelector('.accordion-content-container').setAttribute('aria-hidden', 'true');
	        }
	    });
	
	    this._internalVars.handler = toggleAccordion.bind(this);
	}
	
	exports["default"] = Accordion;
	module.exports = exports["default"];

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by u1d230 on 7/13/15.
	 */
	
	//Module Imports
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	    setting: 'content',
	    isRequired: true,
	    validate: 'type', //a type or a value
	    possibleValues: ['string', 'object'],
	    errorMessage: ['GDK Alert : Content must be defined and set to a DOM selector or Node']
	}];
	
	var Alert = (function () {
	    /**
	     * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	     * @param {string|Object} content
	     *  A reference to the html alert node
	     */
	
	    function Alert(options) {
	        _classCallCheck(this, Alert);
	
	        this._internalVars = {
	            node: null, //used for current node
	            alertContentClass: "alert-content",
	            alertContent: null,
	            alertCloseBtnClass: "icon-close-20",
	            alertCloseBtn: null
	        };
	
	        //options with defaults set
	        this._defaults = {};
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2['default'].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2['default'].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2['default'].getContentType(this);
	            setLocalVars.call(this);
	            setEvents.call(this);
	        }
	    }
	
	    // Private Methods
	
	    //Public Methods
	
	    /**
	     * removes the node from the dom and any events attached
	     */
	
	    _createClass(Alert, [{
	        key: 'destroy',
	        value: function destroy() {
	            removeEvents.call(this);
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return Alert;
	})();
	
	function setLocalVars() {
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    this._internalVars.alertCloseBtn = this._internalVars.node.querySelectorAll('button.' + this._internalVars.alertCloseBtnClass);
	}
	
	/**
	 * setEvents()
	 * Sets all the events needed for the component
	 */
	function setEvents() {
	    for (var i = 0; i < this._internalVars.alertCloseBtn.length; i++) {
	        this._internalVars.alertCloseBtn[i].addEventListener("click", removeAlert.bind(this, this._internalVars.alertCloseBtn[i]));
	    }
	}
	
	function removeEvents() {
	    for (var i = 0; i < this._internalVars.alertCloseBtn.length; i++) {
	        this._internalVars.alertCloseBtn[i].removeEventListener("click", removeAlert.bind(this, this._internalVars.alertCloseBtn[i]));
	    }
	}
	
	/**
	 * removeAlert()
	 * checks to remove Alert appropriately
	 */
	function removeAlert(e) {
	    if (this._internalVars.node.children.length == 1 && e.parentNode.parentNode.children.length == 1) {
	        fadeAndRemove(this._internalVars.node);
	    }
	    if (e.parentNode.parentNode.children.length == 1) {
	        fadeAndRemove(e.parentNode.parentNode.parentNode);
	    }
	    fadeAndRemove(e.parentNode);
	}
	
	/**
	 * fade()
	 * fade effect
	 */
	function fadeOutEffect(e) {
	    var op = 1; // initial opacity
	    var timer = setInterval(function () {
	        if (op <= 0.01) {
	            clearInterval(timer);
	        }
	        e.style.opacity = op;
	        e.style.filter = 'alpha(opacity=' + op * 100 + ")";
	        op -= op * 0.1;
	    }, 15);
	}
	
	/**
	 * removeChildCall
	 * Instantiate removal of child element
	 */
	function removeChildCall(e) {
	    e.parentNode.removeChild(e);
	}
	
	/**
	 * fadeAndRemove()
	 * Combine fade effect with delayed removal of element
	 */
	function fadeAndRemove(e) {
	    fadeOutEffect(e);
	    setTimeout(removeChildCall, 500, e);
	}
	
	exports['default'] = Alert;
	module.exports = exports['default'];

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	
	//Module Imports
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _utils = __webpack_require__(8);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK MoreInfoButton : Content must be defined and set to a DOM selector or Node"]
	}];
	
	var MoreInfoButton = (function () {
	    /**
	     * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	     * @param {string|Object} content
	     * A reference to the html More Info Button node
	     */
	
	    function MoreInfoButton(options) {
	        _classCallCheck(this, MoreInfoButton);
	
	        console.log('MoreInfoButton initialized');
	
	        this._internalVars = {
	            node: null, //used for current node
	            button: null,
	            ul: null,
	            wrapperElementId: "wrapper",
	            wrapper: null
	        };
	
	        //options with defaults set
	        this._defaults = {};
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2['default'].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2['default'].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2['default'].getContentType(this);
	            setLocalVars.call(this);
	            setEvents.call(this);
	
	            this._internalVars.button.setAttribute('aria-expanded', 'false');
	            this._internalVars.button.setAttribute('role', 'button');
	        }
	    }
	
	    // Private Methods
	    /**
	     * setEvents()
	     * Sets all the events needed for the component
	     */
	
	    /**
	    * destroy()
	    * removes the node from the dom and any events attached
	    */
	
	    _createClass(MoreInfoButton, [{
	        key: 'destroy',
	        value: function destroy() {
	            removeEvents.call(this);
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return MoreInfoButton;
	})();
	
	function setEvents() {
	    var eventName = "click";
	    if ("ontouchstart" in document.documentElement) {
	        eventName = "touchstart";
	    }
	    this._internalVars.node.addEventListener('mouseleave', this._internalVars.menuHandler);
	    this._internalVars.button.addEventListener(eventName, this._internalVars.toggleHandler);
	    this._internalVars.button.addEventListener("keydown", this._internalVars.keyHandler);
	}
	
	/**
	 * removeEvents()
	 * removes all events from the component
	 */
	function removeEvents() {
	    var eventName = "click";
	    if ("ontouchstart" in document.documentElement) {
	        eventName = "touchstart";
	    }
	    this._internalVars.node.removeEventListener('mouseleave', this._internalVars.menuHandler);
	    this._internalVars.button.removeEventListener(eventName, this._internalVars.toggleHandler);
	    this._internalVars.button.removeEventListener("keydown", this._internalVars.keyHandler);
	}
	
	function closeMenu() {
	    var _this = this;
	
	    this._internalVars.ul.classList.remove("options-in");
	    this._internalVars.ul.classList.add("options-out");
	    this._internalVars.button.setAttribute('aria-expanded', 'false');
	    setTimeout(function () {
	        _this._internalVars.ul.style.display = "none";
	    }, 300);
	}
	
	/**
	 * toggleOptions()
	 * toggles the options view
	 */
	function toggleOptions() {
	    var _this2 = this;
	
	    if (utils.hasClass(this._internalVars.ul, "options-in")) {
	        this._internalVars.ul.classList.remove("options-in");
	        this._internalVars.ul.classList.add("options-out");
	        this._internalVars.button.setAttribute('aria-expanded', 'false');
	        setTimeout(function () {
	            _this2._internalVars.ul.style.display = "none";
	        }, 300);
	    } else {
	        this._internalVars.ul.style.display = "block";
	        this._internalVars.ul.classList.remove("options-out");
	        this._internalVars.ul.classList.add("options-in");
	        this._internalVars.button.setAttribute('aria-expanded', 'true');
	
	        checkUlPosistion.call(this);
	    }
	}
	
	function keyOptions(e) {
	    if ((e.type == 'keydown' || e.type == 'keypress') && (e.keyCode || e.which) != 13) {
	        return;
	    } else {
	        if (utils.hasClass(this._internalVars.ul, "options-out")) {
	            this._internalVars.ul.style.display = "block";
	            this._internalVars.ul.classList.remove("options-out");
	            this._internalVars.ul.classList.add("options-in");
	            this._internalVars.button.setAttribute('aria-expanded', 'true');
	            var allA = this._internalVars.ul.querySelectorAll('a');
	            allA[0].focus();
	
	            checkUlPosistion.call(this);
	        }
	    }
	}
	
	/**
	 * toggleOptions()
	 * detect if there is enough space to see the whole menu when opened
	 * if not we need to scroll the body so there is enough space
	 */
	function checkUlPosistion() {
	
	    if (this._internalVars.ul.getBoundingClientRect().top + this._internalVars.ul.offsetHeight > window.innerHeight) {
	
	        var windowHeight = window.innerHeight;
	        var moreInfoHeight = this._internalVars.ul.getBoundingClientRect().top + this._internalVars.ul.offsetHeight;
	        var neededSpace = moreInfoHeight - windowHeight;
	
	        var currentScrollOffset = window.scrollY || window.pageYOffset;
	        var newScrollOffset = Math.round(currentScrollOffset + neededSpace);
	
	        scrollTo(newScrollOffset, 200);
	    }
	}
	
	/**
	* scrollTo()
	* Scrolls to a specific point
	*
	* @param  {Object} node    DOM node
	* @param  {Number}
	* @param  {Number}
	*/
	function scrollTo(to, duration) {
	    var start = document.documentElement.scrollTop || document.body.scrollTop,
	        change = to - start,
	        currentTime = 0,
	        increment = 20;
	
	    var animateScroll = function animateScroll() {
	        currentTime += increment;
	        var val = easeInOutQuad(currentTime, start, change, duration);
	        document.documentElement.scrollTop = val;
	        document.body.scrollTop = val;
	
	        if (currentTime < duration) {
	            setTimeout(animateScroll, increment);
	        }
	    };
	    animateScroll();
	}
	
	/**
	* easeInQuad()
	* Quadratic easing
	*/
	function easeInOutQuad(t, b, c, d) {
	    t /= d / 2;
	    if (t < 1) return c / 2 * t * t + b;
	    t--;
	    return -c / 2 * (t * (t - 2) - 1) + b;
	}
	
	/**
	 * setLocalVars()
	 * set local vars to the ones passed in options
	 */
	function setLocalVars() {
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    this._internalVars.button = this._internalVars.node.querySelector(".more-info-button");
	    this._internalVars.ul = this._internalVars.node.querySelector("ul");
	    this._internalVars.wrapper = document.querySelector("#" + this._internalVars.wrapperElementId);
	
	    this._internalVars.menuHandler = closeMenu.bind(this);
	    this._internalVars.toggleHandler = toggleOptions.bind(this);
	    this._internalVars.keyHandler = keyOptions.bind(this);
	}
	
	exports['default'] = MoreInfoButton;
	module.exports = exports['default'];

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	//Module Imports
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var Trianglify = __webpack_require__(46);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK BackgroundPattern : Content must be defined and set to a DOM selector or Node"]
	}];
	
	var BackgroundPattern = (function () {
	    /**
	     * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	     * @param {string|Object} content
	     *  A reference to the html More Background Pattern node
	     */
	
	    function BackgroundPattern(options) {
	        _classCallCheck(this, BackgroundPattern);
	
	        console.log('BackgroundPattern initialized');
	
	        //SM=75 MED=125 LG=175
	
	        this._internalVars = {
	            node: null //used for current node
	        };
	
	        //options with defaults set
	        this._defaults = {};
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2['default'].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2['default'].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2['default'].getContentType(this);
	            setLocalVars.call(this);
	            init.call(this);
	        }
	    }
	
	    // Private Methods
	
	    /**
	     * init()
	     * Initializes the Trianglify pattern
	     */
	
	    /**
	    * destroy()
	    * removes the node from the dom and any events attached
	    */
	
	    _createClass(BackgroundPattern, [{
	        key: 'destroy',
	        value: function destroy() {
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return BackgroundPattern;
	})();
	
	function init() {
	
	    var pattern = Trianglify({
	        variance: "0.7",
	        cell_size: 175,
	        x_colors: ["#ffffff", "#dcdcdc", "#e6e6e6", "#ffffff", "e8e8e8", "f0f0f0", "#dcdcdc", "#ffffff", "#f5f5f5", "e8e8e8", "#ffffff", "#e6e6e6", "#f5f5f5", "#fafafa", "#ffffff"],
	        width: 3000,
	        height: 800
	    });
	    this._internalVars.node.appendChild(pattern.canvas());
	}
	
	/**
	 * setLocalVars()
	 * set local vars to the ones passed in options
	 */
	function setLocalVars() {
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	}
	
	exports['default'] = BackgroundPattern;
	module.exports = exports['default'];

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(47);

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var require;var require;"use strict";
	
	!(function (e) {
	  if (true) module.exports = e();else if ("function" == typeof define && define.amd) define([], e);else {
	    var r;r = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this, r.Trianglify = e();
	  }
	})(function () {
	  var e;return (function r(e, n, t) {
	    function f(a, i) {
	      if (!n[a]) {
	        if (!e[a]) {
	          var c = "function" == typeof require && require;if (!i && c) return require(a, !0);if (o) return o(a, !0);var u = new Error("Cannot find module '" + a + "'");throw (u.code = "MODULE_NOT_FOUND", u);
	        }var d = n[a] = { exports: {} };e[a][0].call(d.exports, function (r) {
	          var n = e[a][1][r];return f(n ? n : r);
	        }, d, d.exports, r, e, n, t);
	      }return n[a].exports;
	    }for (var o = "function" == typeof require && require, a = 0; a < t.length; a++) f(t[a]);return f;
	  })({ "./lib/trianglify.js": [function (e, r) {
	      function n(e) {
	        function r(e, r, n) {
	          return (e - r[0]) * (n[1] - n[0]) / (r[1] - r[0]) + n[0];
	        }function n(n, t) {
	          for (var f = [], o = -y; n + y > o; o += e.cell_size) for (var a = -v; t + v > a; a += e.cell_size) {
	            var i = o + e.cell_size / 2 + r(rand(), [0, 1], [-w, w]),
	                c = a + e.cell_size / 2 + r(rand(), [0, 1], [-w, w]);f.push([i, c].map(Math.floor));
	          }return f;
	        }function a(e) {
	          return { x: (e[0][0] + e[1][0] + e[2][0]) / 3, y: (e[0][1] + e[1][1] + e[2][1]) / 3 };
	        }function u() {
	          if (e.palette instanceof Array) return e.palette[Math.floor(rand() * e.palette.length)];var r = Object.keys(e.palette);return e.palette[r[Math.floor(rand() * r.length)]];
	        }function d(e, r) {
	          var n = {};for (var t in e) n[t] = e[t];for (t in r) {
	            if (!e.hasOwnProperty(t)) throw new Error(t + " is not a configuration option for Trianglify. Check your spelling?");n[t] = r[t];
	          }return n;
	        }if ((e = d(c, e), rand = f(e.seed), "random" === e.x_colors && (e.x_colors = u()), "random" === e.y_colors && (e.y_colors = u()), "match_x" === e.y_colors && (e.y_colors = e.x_colors), !(e.width > 0 && e.height > 0))) throw new Error("Width and height must be numbers greater than 0");if (e.cell_size < 2) throw new Error("Cell size must be greater than 2.");var s;if (e.color_function) s = function (r, n) {
	          return o(e.color_function(r, n));
	        };else {
	          var l = o.scale(e.x_colors).mode(e.color_space),
	              b = o.scale(e.y_colors).mode(e.color_space);s = function (r, n) {
	            return o.interpolate(l(r), b(n), .5, e.color_space);
	          };
	        }for (var h = e.width, g = e.height, p = Math.floor((h + 4 * e.cell_size) / e.cell_size), m = Math.floor((g + 4 * e.cell_size) / e.cell_size), y = (p * e.cell_size - h) / 2, v = (m * e.cell_size - g) / 2, w = e.cell_size * e.variance / 2, x = function x(e) {
	          return r(e, [-y, h + y], [0, 1]);
	        }, _ = function _(e) {
	          return r(e, [-v, g + v], [0, 1]);
	        }, k = n(h, g), j = t.triangulate(k), M = [], q = function q(e) {
	          return k[e];
	        }, C = 0; C < j.length; C += 3) {
	          var N = [j[C], j[C + 1], j[C + 2]].map(q),
	              U = a(N),
	              A = s(x(U.x), _(U.y)).hex();M.push([A, N]);
	        }return i(M, e);
	      }var t = e("delaunay-fast"),
	          f = e("seedrandom"),
	          o = e("chroma-js"),
	          a = e("./colorbrewer"),
	          i = e("./pattern"),
	          c = { width: 600, height: 400, cell_size: 75, variance: .75, seed: null, x_colors: "random", y_colors: "match_x", palette: a, color_space: "lab", color_function: null, stroke_width: 1.51 };n.colorbrewer = a, n.defaults = c, r.exports = n;
	    }, { "./colorbrewer": "/Users/qrohlf/Code/trianglify/lib/colorbrewer.js", "./pattern": "/Users/qrohlf/Code/trianglify/lib/pattern.js", "chroma-js": "/Users/qrohlf/Code/trianglify/node_modules/chroma-js/chroma.js", "delaunay-fast": "/Users/qrohlf/Code/trianglify/node_modules/delaunay-fast/delaunay.js", seedrandom: "/Users/qrohlf/Code/trianglify/node_modules/seedrandom/index.js" }], "/Users/qrohlf/Code/trianglify/lib/colorbrewer.js": [function (e, r) {
	      r.exports = { YlGn: ["#ffffe5", "#f7fcb9", "#d9f0a3", "#addd8e", "#78c679", "#41ab5d", "#238443", "#006837", "#004529"], YlGnBu: ["#ffffd9", "#edf8b1", "#c7e9b4", "#7fcdbb", "#41b6c4", "#1d91c0", "#225ea8", "#253494", "#081d58"], GnBu: ["#f7fcf0", "#e0f3db", "#ccebc5", "#a8ddb5", "#7bccc4", "#4eb3d3", "#2b8cbe", "#0868ac", "#084081"], BuGn: ["#f7fcfd", "#e5f5f9", "#ccece6", "#99d8c9", "#66c2a4", "#41ae76", "#238b45", "#006d2c", "#00441b"], PuBuGn: ["#fff7fb", "#ece2f0", "#d0d1e6", "#a6bddb", "#67a9cf", "#3690c0", "#02818a", "#016c59", "#014636"], PuBu: ["#fff7fb", "#ece7f2", "#d0d1e6", "#a6bddb", "#74a9cf", "#3690c0", "#0570b0", "#045a8d", "#023858"], BuPu: ["#f7fcfd", "#e0ecf4", "#bfd3e6", "#9ebcda", "#8c96c6", "#8c6bb1", "#88419d", "#810f7c", "#4d004b"], RdPu: ["#fff7f3", "#fde0dd", "#fcc5c0", "#fa9fb5", "#f768a1", "#dd3497", "#ae017e", "#7a0177", "#49006a"], PuRd: ["#f7f4f9", "#e7e1ef", "#d4b9da", "#c994c7", "#df65b0", "#e7298a", "#ce1256", "#980043", "#67001f"], OrRd: ["#fff7ec", "#fee8c8", "#fdd49e", "#fdbb84", "#fc8d59", "#ef6548", "#d7301f", "#b30000", "#7f0000"], YlOrRd: ["#ffffcc", "#ffeda0", "#fed976", "#feb24c", "#fd8d3c", "#fc4e2a", "#e31a1c", "#bd0026", "#800026"], YlOrBr: ["#ffffe5", "#fff7bc", "#fee391", "#fec44f", "#fe9929", "#ec7014", "#cc4c02", "#993404", "#662506"], Purples: ["#fcfbfd", "#efedf5", "#dadaeb", "#bcbddc", "#9e9ac8", "#807dba", "#6a51a3", "#54278f", "#3f007d"], Blues: ["#f7fbff", "#deebf7", "#c6dbef", "#9ecae1", "#6baed6", "#4292c6", "#2171b5", "#08519c", "#08306b"], Greens: ["#f7fcf5", "#e5f5e0", "#c7e9c0", "#a1d99b", "#74c476", "#41ab5d", "#238b45", "#006d2c", "#00441b"], Oranges: ["#fff5eb", "#fee6ce", "#fdd0a2", "#fdae6b", "#fd8d3c", "#f16913", "#d94801", "#a63603", "#7f2704"], Reds: ["#fff5f0", "#fee0d2", "#fcbba1", "#fc9272", "#fb6a4a", "#ef3b2c", "#cb181d", "#a50f15", "#67000d"], Greys: ["#ffffff", "#f0f0f0", "#d9d9d9", "#bdbdbd", "#969696", "#737373", "#525252", "#252525", "#000000"], PuOr: ["#7f3b08", "#b35806", "#e08214", "#fdb863", "#fee0b6", "#f7f7f7", "#d8daeb", "#b2abd2", "#8073ac", "#542788", "#2d004b"], BrBG: ["#543005", "#8c510a", "#bf812d", "#dfc27d", "#f6e8c3", "#f5f5f5", "#c7eae5", "#80cdc1", "#35978f", "#01665e", "#003c30"], PRGn: ["#40004b", "#762a83", "#9970ab", "#c2a5cf", "#e7d4e8", "#f7f7f7", "#d9f0d3", "#a6dba0", "#5aae61", "#1b7837", "#00441b"], PiYG: ["#8e0152", "#c51b7d", "#de77ae", "#f1b6da", "#fde0ef", "#f7f7f7", "#e6f5d0", "#b8e186", "#7fbc41", "#4d9221", "#276419"], RdBu: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#f7f7f7", "#d1e5f0", "#92c5de", "#4393c3", "#2166ac", "#053061"], RdGy: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#ffffff", "#e0e0e0", "#bababa", "#878787", "#4d4d4d", "#1a1a1a"], RdYlBu: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee090", "#ffffbf", "#e0f3f8", "#abd9e9", "#74add1", "#4575b4", "#313695"], Spectral: ["#9e0142", "#d53e4f", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#e6f598", "#abdda4", "#66c2a5", "#3288bd", "#5e4fa2"], RdYlGn: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#d9ef8b", "#a6d96a", "#66bd63", "#1a9850", "#006837"] };
	    }, {}], "/Users/qrohlf/Code/trianglify/lib/pattern.js": [function (e, r) {
	      (function (n) {
	        function t(r, t) {
	          function o() {
	            var e = f.createElementNS("http://www.w3.org/2000/svg", "svg");return e.setAttribute("width", t.width), e.setAttribute("height", t.height), r.forEach(function (r) {
	              var n = f.createElementNS("http://www.w3.org/2000/svg", "path");n.setAttribute("d", "M" + r[1].join("L") + "Z"), n.setAttribute("fill", r[0]), n.setAttribute("stroke", r[0]), n.setAttribute("stroke-width", t.stroke_width), e.appendChild(n);
	            }), e;
	          }function a(o) {
	            if ("undefined" != typeof n) try {
	              e("canvas");
	            } catch (a) {
	              throw Error("The optional node-canvas dependency is needed for Trianglify to render using canvas in node.");
	            }return o || (o = f.createElement("canvas")), o.setAttribute("width", t.width), o.setAttribute("height", t.height), ctx = o.getContext("2d"), ctx.canvas.width = t.width, ctx.canvas.height = t.height, r.forEach(function (e) {
	              ctx.fillStyle = ctx.strokeStyle = e[0], ctx.lineWidth = t.stroke_width, ctx.beginPath(), ctx.moveTo.apply(ctx, e[1][0]), ctx.lineTo.apply(ctx, e[1][1]), ctx.lineTo.apply(ctx, e[1][2]), ctx.fill(), ctx.stroke();
	            }), o;
	          }function i() {
	            return a().toDataURL("image/png");
	          }return { polys: r, opts: t, svg: o, canvas: a, png: i };
	        }var f = "undefined" != typeof document ? document : e("jsdom").jsdom("<html/>");r.exports = t;
	      }).call(this, e("_process"));
	    }, { _process: "/Users/qrohlf/Code/trianglify/node_modules/browserify/node_modules/process/browser.js", canvas: "/Users/qrohlf/Code/trianglify/node_modules/browserify/node_modules/browser-resolve/empty.js", jsdom: "/Users/qrohlf/Code/trianglify/node_modules/browserify/node_modules/browser-resolve/empty.js" }], "/Users/qrohlf/Code/trianglify/node_modules/browserify/node_modules/browser-resolve/empty.js": [function () {}, {}], "/Users/qrohlf/Code/trianglify/node_modules/browserify/node_modules/process/browser.js": [function (e, r) {
	      function n() {
	        if (!a) {
	          a = !0;for (var e, r = o.length; r;) {
	            e = o, o = [];for (var n = -1; ++n < r;) e[n]();r = o.length;
	          }a = !1;
	        }
	      }function t() {}var f = r.exports = {},
	          o = [],
	          a = !1;f.nextTick = function (e) {
	        o.push(e), a || setTimeout(n, 0);
	      }, f.title = "browser", f.browser = !0, f.env = {}, f.argv = [], f.version = "", f.versions = {}, f.on = t, f.addListener = t, f.once = t, f.off = t, f.removeListener = t, f.removeAllListeners = t, f.emit = t, f.binding = function () {
	        throw new Error("process.binding is not supported");
	      }, f.cwd = function () {
	        return "/";
	      }, f.chdir = function () {
	        throw new Error("process.chdir is not supported");
	      }, f.umask = function () {
	        return 0;
	      };
	    }, {}], "/Users/qrohlf/Code/trianglify/node_modules/chroma-js/chroma.js": [function (r, n, t) {
	      (function () {
	        var r, f, o, a, i, c, u, d, s, l, b, h, g, p, m, y, v, w, x, _, k, j, M, q, C, N, U, A, P, z, G, E, B, I, R, S, O, T, Y;l = function (e, n, t, f) {
	          return new r(e, n, t, f);
	        }, "undefined" != typeof n && null !== n && null != n.exports && (n.exports = l), "function" == typeof e && e.amd ? e([], function () {
	          return l;
	        }) : (I = "undefined" != typeof t && null !== t ? t : this, I.chroma = l), l.color = function (e, n, t, f) {
	          return new r(e, n, t, f);
	        }, l.hsl = function (e, n, t, f) {
	          return new r(e, n, t, f, "hsl");
	        }, l.hsv = function (e, n, t, f) {
	          return new r(e, n, t, f, "hsv");
	        }, l.rgb = function (e, n, t, f) {
	          return new r(e, n, t, f, "rgb");
	        }, l.hex = function (e) {
	          return new r(e);
	        }, l.css = function (e) {
	          return new r(e);
	        }, l.lab = function (e, n, t) {
	          return new r(e, n, t, "lab");
	        }, l.lch = function (e, n, t) {
	          return new r(e, n, t, "lch");
	        }, l.hsi = function (e, n, t) {
	          return new r(e, n, t, "hsi");
	        }, l.gl = function (e, n, t, f) {
	          return new r(255 * e, 255 * n, 255 * t, f, "gl");
	        }, l.interpolate = function (e, n, t, f) {
	          return null == e || null == n ? "#000" : ("string" === R(e) && (e = new r(e)), "string" === R(n) && (n = new r(n)), e.interpolate(t, n, f));
	        }, l.mix = l.interpolate, l.contrast = function (e, n) {
	          var t, f;return "string" === R(e) && (e = new r(e)), "string" === R(n) && (n = new r(n)), t = e.luminance(), f = n.luminance(), t > f ? (t + .05) / (f + .05) : (f + .05) / (t + .05);
	        }, l.luminance = function (e) {
	          return l(e).luminance();
	        }, l._Color = r, r = (function () {
	          function e() {
	            var e, r, n, t, f, o, a, i, c, u, d, s, l, h, g, p;for (f = this, n = [], u = 0, d = arguments.length; d > u; u++) r = arguments[u], null != r && n.push(r);if (0 === n.length) s = [255, 0, 255, 1, "rgb"], a = s[0], i = s[1], c = s[2], e = s[3], t = s[4];else if ("array" === R(n[0])) {
	              if (3 === n[0].length) l = n[0], a = l[0], i = l[1], c = l[2], e = 1;else {
	                if (4 !== n[0].length) throw "unknown input argument";h = n[0], a = h[0], i = h[1], c = h[2], e = h[3];
	              }t = null != (g = n[1]) ? g : "rgb";
	            } else "string" === R(n[0]) ? (a = n[0], t = "hex") : "object" === R(n[0]) ? (p = n[0]._rgb, a = p[0], i = p[1], c = p[2], e = p[3], t = "rgb") : n.length >= 3 && (a = n[0], i = n[1], c = n[2]);3 === n.length ? (t = "rgb", e = 1) : 4 === n.length ? "string" === R(n[3]) ? (t = n[3], e = 1) : "number" === R(n[3]) && (t = "rgb", e = n[3]) : 5 === n.length && (e = n[3], t = n[4]), null == e && (e = 1), "rgb" === t ? f._rgb = [a, i, c, e] : "gl" === t ? f._rgb = [255 * a, 255 * i, 255 * c, e] : "hsl" === t ? (f._rgb = v(a, i, c), f._rgb[3] = e) : "hsv" === t ? (f._rgb = w(a, i, c), f._rgb[3] = e) : "hex" === t ? f._rgb = m(a) : "lab" === t ? (f._rgb = _(a, i, c), f._rgb[3] = e) : "lch" === t ? (f._rgb = M(a, i, c), f._rgb[3] = e) : "hsi" === t && (f._rgb = y(a, i, c), f._rgb[3] = e), o = b(f._rgb);
	          }return e.prototype.rgb = function () {
	            return this._rgb.slice(0, 3);
	          }, e.prototype.rgba = function () {
	            return this._rgb;
	          }, e.prototype.hex = function () {
	            return U(this._rgb);
	          }, e.prototype.toString = function () {
	            return this.name();
	          }, e.prototype.hsl = function () {
	            return P(this._rgb);
	          }, e.prototype.hsv = function () {
	            return z(this._rgb);
	          }, e.prototype.lab = function () {
	            return G(this._rgb);
	          }, e.prototype.lch = function () {
	            return E(this._rgb);
	          }, e.prototype.hsi = function () {
	            return A(this._rgb);
	          }, e.prototype.gl = function () {
	            return [this._rgb[0] / 255, this._rgb[1] / 255, this._rgb[2] / 255, this._rgb[3]];
	          }, e.prototype.luminance = function (r, n) {
	            var t, f, o, a;return null == n && (n = "rgb"), arguments.length ? (0 === r && (this._rgb = [0, 0, 0, this._rgb[3]]), 1 === r && (this._rgb = [255, 255, 255, this._rgb[3]]), t = C(this._rgb), f = 1e-7, o = 20, a = function (e, t) {
	              var i, c;return c = e.interpolate(.5, t, n), i = c.luminance(), Math.abs(r - i) < f || ! o-- ? c : i > r ? a(e, c) : a(c, t);
	            }, this._rgb = (t > r ? a(new e("black"), this) : a(this, new e("white"))).rgba(), this) : C(this._rgb);
	          }, e.prototype.name = function () {
	            var e, r;e = this.hex();for (r in l.colors) if (e === l.colors[r]) return r;return e;
	          }, e.prototype.alpha = function (e) {
	            return arguments.length ? (this._rgb[3] = e, this) : this._rgb[3];
	          }, e.prototype.css = function (e) {
	            var r, n, t, f;return null == e && (e = "rgb"), n = this, t = n._rgb, 3 === e.length && t[3] < 1 && (e += "a"), "rgb" === e ? e + "(" + t.slice(0, 3).map(Math.round).join(",") + ")" : "rgba" === e ? e + "(" + t.slice(0, 3).map(Math.round).join(",") + "," + t[3] + ")" : "hsl" === e || "hsla" === e ? (r = n.hsl(), f = function (e) {
	              return Math.round(100 * e) / 100;
	            }, r[0] = f(r[0]), r[1] = f(100 * r[1]) + "%", r[2] = f(100 * r[2]) + "%", 4 === e.length && (r[3] = t[3]), e + "(" + r.join(",") + ")") : void 0;
	          }, e.prototype.interpolate = function (r, n, t) {
	            var f, o, a, i, c, u, d, s, l, b, h, g, p, m;if ((s = this, null == t && (t = "rgb"), "string" === R(n) && (n = new e(n)), "hsl" === t || "hsv" === t || "lch" === t || "hsi" === t)) "hsl" === t ? (p = s.hsl(), m = n.hsl()) : "hsv" === t ? (p = s.hsv(), m = n.hsv()) : "hsi" === t ? (p = s.hsi(), m = n.hsi()) : "lch" === t && (p = s.lch(), m = n.lch()), "h" === t.substr(0, 1) ? (a = p[0], h = p[1], u = p[2], i = m[0], g = m[1], d = m[2]) : (u = p[0], h = p[1], a = p[2], d = m[0], g = m[1], i = m[2]), isNaN(a) || isNaN(i) ? isNaN(a) ? isNaN(i) ? o = Number.NaN : (o = i, 1 !== u && 0 !== u || "hsv" === t || (b = g)) : (o = a, 1 !== d && 0 !== d || "hsv" === t || (b = h)) : (f = i > a && i - a > 180 ? i - (a + 360) : a > i && a - i > 180 ? i + 360 - a : i - a, o = a + r * f), null == b && (b = h + r * (g - h)), c = u + r * (d - u), l = "h" === t.substr(0, 1) ? new e(o, b, c, t) : new e(c, b, o, t);else if ("rgb" === t) p = s._rgb, m = n._rgb, l = new e(p[0] + r * (m[0] - p[0]), p[1] + r * (m[1] - p[1]), p[2] + r * (m[2] - p[2]), t);else {
	              if ("lab" !== t) throw "color mode " + t + " is not supported";p = s.lab(), m = n.lab(), l = new e(p[0] + r * (m[0] - p[0]), p[1] + r * (m[1] - p[1]), p[2] + r * (m[2] - p[2]), t);
	            }return l.alpha(s.alpha() + r * (n.alpha() - s.alpha())), l;
	          }, e.prototype.premultiply = function () {
	            var e, r;return r = this.rgb(), e = this.alpha(), l(r[0] * e, r[1] * e, r[2] * e, e);
	          }, e.prototype.darken = function (e) {
	            var r, n;return null == e && (e = 20), n = this, r = n.lch(), r[0] -= e, l.lch(r).alpha(n.alpha());
	          }, e.prototype.darker = function (e) {
	            return this.darken(e);
	          }, e.prototype.brighten = function (e) {
	            return null == e && (e = 20), this.darken(-e);
	          }, e.prototype.brighter = function (e) {
	            return this.brighten(e);
	          }, e.prototype.saturate = function (e) {
	            var r, n;return null == e && (e = 20), n = this, r = n.lch(), r[1] += e, l.lch(r).alpha(n.alpha());
	          }, e.prototype.desaturate = function (e) {
	            return null == e && (e = 20), this.saturate(-e);
	          }, e;
	        })(), b = function (e) {
	          var r;for (r in e) 3 > r ? (e[r] < 0 && (e[r] = 0), e[r] > 255 && (e[r] = 255)) : 3 === r && (e[r] < 0 && (e[r] = 0), e[r] > 1 && (e[r] = 1));return e;
	        }, p = function (e) {
	          var r, n, t, f, o, a, i, c;if ((e = e.toLowerCase(), null != l.colors && l.colors[e])) return m(l.colors[e]);if (t = e.match(/rgb\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*\)/)) {
	            for (f = t.slice(1, 4), n = o = 0; 2 >= o; n = ++o) f[n] = +f[n];f[3] = 1;
	          } else if (t = e.match(/rgba\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*,\s*([01]|[01]?\.\d+)\)/)) for (f = t.slice(1, 5), n = a = 0; 3 >= a; n = ++a) f[n] = +f[n];else if (t = e.match(/rgb\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) {
	            for (f = t.slice(1, 4), n = i = 0; 2 >= i; n = ++i) f[n] = Math.round(2.55 * f[n]);f[3] = 1;
	          } else if (t = e.match(/rgba\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) {
	            for (f = t.slice(1, 5), n = c = 0; 2 >= c; n = ++c) f[n] = Math.round(2.55 * f[n]);f[3] = +f[3];
	          } else (t = e.match(/hsl\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) ? (r = t.slice(1, 4), r[1] *= .01, r[2] *= .01, f = v(r), f[3] = 1) : (t = e.match(/hsla\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) && (r = t.slice(1, 4), r[1] *= .01, r[2] *= .01, f = v(r), f[3] = +t[4]);return f;
	        }, m = function (e) {
	          var r, n, t, f, o, a;if (e.match(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)) return (4 === e.length || 7 === e.length) && (e = e.substr(1)), 3 === e.length && (e = e.split(""), e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]), a = parseInt(e, 16), f = a >> 16, t = a >> 8 & 255, n = 255 & a, [f, t, n, 1];if (e.match(/^#?([A-Fa-f0-9]{8})$/)) return 9 === e.length && (e = e.substr(1)), a = parseInt(e, 16), f = a >> 24 & 255, t = a >> 16 & 255, n = a >> 8 & 255, r = 255 & a, [f, t, n, r];if (o = p(e)) return o;throw "unknown color: " + e;
	        }, y = function (e, r, n) {
	          var t, f, i, c;return c = S(arguments), e = c[0], r = c[1], n = c[2], e /= 360, 1 / 3 > e ? (t = (1 - r) / 3, i = (1 + r * g(a * e) / g(o - a * e)) / 3, f = 1 - (t + i)) : 2 / 3 > e ? (e -= 1 / 3, i = (1 - r) / 3, f = (1 + r * g(a * e) / g(o - a * e)) / 3, t = 1 - (i + f)) : (e -= 2 / 3, f = (1 - r) / 3, t = (1 + r * g(a * e) / g(o - a * e)) / 3, i = 1 - (f + t)), i = q(n * i * 3), f = q(n * f * 3), t = q(n * t * 3), [255 * i, 255 * f, 255 * t];
	        }, v = function () {
	          var e, r, n, t, f, o, a, i, c, u, d, s, l, b;if ((l = S(arguments), t = l[0], i = l[1], o = l[2], 0 === i)) a = n = e = 255 * o;else {
	            for (d = [0, 0, 0], r = [0, 0, 0], u = .5 > o ? o * (1 + i) : o + i - o * i, c = 2 * o - u, t /= 360, d[0] = t + 1 / 3, d[1] = t, d[2] = t - 1 / 3, f = s = 0; 2 >= s; f = ++s) d[f] < 0 && (d[f] += 1), d[f] > 1 && (d[f] -= 1), r[f] = 6 * d[f] < 1 ? c + 6 * (u - c) * d[f] : 2 * d[f] < 1 ? u : 3 * d[f] < 2 ? c + (u - c) * (2 / 3 - d[f]) * 6 : c;b = [Math.round(255 * r[0]), Math.round(255 * r[1]), Math.round(255 * r[2])], a = b[0], n = b[1], e = b[2];
	          }return [a, n, e];
	        }, w = function () {
	          var e, r, n, t, f, o, a, i, c, u, d, s, l, b, h, g, p, m;if ((s = S(arguments), t = s[0], c = s[1], d = s[2], d *= 255, 0 === c)) i = n = e = d;else switch ((360 === t && (t = 0), t > 360 && (t -= 360), 0 > t && (t += 360), t /= 60, f = Math.floor(t), r = t - f, o = d * (1 - c), a = d * (1 - c * r), u = d * (1 - c * (1 - r)), f)) {case 0:
	              l = [d, u, o], i = l[0], n = l[1], e = l[2];break;case 1:
	              b = [a, d, o], i = b[0], n = b[1], e = b[2];break;case 2:
	              h = [o, d, u], i = h[0], n = h[1], e = h[2];break;case 3:
	              g = [o, a, d], i = g[0], n = g[1], e = g[2];break;case 4:
	              p = [u, o, d], i = p[0], n = p[1], e = p[2];break;case 5:
	              m = [d, o, a], i = m[0], n = m[1], e = m[2];}return i = Math.round(i), n = Math.round(n), e = Math.round(e), [i, n, e];
	        }, f = 18, i = .95047, c = 1, u = 1.08883, x = function () {
	          var e, r, n, t, f, o;return o = S(arguments), f = o[0], e = o[1], r = o[2], n = Math.sqrt(e * e + r * r), t = Math.atan2(r, e) / Math.PI * 180, [f, n, t];
	        }, _ = function (e, r, n) {
	          var t, f, o, a, d, s, l;return void 0 !== e && 3 === e.length && (s = e, e = s[0], r = s[1], n = s[2]), void 0 !== e && 3 === e.length && (l = e, e = l[0], r = l[1], n = l[2]), a = (e + 16) / 116, o = a + r / 500, d = a - n / 200, o = k(o) * i, a = k(a) * c, d = k(d) * u, f = T(3.2404542 * o - 1.5371385 * a - .4985314 * d), t = T(-.969266 * o + 1.8760108 * a + .041556 * d), n = T(.0556434 * o - .2040259 * a + 1.0572252 * d), [q(f, 0, 255), q(t, 0, 255), q(n, 0, 255), 1];
	        }, k = function (e) {
	          return e > .206893034 ? e * e * e : (e - 4 / 29) / 7.787037;
	        }, T = function (e) {
	          return Math.round(255 * (.00304 >= e ? 12.92 * e : 1.055 * Math.pow(e, 1 / 2.4) - .055));
	        }, j = function () {
	          var e, r, n, t;return t = S(arguments), n = t[0], e = t[1], r = t[2], r = r * Math.PI / 180, [n, Math.cos(r) * e, Math.sin(r) * e];
	        }, M = function (e, r, n) {
	          var t, f, o, a, i, c, u;return c = j(e, r, n), t = c[0], f = c[1], o = c[2], u = _(t, f, o), i = u[0], a = u[1], o = u[2], [q(i, 0, 255), q(a, 0, 255), q(o, 0, 255)];
	        }, C = function (e, r, n) {
	          var t;return t = S(arguments), e = t[0], r = t[1], n = t[2], e = N(e), r = N(r), n = N(n), .2126 * e + .7152 * r + .0722 * n;
	        }, N = function (e) {
	          return e /= 255, .03928 >= e ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
	        }, U = function () {
	          var e, r, n, t, f, o;return o = S(arguments), n = o[0], r = o[1], e = o[2], f = n << 16 | r << 8 | e, t = "000000" + f.toString(16), "#" + t.substr(t.length - 6);
	        }, A = function () {
	          var e, r, n, t, f, o, a, i, c;return c = S(arguments), a = c[0], n = c[1], r = c[2], e = 2 * Math.PI, a /= 255, n /= 255, r /= 255, o = Math.min(a, n, r), f = (a + n + r) / 3, i = 1 - o / f, 0 === i ? t = 0 : (t = (a - n + (a - r)) / 2, t /= Math.sqrt((a - n) * (a - n) + (a - r) * (n - r)), t = Math.acos(t), r > n && (t = e - t), t /= e), [360 * t, i, f];
	        }, P = function (e, r, n) {
	          var t, f, o, a, i, c;return void 0 !== e && e.length >= 3 && (c = e, e = c[0], r = c[1], n = c[2]), e /= 255, r /= 255, n /= 255, a = Math.min(e, r, n), o = Math.max(e, r, n), f = (o + a) / 2, o === a ? (i = 0, t = Number.NaN) : i = .5 > f ? (o - a) / (o + a) : (o - a) / (2 - o - a), e === o ? t = (r - n) / (o - a) : r === o ? t = 2 + (n - e) / (o - a) : n === o && (t = 4 + (e - r) / (o - a)), t *= 60, 0 > t && (t += 360), [t, i, f];
	        }, z = function () {
	          var e, r, n, t, f, o, a, i, c, u;return u = S(arguments), a = u[0], n = u[1], e = u[2], o = Math.min(a, n, e), f = Math.max(a, n, e), r = f - o, c = f / 255, 0 === f ? (t = Number.NaN, i = 0) : (i = r / f, a === f && (t = (n - e) / r), n === f && (t = 2 + (e - a) / r), e === f && (t = 4 + (a - n) / r), t *= 60, 0 > t && (t += 360)), [t, i, c];
	        }, G = function () {
	          var e, r, n, t, f, o, a;return a = S(arguments), n = a[0], r = a[1], e = a[2], n = B(n), r = B(r), e = B(e), t = O((.4124564 * n + .3575761 * r + .1804375 * e) / i), f = O((.2126729 * n + .7151522 * r + .072175 * e) / c), o = O((.0193339 * n + .119192 * r + .9503041 * e) / u), [116 * f - 16, 500 * (t - f), 200 * (f - o)];
	        }, B = function (e) {
	          return (e /= 255) <= .04045 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
	        }, O = function (e) {
	          return e > .008856 ? Math.pow(e, 1 / 3) : 7.787037 * e + 4 / 29;
	        }, E = function () {
	          var e, r, n, t, f, o, a;return o = S(arguments), f = o[0], n = o[1], r = o[2], a = G(f, n, r), t = a[0], e = a[1], r = a[2], x(t, e, r);
	        }, l.scale = function (e, r) {
	          var n, t, f, o, a, i, c, u, d, s, b, h, g, p, m, y, v, w, x, _, k;return y = "rgb", v = l("#ccc"), k = 0, g = !1, h = [0, 1], s = [], x = !1, _ = [], m = 0, p = 1, b = !1, w = 0, d = {}, i = function (e, r) {
	            var n, t, f, o, i, c, u;if ((null == e && (e = ["#ddd", "#222"]), null != e && "string" === R(e) && null != (null != (i = l.brewer) ? i[e] : void 0) && (e = l.brewer[e]), "array" === R(e))) {
	              for (e = e.slice(0), n = f = 0, c = e.length - 1; c >= 0 ? c >= f : f >= c; n = c >= 0 ? ++f : --f) t = e[n], "string" === R(t) && (e[n] = l(t));if (null != r) _ = r;else for (_ = [], n = o = 0, u = e.length - 1; u >= 0 ? u >= o : o >= u; n = u >= 0 ? ++o : --o) _.push(n / (e.length - 1));
	            }return a(), s = e;
	          }, c = function (e) {
	            return null == e && (e = []), h = e, m = e[0], p = e[e.length - 1], a(), w = 2 === e.length ? 0 : e.length - 1;
	          }, f = function (e) {
	            var r, n;if (null != h) {
	              for (n = h.length - 1, r = 0; n > r && e >= h[r];) r++;return r - 1;
	            }return 0;
	          }, u = function (e) {
	            return e;
	          }, n = function (e) {
	            var r, n, t, o, a;return a = e, h.length > 2 && (o = h.length - 1, r = f(e), t = h[0] + (h[1] - h[0]) * (0 + .5 * k), n = h[o - 1] + (h[o] - h[o - 1]) * (1 - .5 * k), a = m + (h[r] + .5 * (h[r + 1] - h[r]) - t) / (n - t) * (p - m)), a;
	          }, o = function (e, r) {
	            var n, t, o, a, i, c, b, g, x;if ((null == r && (r = !1), isNaN(e))) return v;if ((r ? b = e : h.length > 2 ? (n = f(e), b = n / (w - 1)) : (b = o = m !== p ? (e - m) / (p - m) : 0, b = o = (e - m) / (p - m), b = Math.min(1, Math.max(0, b))), r || (b = u(b)), i = Math.floor(1e4 * b), d[i])) t = d[i];else {
	              if ("array" === R(s)) for (a = g = 0, x = _.length - 1; x >= 0 ? x >= g : g >= x; a = x >= 0 ? ++g : --g) {
	                if ((c = _[a], c >= b)) {
	                  t = s[a];break;
	                }if (b >= c && a === _.length - 1) {
	                  t = s[a];break;
	                }if (b > c && b < _[a + 1]) {
	                  b = (b - c) / (_[a + 1] - c), t = l.interpolate(s[a], s[a + 1], b, y);break;
	                }
	              } else "function" === R(s) && (t = s(b));d[i] = t;
	            }return t;
	          }, a = function () {
	            return d = {};
	          }, i(e, r), t = function (e) {
	            var r;return r = o(e), x && r[x] ? r[x]() : r;
	          }, t.domain = function (e, r, n, f) {
	            var o;return null == n && (n = "e"), arguments.length ? (null != r && (o = l.analyze(e, f), e = 0 === r ? [o.min, o.max] : l.limits(o, n, r)), c(e), t) : h;
	          }, t.mode = function (e) {
	            return arguments.length ? (y = e, a(), t) : y;
	          }, t.range = function (e, r) {
	            return i(e, r), t;
	          }, t.out = function (e) {
	            return x = e, t;
	          }, t.spread = function (e) {
	            return arguments.length ? (k = e, t) : k;
	          }, t.correctLightness = function (e) {
	            return arguments.length ? (b = e, a(), u = b ? function (e) {
	              var r, n, t, f, a, i, c, u, d;for (r = o(0, !0).lab()[0], n = o(1, !0).lab()[0], c = r > n, t = o(e, !0).lab()[0], a = r + (n - r) * e, f = t - a, u = 0, d = 1, i = 20; Math.abs(f) > .01 && i-- > 0;) !(function () {
	                return c && (f *= -1), 0 > f ? (u = e, e += .5 * (d - e)) : (d = e, e += .5 * (u - e)), t = o(e, !0).lab()[0], f = t - a;
	              })();return e;
	            } : function (e) {
	              return e;
	            }, t) : b;
	          }, t.colors = function (r) {
	            var n, f, o, a, i, c;if ((null == r && (r = "hex"), e = [], f = [], h.length > 2)) for (n = o = 1, c = h.length; c >= 1 ? c > o : o > c; n = c >= 1 ? ++o : --o) f.push(.5 * (h[n - 1] + h[n]));else f = h;for (a = 0, i = f.length; i > a; a++) n = f[a], e.push(t(n)[r]());return e;
	          }, t;
	        }, null == (Y = l.scales) && (l.scales = {}), l.scales.cool = function () {
	          return l.scale([l.hsl(180, 1, .9), l.hsl(250, .7, .4)]);
	        }, l.scales.hot = function () {
	          return l.scale(["#000", "#f00", "#ff0", "#fff"], [0, .25, .75, 1]).mode("rgb");
	        }, l.analyze = function (e, r, n) {
	          var t, f, o, a, i, c, u;if ((o = { min: Number.MAX_VALUE, max: -1 * Number.MAX_VALUE, sum: 0, values: [], count: 0 }, null == n && (n = function () {
	            return !0;
	          }), t = function (e) {
	            null == e || isNaN(e) || (o.values.push(e), o.sum += e, e < o.min && (o.min = e), e > o.max && (o.max = e), o.count += 1);
	          }, i = function (e, f) {
	            return n(e, f) ? null != r && "function" === R(r) ? t(r(e)) : null != r && "string" === R(r) || "number" === R(r) ? t(e[r]) : t(e) : void 0;
	          }, "array" === R(e))) for (c = 0, u = e.length; u > c; c++) a = e[c], i(a);else for (f in e) a = e[f], i(a, f);return o.domain = [o.min, o.max], o.limits = function (e, r) {
	            return l.limits(o, e, r);
	          }, o;
	        }, l.limits = function (e, r, n) {
	          var t, f, o, a, i, c, u, d, s, b, h, g, p, m, y, v, w, x, _, k, j, M, q, C, N, U, A, P, z, G, E, B, I, S, O, T, Y, L, F, D, V, X, W, $, Z, H, J, K, Q, er, rr, nr, tr, fr, or, ar;if ((null == r && (r = "equal"), null == n && (n = 7), "array" === R(e) && (e = l.analyze(e)), p = e.min, h = e.max, q = e.sum, U = e.values.sort(function (e, r) {
	            return e - r;
	          }), b = [], "c" === r.substr(0, 1) && (b.push(p), b.push(h)), "e" === r.substr(0, 1))) {
	            for (b.push(p), u = A = 1, Y = n - 1; Y >= 1 ? Y >= A : A >= Y; u = Y >= 1 ? ++A : --A) b.push(p + u / n * (h - p));b.push(h);
	          } else if ("l" === r.substr(0, 1)) {
	            if (0 >= p) throw "Logarithmic scales are only possible for values > 0";for (m = Math.LOG10E * Math.log(p), g = Math.LOG10E * Math.log(h), b.push(p), u = P = 1, $ = n - 1; $ >= 1 ? $ >= P : P >= $; u = $ >= 1 ? ++P : --P) b.push(Math.pow(10, m + u / n * (g - m)));b.push(h);
	          } else if ("q" === r.substr(0, 1)) {
	            for (b.push(p), u = z = 1, Z = n - 1; Z >= 1 ? Z >= z : z >= Z; u = Z >= 1 ? ++z : --z) _ = U.length * u / n, k = Math.floor(_), k === _ ? b.push(U[k]) : (j = _ - k, b.push(U[k] * j + U[k + 1] * (1 - j)));b.push(h);
	          } else if ("k" === r.substr(0, 1)) {
	            for (v = U.length, t = new Array(v), i = new Array(n), M = !0, w = 0, o = null, o = [], o.push(p), u = G = 1, H = n - 1; H >= 1 ? H >= G : G >= H; u = H >= 1 ? ++G : --G) o.push(p + u / n * (h - p));for (o.push(h); M;) {
	              for (d = E = 0, J = n - 1; J >= 0 ? J >= E : E >= J; d = J >= 0 ? ++E : --E) i[d] = 0;for (u = B = 0, K = v - 1; K >= 0 ? K >= B : B >= K; u = K >= 0 ? ++B : --B) {
	                for (N = U[u], y = Number.MAX_VALUE, d = I = 0, Q = n - 1; Q >= 0 ? Q >= I : I >= Q; d = Q >= 0 ? ++I : --I) c = Math.abs(o[d] - N), y > c && (y = c, f = d);i[f]++, t[u] = f;
	              }for (x = new Array(n), d = S = 0, er = n - 1; er >= 0 ? er >= S : S >= er; d = er >= 0 ? ++S : --S) x[d] = null;for (u = O = 0, rr = v - 1; rr >= 0 ? rr >= O : O >= rr; u = rr >= 0 ? ++O : --O) a = t[u], null === x[a] ? x[a] = U[u] : x[a] += U[u];for (d = T = 0, L = n - 1; L >= 0 ? L >= T : T >= L; d = L >= 0 ? ++T : --T) x[d] *= 1 / i[d];for (M = !1, d = nr = 0, F = n - 1; F >= 0 ? F >= nr : nr >= F; d = F >= 0 ? ++nr : --nr) if (x[d] !== o[u]) {
	                M = !0;break;
	              }o = x, w++, w > 200 && (M = !1);
	            }for (s = {}, d = tr = 0, D = n - 1; D >= 0 ? D >= tr : tr >= D; d = D >= 0 ? ++tr : --tr) s[d] = [];for (u = fr = 0, V = v - 1; V >= 0 ? V >= fr : fr >= V; u = V >= 0 ? ++fr : --fr) a = t[u], s[a].push(U[u]);for (C = [], d = or = 0, X = n - 1; X >= 0 ? X >= or : or >= X; d = X >= 0 ? ++or : --or) C.push(s[d][0]), C.push(s[d][s[d].length - 1]);for (C = C.sort(function (e, r) {
	              return e - r;
	            }), b.push(C[0]), u = ar = 1, W = C.length - 1; W >= ar; u = ar += 2) isNaN(C[u]) || b.push(C[u]);
	          }return b;
	        }, l.brewer = s = { OrRd: ["#fff7ec", "#fee8c8", "#fdd49e", "#fdbb84", "#fc8d59", "#ef6548", "#d7301f", "#b30000", "#7f0000"], PuBu: ["#fff7fb", "#ece7f2", "#d0d1e6", "#a6bddb", "#74a9cf", "#3690c0", "#0570b0", "#045a8d", "#023858"], BuPu: ["#f7fcfd", "#e0ecf4", "#bfd3e6", "#9ebcda", "#8c96c6", "#8c6bb1", "#88419d", "#810f7c", "#4d004b"], Oranges: ["#fff5eb", "#fee6ce", "#fdd0a2", "#fdae6b", "#fd8d3c", "#f16913", "#d94801", "#a63603", "#7f2704"], BuGn: ["#f7fcfd", "#e5f5f9", "#ccece6", "#99d8c9", "#66c2a4", "#41ae76", "#238b45", "#006d2c", "#00441b"], YlOrBr: ["#ffffe5", "#fff7bc", "#fee391", "#fec44f", "#fe9929", "#ec7014", "#cc4c02", "#993404", "#662506"], YlGn: ["#ffffe5", "#f7fcb9", "#d9f0a3", "#addd8e", "#78c679", "#41ab5d", "#238443", "#006837", "#004529"], Reds: ["#fff5f0", "#fee0d2", "#fcbba1", "#fc9272", "#fb6a4a", "#ef3b2c", "#cb181d", "#a50f15", "#67000d"], RdPu: ["#fff7f3", "#fde0dd", "#fcc5c0", "#fa9fb5", "#f768a1", "#dd3497", "#ae017e", "#7a0177", "#49006a"], Greens: ["#f7fcf5", "#e5f5e0", "#c7e9c0", "#a1d99b", "#74c476", "#41ab5d", "#238b45", "#006d2c", "#00441b"], YlGnBu: ["#ffffd9", "#edf8b1", "#c7e9b4", "#7fcdbb", "#41b6c4", "#1d91c0", "#225ea8", "#253494", "#081d58"], Purples: ["#fcfbfd", "#efedf5", "#dadaeb", "#bcbddc", "#9e9ac8", "#807dba", "#6a51a3", "#54278f", "#3f007d"], GnBu: ["#f7fcf0", "#e0f3db", "#ccebc5", "#a8ddb5", "#7bccc4", "#4eb3d3", "#2b8cbe", "#0868ac", "#084081"], Greys: ["#ffffff", "#f0f0f0", "#d9d9d9", "#bdbdbd", "#969696", "#737373", "#525252", "#252525", "#000000"], YlOrRd: ["#ffffcc", "#ffeda0", "#fed976", "#feb24c", "#fd8d3c", "#fc4e2a", "#e31a1c", "#bd0026", "#800026"], PuRd: ["#f7f4f9", "#e7e1ef", "#d4b9da", "#c994c7", "#df65b0", "#e7298a", "#ce1256", "#980043", "#67001f"], Blues: ["#f7fbff", "#deebf7", "#c6dbef", "#9ecae1", "#6baed6", "#4292c6", "#2171b5", "#08519c", "#08306b"], PuBuGn: ["#fff7fb", "#ece2f0", "#d0d1e6", "#a6bddb", "#67a9cf", "#3690c0", "#02818a", "#016c59", "#014636"], Spectral: ["#9e0142", "#d53e4f", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#e6f598", "#abdda4", "#66c2a5", "#3288bd", "#5e4fa2"], RdYlGn: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee08b", "#ffffbf", "#d9ef8b", "#a6d96a", "#66bd63", "#1a9850", "#006837"], RdBu: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#f7f7f7", "#d1e5f0", "#92c5de", "#4393c3", "#2166ac", "#053061"], PiYG: ["#8e0152", "#c51b7d", "#de77ae", "#f1b6da", "#fde0ef", "#f7f7f7", "#e6f5d0", "#b8e186", "#7fbc41", "#4d9221", "#276419"], PRGn: ["#40004b", "#762a83", "#9970ab", "#c2a5cf", "#e7d4e8", "#f7f7f7", "#d9f0d3", "#a6dba0", "#5aae61", "#1b7837", "#00441b"], RdYlBu: ["#a50026", "#d73027", "#f46d43", "#fdae61", "#fee090", "#ffffbf", "#e0f3f8", "#abd9e9", "#74add1", "#4575b4", "#313695"], BrBG: ["#543005", "#8c510a", "#bf812d", "#dfc27d", "#f6e8c3", "#f5f5f5", "#c7eae5", "#80cdc1", "#35978f", "#01665e", "#003c30"], RdGy: ["#67001f", "#b2182b", "#d6604d", "#f4a582", "#fddbc7", "#ffffff", "#e0e0e0", "#bababa", "#878787", "#4d4d4d", "#1a1a1a"], PuOr: ["#7f3b08", "#b35806", "#e08214", "#fdb863", "#fee0b6", "#f7f7f7", "#d8daeb", "#b2abd2", "#8073ac", "#542788", "#2d004b"], Set2: ["#66c2a5", "#fc8d62", "#8da0cb", "#e78ac3", "#a6d854", "#ffd92f", "#e5c494", "#b3b3b3"], Accent: ["#7fc97f", "#beaed4", "#fdc086", "#ffff99", "#386cb0", "#f0027f", "#bf5b17", "#666666"], Set1: ["#e41a1c", "#377eb8", "#4daf4a", "#984ea3", "#ff7f00", "#ffff33", "#a65628", "#f781bf", "#999999"], Set3: ["#8dd3c7", "#ffffb3", "#bebada", "#fb8072", "#80b1d3", "#fdb462", "#b3de69", "#fccde5", "#d9d9d9", "#bc80bd", "#ccebc5", "#ffed6f"], Dark2: ["#1b9e77", "#d95f02", "#7570b3", "#e7298a", "#66a61e", "#e6ab02", "#a6761d", "#666666"], Paired: ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6", "#6a3d9a", "#ffff99", "#b15928"], Pastel2: ["#b3e2cd", "#fdcdac", "#cbd5e8", "#f4cae4", "#e6f5c9", "#fff2ae", "#f1e2cc", "#cccccc"], Pastel1: ["#fbb4ae", "#b3cde3", "#ccebc5", "#decbe4", "#fed9a6", "#ffffcc", "#e5d8bd", "#fddaec", "#f2f2f2"] }, l.colors = h = { indigo: "#4b0082", gold: "#ffd700", hotpink: "#ff69b4", firebrick: "#b22222", indianred: "#cd5c5c", yellow: "#ffff00", mistyrose: "#ffe4e1", darkolivegreen: "#556b2f", olive: "#808000", darkseagreen: "#8fbc8f", pink: "#ffc0cb", tomato: "#ff6347", lightcoral: "#f08080", orangered: "#ff4500", navajowhite: "#ffdead", lime: "#00ff00", palegreen: "#98fb98", darkslategrey: "#2f4f4f", greenyellow: "#adff2f", burlywood: "#deb887", seashell: "#fff5ee", mediumspringgreen: "#00fa9a", fuchsia: "#ff00ff", papayawhip: "#ffefd5", blanchedalmond: "#ffebcd", chartreuse: "#7fff00", dimgray: "#696969", black: "#000000", peachpuff: "#ffdab9", springgreen: "#00ff7f", aquamarine: "#7fffd4", white: "#ffffff", orange: "#ffa500", lightsalmon: "#ffa07a", darkslategray: "#2f4f4f", brown: "#a52a2a", ivory: "#fffff0", dodgerblue: "#1e90ff", peru: "#cd853f", lawngreen: "#7cfc00", chocolate: "#d2691e", crimson: "#dc143c", forestgreen: "#228b22", darkgrey: "#a9a9a9", lightseagreen: "#20b2aa", cyan: "#00ffff", mintcream: "#f5fffa", silver: "#c0c0c0", antiquewhite: "#faebd7", mediumorchid: "#ba55d3", skyblue: "#87ceeb", gray: "#808080", darkturquoise: "#00ced1", goldenrod: "#daa520", darkgreen: "#006400", floralwhite: "#fffaf0", darkviolet: "#9400d3", darkgray: "#a9a9a9", moccasin: "#ffe4b5", saddlebrown: "#8b4513", grey: "#808080", darkslateblue: "#483d8b", lightskyblue: "#87cefa", lightpink: "#ffb6c1", mediumvioletred: "#c71585", slategrey: "#708090", red: "#ff0000", deeppink: "#ff1493", limegreen: "#32cd32", darkmagenta: "#8b008b", palegoldenrod: "#eee8aa", plum: "#dda0dd", turquoise: "#40e0d0", lightgrey: "#d3d3d3", lightgoldenrodyellow: "#fafad2", darkgoldenrod: "#b8860b", lavender: "#e6e6fa", maroon: "#800000", yellowgreen: "#9acd32", sandybrown: "#f4a460", thistle: "#d8bfd8", violet: "#ee82ee", navy: "#000080", magenta: "#ff00ff", dimgrey: "#696969", tan: "#d2b48c", rosybrown: "#bc8f8f", olivedrab: "#6b8e23", blue: "#0000ff", lightblue: "#add8e6", ghostwhite: "#f8f8ff", honeydew: "#f0fff0", cornflowerblue: "#6495ed", slateblue: "#6a5acd", linen: "#faf0e6", darkblue: "#00008b", powderblue: "#b0e0e6", seagreen: "#2e8b57", darkkhaki: "#bdb76b", snow: "#fffafa", sienna: "#a0522d", mediumblue: "#0000cd", royalblue: "#4169e1", lightcyan: "#e0ffff", green: "#008000", mediumpurple: "#9370db", midnightblue: "#191970", cornsilk: "#fff8dc", paleturquoise: "#afeeee", bisque: "#ffe4c4", slategray: "#708090", darkcyan: "#008b8b", khaki: "#f0e68c", wheat: "#f5deb3", teal: "#008080", darkorchid: "#9932cc", deepskyblue: "#00bfff", salmon: "#fa8072", darkred: "#8b0000", steelblue: "#4682b4", palevioletred: "#db7093", lightslategray: "#778899", aliceblue: "#f0f8ff", lightslategrey: "#778899", lightgreen: "#90ee90", orchid: "#da70d6", gainsboro: "#dcdcdc", mediumseagreen: "#3cb371", lightgray: "#d3d3d3", mediumturquoise: "#48d1cc", lemonchiffon: "#fffacd", cadetblue: "#5f9ea0", lightyellow: "#ffffe0", lavenderblush: "#fff0f5", coral: "#ff7f50", purple: "#800080", aqua: "#00ffff", whitesmoke: "#f5f5f5", mediumslateblue: "#7b68ee", darkorange: "#ff8c00", mediumaquamarine: "#66cdaa", darksalmon: "#e9967a", beige: "#f5f5dc", blueviolet: "#8a2be2", azure: "#f0ffff", lightsteelblue: "#b0c4de", oldlace: "#fdf5e6" }, R = (function () {
	          var e, r, n, t, f;for (e = {}, f = "Boolean Number String Function Array Date RegExp Undefined Null".split(" "), n = 0, t = f.length; t > n; n++) r = f[n], e["[object " + r + "]"] = r.toLowerCase();return function (r) {
	            var n;return n = Object.prototype.toString.call(r), e[n] || "object";
	          };
	        })(), q = function (e, r, n) {
	          return null == r && (r = 0), null == n && (n = 1), r > e && (e = r), e > n && (e = n), e;
	        }, S = function (e) {
	          return e.length >= 3 ? e : e[0];
	        }, a = 2 * Math.PI, o = Math.PI / 3, g = Math.cos, d = function (e) {
	          var r, n, t, f, o, a, i, c, u, s, b;return e = (function () {
	            var r, n, t;for (t = [], r = 0, n = e.length; n > r; r++) f = e[r], t.push(l(f));return t;
	          })(), 2 === e.length ? (u = (function () {
	            var r, n, t;for (t = [], r = 0, n = e.length; n > r; r++) f = e[r], t.push(f.lab());return t;
	          })(), o = u[0], a = u[1], r = function (e) {
	            var r, n;return n = (function () {
	              var n, t;for (t = [], r = n = 0; 2 >= n; r = ++n) t.push(o[r] + e * (a[r] - o[r]));return t;
	            })(), l.lab.apply(l, n);
	          }) : 3 === e.length ? (s = (function () {
	            var r, n, t;
	            for (t = [], r = 0, n = e.length; n > r; r++) f = e[r], t.push(f.lab());return t;
	          })(), o = s[0], a = s[1], i = s[2], r = function (e) {
	            var r, n;return n = (function () {
	              var n, t;for (t = [], r = n = 0; 2 >= n; r = ++n) t.push((1 - e) * (1 - e) * o[r] + 2 * (1 - e) * e * a[r] + e * e * i[r]);return t;
	            })(), l.lab.apply(l, n);
	          }) : 4 === e.length ? (b = (function () {
	            var r, n, t;for (t = [], r = 0, n = e.length; n > r; r++) f = e[r], t.push(f.lab());return t;
	          })(), o = b[0], a = b[1], i = b[2], c = b[3], r = function (e) {
	            var r, n;return n = (function () {
	              var n, t;for (t = [], r = n = 0; 2 >= n; r = ++n) t.push((1 - e) * (1 - e) * (1 - e) * o[r] + 3 * (1 - e) * (1 - e) * e * a[r] + 3 * (1 - e) * e * e * i[r] + e * e * e * c[r]);return t;
	            })(), l.lab.apply(l, n);
	          }) : 5 === e.length && (n = d(e.slice(0, 3)), t = d(e.slice(2, 5)), r = function (e) {
	            return .5 > e ? n(2 * e) : t(2 * (e - .5));
	          }), r;
	        }, l.interpolate.bezier = d;
	      }).call(this);
	    }, {}], "/Users/qrohlf/Code/trianglify/node_modules/delaunay-fast/delaunay.js": [function (e, r) {
	      var n;!(function () {
	        "use strict";function e(e) {
	          var r,
	              n,
	              t,
	              f,
	              o,
	              a,
	              i = Number.POSITIVE_INFINITY,
	              c = Number.POSITIVE_INFINITY,
	              u = Number.NEGATIVE_INFINITY,
	              d = Number.NEGATIVE_INFINITY;for (r = e.length; r--;) e[r][0] < i && (i = e[r][0]), e[r][0] > u && (u = e[r][0]), e[r][1] < c && (c = e[r][1]), e[r][1] > d && (d = e[r][1]);return n = u - i, t = d - c, f = Math.max(n, t), o = i + .5 * n, a = c + .5 * t, [[o - 20 * f, a - f], [o, a + 20 * f], [o + 20 * f, a - f]];
	        }function t(e, r, n, t) {
	          var f,
	              a,
	              i,
	              c,
	              u,
	              d,
	              s,
	              l,
	              b,
	              h,
	              g = e[r][0],
	              p = e[r][1],
	              m = e[n][0],
	              y = e[n][1],
	              v = e[t][0],
	              w = e[t][1],
	              x = Math.abs(p - y),
	              _ = Math.abs(y - w);if (o > x && o > _) throw new Error("Eek! Coincident points!");return o > x ? (c = -((v - m) / (w - y)), d = (m + v) / 2, l = (y + w) / 2, f = (m + g) / 2, a = c * (f - d) + l) : o > _ ? (i = -((m - g) / (y - p)), u = (g + m) / 2, s = (p + y) / 2, f = (v + m) / 2, a = i * (f - u) + s) : (i = -((m - g) / (y - p)), c = -((v - m) / (w - y)), u = (g + m) / 2, d = (m + v) / 2, s = (p + y) / 2, l = (y + w) / 2, f = (i * u - c * d + l - s) / (i - c), a = x > _ ? i * (f - u) + s : c * (f - d) + l), b = m - f, h = y - a, { i: r, j: n, k: t, x: f, y: a, r: b * b + h * h };
	        }function f(e) {
	          var r, n, t, f, o, a;for (n = e.length; n;) for (f = e[--n], t = e[--n], r = n; r;) if ((a = e[--r], o = e[--r], t === o && f === a || t === a && f === o)) {
	            e.splice(n, 2), e.splice(r, 2);break;
	          }
	        }var o = 1 / 1048576;n = { triangulate: function triangulate(r, n) {
	            var a,
	                i,
	                c,
	                u,
	                d,
	                s,
	                l,
	                b,
	                h,
	                g,
	                p,
	                m,
	                y = r.length;if (3 > y) return [];if ((r = r.slice(0), n)) for (a = y; a--;) r[a] = r[a][n];for (c = new Array(y), a = y; a--;) c[a] = a;for (c.sort(function (e, n) {
	              return r[n][0] - r[e][0];
	            }), u = e(r), r.push(u[0], u[1], u[2]), d = [t(r, y + 0, y + 1, y + 2)], s = [], l = [], a = c.length; a--; l.length = 0) {
	              for (m = c[a], i = d.length; i--;) b = r[m][0] - d[i].x, b > 0 && b * b > d[i].r ? (s.push(d[i]), d.splice(i, 1)) : (h = r[m][1] - d[i].y, b * b + h * h - d[i].r > o || (l.push(d[i].i, d[i].j, d[i].j, d[i].k, d[i].k, d[i].i), d.splice(i, 1)));for (f(l), i = l.length; i;) p = l[--i], g = l[--i], d.push(t(r, g, p, m));
	            }for (a = d.length; a--;) s.push(d[a]);for (d.length = 0, a = s.length; a--;) s[a].i < y && s[a].j < y && s[a].k < y && d.push(s[a].i, s[a].j, s[a].k);return d;
	          }, contains: function contains(e, r) {
	            if (r[0] < e[0][0] && r[0] < e[1][0] && r[0] < e[2][0] || r[0] > e[0][0] && r[0] > e[1][0] && r[0] > e[2][0] || r[1] < e[0][1] && r[1] < e[1][1] && r[1] < e[2][1] || r[1] > e[0][1] && r[1] > e[1][1] && r[1] > e[2][1]) return null;var n = e[1][0] - e[0][0],
	                t = e[2][0] - e[0][0],
	                f = e[1][1] - e[0][1],
	                o = e[2][1] - e[0][1],
	                a = n * o - t * f;if (0 === a) return null;var i = (o * (r[0] - e[0][0]) - t * (r[1] - e[0][1])) / a,
	                c = (n * (r[1] - e[0][1]) - f * (r[0] - e[0][0])) / a;return 0 > i || 0 > c || i + c > 1 ? null : [i, c];
	          } }, "undefined" != typeof r && (r.exports = n);
	      })();
	    }, {}], "/Users/qrohlf/Code/trianglify/node_modules/seedrandom/index.js": [function (e, r) {
	      var n = e("./lib/alea"),
	          t = e("./lib/xor128"),
	          f = e("./lib/xorwow"),
	          o = e("./lib/xorshift7"),
	          a = e("./lib/xor4096"),
	          i = e("./lib/tychei"),
	          c = e("./seedrandom");c.alea = n, c.xor128 = t, c.xorwow = f, c.xorshift7 = o, c.xor4096 = a, c.tychei = i, r.exports = c;
	    }, { "./lib/alea": "/Users/qrohlf/Code/trianglify/node_modules/seedrandom/lib/alea.js", "./lib/tychei": "/Users/qrohlf/Code/trianglify/node_modules/seedrandom/lib/tychei.js", "./lib/xor128": "/Users/qrohlf/Code/trianglify/node_modules/seedrandom/lib/xor128.js", "./lib/xor4096": "/Users/qrohlf/Code/trianglify/node_modules/seedrandom/lib/xor4096.js", "./lib/xorshift7": "/Users/qrohlf/Code/trianglify/node_modules/seedrandom/lib/xorshift7.js", "./lib/xorwow": "/Users/qrohlf/Code/trianglify/node_modules/seedrandom/lib/xorwow.js", "./seedrandom": "/Users/qrohlf/Code/trianglify/node_modules/seedrandom/seedrandom.js" }], "/Users/qrohlf/Code/trianglify/node_modules/seedrandom/lib/alea.js": [function (r, n) {
	      !(function (e, r, n) {
	        function t(e) {
	          var r = this,
	              n = a();r.next = function () {
	            var e = 2091639 * r.s0 + 2.3283064365386963e-10 * r.c;return r.s0 = r.s1, r.s1 = r.s2, r.s2 = e - (r.c = 0 | e);
	          }, r.c = 1, r.s0 = n(" "), r.s1 = n(" "), r.s2 = n(" "), r.s0 -= n(e), r.s0 < 0 && (r.s0 += 1), r.s1 -= n(e), r.s1 < 0 && (r.s1 += 1), r.s2 -= n(e), r.s2 < 0 && (r.s2 += 1), n = null;
	        }function f(e, r) {
	          return r.c = e.c, r.s0 = e.s0, r.s1 = e.s1, r.s2 = e.s2, r;
	        }function o(e, r) {
	          var n = new t(e),
	              o = r && r.state,
	              a = n.next;return a.int32 = function () {
	            return 4294967296 * n.next() | 0;
	          }, a.double = function () {
	            return a() + 1.1102230246251565e-16 * (2097152 * a() | 0);
	          }, a.quick = a, o && ("object" == typeof o && f(o, n), a.state = function () {
	            return f(n, {});
	          }), a;
	        }function a() {
	          var e = 4022871197,
	              r = function r(_r) {
	            _r = _r.toString();for (var n = 0; n < _r.length; n++) {
	              e += _r.charCodeAt(n);var t = .02519603282416938 * e;e = t >>> 0, t -= e, t *= e, e = t >>> 0, t -= e, e += 4294967296 * t;
	            }return 2.3283064365386963e-10 * (e >>> 0);
	          };return r;
	        }r && r.exports ? r.exports = o : n && n.amd ? n(function () {
	          return o;
	        }) : this.alea = o;
	      })(this, "object" == typeof n && n, "function" == typeof e && e);
	    }, {}], "/Users/qrohlf/Code/trianglify/node_modules/seedrandom/lib/tychei.js": [function (r, n) {
	      !(function (e, r, n) {
	        function t(e) {
	          var r = this,
	              n = "";r.next = function () {
	            var e = r.b,
	                n = r.c,
	                t = r.d,
	                f = r.a;return e = e << 25 ^ e >>> 7 ^ n, n = n - t | 0, t = t << 24 ^ t >>> 8 ^ f, f = f - e | 0, r.b = e = e << 20 ^ e >>> 12 ^ n, r.c = n = n - t | 0, r.d = t << 16 ^ n >>> 16 ^ f, r.a = f - e | 0;
	          }, r.a = 0, r.b = 0, r.c = -1640531527, r.d = 1367130551, e === Math.floor(e) ? (r.a = e / 4294967296 | 0, r.b = 0 | e) : n += e;for (var t = 0; t < n.length + 20; t++) r.b ^= 0 | n.charCodeAt(t), r.next();
	        }function f(e, r) {
	          return r.a = e.a, r.b = e.b, r.c = e.c, r.d = e.d, r;
	        }function o(e, r) {
	          var n = new t(e),
	              o = r && r.state,
	              a = function a() {
	            return (n.next() >>> 0) / 4294967296;
	          };return a.double = function () {
	            do var e = n.next() >>> 11,
	                r = (n.next() >>> 0) / 4294967296,
	                t = (e + r) / (1 << 21); while (0 === t);return t;
	          }, a.int32 = n.next, a.quick = a, o && ("object" == typeof o && f(o, n), a.state = function () {
	            return f(n, {});
	          }), a;
	        }r && r.exports ? r.exports = o : n && n.amd ? n(function () {
	          return o;
	        }) : this.tychei = o;
	      })(this, "object" == typeof n && n, "function" == typeof e && e);
	    }, {}], "/Users/qrohlf/Code/trianglify/node_modules/seedrandom/lib/xor128.js": [function (r, n) {
	      !(function (e, r, n) {
	        function t(e) {
	          var r = this,
	              n = "";r.x = 0, r.y = 0, r.z = 0, r.w = 0, r.next = function () {
	            var e = r.x ^ r.x << 11;return r.x = r.y, r.y = r.z, r.z = r.w, r.w ^= r.w >>> 19 ^ e ^ e >>> 8;
	          }, e === (0 | e) ? r.x = e : n += e;for (var t = 0; t < n.length + 64; t++) r.x ^= 0 | n.charCodeAt(t), r.next();
	        }function f(e, r) {
	          return r.x = e.x, r.y = e.y, r.z = e.z, r.w = e.w, r;
	        }function o(e, r) {
	          var n = new t(e),
	              o = r && r.state,
	              a = function a() {
	            return (n.next() >>> 0) / 4294967296;
	          };return a.double = function () {
	            do var e = n.next() >>> 11,
	                r = (n.next() >>> 0) / 4294967296,
	                t = (e + r) / (1 << 21); while (0 === t);return t;
	          }, a.int32 = n.next, a.quick = a, o && ("object" == typeof o && f(o, n), a.state = function () {
	            return f(n, {});
	          }), a;
	        }r && r.exports ? r.exports = o : n && n.amd ? n(function () {
	          return o;
	        }) : this.xor128 = o;
	      })(this, "object" == typeof n && n, "function" == typeof e && e);
	    }, {}], "/Users/qrohlf/Code/trianglify/node_modules/seedrandom/lib/xor4096.js": [function (r, n) {
	      !(function (e, r, n) {
	        function t(e) {
	          function r(e, r) {
	            var n,
	                t,
	                f,
	                o,
	                a,
	                i = [],
	                c = 128;for (r === (0 | r) ? (t = r, r = null) : (r += "\x00", t = 0, c = Math.max(c, r.length)), f = 0, o = -32; c > o; ++o) r && (t ^= r.charCodeAt((o + 32) % r.length)), 0 === o && (a = t), t ^= t << 10, t ^= t >>> 15, t ^= t << 4, t ^= t >>> 13, o >= 0 && (a = a + 1640531527 | 0, n = i[127 & o] ^= t + a, f = 0 == n ? f + 1 : 0);for (f >= 128 && (i[127 & (r && r.length || 0)] = -1), f = 127, o = 512; o > 0; --o) t = i[f + 34 & 127], n = i[f = f + 1 & 127], t ^= t << 13, n ^= n << 17, t ^= t >>> 15, n ^= n >>> 12, i[f] = t ^ n;e.w = a, e.X = i, e.i = f;
	          }var n = this;n.next = function () {
	            var e,
	                r,
	                t = n.w,
	                f = n.X,
	                o = n.i;return n.w = t = t + 1640531527 | 0, r = f[o + 34 & 127], e = f[o = o + 1 & 127], r ^= r << 13, e ^= e << 17, r ^= r >>> 15, e ^= e >>> 12, r = f[o] = r ^ e, n.i = o, r + (t ^ t >>> 16) | 0;
	          }, r(n, e);
	        }function f(e, r) {
	          return r.i = e.i, r.w = e.w, r.X = e.X.slice(), r;
	        }function o(e, r) {
	          null == e && (e = +new Date());var n = new t(e),
	              o = r && r.state,
	              a = function a() {
	            return (n.next() >>> 0) / 4294967296;
	          };return a.double = function () {
	            do var e = n.next() >>> 11,
	                r = (n.next() >>> 0) / 4294967296,
	                t = (e + r) / (1 << 21); while (0 === t);return t;
	          }, a.int32 = n.next, a.quick = a, o && (o.X && f(o, n), a.state = function () {
	            return f(n, {});
	          }), a;
	        }r && r.exports ? r.exports = o : n && n.amd ? n(function () {
	          return o;
	        }) : this.xor4096 = o;
	      })(this, "object" == typeof n && n, "function" == typeof e && e);
	    }, {}], "/Users/qrohlf/Code/trianglify/node_modules/seedrandom/lib/xorshift7.js": [function (r, n) {
	      !(function (e, r, n) {
	        function t(e) {
	          function r(e, r) {
	            var n,
	                t,
	                f = [];if (r === (0 | r)) t = f[0] = r;else for (r = "" + r, n = 0; n < r.length; ++n) f[7 & n] = f[7 & n] << 15 ^ r.charCodeAt(n) + f[n + 1 & 7] << 13;for (; f.length < 8;) f.push(0);for (n = 0; 8 > n && 0 === f[n]; ++n);for (t = 8 == n ? f[7] = -1 : f[n], e.x = f, e.i = 0, n = 256; n > 0; --n) e.next();
	          }var n = this;n.next = function () {
	            var e,
	                r,
	                t = n.x,
	                f = n.i;return e = t[f], e ^= e >>> 7, r = e ^ e << 24, e = t[f + 1 & 7], r ^= e ^ e >>> 10, e = t[f + 3 & 7], r ^= e ^ e >>> 3, e = t[f + 4 & 7], r ^= e ^ e << 7, e = t[f + 7 & 7], e ^= e << 13, r ^= e ^ e << 9, t[f] = r, n.i = f + 1 & 7, r;
	          }, r(n, e);
	        }function f(e, r) {
	          return r.x = e.x.slice(), r.i = e.i, r;
	        }function o(e, r) {
	          null == e && (e = +new Date());var n = new t(e),
	              o = r && r.state,
	              a = function a() {
	            return (n.next() >>> 0) / 4294967296;
	          };return a.double = function () {
	            do var e = n.next() >>> 11,
	                r = (n.next() >>> 0) / 4294967296,
	                t = (e + r) / (1 << 21); while (0 === t);return t;
	          }, a.int32 = n.next, a.quick = a, o && (o.x && f(o, n), a.state = function () {
	            return f(n, {});
	          }), a;
	        }r && r.exports ? r.exports = o : n && n.amd ? n(function () {
	          return o;
	        }) : this.xorshift7 = o;
	      })(this, "object" == typeof n && n, "function" == typeof e && e);
	    }, {}], "/Users/qrohlf/Code/trianglify/node_modules/seedrandom/lib/xorwow.js": [function (r, n) {
	      !(function (e, r, n) {
	        function t(e) {
	          var r = this,
	              n = "";r.next = function () {
	            var e = r.x ^ r.x >>> 2;return r.x = r.y, r.y = r.z, r.z = r.w, r.w = r.v, (r.d = r.d + 362437 | 0) + (r.v = r.v ^ r.v << 4 ^ (e ^ e << 1)) | 0;
	          }, r.x = 0, r.y = 0, r.z = 0, r.w = 0, r.v = 0, e === (0 | e) ? r.x = e : n += e;for (var t = 0; t < n.length + 64; t++) r.x ^= 0 | n.charCodeAt(t), t == n.length && (r.d = r.x << 10 ^ r.x >>> 4), r.next();
	        }function f(e, r) {
	          return r.x = e.x, r.y = e.y, r.z = e.z, r.w = e.w, r.v = e.v, r.d = e.d, r;
	        }function o(e, r) {
	          var n = new t(e),
	              o = r && r.state,
	              a = function a() {
	            return (n.next() >>> 0) / 4294967296;
	          };return a.double = function () {
	            do var e = n.next() >>> 11,
	                r = (n.next() >>> 0) / 4294967296,
	                t = (e + r) / (1 << 21); while (0 === t);return t;
	          }, a.int32 = n.next, a.quick = a, o && ("object" == typeof o && f(o, n), a.state = function () {
	            return f(n, {});
	          }), a;
	        }r && r.exports ? r.exports = o : n && n.amd ? n(function () {
	          return o;
	        }) : this.xorwow = o;
	      })(this, "object" == typeof n && n, "function" == typeof e && e);
	    }, {}], "/Users/qrohlf/Code/trianglify/node_modules/seedrandom/seedrandom.js": [function (r, n) {
	      !(function (t, f) {
	        function o(e, r, n) {
	          var o = [];r = 1 == r ? { entropy: !0 } : r || {};var l = u(c(r.entropy ? [e, s(t)] : null == e ? d() : e, 3), o),
	              b = new a(o),
	              p = function p() {
	            for (var e = b.g(g), r = y, n = 0; v > e;) e = (e + n) * h, r *= h, n = b.g(1);for (; e >= w;) e /= 2, r /= 2, n >>>= 1;return (e + n) / r;
	          };return p.int32 = function () {
	            return 0 | b.g(4);
	          }, p.quick = function () {
	            return b.g(4) / 4294967296;
	          }, p.double = p, u(s(b.S), t), (r.pass || n || function (e, r, n, t) {
	            return t && (t.S && i(t, b), e.state = function () {
	              return i(b, {});
	            }), n ? (f[m] = e, r) : e;
	          })(p, l, "global" in r ? r.global : this == f, r.state);
	        }function a(e) {
	          var r,
	              n = e.length,
	              t = this,
	              f = 0,
	              o = t.i = t.j = 0,
	              a = t.S = [];for (n || (e = [n++]); h > f;) a[f] = f++;for (f = 0; h > f; f++) a[f] = a[o = x & o + e[f % n] + (r = a[f])], a[o] = r;(t.g = function (e) {
	            for (var r, n = 0, f = t.i, o = t.j, a = t.S; e--;) r = a[f = x & f + 1], n = n * h + a[x & (a[f] = a[o = x & o + r]) + (a[o] = r)];return t.i = f, t.j = o, n;
	          })(h);
	        }function i(e, r) {
	          return r.i = e.i, r.j = e.j, r.S = e.S.slice(), r;
	        }function c(e, r) {
	          var n,
	              t = [],
	              f = typeof e;if (r && "object" == f) for (n in e) try {
	            t.push(c(e[n], r - 1));
	          } catch (o) {}return t.length ? t : "string" == f ? e : e + "\x00";
	        }function u(e, r) {
	          for (var n, t = e + "", f = 0; f < t.length;) r[x & f] = x & (n ^= 19 * r[x & f]) + t.charCodeAt(f++);return s(r);
	        }function d() {
	          try {
	            if (l) return s(l.randomBytes(h));var e = new Uint8Array(h);return (b.crypto || b.msCrypto).getRandomValues(e), s(e);
	          } catch (r) {
	            var n = b.navigator,
	                f = n && n.plugins;return [+new Date(), b, f, b.screen, s(t)];
	          }
	        }function s(e) {
	          return String.fromCharCode.apply(0, e);
	        }var l,
	            b = this,
	            h = 256,
	            g = 6,
	            p = 52,
	            m = "random",
	            y = f.pow(h, g),
	            v = f.pow(2, p),
	            w = 2 * v,
	            x = h - 1;if ((f["seed" + m] = o, u(f.random(), t), "object" == typeof n && n.exports)) {
	          n.exports = o;try {
	            l = r("crypto");
	          } catch (_) {}
	        } else "function" == typeof e && e.amd && e(function () {
	          return o;
	        });
	      })([], Math);
	    }, { crypto: !1 }] }, {}, ["./lib/trianglify.js"])("./lib/trianglify.js");
	});

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	//Module Imports
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var Trianglify = __webpack_require__(46);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK BackgroundPatternPortfolioPage : Content must be defined and set to a DOM selector or Node"]
	}];
	
	var BackgroundPatternPortfolioPage = (function () {
	    function BackgroundPatternPortfolioPage(options) {
	        _classCallCheck(this, BackgroundPatternPortfolioPage);
	
	        console.log('BackgroundPatternPortfolioPage initialized');
	
	        //SM=75 MED=125 LG=175
	
	        this._internalVars = {
	            node: null //used for current node
	        };
	
	        //options with defaults set
	        this._defaults = {};
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2['default'].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2['default'].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2['default'].getContentType(this);
	            setLocalVars.call(this);
	            setEvents.call(this);
	            init.call(this);
	        }
	    }
	
	    // Private Methods
	
	    /**
	     * init()
	     * Initializes the Trianglify pattern
	     */
	
	    /**
	     * destroy()
	     * removes the node from the dom and any events attached
	     */
	
	    _createClass(BackgroundPatternPortfolioPage, [{
	        key: 'destroy',
	        value: function destroy() {
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return BackgroundPatternPortfolioPage;
	})();
	
	function init() {
	
	    if (this._internalVars.alertVerificationItems.length === 0) {
	        alertHeight.call(this);
	    } else {
	        initialAlertDisplay.call(this);
	    }
	}
	
	function trianglify() {
	    var pattern = Trianglify({
	        variance: "0.7",
	        cell_size: 175,
	        x_colors: ["#ffffff", "#dcdcdc", "#e6e6e6", "#ffffff", "e8e8e8", "f0f0f0", "#dcdcdc", "#ffffff", "#f5f5f5", "e8e8e8", "#ffffff", "#e6e6e6", "#f5f5f5", "#fafafa", "#ffffff"],
	        width: 3000,
	        height: this._internalVars.canvasHeight
	    });
	    this._internalVars.node.appendChild(pattern.canvas());
	    var canvas = document.getElementsByTagName('canvas');
	    canvas[0].setAttribute('id', 'portfolioBackground');
	}
	
	function setCanvasHeight() {
	    if (this._internalVars.alertVerificationItems.length === 0) {
	        this._internalVars.canvasHeight = 220;
	    }
	    if (document.getElementById(this._internalVars.canvasID) === null) {} else {
	        document.getElementById(this._internalVars.canvasID).parentNode.removeChild(document.getElementById(this._internalVars.canvasID));
	    }
	    this._internalVars.backgroundPatternHeightObject.style.height = this._internalVars.canvasHeight + "px";
	    trianglify.call(this);
	}
	
	function initialAlertDisplay() {
	    this._internalVars.alertActive = 0;
	    this._internalVars.alertItems[this._internalVars.alertActive].classList.add('alert-active');
	    if (this._internalVars.alertItems.length > 1) {
	        this._internalVars.alertTotalObject.innerHTML = this._internalVars.alertItems.length;
	        currentAlertState.call(this);
	    } else {
	        //hide carousel
	        this._internalVars.carouselObject.style.display = 'none';
	    }
	    alertHeight.call(this);
	    chevronState.call(this);
	}
	
	function chevronState() {
	    var currentAlert = this._internalVars.alertActive + 1;
	
	    if (currentAlert === 1) {
	        //disable left arrow
	        this._internalVars.arrowLeft.setAttribute('disabled', 'disabled');
	        this._internalVars.arrowLeft.parentNode.classList.add('disabled');
	        if (this._internalVars.alertItems.length === 2) {
	            this._internalVars.arrowRight.removeAttribute('disabled');
	            this._internalVars.arrowRight.parentNode.classList.remove('disabled');
	        }
	    } else if (currentAlert === this._internalVars.alertItems.length) {
	        //disable right arrow
	        if (this._internalVars.alertItems.length === 2) {
	            this._internalVars.arrowLeft.removeAttribute('disabled');
	            this._internalVars.arrowLeft.parentNode.classList.remove('disabled');
	        }
	        this._internalVars.arrowRight.setAttribute('disabled', 'disabled');
	        this._internalVars.arrowRight.parentNode.classList.add('disabled');
	    } else {
	        //remove disabled classes/attributes
	        this._internalVars.arrowLeft.removeAttribute('disabled');
	        this._internalVars.arrowLeft.parentNode.classList.remove('disabled');
	        this._internalVars.arrowRight.removeAttribute('disabled');
	        this._internalVars.arrowRight.parentNode.classList.remove('disabled');
	    }
	}
	
	function currentAlertState() {
	    this._internalVars.alertCurrentObject.innerHTML = this._internalVars.alertActive + 1;
	}
	
	function alertHeight() {
	    this._internalVars.canvasHeight = this._internalVars.backgroundPatternHeightObject.querySelector('.container').clientHeight;
	    setCanvasHeight.call(this);
	}
	
	function setEvents() {
	    this._internalVars.arrowRight.addEventListener("click", carouselSelection.bind(this));
	    this._internalVars.arrowLeft.addEventListener("click", carouselSelection.bind(this));
	
	    for (var i = 0; i < this._internalVars.closeButtonObject.length; i++) {
	        this._internalVars.closeButtonObject[i].addEventListener("click", closeButton.bind(this, this._internalVars.closeButtonObject[i]));
	    }
	
	    window.addEventListener('resize', alertHeight.bind(this));
	}
	
	function closeButton() {
	    var nextAlert = null,
	        currentAlert = this._internalVars.alertActive + 1;
	
	    if (currentAlert === this._internalVars.alertItems.length) {
	        nextAlert = this._internalVars.alertActive - 1;
	    } else {
	        nextAlert = this._internalVars.alertActive;
	    }
	
	    this._internalVars.alertItems[this._internalVars.alertActive].classList.remove('alert-active');
	    this._internalVars.alertItems[this._internalVars.alertActive].classList.remove('alert-importance');
	    this._internalVars.alertItems = document.querySelectorAll('.' + this._internalVars.alertItemsClass);
	
	    if (this._internalVars.alertItems.length > 0) {
	        this._internalVars.alertItems[nextAlert].classList.add('alert-active');
	        this._internalVars.alertActive = [].indexOf.call(this._internalVars.alertItems, document.querySelector('.' + this._internalVars.currentAlertClass));
	
	        if (this._internalVars.alertItems.length === 1) {
	            this._internalVars.carouselObject.style.display = 'none';
	        } else {
	            this._internalVars.alertTotalObject.innerHTML = this._internalVars.alertItems.length;
	            chevronState.call(this);
	            currentAlertState.call(this);
	        }
	    } else {
	        this._internalVars.alertVerificationItems[0].classList.remove('portfolio-alerts');
	    }
	    alertHeight.call(this);
	}
	
	function carouselSelection(e) {
	    e.preventDefault();
	
	    var nextAlert = null;
	
	    this._internalVars.alertItems[this._internalVars.alertActive].classList.remove('alert-active');
	
	    if (e.target.id === 'arrow-right') {
	        nextAlert = this._internalVars.alertActive + 1;
	        this._internalVars.alertActive = nextAlert;
	    } else {
	        nextAlert = this._internalVars.alertActive - 1;
	        this._internalVars.alertActive = nextAlert;
	    }
	
	    this._internalVars.alertItems[this._internalVars.alertActive].classList.add('alert-active');
	
	    alertHeight.call(this);
	    chevronState.call(this);
	    currentAlertState.call(this);
	}
	
	/**
	 * setLocalVars()
	 * set local vars to the ones passed in options
	 */
	function setLocalVars() {
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    this._internalVars.alertVerificationClass = 'portfolio-alerts';
	    this._internalVars.alertVerificationItems = document.getElementsByClassName(this._internalVars.alertVerificationClass);
	
	    this._internalVars.backgroundPatternHeightID = "background-pattern-portfolio-page";
	    this._internalVars.backgroundPatternHeightObject = document.getElementById(this._internalVars.backgroundPatternHeightID);
	    this._internalVars.canvasHeight = null;
	
	    this._internalVars.alertContainerID = 'portfolio-alert-container';
	    this._internalVars.alertContainerObject = document.getElementById(this._internalVars.alertContainerID);
	
	    this._internalVars.alertItemsClass = 'alert-importance';
	    this._internalVars.alertItems = document.querySelectorAll('.' + this._internalVars.alertItemsClass);
	
	    this._internalVars.currentAlertClass = 'alert-active';
	    this._internalVars.currentAlertObject = document.querySelector('.' + this._internalVars.currentAlertClass);
	
	    this._internalVars.alertActive = null;
	
	    this._internalVars.alertCurrentID = 'alert-current';
	    this._internalVars.alertTotalID = 'alert-total';
	    this._internalVars.alertCurrentObject = document.getElementById(this._internalVars.alertCurrentID);
	    this._internalVars.alertTotalObject = document.getElementById(this._internalVars.alertTotalID);
	
	    this._internalVars.arrowRightID = 'arrow-right';
	    this._internalVars.arrowRight = document.getElementById(this._internalVars.arrowRightID);
	
	    this._internalVars.arrowLeftID = 'arrow-left';
	    this._internalVars.arrowLeft = document.getElementById(this._internalVars.arrowLeftID);
	
	    this._internalVars.carouselClass = 'carousel';
	    this._internalVars.carouselObject = document.querySelector('.' + this._internalVars.carouselClass);
	
	    this._internalVars.closeButtonClass = 'icon-close-20';
	
	    this._internalVars.alertContainerID = 'portfolio-alert-container';
	    this._internalVars.alertContainerObject = document.getElementById(this._internalVars.alertContainerID);
	    this._internalVars.closeButtonObject = this._internalVars.alertContainerObject.querySelectorAll('.' + this._internalVars.closeButtonClass);
	
	    this._internalVars.canvasID = 'portfolioBackground';
	}
	
	exports['default'] = BackgroundPatternPortfolioPage;
	module.exports = exports['default'];

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	
	//Module Imports
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK DotNavigation : Content must be defined and set to a DOM selector or Node"]
	}, {
	    setting: "onClicked",
	    isRequired: false,
	    validate: "type",
	    possibleValues: ["function"],
	    errorMessage: ["GDK DotNavigation : onClicked must be a function"]
	}, {
	    setting: "startingPos",
	    isRequired: false,
	    validate: "type", //a type or a value
	    possibleValues: ["number"],
	    errorMessage: ["GDK DotNavigation : startingPos must be set to a number"]
	}];
	
	var DotNavigation = (function () {
	
	    /**
	     * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	     * @param {string|Object} content
	     * A reference to the html Dot Navigation node
	     *
	     * @param {function} [onClicked]
	     * Callback function fired once a item is clicked
	     *
	     * @param {number} [startingPos=1]
	     * The number of the navigation item to display on initialization
	     */
	
	    function DotNavigation(options) {
	        _classCallCheck(this, DotNavigation);
	
	        console.log("Initialized Dot Navigation");
	
	        this._internalVars = {
	            node: null, //used for content item
	            navItem: null,
	            svg: "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"14px\" height=\"14px\" viewBox=\"0 0 16 16\"preserveAspectRatio=\"none\"><circle cx=\"8\" cy=\"8\" r=\"6.215\"/></svg>"
	        };
	
	        //options with defaults set
	        this._defaults = {
	            startingPos: 1
	        };
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2["default"].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2["default"].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2["default"].getContentType(this);
	            setLocalVars.call(this);
	            setEvents.call(this);
	            setStartPosition.call(this);
	        }
	    }
	
	    // Private Methods
	
	    /**
	     * setLocalVars()
	     * set all the local vars to passed in options
	     */
	
	    //Public Methods
	
	    /**
	     * @param {number} newIndex
	     * newIndex is the number of the navigation item to display first on initialization
	     */
	
	    _createClass(DotNavigation, [{
	        key: "goTo",
	        value: function goTo(newIndex) {
	
	            var index = newIndex - 1;
	
	            Array.prototype.map.call(this._internalVars.navItem, function (e, rank) {
	                if (rank === index) {
	                    e.parentNode.classList.add("dot-navigation-active");
	                } else {
	                    e.parentNode.classList.remove("dot-navigation-active");
	                }
	            });
	        }
	
	        /**
	         * destroy()
	         * removes the node from the dom and any events attached
	         */
	    }, {
	        key: "destroy",
	        value: function destroy() {
	            removeEvents.call(this);
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return DotNavigation;
	})();
	
	function setLocalVars() {
	    var _this = this;
	
	    //determine the type of content passed in
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    this._internalVars.navItem = this._internalVars.node.querySelectorAll("li a");
	
	    //set click events
	    Array.prototype.forEach.call(this._internalVars.navItem, function (el, i) {
	        el.insertAdjacentHTML('beforeend', _this._internalVars.svg);
	    });
	
	    this._internalVars.handler = dotNavigationClickHandler.bind(this);
	}
	
	/**
	 * setEvents()
	 * Sets all the events needed for the component
	 */
	function setEvents() {
	    var _this2 = this;
	
	    var eventName = "click";
	
	    if ("ontouchstart" in document.documentElement) {
	        eventName = "touchstart";
	    }
	
	    //set click events
	    Array.prototype.forEach.call(this._internalVars.navItem, function (el, i) {
	        el.addEventListener(eventName, _this2._internalVars.handler);
	    });
	}
	
	/**
	 * removeEvents()
	 * removes all events from the component
	 */
	function removeEvents() {
	    var _this3 = this;
	
	    var eventName = "click";
	
	    if ("ontouchstart" in document.documentElement) {
	        eventName = "touchstart";
	    }
	
	    //remove click events
	    Array.prototype.forEach.call(this._internalVars.navItem, function (el, i) {
	        el.removeEventListener(eventName, _this3._internalVars.handler);
	    });
	}
	
	/**
	 * dotNavigationClickHandler()
	 * Gets fired when you click on a navigation item
	 */
	function dotNavigationClickHandler(el) {
	    var _this4 = this;
	
	    el.preventDefault();
	    var currentNode = el.currentTarget;
	    var currentIndex = undefined;
	    // add selected class
	    Array.prototype.map.call(this._internalVars.navItem, function (e, rank) {
	        if (e === currentNode) {
	            e.parentNode.classList.add("dot-navigation-active");
	            currentIndex = rank;
	        } else {
	            e.parentNode.classList.remove("dot-navigation-active");
	        }
	    });
	
	    // fire onClicked Callback if there is one
	    setTimeout(function () {
	        if (_this4._options.onClicked) _this4._options.onClicked(currentIndex + 1);
	    }, 10);
	}
	
	/**
	 * setStartPosition()
	 * Set starting link
	 */
	function setStartPosition() {
	
	    var linkIndex = this._options.startingPos - 1;
	
	    Array.prototype.map.call(this._internalVars.navItem, function (e, rank) {
	        if (rank === linkIndex) {
	            e.parentNode.classList.add("dot-navigation-active");
	        }
	    });
	}
	
	exports["default"] = DotNavigation;
	module.exports = exports["default"];

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by u1d230 on 11/6/15.
	 */
	
	//Module Imports
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	    setting: 'content',
	    isRequired: true,
	    validate: 'type', //a type or a value
	    possibleValues: ['string', 'object'],
	    errorMessage: ['GDK EditableTable : Content must be defined and set to a DOM selector or Node']
	}];
	
	var EditableTable = (function () {
	    /**
	     * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	     * @param {string|Object} content
	     *  A reference to the editable table with edit buttons and fields node
	     */
	
	    function EditableTable(options) {
	        _classCallCheck(this, EditableTable);
	
	        this._internalVars = {
	            node: null, //used for current node
	            editBtn: null
	        };
	
	        //options with defaults set
	        this._defaults = {};
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2['default'].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2['default'].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2['default'].getContentType(this);
	            setLocalVars.call(this);
	            setEvents.call(this);
	        }
	    }
	
	    // Private Methods
	
	    //Public Methods
	
	    /**
	     * destroy()
	     * removes the node from the dom and any events attached
	     */
	
	    _createClass(EditableTable, [{
	        key: 'destroy',
	        value: function destroy() {
	            removeEvents.call(this);
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return EditableTable;
	})();
	
	function setLocalVars() {
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    this._internalVars.editBtn = this._internalVars.node.querySelectorAll('.table--editable-non-sortable .btn');
	
	    this._internalVars.handler = toggleEdit.bind(this);
	}
	
	/**
	 * setEvents()
	 * Sets all the events needed for the component
	 */
	function setEvents() {
	    var eventName = "click";
	    if ("ontouchstart" in document.documentElement) {
	        eventName = "click";
	    }
	
	    for (var i = 0; i < this._internalVars.editBtn.length; i++) {
	        this._internalVars.editBtn[i].addEventListener(eventName, this._internalVars.handler);
	    }
	}
	
	/**
	 * removeEvents()
	 * removes all events from the component
	 */
	function removeEvents() {
	    var eventName = "click";
	    if ("ontouchstart" in document.documentElement) {
	        eventName = "touchstart";
	    }
	
	    for (var i = 0; i < this._internalVars.editBtn.length; i++) {
	        this._internalVars.editBtn[i].removeEventListener("click", this._internalVars.handler);
	    }
	}
	
	function toggleEdit(e) {
	    var currentEditBtn = e.target;
	    var parentTR = currentEditBtn.parentNode.parentNode;
	    var childrenTD = parentTR.querySelectorAll('td');
	    for (var i = 0; i < childrenTD.length; i++) {
	        childrenTD[i].classList.toggle("td-edit-fields");
	    }
	}
	
	exports['default'] = EditableTable;
	module.exports = exports['default'];

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by u1d230 on 12/1/15.
	 */
	//Module Imports
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	    setting: 'content',
	    isRequired: true,
	    validate: 'type', //a type or a value
	    possibleValues: ['string', 'object'],
	    errorMessage: ['GDK Alert : Content must be defined and set to a DOM selector or Node']
	}];
	
	var CoverageGraph = (function () {
	    /**
	     * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	     * @param {string|Object} content
	     *  A reference to the coverage graph node
	     */
	
	    function CoverageGraph(options) {
	        _classCallCheck(this, CoverageGraph);
	
	        this._internalVars = {
	            node: null, //used for current node
	            breakdownNode: null,
	            legendNode: null,
	            labelArray: null,
	            costArray: null,
	            percentArray: [],
	            totalSum: 0,
	            percentSum: 0,
	            centerCircle: null
	        };
	
	        //options with defaults set
	        this._defaults = {};
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2['default'].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2['default'].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2['default'].getContentType(this);
	            setLocalVars.call(this);
	            setEvents.call(this);
	            appendCenterCost.call(this);
	            createSlices.call(this);
	            createLegend.call(this);
	        }
	    }
	
	    // Private Methods
	
	    //Public Methods
	
	    /**
	     * destroy()
	     * removes the node from the dom and any events attached
	     */
	
	    _createClass(CoverageGraph, [{
	        key: 'destroy',
	        value: function destroy() {
	            $(this._internalVars.node).datepicker("destroy");
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return CoverageGraph;
	})();
	
	function setLocalVars() {
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    this._internalVars.breakdownNode = this._internalVars.node.querySelector('.coverage-graph-breakdown');
	    if (this._internalVars.breakdownNode.dataset !== undefined) {
	        this._internalVars.costArray = this._internalVars.breakdownNode.dataset.costbreakdown.split(" ");
	        this._internalVars.labelArray = this._internalVars.breakdownNode.dataset.labels.split(",");
	    } else {
	        this._internalVars.labelArray = this._internalVars.breakdownNode.getAttribute('data-labels').split(",");
	        this._internalVars.costArray = this._internalVars.breakdownNode.getAttribute('data-costbreakdown').split(" ");
	    }
	    this._internalVars.centerCircle = this._internalVars.breakdownNode.querySelector('.circle');
	    this._internalVars.legendNode = this._internalVars.node.querySelector('.legend');
	}
	
	/**
	 * setEvents()
	 * Sets all the events needed for the component
	 */
	function setEvents() {}
	
	function appendCenterCost() {
	    var monetary = this._internalVars.centerCircle.querySelector('.monetary');
	    var sumText = getCostSum.call(this);
	    var costBreakdownArray = sumText.toString().split(".");
	    var textNodeSum = document.createTextNode(costBreakdownArray[0]);
	    monetary.appendChild(textNodeSum);
	    var supElement = document.createElement('SUP');
	    var textNodeSumDecimal = document.createTextNode("." + costBreakdownArray[1]);
	    supElement.appendChild(textNodeSumDecimal);
	    monetary.appendChild(supElement);
	}
	
	function createSlices() {
	    var percentarray = createPercentageArray.call(this);
	    var sheet = (function () {
	        var style = document.createElement('STYLE');
	        style.appendChild(document.createTextNode(""));
	        document.head.appendChild(style);
	        return style.sheet;
	    })();
	    for (var j = 0; j < percentarray.length; j++) {
	        var newDiv = document.createElement('DIV');
	        this._internalVars.breakdownNode.appendChild(newDiv);
	        if (percentarray[j] >= 180) {
	            newDiv.setAttribute('class', 'pie big');
	        } else {
	            newDiv.setAttribute('class', 'pie');
	        }
	        newDiv.setAttribute('data-start', this._internalVars.percentSum.toFixed(1));
	        if (j !== 0) {
	            setPrefixes(newDiv, "Transform", "rotate(" + this._internalVars.percentSum + "deg)");
	            sheet.insertRule(insertDataStartCSS(this._internalVars.percentSum), 0);
	        }
	        this._internalVars.percentSum += parseFloat(percentarray[j]);
	        newDiv.setAttribute('data-value', percentarray[j]);
	        sheet.insertRule(insertDataValueCSS(percentarray[j], percentarray.length, j), 0);
	    }
	}
	
	function insertDataValueCSS(degree, length, index) {
	    degree = parseFloat(degree);
	    var degree1 = degree;
	    if (index != length - 1) {
	        degree1 = parseFloat(degree + 1);
	    }
	    var cssString = ".pie[data-value='" + degree + "']:BEFORE { -moz-transform: rotate(" + degree1 + "deg); -ms-transform: rotate(" + degree1 + "deg); -webkit-transform: rotate(" + degree1 + "deg); -o-transform: rotate(" + degree1 + "deg); transform:rotate(" + degree1 + "deg);}";
	    return cssString;
	}
	
	function insertDataStartCSS(degree) {
	    degree = parseFloat(degree).toFixed(1);
	    var cssString = ".pie[data-start='" + degree + "'] { -moz-transform: rotate(" + degree + "deg); /* Firefox */ -ms-transform: rotate(" + degree + "deg); /* IE */ -webkit-transform: rotate(" + degree + "deg); /* Safari and Chrome */ -o-transform: rotate(" + degree + "deg); /* Opera */transform:rotate(" + degree + "deg);}";
	    return cssString;
	}
	
	function setPrefixes(element, property, value) {
	    element.style["webkit" + property] = value;
	    element.style["moz" + property] = value;
	    element.style["ms" + property] = value;
	    element.style["o" + property] = value;
	}
	
	function getCostSum() {
	    var costArray = this._internalVars.costArray;
	    var sum = this._internalVars.totalSum;
	    for (var i = 0; i < costArray.length; i++) {
	        sum += parseFloat(costArray[i]);
	    }
	    sum = sum.toFixed(2);
	    return sum;
	}
	
	function createLegend() {
	    var costArray = this._internalVars.costArray;
	    var labelArray = this._internalVars.labelArray;
	    for (var i = 0; i < costArray.length; i++) {
	        this._internalVars.legendNode.querySelector('ul').appendChild(createLi(labelArray[i], parseFloat(costArray[i])));
	    }
	}
	
	function createPercentageArray() {
	    var costArray = this._internalVars.costArray;
	    var costSum = getCostSum.call(this);
	    for (var j = 0; j < costArray.length; j++) {
	        this._internalVars.percentArray.push(costToPercentage(costArray[j], costSum));
	    }
	    return this._internalVars.percentArray;
	}
	
	function costToPercentage(cost, sum) {
	    var percent = cost / sum * 360;
	    return percent;
	}
	
	function createLi(item, cost) {
	    var liEl = document.createElement("LI");
	    var divEl = document.createElement("DIV");
	    divEl.setAttribute('class', 'legend-item');
	    liEl.appendChild(divEl);
	    var labelString = item + " ($" + cost.toFixed(2) + ")";
	    var hello = document.createTextNode(labelString);
	    liEl.appendChild(hello);
	    return liEl;
	}
	
	exports['default'] = CoverageGraph;
	module.exports = exports['default'];

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _appState = __webpack_require__(7);
	
	var _appState2 = _interopRequireDefault(_appState);
	
	//Module Imports
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK CommonQuestionsSquares : Content must be defined and set to a DOM selector or Node"]
	}];
	
	var CommonQuestionsSquares = (function () {
	    /**
	     * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	     * @param {string|Object} content
	     *  A reference to the common questions squares node
	     */
	
	    function CommonQuestionsSquares(options) {
	        _classCallCheck(this, CommonQuestionsSquares);
	
	        this._internalVars = {
	            node: null, //used for content item
	            individualBoxes: null
	        };
	
	        //options with defaults set
	        this._defaults = {};
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2['default'].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2['default'].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2['default'].getContentType(this);
	            setLocalVars.call(this);
	            setEvents.call(this);
	
	            var allSquares = this._internalVars.node.querySelectorAll('.square');
	            Array.prototype.forEach.call(allSquares, function (el, i) {
	                if (!el.classList.contains('square-link')) el.setAttribute('tabindex', '0');
	            });
	        }
	    }
	
	    // Private Methods
	    /**
	     * setEvents()
	     * Sets all the events needed for the component
	     */
	
	    //Public Methods
	
	    /**
	     * destroy()
	     * removes the node from the dom and any events attached
	     */
	
	    _createClass(CommonQuestionsSquares, [{
	        key: 'destroy',
	        value: function destroy() {
	            removeEvents.call(this);
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return CommonQuestionsSquares;
	})();
	
	function setEvents() {
	    var eventName = "click";
	    if ("ontouchstart" in document.documentElement) {
	        eventName = "click";
	    }
	
	    console.log(this._internalVars.individualBoxes);
	
	    for (var j = 0; j < this._internalVars.individualBoxes.length - 1; j++) {
	        this._internalVars.individualBoxes[j].addEventListener('mouseover', removeStyleAttr.bind(this, this._internalVars.individualBoxes[j]));
	        this._internalVars.individualBoxes[j].addEventListener(eventName, openPanel.bind(this, this._internalVars.individualBoxes[j]));
	    }
	}
	
	function removeStyleAttr(e) {
	    if (_appState2['default'].mode !== "mobile") {
	        var el = e.querySelector('.back');
	        el.removeAttribute('style');
	    }
	}
	
	function openPanel(e) {
	    var el = e.querySelector('.back');
	    if (_appState2['default'].mode === "mobile") {
	        e.classList.toggle('open');
	        if (e.classList.contains('open')) {
	            el.style.display = "block";
	            var paragraph = el.querySelector("p");
	            el.style.maxHeight = outerHeight.call(this, paragraph) + "px";
	        } else {
	            el.removeAttribute('style');
	            el.style.display = "block";
	            el.style.maxHeight = "0px";
	        }
	    } else {
	        el.removeAttribute('style');
	    }
	}
	
	/**
	 * removeEvents()
	 * removes all events from the component
	 */
	function removeEvents() {
	    var eventName = "click";
	    if ("ontouchstart" in document.documentElement) {
	        eventName = "touchstart";
	    }
	    for (var j = 0; j < this._internalVars.individualBoxes.length - 1; j++) {
	        this._internalVars.individualBoxes[j].removeEventListener('mouseover', removeStyleAttr.bind(this, this._internalVars.individualBoxes[j]));
	        this._internalVars.individualBoxes[j].removeEventListener(eventName, openPanel.bind(this, this._internalVars.individualBoxes[j]));
	    }
	}
	
	/**
	 * setLocalVars()
	 * set all the local vars to passed in options
	 */
	function setLocalVars() {
	    //determine the type of content passed in
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    this._internalVars.individualBoxes = this._internalVars.node.children;
	}
	
	/**
	 * outerHeight()
	 * used to get the height of an element that is the same across all browsers
	 *
	 * @param  {Object} node    DOM node
	 * @return {number}
	 */
	function outerHeight(el) {
	    var height = el.offsetHeight;
	    var style = getComputedStyle(el);
	
	    height += parseInt(style.marginTop) + parseInt(style.marginBottom);
	    return height;
	}
	
	exports['default'] = CommonQuestionsSquares;
	module.exports = exports['default'];

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by u1d149 on 1/25/2016.
	 */
	
	//Module Imports
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _utils = __webpack_require__(8);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK UpsellCarousel : Content must be defined and set to a DOM selector or Node"]
	}];
	
	var UpsellCarousel = function UpsellCarousel(options) {
	    _classCallCheck(this, UpsellCarousel);
	
	    console.log('UpsellCarousel initialized');
	
	    this._internalVars = {
	        node: null //used for current node
	    };
	
	    //options with defaults set
	    this._defaults = {};
	
	    // Create options by extending defaults with the passed in arguments
	    if (options && typeof options === "object") {
	        this._options = _baseComponent2['default'].extendDefaults(this._defaults, options);
	    }
	
	    //if the required options are valid set up the environment
	    if (_baseComponent2['default'].validateSettings(this._options, validateSettings)) {
	        this._internalVars.contentType = _baseComponent2['default'].getContentType(this);
	        setLocalVars.call(this);
	        setEvents.call(this);
	        if (this._internalVars.node) {
	            carouselDefaults.call(this);
	        }
	    }
	}
	
	// Private Methods
	/**
	 * setEvents()
	 * Sets all the events needed for the component
	 */
	;
	
	function setEvents() {
	    window.addEventListener("load", carouselDefaults.bind(this));
	    window.addEventListener("resize", carouselDefaults.bind(this));
	
	    for (var i = 0; i < this._internalVars.carouselChevronBtn.length; i++) {
	        this._internalVars.carouselChevronBtn[i].addEventListener("click", carouselClick.bind(this, this._internalVars.carouselChevronBtn[i]));
	    }
	}
	
	/**
	 * removeEvents()
	 * removes all events from the component
	 */
	function removeEvents() {
	    window.removeEventListener("load", carouselDefaults.bind(this));
	    window.removeEventListener("resize", carouselDefaults.bind(this));
	
	    for (var i = 0; i < this._internalVars.carouselChevronBtn.length; i++) {
	        this._internalVars.carouselChevronBtn[i].removeEventListener("click", carouselClick.bind(this, this._internalVars.carouselChevronBtn[i]));
	    }
	}
	
	/**
	 * toggleView()
	 * instantiate View More/Less
	 */
	function carouselDefaults() {
	    if (window.innerWidth > this._internalVars.carouselIconDisplay) {
	        this._internalVars.carouselIconNumber = 4;
	    } else if (window.innerWidth > this._internalVars.carouselIconSmallDisplay) {
	        this._internalVars.carouselIconNumber = 2;
	    } else {
	        this._internalVars.carouselIconNumber = 1;
	    }
	
	    this._internalVars.carouselIconWidth = this._internalVars.carouselObject.querySelector(this._internalVars.carouselIconClass).clientWidth;
	
	    this._internalVars.carouselObject.style.width = (this._internalVars.carouselIconNumber + 2) * this._internalVars.carouselIconWidth + 'px';
	    this._internalVars.carouselItemsLeft = this._internalVars.carouselUpsellNumber - this._internalVars.carouselIconNumber;
	    this._internalVars.carouselLeftVal = 0;
	    this._internalVars.carouselObject.querySelector(this._internalVars.carouselIconWrapperClass).style.left = 0 + 'px';
	
	    var wrapperWidth = this._internalVars.carouselIconWidth * this._internalVars.carouselIconNumber,
	        containerWidth = this._internalVars.carouselIconWidth * this._internalVars.carouselUpsellNumber;
	
	    document.querySelector(this._internalVars.carouselWrapperClass).style.width = wrapperWidth + 'px';
	    document.querySelector(this._internalVars.carouselIconWrapperClass).style.width = containerWidth + 'px';
	
	    chevronState.call(this);
	}
	
	function carouselClick(e) {
	
	    if (!e.classList.contains("disabled")) {
	
	        var itemsLeftWidth = document.querySelector(this._internalVars.carouselIconWrapperClass).style.getPropertyValue("left"),
	            itemsLeftWidthValue = itemsLeftWidth.slice(0, -2),
	            itemsLeftWidthVal = Number(itemsLeftWidthValue.replace(/^-/, "")),
	            itemsRightWidth = this._internalVars.carouselIconWidth * this._internalVars.carouselUpsellNumber - itemsLeftWidthVal - this._internalVars.carouselIconWidth * this._internalVars.carouselIconNumber;
	
	        var operand = null;
	        var totalScrollValue = null;
	        var movementValue = null;
	
	        if (e.querySelector("span").classList.contains("icon-chevron-right")) {
	            operand = "-";
	            totalScrollValue = itemsRightWidth;
	        } else {
	            operand = "+";
	            totalScrollValue = itemsLeftWidthVal;
	        }
	
	        if (this._internalVars.carouselIconWidth * this._internalVars.carouselIconNumber > totalScrollValue) {
	            movementValue = totalScrollValue;
	        } else {
	            movementValue = this._internalVars.carouselIconWidth * this._internalVars.carouselIconNumber;
	        }
	
	        if (operand === "+") {
	            this._internalVars.carouselObject.querySelector(this._internalVars.carouselIconWrapperClass).style.left = Number(itemsLeftWidthValue) + movementValue + 'px';
	        } else {
	            this._internalVars.carouselObject.querySelector(this._internalVars.carouselIconWrapperClass).style.left = Number(itemsLeftWidthValue) - movementValue + 'px';
	        }
	
	        chevronState.call(this);
	    }
	}
	
	function chevronState() {
	    var itemsLeftWidth = document.querySelector(this._internalVars.carouselIconWrapperClass).style.getPropertyValue("left"),
	        itemsLeftWidthValue = itemsLeftWidth.slice(0, -2),
	        itemsLeftWidthVal = Number(itemsLeftWidthValue.replace(/^-/, "")),
	        itemsRightWidth = this._internalVars.carouselIconWidth * this._internalVars.carouselUpsellNumber - itemsLeftWidthVal - this._internalVars.carouselIconWidth * this._internalVars.carouselIconNumber;
	
	    if (itemsLeftWidthVal === 0) {
	        this._internalVars.carouselChevronBtn[0].classList.add("disabled");
	        this._internalVars.carouselChevronBtn[0].children[0].setAttribute("disabled", "disabled");
	    } else {
	        this._internalVars.carouselChevronBtn[0].classList.remove("disabled");
	        this._internalVars.carouselChevronBtn[0].children[0].removeAttribute("disabled");
	    }
	
	    if (itemsRightWidth === 0) {
	        this._internalVars.carouselChevronBtn[1].classList.add("disabled");
	        this._internalVars.carouselChevronBtn[1].children[0].setAttribute("disabled", "disabled");
	    } else {
	        this._internalVars.carouselChevronBtn[1].classList.remove("disabled");
	        this._internalVars.carouselChevronBtn[1].children[0].removeAttribute("disabled");
	    }
	}
	
	/**
	 * setLocalVars()
	 * set local vars to the ones passed in options
	 */
	function setLocalVars() {
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    this._internalVars.carouselIconDisplay = 645;
	    this._internalVars.carouselIconSmallDisplay = 440;
	    this._internalVars.carouselIconNumber = 0;
	    this._internalVars.carouselIconClass = '.carousel-upsell-product';
	    this._internalVars.carouselWrapperClass = '.icon-carousel';
	    this._internalVars.carouselIconWrapperClass = '.icon-carousel-display';
	    this._internalVars.carouselIconChevronClass = '.carousel-upsell-chevron';
	    this._internalVars.carouselObject = this._internalVars.node;
	    this._internalVars.carouselUpsellNumber = this._internalVars.carouselObject.querySelectorAll(this._internalVars.carouselIconClass).length;
	    this._internalVars.carouselChevronBtn = this._internalVars.carouselObject.querySelectorAll(this._internalVars.carouselIconChevronClass);
	}
	
	exports['default'] = UpsellCarousel;
	module.exports = exports['default'];

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by u1d149 on 2/11/2016.
	 */
	
	//Require static assets
	
	//Module Imports
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _utils = __webpack_require__(8);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK Portfolio : Content must be defined and set to a DOM selector or Node"]
	}];
	
	var Portfolio = function Portfolio(options) {
	    _classCallCheck(this, Portfolio);
	
	    console.log('Portfolio initialized');
	
	    this._internalVars = {
	        node: null //used for current node
	    };
	
	    //options with defaults set
	    this._defaults = {};
	
	    // Create options by extending defaults with the passed in arugments
	    if (options && typeof options === "object") {
	        this._options = _baseComponent2['default'].extendDefaults(this._defaults, options);
	    }
	
	    //if the required options are valid set up the environment
	    if (_baseComponent2['default'].validateSettings(this._options, validateSettings)) {
	        this._internalVars.contentType = _baseComponent2['default'].getContentType(this);
	        setLocalVars.call(this);
	        setEvents.call(this);
	        setContainerHeight.call(this);
	    }
	}
	
	// Private Methods
	/**
	 * setEvents()
	 * Sets all the events needed for the component
	 */
	;
	
	function setEvents() {
	    window.onresize = setContainerHeight.bind(this);
	}
	
	/**
	 * removeEvents()
	 * removes all events from the component
	 */
	function removeEvents() {}
	
	/**
	 * setContainerHeight()
	 * set container height
	 */
	function setContainerHeight() {
	    if (window.innerWidth > 550) {
	        this._internalVars.portfolioLeft.removeAttribute('style');
	        this._internalVars.portfolioRight.removeAttribute('style');
	
	        var arrHeight = [];
	
	        var leftHeight = this._internalVars.portfolioLeft.clientHeight;
	        var rightHeight = this._internalVars.portfolioRight.clientHeight;
	
	        arrHeight.push(leftHeight, rightHeight);
	
	        var containerHeight = Math.max.apply(Math, arrHeight);
	
	        this._internalVars.portfolioLeft.style.height = containerHeight + 'px';
	        this._internalVars.portfolioRight.style.height = containerHeight + 'px';
	    } else {
	        this._internalVars.portfolioLeft.removeAttribute('style');
	        this._internalVars.portfolioRight.removeAttribute('style');
	    }
	}
	
	/**
	 * setLocalVars()
	 * set local vars to the ones passed in options
	 */
	function setLocalVars() {
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    this._internalVars.portfolioLeftClass = 'left-portfolio-container';
	    this._internalVars.portfolioRightClass = 'right-portfolio-container';
	    this._internalVars.portfolioObject = this._internalVars.node;
	    this._internalVars.portfolioLeft = this._internalVars.portfolioObject.querySelector('.' + this._internalVars.portfolioLeftClass);
	    this._internalVars.portfolioRight = this._internalVars.portfolioObject.querySelector('.' + this._internalVars.portfolioRightClass);
	}
	
	exports['default'] = Portfolio;
	module.exports = exports['default'];

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	//Module Imports
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _utils = __webpack_require__(8);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK Payment Plans : Content must be defined and set to a DOM selector or Node"]
	}];
	
	var PayPlans =
	/**
	 * PayPlans Constructor
	 * @param {Object} options sets _internalVars, _defaults, creates options, validates settings, sets up the environment
	 */
	function PayPlans(options) {
	    _classCallCheck(this, PayPlans);
	
	    console.log('Payment Plans initialized');
	
	    this._internalVars = {
	        node: null //used for current node
	    };
	
	    //options with defaults set
	    this._defaults = {};
	
	    // Create options by extending defaults with the passed in arugments
	    if (options && typeof options === "object") {
	        this._options = _baseComponent2['default'].extendDefaults(this._defaults, options);
	    }
	
	    //if the required options are valid set up the environment
	    if (_baseComponent2['default'].validateSettings(this._options, validateSettings)) {
	        this._internalVars.contentType = _baseComponent2['default'].getContentType(this);
	        setLocalVars.call(this);
	        setEvents.call(this);
	
	        Array.prototype.forEach.call(this._internalVars.payPlanCardTopObject, function (element) {
	            if (!element.getAttribute('tabindex')) element.setAttribute('tabindex', '0');
	            element.setAttribute('role', 'radio');
	            if (!element.getElementsByTagName('input')[0].getAttribute('tabindex')) element.getElementsByTagName('input')[0].setAttribute('tabindex', '-1');
	            if (!element.getAttribute('aria-checked')) element.setAttribute('aria-checked', 'false');
	        });
	
	        Array.prototype.forEach.call(this._internalVars.payPlanInnerWrapperObjects, function (el) {
	            el.querySelectorAll('.payment-plan-row')[0].setAttribute('role', 'radiogroup');
	        });
	
	        Array.prototype.forEach.call(this._internalVars.payPlanCardTopObject, function (element) {
	            element.getElementsByTagName('input')[0].setAttribute('tabindex', '-1');
	        });
	    }
	}
	
	// Private Methods
	
	/**
	 * setEvents()
	 * Sets all the events needed for the component
	 */
	;
	
	function setEvents() {
	    var _this = this;
	
	    Array.prototype.forEach.call(this._internalVars.payPlanCards, function (el) {
	        el.addEventListener('click', setPayPlan.bind(_this));
	        el.addEventListener('keyup', setPayPlan.bind(_this));
	        el.addEventListener('mouseover', setState.bind(_this));
	        el.addEventListener('mouseout', resetState.bind(_this));
	        el.addEventListener('focus', setState.bind(_this));
	        el.addEventListener('blur', resetState.bind(_this));
	    });
	
	    Array.prototype.forEach.call(this._internalVars.carouselBtnObjects, function (el) {
	        el.addEventListener('click', carouselMovement.bind(_this));
	        el.addEventListener('keyup', carouselMovement.bind(_this));
	    });
	
	    window.addEventListener('resize', resetCarouselDefaults.bind(this));
	
	    this._internalVars.payPlansForm[0].addEventListener('keypress', checkEvent.bind(this));
	}
	
	/**
	 * Assigns a class to an internal variable based on the event type
	 * @param {Event} event Event type
	 */
	function setEventType(event) {
	    if (event === 'mouseover' || event === 'mouseout') {
	        this._internalVars.eventType = 'hover';
	    } else {
	        this._internalVars.eventType = 'focus';
	    }
	}
	
	/**
	 * Evaluates which row (top or bottom of cards) and card in that row that should be targeted when setting states
	 * @param {Event} e Event type
	 */
	function setRowIndex(e) {
	    var currentNode = e.currentTarget,
	        payPlanWrapper = currentNode.parentNode.parentNode,
	        rowWrapper = currentNode.parentNode,
	        payPlanCard = rowWrapper.querySelectorAll(this._internalVars.payPlanCardClass),
	        index = [].indexOf.call(payPlanCard, currentNode),
	        rowIndex = [].indexOf.call(payPlanWrapper.querySelectorAll('.payment-plan-row'), rowWrapper);
	
	    if (currentNode.classList.contains(this._internalVars.payPlanCardTopClass)) {
	        rowIndex = rowIndex + 1;
	    } else {
	        rowIndex = rowIndex - 1;
	    }
	
	    this._internalVars.rowIndex = rowIndex;
	    this._internalVars.cardIndex = index;
	}
	
	/**
	 * Sets state of card classes (hover, focus) based on the interaction with the card counterpart (top/bottom)
	 * @param {Event} e Event type
	 */
	function setOtherCardState(e) {
	    setRowIndex.call(this, e);
	
	    e.currentTarget.parentNode.parentNode.children[this._internalVars.rowIndex].children[this._internalVars.cardIndex].classList.add(this._internalVars.eventType);
	}
	
	/**
	 * Sets the state of card classes (hover, focus) of the card interacted with (top/bottom)
	 * @param {Event} e Event type
	 */
	function setState(e) {
	    var event = e.type;
	    setEventType.call(this, event);
	
	    e.currentTarget.classList.add(this._internalVars.eventType);
	
	    setOtherCardState.call(this, e);
	}
	
	/**
	 * Removes the state of card classes (hover, focus) of the card (top and bottom) containing the state
	 * @param {Event} e Event type
	 */
	function resetState(e) {
	    var _this2 = this;
	
	    var event = e.type;
	    setEventType.call(this, event);
	
	    Array.prototype.forEach.call(this._internalVars.node.querySelectorAll('.' + this._internalVars.eventType), function (el) {
	        el.classList.remove(_this2._internalVars.eventType);
	    });
	}
	
	function setPayPlan(event) {
	    if (event.type == 'keypress' || event.type == 'keyup' && (event.keyCode || event.which) != 13) {} else {
	        resetSelected.call(this);
	
	        event.currentTarget.classList.add(this._internalVars.payPlanSelectedClass);
	        event.currentTarget.classList.add(this._internalVars.focusClass);
	
	        setRowIndex.call(this, event);
	
	        if (event.currentTarget.classList.contains('card-top')) {
	            event.currentTarget.children[0].setAttribute('checked', 'checked');
	            event.currentTarget.setAttribute('aria-checked', 'true');
	        } else {
	            event.currentTarget.parentNode.parentNode.children[this._internalVars.rowIndex].children[0].setAttribute('checked', 'checked');
	            event.currentTarget.parentNode.parentNode.children[this._internalVars.rowIndex].setAttribute('aria-checked', 'true');
	        }
	
	        event.currentTarget.parentNode.parentNode.children[this._internalVars.rowIndex].children[this._internalVars.cardIndex].classList.add(this._internalVars.payPlanSelectedClass);
	        event.currentTarget.parentNode.parentNode.children[this._internalVars.rowIndex].children[this._internalVars.cardIndex].classList.add(this._internalVars.focusClass);
	
	        payPlanInView.bind(this);
	    }
	}
	
	function resetSelected() {
	    var _this3 = this;
	
	    var selected = this._internalVars.payPlanObject.querySelectorAll('.' + this._internalVars.payPlanSelectedClass);
	
	    selected[0].children[0].removeAttribute('checked');
	    selected[0].setAttribute('aria-checked', 'false');
	
	    Array.prototype.forEach.call(selected, function (el) {
	        el.classList.remove(_this3._internalVars.payPlanSelectedClass);
	        el.classList.remove(_this3._internalVars.focusClass);
	    });
	}
	
	function carouselMovement(event) {
	    if (event.type == 'keypress' || event.type == 'keyup' && (event.keyCode || event.which) != 13) {} else {
	        if (!event.target.hasAttribute('disabled')) {
	            if (!this._internalVars.defaultsSet) {
	                setCarouselDefault.call(this);
	            }
	            carouselSlide.call(this, event);
	        }
	    }
	}
	
	function setCarouselDefault() {
	    this._internalVars.carouselCardObejcts = this._internalVars.payPlanWrapperObjects[1].querySelectorAll(this._internalVars.payPlanCardClass);
	    this._internalVars.corouselCardLength = this._internalVars.carouselCardObejcts.length / 2;
	    this._internalVars.carouselInitialWidth = this._internalVars.carouselMoveObject.clientWidth;
	    this._internalVars.carouselCardWidth = Math.ceil(this._internalVars.carouselCardObejcts[0].clientWidth) + 5;
	    this._internalVars.carouselAcutalWidth = this._internalVars.carouselCardWidth * this._internalVars.corouselCardLength;
	    this._internalVars.cardsOnLeft = 0;
	    this._internalVars.cardsOnRight = this._internalVars.corouselCardLength - this._internalVars.cardsOnLeft - 2;
	
	    this._internalVars.defaultsSet = true;
	}
	
	function carouselSlide(event) {
	    var operand = null,
	        currentMarginValue = this._internalVars.carouselMoveObject.style.marginLeft,
	        currentMargin = currentMarginValue.slice(0, -2),
	        movementValue = this._internalVars.carouselCardWidth,
	        newMargin = null,
	        disableRightArrow = false,
	        disableLeftArrow = false;
	
	    if (event.target.classList.contains('icon-chevron-right')) {
	        operand = '-';
	        this._internalVars.newCardsOnLeft = this._internalVars.cardsOnLeft - 1;
	        this._internalVars.newCardsOnRight = this._internalVars.cardsOnRight - 1;
	    } else {
	        operand = '+';
	        this._internalVars.newCardsOnLeft = this._internalVars.cardsOnLeft + 1;
	        this._internalVars.newCardsOnRight = this._internalVars.cardsOnRight + 1;
	    }
	
	    if (operand === '-') {
	        if (this._internalVars.newCardsOnRight === 0) {
	            newMargin = -(this._internalVars.corouselCardLength * (this._internalVars.carouselCardWidth + 10)) + this._internalVars.carouselMoveObject.parentNode.clientWidth;
	            disableRightArrow = true;
	        } else {
	            newMargin = currentMargin - movementValue - 10;
	            disableRightArrow = false;
	        }
	    } else {
	        if (this._internalVars.newCardsOnLeft === 0 || this._internalVars.newCardsOnLeft === -0) {
	            newMargin = 0;
	            disableLeftArrow = true;
	        } else {
	            newMargin = Number(currentMargin) + movementValue + 10;
	            disableLeftArrow = false;
	        }
	    }
	
	    this._internalVars.carouselMoveObject.style.marginLeft = newMargin + 'px';
	
	    this._internalVars.cardsOnLeft = this._internalVars.newCardsOnLeft;
	    this._internalVars.cardsOnRight = this._internalVars.newCardsOnRight;
	
	    setArrowState.call(this, disableRightArrow, disableLeftArrow);
	}
	
	function setArrowState(disableRightArrow, disableLeftArrow) {
	    var rightArrow = document.querySelector('.icon-chevron-right'),
	        leftArrow = document.querySelector('.icon-chevron-left');
	
	    if (disableRightArrow === true) {
	        rightArrow.setAttribute('disabled', 'disabled');
	        rightArrow.setAttribute('aria-label', 'Right button disabled');
	        rightArrow.parentNode.classList.add(this._internalVars.carouselDisabledClass);
	    } else {
	        rightArrow.removeAttribute('disabled');
	        rightArrow.parentNode.classList.remove(this._internalVars.carouselDisabledClass);
	        rightArrow.setAttribute('aria-label', 'Right button');
	    }
	
	    if (disableLeftArrow === true) {
	        leftArrow.setAttribute('disabled', 'disabled');
	        leftArrow.parentNode.classList.add(this._internalVars.carouselDisabledClass);
	        leftArrow.setAttribute('aria-label', 'Left button disabled');
	    } else {
	        leftArrow.removeAttribute('disabled');
	        leftArrow.parentNode.classList.remove(this._internalVars.carouselDisabledClass);
	        leftArrow.setAttribute('aria-label', 'Left button');
	    }
	}
	
	function resetCarouselDefaults() {
	    this._internalVars.defaultsSet = false;
	
	    if (window.innerWidth > 911) {
	
	        if (this._internalVars.viewPortCheck === true) {
	            var delay = setTimeout(resetCarouselPos.bind(this), 30);
	            this._internalVars.carouselMoveObject.style.position = 'absolute';
	            this._internalVars.carouselMoveObject.style.left = 0 + 'px';
	            this._internalVars.viewPortCheck = false;
	
	            var disableLeftArrow = true;
	            var disableRightArrow = false;
	            setArrowState.call(this, disableRightArrow, disableLeftArrow);
	        }
	
	        this._internalVars.cardsOnLeft = 0;
	        this._internalVars.cardsOnRight = this._internalVars.corouselCardLength - this._internalVars.cardsOnLeft - 2;
	    } else {
	        this._internalVars.carouselMoveObject.removeAttribute('style');
	        this._internalVars.viewPortCheck = true;
	    }
	}
	
	function resetCarouselPos() {
	    this._internalVars.carouselMoveObject.style.position = 'relative';
	    this._internalVars.carouselMoveObject.style.marginLeft = 0 + 'px';
	    this._internalVars.carouselMoveObject.style.removeProperty('left');
	}
	
	function payPlanInView(el) {
	    var currentNode = el.currentTarget,
	        payPlanWrapper = currentNode.parentNode.parentNode,
	        outerWrapper = currentNode.parentNode.parentNode.parentNode,
	        left = null,
	        disableRightArrow = undefined,
	        disableLeftArrow = undefined,
	        bottomSection = currentNode.parentNode.parentNode.parentNode.parentNode;
	
	    if (window.innerWidth > 911 && bottomSection.classList.contains('view-more-less-content')) {
	        if (!this._internalVars.defaultsSet) {
	            setCarouselDefault.call(this);
	        }
	
	        if (currentNode.offsetLeft + payPlanWrapper.offsetLeft - this._internalVars.carouselObjects[0].clientWidth + currentNode.clientWidth + 5 > outerWrapper.clientWidth) {
	            left = currentNode.offsetLeft - (outerWrapper.clientWidth - currentNode.clientWidth - 15);
	            this._internalVars.newCardsOnLeft = this._internalVars.cardsOnLeft - 1;
	            this._internalVars.newCardsOnRight = this._internalVars.cardsOnRight - 1;
	        }
	
	        if (currentNode.offsetLeft + (payPlanWrapper.offsetLeft - this._internalVars.carouselObjects[0].clientWidth) + currentNode.clientWidth + 5 < currentNode.clientWidth + 5) {
	            left = currentNode.offsetLeft;
	            this._internalVars.newCardsOnLeft = this._internalVars.cardsOnLeft + 1;
	            this._internalVars.newCardsOnRight = this._internalVars.cardsOnRight + 1;
	        }
	
	        if (this._internalVars.newCardsOnLeft === undefined) {
	            this._internalVars.newCardsOnLeft = this._internalVars.cardsOnLeft;
	        }
	
	        if (this._internalVars.newCardsOnRight === undefined) {
	            this._internalVars.newCardsOnRight = this._internalVars.cardsOnRight;
	        }
	
	        this._internalVars.carouselMoveObject.style.marginLeft = '-' + left + 'px';
	
	        if (this._internalVars.newCardsOnRight === 0) {
	            disableRightArrow = true;
	        } else {
	            disableRightArrow = false;
	        }
	
	        if (this._internalVars.newCardsOnLeft === 0 || this._internalVars.newCardsOnLeft === -0) {
	            disableLeftArrow = true;
	        } else {
	            disableLeftArrow = false;
	        }
	
	        this._internalVars.cardsOnLeft = this._internalVars.newCardsOnLeft;
	        this._internalVars.cardsOnRight = this._internalVars.newCardsOnRight;
	
	        setArrowState.call(this, disableRightArrow, disableLeftArrow);
	    } else {
	        if (currentNode.offsetLeft - outerWrapper.scrollLeft + currentNode.clientWidth + 5 > outerWrapper.clientWidth) {
	            left = currentNode.offsetLeft - (outerWrapper.clientWidth - currentNode.clientWidth - 15);
	        }
	
	        if (currentNode.offsetLeft - outerWrapper.scrollLeft + currentNode.clientWidth + 5 < currentNode.clientWidth + 5) {
	            left = currentNode.offsetLeft;
	        }
	        $(outerWrapper).animate({
	            scrollLeft: left
	        }, 350);
	    }
	}
	
	/**
	 * For IE11 - Stops form submit when selecting a card using the enter key
	 */
	function checkEvent() {
	    if (event.keyCode == '13' && event.target.hasAttribute('aria-checked')) {
	        event.preventDefault();
	    }
	}
	
	/**
	 * setLocalVars()
	 * set local vars to the ones passed in options
	 */
	function setLocalVars() {
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    this._internalVars.payPlanObject = this._internalVars.node;
	
	    this._internalVars.payPlanCardClass = '.payment-plan-card';
	    this._internalVars.payPlanCards = this._internalVars.payPlanObject.querySelectorAll(this._internalVars.payPlanCardClass);
	
	    this._internalVars.payPlanCardTopClass = 'card-top';
	    this._internalVars.payPlanCardTopObject = this._internalVars.node.querySelectorAll('.' + this._internalVars.payPlanCardTopClass);
	
	    this._internalVars.hoverClass = 'hover';
	    this._internalVars.focusClass = 'focus';
	
	    this._internalVars.payPlanSelectedClass = 'payment-plan-selected';
	
	    this._internalVars.carouselClass = 'carousel';
	    this._internalVars.carouselObjects = this._internalVars.node.querySelectorAll('.' + this._internalVars.carouselClass);
	
	    this._internalVars.carouselBtnClass = 'carousel-icon';
	    this._internalVars.carouselBtnObjects = this._internalVars.node.querySelectorAll('.' + this._internalVars.carouselBtnClass);
	
	    this._internalVars.carouselDisabledClass = 'disabled';
	
	    this._internalVars.payPlanWrapperClass = 'payment-plan-wrapper';
	    this._internalVars.payPlanWrapperObjects = this._internalVars.payPlanObject.querySelectorAll('.' + this._internalVars.payPlanWrapperClass);
	
	    this._internalVars.defaultsSet = false;
	
	    this._internalVars.payPlanInnerWrapperClass = 'payment-plan-inner-wrapper';
	    this._internalVars.payPlanInnerWrapperObjects = this._internalVars.payPlanObject.querySelectorAll('.' + this._internalVars.payPlanInnerWrapperClass);
	    this._internalVars.carouselMoveObject = this._internalVars.payPlanWrapperObjects[1].querySelector('.' + this._internalVars.payPlanInnerWrapperClass);
	
	    this._internalVars.viewPortCheck = false;
	    this._internalVars.rowIndex = null;
	    this._internalVars.cardIndex = null;
	    this._internalVars.eventType = null;
	
	    this._internalVars.payPlansForm = this._internalVars.payPlanObject.getElementsByTagName('form');
	}
	
	exports['default'] = PayPlans;
	module.exports = exports['default'];

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by Svetoslav Kostadinov on 1/27/2016.
	 */
	
	// Module Imports
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var PromiseIE = __webpack_require__(18).Promise;
	
	var validateSettings = [{
	  setting: "content",
	  isRequired: true,
	  validate: "type", //a type or a value
	  possibleValues: ["string", "object"],
	  errorMessage: ["GDK Consolidated Summary : Content must be defined and set to a DOM selector or Node"]
	}, {
	  setting: "autoLoad",
	  isRequired: false,
	  validate: "type",
	  possibleValues: ["boolean"],
	  errorMessage: ["GDK Consolidated Summary : autoLoad must be a boolean"]
	}, {
	  setting: "loadPlog",
	  isRequired: false,
	  validate: "type",
	  possibleValues: ["function"],
	  errorMessage: ["GDK Consolidated Summary : loadPlog must be a function"]
	}];
	
	/**
	 * Consolidated Summary Component: This is integrated informative component for GEICO Counselors. Main purpose is to ease counselors
	 * work by displaying various information on selected policy holder.
	 */
	
	var ConsolidatedSummary = (function () {
	
	  /**
	   * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	   * @param {string|Object} content
	   *  A reference to Consolidated Summary Component.
	   *
	   * @param {function} loadPlog
	   *  A callback function that gets fired with a return of a promise function
	   *
	   *  @param {boolean} [autoLoad=true]
	   *  Use if you want prevent consolidated summary to auto load when instantiated
	   *
	   */
	
	  function ConsolidatedSummary(options) {
	    _classCallCheck(this, ConsolidatedSummary);
	
	    this._internalVars = {
	      node: null, //used for the current node
	      consolidatedSummary: null //holds reference to the consolidated Summary node;
	    };
	
	    this._defaults = {
	      initialTabOpen: 1,
	      autoLoad: true,
	      loadPlog: function loadPlog() {
	        //Return an empty promise
	        return new PromiseIE(function (resolve, reject) {
	          resolve();
	        });
	      }
	    };
	
	    if (options && typeof options === "object") {
	      this._options = _baseComponent2["default"].extendDefaults(this._defaults, options);
	    }
	
	    if (_baseComponent2["default"].validateSettings(this._options, validateSettings)) {
	      this._internalVars.contentType = _baseComponent2["default"].getContentType(this);
	      setLocalVars.call(this);
	      setEvents.call(this);
	      init.call(this);
	    }
	  }
	
	  /**
	   * Initializing method
	   */
	
	  /**
	   * Global method to switch the Consolidated Summary component on and off
	   * @param initFix
	   */
	
	  _createClass(ConsolidatedSummary, [{
	    key: "toggleConsolidatedSummary",
	    value: function toggleConsolidatedSummary(initFix) {
	      var node = this._internalVars.node;
	      if (initFix) {
	        if (!document.querySelector('#wrapper').classList.contains('consolidated-summary-enabled')) {
	          document.querySelector('#wrapper').classList.add('consolidated-summary-enabled');
	        }
	        if (document.querySelector('#to-top') !== null && document.querySelector('#to-top') !== 'undefined') {
	          if (!document.querySelector('#to-top').classList.contains('consolidated-summary-enabled')) {
	            document.querySelector('#to-top').classList.add('consolidated-summary-enabled');
	          }
	        }
	      } else {
	        toggleComponent.call(this);
	      }
	    }
	  }]);
	
	  return ConsolidatedSummary;
	})();
	
	function init() {
	
	  // make sure the #wrapper don't have the .pinned-consolidated-summary class;
	  document.querySelector('#wrapper').classList.remove('pinned-consolidated-summary');
	
	  if (this._options.autoLoad && this._internalVars.node.classList.contains('hidden')) {
	    this.toggleConsolidatedSummary();
	  } else if (!this._options.autoLoad && !this._internalVars.node.classList.contains('hidden')) {
	    this.toggleConsolidatedSummary();
	  } else if (this._options.autoLoad && !this._internalVars.node.classList.contains('hidden')) {
	    this.toggleConsolidatedSummary(true);
	  }
	  if (this._internalVars.node.classList && this._internalVars.node.classList.contains('extended')) {
	    this._internalVars.node.classList.remove('extended');
	  }
	  if (!this._internalVars.plogComponent.classList || !this._internalVars.plogComponent.classList.contains('extended')) {
	    this._internalVars.plogComponent.classList.add('hidden');
	  }
	
	  /* Instantiate the tabs */
	  openInitialTab.call(this);
	}
	
	/**
	 * method to set events for the component
	 */
	function setEvents() {
	  var _this = this;
	
	  var node = this._internalVars.node;
	  var wrapper = this._internalVars.wrapper;
	
	  /* Tabs */
	  var tabs = this._internalVars.verticalTabs.querySelectorAll('.tab');
	  var panels = this._internalVars.verticalTabs.querySelectorAll('.panel');
	
	  /* PLOG Controls */
	  var plogBtn = this._internalVars.plogBtn;
	  var plog = this._internalVars.plogComponent;
	  var plogSendBtn = this._internalVars.plogSendBtn;
	  var plogForm = this._internalVars.plogForm;
	  /*PLOG Window Controls */
	  var plogResizeBtn = this._internalVars.plogComponent.querySelector(".plogResizeBtn");
	  var plogMinimizeBtn = this._internalVars.plogComponent.querySelector(".plogMinimizeBtn");
	  var options = this._options;
	
	  // On mouse click behavior
	  wrapper.addEventListener("click", function () {
	    node.classList.add("extended");
	    if (document.querySelector('#to-top') !== null && document.querySelector('#to-top') !== 'undefined') {
	      if (!document.querySelector('#to-top').classList.contains('consolidated-summary-extended')) {
	        document.querySelector('#to-top').classList.add('consolidated-summary-extended');
	      }
	    }
	  }, false);
	  // On mouse enter behavior
	  // wrapper.addEventListener("mouseenter", function () {
	  //if (!document.querySelector('body').classList.contains('no-scroll')){
	  //    document.querySelector('body').style.top = -(document.querySelector('body').scrollTop) + "px";
	  //    document.querySelector('body').classList.add('no-scroll');
	  //}
	  //document.querySelector('body').style.position = "fixed";
	  //document.querySelector('body').style.overflowY = "none";
	  // }, false);
	  // On mouse leave behavior
	  wrapper.addEventListener("mouseleave", function () {
	    node.classList.remove("extended");
	    if (document.querySelector('#to-top') !== null && document.querySelector('#to-top') !== 'undefined') {
	      if (document.querySelector('#to-top').classList.contains('consolidated-summary-extended')) {
	        document.querySelector('#to-top').classList.remove('consolidated-summary-extended');
	      }
	    }
	    //if (document.querySelector('body').classList.contains('no-scroll')){
	    //    document.querySelector('body').removeAttribute('style');
	    //    document.querySelector('body').classList.remove('no-scroll');
	    //}
	    //document.querySelector('body').style.position = "static";
	    //document.querySelector('body').style.overflowY = "visible";
	  }, false);
	
	  // implement "pinned" functionality
	  node.querySelector(".consolidated-summary-pin").addEventListener("click", function () {
	    if (!node.classList.contains("pinned")) {
	      document.querySelector('#wrapper').classList.add('pinned-consolidated-summary');
	      if (document.querySelector('#to-top') !== null && document.querySelector('#to-top') !== 'undefined') {
	        if (!document.querySelector('#to-top').classList.contains('consolidated-summary-pinned')) {
	          document.querySelector('#to-top').classList.add('consolidated-summary-pinned');
	        }
	      }
	      if (document.querySelector('.docked-real-time-message-wrapper') !== null && document.querySelector('.docked-real-time-message-wrapper') !== 'undefined') {
	        var dockedMsgArray = document.querySelectorAll('.docked-real-time-message-wrapper');
	        Array.prototype.forEach.call(dockedMsgArray, function (element) {
	          if (!element.classList.contains('con-sum-pinned')) {
	            if (element.hasAttribute('id')) {
	              element.classList.add('con-sum-three-hundred-fix');
	            }
	            element.classList.add('con-sum-pinned');
	          }
	        });
	      }
	      node.classList.add("pinned");
	    } else {
	      document.querySelector('#wrapper').classList.remove('pinned-consolidated-summary');
	      if (document.querySelector('#to-top') !== null && document.querySelector('#to-top') !== 'undefined') {
	        if (document.querySelector('#to-top').classList.contains('consolidated-summary-pinned')) {
	          document.querySelector('#to-top').classList.remove('consolidated-summary-pinned');
	        }
	      }
	      if (document.querySelector('.docked-real-time-message-wrapper') !== null && document.querySelector('.docked-real-time-message-wrapper') !== 'undefined') {
	        var dockedMsgArray = document.querySelectorAll('.docked-real-time-message-wrapper');
	        Array.prototype.forEach.call(dockedMsgArray, function (element) {
	          if (element.classList.contains('con-sum-pinned')) {
	            if (element.hasAttribute('id')) {
	              element.classList.remove('con-sum-three-hundred-fix');
	            }
	            element.classList.remove('con-sum-pinned');
	          }
	        });
	      }
	      node.classList.remove("pinned");
	    }
	  });
	
	  // implement the vertical Tabs functionality
	  var eventName = "click";
	  if ("ontouchstart" in document.documentElement) {
	    eventName = "touchstart";
	  }
	  Array.prototype.forEach.call(tabs, function (element) {
	    element.addEventListener(eventName, tabClickHandler.bind(_this));
	  });
	
	  plogBtn.addEventListener("click", function (e) {
	    e.preventDefault();
	    options.loadPlog().then(function () {
	      // hide Policy Notes
	      if (!plog.classList.contains("hidden")) {
	        plog.classList.add("hidden");
	        if (document.querySelector('#to-top') !== null && document.querySelector('#to-top') !== 'undefined') {
	          if (document.querySelector('#to-top').classList.contains('plog-enabled')) {
	            document.querySelector('#to-top').classList.remove('plog-enabled');
	          }
	        }
	      } else {
	        // Display Policy Notes
	        plog.classList.remove("hidden");
	        if (document.querySelector('#to-top') !== null && document.querySelector('#to-top') !== 'undefined') {
	          if (!document.querySelector('#to-top').classList.contains('plog-enabled')) {
	            document.querySelector('#to-top').classList.add('plog-enabled');
	          }
	        }
	      }
	    });
	  });
	
	  plogMinimizeBtn.addEventListener("click", function () {
	
	    if (!plog.classList.contains("hidden")) {
	      if (plog.classList.contains("maximized")) {
	        plog.classList.remove("maximized");
	      }
	      if (document.querySelector('#to-top') !== null && document.querySelector('#to-top') !== 'undefined') {
	        if (!node.classList.contains('extended') && document.querySelector('#to-top').classList.contains('consolidated-summary-extended')) {
	          document.querySelector('#to-top').classList.remove('consolidated-summary-extended');
	        }
	        if (!node.classList.contains("pinned") && document.querySelector('#to-top').classList.contains('consolidated-summary-pinned')) {
	          document.querySelector('#to-top').classList.remove('consolidated-summary-pinned');
	        }
	        if (document.querySelector('#to-top').classList.contains('plog-enabled')) {
	          document.querySelector('#to-top').classList.remove('plog-enabled');
	        }
	      }
	      plog.classList.add("hidden");
	    } else {
	      plog.classList.remove("hidden");
	    }
	  });
	  plogResizeBtn.addEventListener("click", function () {
	    if (!plog.classList.contains("maximized")) {
	      if (node.classList && node.classList.contains("extended")) {
	        node.classList.remove("extended");
	      }
	      if (node.classList && node.classList.contains("pinned")) {
	        document.querySelector('#wrapper').classList.remove('pinned-consolidated-summary');
	        node.classList.remove("pinned");
	      }
	      plog.classList.add("maximized");
	    } else {
	      plog.classList.remove("maximized");
	    }
	  });
	}
	
	/* Tabs Methods */
	
	/**
	 * tabClickHandler()
	 * Opens tab content for clicked tab and hides the rest
	 */
	function tabClickHandler(element) {
	  var _this2 = this;
	
	  var currentNode = element.currentTarget;
	  //get index of clicked tab
	  var index = [].indexOf.call(this._internalVars.tabs, currentNode);
	  if (this._options.tabClicked) if (this._options.tabClicked(currentNode) === false) return false;
	
	  Array.prototype.map.call(this._internalVars.tabs, function (element) {
	    if (element === currentNode) {
	      element.classList.add("active");
	    } else {
	      element.classList.remove("active");
	    }
	  });
	
	  Array.prototype.map.call(this._internalVars.panels, function (element, i) {
	    if (i === index) {
	      openPanel.call(_this2, element);
	    } else {
	      closePanel.call(_this2, element);
	    }
	  });
	}
	
	/**
	 * openInitialTab()
	 * Opens tab content for tab set by initialTabOpen
	 */
	function openInitialTab() {
	  var _this3 = this;
	
	  var tabIndex = this._options.initialTabOpen - 1;
	
	  Array.prototype.map.call(this._internalVars.tabs, function (element, i) {
	    if (i === tabIndex) {
	      element.classList.add("active");
	    } else {
	      element.classList.remove("active");
	    }
	  });
	
	  Array.prototype.map.call(this._internalVars.panels, function (element, i) {
	    if (i === tabIndex) {
	      openPanel.call(_this3, element);
	    } else {
	      closePanel.call(_this3, element);
	    }
	  });
	}
	
	/**
	 * openPanel()
	 * Opens panel at the same index as the clicked tab and hides the other panels
	 */
	function openPanel(element) {
	  element.classList.add("active");
	}
	
	/**
	 * closePanel()
	 * closes the past in panel
	 */
	function closePanel(element) {
	  element.classList.remove("active");
	}
	
	/**
	 * toggles the component (hide/display).
	 */
	function toggleComponent() {
	  var node = this._internalVars.node;
	  /* con-sum-on */
	  if (node.classList) {
	    if (!node.classList.contains('hidden')) {
	      node.classList.add("hidden");
	      if (document.querySelector('#wrapper').classList.contains('consolidated-summary-enabled')) {
	        document.querySelector('#wrapper').classList.remove('consolidated-summary-enabled');
	      }
	      if (document.querySelector('#wrapper').classList.contains('pinned-consolidated-summary')) {
	        document.querySelector('#wrapper').classList.remove('pinned-consolidated-summary');
	        if (document.querySelector('#consolidated-summary-component').classList.contains('pinned')) {
	          document.querySelector('#consolidated-summary-component').classList.remove('pinned');
	        }
	      }
	
	      if (document.querySelector('#to-top') !== null && document.querySelector('#to-top') !== 'undefined') {
	        if (document.querySelector('#to-top').classList.contains('consolidated-summary-enabled')) {
	          document.querySelector('#to-top').classList.remove('consolidated-summary-enabled');
	        }
	        if (document.querySelector('#to-top').classList.contains('pinned-consolidated-summary')) {
	          document.querySelector('#to-top').classList.remove('pinned-consolidated-summary');
	          if (document.querySelector('#consolidated-summary-component').classList.contains('pinned')) {
	            document.querySelector('#consolidated-summary-component').classList.remove('pinned');
	          }
	        }
	      }
	      if (document.querySelector('.docked-real-time-message-wrapper') !== null && document.querySelector('.docked-real-time-message-wrapper') !== 'undefined') {
	        var dockedMsgArray = document.querySelectorAll('.docked-real-time-message-wrapper');
	        Array.prototype.forEach.call(dockedMsgArray, function (element) {
	          if (element.classList.contains('con-sum-on')) {
	            if (element.hasAttribute('id')) {
	              element.classList.remove('con-sum-fifty-fix');
	            }
	            element.classList.remove('con-sum-on');
	          }
	        });
	      }
	    } else {
	      node.classList.remove("hidden");
	      if (!document.querySelector('#wrapper').classList.contains('consolidated-summary-enabled')) {
	        document.querySelector('#wrapper').classList.add('consolidated-summary-enabled');
	      }
	      if (document.querySelector('#to-top') !== null && document.querySelector('#to-top') !== 'undefined') {
	        if (!document.querySelector('#to-top').classList.contains('consolidated-summary-enabled')) {
	          document.querySelector('#to-top').classList.add('consolidated-summary-enabled');
	        }
	      }
	      if (document.querySelector('.docked-real-time-message-wrapper') !== null && document.querySelector('.docked-real-time-message-wrapper') !== 'undefined') {
	        var dockedMsgArray = document.querySelectorAll('.docked-real-time-message-wrapper');
	        Array.prototype.forEach.call(dockedMsgArray, function (element) {
	          if (!element.classList.contains('con-sum-on')) {
	            if (element.hasAttribute('id')) {
	              element.classList.add('con-sum-fifty-fix');
	            }
	            element.classList.add('con-sum-on');
	          }
	        });
	      }
	    }
	  }
	}
	
	/**
	 * Method to set local variables.
	 */
	function setLocalVars() {
	  if (this._internalVars.contentType === 'string') {
	    this._internalVars.node = document.querySelector(this._options.content);
	  } else if (this._internalVars.contentType === 'domNode') {
	    this._internalVars.node = this._options.content;
	  }
	  this._internalVars.wrapper = this._internalVars.node.querySelector(".consolidated-summary-wrapper");
	
	  this._internalVars.verticalTabs = this._internalVars.node.querySelector('.consolidated-summary-content-tabs');
	  this._internalVars.tabs = this._internalVars.verticalTabs.querySelectorAll('.tab');
	  this._internalVars.panels = this._internalVars.verticalTabs.querySelectorAll('.panel');
	  this._internalVars.plogComponent = this._internalVars.node.querySelector(".plog");
	  this._internalVars.plogBtn = this._internalVars.node.querySelector(".plog-btn");
	  this._internalVars.plogForm = this._internalVars.node.querySelector(".policy-note-input-form");
	  this._internalVars.plogSendBtn = this._internalVars.node.querySelector(".plog-input-bar .send-btn");
	}
	
	exports["default"] = ConsolidatedSummary;
	module.exports = exports["default"];

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by Svetoslav Kostadinov on 4/14/16.
	 */
	
	//Require static assets
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _appState = __webpack_require__(7);
	
	var _appState2 = _interopRequireDefault(_appState);
	
	//Module Imports
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK Tabs : Content must be defined and set to a DOM selector or Node"]
	}];
	
	var EditComponent = (function () {
	    /**
	     * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	     * @param {string|Object} content
	     *  A reference to the edit component node
	     */
	
	    function EditComponent(options) {
	        _classCallCheck(this, EditComponent);
	
	        this._internalVars = {};
	
	        //options with defaults set
	        this._defaults = {};
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2['default'].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2['default'].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2['default'].getContentType(this);
	            setLocalVars.call(this);
	
	            setEvents.call(this);
	        }
	    }
	
	    //Public Methods
	
	    /**
	     * removes the node from the dom and any events attached
	     */
	
	    _createClass(EditComponent, [{
	        key: 'destroy',
	        value: function destroy() {
	            removeEvents.call(this);
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return EditComponent;
	})();
	
	function setLocalVars() {
	    //determine the type of content passed in
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	    this._internalVars.editFormPlaceholder = this._internalVars.node.querySelector('.edit-form-placeholder');
	    this._internalVars.editForm = this._internalVars.editFormPlaceholder.querySelector('form');
	    this._internalVars.editBtn = this._internalVars.node.querySelector('.btn--edit-list');
	    this._internalVars.cancelBtn = this._internalVars.editForm.querySelector('.btn-cancel');
	    this._internalVars.submitBtn = this._internalVars.editForm.querySelector('.btn-submit');
	
	    this._internalVars.editHandler = expandEditForm.bind(this);
	    this._internalVars.cancelHandler = collapseEditForm.bind(this);
	    this._internalVars.submitHandler = handleFormSubmission.bind(this);
	}
	
	function init() {
	    this._internalVars.editFormPlaceholder.style.maxHeight = 0 + "px";
	}
	
	function setEvents() {
	    var eventName = 'click';
	    this._internalVars.editBtn.addEventListener(eventName, this._internalVars.editHandler);
	    //    Form Controls
	    this._internalVars.cancelBtn.addEventListener(eventName, this._internalVars.cancelHandler);
	    this._internalVars.submitBtn.addEventListener(eventName, this._internalVars.submitHandler);
	}
	
	function removeEvents() {
	    var eventName = 'click';
	    this._internalVars.editBtn.addEventListener(eventName, this._internalVars.editHandler);
	    //    Form Controls
	    this._internalVars.cancelBtn.addEventListener(eventName, this._internalVars.cancelHandler);
	    this._internalVars.submitBtn.addEventListener(eventName, this._internalVars.submitHandler);
	}
	
	function expandEditForm(event) {
	
	    var editContent = this._internalVars.editFormPlaceholder.querySelector(".edit-content");
	    var editPlaceholder = this._internalVars.editFormPlaceholder;
	
	    $(editPlaceholder).slideDown();
	
	    var editButton = event.currentTarget;
	    if (!editButton.classList.contains('hidden')) {
	        editButton.classList.add("hidden");
	    }
	}
	function collapseEditForm(event) {
	    event.preventDefault();
	    var editPlaceholder = this._internalVars.editFormPlaceholder;
	    $(editPlaceholder).slideUp();
	    var editButton = this._internalVars.editBtn;
	    if (editButton.classList.contains('hidden')) {
	        editButton.classList.remove("hidden");
	    }
	}
	function handleFormSubmission(event) {
	    var _this = this;
	
	    event.preventDefault();
	    collapseEditForm.bind(this, event);
	    setTimeout(function () {
	        _this._internalVars.editForm.submit();
	    }, 700);
	}
	
	exports['default'] = EditComponent;
	module.exports = exports['default'];

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Created by svetoslav on 8/10/15.
	 */
	
	//Module Imports
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	  setting: "content",
	  isRequired: true,
	  validate: "type", //a type or a value
	  possibleValues: ["string", "object"],
	  errorMessage: ["GDK DockedMessage : Content must be defined and set to a DOM selector or Node"]
	}, {
	  setting: "autoHide",
	  isRequired: false,
	  validate: "type", //a type or a value
	  possibleValues: ["boolean"],
	  errorMessage: ["GDK DockedMessage : AutoHide must be defined as true or false"]
	}];
	
	var DockedMessage = (function () {
	  /**
	   * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	   * @param {string|Object} content
	   *  A reference to the docked real time message node
	   */
	
	  function DockedMessage(options) {
	    _classCallCheck(this, DockedMessage);
	
	    this._internalVars = {
	      node: null //used for current node
	    };
	
	    //options with defaults set
	    this._defaults = {
	      autoHide: false
	    };
	    // Create options by extending defaults with the passed in arugments
	    if (options && typeof options === "object") {
	      this._options = _baseComponent2["default"].extendDefaults(this._defaults, options);
	    }
	    //if the required options are valid set up the environment
	    if (_baseComponent2["default"].validateSettings(this._options, validateSettings)) {
	      this._internalVars.contentType = _baseComponent2["default"].getContentType(this);
	      setLocalVars.call(this);
	      init.call(this);
	    }
	  }
	
	  //Public Methods
	
	  /**
	   * hides/shows the component
	   */
	
	  _createClass(DockedMessage, [{
	    key: "toggleDockedMessage",
	    value: function toggleDockedMessage() {
	      toggleComponent.call(this);
	    }
	
	    /**
	     * removes the node from the dom and any events attached
	     */
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	      //a little garbage collection
	      for (var variableKey in this) {
	        if (this.hasOwnProperty(variableKey)) {
	          delete this[variableKey];
	        }
	      }
	    }
	  }]);
	
	  return DockedMessage;
	})();
	
	function init() {
	  if (this._options.autoHide) {
	    if (this._options.autoHide === true) {
	      hideComponent.call(this);
	    } else {
	      showComponent.call(this);
	    }
	  } else {
	    showComponent.call(this);
	  }
	}
	
	/**
	 * Toggle Component Function
	 * Displays and hides the component
	 */
	function toggleComponent() {
	  if (this._internalVars.node.classList.contains('hidden')) {
	    showComponent.call(this);
	  } else {
	    hideComponent.call(this);
	  }
	}
	
	function showComponent() {
	  this._internalVars.node.classList.remove('hidden');
	  this._internalVars.main.classList.add("docked-message-on");
	  this._internalVars.footer.classList.add("docked-message-on");
	  if (this._internalVars.toTopExists === true) {
	    this._internalVars.toTop.classList.add("docked-message-on");
	  }
	}
	
	function hideComponent() {
	  this._internalVars.node.classList.add('hidden');
	  this._internalVars.main.classList.remove("docked-message-on");
	  this._internalVars.footer.classList.remove("docked-message-on");
	  if (this._internalVars.toTopExists === true) {
	    this._internalVars.toTop.classList.remove("docked-message-on");
	  }
	}
	
	function setLocalVars() {
	  if (this._internalVars.contentType === 'string') {
	    this._internalVars.node = document.querySelector(this._options.content);
	  } else if (this._internalVars.contentType === 'domNode') {
	    this._internalVars.node = this._options.content;
	  }
	  this._internalVars.toTopExists = false;
	  if (document.querySelector(".to-top-arrow") !== null && document.querySelector(".to-top-arrow") !== 'undefined') {
	    this._internalVars.toTopExists = true;
	    this._internalVars.toTop = document.querySelector(".to-top-arrow");
	  }
	  this._internalVars.main = document.querySelector('#wrapper');
	  this._internalVars.footer = document.querySelector('#primary-footer');
	}
	
	exports["default"] = DockedMessage;
	module.exports = exports["default"];

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	//Module Imports
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var interact = __webpack_require__(60);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type",
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK Segmented Control : Segmented Control must be defined and set to a DOM selector or Node"]
	}, {
	    setting: "initialActive",
	    isRequired: false,
	    validate: "type",
	    possibleValues: ["number"],
	    errorMessage: ["GDK Segmented Control : initialActive must be set to a number"]
	}, {
	    setting: "segmentedControlChange",
	    isRequired: false,
	    validate: "type",
	    possibleValues: ["function"],
	    errorMessage: ["GDK Segmented Control : segmentedControlChange must be a defined and set function"]
	}];
	
	var SegmentedControl = (function () {
	    /**
	     * Refer to the design kit section of this component for JS examples and setting details.
	     * @param {string, Object} content
	     * A reference to the segmented control component node
	     *
	     * @param {number} [initialActive=1]
	     * The number of the item to set as the active selection on initialization. Must be greater than 0 and equal to or less than the number of segment options
	     *
	     * @param {function} [segmentedControlChange]
	     * A callback function that is triggered when the Segmented Control selection is changed
	     */
	
	    function SegmentedControl(options) {
	        _classCallCheck(this, SegmentedControl);
	
	        this._internalVars = {};
	
	        //options with defaults set
	        this._defaults = {
	            initialActive: 1
	        };
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2['default'].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2['default'].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2['default'].getContentType(this);
	            setLocalVars.call(this);
	            init.call(this);
	            setEvents.call(this);
	
	            Array.prototype.forEach.call(this._internalVars.dropZoneObject, function (element) {
	                element.setAttribute('role', 'switch');
	                if (element.classList.contains('active')) {
	                    element.setAttribute('aria-checked', 'true');
	                } else {
	                    element.setAttribute('aria-checked', 'false');
	                }
	            });
	        }
	    }
	
	    //Public Methods
	
	    /**
	     * setInitialActiveOpt(index)
	     * @param {number} index
	     * sets the initial active segment
	     */
	
	    _createClass(SegmentedControl, [{
	        key: 'setInitialActiveOpt',
	        value: function setInitialActiveOpt(index) {
	            setInitialActive.call(this, index);
	        }
	
	        /**
	         * activeSegment()
	         * returns the current active segment anchor element
	         * @returns {Element}
	         */
	    }, {
	        key: 'activeSegment',
	        value: function activeSegment() {
	            return this._internalVars.selectedSegment;
	        }
	
	        /**
	         * removes the node from the dom and any events attached
	         */
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return SegmentedControl;
	})();
	
	function setLocalVars() {
	    //determine the type of content passed in
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    this._internalVars.segmentedControlObject = this._internalVars.node;
	
	    this._internalVars.draggableClass = '.sc-draggable';
	    this._internalVars.dropZoneClass = '.dropzone';
	    this._internalVars.animateClass = 'animate-drop';
	    this._internalVars.dropActiveClass = 'drop-active';
	    this._internalVars.dropTargetClass = 'drop-target';
	    this._internalVars.activeClass = 'active';
	    this._internalVars.activeDragClass = 'active-drag';
	
	    this._internalVars.dropZoneObject = this._internalVars.segmentedControlObject.querySelectorAll(this._internalVars.dropZoneClass);
	    this._internalVars.draggableObject = this._internalVars.segmentedControlObject.querySelector(this._internalVars.draggableClass);
	
	    this._internalVars.selectedSegment = null;
	}
	
	function init() {
	    var _this = this;
	
	    var index = this._options.initialActive;
	
	    setInitialActive.call(this, index);
	
	    interact(this._internalVars.draggableObject).draggable({
	        inertia: true,
	        restrict: {
	            restriction: 'parent',
	            endOnly: false,
	            elementRect: { top: 0, left: 0, bottom: 0, right: 1 }
	        },
	        autoScroll: false,
	        snap: {
	            targets: [{ y: 0, range: Infinity }]
	
	        },
	
	        onmove: scDragMoveListener.bind(this)
	    });
	
	    function scDragMoveListener(event) {
	        var target = event.target,
	            x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
	            y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
	
	        target.style.left = x + "px";
	
	        target.setAttribute('data-x', x);
	        target.setAttribute('data-y', 0);
	
	        target.innerText = '';
	        target.style.zIndex = 1;
	        target.classList.add(this._internalVars.activeDragClass);
	    }
	
	    Array.prototype.forEach.call(this._internalVars.dropZoneObject, function (element) {
	        interact(element).dropzone({
	            accept: _this._internalVars.draggableClass,
	
	            overlap: 0.4,
	
	            ondropactivate: dropActivate.bind(_this),
	
	            ondragenter: dragEnter.bind(_this),
	
	            ondragleave: dragLeave.bind(_this),
	
	            ondrop: onDrop.bind(_this),
	
	            ondropdeactivate: dropDeactivate.bind(_this)
	        });
	    });
	
	    function dropActivate(event) {
	        event.target.classList.add(this._internalVars.dropActiveClass);
	    }
	
	    function dragEnter(event) {
	        var dropzoneElement = event.target;
	
	        dropzoneElement.classList.add(this._internalVars.dropTargetClass);
	    }
	
	    function dragLeave(event) {
	        event.target.classList.remove(this._internalVars.dropTargetClass);
	    }
	
	    function onDrop(event) {
	        var xcord = event.target.offsetLeft,
	            delay = setTimeout(setNewSelection.bind(this), 350),
	            current = event.target.offsetParent.querySelector('.' + this._internalVars.activeClass);
	
	        current.classList.remove(this._internalVars.activeClass);
	        current.setAttribute('aria-checked', 'false');
	        event.target.classList.add(this._internalVars.activeClass);
	        event.target.setAttribute('aria-checked', 'true');
	        event.relatedTarget.classList.add(this._internalVars.animateClass);
	        event.relatedTarget.setAttribute('data-x', xcord);
	        event.relatedTarget.style.left = xcord + 'px';
	
	        function setNewSelection() {
	            event.relatedTarget.textContent = event.target.textContent;
	            event.relatedTarget.style.zIndex = 2;
	            event.relatedTarget.classList.remove(this._internalVars.animateClass);
	            event.relatedTarget.classList.remove(this._internalVars.activeDragClass);
	            this._internalVars.segmentedControlObject.querySelector('.' + this._internalVars.activeClass).focus();
	        }
	
	        this._internalVars.selectedSegment = event.target;
	
	        if (this._options.segmentedControlChange) {
	            this._options.segmentedControlChange(event.target);
	        }
	    }
	
	    function dropDeactivate(event) {
	        event.target.classList.remove(this._internalVars.dropActiveClass);
	        event.target.classList.remove(this._internalVars.dropTargetClass);
	    }
	}
	
	function setEvents() {
	    var _this2 = this;
	
	    var eventName = "click";
	
	    if ("ontouchstart" in document.documentElement) {
	        eventName = "touchstart";
	    }
	
	    Array.prototype.forEach.call(this._internalVars.dropZoneObject, function (element) {
	        element.addEventListener(eventName, setActiveSelection.bind(_this2));
	        element.addEventListener('focus', function () {
	            if (element.classList.contains('active')) {
	                element.parentNode.firstElementChild.style.textDecoration = 'underline';
	            } else {
	                element.parentNode.firstElementChild.style.textDecoration = 'none';
	            }
	        });
	        element.addEventListener('blur', function () {
	            element.parentNode.firstElementChild.style.textDecoration = 'none';
	        });
	    });
	
	    this._internalVars.draggableObject.addEventListener(eventName, function () {
	        this.parentNode.querySelector('.active').focus();
	        this.style.textDecoration = 'underline';
	    });
	
	    window.addEventListener('resize', resetActiveSelection.bind(this));
	}
	
	function setInitialActive(activeIndex) {
	
	    var activeElement = this._internalVars.segmentedControlObject.querySelector('.' + this._internalVars.activeClass);
	
	    if (activeElement) {
	        activeElement.classList.remove(this._internalVars.activeClass);
	        activeElement.setAttribute('aria-checked', 'false');
	    }
	
	    if (activeIndex <= this._internalVars.dropZoneObject.length && activeIndex > 0) {
	        this._internalVars.dropZoneObject[activeIndex - 1].classList.add(this._internalVars.activeClass);
	    } else {
	        this._internalVars.dropZoneObject[0].classList.add(this._internalVars.activeClass);
	    }
	
	    activeElement = this._internalVars.segmentedControlObject.querySelector('.' + this._internalVars.activeClass);
	    var activeElementLeft = activeElement.offsetLeft,
	        activeElementContent = activeElement.innerHTML;
	
	    activeElement.setAttribute('aria-checked', 'true');
	    this._internalVars.draggableObject.style.left = activeElementLeft + 'px';
	    this._internalVars.draggableObject.innerHTML = activeElementContent;
	    this._internalVars.draggableObject.setAttribute('data-x', activeElementLeft);
	
	    this._internalVars.selectedSegment = activeElement;
	}
	
	function setActiveSelection(event) {
	    event.preventDefault();
	    var left = event.target.offsetLeft,
	        delay = setTimeout(setNewSelection.bind(this), 350),
	        current = event.target.offsetParent.querySelector('.' + this._internalVars.activeClass);
	
	    current.classList.remove(this._internalVars.activeClass);
	    current.setAttribute('aria-checked', 'false');
	    event.target.classList.add(this._internalVars.activeClass);
	    event.target.setAttribute('aria-checked', 'true');
	    this._internalVars.draggableObject.classList.add(this._internalVars.animateClass);
	    this._internalVars.draggableObject.classList.add(this._internalVars.activeDragClass);
	    this._internalVars.draggableObject.innerText = '';
	    this._internalVars.draggableObject.style.zIndex = 1;
	
	    this._internalVars.draggableObject.setAttribute('data-x', left);
	    this._internalVars.draggableObject.style.left = left + 'px';
	
	    function setNewSelection() {
	        this._internalVars.draggableObject.innerHTML = event.target.innerHTML;
	        this._internalVars.draggableObject.style.zIndex = 2;
	        this._internalVars.draggableObject.classList.remove(this._internalVars.animateClass);
	        this._internalVars.draggableObject.classList.remove(this._internalVars.activeDragClass);
	        this._internalVars.draggableObject.style.textDecoration = 'underline';
	    }
	
	    this._internalVars.selectedSegment = event.target;
	
	    if (this._options.segmentedControlChange) {
	        this._options.segmentedControlChange(event.target);
	    }
	}
	
	function resetActiveSelection() {
	    var current = this._internalVars.segmentedControlObject.querySelector('.' + this._internalVars.activeClass),
	        left = current.offsetLeft;
	
	    this._internalVars.draggableObject.setAttribute('data-x', left);
	    this._internalVars.draggableObject.style.left = left + 'px';
	}
	
	exports['default'] = SegmentedControl;
	module.exports = exports['default'];

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(61);

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * interact.js v1.2.8
	 *
	 * Copyright (c) 2012-2015 Taye Adeyemi <dev@taye.me>
	 * Open source under the MIT License.
	 * https://raw.github.com/taye/interact.js/master/LICENSE
	 */'use strict';(function(realWindow){'use strict'; // return early if there's no window to work with (eg. Node.js)
	if(!realWindow){return;}var  // get wrapped window if using Shadow DOM polyfill
	window=(function(){ // create a TextNode
	var el=realWindow.document.createTextNode(''); // check if it's wrapped by a polyfill
	if(el.ownerDocument !== realWindow.document && typeof realWindow.wrap === 'function' && realWindow.wrap(el) === el){ // return wrapped window
	return realWindow.wrap(realWindow);} // no Shadow DOM polyfil or native implementation
	return realWindow;})(),document=window.document,DocumentFragment=window.DocumentFragment || blank,SVGElement=window.SVGElement || blank,SVGSVGElement=window.SVGSVGElement || blank,SVGElementInstance=window.SVGElementInstance || blank,HTMLElement=window.HTMLElement || window.Element,PointerEvent=window.PointerEvent || window.MSPointerEvent,pEventTypes,hypot=Math.hypot || function(x,y){return Math.sqrt(x * x + y * y);},tmpXY={}, // reduce object creation in getXY()
	documents=[], // all documents being listened to
	interactables=[], // all set interactables
	interactions=[], // all interactions
	dynamicDrop=false, // {
	//      type: {
	//          selectors: ['selector', ...],
	//          contexts : [document, ...],
	//          listeners: [[listener, useCapture], ...]
	//      }
	//  }
	delegatedEvents={},defaultOptions={base:{accept:null,actionChecker:null,styleCursor:true,preventDefault:'auto',origin:{x:0,y:0},deltaSource:'page',allowFrom:null,ignoreFrom:null,_context:document,dropChecker:null},drag:{enabled:false,manualStart:true,max:Infinity,maxPerElement:1,snap:null,restrict:null,inertia:null,autoScroll:null,axis:'xy'},drop:{enabled:false,accept:null,overlap:'pointer'},resize:{enabled:false,manualStart:false,max:Infinity,maxPerElement:1,snap:null,restrict:null,inertia:null,autoScroll:null,square:false,preserveAspectRatio:false,axis:'xy', // use default margin
	margin:NaN, // object with props left, right, top, bottom which are
	// true/false values to resize when the pointer is over that edge,
	// CSS selectors to match the handles for each direction
	// or the Elements for each handle
	edges:null, // a value of 'none' will limit the resize rect to a minimum of 0x0
	// 'negate' will alow the rect to have negative width/height
	// 'reposition' will keep the width/height positive by swapping
	// the top and bottom edges and/or swapping the left and right edges
	invert:'none'},gesture:{manualStart:false,enabled:false,max:Infinity,maxPerElement:1,restrict:null},perAction:{manualStart:false,max:Infinity,maxPerElement:1,snap:{enabled:false,endOnly:false,range:Infinity,targets:null,offsets:null,relativePoints:null},restrict:{enabled:false,endOnly:false},autoScroll:{enabled:false,container:null, // the item that is scrolled (Window or HTMLElement)
	margin:60,speed:300 // the scroll speed in pixels per second
	},inertia:{enabled:false,resistance:10, // the lambda in exponential decay
	minSpeed:100, // target speed must be above this for inertia to start
	endSpeed:10, // the speed at which inertia is slow enough to stop
	allowResume:true, // allow resuming an action in inertia phase
	zeroResumeDelta:true, // if an action is resumed after launch, set dx/dy to 0
	smoothEndDuration:300 // animate to snap/restrict endOnly if there's no inertia
	}},_holdDuration:600}, // Things related to autoScroll
	autoScroll={interaction:null,i:null, // the handle returned by window.setInterval
	x:0,y:0, // Direction each pulse is to scroll in
	// scroll the window by the values in scroll.x/y
	scroll:function scroll(){var options=autoScroll.interaction.target.options[autoScroll.interaction.prepared.name].autoScroll,container=options.container || getWindow(autoScroll.interaction.element),now=new Date().getTime(), // change in time in seconds
	dtx=(now - autoScroll.prevTimeX) / 1000,dty=(now - autoScroll.prevTimeY) / 1000,vx,vy,sx,sy; // displacement
	if(options.velocity){vx = options.velocity.x;vy = options.velocity.y;}else {vx = vy = options.speed;}sx = vx * dtx;sy = vy * dty;if(sx >= 1 || sy >= 1){if(isWindow(container)){container.scrollBy(autoScroll.x * sx,autoScroll.y * sy);}else if(container){container.scrollLeft += autoScroll.x * sx;container.scrollTop += autoScroll.y * sy;}if(sx >= 1)autoScroll.prevTimeX = now;if(sy >= 1)autoScroll.prevTimeY = now;}if(autoScroll.isScrolling){cancelFrame(autoScroll.i);autoScroll.i = reqFrame(autoScroll.scroll);}},isScrolling:false,prevTimeX:0,prevTimeY:0,start:function start(interaction){autoScroll.isScrolling = true;cancelFrame(autoScroll.i);autoScroll.interaction = interaction;autoScroll.prevTimeX = new Date().getTime();autoScroll.prevTimeY = new Date().getTime();autoScroll.i = reqFrame(autoScroll.scroll);},stop:function stop(){autoScroll.isScrolling = false;cancelFrame(autoScroll.i);}}, // Does the browser support touch input?
	supportsTouch='ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch, // Does the browser support PointerEvents
	// Avoid PointerEvent bugs introduced in Chrome 55
	supportsPointerEvent=PointerEvent && !/Chrome/.test(navigator.userAgent), // Less Precision with touch input
	margin=supportsTouch || supportsPointerEvent?20:10,pointerMoveTolerance=1, // for ignoring browser's simulated mouse events
	prevTouchTime=0, // Allow this many interactions to happen simultaneously
	maxInteractions=Infinity, // Check if is IE9 or older
	actionCursors=document.all && !window.atob?{drag:'move',resizex:'e-resize',resizey:'s-resize',resizexy:'se-resize',resizetop:'n-resize',resizeleft:'w-resize',resizebottom:'s-resize',resizeright:'e-resize',resizetopleft:'se-resize',resizebottomright:'se-resize',resizetopright:'ne-resize',resizebottomleft:'ne-resize',gesture:''}:{drag:'move',resizex:'ew-resize',resizey:'ns-resize',resizexy:'nwse-resize',resizetop:'ns-resize',resizeleft:'ew-resize',resizebottom:'ns-resize',resizeright:'ew-resize',resizetopleft:'nwse-resize',resizebottomright:'nwse-resize',resizetopright:'nesw-resize',resizebottomleft:'nesw-resize',gesture:''},actionIsEnabled={drag:true,resize:true,gesture:true}, // because Webkit and Opera still use 'mousewheel' event type
	wheelEvent='onmousewheel' in document?'mousewheel':'wheel',eventTypes=['dragstart','dragmove','draginertiastart','dragend','dragenter','dragleave','dropactivate','dropdeactivate','dropmove','drop','resizestart','resizemove','resizeinertiastart','resizeend','gesturestart','gesturemove','gestureinertiastart','gestureend','down','move','up','cancel','tap','doubletap','hold'],globalEvents={}, // Opera Mobile must be handled differently
	isOperaMobile=navigator.appName == 'Opera' && supportsTouch && navigator.userAgent.match('Presto'), // scrolling doesn't change the result of getClientRects on iOS 7
	isIOS7=/iP(hone|od|ad)/.test(navigator.platform) && /OS 7[^\d]/.test(navigator.appVersion), // prefix matchesSelector
	prefixedMatchesSelector='matches' in Element.prototype?'matches':'webkitMatchesSelector' in Element.prototype?'webkitMatchesSelector':'mozMatchesSelector' in Element.prototype?'mozMatchesSelector':'oMatchesSelector' in Element.prototype?'oMatchesSelector':'msMatchesSelector', // will be polyfill function if browser is IE8
	ie8MatchesSelector, // native requestAnimationFrame or polyfill
	reqFrame=realWindow.requestAnimationFrame,cancelFrame=realWindow.cancelAnimationFrame, // Events wrapper
	events=(function(){var useAttachEvent='attachEvent' in window && !('addEventListener' in window),addEvent=useAttachEvent?'attachEvent':'addEventListener',removeEvent=useAttachEvent?'detachEvent':'removeEventListener',on=useAttachEvent?'on':'',elements=[],targets=[],attachedListeners=[];function add(element,type,listener,useCapture){var elementIndex=indexOf(elements,element),target=targets[elementIndex];if(!target){target = {events:{},typeCount:0};elementIndex = elements.push(element) - 1;targets.push(target);attachedListeners.push(useAttachEvent?{supplied:[],wrapped:[],useCount:[]}:null);}if(!target.events[type]){target.events[type] = [];target.typeCount++;}if(!contains(target.events[type],listener)){var ret;if(useAttachEvent){var listeners=attachedListeners[elementIndex],listenerIndex=indexOf(listeners.supplied,listener);var wrapped=listeners.wrapped[listenerIndex] || function(event){if(!event.immediatePropagationStopped){event.target = event.srcElement;event.currentTarget = element;event.preventDefault = event.preventDefault || preventDef;event.stopPropagation = event.stopPropagation || stopProp;event.stopImmediatePropagation = event.stopImmediatePropagation || stopImmProp;if(/mouse|click/.test(event.type)){event.pageX = event.clientX + getWindow(element).document.documentElement.scrollLeft;event.pageY = event.clientY + getWindow(element).document.documentElement.scrollTop;}listener(event);}};ret = element[addEvent](on + type,wrapped,Boolean(useCapture));if(listenerIndex === -1){listeners.supplied.push(listener);listeners.wrapped.push(wrapped);listeners.useCount.push(1);}else {listeners.useCount[listenerIndex]++;}}else {ret = element[addEvent](type,listener,useCapture || false);}target.events[type].push(listener);return ret;}}function remove(element,type,listener,useCapture){var i,elementIndex=indexOf(elements,element),target=targets[elementIndex],listeners,listenerIndex,wrapped=listener;if(!target || !target.events){return;}if(useAttachEvent){listeners = attachedListeners[elementIndex];listenerIndex = indexOf(listeners.supplied,listener);wrapped = listeners.wrapped[listenerIndex];}if(type === 'all'){for(type in target.events) {if(target.events.hasOwnProperty(type)){remove(element,type,'all');}}return;}if(target.events[type]){var len=target.events[type].length;if(listener === 'all'){for(i = 0;i < len;i++) {remove(element,type,target.events[type][i],Boolean(useCapture));}return;}else {for(i = 0;i < len;i++) {if(target.events[type][i] === listener){element[removeEvent](on + type,wrapped,useCapture || false);target.events[type].splice(i,1);if(useAttachEvent && listeners){listeners.useCount[listenerIndex]--;if(listeners.useCount[listenerIndex] === 0){listeners.supplied.splice(listenerIndex,1);listeners.wrapped.splice(listenerIndex,1);listeners.useCount.splice(listenerIndex,1);}}break;}}}if(target.events[type] && target.events[type].length === 0){target.events[type] = null;target.typeCount--;}}if(!target.typeCount){targets.splice(elementIndex,1);elements.splice(elementIndex,1);attachedListeners.splice(elementIndex,1);}}function preventDef(){this.returnValue = false;}function stopProp(){this.cancelBubble = true;}function stopImmProp(){this.cancelBubble = true;this.immediatePropagationStopped = true;}return {add:add,remove:remove,useAttachEvent:useAttachEvent,_elements:elements,_targets:targets,_attachedListeners:attachedListeners};})();function blank(){}function isElement(o){if(!o || typeof o !== 'object'){return false;}var _window=getWindow(o) || window;return (/object|function/.test(typeof _window.Element)?o instanceof _window.Element //DOM2
	:o.nodeType === 1 && typeof o.nodeName === "string");}function isWindow(thing){return thing === window || !!(thing && thing.Window) && thing instanceof thing.Window;}function isDocFrag(thing){return !!thing && thing instanceof DocumentFragment;}function isArray(thing){return isObject(thing) && typeof thing.length !== undefined && isFunction(thing.splice);}function isObject(thing){return !!thing && typeof thing === 'object';}function isFunction(thing){return typeof thing === 'function';}function isNumber(thing){return typeof thing === 'number';}function isBool(thing){return typeof thing === 'boolean';}function isString(thing){return typeof thing === 'string';}function trySelector(value){if(!isString(value)){return false;} // an exception will be raised if it is invalid
	document.querySelector(value);return true;}function extend(dest,source){for(var prop in source) {dest[prop] = source[prop];}return dest;}var prefixedPropREs={webkit:/(Movement[XY]|Radius[XY]|RotationAngle|Force)$/};function pointerExtend(dest,source){for(var prop in source) {var deprecated=false; // skip deprecated prefixed properties
	for(var vendor in prefixedPropREs) {if(prop.indexOf(vendor) === 0 && prefixedPropREs[vendor].test(prop)){deprecated = true;break;}}if(!deprecated){dest[prop] = source[prop];}}return dest;}function copyCoords(dest,src){dest.page = dest.page || {};dest.page.x = src.page.x;dest.page.y = src.page.y;dest.client = dest.client || {};dest.client.x = src.client.x;dest.client.y = src.client.y;dest.timeStamp = src.timeStamp;}function _setEventXY(targetObj,pointers,interaction){var pointer=pointers.length > 1?pointerAverage(pointers):pointers[0];_getPageXY(pointer,tmpXY,interaction);targetObj.page.x = tmpXY.x;targetObj.page.y = tmpXY.y;_getClientXY(pointer,tmpXY,interaction);targetObj.client.x = tmpXY.x;targetObj.client.y = tmpXY.y;targetObj.timeStamp = new Date().getTime();}function setEventDeltas(targetObj,prev,cur){targetObj.page.x = cur.page.x - prev.page.x;targetObj.page.y = cur.page.y - prev.page.y;targetObj.client.x = cur.client.x - prev.client.x;targetObj.client.y = cur.client.y - prev.client.y;targetObj.timeStamp = new Date().getTime() - prev.timeStamp; // set pointer velocity
	var dt=Math.max(targetObj.timeStamp / 1000,0.001);targetObj.page.speed = hypot(targetObj.page.x,targetObj.page.y) / dt;targetObj.page.vx = targetObj.page.x / dt;targetObj.page.vy = targetObj.page.y / dt;targetObj.client.speed = hypot(targetObj.client.x,targetObj.page.y) / dt;targetObj.client.vx = targetObj.client.x / dt;targetObj.client.vy = targetObj.client.y / dt;}function isNativePointer(pointer){return pointer instanceof window.Event || supportsTouch && window.Touch && pointer instanceof window.Touch;} // Get specified X/Y coords for mouse or event.touches[0]
	function getXY(type,pointer,xy){xy = xy || {};type = type || 'page';xy.x = pointer[type + 'X'];xy.y = pointer[type + 'Y'];return xy;}function _getPageXY(pointer,page){page = page || {}; // Opera Mobile handles the viewport and scrolling oddly
	if(isOperaMobile && isNativePointer(pointer)){getXY('screen',pointer,page);page.x += window.scrollX;page.y += window.scrollY;}else {getXY('page',pointer,page);}return page;}function _getClientXY(pointer,client){client = client || {};if(isOperaMobile && isNativePointer(pointer)){ // Opera Mobile handles the viewport and scrolling oddly
	getXY('screen',pointer,client);}else {getXY('client',pointer,client);}return client;}function getScrollXY(win){win = win || window;return {x:win.scrollX || win.document.documentElement.scrollLeft,y:win.scrollY || win.document.documentElement.scrollTop};}function getPointerId(pointer){return isNumber(pointer.pointerId)?pointer.pointerId:pointer.identifier;}function getActualElement(element){return element instanceof SVGElementInstance?element.correspondingUseElement:element;}function getWindow(node){if(isWindow(node)){return node;}var rootNode=node.ownerDocument || node;return rootNode.defaultView || rootNode.parentWindow || window;}function getElementClientRect(element){var clientRect=element instanceof SVGElement?element.getBoundingClientRect():element.getClientRects()[0];return clientRect && {left:clientRect.left,right:clientRect.right,top:clientRect.top,bottom:clientRect.bottom,width:clientRect.width || clientRect.right - clientRect.left,height:clientRect.height || clientRect.bottom - clientRect.top};}function getElementRect(element){var clientRect=getElementClientRect(element);if(!isIOS7 && clientRect){var scroll=getScrollXY(getWindow(element));clientRect.left += scroll.x;clientRect.right += scroll.x;clientRect.top += scroll.y;clientRect.bottom += scroll.y;}return clientRect;}function getTouchPair(event){var touches=[]; // array of touches is supplied
	if(isArray(event)){touches[0] = event[0];touches[1] = event[1];} // an event
	else {if(event.type === 'touchend'){if(event.touches.length === 1){touches[0] = event.touches[0];touches[1] = event.changedTouches[0];}else if(event.touches.length === 0){touches[0] = event.changedTouches[0];touches[1] = event.changedTouches[1];}}else {touches[0] = event.touches[0];touches[1] = event.touches[1];}}return touches;}function pointerAverage(pointers){var average={pageX:0,pageY:0,clientX:0,clientY:0,screenX:0,screenY:0};var prop;for(var i=0;i < pointers.length;i++) {for(prop in average) {average[prop] += pointers[i][prop];}}for(prop in average) {average[prop] /= pointers.length;}return average;}function touchBBox(event){if(!event.length && !(event.touches && event.touches.length > 1)){return;}var touches=getTouchPair(event),minX=Math.min(touches[0].pageX,touches[1].pageX),minY=Math.min(touches[0].pageY,touches[1].pageY),maxX=Math.max(touches[0].pageX,touches[1].pageX),maxY=Math.max(touches[0].pageY,touches[1].pageY);return {x:minX,y:minY,left:minX,top:minY,width:maxX - minX,height:maxY - minY};}function touchDistance(event,deltaSource){deltaSource = deltaSource || defaultOptions.deltaSource;var sourceX=deltaSource + 'X',sourceY=deltaSource + 'Y',touches=getTouchPair(event);var dx=touches[0][sourceX] - touches[1][sourceX],dy=touches[0][sourceY] - touches[1][sourceY];return hypot(dx,dy);}function touchAngle(event,prevAngle,deltaSource){deltaSource = deltaSource || defaultOptions.deltaSource;var sourceX=deltaSource + 'X',sourceY=deltaSource + 'Y',touches=getTouchPair(event),dx=touches[0][sourceX] - touches[1][sourceX],dy=touches[0][sourceY] - touches[1][sourceY],angle=180 * Math.atan(dy / dx) / Math.PI;if(isNumber(prevAngle)){var dr=angle - prevAngle,drClamped=dr % 360;if(drClamped > 315){angle -= 360 + angle / 360 | 0 * 360;}else if(drClamped > 135){angle -= 180 + angle / 360 | 0 * 360;}else if(drClamped < -315){angle += 360 + angle / 360 | 0 * 360;}else if(drClamped < -135){angle += 180 + angle / 360 | 0 * 360;}}return angle;}function getOriginXY(interactable,element){var origin=interactable?interactable.options.origin:defaultOptions.origin;if(origin === 'parent'){origin = parentElement(element);}else if(origin === 'self'){origin = interactable.getRect(element);}else if(trySelector(origin)){origin = closest(element,origin) || {x:0,y:0};}if(isFunction(origin)){origin = origin(interactable && element);}if(isElement(origin)){origin = getElementRect(origin);}origin.x = 'x' in origin?origin.x:origin.left;origin.y = 'y' in origin?origin.y:origin.top;return origin;} // http://stackoverflow.com/a/5634528/2280888
	function _getQBezierValue(t,p1,p2,p3){var iT=1 - t;return iT * iT * p1 + 2 * iT * t * p2 + t * t * p3;}function getQuadraticCurvePoint(startX,startY,cpX,cpY,endX,endY,position){return {x:_getQBezierValue(position,startX,cpX,endX),y:_getQBezierValue(position,startY,cpY,endY)};} // http://gizma.com/easing/
	function easeOutQuad(t,b,c,d){t /= d;return -c * t * (t - 2) + b;}function nodeContains(parent,child){while(child) {if(child === parent){return true;}child = child.parentNode;}return false;}function closest(child,selector){var parent=parentElement(child);while(isElement(parent)) {if(matchesSelector(parent,selector)){return parent;}parent = parentElement(parent);}return null;}function parentElement(node){var parent=node.parentNode;if(isDocFrag(parent)){ // skip past #shado-root fragments
	while((parent = parent.host) && isDocFrag(parent)) {}return parent;}return parent;}function inContext(interactable,element){return interactable._context === element.ownerDocument || nodeContains(interactable._context,element);}function testIgnore(interactable,interactableElement,element){var ignoreFrom=interactable.options.ignoreFrom;if(!ignoreFrom || !isElement(element)){return false;}if(isString(ignoreFrom)){return matchesUpTo(element,ignoreFrom,interactableElement);}else if(isElement(ignoreFrom)){return nodeContains(ignoreFrom,element);}return false;}function testAllow(interactable,interactableElement,element){var allowFrom=interactable.options.allowFrom;if(!allowFrom){return true;}if(!isElement(element)){return false;}if(isString(allowFrom)){return matchesUpTo(element,allowFrom,interactableElement);}else if(isElement(allowFrom)){return nodeContains(allowFrom,element);}return false;}function checkAxis(axis,interactable){if(!interactable){return false;}var thisAxis=interactable.options.drag.axis;return axis === 'xy' || thisAxis === 'xy' || thisAxis === axis;}function checkSnap(interactable,action){var options=interactable.options;if(/^resize/.test(action)){action = 'resize';}return options[action].snap && options[action].snap.enabled;}function checkRestrict(interactable,action){var options=interactable.options;if(/^resize/.test(action)){action = 'resize';}return options[action].restrict && options[action].restrict.enabled;}function checkAutoScroll(interactable,action){var options=interactable.options;if(/^resize/.test(action)){action = 'resize';}return options[action].autoScroll && options[action].autoScroll.enabled;}function withinInteractionLimit(interactable,element,action){var options=interactable.options,maxActions=options[action.name].max,maxPerElement=options[action.name].maxPerElement,activeInteractions=0,targetCount=0,targetElementCount=0;for(var i=0,len=interactions.length;i < len;i++) {var interaction=interactions[i],otherAction=interaction.prepared.name,active=interaction.interacting();if(!active){continue;}activeInteractions++;if(activeInteractions >= maxInteractions){return false;}if(interaction.target !== interactable){continue;}targetCount += otherAction === action.name | 0;if(targetCount >= maxActions){return false;}if(interaction.element === element){targetElementCount++;if(otherAction !== action.name || targetElementCount >= maxPerElement){return false;}}}return maxInteractions > 0;} // Test for the element that's "above" all other qualifiers
	function indexOfDeepestElement(elements){var dropzone,deepestZone=elements[0],index=deepestZone?0:-1,parent,deepestZoneParents=[],dropzoneParents=[],child,i,n;for(i = 1;i < elements.length;i++) {dropzone = elements[i]; // an element might belong to multiple selector dropzones
	if(!dropzone || dropzone === deepestZone){continue;}if(!deepestZone){deepestZone = dropzone;index = i;continue;} // check if the deepest or current are document.documentElement or document.rootElement
	// - if the current dropzone is, do nothing and continue
	if(dropzone.parentNode === dropzone.ownerDocument){continue;} // - if deepest is, update with the current dropzone and continue to next
	else if(deepestZone.parentNode === dropzone.ownerDocument){deepestZone = dropzone;index = i;continue;}if(!deepestZoneParents.length){parent = deepestZone;while(parent.parentNode && parent.parentNode !== parent.ownerDocument) {deepestZoneParents.unshift(parent);parent = parent.parentNode;}} // if this element is an svg element and the current deepest is
	// an HTMLElement
	if(deepestZone instanceof HTMLElement && dropzone instanceof SVGElement && !(dropzone instanceof SVGSVGElement)){if(dropzone === deepestZone.parentNode){continue;}parent = dropzone.ownerSVGElement;}else {parent = dropzone;}dropzoneParents = [];while(parent.parentNode !== parent.ownerDocument) {dropzoneParents.unshift(parent);parent = parent.parentNode;}n = 0; // get (position of last common ancestor) + 1
	while(dropzoneParents[n] && dropzoneParents[n] === deepestZoneParents[n]) {n++;}var parents=[dropzoneParents[n - 1],dropzoneParents[n],deepestZoneParents[n]];child = parents[0].lastChild;while(child) {if(child === parents[1]){deepestZone = dropzone;index = i;deepestZoneParents = [];break;}else if(child === parents[2]){break;}child = child.previousSibling;}}return index;}function Interaction(){this.target = null; // current interactable being interacted with
	this.element = null; // the target element of the interactable
	this.dropTarget = null; // the dropzone a drag target might be dropped into
	this.dropElement = null; // the element at the time of checking
	this.prevDropTarget = null; // the dropzone that was recently dragged away from
	this.prevDropElement = null; // the element at the time of checking
	this.prepared = { // action that's ready to be fired on next move event
	name:null,axis:null,edges:null};this.matches = []; // all selectors that are matched by target element
	this.matchElements = []; // corresponding elements
	this.inertiaStatus = {active:false,smoothEnd:false,ending:false,startEvent:null,upCoords:{},xe:0,ye:0,sx:0,sy:0,t0:0,vx0:0,vys:0,duration:0,resumeDx:0,resumeDy:0,lambda_v0:0,one_ve_v0:0,i:null};if(isFunction(Function.prototype.bind)){this.boundInertiaFrame = this.inertiaFrame.bind(this);this.boundSmoothEndFrame = this.smoothEndFrame.bind(this);}else {var that=this;this.boundInertiaFrame = function(){return that.inertiaFrame();};this.boundSmoothEndFrame = function(){return that.smoothEndFrame();};}this.activeDrops = {dropzones:[], // the dropzones that are mentioned below
	elements:[], // elements of dropzones that accept the target draggable
	rects:[] // the rects of the elements mentioned above
	}; // keep track of added pointers
	this.pointers = [];this.pointerIds = [];this.downTargets = [];this.downTimes = [];this.holdTimers = []; // Previous native pointer move event coordinates
	this.prevCoords = {page:{x:0,y:0},client:{x:0,y:0},timeStamp:0}; // current native pointer move event coordinates
	this.curCoords = {page:{x:0,y:0},client:{x:0,y:0},timeStamp:0}; // Starting InteractEvent pointer coordinates
	this.startCoords = {page:{x:0,y:0},client:{x:0,y:0},timeStamp:0}; // Change in coordinates and time of the pointer
	this.pointerDelta = {page:{x:0,y:0,vx:0,vy:0,speed:0},client:{x:0,y:0,vx:0,vy:0,speed:0},timeStamp:0};this.downEvent = null; // pointerdown/mousedown/touchstart event
	this.downPointer = {};this._eventTarget = null;this._curEventTarget = null;this.prevEvent = null; // previous action event
	this.tapTime = 0; // time of the most recent tap event
	this.prevTap = null;this.startOffset = {left:0,right:0,top:0,bottom:0};this.restrictOffset = {left:0,right:0,top:0,bottom:0};this.snapOffsets = [];this.gesture = {start:{x:0,y:0},startDistance:0, // distance between two touches of touchStart
	prevDistance:0,distance:0,scale:1, // gesture.distance / gesture.startDistance
	startAngle:0, // angle of line joining two touches
	prevAngle:0 // angle of the previous gesture event
	};this.snapStatus = {x:0,y:0,dx:0,dy:0,realX:0,realY:0,snappedX:0,snappedY:0,targets:[],locked:false,changed:false};this.restrictStatus = {dx:0,dy:0,restrictedX:0,restrictedY:0,snap:null,restricted:false,changed:false};this.restrictStatus.snap = this.snapStatus;this.pointerIsDown = false;this.pointerWasMoved = false;this.gesturing = false;this.dragging = false;this.resizing = false;this.resizeAxes = 'xy';this.mouse = false;interactions.push(this);}Interaction.prototype = {getPageXY:function getPageXY(pointer,xy){return _getPageXY(pointer,xy,this);},getClientXY:function getClientXY(pointer,xy){return _getClientXY(pointer,xy,this);},setEventXY:function setEventXY(target,ptr){return _setEventXY(target,ptr,this);},pointerOver:function pointerOver(pointer,event,eventTarget){if(this.prepared.name || !this.mouse){return;}var curMatches=[],curMatchElements=[],prevTargetElement=this.element;this.addPointer(pointer);if(this.target && (testIgnore(this.target,this.element,eventTarget) || !testAllow(this.target,this.element,eventTarget))){ // if the eventTarget should be ignored or shouldn't be allowed
	// clear the previous target
	this.target = null;this.element = null;this.matches = [];this.matchElements = [];}var elementInteractable=interactables.get(eventTarget),elementAction=elementInteractable && !testIgnore(elementInteractable,eventTarget,eventTarget) && testAllow(elementInteractable,eventTarget,eventTarget) && validateAction(elementInteractable.getAction(pointer,event,this,eventTarget),elementInteractable);if(elementAction && !withinInteractionLimit(elementInteractable,eventTarget,elementAction)){elementAction = null;}function pushCurMatches(interactable,selector){if(interactable && inContext(interactable,eventTarget) && !testIgnore(interactable,eventTarget,eventTarget) && testAllow(interactable,eventTarget,eventTarget) && matchesSelector(eventTarget,selector)){curMatches.push(interactable);curMatchElements.push(eventTarget);}}if(elementAction){this.target = elementInteractable;this.element = eventTarget;this.matches = [];this.matchElements = [];}else {interactables.forEachSelector(pushCurMatches);if(this.validateSelector(pointer,event,curMatches,curMatchElements)){this.matches = curMatches;this.matchElements = curMatchElements;this.pointerHover(pointer,event,this.matches,this.matchElements);events.add(eventTarget,supportsPointerEvent?pEventTypes.move:'mousemove',listeners.pointerHover);}else if(this.target){if(nodeContains(prevTargetElement,eventTarget)){this.pointerHover(pointer,event,this.matches,this.matchElements);events.add(this.element,supportsPointerEvent?pEventTypes.move:'mousemove',listeners.pointerHover);}else {this.target = null;this.element = null;this.matches = [];this.matchElements = [];}}}}, // Check what action would be performed on pointerMove target if a mouse
	// button were pressed and change the cursor accordingly
	pointerHover:function pointerHover(pointer,event,eventTarget,curEventTarget,matches,matchElements){var target=this.target;if(!this.prepared.name && this.mouse){var action; // update pointer coords for defaultActionChecker to use
	this.setEventXY(this.curCoords,[pointer]);if(matches){action = this.validateSelector(pointer,event,matches,matchElements);}else if(target){action = validateAction(target.getAction(this.pointers[0],event,this,this.element),this.target);}if(target && target.options.styleCursor){if(action){target._doc.documentElement.style.cursor = getActionCursor(action);}else {target._doc.documentElement.style.cursor = '';}}}else if(this.prepared.name){this.checkAndPreventDefault(event,target,this.element);}},pointerOut:function pointerOut(pointer,event,eventTarget){if(this.prepared.name){return;} // Remove temporary event listeners for selector Interactables
	if(!interactables.get(eventTarget)){events.remove(eventTarget,supportsPointerEvent?pEventTypes.move:'mousemove',listeners.pointerHover);}if(this.target && this.target.options.styleCursor && !this.interacting()){this.target._doc.documentElement.style.cursor = '';}},selectorDown:function selectorDown(pointer,event,eventTarget,curEventTarget){var that=this, // copy event to be used in timeout for IE8
	eventCopy=events.useAttachEvent?extend({},event):event,element=eventTarget,pointerIndex=this.addPointer(pointer),action;this.holdTimers[pointerIndex] = setTimeout(function(){that.pointerHold(events.useAttachEvent?eventCopy:pointer,eventCopy,eventTarget,curEventTarget);},defaultOptions._holdDuration);this.pointerIsDown = true; // Check if the down event hits the current inertia target
	if(this.inertiaStatus.active && this.target.selector){ // climb up the DOM tree from the event target
	while(isElement(element)) { // if this element is the current inertia target element
	if(element === this.element // and the prospective action is the same as the ongoing one
	 && validateAction(this.target.getAction(pointer,event,this,this.element),this.target).name === this.prepared.name){ // stop inertia so that the next move will be a normal one
	cancelFrame(this.inertiaStatus.i);this.inertiaStatus.active = false;this.collectEventTargets(pointer,event,eventTarget,'down');return;}element = parentElement(element);}} // do nothing if interacting
	if(this.interacting()){this.collectEventTargets(pointer,event,eventTarget,'down');return;}function pushMatches(interactable,selector,context){var elements=ie8MatchesSelector?context.querySelectorAll(selector):undefined;if(inContext(interactable,element) && !testIgnore(interactable,element,eventTarget) && testAllow(interactable,element,eventTarget) && matchesSelector(element,selector,elements)){that.matches.push(interactable);that.matchElements.push(element);}} // update pointer coords for defaultActionChecker to use
	this.setEventXY(this.curCoords,[pointer]);this.downEvent = event;while(isElement(element) && !action) {this.matches = [];this.matchElements = [];interactables.forEachSelector(pushMatches);action = this.validateSelector(pointer,event,this.matches,this.matchElements);element = parentElement(element);}if(action){this.prepared.name = action.name;this.prepared.axis = action.axis;this.prepared.edges = action.edges;this.collectEventTargets(pointer,event,eventTarget,'down');return this.pointerDown(pointer,event,eventTarget,curEventTarget,action);}else { // do these now since pointerDown isn't being called from here
	this.downTimes[pointerIndex] = new Date().getTime();this.downTargets[pointerIndex] = eventTarget;pointerExtend(this.downPointer,pointer);copyCoords(this.prevCoords,this.curCoords);this.pointerWasMoved = false;}this.collectEventTargets(pointer,event,eventTarget,'down');}, // Determine action to be performed on next pointerMove and add appropriate
	// style and event Listeners
	pointerDown:function pointerDown(pointer,event,eventTarget,curEventTarget,forceAction){if(!forceAction && !this.inertiaStatus.active && this.pointerWasMoved && this.prepared.name){this.checkAndPreventDefault(event,this.target,this.element);return;}this.pointerIsDown = true;this.downEvent = event;var pointerIndex=this.addPointer(pointer),action; // If it is the second touch of a multi-touch gesture, keep the
	// target the same and get a new action if a target was set by the
	// first touch
	if(this.pointerIds.length > 1 && this.target._element === this.element){var newAction=validateAction(forceAction || this.target.getAction(pointer,event,this,this.element),this.target);if(withinInteractionLimit(this.target,this.element,newAction)){action = newAction;}this.prepared.name = null;} // Otherwise, set the target if there is no action prepared
	else if(!this.prepared.name){var interactable=interactables.get(curEventTarget);if(interactable && !testIgnore(interactable,curEventTarget,eventTarget) && testAllow(interactable,curEventTarget,eventTarget) && (action = validateAction(forceAction || interactable.getAction(pointer,event,this,curEventTarget),interactable,eventTarget)) && withinInteractionLimit(interactable,curEventTarget,action)){this.target = interactable;this.element = curEventTarget;}}var target=this.target,options=target && target.options;if(target && (forceAction || !this.prepared.name)){action = action || validateAction(forceAction || target.getAction(pointer,event,this,curEventTarget),target,this.element);this.setEventXY(this.startCoords,this.pointers);if(!action){return;}if(options.styleCursor){target._doc.documentElement.style.cursor = getActionCursor(action);}this.resizeAxes = action.name === 'resize'?action.axis:null;if(action === 'gesture' && this.pointerIds.length < 2){action = null;}this.prepared.name = action.name;this.prepared.axis = action.axis;this.prepared.edges = action.edges;this.snapStatus.snappedX = this.snapStatus.snappedY = this.restrictStatus.restrictedX = this.restrictStatus.restrictedY = NaN;this.downTimes[pointerIndex] = new Date().getTime();this.downTargets[pointerIndex] = eventTarget;pointerExtend(this.downPointer,pointer);copyCoords(this.prevCoords,this.startCoords);this.pointerWasMoved = false;this.checkAndPreventDefault(event,target,this.element);} // if inertia is active try to resume action
	else if(this.inertiaStatus.active && curEventTarget === this.element && validateAction(target.getAction(pointer,event,this,this.element),target).name === this.prepared.name){cancelFrame(this.inertiaStatus.i);this.inertiaStatus.active = false;this.checkAndPreventDefault(event,target,this.element);}},setModifications:function setModifications(coords,preEnd){var target=this.target,shouldMove=true,shouldSnap=checkSnap(target,this.prepared.name) && (!target.options[this.prepared.name].snap.endOnly || preEnd),shouldRestrict=checkRestrict(target,this.prepared.name) && (!target.options[this.prepared.name].restrict.endOnly || preEnd);if(shouldSnap){this.setSnapping(coords);}else {this.snapStatus.locked = false;}if(shouldRestrict){this.setRestriction(coords);}else {this.restrictStatus.restricted = false;}if(shouldSnap && this.snapStatus.locked && !this.snapStatus.changed){shouldMove = shouldRestrict && this.restrictStatus.restricted && this.restrictStatus.changed;}else if(shouldRestrict && this.restrictStatus.restricted && !this.restrictStatus.changed){shouldMove = false;}return shouldMove;},setStartOffsets:function setStartOffsets(action,interactable,element){var rect=interactable.getRect(element),origin=getOriginXY(interactable,element),snap=interactable.options[this.prepared.name].snap,restrict=interactable.options[this.prepared.name].restrict,width,height;if(rect){this.startOffset.left = this.startCoords.page.x - rect.left;this.startOffset.top = this.startCoords.page.y - rect.top;this.startOffset.right = rect.right - this.startCoords.page.x;this.startOffset.bottom = rect.bottom - this.startCoords.page.y;if('width' in rect){width = rect.width;}else {width = rect.right - rect.left;}if('height' in rect){height = rect.height;}else {height = rect.bottom - rect.top;}}else {this.startOffset.left = this.startOffset.top = this.startOffset.right = this.startOffset.bottom = 0;}this.snapOffsets.splice(0);var snapOffset=snap && snap.offset === 'startCoords'?{x:this.startCoords.page.x - origin.x,y:this.startCoords.page.y - origin.y}:snap && snap.offset || {x:0,y:0};if(rect && snap && snap.relativePoints && snap.relativePoints.length){for(var i=0;i < snap.relativePoints.length;i++) {this.snapOffsets.push({x:this.startOffset.left - width * snap.relativePoints[i].x + snapOffset.x,y:this.startOffset.top - height * snap.relativePoints[i].y + snapOffset.y});}}else {this.snapOffsets.push(snapOffset);}if(rect && restrict.elementRect){this.restrictOffset.left = this.startOffset.left - width * restrict.elementRect.left;this.restrictOffset.top = this.startOffset.top - height * restrict.elementRect.top;this.restrictOffset.right = this.startOffset.right - width * (1 - restrict.elementRect.right);this.restrictOffset.bottom = this.startOffset.bottom - height * (1 - restrict.elementRect.bottom);}else {this.restrictOffset.left = this.restrictOffset.top = this.restrictOffset.right = this.restrictOffset.bottom = 0;}}, /*\
	         * Interaction.start
	         [ method ]
	         *
	         * Start an action with the given Interactable and Element as tartgets. The
	         * action must be enabled for the target Interactable and an appropriate number
	         * of pointers must be held down – 1 for drag/resize, 2 for gesture.
	         *
	         * Use it with `interactable.<action>able({ manualStart: false })` to always
	         * [start actions manually](https://github.com/taye/interact.js/issues/114)
	         *
	         - action       (object)  The action to be performed - drag, resize, etc.
	         - interactable (Interactable) The Interactable to target
	         - element      (Element) The DOM Element to target
	         = (object) interact
	         **
	         | interact(target)
	         |   .draggable({
	         |     // disable the default drag start by down->move
	         |     manualStart: true
	         |   })
	         |   // start dragging after the user holds the pointer down
	         |   .on('hold', function (event) {
	         |     var interaction = event.interaction;
	         |
	         |     if (!interaction.interacting()) {
	         |       interaction.start({ name: 'drag' },
	         |                         event.interactable,
	         |                         event.currentTarget);
	         |     }
	         | });
	        \*/start:function start(action,interactable,element){if(this.interacting() || !this.pointerIsDown || this.pointerIds.length < (action.name === 'gesture'?2:1)){return;} // if this interaction had been removed after stopping
	// add it back
	if(indexOf(interactions,this) === -1){interactions.push(this);} // set the startCoords if there was no prepared action
	if(!this.prepared.name){this.setEventXY(this.startCoords,this.pointers);}this.prepared.name = action.name;this.prepared.axis = action.axis;this.prepared.edges = action.edges;this.target = interactable;this.element = element;this.setStartOffsets(action.name,interactable,element);this.setModifications(this.startCoords.page);this.prevEvent = this[this.prepared.name + 'Start'](this.downEvent);},pointerMove:function pointerMove(pointer,event,eventTarget,curEventTarget,preEnd){if(this.inertiaStatus.active){var pageUp=this.inertiaStatus.upCoords.page;var clientUp=this.inertiaStatus.upCoords.client;var inertiaPosition={pageX:pageUp.x + this.inertiaStatus.sx,pageY:pageUp.y + this.inertiaStatus.sy,clientX:clientUp.x + this.inertiaStatus.sx,clientY:clientUp.y + this.inertiaStatus.sy};this.setEventXY(this.curCoords,[inertiaPosition]);}else {this.recordPointer(pointer);this.setEventXY(this.curCoords,this.pointers);}var duplicateMove=this.curCoords.page.x === this.prevCoords.page.x && this.curCoords.page.y === this.prevCoords.page.y && this.curCoords.client.x === this.prevCoords.client.x && this.curCoords.client.y === this.prevCoords.client.y;var dx,dy,pointerIndex=this.mouse?0:indexOf(this.pointerIds,getPointerId(pointer)); // register movement greater than pointerMoveTolerance
	if(this.pointerIsDown && !this.pointerWasMoved){dx = this.curCoords.client.x - this.startCoords.client.x;dy = this.curCoords.client.y - this.startCoords.client.y;this.pointerWasMoved = hypot(dx,dy) > pointerMoveTolerance;}if(!duplicateMove && (!this.pointerIsDown || this.pointerWasMoved)){if(this.pointerIsDown){clearTimeout(this.holdTimers[pointerIndex]);}this.collectEventTargets(pointer,event,eventTarget,'move');}if(!this.pointerIsDown){return;}if(duplicateMove && this.pointerWasMoved && !preEnd){this.checkAndPreventDefault(event,this.target,this.element);return;} // set pointer coordinate, time changes and speeds
	setEventDeltas(this.pointerDelta,this.prevCoords,this.curCoords);if(!this.prepared.name){return;}if(this.pointerWasMoved // ignore movement while inertia is active
	 && (!this.inertiaStatus.active || pointer instanceof InteractEvent && /inertiastart/.test(pointer.type))){ // if just starting an action, calculate the pointer speed now
	if(!this.interacting()){setEventDeltas(this.pointerDelta,this.prevCoords,this.curCoords); // check if a drag is in the correct axis
	if(this.prepared.name === 'drag'){var absX=Math.abs(dx),absY=Math.abs(dy),targetAxis=this.target.options.drag.axis,axis=absX > absY?'x':absX < absY?'y':'xy'; // if the movement isn't in the axis of the interactable
	if(axis !== 'xy' && targetAxis !== 'xy' && targetAxis !== axis){ // cancel the prepared action
	this.prepared.name = null; // then try to get a drag from another ineractable
	var element=eventTarget; // check element interactables
	while(isElement(element)) {var elementInteractable=interactables.get(element);if(elementInteractable && elementInteractable !== this.target && !elementInteractable.options.drag.manualStart && elementInteractable.getAction(this.downPointer,this.downEvent,this,element).name === 'drag' && checkAxis(axis,elementInteractable)){this.prepared.name = 'drag';this.target = elementInteractable;this.element = element;break;}element = parentElement(element);} // if there's no drag from element interactables,
	// check the selector interactables
	if(!this.prepared.name){var thisInteraction=this;var getDraggable=function getDraggable(interactable,selector,context){var elements=ie8MatchesSelector?context.querySelectorAll(selector):undefined;if(interactable === thisInteraction.target){return;}if(inContext(interactable,eventTarget) && !interactable.options.drag.manualStart && !testIgnore(interactable,element,eventTarget) && testAllow(interactable,element,eventTarget) && matchesSelector(element,selector,elements) && interactable.getAction(thisInteraction.downPointer,thisInteraction.downEvent,thisInteraction,element).name === 'drag' && checkAxis(axis,interactable) && withinInteractionLimit(interactable,element,'drag')){return interactable;}};element = eventTarget;while(isElement(element)) {var selectorInteractable=interactables.forEachSelector(getDraggable);if(selectorInteractable){this.prepared.name = 'drag';this.target = selectorInteractable;this.element = element;break;}element = parentElement(element);}}}}}var starting=!!this.prepared.name && !this.interacting();if(starting && (this.target.options[this.prepared.name].manualStart || !withinInteractionLimit(this.target,this.element,this.prepared))){this.stop(event);return;}if(this.prepared.name && this.target){if(starting){this.start(this.prepared,this.target,this.element);}var shouldMove=this.setModifications(this.curCoords.page,preEnd); // move if snapping or restriction doesn't prevent it
	if(shouldMove || starting){this.prevEvent = this[this.prepared.name + 'Move'](event);}this.checkAndPreventDefault(event,this.target,this.element);}}copyCoords(this.prevCoords,this.curCoords);if(this.dragging || this.resizing){this.autoScrollMove(pointer);}},dragStart:function dragStart(event){var dragEvent=new InteractEvent(this,event,'drag','start',this.element);this.dragging = true;this.target.fire(dragEvent); // reset active dropzones
	this.activeDrops.dropzones = [];this.activeDrops.elements = [];this.activeDrops.rects = [];if(!this.dynamicDrop){this.setActiveDrops(this.element);}var dropEvents=this.getDropEvents(event,dragEvent);if(dropEvents.activate){this.fireActiveDrops(dropEvents.activate);}return dragEvent;},dragMove:function dragMove(event){var target=this.target,dragEvent=new InteractEvent(this,event,'drag','move',this.element),draggableElement=this.element,drop=this.getDrop(dragEvent,event,draggableElement);this.dropTarget = drop.dropzone;this.dropElement = drop.element;var dropEvents=this.getDropEvents(event,dragEvent);target.fire(dragEvent);if(dropEvents.leave){this.prevDropTarget.fire(dropEvents.leave);}if(dropEvents.enter){this.dropTarget.fire(dropEvents.enter);}if(dropEvents.move){this.dropTarget.fire(dropEvents.move);}this.prevDropTarget = this.dropTarget;this.prevDropElement = this.dropElement;return dragEvent;},resizeStart:function resizeStart(event){var resizeEvent=new InteractEvent(this,event,'resize','start',this.element);if(this.prepared.edges){var startRect=this.target.getRect(this.element); /*
	                 * When using the `resizable.square` or `resizable.preserveAspectRatio` options, resizing from one edge
	                 * will affect another. E.g. with `resizable.square`, resizing to make the right edge larger will make
	                 * the bottom edge larger by the same amount. We call these 'linked' edges. Any linked edges will depend
	                 * on the active edges and the edge being interacted with.
	                 */if(this.target.options.resize.square || this.target.options.resize.preserveAspectRatio){var linkedEdges=extend({},this.prepared.edges);linkedEdges.top = linkedEdges.top || linkedEdges.left && !linkedEdges.bottom;linkedEdges.left = linkedEdges.left || linkedEdges.top && !linkedEdges.right;linkedEdges.bottom = linkedEdges.bottom || linkedEdges.right && !linkedEdges.top;linkedEdges.right = linkedEdges.right || linkedEdges.bottom && !linkedEdges.left;this.prepared._linkedEdges = linkedEdges;}else {this.prepared._linkedEdges = null;} // if using `resizable.preserveAspectRatio` option, record aspect ratio at the start of the resize
	if(this.target.options.resize.preserveAspectRatio){this.resizeStartAspectRatio = startRect.width / startRect.height;}this.resizeRects = {start:startRect,current:extend({},startRect),restricted:extend({},startRect),previous:extend({},startRect),delta:{left:0,right:0,width:0,top:0,bottom:0,height:0}};resizeEvent.rect = this.resizeRects.restricted;resizeEvent.deltaRect = this.resizeRects.delta;}this.target.fire(resizeEvent);this.resizing = true;return resizeEvent;},resizeMove:function resizeMove(event){var resizeEvent=new InteractEvent(this,event,'resize','move',this.element);var edges=this.prepared.edges,invert=this.target.options.resize.invert,invertible=invert === 'reposition' || invert === 'negate';if(edges){var dx=resizeEvent.dx,dy=resizeEvent.dy,start=this.resizeRects.start,current=this.resizeRects.current,restricted=this.resizeRects.restricted,delta=this.resizeRects.delta,previous=extend(this.resizeRects.previous,restricted),originalEdges=edges; // `resize.preserveAspectRatio` takes precedence over `resize.square`
	if(this.target.options.resize.preserveAspectRatio){var resizeStartAspectRatio=this.resizeStartAspectRatio;edges = this.prepared._linkedEdges;if(originalEdges.left && originalEdges.bottom || originalEdges.right && originalEdges.top){dy = -dx / resizeStartAspectRatio;}else if(originalEdges.left || originalEdges.right){dy = dx / resizeStartAspectRatio;}else if(originalEdges.top || originalEdges.bottom){dx = dy * resizeStartAspectRatio;}}else if(this.target.options.resize.square){edges = this.prepared._linkedEdges;if(originalEdges.left && originalEdges.bottom || originalEdges.right && originalEdges.top){dy = -dx;}else if(originalEdges.left || originalEdges.right){dy = dx;}else if(originalEdges.top || originalEdges.bottom){dx = dy;}} // update the 'current' rect without modifications
	if(edges.top){current.top += dy;}if(edges.bottom){current.bottom += dy;}if(edges.left){current.left += dx;}if(edges.right){current.right += dx;}if(invertible){ // if invertible, copy the current rect
	extend(restricted,current);if(invert === 'reposition'){ // swap edge values if necessary to keep width/height positive
	var swap;if(restricted.top > restricted.bottom){swap = restricted.top;restricted.top = restricted.bottom;restricted.bottom = swap;}if(restricted.left > restricted.right){swap = restricted.left;restricted.left = restricted.right;restricted.right = swap;}}}else { // if not invertible, restrict to minimum of 0x0 rect
	restricted.top = Math.min(current.top,start.bottom);restricted.bottom = Math.max(current.bottom,start.top);restricted.left = Math.min(current.left,start.right);restricted.right = Math.max(current.right,start.left);}restricted.width = restricted.right - restricted.left;restricted.height = restricted.bottom - restricted.top;for(var edge in restricted) {delta[edge] = restricted[edge] - previous[edge];}resizeEvent.edges = this.prepared.edges;resizeEvent.rect = restricted;resizeEvent.deltaRect = delta;}this.target.fire(resizeEvent);return resizeEvent;},gestureStart:function gestureStart(event){var gestureEvent=new InteractEvent(this,event,'gesture','start',this.element);gestureEvent.ds = 0;this.gesture.startDistance = this.gesture.prevDistance = gestureEvent.distance;this.gesture.startAngle = this.gesture.prevAngle = gestureEvent.angle;this.gesture.scale = 1;this.gesturing = true;this.target.fire(gestureEvent);return gestureEvent;},gestureMove:function gestureMove(event){if(!this.pointerIds.length){return this.prevEvent;}var gestureEvent;gestureEvent = new InteractEvent(this,event,'gesture','move',this.element);gestureEvent.ds = gestureEvent.scale - this.gesture.scale;this.target.fire(gestureEvent);this.gesture.prevAngle = gestureEvent.angle;this.gesture.prevDistance = gestureEvent.distance;if(gestureEvent.scale !== Infinity && gestureEvent.scale !== null && gestureEvent.scale !== undefined && !isNaN(gestureEvent.scale)){this.gesture.scale = gestureEvent.scale;}return gestureEvent;},pointerHold:function pointerHold(pointer,event,eventTarget){this.collectEventTargets(pointer,event,eventTarget,'hold');},pointerUp:function pointerUp(pointer,event,eventTarget,curEventTarget){var pointerIndex=this.mouse?0:indexOf(this.pointerIds,getPointerId(pointer));clearTimeout(this.holdTimers[pointerIndex]);this.collectEventTargets(pointer,event,eventTarget,'up');this.collectEventTargets(pointer,event,eventTarget,'tap');this.pointerEnd(pointer,event,eventTarget,curEventTarget);this.removePointer(pointer);},pointerCancel:function pointerCancel(pointer,event,eventTarget,curEventTarget){var pointerIndex=this.mouse?0:indexOf(this.pointerIds,getPointerId(pointer));clearTimeout(this.holdTimers[pointerIndex]);this.collectEventTargets(pointer,event,eventTarget,'cancel');this.pointerEnd(pointer,event,eventTarget,curEventTarget);this.removePointer(pointer);}, // http://www.quirksmode.org/dom/events/click.html
	// >Events leading to dblclick
	//
	// IE8 doesn't fire down event before dblclick.
	// This workaround tries to fire a tap and doubletap after dblclick
	ie8Dblclick:function ie8Dblclick(pointer,event,eventTarget){if(this.prevTap && event.clientX === this.prevTap.clientX && event.clientY === this.prevTap.clientY && eventTarget === this.prevTap.target){this.downTargets[0] = eventTarget;this.downTimes[0] = new Date().getTime();this.collectEventTargets(pointer,event,eventTarget,'tap');}}, // End interact move events and stop auto-scroll unless inertia is enabled
	pointerEnd:function pointerEnd(pointer,event,eventTarget,curEventTarget){var endEvent,target=this.target,options=target && target.options,inertiaOptions=options && this.prepared.name && options[this.prepared.name].inertia,inertiaStatus=this.inertiaStatus;if(this.interacting()){if(inertiaStatus.active && !inertiaStatus.ending){return;}var pointerSpeed,now=new Date().getTime(),inertiaPossible=false,inertia=false,smoothEnd=false,endSnap=checkSnap(target,this.prepared.name) && options[this.prepared.name].snap.endOnly,endRestrict=checkRestrict(target,this.prepared.name) && options[this.prepared.name].restrict.endOnly,dx=0,dy=0,startEvent;if(this.dragging){if(options.drag.axis === 'x'){pointerSpeed = Math.abs(this.pointerDelta.client.vx);}else if(options.drag.axis === 'y'){pointerSpeed = Math.abs(this.pointerDelta.client.vy);}else  /*options.drag.axis === 'xy'*/{pointerSpeed = this.pointerDelta.client.speed;}}else {pointerSpeed = this.pointerDelta.client.speed;} // check if inertia should be started
	inertiaPossible = inertiaOptions && inertiaOptions.enabled && this.prepared.name !== 'gesture' && event !== inertiaStatus.startEvent;inertia = inertiaPossible && now - this.curCoords.timeStamp < 50 && pointerSpeed > inertiaOptions.minSpeed && pointerSpeed > inertiaOptions.endSpeed;if(inertiaPossible && !inertia && (endSnap || endRestrict)){var snapRestrict={};snapRestrict.snap = snapRestrict.restrict = snapRestrict;if(endSnap){this.setSnapping(this.curCoords.page,snapRestrict);if(snapRestrict.locked){dx += snapRestrict.dx;dy += snapRestrict.dy;}}if(endRestrict){this.setRestriction(this.curCoords.page,snapRestrict);if(snapRestrict.restricted){dx += snapRestrict.dx;dy += snapRestrict.dy;}}if(dx || dy){smoothEnd = true;}}if(inertia || smoothEnd){copyCoords(inertiaStatus.upCoords,this.curCoords);this.pointers[0] = inertiaStatus.startEvent = startEvent = new InteractEvent(this,event,this.prepared.name,'inertiastart',this.element);inertiaStatus.t0 = now;target.fire(inertiaStatus.startEvent);if(inertia){inertiaStatus.vx0 = this.pointerDelta.client.vx;inertiaStatus.vy0 = this.pointerDelta.client.vy;inertiaStatus.v0 = pointerSpeed;this.calcInertia(inertiaStatus);var page=extend({},this.curCoords.page),origin=getOriginXY(target,this.element),statusObject;page.x = page.x + inertiaStatus.xe - origin.x;page.y = page.y + inertiaStatus.ye - origin.y;statusObject = {useStatusXY:true,x:page.x,y:page.y,dx:0,dy:0,snap:null};statusObject.snap = statusObject;dx = dy = 0;if(endSnap){var snap=this.setSnapping(this.curCoords.page,statusObject);if(snap.locked){dx += snap.dx;dy += snap.dy;}}if(endRestrict){var restrict=this.setRestriction(this.curCoords.page,statusObject);if(restrict.restricted){dx += restrict.dx;dy += restrict.dy;}}inertiaStatus.modifiedXe += dx;inertiaStatus.modifiedYe += dy;inertiaStatus.i = reqFrame(this.boundInertiaFrame);}else {inertiaStatus.smoothEnd = true;inertiaStatus.xe = dx;inertiaStatus.ye = dy;inertiaStatus.sx = inertiaStatus.sy = 0;inertiaStatus.i = reqFrame(this.boundSmoothEndFrame);}inertiaStatus.active = true;return;}if(endSnap || endRestrict){ // fire a move event at the snapped coordinates
	this.pointerMove(pointer,event,eventTarget,curEventTarget,true);}}if(this.dragging){endEvent = new InteractEvent(this,event,'drag','end',this.element);var draggableElement=this.element,drop=this.getDrop(endEvent,event,draggableElement);this.dropTarget = drop.dropzone;this.dropElement = drop.element;var dropEvents=this.getDropEvents(event,endEvent);if(dropEvents.leave){this.prevDropTarget.fire(dropEvents.leave);}if(dropEvents.enter){this.dropTarget.fire(dropEvents.enter);}if(dropEvents.drop){this.dropTarget.fire(dropEvents.drop);}if(dropEvents.deactivate){this.fireActiveDrops(dropEvents.deactivate);}target.fire(endEvent);}else if(this.resizing){endEvent = new InteractEvent(this,event,'resize','end',this.element);target.fire(endEvent);}else if(this.gesturing){endEvent = new InteractEvent(this,event,'gesture','end',this.element);target.fire(endEvent);}this.stop(event);},collectDrops:function collectDrops(element){var drops=[],elements=[],i;element = element || this.element; // collect all dropzones and their elements which qualify for a drop
	for(i = 0;i < interactables.length;i++) {if(!interactables[i].options.drop.enabled){continue;}var current=interactables[i],accept=current.options.drop.accept; // test the draggable element against the dropzone's accept setting
	if(isElement(accept) && accept !== element || isString(accept) && !matchesSelector(element,accept)){continue;} // query for new elements if necessary
	var dropElements=current.selector?current._context.querySelectorAll(current.selector):[current._element];for(var j=0,len=dropElements.length;j < len;j++) {var currentElement=dropElements[j];if(currentElement === element){continue;}drops.push(current);elements.push(currentElement);}}return {dropzones:drops,elements:elements};},fireActiveDrops:function fireActiveDrops(event){var i,current,currentElement,prevElement; // loop through all active dropzones and trigger event
	for(i = 0;i < this.activeDrops.dropzones.length;i++) {current = this.activeDrops.dropzones[i];currentElement = this.activeDrops.elements[i]; // prevent trigger of duplicate events on same element
	if(currentElement !== prevElement){ // set current element as event target
	event.target = currentElement;current.fire(event);}prevElement = currentElement;}}, // Collect a new set of possible drops and save them in activeDrops.
	// setActiveDrops should always be called when a drag has just started or a
	// drag event happens while dynamicDrop is true
	setActiveDrops:function setActiveDrops(dragElement){ // get dropzones and their elements that could receive the draggable
	var possibleDrops=this.collectDrops(dragElement,true);this.activeDrops.dropzones = possibleDrops.dropzones;this.activeDrops.elements = possibleDrops.elements;this.activeDrops.rects = [];for(var i=0;i < this.activeDrops.dropzones.length;i++) {this.activeDrops.rects[i] = this.activeDrops.dropzones[i].getRect(this.activeDrops.elements[i]);}},getDrop:function getDrop(dragEvent,event,dragElement){var validDrops=[];if(dynamicDrop){this.setActiveDrops(dragElement);} // collect all dropzones and their elements which qualify for a drop
	for(var j=0;j < this.activeDrops.dropzones.length;j++) {var current=this.activeDrops.dropzones[j],currentElement=this.activeDrops.elements[j],rect=this.activeDrops.rects[j];validDrops.push(current.dropCheck(dragEvent,event,this.target,dragElement,currentElement,rect)?currentElement:null);} // get the most appropriate dropzone based on DOM depth and order
	var dropIndex=indexOfDeepestElement(validDrops),dropzone=this.activeDrops.dropzones[dropIndex] || null,element=this.activeDrops.elements[dropIndex] || null;return {dropzone:dropzone,element:element};},getDropEvents:function getDropEvents(pointerEvent,dragEvent){var dropEvents={enter:null,leave:null,activate:null,deactivate:null,move:null,drop:null};if(this.dropElement !== this.prevDropElement){ // if there was a prevDropTarget, create a dragleave event
	if(this.prevDropTarget){dropEvents.leave = {target:this.prevDropElement,dropzone:this.prevDropTarget,relatedTarget:dragEvent.target,draggable:dragEvent.interactable,dragEvent:dragEvent,interaction:this,timeStamp:dragEvent.timeStamp,type:'dragleave'};dragEvent.dragLeave = this.prevDropElement;dragEvent.prevDropzone = this.prevDropTarget;} // if the dropTarget is not null, create a dragenter event
	if(this.dropTarget){dropEvents.enter = {target:this.dropElement,dropzone:this.dropTarget,relatedTarget:dragEvent.target,draggable:dragEvent.interactable,dragEvent:dragEvent,interaction:this,timeStamp:dragEvent.timeStamp,type:'dragenter'};dragEvent.dragEnter = this.dropElement;dragEvent.dropzone = this.dropTarget;}}if(dragEvent.type === 'dragend' && this.dropTarget){dropEvents.drop = {target:this.dropElement,dropzone:this.dropTarget,relatedTarget:dragEvent.target,draggable:dragEvent.interactable,dragEvent:dragEvent,interaction:this,timeStamp:dragEvent.timeStamp,type:'drop'};dragEvent.dropzone = this.dropTarget;}if(dragEvent.type === 'dragstart'){dropEvents.activate = {target:null,dropzone:null,relatedTarget:dragEvent.target,draggable:dragEvent.interactable,dragEvent:dragEvent,interaction:this,timeStamp:dragEvent.timeStamp,type:'dropactivate'};}if(dragEvent.type === 'dragend'){dropEvents.deactivate = {target:null,dropzone:null,relatedTarget:dragEvent.target,draggable:dragEvent.interactable,dragEvent:dragEvent,interaction:this,timeStamp:dragEvent.timeStamp,type:'dropdeactivate'};}if(dragEvent.type === 'dragmove' && this.dropTarget){dropEvents.move = {target:this.dropElement,dropzone:this.dropTarget,relatedTarget:dragEvent.target,draggable:dragEvent.interactable,dragEvent:dragEvent,interaction:this,dragmove:dragEvent,timeStamp:dragEvent.timeStamp,type:'dropmove'};dragEvent.dropzone = this.dropTarget;}return dropEvents;},currentAction:function currentAction(){return this.dragging && 'drag' || this.resizing && 'resize' || this.gesturing && 'gesture' || null;},interacting:function interacting(){return this.dragging || this.resizing || this.gesturing;},clearTargets:function clearTargets(){this.target = this.element = null;this.dropTarget = this.dropElement = this.prevDropTarget = this.prevDropElement = null;},stop:function stop(event){if(this.interacting()){autoScroll.stop();this.matches = [];this.matchElements = [];var target=this.target;if(target.options.styleCursor){target._doc.documentElement.style.cursor = '';} // prevent Default only if were previously interacting
	if(event && isFunction(event.preventDefault)){this.checkAndPreventDefault(event,target,this.element);}if(this.dragging){this.activeDrops.dropzones = this.activeDrops.elements = this.activeDrops.rects = null;}}this.clearTargets();this.pointerIsDown = this.snapStatus.locked = this.dragging = this.resizing = this.gesturing = false;this.prepared.name = this.prevEvent = null;this.inertiaStatus.resumeDx = this.inertiaStatus.resumeDy = 0; // remove pointers if their ID isn't in this.pointerIds
	for(var i=0;i < this.pointers.length;i++) {if(indexOf(this.pointerIds,getPointerId(this.pointers[i])) === -1){this.pointers.splice(i,1);}}},inertiaFrame:function inertiaFrame(){var inertiaStatus=this.inertiaStatus,options=this.target.options[this.prepared.name].inertia,lambda=options.resistance,t=new Date().getTime() / 1000 - inertiaStatus.t0;if(t < inertiaStatus.te){var progress=1 - (Math.exp(-lambda * t) - inertiaStatus.lambda_v0) / inertiaStatus.one_ve_v0;if(inertiaStatus.modifiedXe === inertiaStatus.xe && inertiaStatus.modifiedYe === inertiaStatus.ye){inertiaStatus.sx = inertiaStatus.xe * progress;inertiaStatus.sy = inertiaStatus.ye * progress;}else {var quadPoint=getQuadraticCurvePoint(0,0,inertiaStatus.xe,inertiaStatus.ye,inertiaStatus.modifiedXe,inertiaStatus.modifiedYe,progress);inertiaStatus.sx = quadPoint.x;inertiaStatus.sy = quadPoint.y;}this.pointerMove(inertiaStatus.startEvent,inertiaStatus.startEvent);inertiaStatus.i = reqFrame(this.boundInertiaFrame);}else {inertiaStatus.ending = true;inertiaStatus.sx = inertiaStatus.modifiedXe;inertiaStatus.sy = inertiaStatus.modifiedYe;this.pointerMove(inertiaStatus.startEvent,inertiaStatus.startEvent);this.pointerEnd(inertiaStatus.startEvent,inertiaStatus.startEvent);inertiaStatus.active = inertiaStatus.ending = false;}},smoothEndFrame:function smoothEndFrame(){var inertiaStatus=this.inertiaStatus,t=new Date().getTime() - inertiaStatus.t0,duration=this.target.options[this.prepared.name].inertia.smoothEndDuration;if(t < duration){inertiaStatus.sx = easeOutQuad(t,0,inertiaStatus.xe,duration);inertiaStatus.sy = easeOutQuad(t,0,inertiaStatus.ye,duration);this.pointerMove(inertiaStatus.startEvent,inertiaStatus.startEvent);inertiaStatus.i = reqFrame(this.boundSmoothEndFrame);}else {inertiaStatus.ending = true;inertiaStatus.sx = inertiaStatus.xe;inertiaStatus.sy = inertiaStatus.ye;this.pointerMove(inertiaStatus.startEvent,inertiaStatus.startEvent);this.pointerEnd(inertiaStatus.startEvent,inertiaStatus.startEvent);inertiaStatus.smoothEnd = inertiaStatus.active = inertiaStatus.ending = false;}},addPointer:function addPointer(pointer){var id=getPointerId(pointer),index=this.mouse?0:indexOf(this.pointerIds,id);if(index === -1){index = this.pointerIds.length;}this.pointerIds[index] = id;this.pointers[index] = pointer;return index;},removePointer:function removePointer(pointer){var id=getPointerId(pointer),index=this.mouse?0:indexOf(this.pointerIds,id);if(index === -1){return;}this.pointers.splice(index,1);this.pointerIds.splice(index,1);this.downTargets.splice(index,1);this.downTimes.splice(index,1);this.holdTimers.splice(index,1);},recordPointer:function recordPointer(pointer){var index=this.mouse?0:indexOf(this.pointerIds,getPointerId(pointer));if(index === -1){return;}this.pointers[index] = pointer;},collectEventTargets:function collectEventTargets(pointer,event,eventTarget,eventType){var pointerIndex=this.mouse?0:indexOf(this.pointerIds,getPointerId(pointer)); // do not fire a tap event if the pointer was moved before being lifted
	if(eventType === 'tap' && (this.pointerWasMoved // or if the pointerup target is different to the pointerdown target
	 || !(this.downTargets[pointerIndex] && this.downTargets[pointerIndex] === eventTarget))){return;}var targets=[],elements=[],element=eventTarget;function collectSelectors(interactable,selector,context){var els=ie8MatchesSelector?context.querySelectorAll(selector):undefined;if(interactable._iEvents[eventType] && isElement(element) && inContext(interactable,element) && !testIgnore(interactable,element,eventTarget) && testAllow(interactable,element,eventTarget) && matchesSelector(element,selector,els)){targets.push(interactable);elements.push(element);}}while(element) {if(interact.isSet(element) && interact(element)._iEvents[eventType]){targets.push(interact(element));elements.push(element);}interactables.forEachSelector(collectSelectors);element = parentElement(element);} // create the tap event even if there are no listeners so that
	// doubletap can still be created and fired
	if(targets.length || eventType === 'tap'){this.firePointers(pointer,event,eventTarget,targets,elements,eventType);}},firePointers:function firePointers(pointer,event,eventTarget,targets,elements,eventType){var pointerIndex=this.mouse?0:indexOf(this.pointerIds,getPointerId(pointer)),pointerEvent={},i, // for tap events
	interval,createNewDoubleTap; // if it's a doubletap then the event properties would have been
	// copied from the tap event and provided as the pointer argument
	if(eventType === 'doubletap'){pointerEvent = pointer;}else {pointerExtend(pointerEvent,event);if(event !== pointer){pointerExtend(pointerEvent,pointer);}pointerEvent.preventDefault = preventOriginalDefault;pointerEvent.stopPropagation = InteractEvent.prototype.stopPropagation;pointerEvent.stopImmediatePropagation = InteractEvent.prototype.stopImmediatePropagation;pointerEvent.interaction = this;pointerEvent.timeStamp = new Date().getTime();pointerEvent.originalEvent = event;pointerEvent.originalPointer = pointer;pointerEvent.type = eventType;pointerEvent.pointerId = getPointerId(pointer);pointerEvent.pointerType = this.mouse?'mouse':!supportsPointerEvent?'touch':isString(pointer.pointerType)?pointer.pointerType:[,,'touch','pen','mouse'][pointer.pointerType];}if(eventType === 'tap'){pointerEvent.dt = pointerEvent.timeStamp - this.downTimes[pointerIndex];interval = pointerEvent.timeStamp - this.tapTime;createNewDoubleTap = !!(this.prevTap && this.prevTap.type !== 'doubletap' && this.prevTap.target === pointerEvent.target && interval < 500);pointerEvent.double = createNewDoubleTap;this.tapTime = pointerEvent.timeStamp;}for(i = 0;i < targets.length;i++) {pointerEvent.currentTarget = elements[i];pointerEvent.interactable = targets[i];targets[i].fire(pointerEvent);if(pointerEvent.immediatePropagationStopped || pointerEvent.propagationStopped && elements[i + 1] !== pointerEvent.currentTarget){break;}}if(createNewDoubleTap){var doubleTap={};extend(doubleTap,pointerEvent);doubleTap.dt = interval;doubleTap.type = 'doubletap';this.collectEventTargets(doubleTap,event,eventTarget,'doubletap');this.prevTap = doubleTap;}else if(eventType === 'tap'){this.prevTap = pointerEvent;}},validateSelector:function validateSelector(pointer,event,matches,matchElements){for(var i=0,len=matches.length;i < len;i++) {var match=matches[i],matchElement=matchElements[i],action=validateAction(match.getAction(pointer,event,this,matchElement),match);if(action && withinInteractionLimit(match,matchElement,action)){this.target = match;this.element = matchElement;return action;}}},setSnapping:function setSnapping(pageCoords,status){var snap=this.target.options[this.prepared.name].snap,targets=[],target,page,i;status = status || this.snapStatus;if(status.useStatusXY){page = {x:status.x,y:status.y};}else {var origin=getOriginXY(this.target,this.element);page = extend({},pageCoords);page.x -= origin.x;page.y -= origin.y;}status.realX = page.x;status.realY = page.y;page.x = page.x - this.inertiaStatus.resumeDx;page.y = page.y - this.inertiaStatus.resumeDy;var len=snap.targets?snap.targets.length:0;for(var relIndex=0;relIndex < this.snapOffsets.length;relIndex++) {var relative={x:page.x - this.snapOffsets[relIndex].x,y:page.y - this.snapOffsets[relIndex].y};for(i = 0;i < len;i++) {if(isFunction(snap.targets[i])){target = snap.targets[i](relative.x,relative.y,this);}else {target = snap.targets[i];}if(!target){continue;}targets.push({x:isNumber(target.x)?target.x + this.snapOffsets[relIndex].x:relative.x,y:isNumber(target.y)?target.y + this.snapOffsets[relIndex].y:relative.y,range:isNumber(target.range)?target.range:snap.range});}}var closest={target:null,inRange:false,distance:0,range:0,dx:0,dy:0};for(i = 0,len = targets.length;i < len;i++) {target = targets[i];var range=target.range,dx=target.x - page.x,dy=target.y - page.y,distance=hypot(dx,dy),inRange=distance <= range; // Infinite targets count as being out of range
	// compared to non infinite ones that are in range
	if(range === Infinity && closest.inRange && closest.range !== Infinity){inRange = false;}if(!closest.target || (inRange // is the closest target in range?
	?closest.inRange && range !== Infinity // the pointer is relatively deeper in this target
	?distance / range < closest.distance / closest.range // this target has Infinite range and the closest doesn't
	:range === Infinity && closest.range !== Infinity ||  // OR this target is closer that the previous closest
	distance < closest.distance: // The other is not in range and the pointer is closer to this target
	!closest.inRange && distance < closest.distance)){if(range === Infinity){inRange = true;}closest.target = target;closest.distance = distance;closest.range = range;closest.inRange = inRange;closest.dx = dx;closest.dy = dy;status.range = range;}}var snapChanged;if(closest.target){snapChanged = status.snappedX !== closest.target.x || status.snappedY !== closest.target.y;status.snappedX = closest.target.x;status.snappedY = closest.target.y;}else {snapChanged = true;status.snappedX = NaN;status.snappedY = NaN;}status.dx = closest.dx;status.dy = closest.dy;status.changed = snapChanged || closest.inRange && !status.locked;status.locked = closest.inRange;return status;},setRestriction:function setRestriction(pageCoords,status){var target=this.target,restrict=target && target.options[this.prepared.name].restrict,restriction=restrict && restrict.restriction,page;if(!restriction){return status;}status = status || this.restrictStatus;page = status.useStatusXY?page = {x:status.x,y:status.y}:page = extend({},pageCoords);if(status.snap && status.snap.locked){page.x += status.snap.dx || 0;page.y += status.snap.dy || 0;}page.x -= this.inertiaStatus.resumeDx;page.y -= this.inertiaStatus.resumeDy;status.dx = 0;status.dy = 0;status.restricted = false;var rect,restrictedX,restrictedY;if(isString(restriction)){if(restriction === 'parent'){restriction = parentElement(this.element);}else if(restriction === 'self'){restriction = target.getRect(this.element);}else {restriction = closest(this.element,restriction);}if(!restriction){return status;}}if(isFunction(restriction)){restriction = restriction(page.x,page.y,this.element);}if(isElement(restriction)){restriction = getElementRect(restriction);}rect = restriction;if(!restriction){restrictedX = page.x;restrictedY = page.y;} // object is assumed to have
	// x, y, width, height or
	// left, top, right, bottom
	else if('x' in restriction && 'y' in restriction){restrictedX = Math.max(Math.min(rect.x + rect.width - this.restrictOffset.right,page.x),rect.x + this.restrictOffset.left);restrictedY = Math.max(Math.min(rect.y + rect.height - this.restrictOffset.bottom,page.y),rect.y + this.restrictOffset.top);}else {restrictedX = Math.max(Math.min(rect.right - this.restrictOffset.right,page.x),rect.left + this.restrictOffset.left);restrictedY = Math.max(Math.min(rect.bottom - this.restrictOffset.bottom,page.y),rect.top + this.restrictOffset.top);}status.dx = restrictedX - page.x;status.dy = restrictedY - page.y;status.changed = status.restrictedX !== restrictedX || status.restrictedY !== restrictedY;status.restricted = !!(status.dx || status.dy);status.restrictedX = restrictedX;status.restrictedY = restrictedY;return status;},checkAndPreventDefault:function checkAndPreventDefault(event,interactable,element){if(!(interactable = interactable || this.target)){return;}var options=interactable.options,prevent=options.preventDefault;if(prevent === 'auto' && element && !/^(input|select|textarea)$/i.test(event.target.nodeName)){ // do not preventDefault on pointerdown if the prepared action is a drag
	// and dragging can only start from a certain direction - this allows
	// a touch to pan the viewport if a drag isn't in the right direction
	if(/down|start/i.test(event.type) && this.prepared.name === 'drag' && options.drag.axis !== 'xy'){return;} // with manualStart, only preventDefault while interacting
	if(options[this.prepared.name] && options[this.prepared.name].manualStart && !this.interacting()){return;}event.preventDefault();return;}if(prevent === 'always'){event.preventDefault();return;}},calcInertia:function calcInertia(status){var inertiaOptions=this.target.options[this.prepared.name].inertia,lambda=inertiaOptions.resistance,inertiaDur=-Math.log(inertiaOptions.endSpeed / status.v0) / lambda;status.x0 = this.prevEvent.pageX;status.y0 = this.prevEvent.pageY;status.t0 = status.startEvent.timeStamp / 1000;status.sx = status.sy = 0;status.modifiedXe = status.xe = (status.vx0 - inertiaDur) / lambda;status.modifiedYe = status.ye = (status.vy0 - inertiaDur) / lambda;status.te = inertiaDur;status.lambda_v0 = lambda / status.v0;status.one_ve_v0 = 1 - inertiaOptions.endSpeed / status.v0;},autoScrollMove:function autoScrollMove(pointer){if(!(this.interacting() && checkAutoScroll(this.target,this.prepared.name))){return;}if(this.inertiaStatus.active){autoScroll.x = autoScroll.y = 0;return;}var top,right,bottom,left,options=this.target.options[this.prepared.name].autoScroll,container=options.container || getWindow(this.element);if(isWindow(container)){left = pointer.clientX < autoScroll.margin;top = pointer.clientY < autoScroll.margin;right = pointer.clientX > container.innerWidth - autoScroll.margin;bottom = pointer.clientY > container.innerHeight - autoScroll.margin;}else {var rect=getElementClientRect(container);left = pointer.clientX < rect.left + autoScroll.margin;top = pointer.clientY < rect.top + autoScroll.margin;right = pointer.clientX > rect.right - autoScroll.margin;bottom = pointer.clientY > rect.bottom - autoScroll.margin;}autoScroll.x = right?1:left?-1:0;autoScroll.y = bottom?1:top?-1:0;if(!autoScroll.isScrolling){ // set the autoScroll properties to those of the target
	autoScroll.margin = options.margin;autoScroll.speed = options.speed;autoScroll.start(this);}},_updateEventTargets:function _updateEventTargets(target,currentTarget){this._eventTarget = target;this._curEventTarget = currentTarget;}};function getInteractionFromPointer(pointer,eventType,eventTarget){var i=0,len=interactions.length,mouseEvent=/mouse/i.test(pointer.pointerType || eventType) // MSPointerEvent.MSPOINTER_TYPE_MOUSE
	 || pointer.pointerType === 4,interaction;var id=getPointerId(pointer); // try to resume inertia with a new pointer
	if(/down|start/i.test(eventType)){for(i = 0;i < len;i++) {interaction = interactions[i];var element=eventTarget;if(interaction.inertiaStatus.active && interaction.target.options[interaction.prepared.name].inertia.allowResume && interaction.mouse === mouseEvent){while(element) { // if the element is the interaction element
	if(element === interaction.element){return interaction;}element = parentElement(element);}}}} // if it's a mouse interaction
	if(mouseEvent || !(supportsTouch || supportsPointerEvent)){ // find a mouse interaction that's not in inertia phase
	for(i = 0;i < len;i++) {if(interactions[i].mouse && !interactions[i].inertiaStatus.active){return interactions[i];}} // find any interaction specifically for mouse.
	// if the eventType is a mousedown, and inertia is active
	// ignore the interaction
	for(i = 0;i < len;i++) {if(interactions[i].mouse && !(/down/.test(eventType) && interactions[i].inertiaStatus.active)){return interaction;}} // create a new interaction for mouse
	interaction = new Interaction();interaction.mouse = true;return interaction;} // get interaction that has this pointer
	for(i = 0;i < len;i++) {if(contains(interactions[i].pointerIds,id)){return interactions[i];}} // at this stage, a pointerUp should not return an interaction
	if(/up|end|out/i.test(eventType)){return null;} // get first idle interaction
	for(i = 0;i < len;i++) {interaction = interactions[i];if((!interaction.prepared.name || interaction.target.options.gesture.enabled) && !interaction.interacting() && !(!mouseEvent && interaction.mouse)){return interaction;}}return new Interaction();}function doOnInteractions(method){return function(event){var interaction,eventTarget=getActualElement(event.path?event.path[0]:event.target),curEventTarget=getActualElement(event.currentTarget),i;if(supportsTouch && /touch/.test(event.type)){prevTouchTime = new Date().getTime();for(i = 0;i < event.changedTouches.length;i++) {var pointer=event.changedTouches[i];interaction = getInteractionFromPointer(pointer,event.type,eventTarget);if(!interaction){continue;}interaction._updateEventTargets(eventTarget,curEventTarget);interaction[method](pointer,event,eventTarget,curEventTarget);}}else {if(!supportsPointerEvent && /mouse/.test(event.type)){ // ignore mouse events while touch interactions are active
	for(i = 0;i < interactions.length;i++) {if(!interactions[i].mouse && interactions[i].pointerIsDown){return;}} // try to ignore mouse events that are simulated by the browser
	// after a touch event
	if(new Date().getTime() - prevTouchTime < 500){return;}}interaction = getInteractionFromPointer(event,event.type,eventTarget);if(!interaction){return;}interaction._updateEventTargets(eventTarget,curEventTarget);interaction[method](event,event,eventTarget,curEventTarget);}};}function InteractEvent(interaction,event,action,phase,element,related){var client,page,target=interaction.target,snapStatus=interaction.snapStatus,restrictStatus=interaction.restrictStatus,pointers=interaction.pointers,deltaSource=(target && target.options || defaultOptions).deltaSource,sourceX=deltaSource + 'X',sourceY=deltaSource + 'Y',options=target?target.options:defaultOptions,origin=getOriginXY(target,element),starting=phase === 'start',ending=phase === 'end',coords=starting?interaction.startCoords:interaction.curCoords;element = element || interaction.element;page = extend({},coords.page);client = extend({},coords.client);page.x -= origin.x;page.y -= origin.y;client.x -= origin.x;client.y -= origin.y;var relativePoints=options[action].snap && options[action].snap.relativePoints;if(checkSnap(target,action) && !(starting && relativePoints && relativePoints.length)){this.snap = {range:snapStatus.range,locked:snapStatus.locked,x:snapStatus.snappedX,y:snapStatus.snappedY,realX:snapStatus.realX,realY:snapStatus.realY,dx:snapStatus.dx,dy:snapStatus.dy};if(snapStatus.locked){page.x += snapStatus.dx;page.y += snapStatus.dy;client.x += snapStatus.dx;client.y += snapStatus.dy;}}if(checkRestrict(target,action) && !(starting && options[action].restrict.elementRect) && restrictStatus.restricted){page.x += restrictStatus.dx;page.y += restrictStatus.dy;client.x += restrictStatus.dx;client.y += restrictStatus.dy;this.restrict = {dx:restrictStatus.dx,dy:restrictStatus.dy};}this.pageX = page.x;this.pageY = page.y;this.clientX = client.x;this.clientY = client.y;this.x0 = interaction.startCoords.page.x - origin.x;this.y0 = interaction.startCoords.page.y - origin.y;this.clientX0 = interaction.startCoords.client.x - origin.x;this.clientY0 = interaction.startCoords.client.y - origin.y;this.ctrlKey = event.ctrlKey;this.altKey = event.altKey;this.shiftKey = event.shiftKey;this.metaKey = event.metaKey;this.button = event.button;this.buttons = event.buttons;this.target = element;this.t0 = interaction.downTimes[0];this.type = action + (phase || '');this.interaction = interaction;this.interactable = target;var inertiaStatus=interaction.inertiaStatus;if(inertiaStatus.active){this.detail = 'inertia';}if(related){this.relatedTarget = related;} // end event dx, dy is difference between start and end points
	if(ending){if(deltaSource === 'client'){this.dx = client.x - interaction.startCoords.client.x;this.dy = client.y - interaction.startCoords.client.y;}else {this.dx = page.x - interaction.startCoords.page.x;this.dy = page.y - interaction.startCoords.page.y;}}else if(starting){this.dx = 0;this.dy = 0;} // copy properties from previousmove if starting inertia
	else if(phase === 'inertiastart'){this.dx = interaction.prevEvent.dx;this.dy = interaction.prevEvent.dy;}else {if(deltaSource === 'client'){this.dx = client.x - interaction.prevEvent.clientX;this.dy = client.y - interaction.prevEvent.clientY;}else {this.dx = page.x - interaction.prevEvent.pageX;this.dy = page.y - interaction.prevEvent.pageY;}}if(interaction.prevEvent && interaction.prevEvent.detail === 'inertia' && !inertiaStatus.active && options[action].inertia && options[action].inertia.zeroResumeDelta){inertiaStatus.resumeDx += this.dx;inertiaStatus.resumeDy += this.dy;this.dx = this.dy = 0;}if(action === 'resize' && interaction.resizeAxes){if(options.resize.square){if(interaction.resizeAxes === 'y'){this.dx = this.dy;}else {this.dy = this.dx;}this.axes = 'xy';}else {this.axes = interaction.resizeAxes;if(interaction.resizeAxes === 'x'){this.dy = 0;}else if(interaction.resizeAxes === 'y'){this.dx = 0;}}}else if(action === 'gesture'){this.touches = [pointers[0],pointers[1]];if(starting){this.distance = touchDistance(pointers,deltaSource);this.box = touchBBox(pointers);this.scale = 1;this.ds = 0;this.angle = touchAngle(pointers,undefined,deltaSource);this.da = 0;}else if(ending || event instanceof InteractEvent){this.distance = interaction.prevEvent.distance;this.box = interaction.prevEvent.box;this.scale = interaction.prevEvent.scale;this.ds = this.scale - 1;this.angle = interaction.prevEvent.angle;this.da = this.angle - interaction.gesture.startAngle;}else {this.distance = touchDistance(pointers,deltaSource);this.box = touchBBox(pointers);this.scale = this.distance / interaction.gesture.startDistance;this.angle = touchAngle(pointers,interaction.gesture.prevAngle,deltaSource);this.ds = this.scale - interaction.gesture.prevScale;this.da = this.angle - interaction.gesture.prevAngle;}}if(starting){this.timeStamp = interaction.downTimes[0];this.dt = 0;this.duration = 0;this.speed = 0;this.velocityX = 0;this.velocityY = 0;}else if(phase === 'inertiastart'){this.timeStamp = interaction.prevEvent.timeStamp;this.dt = interaction.prevEvent.dt;this.duration = interaction.prevEvent.duration;this.speed = interaction.prevEvent.speed;this.velocityX = interaction.prevEvent.velocityX;this.velocityY = interaction.prevEvent.velocityY;}else {this.timeStamp = new Date().getTime();this.dt = this.timeStamp - interaction.prevEvent.timeStamp;this.duration = this.timeStamp - interaction.downTimes[0];if(event instanceof InteractEvent){var dx=this[sourceX] - interaction.prevEvent[sourceX],dy=this[sourceY] - interaction.prevEvent[sourceY],dt=this.dt / 1000;this.speed = hypot(dx,dy) / dt;this.velocityX = dx / dt;this.velocityY = dy / dt;} // if normal move or end event, use previous user event coords
	else { // speed and velocity in pixels per second
	this.speed = interaction.pointerDelta[deltaSource].speed;this.velocityX = interaction.pointerDelta[deltaSource].vx;this.velocityY = interaction.pointerDelta[deltaSource].vy;}}if((ending || phase === 'inertiastart') && interaction.prevEvent.speed > 600 && this.timeStamp - interaction.prevEvent.timeStamp < 150){var angle=180 * Math.atan2(interaction.prevEvent.velocityY,interaction.prevEvent.velocityX) / Math.PI,overlap=22.5;if(angle < 0){angle += 360;}var left=135 - overlap <= angle && angle < 225 + overlap,up=225 - overlap <= angle && angle < 315 + overlap,right=!left && (315 - overlap <= angle || angle < 45 + overlap),down=!up && 45 - overlap <= angle && angle < 135 + overlap;this.swipe = {up:up,down:down,left:left,right:right,angle:angle,speed:interaction.prevEvent.speed,velocity:{x:interaction.prevEvent.velocityX,y:interaction.prevEvent.velocityY}};}}InteractEvent.prototype = {preventDefault:blank,stopImmediatePropagation:function stopImmediatePropagation(){this.immediatePropagationStopped = this.propagationStopped = true;},stopPropagation:function stopPropagation(){this.propagationStopped = true;}};function preventOriginalDefault(){this.originalEvent.preventDefault();}function getActionCursor(action){var cursor='';if(action.name === 'drag'){cursor = actionCursors.drag;}if(action.name === 'resize'){if(action.axis){cursor = actionCursors[action.name + action.axis];}else if(action.edges){var cursorKey='resize',edgeNames=['top','bottom','left','right'];for(var i=0;i < 4;i++) {if(action.edges[edgeNames[i]]){cursorKey += edgeNames[i];}}cursor = actionCursors[cursorKey];}}return cursor;}function checkResizeEdge(name,value,page,element,interactableElement,rect,margin){ // false, '', undefined, null
	if(!value){return false;} // true value, use pointer coords and element rect
	if(value === true){ // if dimensions are negative, "switch" edges
	var width=isNumber(rect.width)?rect.width:rect.right - rect.left,height=isNumber(rect.height)?rect.height:rect.bottom - rect.top;if(width < 0){if(name === 'left'){name = 'right';}else if(name === 'right'){name = 'left';}}if(height < 0){if(name === 'top'){name = 'bottom';}else if(name === 'bottom'){name = 'top';}}if(name === 'left'){return page.x < (width >= 0?rect.left:rect.right) + margin;}if(name === 'top'){return page.y < (height >= 0?rect.top:rect.bottom) + margin;}if(name === 'right'){return page.x > (width >= 0?rect.right:rect.left) - margin;}if(name === 'bottom'){return page.y > (height >= 0?rect.bottom:rect.top) - margin;}} // the remaining checks require an element
	if(!isElement(element)){return false;}return isElement(value) // the value is an element to use as a resize handle
	?value === element // otherwise check if element matches value as selector
	:matchesUpTo(element,value,interactableElement);}function defaultActionChecker(pointer,interaction,element){var rect=this.getRect(element),shouldResize=false,action=null,resizeAxes=null,resizeEdges,page=extend({},interaction.curCoords.page),options=this.options;if(!rect){return null;}if(actionIsEnabled.resize && options.resize.enabled){var resizeOptions=options.resize;resizeEdges = {left:false,right:false,top:false,bottom:false}; // if using resize.edges
	if(isObject(resizeOptions.edges)){for(var edge in resizeEdges) {resizeEdges[edge] = checkResizeEdge(edge,resizeOptions.edges[edge],page,interaction._eventTarget,element,rect,resizeOptions.margin || margin);}resizeEdges.left = resizeEdges.left && !resizeEdges.right;resizeEdges.top = resizeEdges.top && !resizeEdges.bottom;shouldResize = resizeEdges.left || resizeEdges.right || resizeEdges.top || resizeEdges.bottom;}else {var right=options.resize.axis !== 'y' && page.x > rect.right - margin,bottom=options.resize.axis !== 'x' && page.y > rect.bottom - margin;shouldResize = right || bottom;resizeAxes = (right?'x':'') + (bottom?'y':'');}}action = shouldResize?'resize':actionIsEnabled.drag && options.drag.enabled?'drag':null;if(actionIsEnabled.gesture && interaction.pointerIds.length >= 2 && !(interaction.dragging || interaction.resizing)){action = 'gesture';}if(action){return {name:action,axis:resizeAxes,edges:resizeEdges};}return null;} // Check if action is enabled globally and the current target supports it
	// If so, return the validated action. Otherwise, return null
	function validateAction(action,interactable){if(!isObject(action)){return null;}var actionName=action.name,options=interactable.options;if((actionName === 'resize' && options.resize.enabled || actionName === 'drag' && options.drag.enabled || actionName === 'gesture' && options.gesture.enabled) && actionIsEnabled[actionName]){if(actionName === 'resize' || actionName === 'resizeyx'){actionName = 'resizexy';}return action;}return null;}var listeners={},interactionListeners=['dragStart','dragMove','resizeStart','resizeMove','gestureStart','gestureMove','pointerOver','pointerOut','pointerHover','selectorDown','pointerDown','pointerMove','pointerUp','pointerCancel','pointerEnd','addPointer','removePointer','recordPointer','autoScrollMove'];for(var i=0,len=interactionListeners.length;i < len;i++) {var name=interactionListeners[i];listeners[name] = doOnInteractions(name);} // bound to the interactable context when a DOM event
	// listener is added to a selector interactable
	function delegateListener(event,useCapture){var fakeEvent={},delegated=delegatedEvents[event.type],eventTarget=getActualElement(event.path?event.path[0]:event.target),element=eventTarget;useCapture = useCapture?true:false; // duplicate the event so that currentTarget can be changed
	for(var prop in event) {fakeEvent[prop] = event[prop];}fakeEvent.originalEvent = event;fakeEvent.preventDefault = preventOriginalDefault; // climb up document tree looking for selector matches
	while(isElement(element)) {for(var i=0;i < delegated.selectors.length;i++) {var selector=delegated.selectors[i],context=delegated.contexts[i];if(matchesSelector(element,selector) && nodeContains(context,eventTarget) && nodeContains(context,element)){var listeners=delegated.listeners[i];fakeEvent.currentTarget = element;for(var j=0;j < listeners.length;j++) {if(listeners[j][1] === useCapture){listeners[j][0](fakeEvent);}}}}element = parentElement(element);}}function delegateUseCapture(event){return delegateListener.call(this,event,true);}interactables.indexOfElement = function indexOfElement(element,context){context = context || document;for(var i=0;i < this.length;i++) {var interactable=this[i];if(interactable.selector === element && interactable._context === context || !interactable.selector && interactable._element === element){return i;}}return -1;};interactables.get = function interactableGet(element,options){return this[this.indexOfElement(element,options && options.context)];};interactables.forEachSelector = function(callback){for(var i=0;i < this.length;i++) {var interactable=this[i];if(!interactable.selector){continue;}var ret=callback(interactable,interactable.selector,interactable._context,i,this);if(ret !== undefined){return ret;}}}; /*\
	     * interact
	     [ method ]
	     *
	     * The methods of this variable can be used to set elements as
	     * interactables and also to change various default settings.
	     *
	     * Calling it as a function and passing an element or a valid CSS selector
	     * string returns an Interactable object which has various methods to
	     * configure it.
	     *
	     - element (Element | string) The HTML or SVG Element to interact with or CSS selector
	     = (object) An @Interactable
	     *
	     > Usage
	     | interact(document.getElementById('draggable')).draggable(true);
	     |
	     | var rectables = interact('rect');
	     | rectables
	     |     .gesturable(true)
	     |     .on('gesturemove', function (event) {
	     |         // something cool...
	     |     })
	     |     .autoScroll(true);
	    \*/function interact(element,options){return interactables.get(element,options) || new Interactable(element,options);} /*\
	     * Interactable
	     [ property ]
	     **
	     * Object type returned by @interact
	    \*/function Interactable(element,options){this._element = element;this._iEvents = this._iEvents || {};var _window;if(trySelector(element)){this.selector = element;var context=options && options.context;_window = context?getWindow(context):window;if(context && (_window.Node?context instanceof _window.Node:isElement(context) || context === _window.document)){this._context = context;}}else {_window = getWindow(element);if(isElement(element,_window)){if(supportsPointerEvent){events.add(this._element,pEventTypes.down,listeners.pointerDown);events.add(this._element,pEventTypes.move,listeners.pointerHover);}else {events.add(this._element,'mousedown',listeners.pointerDown);events.add(this._element,'mousemove',listeners.pointerHover);events.add(this._element,'touchstart',listeners.pointerDown);events.add(this._element,'touchmove',listeners.pointerHover);}}}this._doc = _window.document;if(!contains(documents,this._doc)){listenToDocument(this._doc);}interactables.push(this);this.set(options);}Interactable.prototype = {setOnEvents:function setOnEvents(action,phases){if(action === 'drop'){if(isFunction(phases.ondrop)){this.ondrop = phases.ondrop;}if(isFunction(phases.ondropactivate)){this.ondropactivate = phases.ondropactivate;}if(isFunction(phases.ondropdeactivate)){this.ondropdeactivate = phases.ondropdeactivate;}if(isFunction(phases.ondragenter)){this.ondragenter = phases.ondragenter;}if(isFunction(phases.ondragleave)){this.ondragleave = phases.ondragleave;}if(isFunction(phases.ondropmove)){this.ondropmove = phases.ondropmove;}}else {action = 'on' + action;if(isFunction(phases.onstart)){this[action + 'start'] = phases.onstart;}if(isFunction(phases.onmove)){this[action + 'move'] = phases.onmove;}if(isFunction(phases.onend)){this[action + 'end'] = phases.onend;}if(isFunction(phases.oninertiastart)){this[action + 'inertiastart'] = phases.oninertiastart;}}return this;}, /*\
	         * Interactable.draggable
	         [ method ]
	         *
	         * Gets or sets whether drag actions can be performed on the
	         * Interactable
	         *
	         = (boolean) Indicates if this can be the target of drag events
	         | var isDraggable = interact('ul li').draggable();
	         * or
	         - options (boolean | object) #optional true/false or An object with event listeners to be fired on drag events (object makes the Interactable draggable)
	         = (object) This Interactable
	         | interact(element).draggable({
	         |     onstart: function (event) {},
	         |     onmove : function (event) {},
	         |     onend  : function (event) {},
	         |
	         |     // the axis in which the first movement must be
	         |     // for the drag sequence to start
	         |     // 'xy' by default - any direction
	         |     axis: 'x' || 'y' || 'xy',
	         |
	         |     // max number of drags that can happen concurrently
	         |     // with elements of this Interactable. Infinity by default
	         |     max: Infinity,
	         |
	         |     // max number of drags that can target the same element+Interactable
	         |     // 1 by default
	         |     maxPerElement: 2
	         | });
	        \*/draggable:function draggable(options){if(isObject(options)){this.options.drag.enabled = options.enabled === false?false:true;this.setPerAction('drag',options);this.setOnEvents('drag',options);if(/^x$|^y$|^xy$/.test(options.axis)){this.options.drag.axis = options.axis;}else if(options.axis === null){delete this.options.drag.axis;}return this;}if(isBool(options)){this.options.drag.enabled = options;return this;}return this.options.drag;},setPerAction:function setPerAction(action,options){ // for all the default per-action options
	for(var option in options) { // if this option exists for this action
	if(option in defaultOptions[action]){ // if the option in the options arg is an object value
	if(isObject(options[option])){ // duplicate the object
	this.options[action][option] = extend(this.options[action][option] || {},options[option]);if(isObject(defaultOptions.perAction[option]) && 'enabled' in defaultOptions.perAction[option]){this.options[action][option].enabled = options[option].enabled === false?false:true;}}else if(isBool(options[option]) && isObject(defaultOptions.perAction[option])){this.options[action][option].enabled = options[option];}else if(options[option] !== undefined){ // or if it's not undefined, do a plain assignment
	this.options[action][option] = options[option];}}}}, /*\
	         * Interactable.dropzone
	         [ method ]
	         *
	         * Returns or sets whether elements can be dropped onto this
	         * Interactable to trigger drop events
	         *
	         * Dropzones can receive the following events:
	         *  - `dropactivate` and `dropdeactivate` when an acceptable drag starts and ends
	         *  - `dragenter` and `dragleave` when a draggable enters and leaves the dropzone
	         *  - `dragmove` when a draggable that has entered the dropzone is moved
	         *  - `drop` when a draggable is dropped into this dropzone
	         *
	         *  Use the `accept` option to allow only elements that match the given CSS selector or element.
	         *
	         *  Use the `overlap` option to set how drops are checked for. The allowed values are:
	         *   - `'pointer'`, the pointer must be over the dropzone (default)
	         *   - `'center'`, the draggable element's center must be over the dropzone
	         *   - a number from 0-1 which is the `(intersection area) / (draggable area)`.
	         *       e.g. `0.5` for drop to happen when half of the area of the
	         *       draggable is over the dropzone
	         *
	         - options (boolean | object | null) #optional The new value to be set.
	         | interact('.drop').dropzone({
	         |   accept: '.can-drop' || document.getElementById('single-drop'),
	         |   overlap: 'pointer' || 'center' || zeroToOne
	         | }
	         = (boolean | object) The current setting or this Interactable
	        \*/dropzone:function dropzone(options){if(isObject(options)){this.options.drop.enabled = options.enabled === false?false:true;this.setOnEvents('drop',options);if(/^(pointer|center)$/.test(options.overlap)){this.options.drop.overlap = options.overlap;}else if(isNumber(options.overlap)){this.options.drop.overlap = Math.max(Math.min(1,options.overlap),0);}if('accept' in options){this.options.drop.accept = options.accept;}if('checker' in options){this.options.drop.checker = options.checker;}return this;}if(isBool(options)){this.options.drop.enabled = options;return this;}return this.options.drop;},dropCheck:function dropCheck(dragEvent,event,draggable,draggableElement,dropElement,rect){var dropped=false; // if the dropzone has no rect (eg. display: none)
	// call the custom dropChecker or just return false
	if(!(rect = rect || this.getRect(dropElement))){return this.options.drop.checker?this.options.drop.checker(dragEvent,event,dropped,this,dropElement,draggable,draggableElement):false;}var dropOverlap=this.options.drop.overlap;if(dropOverlap === 'pointer'){var page=_getPageXY(dragEvent),origin=getOriginXY(draggable,draggableElement),horizontal,vertical;page.x += origin.x;page.y += origin.y;horizontal = page.x > rect.left && page.x < rect.right;vertical = page.y > rect.top && page.y < rect.bottom;dropped = horizontal && vertical;}var dragRect=draggable.getRect(draggableElement);if(dropOverlap === 'center'){var cx=dragRect.left + dragRect.width / 2,cy=dragRect.top + dragRect.height / 2;dropped = cx >= rect.left && cx <= rect.right && cy >= rect.top && cy <= rect.bottom;}if(isNumber(dropOverlap)){var overlapArea=Math.max(0,Math.min(rect.right,dragRect.right) - Math.max(rect.left,dragRect.left)) * Math.max(0,Math.min(rect.bottom,dragRect.bottom) - Math.max(rect.top,dragRect.top)),overlapRatio=overlapArea / (dragRect.width * dragRect.height);dropped = overlapRatio >= dropOverlap;}if(this.options.drop.checker){dropped = this.options.drop.checker(dragEvent,event,dropped,this,dropElement,draggable,draggableElement);}return dropped;}, /*\
	         * Interactable.dropChecker
	         [ method ]
	         *
	         * DEPRECATED. Use interactable.dropzone({ checker: function... }) instead.
	         *
	         * Gets or sets the function used to check if a dragged element is
	         * over this Interactable.
	         *
	         - checker (function) #optional The function that will be called when checking for a drop
	         = (Function | Interactable) The checker function or this Interactable
	         *
	         * The checker function takes the following arguments:
	         *
	         - dragEvent (InteractEvent) The related dragmove or dragend event
	         - event (TouchEvent | PointerEvent | MouseEvent) The user move/up/end Event related to the dragEvent
	         - dropped (boolean) The value from the default drop checker
	         - dropzone (Interactable) The dropzone interactable
	         - dropElement (Element) The dropzone element
	         - draggable (Interactable) The Interactable being dragged
	         - draggableElement (Element) The actual element that's being dragged
	         *
	         > Usage:
	         | interact(target)
	         | .dropChecker(function(dragEvent,         // related dragmove or dragend event
	         |                       event,             // TouchEvent/PointerEvent/MouseEvent
	         |                       dropped,           // bool result of the default checker
	         |                       dropzone,          // dropzone Interactable
	         |                       dropElement,       // dropzone elemnt
	         |                       draggable,         // draggable Interactable
	         |                       draggableElement) {// draggable element
	         |
	         |   return dropped && event.target.hasAttribute('allow-drop');
	         | }
	        \*/dropChecker:function dropChecker(checker){if(isFunction(checker)){this.options.drop.checker = checker;return this;}if(checker === null){delete this.options.getRect;return this;}return this.options.drop.checker;}, /*\
	         * Interactable.accept
	         [ method ]
	         *
	         * Deprecated. add an `accept` property to the options object passed to
	         * @Interactable.dropzone instead.
	         *
	         * Gets or sets the Element or CSS selector match that this
	         * Interactable accepts if it is a dropzone.
	         *
	         - newValue (Element | string | null) #optional
	         * If it is an Element, then only that element can be dropped into this dropzone.
	         * If it is a string, the element being dragged must match it as a selector.
	         * If it is null, the accept options is cleared - it accepts any element.
	         *
	         = (string | Element | null | Interactable) The current accept option if given `undefined` or this Interactable
	        \*/accept:function accept(newValue){if(isElement(newValue)){this.options.drop.accept = newValue;return this;} // test if it is a valid CSS selector
	if(trySelector(newValue)){this.options.drop.accept = newValue;return this;}if(newValue === null){delete this.options.drop.accept;return this;}return this.options.drop.accept;}, /*\
	         * Interactable.resizable
	         [ method ]
	         *
	         * Gets or sets whether resize actions can be performed on the
	         * Interactable
	         *
	         = (boolean) Indicates if this can be the target of resize elements
	         | var isResizeable = interact('input[type=text]').resizable();
	         * or
	         - options (boolean | object) #optional true/false or An object with event listeners to be fired on resize events (object makes the Interactable resizable)
	         = (object) This Interactable
	         | interact(element).resizable({
	         |     onstart: function (event) {},
	         |     onmove : function (event) {},
	         |     onend  : function (event) {},
	         |
	         |     edges: {
	         |       top   : true,       // Use pointer coords to check for resize.
	         |       left  : false,      // Disable resizing from left edge.
	         |       bottom: '.resize-s',// Resize if pointer target matches selector
	         |       right : handleEl    // Resize if pointer target is the given Element
	         |     },
	         |
	         |     // Width and height can be adjusted independently. When `true`, width and
	         |     // height are adjusted at a 1:1 ratio.
	         |     square: false,
	         |
	         |     // Width and height can be adjusted independently. When `true`, width and
	         |     // height maintain the aspect ratio they had when resizing started.
	         |     preserveAspectRatio: false,
	         |
	         |     // a value of 'none' will limit the resize rect to a minimum of 0x0
	         |     // 'negate' will allow the rect to have negative width/height
	         |     // 'reposition' will keep the width/height positive by swapping
	         |     // the top and bottom edges and/or swapping the left and right edges
	         |     invert: 'none' || 'negate' || 'reposition'
	         |
	         |     // limit multiple resizes.
	         |     // See the explanation in the @Interactable.draggable example
	         |     max: Infinity,
	         |     maxPerElement: 1,
	         | });
	        \*/resizable:function resizable(options){if(isObject(options)){this.options.resize.enabled = options.enabled === false?false:true;this.setPerAction('resize',options);this.setOnEvents('resize',options);if(/^x$|^y$|^xy$/.test(options.axis)){this.options.resize.axis = options.axis;}else if(options.axis === null){this.options.resize.axis = defaultOptions.resize.axis;}if(isBool(options.preserveAspectRatio)){this.options.resize.preserveAspectRatio = options.preserveAspectRatio;}else if(isBool(options.square)){this.options.resize.square = options.square;}return this;}if(isBool(options)){this.options.resize.enabled = options;return this;}return this.options.resize;}, /*\
	         * Interactable.squareResize
	         [ method ]
	         *
	         * Deprecated. Add a `square: true || false` property to @Interactable.resizable instead
	         *
	         * Gets or sets whether resizing is forced 1:1 aspect
	         *
	         = (boolean) Current setting
	         *
	         * or
	         *
	         - newValue (boolean) #optional
	         = (object) this Interactable
	        \*/squareResize:function squareResize(newValue){if(isBool(newValue)){this.options.resize.square = newValue;return this;}if(newValue === null){delete this.options.resize.square;return this;}return this.options.resize.square;}, /*\
	         * Interactable.gesturable
	         [ method ]
	         *
	         * Gets or sets whether multitouch gestures can be performed on the
	         * Interactable's element
	         *
	         = (boolean) Indicates if this can be the target of gesture events
	         | var isGestureable = interact(element).gesturable();
	         * or
	         - options (boolean | object) #optional true/false or An object with event listeners to be fired on gesture events (makes the Interactable gesturable)
	         = (object) this Interactable
	         | interact(element).gesturable({
	         |     onstart: function (event) {},
	         |     onmove : function (event) {},
	         |     onend  : function (event) {},
	         |
	         |     // limit multiple gestures.
	         |     // See the explanation in @Interactable.draggable example
	         |     max: Infinity,
	         |     maxPerElement: 1,
	         | });
	        \*/gesturable:function gesturable(options){if(isObject(options)){this.options.gesture.enabled = options.enabled === false?false:true;this.setPerAction('gesture',options);this.setOnEvents('gesture',options);return this;}if(isBool(options)){this.options.gesture.enabled = options;return this;}return this.options.gesture;}, /*\
	         * Interactable.autoScroll
	         [ method ]
	         **
	         * Deprecated. Add an `autoscroll` property to the options object
	         * passed to @Interactable.draggable or @Interactable.resizable instead.
	         *
	         * Returns or sets whether dragging and resizing near the edges of the
	         * window/container trigger autoScroll for this Interactable
	         *
	         = (object) Object with autoScroll properties
	         *
	         * or
	         *
	         - options (object | boolean) #optional
	         * options can be:
	         * - an object with margin, distance and interval properties,
	         * - true or false to enable or disable autoScroll or
	         = (Interactable) this Interactable
	        \*/autoScroll:function autoScroll(options){if(isObject(options)){options = extend({actions:['drag','resize']},options);}else if(isBool(options)){options = {actions:['drag','resize'],enabled:options};}return this.setOptions('autoScroll',options);}, /*\
	         * Interactable.snap
	         [ method ]
	         **
	         * Deprecated. Add a `snap` property to the options object passed
	         * to @Interactable.draggable or @Interactable.resizable instead.
	         *
	         * Returns or sets if and how action coordinates are snapped. By
	         * default, snapping is relative to the pointer coordinates. You can
	         * change this by setting the
	         * [`elementOrigin`](https://github.com/taye/interact.js/pull/72).
	         **
	         = (boolean | object) `false` if snap is disabled; object with snap properties if snap is enabled
	         **
	         * or
	         **
	         - options (object | boolean | null) #optional
	         = (Interactable) this Interactable
	         > Usage
	         | interact(document.querySelector('#thing')).snap({
	         |     targets: [
	         |         // snap to this specific point
	         |         {
	         |             x: 100,
	         |             y: 100,
	         |             range: 25
	         |         },
	         |         // give this function the x and y page coords and snap to the object returned
	         |         function (x, y) {
	         |             return {
	         |                 x: x,
	         |                 y: (75 + 50 * Math.sin(x * 0.04)),
	         |                 range: 40
	         |             };
	         |         },
	         |         // create a function that snaps to a grid
	         |         interact.createSnapGrid({
	         |             x: 50,
	         |             y: 50,
	         |             range: 10,              // optional
	         |             offset: { x: 5, y: 10 } // optional
	         |         })
	         |     ],
	         |     // do not snap during normal movement.
	         |     // Instead, trigger only one snapped move event
	         |     // immediately before the end event.
	         |     endOnly: true,
	         |
	         |     relativePoints: [
	         |         { x: 0, y: 0 },  // snap relative to the top left of the element
	         |         { x: 1, y: 1 },  // and also to the bottom right
	         |     ],  
	         |
	         |     // offset the snap target coordinates
	         |     // can be an object with x/y or 'startCoords'
	         |     offset: { x: 50, y: 50 }
	         |   }
	         | });
	        \*/snap:function snap(options){var ret=this.setOptions('snap',options);if(ret === this){return this;}return ret.drag;},setOptions:function setOptions(option,options){var actions=options && isArray(options.actions)?options.actions:['drag'];var i;if(isObject(options) || isBool(options)){for(i = 0;i < actions.length;i++) {var action=/resize/.test(actions[i])?'resize':actions[i];if(!isObject(this.options[action])){continue;}var thisOption=this.options[action][option];if(isObject(options)){extend(thisOption,options);thisOption.enabled = options.enabled === false?false:true;if(option === 'snap'){if(thisOption.mode === 'grid'){thisOption.targets = [interact.createSnapGrid(extend({offset:thisOption.gridOffset || {x:0,y:0}},thisOption.grid || {}))];}else if(thisOption.mode === 'anchor'){thisOption.targets = thisOption.anchors;}else if(thisOption.mode === 'path'){thisOption.targets = thisOption.paths;}if('elementOrigin' in options){thisOption.relativePoints = [options.elementOrigin];}}}else if(isBool(options)){thisOption.enabled = options;}}return this;}var ret={},allActions=['drag','resize','gesture'];for(i = 0;i < allActions.length;i++) {if(option in defaultOptions[allActions[i]]){ret[allActions[i]] = this.options[allActions[i]][option];}}return ret;}, /*\
	         * Interactable.inertia
	         [ method ]
	         **
	         * Deprecated. Add an `inertia` property to the options object passed
	         * to @Interactable.draggable or @Interactable.resizable instead.
	         *
	         * Returns or sets if and how events continue to run after the pointer is released
	         **
	         = (boolean | object) `false` if inertia is disabled; `object` with inertia properties if inertia is enabled
	         **
	         * or
	         **
	         - options (object | boolean | null) #optional
	         = (Interactable) this Interactable
	         > Usage
	         | // enable and use default settings
	         | interact(element).inertia(true);
	         |
	         | // enable and use custom settings
	         | interact(element).inertia({
	         |     // value greater than 0
	         |     // high values slow the object down more quickly
	         |     resistance     : 16,
	         |
	         |     // the minimum launch speed (pixels per second) that results in inertia start
	         |     minSpeed       : 200,
	         |
	         |     // inertia will stop when the object slows down to this speed
	         |     endSpeed       : 20,
	         |
	         |     // boolean; should actions be resumed when the pointer goes down during inertia
	         |     allowResume    : true,
	         |
	         |     // boolean; should the jump when resuming from inertia be ignored in event.dx/dy
	         |     zeroResumeDelta: false,
	         |
	         |     // if snap/restrict are set to be endOnly and inertia is enabled, releasing
	         |     // the pointer without triggering inertia will animate from the release
	         |     // point to the snaped/restricted point in the given amount of time (ms)
	         |     smoothEndDuration: 300,
	         |
	         |     // an array of action types that can have inertia (no gesture)
	         |     actions        : ['drag', 'resize']
	         | });
	         |
	         | // reset custom settings and use all defaults
	         | interact(element).inertia(null);
	        \*/inertia:function inertia(options){var ret=this.setOptions('inertia',options);if(ret === this){return this;}return ret.drag;},getAction:function getAction(pointer,event,interaction,element){var action=this.defaultActionChecker(pointer,interaction,element);if(this.options.actionChecker){return this.options.actionChecker(pointer,event,action,this,element,interaction);}return action;},defaultActionChecker:defaultActionChecker, /*\
	         * Interactable.actionChecker
	         [ method ]
	         *
	         * Gets or sets the function used to check action to be performed on
	         * pointerDown
	         *
	         - checker (function | null) #optional A function which takes a pointer event, defaultAction string, interactable, element and interaction as parameters and returns an object with name property 'drag' 'resize' or 'gesture' and optionally an `edges` object with boolean 'top', 'left', 'bottom' and right props.
	         = (Function | Interactable) The checker function or this Interactable
	         *
	         | interact('.resize-drag')
	         |   .resizable(true)
	         |   .draggable(true)
	         |   .actionChecker(function (pointer, event, action, interactable, element, interaction) {
	         |
	         |   if (interact.matchesSelector(event.target, '.drag-handle') {
	         |     // force drag with handle target
	         |     action.name = drag;
	         |   }
	         |   else {
	         |     // resize from the top and right edges
	         |     action.name  = 'resize';
	         |     action.edges = { top: true, right: true };
	         |   }
	         |
	         |   return action;
	         | });
	        \*/actionChecker:function actionChecker(checker){if(isFunction(checker)){this.options.actionChecker = checker;return this;}if(checker === null){delete this.options.actionChecker;return this;}return this.options.actionChecker;}, /*\
	         * Interactable.getRect
	         [ method ]
	         *
	         * The default function to get an Interactables bounding rect. Can be
	         * overridden using @Interactable.rectChecker.
	         *
	         - element (Element) #optional The element to measure.
	         = (object) The object's bounding rectangle.
	         o {
	         o     top   : 0,
	         o     left  : 0,
	         o     bottom: 0,
	         o     right : 0,
	         o     width : 0,
	         o     height: 0
	         o }
	        \*/getRect:function rectCheck(element){element = element || this._element;if(this.selector && !isElement(element)){element = this._context.querySelector(this.selector);}return getElementRect(element);}, /*\
	         * Interactable.rectChecker
	         [ method ]
	         *
	         * Returns or sets the function used to calculate the interactable's
	         * element's rectangle
	         *
	         - checker (function) #optional A function which returns this Interactable's bounding rectangle. See @Interactable.getRect
	         = (function | object) The checker function or this Interactable
	        \*/rectChecker:function rectChecker(checker){if(isFunction(checker)){this.getRect = checker;return this;}if(checker === null){delete this.options.getRect;return this;}return this.getRect;}, /*\
	         * Interactable.styleCursor
	         [ method ]
	         *
	         * Returns or sets whether the action that would be performed when the
	         * mouse on the element are checked on `mousemove` so that the cursor
	         * may be styled appropriately
	         *
	         - newValue (boolean) #optional
	         = (boolean | Interactable) The current setting or this Interactable
	        \*/styleCursor:function styleCursor(newValue){if(isBool(newValue)){this.options.styleCursor = newValue;return this;}if(newValue === null){delete this.options.styleCursor;return this;}return this.options.styleCursor;}, /*\
	         * Interactable.preventDefault
	         [ method ]
	         *
	         * Returns or sets whether to prevent the browser's default behaviour
	         * in response to pointer events. Can be set to:
	         *  - `'always'` to always prevent
	         *  - `'never'` to never prevent
	         *  - `'auto'` to let interact.js try to determine what would be best
	         *
	         - newValue (string) #optional `true`, `false` or `'auto'`
	         = (string | Interactable) The current setting or this Interactable
	        \*/preventDefault:function preventDefault(newValue){if(/^(always|never|auto)$/.test(newValue)){this.options.preventDefault = newValue;return this;}if(isBool(newValue)){this.options.preventDefault = newValue?'always':'never';return this;}return this.options.preventDefault;}, /*\
	         * Interactable.origin
	         [ method ]
	         *
	         * Gets or sets the origin of the Interactable's element.  The x and y
	         * of the origin will be subtracted from action event coordinates.
	         *
	         - origin (object | string) #optional An object eg. { x: 0, y: 0 } or string 'parent', 'self' or any CSS selector
	         * OR
	         - origin (Element) #optional An HTML or SVG Element whose rect will be used
	         **
	         = (object) The current origin or this Interactable
	        \*/origin:function origin(newValue){if(trySelector(newValue)){this.options.origin = newValue;return this;}else if(isObject(newValue)){this.options.origin = newValue;return this;}return this.options.origin;}, /*\
	         * Interactable.deltaSource
	         [ method ]
	         *
	         * Returns or sets the mouse coordinate types used to calculate the
	         * movement of the pointer.
	         *
	         - newValue (string) #optional Use 'client' if you will be scrolling while interacting; Use 'page' if you want autoScroll to work
	         = (string | object) The current deltaSource or this Interactable
	        \*/deltaSource:function deltaSource(newValue){if(newValue === 'page' || newValue === 'client'){this.options.deltaSource = newValue;return this;}return this.options.deltaSource;}, /*\
	         * Interactable.restrict
	         [ method ]
	         **
	         * Deprecated. Add a `restrict` property to the options object passed to
	         * @Interactable.draggable, @Interactable.resizable or @Interactable.gesturable instead.
	         *
	         * Returns or sets the rectangles within which actions on this
	         * interactable (after snap calculations) are restricted. By default,
	         * restricting is relative to the pointer coordinates. You can change
	         * this by setting the
	         * [`elementRect`](https://github.com/taye/interact.js/pull/72).
	         **
	         - options (object) #optional an object with keys drag, resize, and/or gesture whose values are rects, Elements, CSS selectors, or 'parent' or 'self'
	         = (object) The current restrictions object or this Interactable
	         **
	         | interact(element).restrict({
	         |     // the rect will be `interact.getElementRect(element.parentNode)`
	         |     drag: element.parentNode,
	         |
	         |     // x and y are relative to the the interactable's origin
	         |     resize: { x: 100, y: 100, width: 200, height: 200 }
	         | })
	         |
	         | interact('.draggable').restrict({
	         |     // the rect will be the selected element's parent
	         |     drag: 'parent',
	         |
	         |     // do not restrict during normal movement.
	         |     // Instead, trigger only one restricted move event
	         |     // immediately before the end event.
	         |     endOnly: true,
	         |
	         |     // https://github.com/taye/interact.js/pull/72#issue-41813493
	         |     elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
	         | });
	        \*/restrict:function restrict(options){if(!isObject(options)){return this.setOptions('restrict',options);}var actions=['drag','resize','gesture'],ret;for(var i=0;i < actions.length;i++) {var action=actions[i];if(action in options){var perAction=extend({actions:[action],restriction:options[action]},options);ret = this.setOptions('restrict',perAction);}}return ret;}, /*\
	         * Interactable.context
	         [ method ]
	         *
	         * Gets the selector context Node of the Interactable. The default is `window.document`.
	         *
	         = (Node) The context Node of this Interactable
	         **
	        \*/context:function context(){return this._context;},_context:document, /*\
	         * Interactable.ignoreFrom
	         [ method ]
	         *
	         * If the target of the `mousedown`, `pointerdown` or `touchstart`
	         * event or any of it's parents match the given CSS selector or
	         * Element, no drag/resize/gesture is started.
	         *
	         - newValue (string | Element | null) #optional a CSS selector string, an Element or `null` to not ignore any elements
	         = (string | Element | object) The current ignoreFrom value or this Interactable
	         **
	         | interact(element, { ignoreFrom: document.getElementById('no-action') });
	         | // or
	         | interact(element).ignoreFrom('input, textarea, a');
	        \*/ignoreFrom:function ignoreFrom(newValue){if(trySelector(newValue)){ // CSS selector to match event.target
	this.options.ignoreFrom = newValue;return this;}if(isElement(newValue)){ // specific element
	this.options.ignoreFrom = newValue;return this;}return this.options.ignoreFrom;}, /*\
	         * Interactable.allowFrom
	         [ method ]
	         *
	         * A drag/resize/gesture is started only If the target of the
	         * `mousedown`, `pointerdown` or `touchstart` event or any of it's
	         * parents match the given CSS selector or Element.
	         *
	         - newValue (string | Element | null) #optional a CSS selector string, an Element or `null` to allow from any element
	         = (string | Element | object) The current allowFrom value or this Interactable
	         **
	         | interact(element, { allowFrom: document.getElementById('drag-handle') });
	         | // or
	         | interact(element).allowFrom('.handle');
	        \*/allowFrom:function allowFrom(newValue){if(trySelector(newValue)){ // CSS selector to match event.target
	this.options.allowFrom = newValue;return this;}if(isElement(newValue)){ // specific element
	this.options.allowFrom = newValue;return this;}return this.options.allowFrom;}, /*\
	         * Interactable.element
	         [ method ]
	         *
	         * If this is not a selector Interactable, it returns the element this
	         * interactable represents
	         *
	         = (Element) HTML / SVG Element
	        \*/element:function element(){return this._element;}, /*\
	         * Interactable.fire
	         [ method ]
	         *
	         * Calls listeners for the given InteractEvent type bound globally
	         * and directly to this Interactable
	         *
	         - iEvent (InteractEvent) The InteractEvent object to be fired on this Interactable
	         = (Interactable) this Interactable
	        \*/fire:function fire(iEvent){if(!(iEvent && iEvent.type) || !contains(eventTypes,iEvent.type)){return this;}var listeners,i,len,onEvent='on' + iEvent.type,funcName=''; // Interactable#on() listeners
	if(iEvent.type in this._iEvents){listeners = this._iEvents[iEvent.type];for(i = 0,len = listeners.length;i < len && !iEvent.immediatePropagationStopped;i++) {funcName = listeners[i].name;listeners[i](iEvent);}} // interactable.onevent listener
	if(isFunction(this[onEvent])){funcName = this[onEvent].name;this[onEvent](iEvent);} // interact.on() listeners
	if(iEvent.type in globalEvents && (listeners = globalEvents[iEvent.type])){for(i = 0,len = listeners.length;i < len && !iEvent.immediatePropagationStopped;i++) {funcName = listeners[i].name;listeners[i](iEvent);}}return this;}, /*\
	         * Interactable.on
	         [ method ]
	         *
	         * Binds a listener for an InteractEvent or DOM event.
	         *
	         - eventType  (string | array | object) The types of events to listen for
	         - listener   (function) The function to be called on the given event(s)
	         - useCapture (boolean) #optional useCapture flag for addEventListener
	         = (object) This Interactable
	        \*/on:function on(eventType,listener,useCapture){var i;if(isString(eventType) && eventType.search(' ') !== -1){eventType = eventType.trim().split(/ +/);}if(isArray(eventType)){for(i = 0;i < eventType.length;i++) {this.on(eventType[i],listener,useCapture);}return this;}if(isObject(eventType)){for(var prop in eventType) {this.on(prop,eventType[prop],listener);}return this;}if(eventType === 'wheel'){eventType = wheelEvent;} // convert to boolean
	useCapture = useCapture?true:false;if(contains(eventTypes,eventType)){ // if this type of event was never bound to this Interactable
	if(!(eventType in this._iEvents)){this._iEvents[eventType] = [listener];}else {this._iEvents[eventType].push(listener);}} // delegated event for selector
	else if(this.selector){if(!delegatedEvents[eventType]){delegatedEvents[eventType] = {selectors:[],contexts:[],listeners:[]}; // add delegate listener functions
	for(i = 0;i < documents.length;i++) {events.add(documents[i],eventType,delegateListener);events.add(documents[i],eventType,delegateUseCapture,true);}}var delegated=delegatedEvents[eventType],index;for(index = delegated.selectors.length - 1;index >= 0;index--) {if(delegated.selectors[index] === this.selector && delegated.contexts[index] === this._context){break;}}if(index === -1){index = delegated.selectors.length;delegated.selectors.push(this.selector);delegated.contexts.push(this._context);delegated.listeners.push([]);} // keep listener and useCapture flag
	delegated.listeners[index].push([listener,useCapture]);}else {events.add(this._element,eventType,listener,useCapture);}return this;}, /*\
	         * Interactable.off
	         [ method ]
	         *
	         * Removes an InteractEvent or DOM event listener
	         *
	         - eventType  (string | array | object) The types of events that were listened for
	         - listener   (function) The listener function to be removed
	         - useCapture (boolean) #optional useCapture flag for removeEventListener
	         = (object) This Interactable
	        \*/off:function off(eventType,listener,useCapture){var i;if(isString(eventType) && eventType.search(' ') !== -1){eventType = eventType.trim().split(/ +/);}if(isArray(eventType)){for(i = 0;i < eventType.length;i++) {this.off(eventType[i],listener,useCapture);}return this;}if(isObject(eventType)){for(var prop in eventType) {this.off(prop,eventType[prop],listener);}return this;}var eventList,index=-1; // convert to boolean
	useCapture = useCapture?true:false;if(eventType === 'wheel'){eventType = wheelEvent;} // if it is an action event type
	if(contains(eventTypes,eventType)){eventList = this._iEvents[eventType];if(eventList && (index = indexOf(eventList,listener)) !== -1){this._iEvents[eventType].splice(index,1);}} // delegated event
	else if(this.selector){var delegated=delegatedEvents[eventType],matchFound=false;if(!delegated){return this;} // count from last index of delegated to 0
	for(index = delegated.selectors.length - 1;index >= 0;index--) { // look for matching selector and context Node
	if(delegated.selectors[index] === this.selector && delegated.contexts[index] === this._context){var listeners=delegated.listeners[index]; // each item of the listeners array is an array: [function, useCaptureFlag]
	for(i = listeners.length - 1;i >= 0;i--) {var fn=listeners[i][0],useCap=listeners[i][1]; // check if the listener functions and useCapture flags match
	if(fn === listener && useCap === useCapture){ // remove the listener from the array of listeners
	listeners.splice(i,1); // if all listeners for this interactable have been removed
	// remove the interactable from the delegated arrays
	if(!listeners.length){delegated.selectors.splice(index,1);delegated.contexts.splice(index,1);delegated.listeners.splice(index,1); // remove delegate function from context
	events.remove(this._context,eventType,delegateListener);events.remove(this._context,eventType,delegateUseCapture,true); // remove the arrays if they are empty
	if(!delegated.selectors.length){delegatedEvents[eventType] = null;}} // only remove one listener
	matchFound = true;break;}}if(matchFound){break;}}}} // remove listener from this Interatable's element
	else {events.remove(this._element,eventType,listener,useCapture);}return this;}, /*\
	         * Interactable.set
	         [ method ]
	         *
	         * Reset the options of this Interactable
	         - options (object) The new settings to apply
	         = (object) This Interactable
	        \*/set:function set(options){if(!isObject(options)){options = {};}this.options = extend({},defaultOptions.base);var i,actions=['drag','drop','resize','gesture'],methods=['draggable','dropzone','resizable','gesturable'],perActions=extend(extend({},defaultOptions.perAction),options[action] || {});for(i = 0;i < actions.length;i++) {var action=actions[i];this.options[action] = extend({},defaultOptions[action]);this.setPerAction(action,perActions);this[methods[i]](options[action]);}var settings=['accept','actionChecker','allowFrom','deltaSource','dropChecker','ignoreFrom','origin','preventDefault','rectChecker','styleCursor'];for(i = 0,len = settings.length;i < len;i++) {var setting=settings[i];this.options[setting] = defaultOptions.base[setting];if(setting in options){this[setting](options[setting]);}}return this;}, /*\
	         * Interactable.unset
	         [ method ]
	         *
	         * Remove this interactable from the list of interactables and remove
	         * it's drag, drop, resize and gesture capabilities
	         *
	         = (object) @interact
	        \*/unset:function unset(){events.remove(this._element,'all');if(!isString(this.selector)){events.remove(this,'all');if(this.options.styleCursor){this._element.style.cursor = '';}}else { // remove delegated events
	for(var type in delegatedEvents) {var delegated=delegatedEvents[type];for(var i=0;i < delegated.selectors.length;i++) {if(delegated.selectors[i] === this.selector && delegated.contexts[i] === this._context){delegated.selectors.splice(i,1);delegated.contexts.splice(i,1);delegated.listeners.splice(i,1); // remove the arrays if they are empty
	if(!delegated.selectors.length){delegatedEvents[type] = null;}}events.remove(this._context,type,delegateListener);events.remove(this._context,type,delegateUseCapture,true);break;}}}this.dropzone(false);interactables.splice(indexOf(interactables,this),1);return interact;}};function warnOnce(method,message){var warned=false;return function(){if(!warned){window.console.warn(message);warned = true;}return method.apply(this,arguments);};}Interactable.prototype.snap = warnOnce(Interactable.prototype.snap,'Interactable#snap is deprecated. See the new documentation for snapping at http://interactjs.io/docs/snapping');Interactable.prototype.restrict = warnOnce(Interactable.prototype.restrict,'Interactable#restrict is deprecated. See the new documentation for resticting at http://interactjs.io/docs/restriction');Interactable.prototype.inertia = warnOnce(Interactable.prototype.inertia,'Interactable#inertia is deprecated. See the new documentation for inertia at http://interactjs.io/docs/inertia');Interactable.prototype.autoScroll = warnOnce(Interactable.prototype.autoScroll,'Interactable#autoScroll is deprecated. See the new documentation for autoScroll at http://interactjs.io/docs/#autoscroll');Interactable.prototype.squareResize = warnOnce(Interactable.prototype.squareResize,'Interactable#squareResize is deprecated. See http://interactjs.io/docs/#resize-square');Interactable.prototype.accept = warnOnce(Interactable.prototype.accept,'Interactable#accept is deprecated. use Interactable#dropzone({ accept: target }) instead');Interactable.prototype.dropChecker = warnOnce(Interactable.prototype.dropChecker,'Interactable#dropChecker is deprecated. use Interactable#dropzone({ dropChecker: checkerFunction }) instead');Interactable.prototype.context = warnOnce(Interactable.prototype.context,'Interactable#context as a method is deprecated. It will soon be a DOM Node instead'); /*\
	     * interact.isSet
	     [ method ]
	     *
	     * Check if an element has been set
	     - element (Element) The Element being searched for
	     = (boolean) Indicates if the element or CSS selector was previously passed to interact
	    \*/interact.isSet = function(element,options){return interactables.indexOfElement(element,options && options.context) !== -1;}; /*\
	     * interact.on
	     [ method ]
	     *
	     * Adds a global listener for an InteractEvent or adds a DOM event to
	     * `document`
	     *
	     - type       (string | array | object) The types of events to listen for
	     - listener   (function) The function to be called on the given event(s)
	     - useCapture (boolean) #optional useCapture flag for addEventListener
	     = (object) interact
	    \*/interact.on = function(type,listener,useCapture){if(isString(type) && type.search(' ') !== -1){type = type.trim().split(/ +/);}if(isArray(type)){for(var i=0;i < type.length;i++) {interact.on(type[i],listener,useCapture);}return interact;}if(isObject(type)){for(var prop in type) {interact.on(prop,type[prop],listener);}return interact;} // if it is an InteractEvent type, add listener to globalEvents
	if(contains(eventTypes,type)){ // if this type of event was never bound
	if(!globalEvents[type]){globalEvents[type] = [listener];}else {globalEvents[type].push(listener);}} // If non InteractEvent type, addEventListener to document
	else {events.add(document,type,listener,useCapture);}return interact;}; /*\
	     * interact.off
	     [ method ]
	     *
	     * Removes a global InteractEvent listener or DOM event from `document`
	     *
	     - type       (string | array | object) The types of events that were listened for
	     - listener   (function) The listener function to be removed
	     - useCapture (boolean) #optional useCapture flag for removeEventListener
	     = (object) interact
	     \*/interact.off = function(type,listener,useCapture){if(isString(type) && type.search(' ') !== -1){type = type.trim().split(/ +/);}if(isArray(type)){for(var i=0;i < type.length;i++) {interact.off(type[i],listener,useCapture);}return interact;}if(isObject(type)){for(var prop in type) {interact.off(prop,type[prop],listener);}return interact;}if(!contains(eventTypes,type)){events.remove(document,type,listener,useCapture);}else {var index;if(type in globalEvents && (index = indexOf(globalEvents[type],listener)) !== -1){globalEvents[type].splice(index,1);}}return interact;}; /*\
	     * interact.enableDragging
	     [ method ]
	     *
	     * Deprecated.
	     *
	     * Returns or sets whether dragging is enabled for any Interactables
	     *
	     - newValue (boolean) #optional `true` to allow the action; `false` to disable action for all Interactables
	     = (boolean | object) The current setting or interact
	    \*/interact.enableDragging = warnOnce(function(newValue){if(newValue !== null && newValue !== undefined){actionIsEnabled.drag = newValue;return interact;}return actionIsEnabled.drag;},'interact.enableDragging is deprecated and will soon be removed.'); /*\
	     * interact.enableResizing
	     [ method ]
	     *
	     * Deprecated.
	     *
	     * Returns or sets whether resizing is enabled for any Interactables
	     *
	     - newValue (boolean) #optional `true` to allow the action; `false` to disable action for all Interactables
	     = (boolean | object) The current setting or interact
	    \*/interact.enableResizing = warnOnce(function(newValue){if(newValue !== null && newValue !== undefined){actionIsEnabled.resize = newValue;return interact;}return actionIsEnabled.resize;},'interact.enableResizing is deprecated and will soon be removed.'); /*\
	     * interact.enableGesturing
	     [ method ]
	     *
	     * Deprecated.
	     *
	     * Returns or sets whether gesturing is enabled for any Interactables
	     *
	     - newValue (boolean) #optional `true` to allow the action; `false` to disable action for all Interactables
	     = (boolean | object) The current setting or interact
	    \*/interact.enableGesturing = warnOnce(function(newValue){if(newValue !== null && newValue !== undefined){actionIsEnabled.gesture = newValue;return interact;}return actionIsEnabled.gesture;},'interact.enableGesturing is deprecated and will soon be removed.');interact.eventTypes = eventTypes; /*\
	     * interact.debug
	     [ method ]
	     *
	     * Returns debugging data
	     = (object) An object with properties that outline the current state and expose internal functions and variables
	    \*/interact.debug = function(){var interaction=interactions[0] || new Interaction();return {interactions:interactions,target:interaction.target,dragging:interaction.dragging,resizing:interaction.resizing,gesturing:interaction.gesturing,prepared:interaction.prepared,matches:interaction.matches,matchElements:interaction.matchElements,prevCoords:interaction.prevCoords,startCoords:interaction.startCoords,pointerIds:interaction.pointerIds,pointers:interaction.pointers,addPointer:listeners.addPointer,removePointer:listeners.removePointer,recordPointer:listeners.recordPointer,snap:interaction.snapStatus,restrict:interaction.restrictStatus,inertia:interaction.inertiaStatus,downTime:interaction.downTimes[0],downEvent:interaction.downEvent,downPointer:interaction.downPointer,prevEvent:interaction.prevEvent,Interactable:Interactable,interactables:interactables,pointerIsDown:interaction.pointerIsDown,defaultOptions:defaultOptions,defaultActionChecker:defaultActionChecker,actionCursors:actionCursors,dragMove:listeners.dragMove,resizeMove:listeners.resizeMove,gestureMove:listeners.gestureMove,pointerUp:listeners.pointerUp,pointerDown:listeners.pointerDown,pointerMove:listeners.pointerMove,pointerHover:listeners.pointerHover,eventTypes:eventTypes,events:events,globalEvents:globalEvents,delegatedEvents:delegatedEvents,prefixedPropREs:prefixedPropREs};}; // expose the functions used to calculate multi-touch properties
	interact.getPointerAverage = pointerAverage;interact.getTouchBBox = touchBBox;interact.getTouchDistance = touchDistance;interact.getTouchAngle = touchAngle;interact.getElementRect = getElementRect;interact.getElementClientRect = getElementClientRect;interact.matchesSelector = matchesSelector;interact.closest = closest; /*\
	     * interact.margin
	     [ method ]
	     *
	     * Deprecated. Use `interact(target).resizable({ margin: number });` instead.
	     * Returns or sets the margin for autocheck resizing used in
	     * @Interactable.getAction. That is the distance from the bottom and right
	     * edges of an element clicking in which will start resizing
	     *
	     - newValue (number) #optional
	     = (number | interact) The current margin value or interact
	    \*/interact.margin = warnOnce(function(newvalue){if(isNumber(newvalue)){margin = newvalue;return interact;}return margin;},'interact.margin is deprecated. Use interact(target).resizable({ margin: number }); instead.'); /*\
	     * interact.supportsTouch
	     [ method ]
	     *
	     = (boolean) Whether or not the browser supports touch input
	    \*/interact.supportsTouch = function(){return supportsTouch;}; /*\
	     * interact.supportsPointerEvent
	     [ method ]
	     *
	     = (boolean) Whether or not the browser supports PointerEvents
	    \*/interact.supportsPointerEvent = function(){return supportsPointerEvent;}; /*\
	     * interact.stop
	     [ method ]
	     *
	     * Cancels all interactions (end events are not fired)
	     *
	     - event (Event) An event on which to call preventDefault()
	     = (object) interact
	    \*/interact.stop = function(event){for(var i=interactions.length - 1;i >= 0;i--) {interactions[i].stop(event);}return interact;}; /*\
	     * interact.dynamicDrop
	     [ method ]
	     *
	     * Returns or sets whether the dimensions of dropzone elements are
	     * calculated on every dragmove or only on dragstart for the default
	     * dropChecker
	     *
	     - newValue (boolean) #optional True to check on each move. False to check only before start
	     = (boolean | interact) The current setting or interact
	    \*/interact.dynamicDrop = function(newValue){if(isBool(newValue)){ //if (dragging && dynamicDrop !== newValue && !newValue) {
	//calcRects(dropzones);
	//}
	dynamicDrop = newValue;return interact;}return dynamicDrop;}; /*\
	     * interact.pointerMoveTolerance
	     [ method ]
	     * Returns or sets the distance the pointer must be moved before an action
	     * sequence occurs. This also affects tolerance for tap events.
	     *
	     - newValue (number) #optional The movement from the start position must be greater than this value
	     = (number | Interactable) The current setting or interact
	    \*/interact.pointerMoveTolerance = function(newValue){if(isNumber(newValue)){pointerMoveTolerance = newValue;return this;}return pointerMoveTolerance;}; /*\
	     * interact.maxInteractions
	     [ method ]
	     **
	     * Returns or sets the maximum number of concurrent interactions allowed.
	     * By default only 1 interaction is allowed at a time (for backwards
	     * compatibility). To allow multiple interactions on the same Interactables
	     * and elements, you need to enable it in the draggable, resizable and
	     * gesturable `'max'` and `'maxPerElement'` options.
	     **
	     - newValue (number) #optional Any number. newValue <= 0 means no interactions.
	    \*/interact.maxInteractions = function(newValue){if(isNumber(newValue)){maxInteractions = newValue;return this;}return maxInteractions;};interact.createSnapGrid = function(grid){return function(x,y){var offsetX=0,offsetY=0;if(isObject(grid.offset)){offsetX = grid.offset.x;offsetY = grid.offset.y;}var gridx=Math.round((x - offsetX) / grid.x),gridy=Math.round((y - offsetY) / grid.y),newX=gridx * grid.x + offsetX,newY=gridy * grid.y + offsetY;return {x:newX,y:newY,range:grid.range};};};function endAllInteractions(event){for(var i=0;i < interactions.length;i++) {interactions[i].pointerEnd(event,event);}}function listenToDocument(doc){if(contains(documents,doc)){return;}var win=doc.defaultView || doc.parentWindow; // add delegate event listener
	for(var eventType in delegatedEvents) {events.add(doc,eventType,delegateListener);events.add(doc,eventType,delegateUseCapture,true);}if(supportsPointerEvent){if(PointerEvent === win.MSPointerEvent){pEventTypes = {up:'MSPointerUp',down:'MSPointerDown',over:'mouseover',out:'mouseout',move:'MSPointerMove',cancel:'MSPointerCancel'};}else {pEventTypes = {up:'pointerup',down:'pointerdown',over:'pointerover',out:'pointerout',move:'pointermove',cancel:'pointercancel'};}events.add(doc,pEventTypes.down,listeners.selectorDown);events.add(doc,pEventTypes.move,listeners.pointerMove);events.add(doc,pEventTypes.over,listeners.pointerOver);events.add(doc,pEventTypes.out,listeners.pointerOut);events.add(doc,pEventTypes.up,listeners.pointerUp);events.add(doc,pEventTypes.cancel,listeners.pointerCancel); // autoscroll
	events.add(doc,pEventTypes.move,listeners.autoScrollMove);}else {events.add(doc,'mousedown',listeners.selectorDown);events.add(doc,'mousemove',listeners.pointerMove);events.add(doc,'mouseup',listeners.pointerUp);events.add(doc,'mouseover',listeners.pointerOver);events.add(doc,'mouseout',listeners.pointerOut);events.add(doc,'touchstart',listeners.selectorDown);events.add(doc,'touchmove',listeners.pointerMove);events.add(doc,'touchend',listeners.pointerUp);events.add(doc,'touchcancel',listeners.pointerCancel); // autoscroll
	events.add(doc,'mousemove',listeners.autoScrollMove);events.add(doc,'touchmove',listeners.autoScrollMove);}events.add(win,'blur',endAllInteractions);try{if(win.frameElement){var parentDoc=win.frameElement.ownerDocument,parentWindow=parentDoc.defaultView;events.add(parentDoc,'mouseup',listeners.pointerEnd);events.add(parentDoc,'touchend',listeners.pointerEnd);events.add(parentDoc,'touchcancel',listeners.pointerEnd);events.add(parentDoc,'pointerup',listeners.pointerEnd);events.add(parentDoc,'MSPointerUp',listeners.pointerEnd);events.add(parentWindow,'blur',endAllInteractions);}}catch(error) {interact.windowParentError = error;} // prevent native HTML5 drag on interact.js target elements
	events.add(doc,'dragstart',function(event){for(var i=0;i < interactions.length;i++) {var interaction=interactions[i];if(interaction.element && (interaction.element === event.target || nodeContains(interaction.element,event.target))){interaction.checkAndPreventDefault(event,interaction.target,interaction.element);return;}}});if(events.useAttachEvent){ // For IE's lack of Event#preventDefault
	events.add(doc,'selectstart',function(event){var interaction=interactions[0];if(interaction.currentAction()){interaction.checkAndPreventDefault(event);}}); // For IE's bad dblclick event sequence
	events.add(doc,'dblclick',doOnInteractions('ie8Dblclick'));}documents.push(doc);}listenToDocument(document);function indexOf(array,target){for(var i=0,len=array.length;i < len;i++) {if(array[i] === target){return i;}}return -1;}function contains(array,target){return indexOf(array,target) !== -1;}function matchesSelector(element,selector,nodeList){if(ie8MatchesSelector){return ie8MatchesSelector(element,selector,nodeList);} // remove /deep/ from selectors if shadowDOM polyfill is used
	if(window !== realWindow){selector = selector.replace(/\/deep\//g,' ');}return element[prefixedMatchesSelector](selector);}function matchesUpTo(element,selector,limit){while(isElement(element)) {if(matchesSelector(element,selector)){return true;}element = parentElement(element);if(element === limit){return matchesSelector(element,selector);}}return false;} // For IE8's lack of an Element#matchesSelector
	// taken from http://tanalin.com/en/blog/2012/12/matches-selector-ie8/ and modified
	if(!(prefixedMatchesSelector in Element.prototype) || !isFunction(Element.prototype[prefixedMatchesSelector])){ie8MatchesSelector = function(element,selector,elems){elems = elems || element.parentNode.querySelectorAll(selector);for(var i=0,len=elems.length;i < len;i++) {if(elems[i] === element){return true;}}return false;};} // requestAnimationFrame polyfill
	(function(){var lastTime=0,vendors=['ms','moz','webkit','o'];for(var x=0;x < vendors.length && !realWindow.requestAnimationFrame;++x) {reqFrame = realWindow[vendors[x] + 'RequestAnimationFrame'];cancelFrame = realWindow[vendors[x] + 'CancelAnimationFrame'] || realWindow[vendors[x] + 'CancelRequestAnimationFrame'];}if(!reqFrame){reqFrame = function(callback){var currTime=new Date().getTime(),timeToCall=Math.max(0,16 - (currTime - lastTime)),id=setTimeout(function(){callback(currTime + timeToCall);},timeToCall);lastTime = currTime + timeToCall;return id;};}if(!cancelFrame){cancelFrame = function(id){clearTimeout(id);};}})(); /* global exports: true, module, define */ // http://documentcloud.github.io/underscore/docs/underscore.html#section-11
	if(true){if(typeof module !== 'undefined' && module.exports){exports = module.exports = interact;}exports.interact = interact;} // AMD
	else if(typeof define === 'function' && define.amd){define('interact',function(){return interact;});}else {realWindow.interact = interact;}})(typeof window === 'undefined'?undefined:window);

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	
	//Module Imports
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	  setting: "content",
	  isRequired: true,
	  validate: "type", //a type or a value
	  possibleValues: ["string", "object"],
	  errorMessage: ["GDK MultipleSelectBox : Content must be defined and set to a DOM selector or Node"]
	}, {
	  setting: "config",
	  isRequired: false,
	  validate: "type", //a type or a value
	  possibleValues: ["object"],
	  errorMessage: ["GDK MultipleSelectBox : config may be defined and set as an object"]
	}, {
	  setting: "initialOptions",
	  isRequired: false,
	  validate: "type", //a type or a value
	  possibleValues: ["object", "string"],
	  errorMessage: ["GDK MultipleSelectBox : initialOptions may be defined and set as an array"]
	}, {
	  setting: "multiSelectChange",
	  isRequired: false,
	  validate: "type", //a type or a value
	  possibleValues: ["function"],
	  errorMessage: ["GDK MultipleSelectBox : multiSelectChange may be defined and set as a function"]
	}];
	
	/**
	 * MultipleSelectBox class
	 */
	
	var MultipleSelectBox = (function () {
	
	  /**
	   * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	   * @param {string|Object} content
	   *  A reference to the multiple select box node
	   *
	   *  @param {Object} [initialOptions]
	   *  An array containing strings corresponding to 'value' attributes or numbers referencing the index of the select options
	   *
	   *  @param {function} [multiSelectChange]
	   *  A callback function that is triggered when an option is added or removed from the Multi-Select Box
	   */
	
	  function MultipleSelectBox(options) {
	    _classCallCheck(this, MultipleSelectBox);
	
	    this._internalVars = {
	      node: null, //used for current node
	      closeBtn: null
	    };
	
	    //options with defaults set
	    this._defaults = {
	      autoShow: false,
	      overlayShouldCloseModal: true,
	      hideCloseButton: false,
	      config: {
	        '.chosen-select': {},
	        '.chosen-select-deselect': { allow_single_deselect: true },
	        '.chosen-select-no-single': { disable_search_threshold: 10 },
	        '.chosen-select-no-results': { no_results_text: 'Oops, nothing found!' },
	        '.chosen-select-width': { width: "auto" }
	      }
	    };
	
	    // Create options by extending defaults with the passed in arugments
	    if (options && typeof options === "object") {
	      this._options = _baseComponent2["default"].extendDefaults(this._defaults, options);
	    }
	
	    //if the required options are valid set up the environment
	    if (_baseComponent2["default"].validateSettings(this._options, validateSettings)) {
	      this._internalVars.contentType = _baseComponent2["default"].getContentType(this);
	      setLocalVars.call(this);
	      init.call(this);
	      setEvents.call(this);
	    }
	  }
	
	  //Public Methods
	
	  /**
	   * sets the initial selected options
	   * @param {Object} array Array containing the index or option text of the items to be pre-selected
	   */
	
	  _createClass(MultipleSelectBox, [{
	    key: "setInitialSelectionOptions",
	    value: function setInitialSelectionOptions(array) {
	      setInitialSelections.call(this, array);
	    }
	
	    /**
	     * Returns the current selected options
	     * @returns {Array} containing the selected options
	     */
	  }, {
	    key: "activeSelections",
	    value: function activeSelections() {
	      return this._internalVars.selectedItems;
	    }
	
	    /**
	     * removes the node from the dom and any events attached
	     */
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	      //a little garbage collection
	      for (var variableKey in this) {
	        if (this.hasOwnProperty(variableKey)) {
	          delete this[variableKey];
	        }
	      }
	    }
	  }]);
	
	  return MultipleSelectBox;
	})();
	
	function init() {
	  if (this._options.initialOptions) {
	    var array = this._options.initialOptions;
	
	    setInitialSelections.call(this, array);
	  }
	
	  for (var selector in this._options.config) {
	    $(selector).chosen(this._options.config[selector]);
	  }
	}
	
	function setEvents() {
	  $('#' + this._internalVars.node.id).chosen().on('change', updateValues.bind(this));
	}
	
	/**
	 * Sets the initial values pragmatically
	 * @param {array} array Array containing numbers or strings referencing options to be set by default
	 */
	function setInitialSelections(array) {
	  var _this = this;
	
	  var initialValues = [];
	
	  Array.prototype.forEach.call(array, function (item) {
	    if (typeof item === "string") {
	      Array.prototype.forEach.call(_this._internalVars.node.options, function (ele) {
	        if (item === ele.value) {
	          initialValues.push(item);
	        }
	      });
	    } else if (typeof item === "number") {
	      if (item >= 0 && item <= _this._internalVars.node.options.length) {
	        if (item - Math.floor(item) === 0) {
	          var value = _this._internalVars.node.options[item].value;
	          initialValues.push(value);
	        }
	      }
	    }
	  });
	
	  $('#' + this._internalVars.node.id).val(initialValues).trigger('chosen:updated');
	
	  updateValues.call(this);
	}
	
	/**
	 * creates an array of the chosen values
	 */
	function updateValues() {
	  var _this2 = this;
	
	  var selectBox = $('#' + this._internalVars.node.id),
	      empty = undefined;
	
	  this._internalVars.selectedItems = [];
	
	  if (selectBox.val() !== null) {
	    Array.prototype.forEach.call(selectBox.val(), function (element) {
	      Array.prototype.forEach.call(_this2._internalVars.node.options, function (el) {
	        if (element === el.value) {
	          _this2._internalVars.selectedItems.push(el);
	        }
	      });
	    });
	    empty = false;
	  } else {
	    empty = true;
	  }
	
	  if (this._options.multiSelectChange) {
	    this._options.multiSelectChange(this._internalVars.selectedItems, empty);
	  }
	}
	
	/**
	 * setLocalVars()
	 * set all the local vars to passed in options
	 */
	function setLocalVars() {
	  //determine the type of content passed in
	  if (this._internalVars.contentType === 'string') {
	    this._internalVars.node = document.querySelector(this._options.content);
	  } else if (this._internalVars.contentType === 'domNode') {
	    this._internalVars.node = this._options.content;
	  }
	
	  this._internalVars.nodeParent = this._internalVars.node.parentNode;
	}
	
	exports["default"] = MultipleSelectBox;
	module.exports = exports["default"];

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	
	//Module Imports
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK CardSelections : Content must be defined and set to a DOM selector or Node"]
	}, {
	    setting: "initialActiveCard",
	    isRequired: false,
	    validate: "type", //a type or a value
	    possibleValues: ["number"],
	    errorMessage: ["GDK CardSelections : initialActiveCard must be set to a number"]
	}, {
	    setting: "cardSelectionSet",
	    isRequired: false,
	    validate: "type",
	    possibleValues: ["function"],
	    errorMessage: ["GDK CardSelections : cardSelectionClick must be a function"]
	}];
	
	var CardSelections = (function () {
	
	    /**
	     * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	     * @param {string|Object} content
	     *  A reference to the html More Background Pattern node
	     *
	     *  @param {number} [initialActiveCard=1]
	     *  The number of the item to set as the active card on initialization. Must be greater than 0 and equal to or less than the number of cards.
	     *
	     *  @param {function} [cardSelectionSet]
	     *   A callback function that is triggered when any card is set to active.
	     */
	
	    function CardSelections(options) {
	        _classCallCheck(this, CardSelections);
	
	        this._internalVars = {
	            node: null //used for content item
	        };
	
	        //options with defaults set
	        this._defaults = {
	            initialActiveCard: 1
	        };
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2["default"].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2["default"].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2["default"].getContentType(this);
	            setLocalVars.call(this);
	            setEvents.call(this);
	            init.call(this);
	
	            this._internalVars.cardSelectionSection.setAttribute('role', 'radiogroup');
	
	            Array.prototype.forEach.call(this._internalVars.cardSelectionsCards, function (element) {
	                if (!element.getAttribute('tabindex')) element.setAttribute('tabindex', '0');
	
	                if (!element.getElementsByTagName('input')[0].getAttribute('tabindex')) element.getElementsByTagName('input')[0].setAttribute('tabindex', '-1');
	
	                element.setAttribute('role', 'radio');
	            });
	        }
	    }
	
	    // Private Methods
	    /**
	     * setEvents()
	     * Sets all the events needed for the component
	     */
	
	    //Public Methods
	
	    /**
	     * Returns the active selected card
	     * @return {Element}
	     */
	
	    _createClass(CardSelections, [{
	        key: "currentActiveCard",
	        value: function currentActiveCard() {
	            return this._internalVars.selectedCard;
	        }
	
	        /**
	         * sets the initial active card using an index parameter
	         * @param {Number} index Number indicating what the active card should be set to
	         */
	    }, {
	        key: "setActiveCard",
	        value: function setActiveCard(index) {
	            setInitialActiveCard.call(this, index);
	        }
	
	        /**
	         * removes the node from the dom and any events attached
	         */
	    }, {
	        key: "destroy",
	        value: function destroy() {
	            removeEvents.call(this);
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return CardSelections;
	})();
	
	function setEvents() {
	    var _this = this;
	
	    var eventName = "click";
	
	    Array.prototype.forEach.call(this._internalVars.cardSelectionsCards, function (element) {
	        element.addEventListener(eventName, _this._internalVars.handler);
	        element.addEventListener('keyup', _this._internalVars.handler);
	    });
	
	    this._internalVars.cardSelectionsObject.getElementsByTagName('input')[0].form.addEventListener('keypress', checkEvent.bind(this));
	}
	
	/**
	 * removeEvents()
	 * removes all events from the component
	 */
	function removeEvents() {
	    var _this2 = this;
	
	    var eventName = "click";
	
	    Array.prototype.forEach.call(this._internalVars.cardSelectionsCards, function (element) {
	        element.removeEventListener(eventName, _this2._internalVars.handler);
	        element.removeEventListener('keyup', _this2._internalVars.handler);
	    });
	}
	
	/**
	 * init()
	 * Sets the initial values
	 */
	function init() {
	    var index = null;
	
	    if (this._options.initialActiveCard) {
	        index = this._options.initialActiveCard;
	    } else {
	        index = this._defaults.initialActiveCard;
	    }
	
	    setInitialActiveCard.call(this, index);
	}
	
	/**
	 * Removes the class and attributes identifying the card as selected
	 */
	function resetSelected() {
	    var _this3 = this;
	
	    var selected = this._internalVars.cardSelectionsObject.querySelectorAll('.' + this._internalVars.cardSelectedClass);
	
	    if (selected) {
	        Array.prototype.forEach.call(selected, function (el) {
	            el.classList.remove(_this3._internalVars.cardSelectedClass);
	            el.getElementsByTagName('input')[0].removeAttribute('checked');
	            el.setAttribute('aria-checked', 'false');
	        });
	    }
	}
	
	/**
	 * Adds attributes identifying the card as selected
	 */
	function setActiveCardAttributes() {
	    this._internalVars.selectedCard = this._internalVars.cardSelectionsObject.querySelector('.' + this._internalVars.cardSelectedClass);
	
	    this._internalVars.selectedCard.getElementsByTagName('input')[0].setAttribute('checked', 'checked');
	    this._internalVars.selectedCard.setAttribute('aria-checked', 'true');
	
	    if (this._options.cardSelectionSet) {
	        this._options.cardSelectionSet(this._internalVars.selectedCard);
	    }
	}
	
	/**
	 * setInitialActiveCard()
	 * Sets the initial active card
	 */
	function setInitialActiveCard(index) {
	    resetSelected.call(this);
	
	    if (index <= this._internalVars.cardSelectionsCards.length && index > 0) {
	        this._internalVars.cardSelectionsCards[index - 1].classList.add(this._internalVars.cardSelectedClass);
	    } else {
	        this._internalVars.cardSelectionsCards[0].classList.add(this._internalVars.cardSelectedClass);
	    }
	
	    setActiveCardAttributes.call(this);
	}
	
	/**
	 * setActiveCard()
	 * Sets the active card
	 */
	function setActiveCard(event) {
	    if (event.type == 'keypress' || event.type == 'keyup' && (event.keyCode || event.which) != 13) {} else {
	        resetSelected.call(this);
	
	        event.currentTarget.classList.add(this._internalVars.cardSelectedClass);
	
	        setActiveCardAttributes.call(this);
	    }
	}
	
	/**
	 * For IE11 - Stops form submit when selecting a card using the enter key
	 */
	function checkEvent() {
	    if (event.keyCode == '13' && event.target.hasAttribute('aria-checked')) {
	        event.preventDefault();
	    }
	}
	
	/**
	 * setLocalVars()
	 * set all the local vars to passed in options
	 */
	function setLocalVars() {
	    //determine the type of content passed in
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    this._internalVars.cardSelectionsObject = this._internalVars.node;
	
	    this._internalVars.cardSelectionSectionClass = 'card-selections';
	    this._internalVars.cardSelectedClass = 'card-selections-selected';
	    this._internalVars.cardSelectionsCardClass = 'card-selections-card';
	    this._internalVars.selectedCard = null;
	
	    this._internalVars.cardSelectionSection = this._internalVars.cardSelectionsObject.querySelector('.' + this._internalVars.cardSelectionSectionClass);
	    this._internalVars.cardSelectionsCards = this._internalVars.cardSelectionsObject.querySelectorAll('.' + this._internalVars.cardSelectionsCardClass);
	
	    this._internalVars.handler = setActiveCard.bind(this);
	}
	
	exports["default"] = CardSelections;
	module.exports = exports["default"];

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	//Module Imports
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var interactjs = __webpack_require__(60);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type",
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK Time Input : Time Input must be defined and set to a DOM selector or Node"]
	}, {
	    setting: "segmentedControlVar",
	    isRequired: true,
	    validate: "type",
	    possibleValues: ["string"],
	    errorMessage: ["GDK Time Input : segmentedControlVar must be defined as a string"]
	}, {
	    setting: "callBackOnTimeChange",
	    isRequired: false,
	    validate: "type",
	    possibleValues: ["function"],
	    errorMessage: ["GDK Time Input : callBackOnTimeChange must be a defined and set function"]
	}, {
	    setting: "setInitialTime",
	    isRequired: false,
	    validate: "type",
	    possibleValues: ["string"],
	    errorMessage: ["GDK Time Input : setInitialTime must be defined as a string"]
	}];
	
	/**
	 * TimeInput Class
	 */
	
	var TimeInput = (function () {
	
	    /**
	     * Refer to the design kit section of this component for JS examples and setting details.
	     * @param {string|Object} content
	     * A reference to the time input component node
	     *
	     *
	     * @param {string} segmentedControlVar
	     * A name for the segmented control GDK Object
	     *
	     *
	     * @param {function} [callBackOnTimeChange]
	     * A callback function triggered when the time has changed
	     *
	     * @param {string} [setInitialTime]
	     * A string that will populate the time input field and adjust the segmented control if necessary
	     *
	     *
	     */
	
	    function TimeInput(options) {
	        _classCallCheck(this, TimeInput);
	
	        this._internalVars = {};
	
	        //options with defaults set
	        this._defaults = {};
	
	        // Create options by extending defaults with the passed in arguments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2['default'].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2['default'].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2['default'].getContentType(this);
	            setLocalVars.call(this);
	            initSegmentedControl.call(this);
	            setEvents.call(this);
	            setValue.call(this);
	            initMask.call(this);
	        }
	    }
	
	    // Private Methods
	
	    /**
	     * setEvents()
	     * Sets all the events needed for the component
	     */
	
	    //Public Methods
	
	    /**
	     * returns the time entered in a 24hr format
	     * @return {{time: (string)}}
	     */
	
	    _createClass(TimeInput, [{
	        key: 'getTime',
	        value: function getTime() {
	            this._internalVars.publicMethodUsed = true;
	            getValue.call(this);
	            return this._internalVars.timeInputFieldValue;
	        }
	
	        /**
	         * sets the time value
	         * @param {string} time String containing the 24hr time format
	         */
	    }, {
	        key: 'setTime',
	        value: function setTime(time) {
	            this._internalVars.publicMethodUsed = true;
	            getCurrentValue.call(this);
	            setValue.call(this, time);
	            getValue.call(this);
	        }
	
	        /**
	         * removes the node from the dom and any events attached
	         */
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            removeEvents.call(this);
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return TimeInput;
	})();
	
	function setEvents() {
	    var _this = this;
	
	    this._internalVars.timeInputField.addEventListener('focus', getCurrentValue.bind(this));
	    this._internalVars.timeInputField.addEventListener('keyup', checkKey.bind(this));
	    this._internalVars.timeInputField.addEventListener('blur', getValue.bind(this));
	
	    var eventName = "click";
	
	    if ("ontouchstart" in document.documentElement) {
	        eventName = "touchstart";
	    }
	
	    Array.prototype.forEach.call(this._internalVars.dropZoneObject, function (element) {
	        element.addEventListener(eventName, setSegmentValue.bind(_this));
	        interactjs(element).dropzone({
	            ondrop: segmentChange.bind(_this)
	        });
	    });
	}
	
	/**
	 * removeEvents()
	 * removes all events from the component
	 */
	function removeEvents() {
	    var _this2 = this;
	
	    this._internalVars.timeInputField.removeEventListener('focus', getCurrentValue.bind(this));
	    this._internalVars.timeInputField.removeEventListener('keyup', checkKey.bind(this));
	    this._internalVars.timeInputField.removeEventListener('blur', getValue.bind(this));
	
	    var eventName = "click";
	
	    if ("ontouchstart" in document.documentElement) {
	        eventName = "touchstart";
	    }
	
	    Array.prototype.forEach.call(this._internalVars.dropZoneObject, function (element) {
	        element.removeEventListener(eventName, setSegmentValue.bind(_this2));
	    });
	}
	
	/**
	 * initMask()
	 * instantiates the input field mask
	 */
	function initMask() {
	    $(this._internalVars.timeInputField).mask("99:99", {});
	}
	
	/**
	 * initSegmentedControl()
	 * instantiates the segmented control component
	 */
	function initSegmentedControl() {
	    this[this._options.segmentedControlVar] = new GDK.SegmentedControl({
	        "content": this._internalVars.segmentedControlObject
	    });
	}
	
	/**
	 * setValue()
	 * populates the input field value and calls a function to adjust the segmented control
	 */
	function setValue(time) {
	    var entry = undefined;
	
	    if (time) {
	        entry = time;
	    } else if (this._options.setInitialTime) {
	        entry = this._options.setInitialTime;
	    } else {
	        entry = ':';
	    }
	
	    if (entry.indexOf(":") > 0) {
	        var minutes = entry.substring(entry.indexOf(":") + 1),
	            hour = entry.substring(0, entry.indexOf(":"));
	
	        if (minutes.length == 2 && hour.length < 3 && hour.length > 0) {
	            if (hour < 24 && minutes < 60) {
	                var numHour = parseInt(hour),
	                    userEntry = false,
	                    segmentVars = setChangeSegmentVars(numHour, userEntry);
	
	                updatePeriod.call(this, segmentVars.period, segmentVars.changeSegment);
	
	                var convertedTime = convertTo12hrFormat.call(this, numHour, minutes, segmentVars.changeSegment);
	
	                if (entry === time) {
	                    $(this._internalVars.timeInputField).mask("", {});
	                    this._internalVars.timeInputField.setAttribute('value', convertedTime);
	                    this._internalVars.timeInputField.value = convertedTime;
	                    $(this._internalVars.timeInputField).mask("99:99", {});
	                } else {
	                    this._internalVars.timeInputField.setAttribute('value', convertedTime);
	                }
	            }
	        }
	    }
	}
	
	/**
	 * setChangeSegmentVars(numHour, userEntry)
	 * @param numHour
	 * @param userEntry
	 * @returns {{period: string, changeSegment: boolean}}
	 * returns an object storing the time period and boolean indicating if the segmented control should be changed
	 */
	function setChangeSegmentVars(numHour, userEntry) {
	    if (numHour > 12 && numHour < 24) {
	        return {
	            "period": "PM",
	            "changeSegment": true
	        };
	    } else if (numHour < 1) {
	        return {
	            "period": "AM",
	            "changeSegment": true
	        };
	    } else {
	        if (userEntry === false) {
	            return {
	                "period": "AM",
	                "changeSegment": true
	            };
	        } else {
	            return {
	                "period": "AM",
	                "changeSegment": false
	            };
	        }
	    }
	}
	
	/**
	 * convertTo12hrFormat(numHour, minutes)
	 * @param numHour
	 * @param minutes
	 * @returns {string}
	 * returns a string converting a 24hr time format to a 12hr format
	 */
	function convertTo12hrFormat(numHour, minutes) {
	    if (numHour > 12) {
	        numHour = numHour - 12;
	    } else if (numHour < 1) {
	        numHour = numHour + 12;
	    }
	
	    var newHour = numHour.toString();
	
	    if (newHour.length < 2) {
	        newHour = "0" + newHour;
	    }
	
	    return newHour + minutes;
	}
	
	/**
	 * convertTo24hrFormat(activeSegment, hour, minutes)
	 * @param activeSegment
	 * @param hour
	 * @param minutes
	 * @returns {string}
	 * returns a string converting a 12hr time format to a 24hr format
	 */
	function convertTo24hrFormat(activeSegment, hour, minutes) {
	    var newHour = parseInt(hour);
	    if (activeSegment === 'PM') {
	        hour = newHour + 12;
	        if (hour === 24) {
	            hour = hour - 12;
	        }
	    } else {
	        if (newHour === 12) {
	            hour = newHour - 12 + "0";
	        }
	    }
	
	    return hour + ":" + minutes;
	}
	
	/**
	 * parseInputValue()
	 * Takes the time value and returns hours, minutes and the current segment
	 * @returns {{hours: string, minutes: string, segment: string}}
	 */
	function parseInputValue() {
	    this._internalVars.timeInputSegmentSelection = this._internalVars.timeInputObject.querySelector('.' + this._internalVars.activeClass);
	    var activeElementText = this._internalVars.timeInputSegmentSelection.innerHTML,
	        minutes = this._internalVars.timeInputField.value.slice(-2),
	        hours = this._internalVars.timeInputField.value.substring(0, 2);
	
	    return {
	        "hours": hours,
	        "minutes": minutes,
	        "segment": activeElementText
	    };
	}
	
	/**
	 * getCurrentValue()
	 * Set a local variable and stores the current time
	 */
	function getCurrentValue() {
	    var timeEntry = parseInputValue.call(this);
	
	    if (timeEntry.hours.length !== 0 && timeEntry.minutes.length !== 0) {
	        this._internalVars.timeInputFieldCurrentValue = convertTo24hrFormat.call(this, timeEntry.segment, timeEntry.hours, timeEntry.minutes);
	    } else {
	        this._internalVars.timeInputFieldCurrentValue = '__:__';
	    }
	
	    this._internalVars.timeInputCompare = true;
	}
	
	/**
	 * setSegmentValue()
	 * Sets a new value for the segmented control when the user changes the segment manually
	 */
	function setSegmentValue() {
	    var timeEntry = parseInputValue.call(this);
	
	    if (timeEntry.hours.length !== 0 && timeEntry.minutes.length !== 0) {
	        if (timeEntry.segment === "AM") {
	            timeEntry.segment = "PM";
	        } else {
	            timeEntry.segment = "AM";
	        }
	
	        this._internalVars.timeInputFieldCurrentValue = convertTo24hrFormat.call(this, timeEntry.segment, timeEntry.hours, timeEntry.minutes);
	        this._internalVars.timeInputCompare = true;
	        getValue.call(this);
	    }
	}
	
	/**
	 * checkKey(event)
	 * @param event
	 * check if numbers or backspace was pressed
	 */
	function checkKey(event) {
	    //Check the key pressed to trigger function (keys 0-9 and 'backspace')
	
	    if (event.which > 47 && event.which < 58 || event.which === 8 || event.which > 95 && event.which < 106 || event.which == 229) {
	        setTimePeriodVar.call(this);
	    }
	}
	
	/**
	 * setTimePeriodVar()
	 * set an AM or PM variable and evaluate if the segment should change
	 */
	function setTimePeriodVar() {
	    var hour = undefined,
	        userEntry = true;
	
	    //Desktops/iOS recognize the input mask as a value when checking the length, Android does not
	    if (this._internalVars.timeInputField.value.length > 3) {
	        hour = this._internalVars.timeInputField.value.substring(2, 0);
	    }
	
	    if (this._internalVars.timeInputField.value.length === 3) {
	        hour = this._internalVars.timeInputField.value.substring(1, 0);
	    }
	
	    var segmentVars = setChangeSegmentVars(hour, userEntry);
	
	    updatePeriod.call(this, segmentVars.period, segmentVars.changeSegment);
	}
	
	/**
	 * updatePeriod(period, changeSegment)
	 * @param period
	 * @param changeSegment
	 * changes the segmented control to AM or PM
	 */
	function updatePeriod(period, changeSegment) {
	    var activeIndex = undefined;
	
	    if (period === 'AM') {
	        activeIndex = 0;
	    } else {
	        activeIndex = 1;
	    }
	
	    this._internalVars.timeInputSegmentSelection = this._internalVars.timeInputObject.querySelector('.' + this._internalVars.activeClass);
	
	    if (period !== this._internalVars.timeInputSegmentSelection.innerHTML && changeSegment === true) {
	        var delay = setTimeout(setNewSegmentValue.bind(this), 350);
	
	        if (this._internalVars.timeInputSegmentSelection) {
	            this._internalVars.timeInputSegmentSelection.classList.remove(this._internalVars.activeClass);
	            this._internalVars.timeInputSegmentSelection.setAttribute('aria-checked', 'false');
	        }
	
	        this._internalVars.dropZoneObject[activeIndex].classList.add(this._internalVars.activeClass);
	        this._internalVars.dropZoneObject[activeIndex].setAttribute('aria-checked', 'true');
	        this._internalVars.draggableObject.classList.add(this._internalVars.animateClass);
	        this._internalVars.draggableObject.classList.add(this._internalVars.activeDragClass);
	        this._internalVars.draggableObject.innerText = '';
	        this._internalVars.draggableObject.style.zIndex = 1;
	
	        this._internalVars.timeInputSegmentSelection = this._internalVars.timeInputObject.querySelector('.' + this._internalVars.activeClass);
	        var activeElementLeft = this._internalVars.timeInputSegmentSelection.offsetLeft;
	
	        this._internalVars.draggableObject.style.left = activeElementLeft + 'px';
	        this._internalVars.draggableObject.setAttribute('data-x', activeElementLeft);
	        this._internalVars.timeInputSegmentChangeOnly = true;
	    }
	}
	
	/**
	 * setNewSegmentValue()
	 * sets values of element after animation
	 */
	function setNewSegmentValue() {
	    this._internalVars.timeInputSegmentSelection = this._internalVars.timeInputObject.querySelector('.' + this._internalVars.activeClass);
	    var activeElementContent = this._internalVars.timeInputSegmentSelection.innerHTML;
	
	    this._internalVars.draggableObject.innerHTML = activeElementContent;
	    this._internalVars.draggableObject.style.zIndex = 2;
	    this._internalVars.draggableObject.classList.remove(this._internalVars.animateClass);
	    this._internalVars.draggableObject.classList.remove(this._internalVars.activeDragClass);
	}
	
	/**
	 * segmentChange(event)
	 * @param event
	 * updates the segment visually when the user drops the segment selector
	 */
	function segmentChange(event) {
	    var period = event.target.innerHTML,
	        changeSegment = true,
	        timeEntry = parseInputValue.call(this);
	
	    updatePeriod.call(this, period, changeSegment);
	
	    if (timeEntry.hours.length !== 0 && timeEntry.minutes.length !== 0) {
	        getValue.call(this);
	    }
	}
	
	/**
	 * getValue()
	 * gets the value of the input field and segmented control selection
	 */
	function getValue() {
	    var timeEntry = parseInputValue.call(this);
	
	    if (timeEntry.hours < 24 && timeEntry.minutes < 60) {
	        if (timeEntry.hours < 13) {
	            this._internalVars.timeInputFieldValue = convertTo24hrFormat.call(this, timeEntry.segment, timeEntry.hours, timeEntry.minutes);
	        } else {
	            this._internalVars.timeInputFieldValue = timeEntry.hours + ":" + timeEntry.minutes;
	        }
	    } else if (timeEntry.hours >= 24 || timeEntry.minutes >= 60) {
	        this._internalVars.timeInputFieldValue = timeEntry.hours + ":" + timeEntry.minutes;
	    } else {
	        this._internalVars.timeInputFieldValue = "";
	    }
	
	    if (this._options.callBackOnTimeChange && this._internalVars.publicMethodUsed === false) {
	        if (this._internalVars.timeInputFieldCurrentValue === '__:__' || this._internalVars.timeInputFieldValue !== this._internalVars.timeInputFieldCurrentValue && this._internalVars.timeInputCompare === true) {
	            this._options.callBackOnTimeChange(this._internalVars.timeInputFieldValue);
	            this._internalVars.timeInputCompare = false;
	        } else if (this._internalVars.timeInputSegmentChangeOnly === true) {
	            this._options.callBackOnTimeChange(this._internalVars.timeInputFieldValue);
	            this._internalVars.timeInputSegmentChangeOnly = false;
	        }
	    }
	    this._internalVars.publicMethodUsed = false;
	}
	
	/**
	 * setLocalVars()
	 * set all the local vars to passed in options
	 */
	function setLocalVars() {
	    //determine the type of content passed in
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    this._internalVars.timeInputObject = this._internalVars.node;
	
	    this._internalVars.timeInputFieldClass = 'time-input';
	    this._internalVars.segmentedControlClass = 'segmented-control-component';
	    this._internalVars.activeClass = 'active';
	    this._internalVars.dropZoneClass = '.dropzone';
	    this._internalVars.draggableClass = '.sc-draggable';
	    this._internalVars.activeDragClass = 'active-drag';
	    this._internalVars.animateClass = 'animate-drop';
	
	    this._internalVars.segmentedControlObject = this._internalVars.timeInputObject.querySelector('.' + this._internalVars.segmentedControlClass);
	    this._internalVars.timeInputField = this._internalVars.timeInputObject.querySelector('.' + this._internalVars.timeInputFieldClass);
	    this._internalVars.dropZoneObject = this._internalVars.timeInputObject.querySelectorAll(this._internalVars.dropZoneClass);
	    this._internalVars.draggableObject = this._internalVars.timeInputObject.querySelector(this._internalVars.draggableClass);
	    this._internalVars.timeInputFieldValue = this._internalVars.timeInputField.value;
	
	    this._internalVars.timeInputFieldCurrentValue = null;
	    this._internalVars.timeInputSegmentSelection = null;
	    this._internalVars.timeInputCompare = false;
	    this._internalVars.timeInputSegmentChangeOnly = null;
	    this._internalVars.publicMethodUsed = false;
	}
	
	exports['default'] = TimeInput;
	module.exports = exports['default'];

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _appState = __webpack_require__(7);
	
	var _appState2 = _interopRequireDefault(_appState);
	
	//Module Imports
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK NavigationalBox : Content must be defined and set to a DOM selector or Node"]
	}, {
	    setting: "urlSetting",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string"],
	    errorMessage: ["GDK NavigationalBox : urlSetting must be defined and set to a URL string"]
	}, {
	    setting: "targetSetting",
	    isRequired: false,
	    validate: "value", //a type or a value
	    possibleValues: ["_self", "_blank"],
	    errorMessage: ["GDK NavigationalBox : targetSetting must be defined and set to '_self' or '_blank'"]
	}];
	
	var NavigationalBox = (function () {
	
	    /**
	     * Refer to the design kit section of this component for JS examples and setting details.
	     * @param {string, Object} content
	     * A reference to the navigational box
	     *
	     * @param {string} urlSetting
	     * Used to set the initial URL for the navigational box
	     *
	     * @param {string} [targetSetting="_self"]
	     * Used to set URL target to open in same page or in a new window/tab
	     */
	
	    function NavigationalBox(options) {
	        _classCallCheck(this, NavigationalBox);
	
	        this._internalVars = {
	            node: null //used for content item
	        };
	
	        //options with defaults set
	        this._defaults = {
	            targetSetting: "_self"
	        };
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2['default'].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2['default'].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2['default'].getContentType(this);
	            setLocalVars.call(this);
	            setEvents.call(this);
	            if (!this._internalVars.node.getAttribute('tabindex')) this._internalVars.node.setAttribute('tabindex', '0');
	
	            this._internalVars.node.setAttribute('role', 'link');
	        }
	    }
	
	    // Private Methods
	    /**
	     * setEvents()
	     * Sets all the events needed for the component
	     */
	
	    //Public Methods
	    /**
	     * @param {string} [url]
	     * url is new URL string to set to component
	     */
	
	    _createClass(NavigationalBox, [{
	        key: 'setURL',
	        value: function setURL(url) {
	            this._options.urlSetting = url;
	        }
	
	        /**
	         * @param {string} [target="_self"]
	         * target is new target string to set to component with '_self' or '_blank'
	         */
	    }, {
	        key: 'setTarget',
	        value: function setTarget(target) {
	            this._options.targetSetting = target;
	        }
	
	        /**
	         * destroy()
	         * removes the node from the dom and any events attached
	         */
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            removeEvents.call(this);
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return NavigationalBox;
	})();
	
	function setEvents() {
	    var eventName = "click";
	    if ("ontouchstart" in document.documentElement) {
	        eventName = "touchstart";
	    }
	
	    this._internalVars.node.addEventListener(eventName, this._internalVars.handler);
	    this._internalVars.node.addEventListener("keyup", this._internalVars.handler);
	}
	
	/**
	 * removeEvents()
	 * removes all events from the component
	 */
	function removeEvents() {
	    var eventName = "click";
	    if ("ontouchstart" in document.documentElement) {
	        eventName = "touchstart";
	    }
	
	    this._internalVars.node.removeEventListener(eventName, this._internalVars.handler);
	    this._internalVars.node.removeEventListener("keyup", this._internalVars.handler);
	}
	
	/**
	 * setLocalVars()
	 * set all the local vars to passed in options
	 */
	function setLocalVars() {
	    //determine the type of content passed in
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    this._internalVars.handler = redirectionToURL.bind(this);
	}
	
	function redirectionToURL(el) {
	    if (el.type == 'keypress' || el.type == 'keyup' && (el.keyCode || el.which) != 13) {
	        return;
	    }
	    if (_appState2['default'].mode == 'desktop') {
	        window.open(this._options.urlSetting, this._options.targetSetting);
	    } else if (_appState2['default'].mode == 'mobile') {
	        window.open(this._options.urlSetting, '_self');
	    }
	}
	
	exports['default'] = NavigationalBox;
	module.exports = exports['default'];

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	//Module Imports
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	    setting: 'content',
	    isRequired: true,
	    validate: 'type', //a type or a value
	    possibleValues: ['string', 'object'],
	    errorMessage: ['GDK PasswordMeter : Content must be defined and set to a DOM selector or Node']
	}, {
	    setting: 'fairRegex',
	    isRequired: true,
	    validate: 'type', //a type or a value
	    possibleValues: ['string', 'object'],
	    errorMessage: ['GDK PasswordMeter : fairRegex must be a regex string to pass into the RegExp object constructor function or a regex literal']
	}, {
	    setting: 'strongRegex',
	    isRequired: true,
	    validate: 'type', //a type or a value
	    possibleValues: ['string', 'object'],
	    errorMessage: ['GDK PasswordMeter : strongRegex must be a regex string to pass into the RegExp object constructor function or a regex literal']
	}, {
	    setting: 'weakString',
	    isRequired: false,
	    validate: 'type', //a type or a value
	    possibleValues: ['string'],
	    errorMessage: ['GDK PasswordMeter : weakString must be a string to specify another term instead of the default Weak']
	}, {
	    setting: 'fairString',
	    isRequired: false,
	    validate: 'type', //a type or a value
	    possibleValues: ['string'],
	    errorMessage: ['GDK PasswordMeter : fairString must be a string to specify another term instead of the default Fair']
	}, {
	    setting: 'strongString',
	    isRequired: false,
	    validate: 'type', //a type or a value
	    possibleValues: ['string'],
	    errorMessage: ['GDK PasswordMeter : strongString must be a string to specify another term instead of the default Strong']
	}, {
	    setting: 'onInputChange',
	    isRequired: false,
	    validate: 'type',
	    possibleValues: ['function'],
	    errorMessage: ['GDK PasswordMeter : onInputChange must be a defined and set function']
	}];
	
	var PasswordMeter = (function () {
	    /**
	     * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	     * @param {string|Object} content
	     * A reference to the password form field container wrapping both the field and meter
	     *
	     * @param {string|Object} fairRegex
	     * A regex string to pass into the RegExp object constructor function or a regex literal for fair password strength
	     *
	     * @param {string|Object} strongRegex
	     * A regex string to pass into the RegExp object constructor function or a regex literal for strong password strength
	     *
	     * @param {string} [weakString="Weak"]
	     * A string to indicate a Weak password strength
	     *
	     * @param {string} [fairString="Fair"]
	     * A string to indicate a Fair password strength
	     *
	     * @param {string} [strongString="Strong"]
	     * A string to indicate a Strong password strength
	     *
	     * @param {function} [onInputChange]
	     * A callback function with each password character input
	     */
	
	    function PasswordMeter(options) {
	        _classCallCheck(this, PasswordMeter);
	
	        this._internalVars = {
	            node: null //used for current node
	        };
	
	        //options with defaults set
	        this._defaults = {
	            weakString: 'Weak',
	            fairString: 'Fair',
	            strongString: 'Strong'
	        };
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2['default'].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2['default'].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2['default'].getContentType(this);
	            setLocalVars.call(this);
	            setEvents.call(this);
	
	            if (!this._internalVars.meterContainerParent.getAttribute('aria-live')) this._internalVars.meterContainerParent.setAttribute('aria-live', 'polite');
	        }
	    }
	
	    // Private Methods
	
	    //Public Methods
	
	    /**
	     * getCurrentStrength()
	     * returns a string indicating the current password strength level
	     * @returns {string}
	     */
	
	    _createClass(PasswordMeter, [{
	        key: 'getCurrentStrength',
	        value: function getCurrentStrength() {
	            return this._internalVars.meterContainer.getAttribute('class');
	        }
	
	        /**
	         * removes the node from the dom and any events attached
	         */
	    }, {
	        key: 'destroy',
	        value: function destroy() {
	            removeEvents.call(this);
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return PasswordMeter;
	})();
	
	function setLocalVars() {
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    this._internalVars.meterContainerParent = this._internalVars.node.querySelector('.password-meter-container');
	    this._internalVars.meterContainer = this._internalVars.node.querySelector('.password-meter-container > div');
	    this._internalVars.passwordField = this._internalVars.node.querySelector('input[type="password"]');
	    this._internalVars.weakBar = this._internalVars.meterContainer.querySelector('.weak');
	    this._internalVars.fairBar = this._internalVars.meterContainer.querySelector('.fair');
	    this._internalVars.strongBar = this._internalVars.meterContainer.querySelector('.strong');
	    this._internalVars.handler = meterChange.bind(this);
	
	    this._internalVars.strongRegexObj = new RegExp(this._options.strongRegex);
	    if (this._options.strongRegex.toString().charAt(0) === '/') {
	        this._internalVars.strongRegexObj = this._options.strongRegex;
	    }
	    this._internalVars.fairRegexObj = new RegExp(this._options.fairRegex);
	    if (this._options.fairRegex.toString().charAt(0) === '/') {
	        this._internalVars.fairRegexObj = this._options.fairRegex;
	    }
	}
	
	/**
	 * setEvents()
	 * Sets all the events needed for the component
	 */
	function setEvents() {
	    this._internalVars.passwordField.addEventListener('input', this._internalVars.handler);
	}
	
	function removeEvents() {
	    this._internalVars.passwordField.removeEventListener('input', this._internalVars.handler);
	}
	
	/**
	 * whatever()
	 * whatever about the function
	 */
	function removeAll() {
	    this._internalVars.meterContainer.removeAttribute('class');
	}
	
	function meterChange(e) {
	    if (this._internalVars.strongRegexObj.test(e.target.value)) {
	        removeAll.call(this);
	        this._internalVars.meterContainer.classList.add('password-strong');
	        this._internalVars.strongBar.innerHTML = this._options.strongString;
	    } else if (this._internalVars.fairRegexObj.test(e.target.value)) {
	        removeAll.call(this);
	        this._internalVars.meterContainer.classList.add('password-fair');
	        this._internalVars.fairBar.innerHTML = this._options.fairString;
	    } else if (e.target.value === "") {
	        removeAll.call(this);
	    } else {
	        removeAll.call(this);
	        this._internalVars.meterContainer.classList.add('password-weak');
	        this._internalVars.weakBar.innerHTML = this._options.weakString;
	    }
	
	    if (this._options.onInputChange) {
	        this._options.onInputChange();
	    }
	}
	
	exports['default'] = PasswordMeter;
	module.exports = exports['default'];

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	
	//Module Imports
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK Credit Card : Content must be defined and set to a DOM selector or Node"]
	}];
	
	/**
	 * CreditCard Class
	 */
	
	var CreditCard = (function () {
	    /**
	     * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	     * @param {string|Object} content
	     * A reference to the div form field containing the credit card input node
	     *
	     */
	
	    function CreditCard(options) {
	        _classCallCheck(this, CreditCard);
	
	        this._internalVars = {
	
	            creditCards: {
	                americanExpress: {
	                    validDigits: ['34', '37'],
	                    cardFormat: 'alternate',
	                    cardFormatArray: [4, 6, 5],
	                    accepted: true
	                },
	                visa: {
	                    validDigits: ['4'],
	                    cardFormat: 'general',
	                    cardFormatArray: [4, 4, 4, 4],
	                    accepted: true
	                },
	                mastercard: {
	                    validDigits: ['2221-2720', '51-55'],
	                    cardFormat: 'general',
	                    cardFormatArray: [4, 4, 4, 4],
	                    accepted: true
	                },
	                discover: {
	                    validDigits: ['6011', '64', '65'],
	                    cardFormat: 'general',
	                    cardFormatArray: [4, 4, 4, 4],
	                    accepted: true
	                },
	                dinersClub: {
	                    validDigits: ['300-305', '3095', '36', '38-39'],
	                    cardFormat: 'alternate',
	                    cardFormatArray: [4, 5, 4],
	                    accepted: false
	                },
	                jcb: {
	                    validDigits: ['3528-3589'],
	                    cardFormat: 'general',
	                    cardFormatArray: [4, 4, 4, 4],
	                    accepted: false
	                }
	            }
	        };
	
	        //options with defaults set
	        this._defaults = {};
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2["default"].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2["default"].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2["default"].getContentType(this);
	            setLocalVars.call(this);
	            setEvents.call(this);
	        }
	    }
	
	    // Private Methods
	    /**
	     * setEvents()
	     * Sets all the events needed for the component
	     */
	
	    //Public Methods
	
	    /**
	     * getCardType()
	     * returns the card type
	     * @returns {*|string}
	     */
	
	    _createClass(CreditCard, [{
	        key: "getCardType",
	        value: function getCardType() {
	            switch (this._internalVars.creditCardType) {
	                case 'default':
	                    this._internalVars.creditCardType = 'invalid CC';
	                    break;
	                case 'jcb':
	                    this._internalVars.creditCardType = 'invalid: JCB';
	                    break;
	                case 'dinersClub':
	                    this._internalVars.creditCardType = 'invalid: Diners Club';
	                    break;
	            }
	            return this._internalVars.creditCardType;
	        }
	
	        /**
	         * getCardInputValue()
	         * returns the card input value without formatting
	         * @returns {*|string}
	         */
	    }, {
	        key: "getCardInputValue",
	        value: function getCardInputValue() {
	            return this._internalVars.creditCardInputValue;
	        }
	
	        /**
	         * setCardInputValue(cardNumber)
	         * sets the card number
	         * @param {string} cardNumber
	         * The card number to be populated in the input field
	         */
	    }, {
	        key: "setCardInputValue",
	        value: function setCardInputValue(cardNumber) {
	            if (cardNumber) {
	                this._internalVars.creditCardInput.value = cardNumber;
	                this._internalVars.creditCardInput.value = this._internalVars.creditCardInput.value.replace(/\D/g, '');
	                change.call(this);
	            }
	        }
	
	        /**
	         * destroy()
	         * removes the node from the dom and any events attached
	         */
	    }, {
	        key: "destroy",
	        value: function destroy() {
	            removeEvents.call(this);
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return CreditCard;
	})();
	
	function setEvents() {
	    this._internalVars.creditCardInput.addEventListener('paste', paste.bind(this));
	    this._internalVars.creditCardInput.addEventListener('keypress', validateKeyPress.bind(this));
	    this._internalVars.creditCardInput.addEventListener('keyup', checkValue.bind(this));
	    this._internalVars.creditCardInput.addEventListener('input', change.bind(this));
	    this._internalVars.creditCardInput.addEventListener('blur', validateField.bind(this));
	}
	
	/**
	 * removeEvents()
	 * removes all events from the component
	 */
	function removeEvents() {
	    this._internalVars.creditCardInput.removeEventListener('paste', paste.bind(this));
	    this._internalVars.creditCardInput.removeEventListener('keypress', validateKeyPress.bind(this));
	    this._internalVars.creditCardInput.removeEventListener('keyup', checkValue.bind(this));
	    this._internalVars.creditCardInput.removeEventListener('input', change.bind(this));
	    this._internalVars.creditCardInput.removeEventListener('blur', validateField.bind(this));
	}
	
	/**
	 * paste(event)
	 * @param event
	 * removes non-numeric characters and formats numeric characters
	 */
	function paste(event) {
	    var currentLength = this._internalVars.creditCardInput.value.length;
	    //allow time for value to be recognized
	    var delay = setTimeout(pasteComplete.bind(this), 100);
	    function pasteComplete() {
	        //remove non-numeric characters
	        this._internalVars.creditCardInput.value = this._internalVars.creditCardInput.value.replace(/\D/g, '');
	        change.call(this);
	        //set cursor position
	        for (var i = 0; i < this._internalVars.sequenceArray.length; i++) {
	            if (this._internalVars.creditCardInput.value.length === this._internalVars.sequenceArray[i] + (i + 1)) {
	                currentLength = currentLength + 1;
	            }
	        }
	        this._internalVars.creditCardInput.setSelectionRange(this._internalVars.creditCardInput.value.length - currentLength, this._internalVars.creditCardInput.value.length - currentLength);
	    }
	}
	
	/**
	 * validateKeyPress(event)
	 * @param event
	 * restrict non-numeric characters
	 */
	function validateKeyPress(event) {
	    var keyCode = event.which || event.keyCode;
	    if (keyCode > 0 && keyCode < 8 || keyCode > 9 && keyCode < 37 || keyCode > 38 && keyCode < 48 || keyCode > 57 && keyCode < 96 || keyCode > 95 && keyCode < 230) {
	        event.preventDefault();
	    }
	}
	
	/**
	 * checkValue(event)
	 * @param event
	 * set card properties, image, and format
	 */
	function checkValue(event) {
	    var keyCode = event.which || event.keyCode;
	
	    if (keyCode === 8) {
	        setCardFormat.call(this, keyCode);
	    }
	}
	
	/**
	 * change()
	 * Triggers function when input value changes
	 */
	function change() {
	    setCardProperties.call(this);
	    setCardImage.call(this);
	    setCardFormat.call(this);
	}
	
	/**
	 * setCardProperties()
	 * set card type/format etc.
	 */
	function setCardProperties() {
	    var _this = this;
	
	    // Set variable identifying a matching card
	    var cardIsSet = false;
	    var inputValue = this._internalVars.creditCardInput.value.replace(/ /g, '');
	
	    // loop through credit cards object
	    for (var key in this._internalVars.creditCards) {
	        if (this._internalVars.creditCards.hasOwnProperty(key)) {
	            //loop through the validDigits array inside credit card object
	            for (var digits in this._internalVars.creditCards[key].validDigits) {
	                //Set properties if entry matches valid digits
	                if (this._internalVars.creditCards[key].validDigits[digits].indexOf('-') >= 0) {
	                    var hyphenPosition = this._internalVars.creditCards[key].validDigits[digits].indexOf('-');
	                    var beginingPoint = this._internalVars.creditCards[key].validDigits[digits].substring(0, hyphenPosition);
	                    var endPoint = this._internalVars.creditCards[key].validDigits[digits].substring(hyphenPosition + 1, this._internalVars.creditCards[key].validDigits[digits].length);
	                    if (inputValue.substring(0, hyphenPosition) >= beginingPoint && inputValue.substring(0, hyphenPosition) <= endPoint) {
	                        this._internalVars.creditCardType = key;
	                        this._internalVars.cardFormat = this._internalVars.creditCards[key].cardFormat;
	                        this._internalVars.cardFormatArray = this._internalVars.creditCards[key].cardFormatArray;
	                        cardIsSet = true;
	                    }
	                } else {
	                    if (inputValue.substring(0, this._internalVars.creditCards[key].validDigits[digits].length) === this._internalVars.creditCards[key].validDigits[digits]) {
	                        this._internalVars.creditCardType = key;
	                        this._internalVars.cardFormat = this._internalVars.creditCards[key].cardFormat;
	                        this._internalVars.cardFormatArray = this._internalVars.creditCards[key].cardFormatArray;
	                        cardIsSet = true;
	                    }
	                }
	            }
	        }
	    }
	
	    //Set default properties if entry does not match valid digits
	    if (cardIsSet === false) {
	        this._internalVars.creditCardType = 'default';
	        this._internalVars.cardFormat = 'general';
	        this._internalVars.cardFormatArray = [4, 4, 4, 4];
	    }
	
	    //Set sequence array based on card format
	    this._internalVars.sequenceArray = [];
	
	    var sequenceNumber = 0;
	    Array.prototype.forEach.call(this._internalVars.cardFormatArray, function (formatNumber) {
	        sequenceNumber += formatNumber;
	        _this._internalVars.sequenceArray.push(sequenceNumber);
	        _this._internalVars.cardMaxLenth = sequenceNumber + _this._internalVars.cardFormatArray.length - 1;
	    });
	}
	
	/**
	 * setCardImage()
	 * sets the card type image on the view
	 */
	function setCardImage() {
	    if (this._internalVars.creditCardType !== 'default' && this._internalVars.creditCards[this._internalVars.creditCardType].accepted !== false) {
	        this._internalVars.creditCardImageField.setAttribute('class', 'credit-card-image ' + this._internalVars.creditCardType);
	    } else {
	        this._internalVars.creditCardImageField.setAttribute('class', 'credit-card-image');
	    }
	}
	
	/**
	 * setCardFormat(key)
	 * @param key
	 * formats the entry based on the card type
	 */
	function setCardFormat(key) {
	    //Set max length based on card type
	    this._internalVars.creditCardInput.setAttribute('maxlength', this._internalVars.cardMaxLenth);
	
	    //Set variables for cursor position
	    var caretPos = this._internalVars.creditCardInput.selectionStart;
	    var cursorPosition = caretPos;
	
	    //remove next available number if backspacing over a space
	    if (key === 8) {
	        for (var b = 0; b < this._internalVars.sequenceArray.length; b++) {
	            if (caretPos === this._internalVars.sequenceArray[b] + b) {
	                var first = this._internalVars.creditCardInput.value.slice(0, caretPos - 1);
	                var second = this._internalVars.creditCardInput.value.slice(caretPos, this._internalVars.creditCardInput.value.length);
	                this._internalVars.creditCardInput.value = first + second;
	                cursorPosition = caretPos - 1;
	            }
	        }
	    }
	
	    //Set variable containing input value and previous value without spaces
	    var inputValue = this._internalVars.creditCardInput.value.replace(/ /g, '');
	    this._internalVars.creditCardInputValue = inputValue;
	    var prevInputValue = this._internalVars.creditCardInputPreviousValue.replace(/ /g, '');
	    var difference = inputValue.length - prevInputValue.length;
	
	    var newValueArray = [];
	    for (var v = 0; v < this._internalVars.sequenceArray.length; v++) {
	        if (inputValue.length >= this._internalVars.sequenceArray[v] - this._internalVars.cardFormatArray[v]) {
	            newValueArray.push(inputValue.substring(this._internalVars.sequenceArray[v] - this._internalVars.cardFormatArray[v], this._internalVars.sequenceArray[v]));
	        }
	    }
	
	    //check if multiple keys pressed
	    if (key !== 8) {
	        if (this._internalVars.creditCardInputPreviousValue.length + 1 < this._internalVars.creditCardInput.value.length) {
	            for (var i = 0; i < this._internalVars.sequenceArray.length; i++) {
	                if (caretPos - difference < this._internalVars.sequenceArray[i] + (i + 1) && caretPos > this._internalVars.sequenceArray[i] + (i + 1)) {
	                    cursorPosition = caretPos + 1;
	                }
	            }
	        }
	    }
	
	    //combine value arrays with a space
	    var newValue = newValueArray.join(' ');
	    this._internalVars.creditCardInput.value = newValue;
	
	    //update cursor position and/or add a space if a number is pressed
	    if (key !== 8) {
	        for (var s = 0; s < this._internalVars.sequenceArray.length; s++) {
	            if (caretPos + (difference - 1) > this._internalVars.sequenceArray[s] + (s + 1) && caretPos <= this._internalVars.sequenceArray[s] + (s + 1)) {
	                cursorPosition = caretPos + 1;
	            }
	            if (s + 1 !== this._internalVars.cardFormatArray.length && caretPos === this._internalVars.sequenceArray[s] + s && this._internalVars.creditCardInputPreviousValue.length !== this._internalVars.creditCardInput.value.length) {
	                cursorPosition = caretPos + 1;
	                if (caretPos === this._internalVars.creditCardInput.value.length) {
	                    this._internalVars.creditCardInput.value = this._internalVars.creditCardInput.value + ' ';
	                }
	            }
	        }
	    }
	
	    this._internalVars.creditCardInputPreviousValue = this._internalVars.creditCardInput.value;
	    this._internalVars.creditCardInput.setSelectionRange(cursorPosition, cursorPosition);
	}
	
	/**
	 * validateField()
	 * shows an error message if the card is not accepted or the field is incomplete
	 */
	function validateField() {
	    var invalidEntryError = 'Please enter a valid credit card number',
	        invalidCardError = 'Please use American Express, Visa, Mastercard, or Discover',
	        errorMessage = undefined,
	        invalidEntry = false;
	
	    //console.log(this._internalVars.creditCards[this._internalVars.creditCardType].accepted);
	    if (this._internalVars.creditCardInput.value.length !== this._internalVars.cardMaxLenth) {
	        invalidEntry = true;
	        errorMessage = invalidEntryError;
	    } else if (this._internalVars.creditCardType === 'default') {
	        invalidEntry = true;
	        errorMessage = invalidEntryError;
	    } else if (this._internalVars.creditCards[this._internalVars.creditCardType].accepted === false) {
	        invalidEntry = true;
	        errorMessage = invalidCardError;
	    } else {
	        invalidEntry = false;
	    }
	
	    if (invalidEntry === true) {
	        if (this._internalVars.creditCardField.classList.contains('form-field--error')) {
	            var errorObj = document.getElementById('form-message-' + this._internalVars.creditCardField.id);
	            errorObj.innerHTML = errorMessage;
	        } else {
	            this._internalVars.creditCardField.classList.add('form-field--error');
	            this._internalVars.creditCardInput.setAttribute('aria-invalid', 'true');
	
	            var error = document.createElement('span');
	            error.id = 'form-message-' + this._internalVars.creditCardField.id;
	            error.className = 'form-message';
	            error.innerHTML = errorMessage;
	
	            this._internalVars.creditCardField.appendChild(error);
	        }
	    } else {
	        if (this._internalVars.creditCardField.classList.contains('form-field--error')) {
	            this._internalVars.creditCardField.classList.remove('form-field--error');
	            this._internalVars.creditCardInput.setAttribute('aria-invalid', 'false');
	            var errorObj = document.getElementById('form-message-' + this._internalVars.creditCardField.id);
	            errorObj.parentNode.removeChild(errorObj);
	        }
	    }
	}
	
	/**
	 * setLocalVars()
	 * set all the local vars to passed in options
	 */
	function setLocalVars() {
	    //determine the type of content passed in
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    this._internalVars.creditCardField = this._internalVars.node;
	    this._internalVars.creditCardClass = 'credit-card';
	    this._internalVars.creditCardInput = this._internalVars.creditCardField.querySelector('.' + this._internalVars.creditCardClass);
	    this._internalVars.creditCardImageClass = 'credit-card-image';
	    this._internalVars.creditCardImageField = this._internalVars.creditCardField.querySelector('.' + this._internalVars.creditCardImageClass);
	
	    this._internalVars.creditCardInputPreviousValue = this._internalVars.creditCardInput.value;
	    this._internalVars.creditCardInputValue = null;
	}
	
	exports["default"] = CreditCard;
	module.exports = exports["default"];

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	
	//Module Imports
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _utils = __webpack_require__(8);
	
	var utils = _interopRequireWildcard(_utils);
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var _appState = __webpack_require__(7);
	
	var _appState2 = _interopRequireDefault(_appState);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK CurrencyInput : Content must be defined and set to a DOM selector or Node"]
	}, {
	    setting: "numType",
	    isRequired: false,
	    validate: "value", //a type or a value
	    possibleValues: ["whole", "decimal"],
	    errorMessage: ["GDK CurrencyInput : numType must be set to whole or decimal"]
	}, {
	    setting: "onCompleteFormat",
	    isRequired: false,
	    validate: "type", //a type or a value
	    possibleValues: ["function"],
	    errorMessage: ["GDK CurrencyInput : onCompleteFormat must be a defined and set function"]
	}];
	
	/**
	 * CurrencyInput Class
	 */
	
	var CurrencyInput = (function () {
	    /**
	     * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	     * @param {string|Object} content
	     * A reference to the component node of currency input field
	     *
	     * @param {string} [numType="decimal"]
	     *  A string representing the number type of the currency input field
	     *
	     *  @param {function} [onCompleteFormat]
	     *  A callback function fired on blur after formatting is complete in the input field
	     */
	
	    function CurrencyInput(options) {
	        _classCallCheck(this, CurrencyInput);
	
	        console.log('CurrencyInput initialized');
	
	        this._internalVars = {
	            node: null //used for current node
	        };
	
	        //options with defaults set
	        this._defaults = {
	            numType: 'decimal'
	        };
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2['default'].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2['default'].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2['default'].getContentType(this);
	            setLocalVars.call(this);
	            setEvents.call(this);
	
	            if (this._internalVars.node.getAttribute('type') != 'text') {
	                this._internalVars.node.setAttribute('type', 'text');
	            }
	
	            if (!this._internalVars.node.hasAttribute('placeholder') && this._options.numType == 'decimal') {
	                this._internalVars.node.setAttribute('placeholder', '0.00');
	            } else if (!this._internalVars.node.hasAttribute('placeholder') && this._options.numType == 'whole') {
	                this._internalVars.node.setAttribute('placeholder', '0');
	            }
	        }
	    }
	
	    // Private Methods
	    /**
	     * setEvents()
	     * Sets all the events needed for the component
	     */
	
	    //Public Methods
	
	    /**
	     * removes the node from the dom and any events attached
	     */
	
	    _createClass(CurrencyInput, [{
	        key: 'destroy',
	        value: function destroy() {
	            removeEvents.call(this);
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	
	        /**
	         * getCurrencyInput()
	         * return a type float number from currency input field
	         * @returns {float}
	         */
	    }, {
	        key: 'getCurrencyInput',
	        value: function getCurrencyInput() {
	            return parseFloat(this._internalVars.node.value);
	        }
	    }]);
	
	    return CurrencyInput;
	})();
	
	function setEvents() {
	    this._internalVars.node.addEventListener("keydown", this._internalVars.keyDownHandler);
	    this._internalVars.node.addEventListener("keyup", this._internalVars.keyUpHandler);
	    this._internalVars.node.addEventListener("keypress", this._internalVars.keyPressHandler);
	    this._internalVars.node.addEventListener("blur", this._internalVars.blurHandler);
	}
	
	/**
	 * removeEvents()
	 * removes all events from the component
	 */
	function removeEvents() {
	    this._internalVars.node.removeEventListener("keydown", this._internalVars.keyDownHandler);
	    this._internalVars.node.removeEventListener("keyup", this._internalVars.keyUpHandler);
	    this._internalVars.node.removeEventListener("keypress", this._internalVars.keyPressHandler);
	    this._internalVars.node.removeEventListener("blur", this._internalVars.blurHandler);
	}
	
	function decimalExist(value) {
	    if (value.indexOf('.') != -1) {
	        return true;
	    } else {
	        return false;
	    }
	}
	
	function numOfCharAfterDecimal(value) {
	    return value.toString().substr(value.toString().indexOf(".") + 1).length;
	}
	
	function isCharacterValid(e, type) {
	    var keyCode = e.which || e.keyCode;
	    //numeric								arrow key						backspace and tab					enter
	    if (keyCode >= 48 && keyCode <= 57 || keyCode >= 37 && keyCode <= 40 || keyCode >= 8 && keyCode <= 9 || keyCode == 13 || type == 'decimal' && keyCode == 190 || keyCode == 46) {
	        return true;
	    } else {
	        return false;
	    }
	}
	
	function parsedValue(value, type) {
	    if (type == 'decimal') {
	        return parseFloat(removeCommas(value)).toFixed(2);
	    } else if (type == 'whole') {
	        return parseInt(removeCommas(value));
	    }
	}
	
	function insertCommas(value) {
	    value = value.split('.');
	    if (value[1] !== undefined) {
	        return value[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + '.' + value[1];
	    } else {
	        return value[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	    }
	}
	
	function removeCommas(value) {
	    return value.replace(/[^\d\.]/g, '');
	}
	
	function commaCount(value) {
	    var counter = 0;
	    for (var i = 0; i < value.length; i++) {
	        if (value.charAt(i) == ',') {
	            counter++;
	        }
	    }
	    return counter;
	}
	
	function isCaretBeforeDecimal(caretPos, decimalPos) {
	    if (caretPos <= decimalPos) {
	        return true;
	    } else if (caretPos > decimalPos) {
	        return false;
	    }
	}
	
	function isSelected() {
	    if (document.getSelection().toString() !== '') {
	        return true;
	    } else if (document.getSelection().toString === '') {
	        return false;
	    }
	}
	
	//blur
	function completeDisplay() {
	    this._internalVars.inputValue = this._internalVars.node.value;
	
	    if (this._internalVars.node.value !== '') {
	        this._internalVars.node.value = insertCommas(parsedValue(this._internalVars.inputValue, this._options.numType).toString());
	
	        if (this._options.onCompleteFormat) {
	            if (this._options.numType == 'decimal') {
	                this._options.onCompleteFormat(parseFloat(this._internalVars.node.value.replace(/[^\d\.]/g, '')).toFixed(2));
	            } else if (this._options.numType == 'whole') {
	                this._options.onCompleteFormat(parseFloat(this._internalVars.node.value.replace(/[^\d\.]/g, '')));
	            }
	        }
	    }
	}
	
	//keydown-initial
	function inputCharacters(e) {
	    this._internalVars.inputValue = this._internalVars.node.value;
	    this._internalVars.caretLocation = this._internalVars.node.selectionStart;
	    this._internalVars.decimalLocation = this._internalVars.node.value.indexOf('.');
	
	    if (this._options.numType == 'decimal') {
	        if (decimalExist(this._internalVars.inputValue)) {
	            this._internalVars.allowDecimal = false;
	        } else {
	            this._internalVars.allowDecimal = true;
	        }
	
	        if (decimalExist(this._internalVars.inputValue) && !isCaretBeforeDecimal(this._internalVars.caretLocation, this._internalVars.decimalLocation) && numOfCharAfterDecimal(this._internalVars.inputValue) == 2 && !isSelected()) {
	            this._internalVars.allowCharacters = false;
	            this._internalVars.node.setAttribute('maxlength', this._internalVars.inputValue.length);
	        } else if (decimalExist(this._internalVars.inputValue) && isCaretBeforeDecimal(this._internalVars.caretLocation, this._internalVars.decimalLocation) && numOfCharAfterDecimal(this._internalVars.inputValue) <= 2 || isSelected()) {
	            this._internalVars.allowCharacters = true;
	            this._internalVars.node.removeAttribute('maxlength');
	        } else {
	            this._internalVars.allowCharacters = true;
	            this._internalVars.node.removeAttribute('maxlength');
	        }
	    } else if (this._options.numType == 'whole') {
	        this._internalVars.allowDecimal = false;
	    }
	}
	
	//keyup-after
	function inputAutoCommas(e) {
	    var keyCode = e.which || e.keyCode;
	    this._internalVars.inputValue = this._internalVars.node.value;
	    this._internalVars.caretLocation = this._internalVars.node.selectionStart;
	    var beforeCommaCount = commaCount(this._internalVars.inputValue);
	
	    if (keyCode != 9 && keyCode != 16 && !(keyCode >= 37 && keyCode <= 40)) {
	        this._internalVars.node.value = insertCommas(removeCommas(this._internalVars.inputValue));
	
	        this._internalVars.inputValue = this._internalVars.node.value;
	
	        if (this._options.numType == 'whole') {
	            this._internalVars.node.value = this._internalVars.inputValue.replace('.', '');
	        }
	
	        var afterCommaCount = commaCount(this._internalVars.inputValue);
	
	        if (beforeCommaCount != afterCommaCount) {
	            this._internalVars.node.selectionStart = this._internalVars.caretLocation + 1;
	            this._internalVars.node.selectionEnd = this._internalVars.caretLocation + 1;
	            if (keyCode == 8) {
	                this._internalVars.node.selectionStart = this._internalVars.caretLocation - 1;
	                this._internalVars.node.selectionEnd = this._internalVars.caretLocation - 1;
	            }
	        } else {
	            this._internalVars.node.selectionStart = this._internalVars.caretLocation;
	            this._internalVars.node.selectionEnd = this._internalVars.caretLocation;
	        }
	    }
	}
	
	//keypress
	function preventInput(event) {
	    if (!isCharacterValid(event, this._options.numType) || !this._internalVars.allowCharacters && event.which != 8) {
	        event.preventDefault();
	    }
	    if (!this._internalVars.allowDecimal && event.which == 46) {
	        event.preventDefault();
	    }
	}
	
	/**
	 * setLocalVars()
	 * set local vars to the ones passed in options
	 */
	function setLocalVars() {
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    this._internalVars.keyDownHandler = inputCharacters.bind(this);
	    this._internalVars.keyUpHandler = inputAutoCommas.bind(this);
	    this._internalVars.keyPressHandler = preventInput.bind(this);
	    this._internalVars.blurHandler = completeDisplay.bind(this);
	
	    this._internalVars.inputValue = this._internalVars.node.value;
	    this._internalVars.caretLocation = this._internalVars.node.selectionStart;
	    this._internalVars.decimalLocation = this._internalVars.node.value.indexOf('.');
	    this._internalVars.allowCharacters = true;
	    this._internalVars.allowDecimal = true;
	}
	
	exports['default'] = CurrencyInput;
	module.exports = exports['default'];

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	//Require static assets
	
	//Module Imports
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _baseComponent = __webpack_require__(17);
	
	var _baseComponent2 = _interopRequireDefault(_baseComponent);
	
	var validateSettings = [{
	    setting: "content",
	    isRequired: true,
	    validate: "type", //a type or a value
	    possibleValues: ["string", "object"],
	    errorMessage: ["GDK Make a Payment : Content must be defined and set to a DOM selector or Node"]
	}];
	
	/**
	 * MakePayment Class
	 */
	
	var MakePayment = (function () {
	    /**
	     * These are settings for the instantiation. Refer to the design kit section of this component for JS setting examples.
	     * @param {string|Object} content
	     * A reference to the div form field containing the make payment input node
	     *
	     */
	
	    function MakePayment(options) {
	        _classCallCheck(this, MakePayment);
	
	        this._internalVars = {};
	
	        //options with defaults set
	        this._defaults = {};
	
	        // Create options by extending defaults with the passed in arugments
	        if (options && typeof options === "object") {
	            this._options = _baseComponent2["default"].extendDefaults(this._defaults, options);
	        }
	
	        //if the required options are valid set up the environment
	        if (_baseComponent2["default"].validateSettings(this._options, validateSettings)) {
	            this._internalVars.contentType = _baseComponent2["default"].getContentType(this);
	            setLocalVars.call(this);
	            setEvents.call(this);
	        }
	    }
	
	    // Private Methods
	    /**
	     * setEvents()
	     * Sets all the events needed for the component
	     */
	
	    //Public Methods
	
	    /**
	     * destroy()
	     * removes the node from the dom and any events attached
	     */
	
	    _createClass(MakePayment, [{
	        key: "destroy",
	        value: function destroy() {
	            removeEvents.call(this);
	            this._internalVars.node.parentNode.removeChild(this._internalVars.node);
	
	            //a little garbage collection
	            for (var variableKey in this) {
	                if (this.hasOwnProperty(variableKey)) {
	                    delete this[variableKey];
	                }
	            }
	        }
	    }]);
	
	    return MakePayment;
	})();
	
	function setEvents() {
	    var _this = this;
	
	    Array.prototype.forEach.call(this._internalVars.radios, function (radio) {
	        radio.addEventListener('change', paymentTypeFieldsDisplay.bind(_this));
	    });
	
	    Array.prototype.forEach.call(this._internalVars.paymentAmountRadios, function (radio) {
	        radio.addEventListener('change', enableDisableOtherAmount.bind(_this));
	    });
	
	    this._internalVars.creditCardcarddholderSelect.addEventListener('change', mailingAddressDisplay.bind(this));
	    this._internalVars.checkAccountholderSelect.addEventListener('change', mailingAddressDisplay.bind(this));
	
	    this._internalVars.creditCardcarddholderSelect.addEventListener('change', prefillName.bind(this));
	    this._internalVars.checkAccountholderSelect.addEventListener('change', prefillName.bind(this));
	
	    Array.prototype.forEach.call(this._internalVars.newAddressRadios, function (radio) {
	        radio.addEventListener('change', newAddressFieldsDisplay.bind(_this));
	    });
	
	    if (this._internalVars.nameOnCheckInput) {
	        this._internalVars.nameOnCheckInput.addEventListener('blur', parseFirstName.bind(this));
	    }
	    if (this._internalVars.nameOnCardInput) {
	        this._internalVars.nameOnCardInput.addEventListener('blur', parseFirstName.bind(this));
	    }
	
	    this._internalVars.saveMethodRadio.addEventListener('change', saveMethodFieldDisplay.bind(this));
	}
	
	/**
	 * removeEvents()
	 * removes all events from the component
	 */
	function removeEvents() {
	    var _this2 = this;
	
	    Array.prototype.forEach.call(this._internalVars.radios, function (radio) {
	        radio.removeEventListener('change', paymentTypeFieldsDisplay.bind(_this2));
	    });
	
	    Array.prototype.forEach.call(this._internalVars.paymentAmountRadios, function (radio) {
	        radio.removeEventListener('change', enableDisableOtherAmount.bind(_this2));
	    });
	
	    this._internalVars.creditCardcarddholderSelect.removeEventListener('change', mailingAddressDisplay.bind(this));
	    this._internalVars.checkAccountholderSelect.removeEventListener('change', mailingAddressDisplay.bind(this));
	
	    Array.prototype.forEach.call(this._internalVars.newAddressRadios, function (radio) {
	        radio.removeEventListener('change', newAddressFieldsDisplay.bind(_this2));
	    });
	
	    if (this._internalVars.nameOnCheckInput) {
	        this._internalVars.nameOnCheckInput.removeEventListener('blur', parseFirstName.bind(this));
	    }
	    if (this._internalVars.nameOnCardInput) {
	        this._internalVars.nameOnCardInput.removeEventListener('blur', parseFirstName.bind(this));
	    }
	
	    this._internalVars.saveMethodRadio.removeEventListener('change', saveMethodFieldDisplay.bind(this));
	}
	
	function enableDisableOtherAmount(event) {
	    if (event.target.value === 'other') {
	        this._internalVars.currencyInput.removeAttribute('disabled');
	    } else if (event.target.value !== 'other') {
	        this._internalVars.currencyInput.setAttribute('disabled', 'disabled');
	    }
	}
	
	function paymentTypeFieldsDisplay(event) {
	    //Set variable values for which fields should be displayed
	    var creditCardFieldsDisplay = false,
	        checkFieldsDisplay = false,
	        generalFieldsDisplay = false,
	        saveMethodFieldsDisplay = false;
	
	    this._internalVars.creditCardSelected = false;
	    this._internalVars.checkSelected = false;
	
	    if (event.target.value === 'card') {
	        generalFieldsDisplay = true;
	        creditCardFieldsDisplay = true;
	        checkFieldsDisplay = false;
	        this._internalVars.creditCardSelected = true;
	        this._internalVars.addressFieldLabel.innerHTML = "Cardholder's";
	    }
	
	    if (event.target.value === 'check') {
	        generalFieldsDisplay = true;
	        checkFieldsDisplay = true;
	        creditCardFieldsDisplay = false;
	        this._internalVars.checkSelected = true;
	        this._internalVars.addressFieldLabel.innerHTML = "Account holder's";
	    }
	
	    //Reset values if payment method is changed
	    this._internalVars.creditCardcarddholderSelect.options[0].selected = true;
	    this._internalVars.checkAccountholderSelect.options[0].selected = true;
	
	    Array.prototype.forEach.call(this._internalVars.newAddressRadios, function (radio) {
	        radio.checked = false;
	    });
	
	    this._internalVars.saveMethodRadio.checked = false;
	
	    toggleFieldDisplay.call(this, creditCardFieldsDisplay, checkFieldsDisplay, generalFieldsDisplay, saveMethodFieldsDisplay);
	}
	
	function toggleFieldDisplay(creditCardFieldsDisplay, checkFieldsDisplay, generalFieldsDisplay, saveMethodFieldsDisplay) {
	    if ($(this._internalVars.dynamicAddressField).is(':visible')) {
	        $(this._internalVars.dynamicAddressField).slideUp();
	    }
	    if ($(this._internalVars.dynamicNewAddressFields).is(':visible')) {
	        $(this._internalVars.dynamicNewAddressFields).slideUp();
	    }
	    if (generalFieldsDisplay === true) {
	        if ($(this._internalVars.dynamicFieldGeneral).is(':hidden')) {
	            $(this._internalVars.dynamicFieldGeneral).slideDown();
	        }
	    } else {
	        if ($(this._internalVars.dynamicFieldGeneral).is(':visible')) {
	            $(this._internalVars.dynamicFieldGeneral).slideUp();
	        }
	    }
	    if (creditCardFieldsDisplay === true) {
	        if ($(this._internalVars.dynamicCardFields).is(':hidden')) {
	            $(this._internalVars.dynamicCardFields).slideDown();
	        }
	    } else {
	        if ($(this._internalVars.dynamicCardFields).is(':visible')) {
	            $(this._internalVars.dynamicCardFields).slideUp();
	        }
	    }
	    if (checkFieldsDisplay === true) {
	        if ($(this._internalVars.dynamicCheckFields).is(':hidden')) {
	            $(this._internalVars.dynamicCheckFields).slideDown();
	        }
	    } else {
	        if ($(this._internalVars.dynamicCheckFields).is(':visible')) {
	            $(this._internalVars.dynamicCheckFields).slideUp();
	        }
	    }
	    if (saveMethodFieldsDisplay === true) {
	        if ($(this._internalVars.dynamicFieldSaveFields).is(':hidden')) {
	            $(this._internalVars.dynamicFieldSaveFields).slideDown();
	        }
	    } else {
	        if ($(this._internalVars.dynamicFieldSaveFields).is(':visible')) {
	            $(this._internalVars.dynamicFieldSaveFields).slideUp();
	        }
	    }
	}
	
	function mailingAddressDisplay(event) {
	    var mailingAddressFields = false;
	    if (event.target.value === 'other') {
	        mailingAddressFields = true;
	    }
	    toggleMailingAddressFieldDisplay.call(this, mailingAddressFields);
	}
	
	function prefillName(event) {
	    var addressLabel = undefined;
	    if (this._internalVars.checkSelected === true) {
	        addressLabel = "Account holder's";
	    } else if (this._internalVars.creditCardSelected === true) {
	        addressLabel = "Cardholder's";
	    }
	    if (event.target.value !== 'other' && event.target.value !== 'select') {
	        var value = undefined;
	        for (var i = 0; i < event.target.length; i++) {
	            if (event.target.options[i].value === event.target.value) {
	                value = event.target.options[i].text;
	            }
	        }
	        if (this._internalVars.creditCardSelected === true) {
	            this._internalVars.nameOnCardInput.value = value;
	        } else if (this._internalVars.checkSelected === true) {
	            this._internalVars.nameOnCheckInput.value = value;
	        }
	    } else {
	        this._internalVars.nameOnCardInput.value = '';
	        this._internalVars.nameOnCheckInput.value = '';
	        this._internalVars.addressFieldLabel.innerHTML = addressLabel;
	    }
	}
	
	function toggleMailingAddressFieldDisplay(mailingAddressFields) {
	    if (mailingAddressFields === true) {
	        if ($(this._internalVars.dynamicAddressField).is(':hidden')) {
	            $(this._internalVars.dynamicAddressField).slideDown();
	        }
	    } else {
	        if ($(this._internalVars.dynamicAddressField).is(':visible')) {
	            $(this._internalVars.dynamicAddressField).slideUp();
	        }
	    }
	}
	
	function newAddressFieldsDisplay(event) {
	    var newAddressFields = false;
	    if (event.target.value === 'new') {
	        newAddressFields = true;
	    }
	    toggleNewAddressFieldsDisplay.call(this, newAddressFields);
	}
	
	function toggleNewAddressFieldsDisplay(newAddressFields) {
	    if (newAddressFields === true) {
	        if ($(this._internalVars.dynamicNewAddressFields).is(':hidden')) {
	            $(this._internalVars.dynamicNewAddressFields).slideDown();
	        }
	    } else {
	        if ($(this._internalVars.dynamicNewAddressFields).is(':visible')) {
	            $(this._internalVars.dynamicNewAddressFields).slideUp();
	        }
	    }
	}
	
	function parseFirstName(event) {
	    var nameField = undefined,
	        addressLabel = undefined;
	    if (this._internalVars.checkSelected === true) {
	        nameField = this._internalVars.nameOnCheckInput;
	        addressLabel = "Account holder's";
	    } else if (this._internalVars.creditCardSelected === true) {
	        nameField = this._internalVars.nameOnCardInput;
	        addressLabel = "Cardholder's";
	    }
	    if (nameField.value.length > 0) {
	        var firstName = event.target.value.split(" ")[0];
	        if (firstName.slice(-1) === 's' || firstName.slice(-1) === 'S') {
	            this._internalVars.addressFieldLabel.innerHTML = firstName + "'";
	        } else {
	            this._internalVars.addressFieldLabel.innerHTML = firstName + "'s";
	        }
	    } else {
	        this._internalVars.addressFieldLabel.innerHTML = addressLabel;
	    }
	}
	
	function saveMethodFieldDisplay(event) {
	    if (event.target.checked === true) {
	        if ($(this._internalVars.dynamicFieldSaveFields).is(':hidden')) {
	            $(this._internalVars.dynamicFieldSaveFields).slideDown();
	        }
	    } else {
	        if ($(this._internalVars.dynamicFieldSaveFields).is(':visible')) {
	            $(this._internalVars.dynamicFieldSaveFields).slideUp();
	        }
	    }
	}
	
	/**
	 * setLocalVars()
	 * set all the local vars to passed in options
	 */
	function setLocalVars() {
	    //determine the type of content passed in
	    if (this._internalVars.contentType === 'string') {
	        this._internalVars.node = document.querySelector(this._options.content);
	    } else if (this._internalVars.contentType === 'domNode') {
	        this._internalVars.node = this._options.content;
	    }
	
	    this._internalVars.makePaymentFields = this._internalVars.node;
	
	    this._internalVars.paymentAmountID = 'payment-amount';
	    this._internalVars.paymentAmountFields = this._internalVars.makePaymentFields.querySelector('#' + this._internalVars.paymentAmountID);
	    this._internalVars.paymentAmountRadios = this._internalVars.paymentAmountFields.querySelectorAll("input[type='radio']");
	
	    this._internalVars.currencyInputClass = 'currency-input';
	    this._internalVars.currencyInput = this._internalVars.makePaymentFields.querySelector('.' + this._internalVars.currencyInputClass);
	
	    this._internalVars.paymentMethodID = 'payment-method-selection';
	    this._internalVars.paymentMethodFields = this._internalVars.makePaymentFields.querySelector('#' + this._internalVars.paymentMethodID);
	    this._internalVars.radios = this._internalVars.paymentMethodFields.querySelectorAll('input');
	
	    this._internalVars.dynamicFieldCheckClass = 'dynamic-fields-check';
	    this._internalVars.dynamicCheckFields = this._internalVars.makePaymentFields.querySelector('.' + this._internalVars.dynamicFieldCheckClass);
	
	    this._internalVars.dynamicFieldCardClass = 'dynamic-fields-card';
	    this._internalVars.dynamicCardFields = this._internalVars.makePaymentFields.querySelector('.' + this._internalVars.dynamicFieldCardClass);
	
	    this._internalVars.dynamicFieldGeneralClass = 'dynamic-fields-general';
	    this._internalVars.dynamicFieldGeneral = this._internalVars.makePaymentFields.querySelector('.' + this._internalVars.dynamicFieldGeneralClass);
	
	    this._internalVars.creditCardCardholderID = 'cardholder-credit-card';
	    this._internalVars.creditCardCardholderField = this._internalVars.makePaymentFields.querySelector('#' + this._internalVars.creditCardCardholderID);
	    this._internalVars.creditCardcarddholderSelect = this._internalVars.creditCardCardholderField.querySelector('select');
	
	    this._internalVars.checkAccountholderID = 'accountholder-check';
	    this._internalVars.checkAccountholderField = this._internalVars.makePaymentFields.querySelector('#' + this._internalVars.checkAccountholderID);
	    this._internalVars.checkAccountholderSelect = this._internalVars.checkAccountholderField.querySelector('select');
	
	    this._internalVars.nameOnCheckID = 'name-on-check';
	    if (this._internalVars.makePaymentFields.querySelector('#' + this._internalVars.nameOnCheckID)) {
	        this._internalVars.nameOnCheckFields = this._internalVars.makePaymentFields.querySelector('#' + this._internalVars.nameOnCheckID);
	        this._internalVars.nameOnCheckInput = this._internalVars.nameOnCheckFields.querySelector('input');
	    }
	
	    this._internalVars.nameOnCardID = 'name-credit-card';
	    if (this._internalVars.makePaymentFields.querySelector('#' + this._internalVars.nameOnCardID)) {
	        this._internalVars.nameOnCardFields = this._internalVars.makePaymentFields.querySelector('#' + this._internalVars.nameOnCardID);
	        this._internalVars.nameOnCardInput = this._internalVars.nameOnCardFields.querySelector('input');
	    }
	
	    this._internalVars.dynamicFieldAddressClass = 'dynamic-fields-address';
	    this._internalVars.dynamicAddressField = this._internalVars.makePaymentFields.querySelector('.' + this._internalVars.dynamicFieldAddressClass);
	
	    this._internalVars.addressFieldNameLabelID = 'address-name';
	    this._internalVars.addressFieldLabel = this._internalVars.makePaymentFields.querySelector('#' + this._internalVars.addressFieldNameLabelID);
	
	    this._internalVars.newAddressID = 'address';
	    this._internalVars.newAddressFields = this._internalVars.makePaymentFields.querySelector('#' + this._internalVars.newAddressID);
	    this._internalVars.newAddressRadios = this._internalVars.newAddressFields.querySelectorAll('input');
	
	    this._internalVars.dynamicFieldNewAddressClass = 'dynamic-fields-new-address';
	    this._internalVars.dynamicNewAddressFields = this._internalVars.makePaymentFields.querySelector('.' + this._internalVars.dynamicFieldNewAddressClass);
	
	    this._internalVars.saveMethodId = 'save-method';
	    this._internalVars.saveMethodField = this._internalVars.makePaymentFields.querySelector('#' + this._internalVars.saveMethodId);
	    this._internalVars.saveMethodRadio = this._internalVars.saveMethodField.querySelector('input');
	
	    this._internalVars.dynamicFieldSaveClass = 'dynamic-fields-save-method';
	    this._internalVars.dynamicFieldSaveFields = this._internalVars.makePaymentFields.querySelector('.' + this._internalVars.dynamicFieldSaveClass);
	}
	
	exports["default"] = MakePayment;
	module.exports = exports["default"];

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// geico-design-kit.bundle.js